var Fp = (e) => {
  throw TypeError(e);
};
var Sh = (e, n, a) => n.has(e) || Fp("Cannot " + a);
var Hp = (e, n, a) => n.has(e) ? Fp("Cannot add the same private member more than once") : n instanceof WeakSet ? n.add(e) : n.set(e, a);
var G = (e, n, a) => (Sh(e, n, "access private method"), a);
const on = {
  MAX_STORAGE_FILE_SIZE_BYTES: {
    value: 52428800,
    description: "The maximum allowed file size, in bytes."
  },
  MAX_LOAD_TYPES_PER_WAREHOUSE: {
    value: 100,
    description: "The maximum number of Loadtypes allowed per Warehouse."
  },
  MAX_LOAD_TYPES_PER_GROUP: {
    value: 50,
    description: "The maximum number of Load Types a group can have."
  },
  MAX_MAX_CARRIER_LEADTIME_LIMIT_HRS: {
    value: 8760,
    description: 'The maximum "max carrier lead time", in hours - the setting on the Dock cannot exceed this value.'
  },
  MAX_MIN_CARRIER_LEADTIME_LIMIT_HRS: {
    value: 1e3,
    description: 'The maximum "minimum carrier lead time", in hours - the setting on the Dock cannot exceed this value.'
  },
  MAX_CAPACITY_DOCKS: {
    value: 10,
    description: "The maximum amount of child capacity Docks that can be created, per Dock."
  },
  MAX_RECURRING_APPOINTMENT_WEEKS: {
    value: 105,
    description: "The maximum amount weeks into the future that you can book a Recurring Appointment Series for."
  },
  MULTI_DOC_MAX_FILES_PER_APPOINTMENT: {
    value: 10,
    description: "The maximum number of files that can be uploaded together."
  },
  MAX_CUSTOM_TAGS_PER_ORG: {
    value: 128,
    description: "The maximum number of custom tags that can be created, per Org."
  },
  MAX_RESERVE_DURATION_MIN: {
    value: 1440,
    description: "The maximum number of minutes a Reserve's duration can be upon creation."
  },
  MAX_WAREHOUSE_PER_USER: {
    value: 70,
    description: "The maximum number of warehouses an user can be part of."
  },
  MAX_WAREHOUSE_PER_GROUP: {
    value: 50,
    description: "The maximum number of warehouses a group can have."
  },
  MIN_RESCHEDULE_MINUTES_FOR_NOTIFICATION: {
    value: 2,
    description: 'The minimum number of minutes between the current and rescheduled "start" to initiate a notification'
  },
  MAX_INTERVAL_TRIM_FOR_CARRIERS: {
    value: 30,
    description: "The maximum number of intervals that can be trimmed from the beginning of the Warehouse's availability"
  },
  MAX_REPORTING_FILTER_SELECTIONS: {
    value: 25,
    description: "The maximum number of items that can be selected for each reporting filter entity."
  },
  MAX_SMS_LENGTH: {
    value: 320,
    description: "The maximum length allowed for an SMS"
  }
};
class En extends Error {
}
class Bh extends En {
  constructor(n) {
    super(`Invalid DateTime: ${n.toMessage()}`);
  }
}
class wh extends En {
  constructor(n) {
    super(`Invalid Interval: ${n.toMessage()}`);
  }
}
class Ch extends En {
  constructor(n) {
    super(`Invalid Duration: ${n.toMessage()}`);
  }
}
class Ot extends En {
}
class iz extends En {
  constructor(n) {
    super(`Invalid unit ${n}`);
  }
}
class l2 extends En {
}
class He extends En {
  constructor() {
    super("Zone is an abstract class");
  }
}
const H = "numeric", C2 = "short", a2 = "long", e4 = {
  year: H,
  month: H,
  day: H
}, Mz = {
  year: H,
  month: C2,
  day: H
}, Eh = {
  year: H,
  month: C2,
  day: H,
  weekday: C2
}, bz = {
  year: H,
  month: a2,
  day: H
}, sz = {
  year: H,
  month: a2,
  day: H,
  weekday: a2
}, dz = {
  hour: H,
  minute: H
}, pz = {
  hour: H,
  minute: H,
  second: H
}, cz = {
  hour: H,
  minute: H,
  second: H,
  timeZoneName: C2
}, zz = {
  hour: H,
  minute: H,
  second: H,
  timeZoneName: a2
}, Oz = {
  hour: H,
  minute: H,
  hourCycle: "h23"
}, uz = {
  hour: H,
  minute: H,
  second: H,
  hourCycle: "h23"
}, Az = {
  hour: H,
  minute: H,
  second: H,
  hourCycle: "h23",
  timeZoneName: C2
}, lz = {
  hour: H,
  minute: H,
  second: H,
  hourCycle: "h23",
  timeZoneName: a2
}, fz = {
  year: H,
  month: H,
  day: H,
  hour: H,
  minute: H
}, mz = {
  year: H,
  month: H,
  day: H,
  hour: H,
  minute: H,
  second: H
}, qz = {
  year: H,
  month: C2,
  day: H,
  hour: H,
  minute: H
}, hz = {
  year: H,
  month: C2,
  day: H,
  hour: H,
  minute: H,
  second: H
}, Xh = {
  year: H,
  month: C2,
  day: H,
  weekday: C2,
  hour: H,
  minute: H
}, yz = {
  year: H,
  month: a2,
  day: H,
  hour: H,
  minute: H,
  timeZoneName: C2
}, Wz = {
  year: H,
  month: a2,
  day: H,
  hour: H,
  minute: H,
  second: H,
  timeZoneName: C2
}, gz = {
  year: H,
  month: a2,
  day: H,
  weekday: a2,
  hour: H,
  minute: H,
  timeZoneName: a2
}, Rz = {
  year: H,
  month: a2,
  day: H,
  weekday: a2,
  hour: H,
  minute: H,
  second: H,
  timeZoneName: a2
};
function D0(e) {
  return typeof e > "u";
}
function vn(e) {
  return typeof e == "number";
}
function rr(e) {
  return typeof e == "number" && e % 1 === 0;
}
function Ph(e) {
  return typeof e == "string";
}
function kh(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function $z() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function Ih(e) {
  return Array.isArray(e) ? e : [e];
}
function Up(e, n, a) {
  if (e.length !== 0)
    return e.reduce((t, r) => {
      const M = [n(r), r];
      return t && a(t[0], M[0]) === t[0] ? t : M;
    }, null)[1];
}
function xh(e, n) {
  return n.reduce((a, t) => (a[t] = e[t], a), {});
}
function $a(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function me(e, n, a) {
  return rr(e) && e >= n && e <= a;
}
function Fh(e, n) {
  return e - n * Math.floor(e / n);
}
function p1(e, n = 2) {
  const a = e < 0;
  let t;
  return a ? t = "-" + ("" + -e).padStart(n, "0") : t = ("" + e).padStart(n, "0"), t;
}
function Ge(e) {
  if (!(D0(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function mn(e) {
  if (!(D0(e) || e === null || e === ""))
    return parseFloat(e);
}
function G4(e) {
  if (!(D0(e) || e === null || e === "")) {
    const n = parseFloat("0." + e) * 1e3;
    return Math.floor(n);
  }
}
function V4(e, n, a = !1) {
  const t = 10 ** n;
  return (a ? Math.trunc : Math.round)(e * t) / t;
}
function Ct(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function ht(e) {
  return Ct(e) ? 366 : 365;
}
function To(e, n) {
  const a = Fh(n - 1, 12) + 1, t = e + (n - a) / 12;
  return a === 2 ? Ct(t) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][a - 1];
}
function Y4(e) {
  let n = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (n = new Date(n), n.setUTCFullYear(n.getUTCFullYear() - 1900)), +n;
}
function So(e) {
  const n = (e + Math.floor(e / 4) - Math.floor(e / 100) + Math.floor(e / 400)) % 7, a = e - 1, t = (a + Math.floor(a / 4) - Math.floor(a / 100) + Math.floor(a / 400)) % 7;
  return n === 4 || t === 3 ? 53 : 52;
}
function n4(e) {
  return e > 99 ? e : e > 60 ? 1900 + e : 2e3 + e;
}
function Lz(e, n, a, t = null) {
  const r = new Date(e), M = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  t && (M.timeZone = t);
  const b = { timeZoneName: n, ...M }, d = new Intl.DateTimeFormat(a, b).formatToParts(r).find((c) => c.type.toLowerCase() === "timezonename");
  return d ? d.value : null;
}
function ir(e, n) {
  let a = parseInt(e, 10);
  Number.isNaN(a) && (a = 0);
  const t = parseInt(n, 10) || 0, r = a < 0 || Object.is(a, -0) ? -t : t;
  return a * 60 + r;
}
function _z(e) {
  const n = Number(e);
  if (typeof e == "boolean" || e === "" || Number.isNaN(n))
    throw new l2(`Invalid unit value ${e}`);
  return n;
}
function Bo(e, n) {
  const a = {};
  for (const t in e)
    if ($a(e, t)) {
      const r = e[t];
      if (r == null) continue;
      a[n(t)] = _z(r);
    }
  return a;
}
function yt(e, n) {
  const a = Math.trunc(Math.abs(e / 60)), t = Math.trunc(Math.abs(e % 60)), r = e >= 0 ? "+" : "-";
  switch (n) {
    case "short":
      return `${r}${p1(a, 2)}:${p1(t, 2)}`;
    case "narrow":
      return `${r}${a}${t > 0 ? `:${t}` : ""}`;
    case "techie":
      return `${r}${p1(a, 2)}${p1(t, 2)}`;
    default:
      throw new RangeError(`Value format ${n} is out of range for property format`);
  }
}
function Mr(e) {
  return xh(e, ["hour", "minute", "second", "millisecond"]);
}
const Nz = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/, Hh = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], vz = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Uh = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Dz(e) {
  switch (e) {
    case "narrow":
      return [...Uh];
    case "short":
      return [...vz];
    case "long":
      return [...Hh];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Tz = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], Sz = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], jh = ["M", "T", "W", "T", "F", "S", "S"];
function Bz(e) {
  switch (e) {
    case "narrow":
      return [...jh];
    case "short":
      return [...Sz];
    case "long":
      return [...Tz];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const wz = ["AM", "PM"], Gh = ["Before Christ", "Anno Domini"], Vh = ["BC", "AD"], Yh = ["B", "A"];
function Cz(e) {
  switch (e) {
    case "narrow":
      return [...Yh];
    case "short":
      return [...Vh];
    case "long":
      return [...Gh];
    default:
      return null;
  }
}
function Jh(e) {
  return wz[e.hour < 12 ? 0 : 1];
}
function Kh(e, n) {
  return Bz(n)[e.weekday - 1];
}
function Zh(e, n) {
  return Dz(n)[e.month - 1];
}
function Qh(e, n) {
  return Cz(n)[e.year < 0 ? 0 : 1];
}
function ey(e, n, a = "always", t = !1) {
  const r = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, M = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (a === "auto" && M) {
    const m = e === "days";
    switch (n) {
      case 1:
        return m ? "tomorrow" : `next ${r[e][0]}`;
      case -1:
        return m ? "yesterday" : `last ${r[e][0]}`;
      case 0:
        return m ? "today" : `this ${r[e][0]}`;
    }
  }
  const b = Object.is(n, -0) || n < 0, d = Math.abs(n), c = d === 1, O = r[e], A = t ? c ? O[1] : O[2] || O[1] : c ? r[e][0] : e;
  return b ? `${d} ${A} ago` : `in ${d} ${A}`;
}
function jp(e, n) {
  let a = "";
  for (const t of e)
    t.literal ? a += t.val : a += n(t.val);
  return a;
}
const ny = {
  D: e4,
  DD: Mz,
  DDD: bz,
  DDDD: sz,
  t: dz,
  tt: pz,
  ttt: cz,
  tttt: zz,
  T: Oz,
  TT: uz,
  TTT: Az,
  TTTT: lz,
  f: fz,
  ff: qz,
  fff: yz,
  ffff: gz,
  F: mz,
  FF: hz,
  FFF: Wz,
  FFFF: Rz
};
class U1 {
  static create(n, a = {}) {
    return new U1(n, a);
  }
  static parseFormat(n) {
    let a = null, t = "", r = !1;
    const M = [];
    for (let b = 0; b < n.length; b++) {
      const d = n.charAt(b);
      d === "'" ? (t.length > 0 && M.push({ literal: r, val: t }), a = null, t = "", r = !r) : r || d === a ? t += d : (t.length > 0 && M.push({ literal: !1, val: t }), t = d, a = d);
    }
    return t.length > 0 && M.push({ literal: r, val: t }), M;
  }
  static macroTokenToFormatOpts(n) {
    return ny[n];
  }
  constructor(n, a) {
    this.opts = a, this.loc = n, this.systemLoc = null;
  }
  formatWithSystemDefault(n, a) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(n, { ...this.opts, ...a }).format();
  }
  formatDateTime(n, a = {}) {
    return this.loc.dtFormatter(n, { ...this.opts, ...a }).format();
  }
  formatDateTimeParts(n, a = {}) {
    return this.loc.dtFormatter(n, { ...this.opts, ...a }).formatToParts();
  }
  resolvedOptions(n, a = {}) {
    return this.loc.dtFormatter(n, { ...this.opts, ...a }).resolvedOptions();
  }
  num(n, a = 0) {
    if (this.opts.forceSimple)
      return p1(n, a);
    const t = { ...this.opts };
    return a > 0 && (t.padTo = a), this.loc.numberFormatter(t).format(n);
  }
  formatDateTimeFromString(n, a) {
    const t = this.loc.listingMode() === "en", r = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", M = (y, $) => this.loc.extract(n, y, $), b = (y) => n.isOffsetFixed && n.offset === 0 && y.allowZ ? "Z" : n.isValid ? n.zone.formatOffset(n.ts, y.format) : "", d = () => t ? Jh(n) : M({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), c = (y, $) => t ? Zh(n, y) : M($ ? { month: y } : { month: y, day: "numeric" }, "month"), O = (y, $) => t ? Kh(n, y) : M(
      $ ? { weekday: y } : { weekday: y, month: "long", day: "numeric" },
      "weekday"
    ), A = (y) => {
      const $ = U1.macroTokenToFormatOpts(y);
      return $ ? this.formatWithSystemDefault(n, $) : y;
    }, m = (y) => t ? Qh(n, y) : M({ era: y }, "era"), q = (y) => {
      switch (y) {
        case "S":
          return this.num(n.millisecond);
        case "u":
        case "SSS":
          return this.num(n.millisecond, 3);
        case "s":
          return this.num(n.second);
        case "ss":
          return this.num(n.second, 2);
        case "uu":
          return this.num(Math.floor(n.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(n.millisecond / 100));
        case "m":
          return this.num(n.minute);
        case "mm":
          return this.num(n.minute, 2);
        case "h":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12);
        case "hh":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12, 2);
        case "H":
          return this.num(n.hour);
        case "HH":
          return this.num(n.hour, 2);
        case "Z":
          return b({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return b({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return b({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return n.zone.offsetName(n.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return n.zone.offsetName(n.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return n.zoneName;
        case "a":
          return d();
        case "d":
          return r ? M({ day: "numeric" }, "day") : this.num(n.day);
        case "dd":
          return r ? M({ day: "2-digit" }, "day") : this.num(n.day, 2);
        case "c":
          return this.num(n.weekday);
        case "ccc":
          return O("short", !0);
        case "cccc":
          return O("long", !0);
        case "ccccc":
          return O("narrow", !0);
        case "E":
          return this.num(n.weekday);
        case "EEE":
          return O("short", !1);
        case "EEEE":
          return O("long", !1);
        case "EEEEE":
          return O("narrow", !1);
        case "L":
          return r ? M({ month: "numeric", day: "numeric" }, "month") : this.num(n.month);
        case "LL":
          return r ? M({ month: "2-digit", day: "numeric" }, "month") : this.num(n.month, 2);
        case "LLL":
          return c("short", !0);
        case "LLLL":
          return c("long", !0);
        case "LLLLL":
          return c("narrow", !0);
        case "M":
          return r ? M({ month: "numeric" }, "month") : this.num(n.month);
        case "MM":
          return r ? M({ month: "2-digit" }, "month") : this.num(n.month, 2);
        case "MMM":
          return c("short", !1);
        case "MMMM":
          return c("long", !1);
        case "MMMMM":
          return c("narrow", !1);
        case "y":
          return r ? M({ year: "numeric" }, "year") : this.num(n.year);
        case "yy":
          return r ? M({ year: "2-digit" }, "year") : this.num(n.year.toString().slice(-2), 2);
        case "yyyy":
          return r ? M({ year: "numeric" }, "year") : this.num(n.year, 4);
        case "yyyyyy":
          return r ? M({ year: "numeric" }, "year") : this.num(n.year, 6);
        case "G":
          return m("short");
        case "GG":
          return m("long");
        case "GGGGG":
          return m("narrow");
        case "kk":
          return this.num(n.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(n.weekYear, 4);
        case "W":
          return this.num(n.weekNumber);
        case "WW":
          return this.num(n.weekNumber, 2);
        case "o":
          return this.num(n.ordinal);
        case "ooo":
          return this.num(n.ordinal, 3);
        case "q":
          return this.num(n.quarter);
        case "qq":
          return this.num(n.quarter, 2);
        case "X":
          return this.num(Math.floor(n.ts / 1e3));
        case "x":
          return this.num(n.ts);
        default:
          return A(y);
      }
    };
    return jp(U1.parseFormat(a), q);
  }
  formatDurationFromString(n, a) {
    const t = (c) => {
      switch (c[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, r = (c) => (O) => {
      const A = t(O);
      return A ? this.num(c.get(A), O.length) : O;
    }, M = U1.parseFormat(a), b = M.reduce(
      (c, { literal: O, val: A }) => O ? c : c.concat(A),
      []
    ), d = n.shiftTo(...b.map(t).filter((c) => c));
    return jp(M, r(d));
  }
}
class B2 {
  constructor(n, a) {
    this.reason = n, this.explanation = a;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
class Et {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new He();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new He();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new He();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, a) {
    throw new He();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, a) {
    throw new He();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    throw new He();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    throw new He();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new He();
  }
}
let iM = null;
class br extends Et {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return iM === null && (iM = new br()), iM;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(n, { format: a, locale: t }) {
    return Lz(n, a, t);
  }
  /** @override **/
  formatOffset(n, a) {
    return yt(this.offset(n), a);
  }
  /** @override **/
  offset(n) {
    return -new Date(n).getTimezoneOffset();
  }
  /** @override **/
  equals(n) {
    return n.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let Ao = {};
function ay(e) {
  return Ao[e] || (Ao[e] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), Ao[e];
}
const ty = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function oy(e, n) {
  const a = e.format(n).replace(/\u200E/g, ""), t = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(a), [, r, M, b, d, c, O, A] = t;
  return [b, r, M, d, c, O, A];
}
function ry(e, n) {
  const a = e.formatToParts(n), t = [];
  for (let r = 0; r < a.length; r++) {
    const { type: M, value: b } = a[r], d = ty[M];
    M === "era" ? t[d] = b : D0(d) || (t[d] = parseInt(b, 10));
  }
  return t;
}
let V3 = {};
class $e extends Et {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(n) {
    return V3[n] || (V3[n] = new $e(n)), V3[n];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    V3 = {}, Ao = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(n) {
    return this.isValidZone(n);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(n) {
    if (!n)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: n }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(n) {
    super(), this.zoneName = n, this.valid = $e.isValidZone(n);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(n, { format: a, locale: t }) {
    return Lz(n, a, t, this.name);
  }
  /** @override **/
  formatOffset(n, a) {
    return yt(this.offset(n), a);
  }
  /** @override **/
  offset(n) {
    const a = new Date(n);
    if (isNaN(a)) return NaN;
    const t = ay(this.name);
    let [r, M, b, d, c, O, A] = t.formatToParts ? ry(t, a) : oy(t, a);
    d === "BC" && (r = -Math.abs(r) + 1);
    const q = Y4({
      year: r,
      month: M,
      day: b,
      hour: c === 24 ? 0 : c,
      minute: O,
      second: A,
      millisecond: 0
    });
    let y = +a;
    const $ = y % 1e3;
    return y -= $ >= 0 ? $ : 1e3 + $, (q - y) / (60 * 1e3);
  }
  /** @override **/
  equals(n) {
    return n.type === "iana" && n.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let MM = null;
class C1 extends Et {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return MM === null && (MM = new C1(0)), MM;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(n) {
    return n === 0 ? C1.utcInstance : new C1(n);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(n) {
    if (n) {
      const a = n.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (a)
        return new C1(ir(a[1], a[2]));
    }
    return null;
  }
  constructor(n) {
    super(), this.fixed = n;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${yt(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${yt(-this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(n, a) {
    return yt(this.fixed, a);
  }
  /** @override **/
  get isUniversal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(n) {
    return n.type === "fixed" && n.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class iy extends Et {
  constructor(n) {
    super(), this.zoneName = n;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Je(e, n) {
  if (D0(e) || e === null)
    return n;
  if (e instanceof Et)
    return e;
  if (Ph(e)) {
    const a = e.toLowerCase();
    return a === "local" || a === "system" ? n : a === "utc" || a === "gmt" ? C1.utcInstance : C1.parseSpecifier(a) || $e.create(e);
  } else return vn(e) ? C1.instance(e) : typeof e == "object" && e.offset && typeof e.offset == "number" ? e : new iy(e);
}
let Gp = () => Date.now(), Vp = "system", Yp = null, Jp = null, Kp = null, Zp, A1 = class {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return Gp;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    Gp = n;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(n) {
    Vp = n;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Je(Vp, br.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return Yp;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(n) {
    Yp = n;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Jp;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(n) {
    Jp = n;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return Kp;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(n) {
    Kp = n;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return Zp;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(n) {
    Zp = n;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    q1.resetCache(), $e.resetCache();
  }
}, Qp = {};
function My(e, n = {}) {
  const a = JSON.stringify([e, n]);
  let t = Qp[a];
  return t || (t = new Intl.ListFormat(e, n), Qp[a] = t), t;
}
let a4 = {};
function t4(e, n = {}) {
  const a = JSON.stringify([e, n]);
  let t = a4[a];
  return t || (t = new Intl.DateTimeFormat(e, n), a4[a] = t), t;
}
let o4 = {};
function by(e, n = {}) {
  const a = JSON.stringify([e, n]);
  let t = o4[a];
  return t || (t = new Intl.NumberFormat(e, n), o4[a] = t), t;
}
let r4 = {};
function sy(e, n = {}) {
  const { base: a, ...t } = n, r = JSON.stringify([e, t]);
  let M = r4[r];
  return M || (M = new Intl.RelativeTimeFormat(e, n), r4[r] = M), M;
}
let ut = null;
function dy() {
  return ut || (ut = new Intl.DateTimeFormat().resolvedOptions().locale, ut);
}
function py(e) {
  const n = e.indexOf("-u-");
  if (n === -1)
    return [e];
  {
    let a;
    const t = e.substring(0, n);
    try {
      a = t4(e).resolvedOptions();
    } catch {
      a = t4(t).resolvedOptions();
    }
    const { numberingSystem: r, calendar: M } = a;
    return [t, r, M];
  }
}
function cy(e, n, a) {
  return (a || n) && (e += "-u", a && (e += `-ca-${a}`), n && (e += `-nu-${n}`)), e;
}
function zy(e) {
  const n = [];
  for (let a = 1; a <= 12; a++) {
    const t = P.utc(2016, a, 1);
    n.push(e(t));
  }
  return n;
}
function Oy(e) {
  const n = [];
  for (let a = 1; a <= 7; a++) {
    const t = P.utc(2016, 11, 13 + a);
    n.push(e(t));
  }
  return n;
}
function Y3(e, n, a, t, r) {
  const M = e.listingMode(a);
  return M === "error" ? null : M === "en" ? t(n) : r(n);
}
function uy(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || new Intl.DateTimeFormat(e.intl).resolvedOptions().numberingSystem === "latn";
}
class Ay {
  constructor(n, a, t) {
    this.padTo = t.padTo || 0, this.floor = t.floor || !1;
    const { padTo: r, floor: M, ...b } = t;
    if (!a || Object.keys(b).length > 0) {
      const d = { useGrouping: !1, ...t };
      t.padTo > 0 && (d.minimumIntegerDigits = t.padTo), this.inf = by(n, d);
    }
  }
  format(n) {
    if (this.inf) {
      const a = this.floor ? Math.floor(n) : n;
      return this.inf.format(a);
    } else {
      const a = this.floor ? Math.floor(n) : V4(n, 3);
      return p1(a, this.padTo);
    }
  }
}
class ly {
  constructor(n, a, t) {
    this.opts = t;
    let r;
    if (n.zone.isUniversal) {
      const b = -1 * (n.offset / 60), d = b >= 0 ? `Etc/GMT+${b}` : `Etc/GMT${b}`;
      n.offset !== 0 && $e.create(d).valid ? (r = d, this.dt = n) : (r = "UTC", t.timeZoneName ? this.dt = n : this.dt = n.offset === 0 ? n : P.fromMillis(n.ts + n.offset * 60 * 1e3));
    } else n.zone.type === "system" ? this.dt = n : (this.dt = n, r = n.zone.name);
    const M = { ...this.opts };
    r && (M.timeZone = r), this.dtf = t4(a, M);
  }
  format() {
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    return this.dtf.formatToParts(this.dt.toJSDate());
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class fy {
  constructor(n, a, t) {
    this.opts = { style: "long", ...t }, !a && $z() && (this.rtf = sy(n, t));
  }
  format(n, a) {
    return this.rtf ? this.rtf.format(n, a) : ey(a, n, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(n, a) {
    return this.rtf ? this.rtf.formatToParts(n, a) : [];
  }
}
let q1 = class At {
  static fromOpts(n) {
    return At.create(n.locale, n.numberingSystem, n.outputCalendar, n.defaultToEN);
  }
  static create(n, a, t, r = !1) {
    const M = n || A1.defaultLocale, b = M || (r ? "en-US" : dy()), d = a || A1.defaultNumberingSystem, c = t || A1.defaultOutputCalendar;
    return new At(b, d, c, M);
  }
  static resetCache() {
    ut = null, a4 = {}, o4 = {}, r4 = {};
  }
  static fromObject({ locale: n, numberingSystem: a, outputCalendar: t } = {}) {
    return At.create(n, a, t);
  }
  constructor(n, a, t, r) {
    const [M, b, d] = py(n);
    this.locale = M, this.numberingSystem = a || b || null, this.outputCalendar = t || d || null, this.intl = cy(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = r, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = uy(this)), this.fastNumbersCached;
  }
  listingMode() {
    const n = this.isEnglish(), a = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return n && a ? "en" : "intl";
  }
  clone(n) {
    return !n || Object.getOwnPropertyNames(n).length === 0 ? this : At.create(
      n.locale || this.specifiedLocale,
      n.numberingSystem || this.numberingSystem,
      n.outputCalendar || this.outputCalendar,
      n.defaultToEN || !1
    );
  }
  redefaultToEN(n = {}) {
    return this.clone({ ...n, defaultToEN: !0 });
  }
  redefaultToSystem(n = {}) {
    return this.clone({ ...n, defaultToEN: !1 });
  }
  months(n, a = !1, t = !0) {
    return Y3(this, n, t, Dz, () => {
      const r = a ? { month: n, day: "numeric" } : { month: n }, M = a ? "format" : "standalone";
      return this.monthsCache[M][n] || (this.monthsCache[M][n] = zy((b) => this.extract(b, r, "month"))), this.monthsCache[M][n];
    });
  }
  weekdays(n, a = !1, t = !0) {
    return Y3(this, n, t, Bz, () => {
      const r = a ? { weekday: n, year: "numeric", month: "long", day: "numeric" } : { weekday: n }, M = a ? "format" : "standalone";
      return this.weekdaysCache[M][n] || (this.weekdaysCache[M][n] = Oy(
        (b) => this.extract(b, r, "weekday")
      )), this.weekdaysCache[M][n];
    });
  }
  meridiems(n = !0) {
    return Y3(
      this,
      void 0,
      n,
      () => wz,
      () => {
        if (!this.meridiemCache) {
          const a = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [P.utc(2016, 11, 13, 9), P.utc(2016, 11, 13, 19)].map(
            (t) => this.extract(t, a, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(n, a = !0) {
    return Y3(this, n, a, Cz, () => {
      const t = { era: n };
      return this.eraCache[n] || (this.eraCache[n] = [P.utc(-40, 1, 1), P.utc(2017, 1, 1)].map(
        (r) => this.extract(r, t, "era")
      )), this.eraCache[n];
    });
  }
  extract(n, a, t) {
    const r = this.dtFormatter(n, a), M = r.formatToParts(), b = M.find((d) => d.type.toLowerCase() === t);
    return b ? b.value : null;
  }
  numberFormatter(n = {}) {
    return new Ay(this.intl, n.forceSimple || this.fastNumbers, n);
  }
  dtFormatter(n, a = {}) {
    return new ly(n, this.intl, a);
  }
  relFormatter(n = {}) {
    return new fy(this.intl, this.isEnglish(), n);
  }
  listFormatter(n = {}) {
    return My(this.intl, n);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  equals(n) {
    return this.locale === n.locale && this.numberingSystem === n.numberingSystem && this.outputCalendar === n.outputCalendar;
  }
};
function Sa(...e) {
  const n = e.reduce((a, t) => a + t.source, "");
  return RegExp(`^${n}$`);
}
function Ba(...e) {
  return (n) => e.reduce(
    ([a, t, r], M) => {
      const [b, d, c] = M(n, r);
      return [{ ...a, ...b }, d || t, c];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function wa(e, ...n) {
  if (e == null)
    return [null, null];
  for (const [a, t] of n) {
    const r = a.exec(e);
    if (r)
      return t(r);
  }
  return [null, null];
}
function Ez(...e) {
  return (n, a) => {
    const t = {};
    let r;
    for (r = 0; r < e.length; r++)
      t[e[r]] = Ge(n[a + r]);
    return [t, null, a + r];
  };
}
const Xz = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, my = `(?:${Xz.source}?(?:\\[(${Nz.source})\\])?)?`, J4 = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Pz = RegExp(`${J4.source}${my}`), K4 = RegExp(`(?:T${Pz.source})?`), qy = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, hy = /(\d{4})-?W(\d\d)(?:-?(\d))?/, yy = /(\d{4})-?(\d{3})/, Wy = Ez("weekYear", "weekNumber", "weekDay"), gy = Ez("year", "ordinal"), Ry = /(\d{4})-(\d\d)-(\d\d)/, kz = RegExp(
  `${J4.source} ?(?:${Xz.source}|(${Nz.source}))?`
), $y = RegExp(`(?: ${kz.source})?`);
function qa(e, n, a) {
  const t = e[n];
  return D0(t) ? a : Ge(t);
}
function Ly(e, n) {
  return [{
    year: qa(e, n),
    month: qa(e, n + 1, 1),
    day: qa(e, n + 2, 1)
  }, null, n + 3];
}
function Ca(e, n) {
  return [{
    hours: qa(e, n, 0),
    minutes: qa(e, n + 1, 0),
    seconds: qa(e, n + 2, 0),
    milliseconds: G4(e[n + 3])
  }, null, n + 4];
}
function Xt(e, n) {
  const a = !e[n] && !e[n + 1], t = ir(e[n + 1], e[n + 2]), r = a ? null : C1.instance(t);
  return [{}, r, n + 3];
}
function Pt(e, n) {
  const a = e[n] ? $e.create(e[n]) : null;
  return [{}, a, n + 1];
}
const _y = RegExp(`^T?${J4.source}$`), Ny = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function vy(e) {
  const [
    n,
    a,
    t,
    r,
    M,
    b,
    d,
    c,
    O
  ] = e, A = n[0] === "-", m = c && c[0] === "-", q = (y, $ = !1) => y !== void 0 && ($ || y && A) ? -y : y;
  return [
    {
      years: q(mn(a)),
      months: q(mn(t)),
      weeks: q(mn(r)),
      days: q(mn(M)),
      hours: q(mn(b)),
      minutes: q(mn(d)),
      seconds: q(mn(c), c === "-0"),
      milliseconds: q(G4(O), m)
    }
  ];
}
const Dy = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Z4(e, n, a, t, r, M, b) {
  const d = {
    year: n.length === 2 ? n4(Ge(n)) : Ge(n),
    month: vz.indexOf(a) + 1,
    day: Ge(t),
    hour: Ge(r),
    minute: Ge(M)
  };
  return b && (d.second = Ge(b)), e && (d.weekday = e.length > 3 ? Tz.indexOf(e) + 1 : Sz.indexOf(e) + 1), d;
}
const Ty = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Sy(e) {
  const [
    ,
    n,
    a,
    t,
    r,
    M,
    b,
    d,
    c,
    O,
    A,
    m
  ] = e, q = Z4(n, r, t, a, M, b, d);
  let y;
  return c ? y = Dy[c] : O ? y = 0 : y = ir(A, m), [q, new C1(y)];
}
function By(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const wy = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, Cy = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Ey = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function ec(e) {
  const [, n, a, t, r, M, b, d] = e;
  return [Z4(n, r, t, a, M, b, d), C1.utcInstance];
}
function Xy(e) {
  const [, n, a, t, r, M, b, d] = e;
  return [Z4(n, d, a, t, r, M, b), C1.utcInstance];
}
const Py = Sa(qy, K4), ky = Sa(hy, K4), Iy = Sa(yy, K4), xy = Sa(Pz), Iz = Ba(
  Ly,
  Ca,
  Xt,
  Pt
), Fy = Ba(
  Wy,
  Ca,
  Xt,
  Pt
), Hy = Ba(
  gy,
  Ca,
  Xt,
  Pt
), Uy = Ba(
  Ca,
  Xt,
  Pt
);
function jy(e) {
  return wa(
    e,
    [Py, Iz],
    [ky, Fy],
    [Iy, Hy],
    [xy, Uy]
  );
}
function Gy(e) {
  return wa(By(e), [Ty, Sy]);
}
function Vy(e) {
  return wa(
    e,
    [wy, ec],
    [Cy, ec],
    [Ey, Xy]
  );
}
function Yy(e) {
  return wa(e, [Ny, vy]);
}
const Jy = Ba(Ca);
function Ky(e) {
  return wa(e, [_y, Jy]);
}
const Zy = Sa(Ry, $y), Qy = Sa(kz), eW = Ba(
  Ca,
  Xt,
  Pt
);
function nW(e) {
  return wa(
    e,
    [Zy, Iz],
    [Qy, eW]
  );
}
const aW = "Invalid Duration", xz = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, tW = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...xz
}, u2 = 146097 / 400, ba = 146097 / 4800, oW = {
  years: {
    quarters: 4,
    months: 12,
    weeks: u2 / 7,
    days: u2,
    hours: u2 * 24,
    minutes: u2 * 24 * 60,
    seconds: u2 * 24 * 60 * 60,
    milliseconds: u2 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: u2 / 28,
    days: u2 / 4,
    hours: u2 * 24 / 4,
    minutes: u2 * 24 * 60 / 4,
    seconds: u2 * 24 * 60 * 60 / 4,
    milliseconds: u2 * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: ba / 7,
    days: ba,
    hours: ba * 24,
    minutes: ba * 24 * 60,
    seconds: ba * 24 * 60 * 60,
    milliseconds: ba * 24 * 60 * 60 * 1e3
  },
  ...xz
}, Rn = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], rW = Rn.slice(0).reverse();
function qn(e, n, a = !1) {
  const t = {
    values: a ? n.values : { ...e.values, ...n.values || {} },
    loc: e.loc.clone(n.loc),
    conversionAccuracy: n.conversionAccuracy || e.conversionAccuracy
  };
  return new v1(t);
}
function iW(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Fz(e, n, a, t, r) {
  const M = e[r][a], b = n[a] / M, d = Math.sign(b) === Math.sign(t[r]), c = !d && t[r] !== 0 && Math.abs(b) <= 1 ? iW(b) : Math.trunc(b);
  t[r] += c, n[a] -= c * M;
}
function MW(e, n) {
  rW.reduce((a, t) => D0(n[t]) ? a : (a && Fz(e, n, a, n, t), t), null);
}
let v1 = class g1 {
  /**
   * @private
   */
  constructor(n) {
    const a = n.conversionAccuracy === "longterm" || !1;
    this.values = n.values, this.loc = n.loc || q1.create(), this.conversionAccuracy = a ? "longterm" : "casual", this.invalid = n.invalid || null, this.matrix = a ? oW : tW, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(n, a) {
    return g1.fromObject({ milliseconds: n }, a);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromObject(n, a = {}) {
    if (n == null || typeof n != "object")
      throw new l2(
        `Duration.fromObject: argument expected to be an object, got ${n === null ? "null" : typeof n}`
      );
    return new g1({
      values: Bo(n, g1.normalizeUnit),
      loc: q1.fromObject(a),
      conversionAccuracy: a.conversionAccuracy
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(n) {
    if (vn(n))
      return g1.fromMillis(n);
    if (g1.isDuration(n))
      return n;
    if (typeof n == "object")
      return g1.fromObject(n);
    throw new l2(
      `Unknown duration argument ${n} of type ${typeof n}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(n, a) {
    const [t] = Yy(n);
    return t ? g1.fromObject(t, a) : g1.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(n, a) {
    const [t] = Ky(n);
    return t ? g1.fromObject(t, a) : g1.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(n, a = null) {
    if (!n)
      throw new l2("need to specify a reason the Duration is invalid");
    const t = n instanceof B2 ? n : new B2(n, a);
    if (A1.throwOnInvalid)
      throw new Ch(t);
    return new g1({ invalid: t });
  }
  /**
   * @private
   */
  static normalizeUnit(n) {
    const a = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[n && n.toLowerCase()];
    if (!a) throw new iz(n);
    return a;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(n) {
    return n && n.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(n, a = {}) {
    const t = {
      ...a,
      floor: a.round !== !1 && a.floor !== !1
    };
    return this.isValid ? U1.create(this.loc, t).formatDurationFromString(this, n) : aW;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(n = {}) {
    const a = Rn.map((t) => {
      const r = this.values[t];
      return D0(r) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...n, unit: t.slice(0, -1) }).format(r);
    }).filter((t) => t);
    return this.loc.listFormatter({ type: "conjunction", style: n.listStyle || "narrow", ...n }).format(a);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let n = "P";
    return this.years !== 0 && (n += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (n += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (n += this.weeks + "W"), this.days !== 0 && (n += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (n += "T"), this.hours !== 0 && (n += this.hours + "H"), this.minutes !== 0 && (n += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (n += V4(this.seconds + this.milliseconds / 1e3, 3) + "S"), n === "P" && (n += "T0S"), n;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(n = {}) {
    if (!this.isValid) return null;
    const a = this.toMillis();
    if (a < 0 || a >= 864e5) return null;
    n = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...n
    };
    const t = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    let r = n.format === "basic" ? "hhmm" : "hh:mm";
    (!n.suppressSeconds || t.seconds !== 0 || t.milliseconds !== 0) && (r += n.format === "basic" ? "ss" : ":ss", (!n.suppressMilliseconds || t.milliseconds !== 0) && (r += ".SSS"));
    let M = t.toFormat(r);
    return n.includePrefix && (M = "T" + M), M;
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.as("milliseconds");
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(n) {
    if (!this.isValid) return this;
    const a = g1.fromDurationLike(n), t = {};
    for (const r of Rn)
      ($a(a.values, r) || $a(this.values, r)) && (t[r] = a.get(r) + this.get(r));
    return qn(this, { values: t }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(n) {
    if (!this.isValid) return this;
    const a = g1.fromDurationLike(n);
    return this.plus(a.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(n) {
    if (!this.isValid) return this;
    const a = {};
    for (const t of Object.keys(this.values))
      a[t] = _z(n(this.values[t], t));
    return qn(this, { values: a }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(n) {
    return this[g1.normalizeUnit(n)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(n) {
    if (!this.isValid) return this;
    const a = { ...this.values, ...Bo(n, g1.normalizeUnit) };
    return qn(this, { values: a });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: n, numberingSystem: a, conversionAccuracy: t } = {}) {
    const r = this.loc.clone({ locale: n, numberingSystem: a }), M = { loc: r };
    return t && (M.conversionAccuracy = t), qn(this, M);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(n) {
    return this.isValid ? this.shiftTo(n).get(n) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const n = this.toObject();
    return MW(this.matrix, n), qn(this, { values: n }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...n) {
    if (!this.isValid) return this;
    if (n.length === 0)
      return this;
    n = n.map((b) => g1.normalizeUnit(b));
    const a = {}, t = {}, r = this.toObject();
    let M;
    for (const b of Rn)
      if (n.indexOf(b) >= 0) {
        M = b;
        let d = 0;
        for (const O in t)
          d += this.matrix[O][b] * t[O], t[O] = 0;
        vn(r[b]) && (d += r[b]);
        const c = Math.trunc(d);
        a[b] = c, t[b] = (d * 1e3 - c * 1e3) / 1e3;
        for (const O in r)
          Rn.indexOf(O) > Rn.indexOf(b) && Fz(this.matrix, r, O, a, b);
      } else vn(r[b]) && (t[b] = r[b]);
    for (const b in t)
      t[b] !== 0 && (a[M] += b === M ? t[b] : t[b] / this.matrix[M][b]);
    return qn(this, { values: a }, !0).normalize();
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const n = {};
    for (const a of Object.keys(this.values))
      n[a] = this.values[a] === 0 ? 0 : -this.values[a];
    return qn(this, { values: n }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(n) {
    if (!this.isValid || !n.isValid || !this.loc.equals(n.loc))
      return !1;
    function a(t, r) {
      return t === void 0 || t === 0 ? r === void 0 || r === 0 : t === r;
    }
    for (const t of Rn)
      if (!a(this.values[t], n.values[t]))
        return !1;
    return !0;
  }
};
const ot = "Invalid Interval";
function bW(e, n) {
  return !e || !e.isValid ? i1.invalid("missing or invalid start") : !n || !n.isValid ? i1.invalid("missing or invalid end") : n < e ? i1.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${n.toISO()}`
  ) : null;
}
class i1 {
  /**
   * @private
   */
  constructor(n) {
    this.s = n.start, this.e = n.end, this.invalid = n.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(n, a = null) {
    if (!n)
      throw new l2("need to specify a reason the Interval is invalid");
    const t = n instanceof B2 ? n : new B2(n, a);
    if (A1.throwOnInvalid)
      throw new wh(t);
    return new i1({ invalid: t });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(n, a) {
    const t = Mt(n), r = Mt(a), M = bW(t, r);
    return M ?? new i1({
      start: t,
      end: r
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(n, a) {
    const t = v1.fromDurationLike(a), r = Mt(n);
    return i1.fromDateTimes(r, r.plus(t));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(n, a) {
    const t = v1.fromDurationLike(a), r = Mt(n);
    return i1.fromDateTimes(r.minus(t), r);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(n, a) {
    const [t, r] = (n || "").split("/", 2);
    if (t && r) {
      let M, b;
      try {
        M = P.fromISO(t, a), b = M.isValid;
      } catch {
        b = !1;
      }
      let d, c;
      try {
        d = P.fromISO(r, a), c = d.isValid;
      } catch {
        c = !1;
      }
      if (b && c)
        return i1.fromDateTimes(M, d);
      if (b) {
        const O = v1.fromISO(r, a);
        if (O.isValid)
          return i1.after(M, O);
      } else if (c) {
        const O = v1.fromISO(t, a);
        if (O.isValid)
          return i1.before(d, O);
      }
    }
    return i1.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(n) {
    return n && n.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(n = "milliseconds") {
    return this.isValid ? this.toDuration(n).get(n) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  count(n = "milliseconds") {
    if (!this.isValid) return NaN;
    const a = this.start.startOf(n), t = this.end.startOf(n);
    return Math.floor(t.diff(a, n).get(n)) + 1;
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(n) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, n) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(n) {
    return this.isValid ? this.s > n : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(n) {
    return this.isValid ? this.e <= n : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(n) {
    return this.isValid ? this.s <= n && this.e > n : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: n, end: a } = {}) {
    return this.isValid ? i1.fromDateTimes(n || this.s, a || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...n) {
    if (!this.isValid) return [];
    const a = n.map(Mt).filter((b) => this.contains(b)).sort(), t = [];
    let { s: r } = this, M = 0;
    for (; r < this.e; ) {
      const b = a[M] || this.e, d = +b > +this.e ? this.e : b;
      t.push(i1.fromDateTimes(r, d)), r = d, M += 1;
    }
    return t;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(n) {
    const a = v1.fromDurationLike(n);
    if (!this.isValid || !a.isValid || a.as("milliseconds") === 0)
      return [];
    let { s: t } = this, r = 1, M;
    const b = [];
    for (; t < this.e; ) {
      const d = this.start.plus(a.mapUnits((c) => c * r));
      M = +d > +this.e ? this.e : d, b.push(i1.fromDateTimes(t, M)), t = M, r += 1;
    }
    return b;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(n) {
    return this.isValid ? this.splitBy(this.length() / n).slice(0, n) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(n) {
    return this.e > n.s && this.s < n.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(n) {
    return this.isValid ? +this.e == +n.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(n) {
    return this.isValid ? +n.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(n) {
    return this.isValid ? this.s <= n.s && this.e >= n.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(n) {
    return !this.isValid || !n.isValid ? !1 : this.s.equals(n.s) && this.e.equals(n.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(n) {
    if (!this.isValid) return this;
    const a = this.s > n.s ? this.s : n.s, t = this.e < n.e ? this.e : n.e;
    return a >= t ? null : i1.fromDateTimes(a, t);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(n) {
    if (!this.isValid) return this;
    const a = this.s < n.s ? this.s : n.s, t = this.e > n.e ? this.e : n.e;
    return i1.fromDateTimes(a, t);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(n) {
    const [a, t] = n.sort((r, M) => r.s - M.s).reduce(
      ([r, M], b) => M ? M.overlaps(b) || M.abutsStart(b) ? [r, M.union(b)] : [r.concat([M]), b] : [r, b],
      [[], null]
    );
    return t && a.push(t), a;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(n) {
    let a = null, t = 0;
    const r = [], M = n.map((c) => [
      { time: c.s, type: "s" },
      { time: c.e, type: "e" }
    ]), b = Array.prototype.concat(...M), d = b.sort((c, O) => c.time - O.time);
    for (const c of d)
      t += c.type === "s" ? 1 : -1, t === 1 ? a = c.time : (a && +a != +c.time && r.push(i1.fromDateTimes(a, c.time)), a = null);
    return i1.merge(r);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...n) {
    return i1.xor([this].concat(n)).map((a) => this.intersection(a)).filter((a) => a && !a.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : ot;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(n) {
    return this.isValid ? `${this.s.toISO(n)}/${this.e.toISO(n)}` : ot;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : ot;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(n) {
    return this.isValid ? `${this.s.toISOTime(n)}/${this.e.toISOTime(n)}` : ot;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime#toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */
  toFormat(n, { separator: a = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(n)}${a}${this.e.toFormat(n)}` : ot;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(n, a) {
    return this.isValid ? this.e.diff(this.s, n, a) : v1.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(n) {
    return i1.fromDateTimes(n(this.s), n(this.e));
  }
}
class m2 {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(n = A1.defaultZone) {
    const a = P.now().setZone(n).set({ month: 12 });
    return !n.isUniversal && a.offset !== a.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(n) {
    return $e.isValidZone(n);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(n) {
    return Je(n, A1.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(n = "long", { locale: a = null, numberingSystem: t = null, locObj: r = null, outputCalendar: M = "gregory" } = {}) {
    return (r || q1.create(a, t, M)).months(n);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(n = "long", { locale: a = null, numberingSystem: t = null, locObj: r = null, outputCalendar: M = "gregory" } = {}) {
    return (r || q1.create(a, t, M)).months(n, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(n = "long", { locale: a = null, numberingSystem: t = null, locObj: r = null } = {}) {
    return (r || q1.create(a, t, null)).weekdays(n);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(n = "long", { locale: a = null, numberingSystem: t = null, locObj: r = null } = {}) {
    return (r || q1.create(a, t, null)).weekdays(n, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: n = null } = {}) {
    return q1.create(n).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(n = "short", { locale: a = null } = {}) {
    return q1.create(a, null, "gregory").eras(n);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */
  static features() {
    return { relative: $z() };
  }
}
function nc(e, n) {
  const a = (r) => r.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), t = a(n) - a(e);
  return Math.floor(v1.fromMillis(t).as("days"));
}
function sW(e, n, a) {
  const t = [
    ["years", (d, c) => c.year - d.year],
    ["quarters", (d, c) => c.quarter - d.quarter],
    ["months", (d, c) => c.month - d.month + (c.year - d.year) * 12],
    [
      "weeks",
      (d, c) => {
        const O = nc(d, c);
        return (O - O % 7) / 7;
      }
    ],
    ["days", nc]
  ], r = {};
  let M, b;
  for (const [d, c] of t)
    if (a.indexOf(d) >= 0) {
      M = d;
      let O = c(e, n);
      b = e.plus({ [d]: O }), b > n ? (e = e.plus({ [d]: O - 1 }), O -= 1) : e = b, r[d] = O;
    }
  return [e, r, b, M];
}
function dW(e, n, a, t) {
  let [r, M, b, d] = sW(e, n, a);
  const c = n - r, O = a.filter(
    (m) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(m) >= 0
  );
  O.length === 0 && (b < n && (b = r.plus({ [d]: 1 })), b !== r && (M[d] = (M[d] || 0) + c / (b - r)));
  const A = v1.fromObject(M, t);
  return O.length > 0 ? v1.fromMillis(c, t).shiftTo(...O).plus(A) : A;
}
const Q4 = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, ac = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, pW = Q4.hanidec.replace(/[\[|\]]/g, "").split("");
function cW(e) {
  let n = parseInt(e, 10);
  if (isNaN(n)) {
    n = "";
    for (let a = 0; a < e.length; a++) {
      const t = e.charCodeAt(a);
      if (e[a].search(Q4.hanidec) !== -1)
        n += pW.indexOf(e[a]);
      else
        for (const r in ac) {
          const [M, b] = ac[r];
          t >= M && t <= b && (n += t - M);
        }
    }
    return parseInt(n, 10);
  } else
    return n;
}
function _2({ numberingSystem: e }, n = "") {
  return new RegExp(`${Q4[e || "latn"]}${n}`);
}
const zW = "missing Intl.DateTimeFormat.formatToParts support";
function E0(e, n = (a) => a) {
  return { regex: e, deser: ([a]) => n(cW(a)) };
}
const OW = " ", Hz = `[ ${OW}]`, Uz = new RegExp(Hz, "g");
function uW(e) {
  return e.replace(/\./g, "\\.?").replace(Uz, Hz);
}
function tc(e) {
  return e.replace(/\./g, "").replace(Uz, " ").toLowerCase();
}
function N2(e, n) {
  return e === null ? null : {
    regex: RegExp(e.map(uW).join("|")),
    deser: ([a]) => e.findIndex((t) => tc(a) === tc(t)) + n
  };
}
function oc(e, n) {
  return { regex: e, deser: ([, a, t]) => ir(a, t), groups: n };
}
function bM(e) {
  return { regex: e, deser: ([n]) => n };
}
function AW(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function lW(e, n) {
  const a = _2(n), t = _2(n, "{2}"), r = _2(n, "{3}"), M = _2(n, "{4}"), b = _2(n, "{6}"), d = _2(n, "{1,2}"), c = _2(n, "{1,3}"), O = _2(n, "{1,6}"), A = _2(n, "{1,9}"), m = _2(n, "{2,4}"), q = _2(n, "{4,6}"), y = (E) => ({ regex: RegExp(AW(E.val)), deser: ([t0]) => t0, literal: !0 }), v = ((E) => {
    if (e.literal)
      return y(E);
    switch (E.val) {
      case "G":
        return N2(n.eras("short", !1), 0);
      case "GG":
        return N2(n.eras("long", !1), 0);
      case "y":
        return E0(O);
      case "yy":
        return E0(m, n4);
      case "yyyy":
        return E0(M);
      case "yyyyy":
        return E0(q);
      case "yyyyyy":
        return E0(b);
      case "M":
        return E0(d);
      case "MM":
        return E0(t);
      case "MMM":
        return N2(n.months("short", !0, !1), 1);
      case "MMMM":
        return N2(n.months("long", !0, !1), 1);
      case "L":
        return E0(d);
      case "LL":
        return E0(t);
      case "LLL":
        return N2(n.months("short", !1, !1), 1);
      case "LLLL":
        return N2(n.months("long", !1, !1), 1);
      case "d":
        return E0(d);
      case "dd":
        return E0(t);
      case "o":
        return E0(c);
      case "ooo":
        return E0(r);
      case "HH":
        return E0(t);
      case "H":
        return E0(d);
      case "hh":
        return E0(t);
      case "h":
        return E0(d);
      case "mm":
        return E0(t);
      case "m":
        return E0(d);
      case "q":
        return E0(d);
      case "qq":
        return E0(t);
      case "s":
        return E0(d);
      case "ss":
        return E0(t);
      case "S":
        return E0(c);
      case "SSS":
        return E0(r);
      case "u":
        return bM(A);
      case "uu":
        return bM(d);
      case "uuu":
        return E0(a);
      case "a":
        return N2(n.meridiems(), 0);
      case "kkkk":
        return E0(M);
      case "kk":
        return E0(m, n4);
      case "W":
        return E0(d);
      case "WW":
        return E0(t);
      case "E":
      case "c":
        return E0(a);
      case "EEE":
        return N2(n.weekdays("short", !1, !1), 1);
      case "EEEE":
        return N2(n.weekdays("long", !1, !1), 1);
      case "ccc":
        return N2(n.weekdays("short", !0, !1), 1);
      case "cccc":
        return N2(n.weekdays("long", !0, !1), 1);
      case "Z":
      case "ZZ":
        return oc(new RegExp(`([+-]${d.source})(?::(${t.source}))?`), 2);
      case "ZZZ":
        return oc(new RegExp(`([+-]${d.source})(${t.source})?`), 2);
      case "z":
        return bM(/[a-z_+-/]{1,256}?/i);
      default:
        return y(E);
    }
  })(e) || {
    invalidReason: zW
  };
  return v.token = e, v;
}
const fW = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  }
};
function mW(e, n, a) {
  const { type: t, value: r } = e;
  if (t === "literal")
    return {
      literal: !0,
      val: r
    };
  const M = a[t];
  let b = fW[t];
  if (typeof b == "object" && (b = b[M]), b)
    return {
      literal: !1,
      val: b
    };
}
function qW(e) {
  return [`^${e.map((a) => a.regex).reduce((a, t) => `${a}(${t.source})`, "")}$`, e];
}
function hW(e, n, a) {
  const t = e.match(n);
  if (t) {
    const r = {};
    let M = 1;
    for (const b in a)
      if ($a(a, b)) {
        const d = a[b], c = d.groups ? d.groups + 1 : 1;
        !d.literal && d.token && (r[d.token.val[0]] = d.deser(t.slice(M, M + c))), M += c;
      }
    return [t, r];
  } else
    return [t, {}];
}
function yW(e) {
  const n = (M) => {
    switch (M) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let a = null, t;
  return D0(e.z) || (a = $e.create(e.z)), D0(e.Z) || (a || (a = new C1(e.Z)), t = e.Z), D0(e.q) || (e.M = (e.q - 1) * 3 + 1), D0(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), D0(e.u) || (e.S = G4(e.u)), [Object.keys(e).reduce((M, b) => {
    const d = n(b);
    return d && (M[d] = e[b]), M;
  }, {}), a, t];
}
let sM = null;
function WW() {
  return sM || (sM = P.fromMillis(1555555555555)), sM;
}
function gW(e, n) {
  if (e.literal)
    return e;
  const a = U1.macroTokenToFormatOpts(e.val);
  if (!a)
    return e;
  const M = U1.create(n, a).formatDateTimeParts(WW()).map((b) => mW(b, n, a));
  return M.includes(void 0) ? e : M;
}
function RW(e, n) {
  return Array.prototype.concat(...e.map((a) => gW(a, n)));
}
function jz(e, n, a) {
  const t = RW(U1.parseFormat(a), e), r = t.map((b) => lW(b, e)), M = r.find((b) => b.invalidReason);
  if (M)
    return { input: n, tokens: t, invalidReason: M.invalidReason };
  {
    const [b, d] = qW(r), c = RegExp(b, "i"), [O, A] = hW(n, c, d), [m, q, y] = A ? yW(A) : [null, null, void 0];
    if ($a(A, "a") && $a(A, "H"))
      throw new Ot(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: n, tokens: t, regex: c, rawMatches: O, matches: A, result: m, zone: q, specificOffset: y };
  }
}
function $W(e, n, a) {
  const { result: t, zone: r, specificOffset: M, invalidReason: b } = jz(e, n, a);
  return [t, r, M, b];
}
const Gz = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], Vz = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function q2(e, n) {
  return new B2(
    "unit out of range",
    `you specified ${n} (of type ${typeof n}) as a ${e}, which is invalid`
  );
}
function Yz(e, n, a) {
  const t = new Date(Date.UTC(e, n - 1, a));
  e < 100 && e >= 0 && t.setUTCFullYear(t.getUTCFullYear() - 1900);
  const r = t.getUTCDay();
  return r === 0 ? 7 : r;
}
function Jz(e, n, a) {
  return a + (Ct(e) ? Vz : Gz)[n - 1];
}
function Kz(e, n) {
  const a = Ct(e) ? Vz : Gz, t = a.findIndex((M) => M < n), r = n - a[t];
  return { month: t + 1, day: r };
}
function i4(e) {
  const { year: n, month: a, day: t } = e, r = Jz(n, a, t), M = Yz(n, a, t);
  let b = Math.floor((r - M + 10) / 7), d;
  return b < 1 ? (d = n - 1, b = So(d)) : b > So(n) ? (d = n + 1, b = 1) : d = n, { weekYear: d, weekNumber: b, weekday: M, ...Mr(e) };
}
function rc(e) {
  const { weekYear: n, weekNumber: a, weekday: t } = e, r = Yz(n, 1, 4), M = ht(n);
  let b = a * 7 + t - r - 3, d;
  b < 1 ? (d = n - 1, b += ht(d)) : b > M ? (d = n + 1, b -= ht(n)) : d = n;
  const { month: c, day: O } = Kz(d, b);
  return { year: d, month: c, day: O, ...Mr(e) };
}
function dM(e) {
  const { year: n, month: a, day: t } = e, r = Jz(n, a, t);
  return { year: n, ordinal: r, ...Mr(e) };
}
function ic(e) {
  const { year: n, ordinal: a } = e, { month: t, day: r } = Kz(n, a);
  return { year: n, month: t, day: r, ...Mr(e) };
}
function LW(e) {
  const n = rr(e.weekYear), a = me(e.weekNumber, 1, So(e.weekYear)), t = me(e.weekday, 1, 7);
  return n ? a ? t ? !1 : q2("weekday", e.weekday) : q2("week", e.week) : q2("weekYear", e.weekYear);
}
function _W(e) {
  const n = rr(e.year), a = me(e.ordinal, 1, ht(e.year));
  return n ? a ? !1 : q2("ordinal", e.ordinal) : q2("year", e.year);
}
function Zz(e) {
  const n = rr(e.year), a = me(e.month, 1, 12), t = me(e.day, 1, To(e.year, e.month));
  return n ? a ? t ? !1 : q2("day", e.day) : q2("month", e.month) : q2("year", e.year);
}
function Qz(e) {
  const { hour: n, minute: a, second: t, millisecond: r } = e, M = me(n, 0, 23) || n === 24 && a === 0 && t === 0 && r === 0, b = me(a, 0, 59), d = me(t, 0, 59), c = me(r, 0, 999);
  return M ? b ? d ? c ? !1 : q2("millisecond", r) : q2("second", t) : q2("minute", a) : q2("hour", n);
}
const pM = "Invalid DateTime", Mc = 864e13;
function J3(e) {
  return new B2("unsupported zone", `the zone "${e.name}" is not supported`);
}
function cM(e) {
  return e.weekData === null && (e.weekData = i4(e.c)), e.weekData;
}
function rt(e, n) {
  const a = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new P({ ...a, ...n, old: a });
}
function e6(e, n, a) {
  let t = e - n * 60 * 1e3;
  const r = a.offset(t);
  if (n === r)
    return [t, n];
  t -= (r - n) * 60 * 1e3;
  const M = a.offset(t);
  return r === M ? [t, r] : [e - Math.min(r, M) * 60 * 1e3, Math.max(r, M)];
}
function bc(e, n) {
  e += n * 60 * 1e3;
  const a = new Date(e);
  return {
    year: a.getUTCFullYear(),
    month: a.getUTCMonth() + 1,
    day: a.getUTCDate(),
    hour: a.getUTCHours(),
    minute: a.getUTCMinutes(),
    second: a.getUTCSeconds(),
    millisecond: a.getUTCMilliseconds()
  };
}
function lo(e, n, a) {
  return e6(Y4(e), n, a);
}
function sc(e, n) {
  const a = e.o, t = e.c.year + Math.trunc(n.years), r = e.c.month + Math.trunc(n.months) + Math.trunc(n.quarters) * 3, M = {
    ...e.c,
    year: t,
    month: r,
    day: Math.min(e.c.day, To(t, r)) + Math.trunc(n.days) + Math.trunc(n.weeks) * 7
  }, b = v1.fromObject({
    years: n.years - Math.trunc(n.years),
    quarters: n.quarters - Math.trunc(n.quarters),
    months: n.months - Math.trunc(n.months),
    weeks: n.weeks - Math.trunc(n.weeks),
    days: n.days - Math.trunc(n.days),
    hours: n.hours,
    minutes: n.minutes,
    seconds: n.seconds,
    milliseconds: n.milliseconds
  }).as("milliseconds"), d = Y4(M);
  let [c, O] = e6(d, a, e.zone);
  return b !== 0 && (c += b, O = e.zone.offset(c)), { ts: c, o: O };
}
function it(e, n, a, t, r, M) {
  const { setZone: b, zone: d } = a;
  if (e && Object.keys(e).length !== 0) {
    const c = n || d, O = P.fromObject(e, {
      ...a,
      zone: c,
      specificOffset: M
    });
    return b ? O : O.setZone(d);
  } else
    return P.invalid(
      new B2("unparsable", `the input "${r}" can't be parsed as ${t}`)
    );
}
function K3(e, n, a = !0) {
  return e.isValid ? U1.create(q1.create("en-US"), {
    allowZ: a,
    forceSimple: !0
  }).formatDateTimeFromString(e, n) : null;
}
function zM(e, n) {
  const a = e.c.year > 9999 || e.c.year < 0;
  let t = "";
  return a && e.c.year >= 0 && (t += "+"), t += p1(e.c.year, a ? 6 : 4), n ? (t += "-", t += p1(e.c.month), t += "-", t += p1(e.c.day)) : (t += p1(e.c.month), t += p1(e.c.day)), t;
}
function dc(e, n, a, t, r, M) {
  let b = p1(e.c.hour);
  return n ? (b += ":", b += p1(e.c.minute), (e.c.second !== 0 || !a) && (b += ":")) : b += p1(e.c.minute), (e.c.second !== 0 || !a) && (b += p1(e.c.second), (e.c.millisecond !== 0 || !t) && (b += ".", b += p1(e.c.millisecond, 3))), r && (e.isOffsetFixed && e.offset === 0 && !M ? b += "Z" : e.o < 0 ? (b += "-", b += p1(Math.trunc(-e.o / 60)), b += ":", b += p1(Math.trunc(-e.o % 60))) : (b += "+", b += p1(Math.trunc(e.o / 60)), b += ":", b += p1(Math.trunc(e.o % 60)))), M && (b += "[" + e.zone.ianaName + "]"), b;
}
const n6 = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, NW = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, vW = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, a6 = ["year", "month", "day", "hour", "minute", "second", "millisecond"], DW = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], TW = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function pc(e) {
  const n = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!n) throw new iz(e);
  return n;
}
function cc(e, n) {
  const a = Je(n.zone, A1.defaultZone), t = q1.fromObject(n), r = A1.now();
  let M, b;
  if (D0(e.year))
    M = r;
  else {
    for (const O of a6)
      D0(e[O]) && (e[O] = n6[O]);
    const d = Zz(e) || Qz(e);
    if (d)
      return P.invalid(d);
    const c = a.offset(r);
    [M, b] = lo(e, c, a);
  }
  return new P({ ts: M, zone: a, loc: t, o: b });
}
function zc(e, n, a) {
  const t = D0(a.round) ? !0 : a.round, r = (b, d) => (b = V4(b, t || a.calendary ? 0 : 2, !0), n.loc.clone(a).relFormatter(a).format(b, d)), M = (b) => a.calendary ? n.hasSame(e, b) ? 0 : n.startOf(b).diff(e.startOf(b), b).get(b) : n.diff(e, b).get(b);
  if (a.unit)
    return r(M(a.unit), a.unit);
  for (const b of a.units) {
    const d = M(b);
    if (Math.abs(d) >= 1)
      return r(d, b);
  }
  return r(e > n ? -0 : 0, a.units[a.units.length - 1]);
}
function Oc(e) {
  let n = {}, a;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (n = e[e.length - 1], a = Array.from(e).slice(0, e.length - 1)) : a = Array.from(e), [n, a];
}
class P {
  /**
   * @access private
   */
  constructor(n) {
    const a = n.zone || A1.defaultZone;
    let t = n.invalid || (Number.isNaN(n.ts) ? new B2("invalid input") : null) || (a.isValid ? null : J3(a));
    this.ts = D0(n.ts) ? A1.now() : n.ts;
    let r = null, M = null;
    if (!t)
      if (n.old && n.old.ts === this.ts && n.old.zone.equals(a))
        [r, M] = [n.old.c, n.old.o];
      else {
        const d = a.offset(this.ts);
        r = bc(this.ts, d), t = Number.isNaN(r.year) ? new B2("invalid input") : null, r = t ? null : r, M = t ? null : d;
      }
    this._zone = a, this.loc = n.loc || q1.create(), this.invalid = t, this.weekData = null, this.c = r, this.o = M, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new P({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [n, a] = Oc(arguments), [t, r, M, b, d, c, O] = a;
    return cc({ year: t, month: r, day: M, hour: b, minute: d, second: c, millisecond: O }, n);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [n, a] = Oc(arguments), [t, r, M, b, d, c, O] = a;
    return n.zone = C1.utcInstance, cc({ year: t, month: r, day: M, hour: b, minute: d, second: c, millisecond: O }, n);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(n, a = {}) {
    const t = kh(n) ? n.valueOf() : NaN;
    if (Number.isNaN(t))
      return P.invalid("invalid input");
    const r = Je(a.zone, A1.defaultZone);
    return r.isValid ? new P({
      ts: t,
      zone: r,
      loc: q1.fromObject(a)
    }) : P.invalid(J3(r));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(n, a = {}) {
    if (vn(n))
      return n < -Mc || n > Mc ? P.invalid("Timestamp out of range") : new P({
        ts: n,
        zone: Je(a.zone, A1.defaultZone),
        loc: q1.fromObject(a)
      });
    throw new l2(
      `fromMillis requires a numerical input, but received a ${typeof n} with value ${n}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(n, a = {}) {
    if (vn(n))
      return new P({
        ts: n * 1e3,
        zone: Je(a.zone, A1.defaultZone),
        loc: q1.fromObject(a)
      });
    throw new l2("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  static fromObject(n, a = {}) {
    n = n || {};
    const t = Je(a.zone, A1.defaultZone);
    if (!t.isValid)
      return P.invalid(J3(t));
    const r = A1.now(), M = D0(a.specificOffset) ? t.offset(r) : a.specificOffset, b = Bo(n, pc), d = !D0(b.ordinal), c = !D0(b.year), O = !D0(b.month) || !D0(b.day), A = c || O, m = b.weekYear || b.weekNumber, q = q1.fromObject(a);
    if ((A || d) && m)
      throw new Ot(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (O && d)
      throw new Ot("Can't mix ordinal dates with month/day");
    const y = m || b.weekday && !A;
    let $, v, E = bc(r, M);
    y ? ($ = DW, v = NW, E = i4(E)) : d ? ($ = TW, v = vW, E = dM(E)) : ($ = a6, v = n6);
    let t0 = !1;
    for (const S0 of $) {
      const u0 = b[S0];
      D0(u0) ? t0 ? b[S0] = v[S0] : b[S0] = E[S0] : t0 = !0;
    }
    const K = y ? LW(b) : d ? _W(b) : Zz(b), C = K || Qz(b);
    if (C)
      return P.invalid(C);
    const s0 = y ? rc(b) : d ? ic(b) : b, [J, I0] = lo(s0, M, t), g0 = new P({
      ts: J,
      zone: t,
      o: I0,
      loc: q
    });
    return b.weekday && A && n.weekday !== g0.weekday ? P.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${b.weekday} and a date of ${g0.toISO()}`
    ) : g0;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(n, a = {}) {
    const [t, r] = jy(n);
    return it(t, r, a, "ISO 8601", n);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(n, a = {}) {
    const [t, r] = Gy(n);
    return it(t, r, a, "RFC 2822", n);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(n, a = {}) {
    const [t, r] = Vy(n);
    return it(t, r, a, "HTTP", a);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(n, a, t = {}) {
    if (D0(n) || D0(a))
      throw new l2("fromFormat requires an input string and a format");
    const { locale: r = null, numberingSystem: M = null } = t, b = q1.fromOpts({
      locale: r,
      numberingSystem: M,
      defaultToEN: !0
    }), [d, c, O, A] = $W(b, n, a);
    return A ? P.invalid(A) : it(d, c, t, `format ${a}`, n, O);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(n, a, t = {}) {
    return P.fromFormat(n, a, t);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(n, a = {}) {
    const [t, r] = nW(n);
    return it(t, r, a, "SQL", n);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(n, a = null) {
    if (!n)
      throw new l2("need to specify a reason the DateTime is invalid");
    const t = n instanceof B2 ? n : new B2(n, a);
    if (A1.throwOnInvalid)
      throw new Bh(t);
    return new P({ invalid: t });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(n) {
    return n && n.isLuxonDateTime || !1;
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(n) {
    return this[n];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? cM(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? cM(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? cM(this).weekday : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? dM(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? m2.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? m2.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? m2.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? m2.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Ct(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return To(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? ht(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? So(this.weekYear) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(n = {}) {
    const { locale: a, numberingSystem: t, calendar: r } = U1.create(
      this.loc.clone(n),
      n
    ).resolvedOptions(this);
    return { locale: a, numberingSystem: t, outputCalendar: r };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(n = 0, a = {}) {
    return this.setZone(C1.instance(n), a);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(A1.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(n, { keepLocalTime: a = !1, keepCalendarTime: t = !1 } = {}) {
    if (n = Je(n, A1.defaultZone), n.equals(this.zone))
      return this;
    if (n.isValid) {
      let r = this.ts;
      if (a || t) {
        const M = n.offset(this.ts), b = this.toObject();
        [r] = lo(b, M, n);
      }
      return rt(this, { ts: r, zone: n });
    } else
      return P.invalid(J3(n));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: n, numberingSystem: a, outputCalendar: t } = {}) {
    const r = this.loc.clone({ locale: n, numberingSystem: a, outputCalendar: t });
    return rt(this, { loc: r });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(n) {
    return this.reconfigure({ locale: n });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(n) {
    if (!this.isValid) return this;
    const a = Bo(n, pc), t = !D0(a.weekYear) || !D0(a.weekNumber) || !D0(a.weekday), r = !D0(a.ordinal), M = !D0(a.year), b = !D0(a.month) || !D0(a.day), d = M || b, c = a.weekYear || a.weekNumber;
    if ((d || r) && c)
      throw new Ot(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (b && r)
      throw new Ot("Can't mix ordinal dates with month/day");
    let O;
    t ? O = rc({ ...i4(this.c), ...a }) : D0(a.ordinal) ? (O = { ...this.toObject(), ...a }, D0(a.day) && (O.day = Math.min(To(O.year, O.month), O.day))) : O = ic({ ...dM(this.c), ...a });
    const [A, m] = lo(O, this.o, this.zone);
    return rt(this, { ts: A, o: m });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(n) {
    if (!this.isValid) return this;
    const a = v1.fromDurationLike(n);
    return rt(this, sc(this, a));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(n) {
    if (!this.isValid) return this;
    const a = v1.fromDurationLike(n).negate();
    return rt(this, sc(this, a));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(n) {
    if (!this.isValid) return this;
    const a = {}, t = v1.normalizeUnit(n);
    switch (t) {
      case "years":
        a.month = 1;
      case "quarters":
      case "months":
        a.day = 1;
      case "weeks":
      case "days":
        a.hour = 0;
      case "hours":
        a.minute = 0;
      case "minutes":
        a.second = 0;
      case "seconds":
        a.millisecond = 0;
        break;
    }
    if (t === "weeks" && (a.weekday = 1), t === "quarters") {
      const r = Math.ceil(this.month / 3);
      a.month = (r - 1) * 3 + 1;
    }
    return this.set(a);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(n) {
    return this.isValid ? this.plus({ [n]: 1 }).startOf(n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(n, a = {}) {
    return this.isValid ? U1.create(this.loc.redefaultToEN(a)).formatDateTimeFromString(this, n) : pM;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(n = e4, a = {}) {
    return this.isValid ? U1.create(this.loc.clone(a), n).formatDateTime(this) : pM;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(n = {}) {
    return this.isValid ? U1.create(this.loc.clone(n), n).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: n = "extended",
    suppressSeconds: a = !1,
    suppressMilliseconds: t = !1,
    includeOffset: r = !0,
    extendedZone: M = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const b = n === "extended";
    let d = zM(this, b);
    return d += "T", d += dc(this, b, a, t, r, M), d;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: n = "extended" } = {}) {
    return this.isValid ? zM(this, n === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return K3(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: n = !1,
    suppressSeconds: a = !1,
    includeOffset: t = !0,
    includePrefix: r = !1,
    extendedZone: M = !1,
    format: b = "extended"
  } = {}) {
    return this.isValid ? (r ? "T" : "") + dc(
      this,
      b === "extended",
      a,
      n,
      t,
      M
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return K3(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return K3(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? zM(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: n = !0, includeZone: a = !1, includeOffsetSpace: t = !0 } = {}) {
    let r = "HH:mm:ss.SSS";
    return (a || n) && (t && (r += " "), a ? r += "z" : n && (r += "ZZ")), K3(this, r, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(n = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(n)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : pM;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(n = {}) {
    if (!this.isValid) return {};
    const a = { ...this.c };
    return n.includeConfig && (a.outputCalendar = this.outputCalendar, a.numberingSystem = this.loc.numberingSystem, a.locale = this.loc.locale), a;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(n, a = "milliseconds", t = {}) {
    if (!this.isValid || !n.isValid)
      return v1.invalid("created by diffing an invalid DateTime");
    const r = { locale: this.locale, numberingSystem: this.numberingSystem, ...t }, M = Ih(a).map(v1.normalizeUnit), b = n.valueOf() > this.valueOf(), d = b ? this : n, c = b ? n : this, O = dW(d, c, M, r);
    return b ? O.negate() : O;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(n = "milliseconds", a = {}) {
    return this.diff(P.now(), n, a);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(n) {
    return this.isValid ? i1.fromDateTimes(this, n) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(n, a) {
    if (!this.isValid) return !1;
    const t = n.valueOf(), r = this.setZone(n.zone, { keepLocalTime: !0 });
    return r.startOf(a) <= t && t <= r.endOf(a);
  }
  /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(n) {
    return this.isValid && n.isValid && this.valueOf() === n.valueOf() && this.zone.equals(n.zone) && this.loc.equals(n.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(n = {}) {
    if (!this.isValid) return null;
    const a = n.base || P.fromObject({}, { zone: this.zone }), t = n.padding ? this < a ? -n.padding : n.padding : 0;
    let r = ["years", "months", "days", "hours", "minutes", "seconds"], M = n.unit;
    return Array.isArray(n.unit) && (r = n.unit, M = void 0), zc(a, this.plus(t), {
      ...n,
      numeric: "always",
      units: r,
      unit: M
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(n = {}) {
    return this.isValid ? zc(n.base || P.fromObject({}, { zone: this.zone }), this, {
      ...n,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...n) {
    if (!n.every(P.isDateTime))
      throw new l2("min requires all arguments be DateTimes");
    return Up(n, (a) => a.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...n) {
    if (!n.every(P.isDateTime))
      throw new l2("max requires all arguments be DateTimes");
    return Up(n, (a) => a.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(n, a, t = {}) {
    const { locale: r = null, numberingSystem: M = null } = t, b = q1.fromOpts({
      locale: r,
      numberingSystem: M,
      defaultToEN: !0
    });
    return jz(b, n, a);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(n, a, t = {}) {
    return P.fromFormatExplain(n, a, t);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return e4;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Mz;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return Eh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return bz;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return sz;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return dz;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return pz;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return cz;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return zz;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return Oz;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return uz;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return Az;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return lz;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return fz;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return mz;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return qz;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return hz;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return Xh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return yz;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Wz;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return gz;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return Rz;
  }
}
function Mt(e) {
  if (P.isDateTime(e))
    return e;
  if (e && e.valueOf && vn(e.valueOf()))
    return P.fromJSDate(e);
  if (e && typeof e == "object")
    return P.fromObject(e);
  throw new l2(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
function eb(e) {
  return e != null;
}
var Ln = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function I2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function SW(e) {
  if (e.__esModule) return e;
  var n = e.default;
  if (typeof n == "function") {
    var a = function t() {
      return this instanceof t ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    a.prototype = n.prototype;
  } else a = {};
  return Object.defineProperty(a, "__esModule", { value: !0 }), Object.keys(e).forEach(function(t) {
    var r = Object.getOwnPropertyDescriptor(e, t);
    Object.defineProperty(a, t, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[t];
      }
    });
  }), a;
}
var M4 = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = t;
  function a(r) {
    "@babel/helpers - typeof";
    return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(M) {
      return typeof M;
    } : function(M) {
      return M && typeof Symbol == "function" && M.constructor === Symbol && M !== Symbol.prototype ? "symbol" : typeof M;
    }, a(r);
  }
  function t(r) {
    var M = typeof r == "string" || r instanceof String;
    if (!M) {
      var b = a(r);
      throw r === null ? b = "null" : b === "object" && (b = r.constructor.name), new TypeError("Expected a string but received a ".concat(b));
    }
  }
  e.exports = n.default, e.exports.default = n.default;
})(M4, M4.exports);
var Xn = M4.exports, b4 = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    for (var M in r)
      typeof t[M] > "u" && (t[M] = r[M]);
    return t;
  }
  e.exports = n.default, e.exports.default = n.default;
})(b4, b4.exports);
var t6 = b4.exports, c1 = {};
Object.defineProperty(c1, "__esModule", {
  value: !0
});
c1.farsiLocales = c1.englishLocales = c1.dotDecimal = c1.decimal = c1.commaDecimal = c1.bengaliLocales = c1.arabicLocales = c1.alphanumeric = c1.alpha = void 0;
var j1 = c1.alpha = {
  "en-US": /^[A-Z]+$/i,
  "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[А-Я]+$/i,
  "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[A-ZÆØÅ]+$/i,
  "de-DE": /^[A-ZÄÖÜß]+$/i,
  "el-GR": /^[Α-ώ]+$/i,
  "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
  "fi-FI": /^[A-ZÅÄÖ]+$/i,
  "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "nb-NO": /^[A-ZÆØÅ]+$/i,
  "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[A-ZÆØÅ]+$/i,
  "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[А-ЯЁ]+$/i,
  "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
  "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๐\s]+$/i,
  "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[א-ת]+$/,
  fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  eo: /^[ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
  "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
  "si-LK": /^[\u0D80-\u0DFF]+$/
}, G1 = c1.alphanumeric = {
  "en-US": /^[0-9A-Z]+$/i,
  "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
  "bg-BG": /^[0-9А-Я]+$/i,
  "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[0-9A-ZÆØÅ]+$/i,
  "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
  "el-GR": /^[0-9Α-ω]+$/i,
  "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
  "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
  "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
  "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
  "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[0-9А-ЯЁ]+$/i,
  "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
  "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
  "th-TH": /^[ก-๙\s]+$/i,
  "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
  "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[0-9א-ת]+$/,
  fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
  bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
  eo: /^[0-9ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
  "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
  "si-LK": /^[0-9\u0D80-\u0DFF]+$/
}, E1 = c1.decimal = {
  "en-US": ".",
  ar: "٫"
}, uc = c1.englishLocales = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"];
for (var Z3, OM = 0; OM < uc.length; OM++)
  Z3 = "en-".concat(uc[OM]), j1[Z3] = j1["en-US"], G1[Z3] = G1["en-US"], E1[Z3] = E1["en-US"];
var Ac = c1.arabicLocales = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"];
for (var Q3, uM = 0; uM < Ac.length; uM++)
  Q3 = "ar-".concat(Ac[uM]), j1[Q3] = j1.ar, G1[Q3] = G1.ar, E1[Q3] = E1.ar;
var lc = c1.farsiLocales = ["IR", "AF"];
for (var AM, lM = 0; lM < lc.length; lM++)
  AM = "fa-".concat(lc[lM]), G1[AM] = G1.fa, E1[AM] = E1.ar;
var fc = c1.bengaliLocales = ["BD", "IN"];
for (var eo, fM = 0; fM < fc.length; fM++)
  eo = "bn-".concat(fc[fM]), j1[eo] = j1.bn, G1[eo] = G1.bn, E1[eo] = E1["en-US"];
var mc = c1.dotDecimal = ["ar-EG", "ar-LB", "ar-LY"], qc = c1.commaDecimal = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "eo", "es-ES", "fr-CA", "fr-FR", "id-ID", "it-IT", "ku-IQ", "hi-IN", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "kk-KZ", "si-LK", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA", "vi-VN"];
for (var mM = 0; mM < mc.length; mM++)
  E1[mc[mM]] = E1["en-US"];
for (var qM = 0; qM < qc.length; qM++)
  E1[qc[qM]] = ",";
j1["fr-CA"] = j1["fr-FR"];
G1["fr-CA"] = G1["fr-FR"];
j1["pt-BR"] = j1["pt-PT"];
G1["pt-BR"] = G1["pt-PT"];
E1["pt-BR"] = E1["pt-PT"];
j1["pl-Pl"] = j1["pl-PL"];
G1["pl-Pl"] = G1["pl-PL"];
E1["pl-Pl"] = E1["pl-PL"];
j1["fa-AF"] = j1.fa;
var s4 = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = M;
  var a = t(Xn);
  function t(b) {
    return b && b.__esModule ? b : { default: b };
  }
  function r(b) {
    "@babel/helpers - typeof";
    return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
      return typeof d;
    } : function(d) {
      return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
    }, r(b);
  }
  function M(b, d) {
    (0, a.default)(b);
    var c, O;
    r(d) === "object" ? (c = d.min || 0, O = d.max) : (c = arguments[1], O = arguments[2]);
    var A = encodeURI(b).split(/%..|./).length - 1;
    return A >= c && (typeof O > "u" || A <= O);
  }
  e.exports = n.default, e.exports.default = n.default;
})(s4, s4.exports);
var BW = s4.exports, d4 = { exports: {} }, p4 = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = b;
  var a = r(Xn), t = r(t6);
  function r(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var M = {
    require_tld: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_numeric_tld: !1,
    allow_wildcard: !1,
    ignore_max_length: !1
  };
  function b(d, c) {
    (0, a.default)(d), c = (0, t.default)(c, M), c.allow_trailing_dot && d[d.length - 1] === "." && (d = d.substring(0, d.length - 1)), c.allow_wildcard === !0 && d.indexOf("*.") === 0 && (d = d.substring(2));
    var O = d.split("."), A = O[O.length - 1];
    return c.require_tld && (O.length < 2 || !c.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(A) || /\s/.test(A)) || !c.allow_numeric_tld && /^\d+$/.test(A) ? !1 : O.every(function(m) {
      return !(m.length > 63 && !c.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(m) || /[\uff01-\uff5e]/.test(m) || /^-|-$/.test(m) || !c.allow_underscores && /_/.test(m));
    });
  }
  e.exports = n.default, e.exports.default = n.default;
})(p4, p4.exports);
var wW = p4.exports, c4 = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = O;
  var a = t(Xn);
  function t(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var r = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", M = "(".concat(r, "[.]){3}").concat(r), b = new RegExp("^".concat(M, "$")), d = "(?:[0-9a-fA-F]{1,4})", c = new RegExp("^(" + "(?:".concat(d, ":){7}(?:").concat(d, "|:)|") + "(?:".concat(d, ":){6}(?:").concat(M, "|:").concat(d, "|:)|") + "(?:".concat(d, ":){5}(?::").concat(M, "|(:").concat(d, "){1,2}|:)|") + "(?:".concat(d, ":){4}(?:(:").concat(d, "){0,1}:").concat(M, "|(:").concat(d, "){1,3}|:)|") + "(?:".concat(d, ":){3}(?:(:").concat(d, "){0,2}:").concat(M, "|(:").concat(d, "){1,4}|:)|") + "(?:".concat(d, ":){2}(?:(:").concat(d, "){0,3}:").concat(M, "|(:").concat(d, "){1,5}|:)|") + "(?:".concat(d, ":){1}(?:(:").concat(d, "){0,4}:").concat(M, "|(:").concat(d, "){1,6}|:)|") + "(?::((?::".concat(d, "){0,5}:").concat(M, "|(?::").concat(d, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
  function O(A) {
    var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0, a.default)(A), m = String(m), m ? m === "4" ? b.test(A) : m === "6" ? c.test(A) : !1 : O(A, 4) || O(A, 6);
  }
  e.exports = n.default, e.exports.default = n.default;
})(c4, c4.exports);
var CW = c4.exports;
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = t0;
  var a = d(Xn), t = d(BW), r = d(wW), M = d(CW), b = d(t6);
  function d(K) {
    return K && K.__esModule ? K : { default: K };
  }
  var c = {
    allow_display_name: !1,
    allow_underscores: !1,
    require_display_name: !1,
    allow_utf8_local_part: !0,
    require_tld: !0,
    blacklisted_chars: "",
    ignore_max_length: !1,
    host_blacklist: [],
    host_whitelist: []
  }, O = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, A = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, m = /^[a-z\d]+$/, q = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, y = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, $ = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, v = 254;
  function E(K) {
    var C = K.replace(/^"(.+)"$/, "$1");
    if (!C.trim())
      return !1;
    var s0 = /[\.";<>]/.test(C);
    if (s0) {
      if (C === K)
        return !1;
      var J = C.split('"').length === C.split('\\"').length;
      if (!J)
        return !1;
    }
    return !0;
  }
  function t0(K, C) {
    if ((0, a.default)(K), C = (0, b.default)(C, c), C.require_display_name || C.allow_display_name) {
      var s0 = K.match(O);
      if (s0) {
        var J = s0[1];
        if (K = K.replace(J, "").replace(/(^<|>$)/g, ""), J.endsWith(" ") && (J = J.slice(0, -1)), !E(J))
          return !1;
      } else if (C.require_display_name)
        return !1;
    }
    if (!C.ignore_max_length && K.length > v)
      return !1;
    var I0 = K.split("@"), g0 = I0.pop(), S0 = g0.toLowerCase();
    if (C.host_blacklist.includes(S0) || C.host_whitelist.length > 0 && !C.host_whitelist.includes(S0))
      return !1;
    var u0 = I0.join("@");
    if (C.domain_specific_validation && (S0 === "gmail.com" || S0 === "googlemail.com")) {
      u0 = u0.toLowerCase();
      var F2 = u0.split("+")[0];
      if (!(0, t.default)(F2.replace(/\./g, ""), {
        min: 6,
        max: 30
      }))
        return !1;
      for (var o2 = F2.split("."), bn = 0; bn < o2.length; bn++)
        if (!m.test(o2[bn]))
          return !1;
    }
    if (C.ignore_max_length === !1 && (!(0, t.default)(u0, {
      max: 64
    }) || !(0, t.default)(g0, {
      max: 254
    })))
      return !1;
    if (!(0, r.default)(g0, {
      require_tld: C.require_tld,
      ignore_max_length: C.ignore_max_length,
      allow_underscores: C.allow_underscores
    })) {
      if (!C.allow_ip_domain)
        return !1;
      if (!(0, M.default)(g0)) {
        if (!g0.startsWith("[") || !g0.endsWith("]"))
          return !1;
        var Fn = g0.slice(1, -1);
        if (Fn.length === 0 || !(0, M.default)(Fn))
          return !1;
      }
    }
    if (u0[0] === '"')
      return u0 = u0.slice(1, u0.length - 1), C.allow_utf8_local_part ? $.test(u0) : q.test(u0);
    for (var H2 = C.allow_utf8_local_part ? y : A, sn = u0.split("."), $1 = 0; $1 < sn.length; $1++)
      if (!H2.test(sn[$1]))
        return !1;
    return !(C.blacklisted_chars && u0.search(new RegExp("[".concat(C.blacklisted_chars, "]+"), "g")) !== -1);
  }
  e.exports = n.default, e.exports.default = n.default;
})(d4, d4.exports);
var EW = d4.exports;
const XW = /* @__PURE__ */ I2(EW);
function o6(e, n) {
  return typeof e == "string" && XW(e, n);
}
var z4 = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = d;
  var a = t(Xn);
  function t(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var r = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, M = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, b = function(O) {
    var A = O.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
    if (A) {
      var m = Number(A[1]), q = Number(A[2]);
      return m % 4 === 0 && m % 100 !== 0 || m % 400 === 0 ? q <= 366 : q <= 365;
    }
    var y = O.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), $ = y[1], v = y[2], E = y[3], t0 = v && "0".concat(v).slice(-2), K = E && "0".concat(E).slice(-2), C = new Date("".concat($, "-").concat(t0 || "01", "-").concat(K || "01"));
    return v && E ? C.getUTCFullYear() === $ && C.getUTCMonth() + 1 === v && C.getUTCDate() === E : !0;
  };
  function d(c) {
    var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, a.default)(c);
    var A = O.strictSeparator ? M.test(c) : r.test(c);
    return A && O.strict ? b(c) : A;
  }
  e.exports = n.default, e.exports.default = n.default;
})(z4, z4.exports);
var PW = z4.exports;
const kW = /* @__PURE__ */ I2(PW);
function IW(e, n) {
  return typeof e == "string" && kW(e, n);
}
var O4 = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = M;
  var a = t(Xn);
  function t(b) {
    return b && b.__esModule ? b : { default: b };
  }
  var r = {
    1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
  };
  function M(b, d) {
    (0, a.default)(b);
    var c = r[[void 0, null].includes(d) ? "all" : d];
    return !!c && c.test(b);
  }
  e.exports = n.default, e.exports.default = n.default;
})(O4, O4.exports);
var xW = O4.exports;
const FW = /* @__PURE__ */ I2(xW);
function r6(e, n) {
  return typeof e == "string" && FW(e, n);
}
const HW = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]], 0, 0, 0, 0, 0, 0, [["2090\\d{4}|2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}"], ["(?:4[0-8]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}"], 0, ["857[58]\\d{4}"]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]], 0, 0, 0, 0, 0, ["50\\d{6}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", [9]], ["(?:6[89]|7[235-9])\\d{7}", [9]], ["800\\d{6}", [9]], ["90[016]\\d{6}", [9]], ["878\\d{6}", [9]], ["860\\d{9}", [12]], ["5[18]\\d{7}", [9]], ["74[0248]\\d{6}", [9]], 0, ["84[0248]\\d{6}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "60\\d{8}|(?:1\\d|[39])\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60(?:[124-7][2-9]|8[1-9])\\d{6}", [10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["(?:19(?:0[01]|4[78])|901)\\d{7}"]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", [9]], ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[01]|[2379]\\d\\d))\\d{5}", [9]], ["800\\d{6}", [9]], ["9(?:0[05689]|76)\\d{6}", [9]], ["70[01]\\d{6}", [9]], ["9(?:3\\d{9}|6\\d{7,10})"], ["9(?:5\\d|7[2-4])\\d{6}", [9]], 0, ["9[17]0\\d{6}", [9]], ["8[134]\\d{7}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["15310\\d{6}|1(?:6[023]|7[0-57-9])\\d{7,8}|1(?:5[0-25-9]|76)\\d{8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], ["1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", [12, 13]], ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:2\\d|9[1-46-9])\\d|3(?:[0-37]\\d|4[013]|5[0-58]|6[01347-9]|8[0-8]|9[0-79])|4(?:[0-25]\\d|[34][02-9]|6[013-579]|7[013579]|8[0-47]|9[0-27])|5(?:[0-36]\\d|4[0146-9]|5[03-57-9]|7[0568]|8[0-358]|9[0-69])|6(?:[013578]\\d|2[0-68]|4[02-8]|6[01689]|9[015689])|7(?:[0-69]\\d|7[03-9]|8[0147])|8(?:[16-9]\\d|2[0-58]))\\d{5}"], ["(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["1[35-7][1-8]\\d{3,6}|(?:1[49][1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[024]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|111|22[02]|77\\d)|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["694(?:[0-249]\\d|3[0-8])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|4[015]|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["510\\d{4}|(?:6\\d|7[0-5])\\d{5}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4])|74[0-2])|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[01]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[05])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-49]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-7])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}", [7, 8, 9]], ["6[01459]\\d{6}|6[01]\\d{4,5}", [6, 7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], ["88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", [10]], ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55(?:410|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, ["151\\d{8,9}", [11, 12]], ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[0-2569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, ["(?:689|8(?:7[18]|80)|95[48])\\d{4}", [7]], ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["345849\\d{4}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", [10]], 0, 0, 0, 0, ["30[0135-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, ["697(?:42|56|[78]\\d)\\d{4}", [9]], ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[245])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}|[12]468\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])\\d{4}"], ["69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}", [8, 10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:55[3-9]|666|8\\d\\d)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-38])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["21(?:1[013-5]|2\\d)\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-7]|5[01])\\d{4}", [6]], ["(?:4[02-4]|5[056]|708[45][0-5])\\d{4}"], ["80[0-5]\\d{6}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], ["600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}"], ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|8988)\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], ["85\\d{5}"], 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], ["(?:25[245]|67[3-68])\\d{9}", [12]], ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["(?:8(?:0(?:[1-8]\\d|9[0-689])|[1-8]\\d\\d|9(?:[0-4]\\d|5[0-3]|62))|9[0-8]\\d\\d)\\d{4}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|[38]3|[4-7]\\d))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[124-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["9[1-689]\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[019]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[017]|2[02]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], ["868619\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-5]|9[89])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}", [6, 7, 8, 9, 10, 11]], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[46])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]], 0, 0, ["[48]0\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:7[5-79]|9[5-8])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function UW(e, n) {
  var a = Array.prototype.slice.call(n);
  return a.push(HW), e.apply(this, a);
}
function u4(e) {
  "@babel/helpers - typeof";
  return u4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, u4(e);
}
function jW(e, n, a) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function GW(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function VW(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), n && gt(e, n);
}
function YW(e) {
  var n = M6();
  return function() {
    var t = Rt(e), r;
    if (n) {
      var M = Rt(this).constructor;
      r = Reflect.construct(t, arguments, M);
    } else
      r = t.apply(this, arguments);
    return JW(this, r);
  };
}
function JW(e, n) {
  if (n && (u4(n) === "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return i6(e);
}
function i6(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function A4(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return A4 = function(t) {
    if (t === null || !KW(t)) return t;
    if (typeof t != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof n < "u") {
      if (n.has(t)) return n.get(t);
      n.set(t, r);
    }
    function r() {
      return fo(t, arguments, Rt(this).constructor);
    }
    return r.prototype = Object.create(t.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), gt(r, t);
  }, A4(e);
}
function fo(e, n, a) {
  return M6() ? fo = Reflect.construct : fo = function(r, M, b) {
    var d = [null];
    d.push.apply(d, M);
    var c = Function.bind.apply(r, d), O = new c();
    return b && gt(O, b.prototype), O;
  }, fo.apply(null, arguments);
}
function M6() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function KW(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function gt(e, n) {
  return gt = Object.setPrototypeOf || function(t, r) {
    return t.__proto__ = r, t;
  }, gt(e, n);
}
function Rt(e) {
  return Rt = Object.setPrototypeOf ? Object.getPrototypeOf : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, Rt(e);
}
var fe = /* @__PURE__ */ function(e) {
  VW(a, e);
  var n = YW(a);
  function a(t) {
    var r;
    return GW(this, a), r = n.call(this, t), Object.setPrototypeOf(i6(r), a.prototype), r.name = r.constructor.name, r;
  }
  return jW(a);
}(/* @__PURE__ */ A4(Error)), nb = 2, ZW = 17, QW = 3, E2 = "0-9０-９٠-٩۰-۹", eg = "-‐-―−ー－", ng = "／/", ag = "．.", tg = "  ­​⁠　", og = "()（）［］\\[\\]", rg = "~⁓∼～", wo = "".concat(eg).concat(ng).concat(ag).concat(tg).concat(og).concat(rg), ab = "+＋";
function hc(e, n) {
  e = e.split("-"), n = n.split("-");
  for (var a = e[0].split("."), t = n[0].split("."), r = 0; r < 3; r++) {
    var M = Number(a[r]), b = Number(t[r]);
    if (M > b) return 1;
    if (b > M) return -1;
    if (!isNaN(M) && isNaN(b)) return 1;
    if (isNaN(M) && !isNaN(b)) return -1;
  }
  return e[1] && n[1] ? e[1] > n[1] ? 1 : e[1] < n[1] ? -1 : 0 : !e[1] && n[1] ? 1 : e[1] && !n[1] ? -1 : 0;
}
var ig = {}.constructor;
function mo(e) {
  return e != null && e.constructor === ig;
}
function l4(e) {
  "@babel/helpers - typeof";
  return l4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, l4(e);
}
function sr(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Mg(e, n) {
  for (var a = 0; a < n.length; a++) {
    var t = n[a];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function dr(e, n, a) {
  return n && Mg(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var bg = "1.2.0", sg = "1.7.35", yc = " ext. ", dg = /^\d+$/, X1 = /* @__PURE__ */ function() {
  function e(n) {
    sr(this, e), Og(n), this.metadata = n, b6.call(this, n);
  }
  return dr(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(a) {
        return a !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(a) {
      return this.metadata.countries[a];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(a) {
      return this.getCountryMetadata(a) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(a) {
      if (this.getCountryCodesForCallingCode(a))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[a])
          return !0;
      } else {
        var t = this.countryCallingCodes()[a];
        if (t && t.length === 1 && t[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(a) {
      return this.nonGeographic() ? !!this.nonGeographic()[a] : !this.getCountryCodesForCallingCode(a);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(a) {
      return this.selectNumberingPlan(a);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(a, t) {
      if (a && dg.test(a) && (t = a, a = null), a && a !== "001") {
        if (!this.hasCountry(a))
          throw new Error("Unknown country: ".concat(a));
        this.numberingPlan = new Wc(this.getCountryMetadata(a), this);
      } else if (t) {
        if (!this.hasCallingCode(t))
          throw new Error("Unknown calling code: ".concat(t));
        this.numberingPlan = new Wc(this.getNumberingPlanMetadata(t), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(a) {
      var t = this.countryCallingCodes()[a];
      if (t)
        return t.length === 1 && t[0].length === 3 ? void 0 : t;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(a) {
      var t = this.getCountryCodesForCallingCode(a);
      if (t)
        return t[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(a) {
      var t = this.getCountryCodeForCallingCode(a);
      if (t)
        return this.getCountryMetadata(t);
      if (this.nonGeographic()) {
        var r = this.nonGeographic()[a];
        if (r)
          return r;
      } else {
        var M = this.countryCallingCodes()[a];
        if (M && M.length === 1 && M[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(a) {
      return this.numberingPlan.type(a);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(a) {
      return this.selectNumberingPlan(a);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), Wc = /* @__PURE__ */ function() {
  function e(n, a) {
    sr(this, e), this.globalMetadataObject = a, this.metadata = n, b6.call(this, a.metadata);
  }
  return dr(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(a) {
      return a[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var a = this, t = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return t.map(function(r) {
        return new pg(r, a);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(a) {
      return a[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(a) {
      if (this.hasTypes() && gc(this.types(), a))
        return new zg(gc(this.types(), a), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? yc : this.metadata[13] || yc;
    }
  }]), e;
}(), pg = /* @__PURE__ */ function() {
  function e(n, a) {
    sr(this, e), this._format = n, this.metadata = a;
  }
  return dr(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !cg.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), cg = /^\(?\$1\)?$/, zg = /* @__PURE__ */ function() {
  function e(n, a) {
    sr(this, e), this.type = n, this.metadata = a;
  }
  return dr(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function gc(e, n) {
  switch (n) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Og(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!mo(e) || !mo(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(mo(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + ug(e) + ": " + e, "."));
}
var ug = function(n) {
  return l4(n);
};
function pr(e, n) {
  if (n = new X1(n), n.hasCountry(e))
    return n.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Ag(e, n) {
  return n.countries.hasOwnProperty(e);
}
function b6(e) {
  var n = e.version;
  typeof n == "number" ? (this.v1 = n === 1, this.v2 = n === 2, this.v3 = n === 3, this.v4 = n === 4) : n ? hc(n, bg) === -1 ? this.v2 = !0 : hc(n, sg) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var lg = ";ext=", sa = function(n) {
  return "([".concat(E2, "]{1,").concat(n, "})");
};
function s6(e) {
  var n = "20", a = "15", t = "9", r = "6", M = "[  \\t,]*", b = "[:\\.．]?[  \\t,-]*", d = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", O = "(?:[xｘ#＃~～]|int|ｉｎｔ)", A = "[- ]+", m = "[  \\t]*", q = "(?:,{2}|;)", y = lg + sa(n), $ = M + c + b + sa(n) + d, v = M + O + b + sa(t) + d, E = A + sa(r) + "#", t0 = m + q + b + sa(a) + d, K = m + "(?:,)+" + b + sa(t) + d;
  return y + "|" + $ + "|" + v + "|" + E + "|" + t0 + "|" + K;
}
var fg = "[" + E2 + "]{" + nb + "}", mg = "[" + ab + "]{0,1}(?:[" + wo + "]*[" + E2 + "]){3,}[" + wo + E2 + "]*", qg = new RegExp("^[" + ab + "]{0,1}(?:[" + wo + "]*[" + E2 + "]){1,2}$", "i"), hg = mg + // Phone number extensions
"(?:" + s6() + ")?", yg = new RegExp(
  // Either a short two-digit-only phone number
  "^" + fg + "$|^" + hg + "$",
  "i"
);
function Wg(e) {
  return e.length >= nb && yg.test(e);
}
function gg(e) {
  return qg.test(e);
}
var Rc = new RegExp("(?:" + s6() + ")$", "i");
function Rg(e) {
  var n = e.search(Rc);
  if (n < 0)
    return {};
  for (var a = e.slice(0, n), t = e.match(Rc), r = 1; r < t.length; ) {
    if (t[r])
      return {
        number: a,
        ext: t[r]
      };
    r++;
  }
}
var $g = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Lg(e) {
  return $g[e];
}
function _g(e, n) {
  var a = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (a) return (a = a.call(e)).next.bind(a);
  if (Array.isArray(e) || (a = Ng(e)) || n) {
    a && (e = a);
    var t = 0;
    return function() {
      return t >= e.length ? { done: !0 } : { done: !1, value: e[t++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ng(e, n) {
  if (e) {
    if (typeof e == "string") return $c(e, n);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    if (a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set") return Array.from(e);
    if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return $c(e, n);
  }
}
function $c(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var a = 0, t = new Array(n); a < n; a++)
    t[a] = e[a];
  return t;
}
function Lc(e) {
  for (var n = "", a = _g(e.split("")), t; !(t = a()).done; ) {
    var r = t.value;
    n += vg(r, n) || "";
  }
  return n;
}
function vg(e, n, a) {
  return e === "+" ? n ? void 0 : "+" : Lg(e);
}
function tb(e, n) {
  return Dg(e, void 0, n);
}
function Dg(e, n, a) {
  var t = a.type(n), r = t && t.possibleLengths() || a.possibleLengths();
  if (!r)
    return "IS_POSSIBLE";
  var M = e.length, b = r[0];
  return b === M ? "IS_POSSIBLE" : b > M ? "TOO_SHORT" : r[r.length - 1] < M ? "TOO_LONG" : r.indexOf(M, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Tg(e, n, a) {
  if (n === void 0 && (n = {}), a = new X1(a), n.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    a.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!a.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      a.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      a.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (a.possibleLengths())
    return d6(e.phone || e.nationalNumber, a);
  if (e.countryCallingCode && a.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function d6(e, n) {
  switch (tb(e, n)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Le(e, n) {
  return e = e || "", new RegExp("^(?:" + n + ")$").test(e);
}
function Sg(e, n) {
  var a = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (a) return (a = a.call(e)).next.bind(a);
  if (Array.isArray(e) || (a = Bg(e)) || n) {
    a && (e = a);
    var t = 0;
    return function() {
      return t >= e.length ? { done: !0 } : { done: !1, value: e[t++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bg(e, n) {
  if (e) {
    if (typeof e == "string") return _c(e, n);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    if (a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set") return Array.from(e);
    if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return _c(e, n);
  }
}
function _c(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var a = 0, t = new Array(n); a < n; a++)
    t[a] = e[a];
  return t;
}
var wg = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function ob(e, n, a) {
  if (n = n || {}, !(!e.country && !e.countryCallingCode)) {
    a = new X1(a), a.selectNumberingPlan(e.country, e.countryCallingCode);
    var t = n.v2 ? e.nationalNumber : e.phone;
    if (Le(t, a.nationalNumberPattern())) {
      if (hM(t, "FIXED_LINE", a))
        return a.type("MOBILE") && a.type("MOBILE").pattern() === "" || !a.type("MOBILE") || hM(t, "MOBILE", a) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var r = Sg(wg), M; !(M = r()).done; ) {
        var b = M.value;
        if (hM(t, b, a))
          return b;
      }
    }
  }
}
function hM(e, n, a) {
  return n = a.type(n), !n || !n.pattern() || n.possibleLengths() && n.possibleLengths().indexOf(e.length) < 0 ? !1 : Le(e, n.pattern());
}
function Cg(e, n, a) {
  if (n = n || {}, a = new X1(a), a.selectNumberingPlan(e.country, e.countryCallingCode), a.hasTypes())
    return ob(e, n, a.metadata) !== void 0;
  var t = n.v2 ? e.nationalNumber : e.phone;
  return Le(t, a.nationalNumberPattern());
}
function Eg(e, n, a) {
  var t = new X1(a), r = t.getCountryCodesForCallingCode(e);
  return r ? r.filter(function(M) {
    return Xg(n, M, a);
  }) : [];
}
function Xg(e, n, a) {
  var t = new X1(a);
  return t.selectNumberingPlan(n), t.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function Pg(e) {
  return e.replace(new RegExp("[".concat(wo, "]+"), "g"), " ").trim();
}
var kg = /(\$\d)/;
function Ig(e, n, a) {
  var t = a.useInternationalFormat, r = a.withNationalPrefix, M = e.replace(new RegExp(n.pattern()), t ? n.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    r && n.nationalPrefixFormattingRule() ? n.format().replace(kg, n.nationalPrefixFormattingRule()) : n.format()
  ));
  return t ? Pg(M) : M;
}
var xg = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Fg(e, n, a) {
  var t = new X1(a);
  if (t.selectNumberingPlan(e, n), t.defaultIDDPrefix())
    return t.defaultIDDPrefix();
  if (xg.test(t.IDDPrefix()))
    return t.IDDPrefix();
}
function Hg(e) {
  var n = e.number, a = e.ext;
  if (!n)
    return "";
  if (n[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(n).concat(a ? ";ext=" + a : "");
}
function Ug(e, n) {
  var a = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (a) return (a = a.call(e)).next.bind(a);
  if (Array.isArray(e) || (a = jg(e)) || n) {
    a && (e = a);
    var t = 0;
    return function() {
      return t >= e.length ? { done: !0 } : { done: !1, value: e[t++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jg(e, n) {
  if (e) {
    if (typeof e == "string") return Nc(e, n);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    if (a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set") return Array.from(e);
    if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return Nc(e, n);
  }
}
function Nc(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var a = 0, t = new Array(n); a < n; a++)
    t[a] = e[a];
  return t;
}
function vc(e, n) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, t);
  }
  return a;
}
function Dc(e) {
  for (var n = 1; n < arguments.length; n++) {
    var a = arguments[n] != null ? arguments[n] : {};
    n % 2 ? vc(Object(a), !0).forEach(function(t) {
      Gg(e, t, a[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : vc(Object(a)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
    });
  }
  return e;
}
function Gg(e, n, a) {
  return n in e ? Object.defineProperty(e, n, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = a, e;
}
var Tc = {
  formatExtension: function(n, a, t) {
    return "".concat(n).concat(t.ext()).concat(a);
  }
};
function Vg(e, n, a, t) {
  if (a ? a = Dc(Dc({}, Tc), a) : a = Tc, t = new X1(t), e.country && e.country !== "001") {
    if (!t.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    t.country(e.country);
  } else if (e.countryCallingCode)
    t.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var r = t.countryCallingCode(), M = a.v2 ? e.nationalNumber : e.phone, b;
  switch (n) {
    case "NATIONAL":
      return M ? (b = Co(M, e.carrierCode, "NATIONAL", t, a), yM(b, e.ext, t, a.formatExtension)) : "";
    case "INTERNATIONAL":
      return M ? (b = Co(M, null, "INTERNATIONAL", t, a), b = "+".concat(r, " ").concat(b), yM(b, e.ext, t, a.formatExtension)) : "+".concat(r);
    case "E.164":
      return "+".concat(r).concat(M);
    case "RFC3966":
      return Hg({
        number: "+".concat(r).concat(M),
        ext: e.ext
      });
    case "IDD":
      if (!a.fromCountry)
        return;
      var d = Jg(M, e.carrierCode, r, a.fromCountry, t);
      return yM(d, e.ext, t, a.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(n, '"'));
  }
}
function Co(e, n, a, t, r) {
  var M = Yg(t.formats(), e);
  return M ? Ig(e, M, {
    useInternationalFormat: a === "INTERNATIONAL",
    withNationalPrefix: !(M.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && r && r.nationalPrefix === !1),
    carrierCode: n,
    metadata: t
  }) : e;
}
function Yg(e, n) {
  for (var a = Ug(e), t; !(t = a()).done; ) {
    var r = t.value;
    if (r.leadingDigitsPatterns().length > 0) {
      var M = r.leadingDigitsPatterns()[r.leadingDigitsPatterns().length - 1];
      if (n.search(M) !== 0)
        continue;
    }
    if (Le(n, r.pattern()))
      return r;
  }
}
function yM(e, n, a, t) {
  return n ? t(e, n, a) : e;
}
function Jg(e, n, a, t, r) {
  var M = pr(t, r.metadata);
  if (M === a) {
    var b = Co(e, n, "NATIONAL", r);
    return a === "1" ? a + " " + b : b;
  }
  var d = Fg(t, void 0, r.metadata);
  if (d)
    return "".concat(d, " ").concat(a, " ").concat(Co(e, null, "INTERNATIONAL", r));
}
function Sc(e, n) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, t);
  }
  return a;
}
function Bc(e) {
  for (var n = 1; n < arguments.length; n++) {
    var a = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Sc(Object(a), !0).forEach(function(t) {
      Kg(e, t, a[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Sc(Object(a)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
    });
  }
  return e;
}
function Kg(e, n, a) {
  return n in e ? Object.defineProperty(e, n, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = a, e;
}
function Zg(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Qg(e, n) {
  for (var a = 0; a < n.length; a++) {
    var t = n[a];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function eR(e, n, a) {
  return n && Qg(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var nR = /* @__PURE__ */ function() {
  function e(n, a, t) {
    if (Zg(this, e), !n)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!a)
      throw new TypeError("`nationalNumber` not passed");
    if (!t)
      throw new TypeError("`metadata` not passed");
    var r = tR(n, t), M = r.country, b = r.countryCallingCode;
    this.country = M, this.countryCallingCode = b, this.nationalNumber = a, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return t;
    };
  }
  return eR(e, [{
    key: "setExt",
    value: function(a) {
      this.ext = a;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Eg(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Tg(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return Cg(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var a = new X1(this.getMetadata());
      return a.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(a) {
      return this.number === a.number && this.ext === a.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return ob(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(a, t) {
      return Vg(this, a, t ? Bc(Bc({}, t), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(a) {
      return this.format("NATIONAL", a);
    }
  }, {
    key: "formatInternational",
    value: function(a) {
      return this.format("INTERNATIONAL", a);
    }
  }, {
    key: "getURI",
    value: function(a) {
      return this.format("RFC3966", a);
    }
  }]), e;
}(), aR = function(n) {
  return /^[A-Z]{2}$/.test(n);
};
function tR(e, n) {
  var a, t, r = new X1(n);
  return aR(e) ? (a = e, r.selectNumberingPlan(a), t = r.countryCallingCode()) : t = e, {
    country: a,
    countryCallingCode: t
  };
}
var oR = new RegExp("([" + E2 + "])");
function rR(e, n, a, t) {
  if (n) {
    var r = new X1(t);
    r.selectNumberingPlan(n, a);
    var M = new RegExp(r.IDDPrefix());
    if (e.search(M) === 0) {
      e = e.slice(e.match(M)[0].length);
      var b = e.match(oR);
      if (!(b && b[1] != null && b[1].length > 0 && b[1] === "0"))
        return e;
    }
  }
}
function iR(e, n) {
  if (e && n.numberingPlan.nationalPrefixForParsing()) {
    var a = new RegExp("^(?:" + n.numberingPlan.nationalPrefixForParsing() + ")"), t = a.exec(e);
    if (t) {
      var r, M, b = t.length - 1, d = b > 0 && t[b];
      if (n.nationalPrefixTransformRule() && d)
        r = e.replace(a, n.nationalPrefixTransformRule()), b > 1 && (M = t[1]);
      else {
        var c = t[0];
        r = e.slice(c.length), d && (M = t[1]);
      }
      var O;
      if (d) {
        var A = e.indexOf(t[1]), m = e.slice(0, A);
        m === n.numberingPlan.nationalPrefix() && (O = n.numberingPlan.nationalPrefix());
      } else
        O = t[0];
      return {
        nationalNumber: r,
        nationalPrefix: O,
        carrierCode: M
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function f4(e, n) {
  var a = iR(e, n), t = a.carrierCode, r = a.nationalNumber;
  if (r !== e) {
    if (!MR(e, r, n))
      return {
        nationalNumber: e
      };
    if (n.possibleLengths() && !bR(r, n))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: r,
    carrierCode: t
  };
}
function MR(e, n, a) {
  return !(Le(e, a.nationalNumberPattern()) && !Le(n, a.nationalNumberPattern()));
}
function bR(e, n) {
  switch (tb(e, n)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function sR(e, n, a, t) {
  var r = n ? pr(n, t) : a;
  if (e.indexOf(r) === 0) {
    t = new X1(t), t.selectNumberingPlan(n, a);
    var M = e.slice(r.length), b = f4(M, t), d = b.nationalNumber, c = f4(e, t), O = c.nationalNumber;
    if (!Le(O, t.nationalNumberPattern()) && Le(d, t.nationalNumberPattern()) || tb(O, t) === "TOO_LONG")
      return {
        countryCallingCode: r,
        number: M
      };
  }
  return {
    number: e
  };
}
function dR(e, n, a, t) {
  if (!e)
    return {};
  var r;
  if (e[0] !== "+") {
    var M = rR(e, n, a, t);
    if (M && M !== e)
      r = !0, e = "+" + M;
    else {
      if (n || a) {
        var b = sR(e, n, a, t), d = b.countryCallingCode, c = b.number;
        if (d)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: d,
            number: c
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  t = new X1(t);
  for (var O = 2; O - 1 <= QW && O <= e.length; ) {
    var A = e.slice(1, O);
    if (t.hasCallingCode(A))
      return t.selectNumberingPlan(A), {
        countryCallingCodeSource: r ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: A,
        number: e.slice(O)
      };
    O++;
  }
  return {};
}
function pR(e, n) {
  var a = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (a) return (a = a.call(e)).next.bind(a);
  if (Array.isArray(e) || (a = cR(e)) || n) {
    a && (e = a);
    var t = 0;
    return function() {
      return t >= e.length ? { done: !0 } : { done: !1, value: e[t++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cR(e, n) {
  if (e) {
    if (typeof e == "string") return wc(e, n);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    if (a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set") return Array.from(e);
    if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return wc(e, n);
  }
}
function wc(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var a = 0, t = new Array(n); a < n; a++)
    t[a] = e[a];
  return t;
}
function zR(e, n) {
  var a = n.countries, t = n.metadata;
  t = new X1(t);
  for (var r = pR(a), M; !(M = r()).done; ) {
    var b = M.value;
    if (t.country(b), t.leadingDigits()) {
      if (e && e.search(t.leadingDigits()) === 0)
        return b;
    } else if (ob({
      phone: e,
      country: b
    }, void 0, t.metadata))
      return b;
  }
}
function OR(e, n) {
  var a = n.nationalNumber, t = n.defaultCountry, r = n.metadata, M = r.getCountryCodesForCallingCode(e);
  if (M)
    return M.length === 1 ? M[0] : zR(a, {
      countries: M,
      defaultCountry: t,
      metadata: r.metadata
    });
}
var p6 = "+", uR = "[\\-\\.\\(\\)]?", Cc = "([" + E2 + "]|" + uR + ")", AR = "^\\" + p6 + Cc + "*[" + E2 + "]" + Cc + "*$", lR = new RegExp(AR, "g"), m4 = E2, fR = "[" + m4 + "]+((\\-)*[" + m4 + "])*", mR = "a-zA-Z", qR = "[" + mR + "]+((\\-)*[" + m4 + "])*", hR = "^(" + fR + "\\.)*" + qR + "\\.?$", yR = new RegExp(hR, "g"), Ec = "tel:", q4 = ";phone-context=", WR = ";isub=";
function gR(e) {
  var n = e.indexOf(q4);
  if (n < 0)
    return null;
  var a = n + q4.length;
  if (a >= e.length)
    return "";
  var t = e.indexOf(";", a);
  return t >= 0 ? e.substring(a, t) : e.substring(a);
}
function RR(e) {
  return e === null ? !0 : e.length === 0 ? !1 : lR.test(e) || yR.test(e);
}
function $R(e, n) {
  var a = n.extractFormattedPhoneNumber, t = gR(e);
  if (!RR(t))
    throw new fe("NOT_A_NUMBER");
  var r;
  if (t === null)
    r = a(e) || "";
  else {
    r = "", t.charAt(0) === p6 && (r += t);
    var M = e.indexOf(Ec), b;
    M >= 0 ? b = M + Ec.length : b = 0;
    var d = e.indexOf(q4);
    r += e.substring(b, d);
  }
  var c = r.indexOf(WR);
  if (c > 0 && (r = r.substring(0, c)), r !== "")
    return r;
}
var LR = 250, _R = new RegExp("[" + ab + E2 + "]"), NR = new RegExp("[^" + E2 + "#]+$");
function vR(e, n, a) {
  if (n = n || {}, a = new X1(a), n.defaultCountry && !a.hasCountry(n.defaultCountry))
    throw n.v2 ? new fe("INVALID_COUNTRY") : new Error("Unknown country: ".concat(n.defaultCountry));
  var t = TR(e, n.v2, n.extract), r = t.number, M = t.ext, b = t.error;
  if (!r) {
    if (n.v2)
      throw b === "TOO_SHORT" ? new fe("TOO_SHORT") : new fe("NOT_A_NUMBER");
    return {};
  }
  var d = BR(r, n.defaultCountry, n.defaultCallingCode, a), c = d.country, O = d.nationalNumber, A = d.countryCallingCode, m = d.countryCallingCodeSource, q = d.carrierCode;
  if (!a.hasSelectedNumberingPlan()) {
    if (n.v2)
      throw new fe("INVALID_COUNTRY");
    return {};
  }
  if (!O || O.length < nb) {
    if (n.v2)
      throw new fe("TOO_SHORT");
    return {};
  }
  if (O.length > ZW) {
    if (n.v2)
      throw new fe("TOO_LONG");
    return {};
  }
  if (n.v2) {
    var y = new nR(A, O, a.metadata);
    return c && (y.country = c), q && (y.carrierCode = q), M && (y.ext = M), y.__countryCallingCodeSource = m, y;
  }
  var $ = (n.extended ? a.hasSelectedNumberingPlan() : c) ? Le(O, a.nationalNumberPattern()) : !1;
  return n.extended ? {
    country: c,
    countryCallingCode: A,
    carrierCode: q,
    valid: $,
    possible: $ ? !0 : !!(n.extended === !0 && a.possibleLengths() && d6(O, a)),
    phone: O,
    ext: M
  } : $ ? SR(c, O, M) : {};
}
function DR(e, n, a) {
  if (e) {
    if (e.length > LR) {
      if (a)
        throw new fe("TOO_LONG");
      return;
    }
    if (n === !1)
      return e;
    var t = e.search(_R);
    if (!(t < 0))
      return e.slice(t).replace(NR, "");
  }
}
function TR(e, n, a) {
  var t = $R(e, {
    extractFormattedPhoneNumber: function(b) {
      return DR(b, a, n);
    }
  });
  if (!t)
    return {};
  if (!Wg(t))
    return gg(t) ? {
      error: "TOO_SHORT"
    } : {};
  var r = Rg(t);
  return r.ext ? r : {
    number: t
  };
}
function SR(e, n, a) {
  var t = {
    country: e,
    phone: n
  };
  return a && (t.ext = a), t;
}
function BR(e, n, a, t) {
  var r = dR(Lc(e), n, a, t.metadata), M = r.countryCallingCodeSource, b = r.countryCallingCode, d = r.number, c;
  if (b)
    t.selectNumberingPlan(b);
  else if (d && (n || a))
    t.selectNumberingPlan(n, a), n && (c = n), b = a || pr(n, t.metadata);
  else return {};
  if (!d)
    return {
      countryCallingCodeSource: M,
      countryCallingCode: b
    };
  var O = f4(Lc(d), t), A = O.nationalNumber, m = O.carrierCode, q = OR(b, {
    nationalNumber: A,
    defaultCountry: n,
    metadata: t
  });
  return q && (c = q, q === "001" || t.country(c)), {
    country: c,
    countryCallingCode: b,
    countryCallingCodeSource: M,
    nationalNumber: A,
    carrierCode: m
  };
}
function Xc(e, n) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, t);
  }
  return a;
}
function Pc(e) {
  for (var n = 1; n < arguments.length; n++) {
    var a = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Xc(Object(a), !0).forEach(function(t) {
      wR(e, t, a[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Xc(Object(a)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
    });
  }
  return e;
}
function wR(e, n, a) {
  return n in e ? Object.defineProperty(e, n, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = a, e;
}
function c6(e, n, a) {
  return vR(e, Pc(Pc({}, n), {}, {
    v2: !0
  }), a);
}
function kc(e, n) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, t);
  }
  return a;
}
function CR(e) {
  for (var n = 1; n < arguments.length; n++) {
    var a = arguments[n] != null ? arguments[n] : {};
    n % 2 ? kc(Object(a), !0).forEach(function(t) {
      ER(e, t, a[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : kc(Object(a)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
    });
  }
  return e;
}
function ER(e, n, a) {
  return n in e ? Object.defineProperty(e, n, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = a, e;
}
function XR(e, n) {
  return xR(e) || IR(e, n) || kR(e, n) || PR();
}
function PR() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kR(e, n) {
  if (e) {
    if (typeof e == "string") return Ic(e, n);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    if (a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set") return Array.from(e);
    if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return Ic(e, n);
  }
}
function Ic(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var a = 0, t = new Array(n); a < n; a++)
    t[a] = e[a];
  return t;
}
function IR(e, n) {
  var a = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (a != null) {
    var t = [], r = !0, M = !1, b, d;
    try {
      for (a = a.call(e); !(r = (b = a.next()).done) && (t.push(b.value), !(n && t.length === n)); r = !0)
        ;
    } catch (c) {
      M = !0, d = c;
    } finally {
      try {
        !r && a.return != null && a.return();
      } finally {
        if (M) throw d;
      }
    }
    return t;
  }
}
function xR(e) {
  if (Array.isArray(e)) return e;
}
function z6(e) {
  var n = Array.prototype.slice.call(e), a = XR(n, 4), t = a[0], r = a[1], M = a[2], b = a[3], d, c, O;
  if (typeof t == "string")
    d = t;
  else throw new TypeError("A text for parsing must be a string.");
  if (!r || typeof r == "string")
    b ? (c = M, O = b) : (c = void 0, O = M), r && (c = CR({
      defaultCountry: r
    }, c));
  else if (mo(r))
    M ? (c = r, O = M) : O = r;
  else throw new Error("Invalid second argument: ".concat(r));
  return {
    text: d,
    options: c,
    metadata: O
  };
}
function FR() {
  var e = z6(arguments), n = e.text, a = e.options, t = e.metadata;
  return c6(n, a, t);
}
function xc(e, n) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, t);
  }
  return a;
}
function Fc(e) {
  for (var n = 1; n < arguments.length; n++) {
    var a = arguments[n] != null ? arguments[n] : {};
    n % 2 ? xc(Object(a), !0).forEach(function(t) {
      HR(e, t, a[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : xc(Object(a)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
    });
  }
  return e;
}
function HR(e, n, a) {
  return n in e ? Object.defineProperty(e, n, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = a, e;
}
function UR(e, n, a) {
  n && n.defaultCountry && !Ag(n.defaultCountry, a) && (n = Fc(Fc({}, n), {}, {
    defaultCountry: void 0
  }));
  try {
    return c6(e, n, a);
  } catch (t) {
    if (!(t instanceof fe)) throw t;
  }
}
function jR() {
  var e = z6(arguments), n = e.text, a = e.options, t = e.metadata;
  return UR(n, a, t);
}
function GR() {
  return UW(FR, arguments);
}
function Hc(e, n) {
  if (typeof e != "string" || e.trim() !== e)
    return !1;
  try {
    var a = GR(e, n);
    return n && a.country, a.isValid();
  } catch {
    return !1;
  }
}
function $t(e, n) {
  return IW(e, n);
}
var h4 = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = b;
  var a = r(Xn), t = c1;
  function r(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var M = /^[0-9]+$/;
  function b(d, c) {
    return (0, a.default)(d), c && c.no_symbols ? M.test(d) : new RegExp("^[+-]?([0-9]*[".concat((c || {}).locale ? t.decimal[c.locale] : ".", "])?[0-9]+$")).test(d);
  }
  e.exports = n.default, e.exports.default = n.default;
})(h4, h4.exports);
var VR = h4.exports;
const YR = /* @__PURE__ */ I2(VR);
function O6(e, n) {
  return typeof e == "string" && YR(e, n);
}
function Pn(e) {
  return e instanceof Date && !isNaN(e.getTime());
}
function rb(e, n) {
  if (n === void 0 && (n = {}), typeof e != "number")
    return !1;
  if (e === 1 / 0 || e === -1 / 0)
    return !!n.allowInfinity;
  if (Number.isNaN(e))
    return !!n.allowNaN;
  if (n.maxDecimalPlaces !== void 0) {
    var a = 0;
    if (e % 1 !== 0 && (a = e.toString().split(".")[1].length), a > n.maxDecimalPlaces)
      return !1;
  }
  return Number.isFinite(e);
}
function nn(e) {
  return typeof e == "number" && Number.isInteger(e);
}
function R1(e) {
  return e instanceof String || typeof e == "string";
}
function wn(e) {
  return Array.isArray(e);
}
function P1(e) {
  return e != null && (typeof e == "object" || typeof e == "function") && !Array.isArray(e);
}
var u6 = { exports: {} }, A6 = { exports: {} };
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var l6;
function I() {
  return l6.apply(null, arguments);
}
function JR(e) {
  l6 = e;
}
function X2(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Dn(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function B0(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function ib(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var n;
  for (n in e)
    if (B0(e, n))
      return !1;
  return !0;
}
function H1(e) {
  return e === void 0;
}
function _e(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function kt(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function f6(e, n) {
  var a = [], t, r = e.length;
  for (t = 0; t < r; ++t)
    a.push(n(e[t], t));
  return a;
}
function Ke(e, n) {
  for (var a in n)
    B0(n, a) && (e[a] = n[a]);
  return B0(n, "toString") && (e.toString = n.toString), B0(n, "valueOf") && (e.valueOf = n.valueOf), e;
}
function ee(e, n, a, t) {
  return I6(e, n, a, t, !0).utc();
}
function KR() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function O0(e) {
  return e._pf == null && (e._pf = KR()), e._pf;
}
var y4;
Array.prototype.some ? y4 = Array.prototype.some : y4 = function(e) {
  var n = Object(this), a = n.length >>> 0, t;
  for (t = 0; t < a; t++)
    if (t in n && e.call(this, n[t], t, n))
      return !0;
  return !1;
};
function Mb(e) {
  var n = null, a = !1, t = e._d && !isNaN(e._d.getTime());
  if (t && (n = O0(e), a = y4.call(n.parsedDateParts, function(r) {
    return r != null;
  }), t = n.overflow < 0 && !n.empty && !n.invalidEra && !n.invalidMonth && !n.invalidWeekday && !n.weekdayMismatch && !n.nullInput && !n.invalidFormat && !n.userInvalidated && (!n.meridiem || n.meridiem && a), e._strict && (t = t && n.charsLeftOver === 0 && n.unusedTokens.length === 0 && n.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = t;
  else
    return t;
  return e._isValid;
}
function cr(e) {
  var n = ee(NaN);
  return e != null ? Ke(O0(n), e) : O0(n).userInvalidated = !0, n;
}
var Uc = I.momentProperties = [], WM = !1;
function bb(e, n) {
  var a, t, r, M = Uc.length;
  if (H1(n._isAMomentObject) || (e._isAMomentObject = n._isAMomentObject), H1(n._i) || (e._i = n._i), H1(n._f) || (e._f = n._f), H1(n._l) || (e._l = n._l), H1(n._strict) || (e._strict = n._strict), H1(n._tzm) || (e._tzm = n._tzm), H1(n._isUTC) || (e._isUTC = n._isUTC), H1(n._offset) || (e._offset = n._offset), H1(n._pf) || (e._pf = O0(n)), H1(n._locale) || (e._locale = n._locale), M > 0)
    for (a = 0; a < M; a++)
      t = Uc[a], r = n[t], H1(r) || (e[t] = r);
  return e;
}
function It(e) {
  bb(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), WM === !1 && (WM = !0, I.updateOffset(this), WM = !1);
}
function P2(e) {
  return e instanceof It || e != null && e._isAMomentObject != null;
}
function m6(e) {
  I.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function h2(e, n) {
  var a = !0;
  return Ke(function() {
    if (I.deprecationHandler != null && I.deprecationHandler(null, e), a) {
      var t = [], r, M, b, d = arguments.length;
      for (M = 0; M < d; M++) {
        if (r = "", typeof arguments[M] == "object") {
          r += `
[` + M + "] ";
          for (b in arguments[0])
            B0(arguments[0], b) && (r += b + ": " + arguments[0][b] + ", ");
          r = r.slice(0, -2);
        } else
          r = arguments[M];
        t.push(r);
      }
      m6(
        e + `
Arguments: ` + Array.prototype.slice.call(t).join("") + `
` + new Error().stack
      ), a = !1;
    }
    return n.apply(this, arguments);
  }, n);
}
var jc = {};
function q6(e, n) {
  I.deprecationHandler != null && I.deprecationHandler(e, n), jc[e] || (m6(n), jc[e] = !0);
}
I.suppressDeprecationWarnings = !1;
I.deprecationHandler = null;
function ne(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function ZR(e) {
  var n, a;
  for (a in e)
    B0(e, a) && (n = e[a], ne(n) ? this[a] = n : this["_" + a] = n);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function W4(e, n) {
  var a = Ke({}, e), t;
  for (t in n)
    B0(n, t) && (Dn(e[t]) && Dn(n[t]) ? (a[t] = {}, Ke(a[t], e[t]), Ke(a[t], n[t])) : n[t] != null ? a[t] = n[t] : delete a[t]);
  for (t in e)
    B0(e, t) && !B0(n, t) && Dn(e[t]) && (a[t] = Ke({}, a[t]));
  return a;
}
function sb(e) {
  e != null && this.set(e);
}
var g4;
Object.keys ? g4 = Object.keys : g4 = function(e) {
  var n, a = [];
  for (n in e)
    B0(e, n) && a.push(n);
  return a;
};
var QR = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function e$(e, n, a) {
  var t = this._calendar[e] || this._calendar.sameElse;
  return ne(t) ? t.call(n, a) : t;
}
function Q2(e, n, a) {
  var t = "" + Math.abs(e), r = n - t.length, M = e >= 0;
  return (M ? a ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + t;
}
var db = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, no = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, gM = {}, ha = {};
function Z(e, n, a, t) {
  var r = t;
  typeof t == "string" && (r = function() {
    return this[t]();
  }), e && (ha[e] = r), n && (ha[n[0]] = function() {
    return Q2(r.apply(this, arguments), n[1], n[2]);
  }), a && (ha[a] = function() {
    return this.localeData().ordinal(
      r.apply(this, arguments),
      e
    );
  });
}
function n$(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function a$(e) {
  var n = e.match(db), a, t;
  for (a = 0, t = n.length; a < t; a++)
    ha[n[a]] ? n[a] = ha[n[a]] : n[a] = n$(n[a]);
  return function(r) {
    var M = "", b;
    for (b = 0; b < t; b++)
      M += ne(n[b]) ? n[b].call(r, e) : n[b];
    return M;
  };
}
function qo(e, n) {
  return e.isValid() ? (n = h6(n, e.localeData()), gM[n] = gM[n] || a$(n), gM[n](e)) : e.localeData().invalidDate();
}
function h6(e, n) {
  var a = 5;
  function t(r) {
    return n.longDateFormat(r) || r;
  }
  for (no.lastIndex = 0; a >= 0 && no.test(e); )
    e = e.replace(
      no,
      t
    ), no.lastIndex = 0, a -= 1;
  return e;
}
var t$ = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function o$(e) {
  var n = this._longDateFormat[e], a = this._longDateFormat[e.toUpperCase()];
  return n || !a ? n : (this._longDateFormat[e] = a.match(db).map(function(t) {
    return t === "MMMM" || t === "MM" || t === "DD" || t === "dddd" ? t.slice(1) : t;
  }).join(""), this._longDateFormat[e]);
}
var r$ = "Invalid date";
function i$() {
  return this._invalidDate;
}
var M$ = "%d", b$ = /\d{1,2}/;
function s$(e) {
  return this._ordinal.replace("%d", e);
}
var d$ = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function p$(e, n, a, t) {
  var r = this._relativeTime[a];
  return ne(r) ? r(e, n, a, t) : r.replace(/%d/i, e);
}
function c$(e, n) {
  var a = this._relativeTime[e > 0 ? "future" : "past"];
  return ne(a) ? a(n) : a.replace(/%s/i, n);
}
var Gc = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function y2(e) {
  return typeof e == "string" ? Gc[e] || Gc[e.toLowerCase()] : void 0;
}
function pb(e) {
  var n = {}, a, t;
  for (t in e)
    B0(e, t) && (a = y2(t), a && (n[a] = e[t]));
  return n;
}
var z$ = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function O$(e) {
  var n = [], a;
  for (a in e)
    B0(e, a) && n.push({ unit: a, priority: z$[a] });
  return n.sort(function(t, r) {
    return t.priority - r.priority;
  }), n;
}
var y6 = /\d/, t2 = /\d\d/, W6 = /\d{3}/, cb = /\d{4}/, zr = /[+-]?\d{6}/, Z0 = /\d\d?/, g6 = /\d\d\d\d?/, R6 = /\d\d\d\d\d\d?/, Or = /\d{1,3}/, zb = /\d{1,4}/, ur = /[+-]?\d{1,6}/, Ea = /\d+/, Ar = /[+-]?\d+/, u$ = /Z|[+-]\d\d:?\d\d/gi, lr = /Z|[+-]\d\d(?::?\d\d)?/gi, A$ = /[+-]?\d+(\.\d{1,3})?/, xt = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Xa = /^[1-9]\d?/, Ob = /^([1-9]\d|\d)/, Eo;
Eo = {};
function j(e, n, a) {
  Eo[e] = ne(n) ? n : function(t, r) {
    return t && a ? a : n;
  };
}
function l$(e, n) {
  return B0(Eo, e) ? Eo[e](n._strict, n._locale) : new RegExp(f$(e));
}
function f$(e) {
  return ge(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(n, a, t, r, M) {
        return a || t || r || M;
      }
    )
  );
}
function ge(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function f2(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function $0(e) {
  var n = +e, a = 0;
  return n !== 0 && isFinite(n) && (a = f2(n)), a;
}
var R4 = {};
function F0(e, n) {
  var a, t = n, r;
  for (typeof e == "string" && (e = [e]), _e(n) && (t = function(M, b) {
    b[n] = $0(M);
  }), r = e.length, a = 0; a < r; a++)
    R4[e[a]] = t;
}
function Ft(e, n) {
  F0(e, function(a, t, r, M) {
    r._w = r._w || {}, n(a, r._w, r, M);
  });
}
function m$(e, n, a) {
  n != null && B0(R4, e) && R4[e](n, a._a, a, e);
}
function fr(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var D1 = 0, qe = 1, K2 = 2, l1 = 3, w2 = 4, he = 5, _n = 6, q$ = 7, h$ = 8;
Z("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Q2(e, 4) : "+" + e;
});
Z(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
Z(0, ["YYYY", 4], 0, "year");
Z(0, ["YYYYY", 5], 0, "year");
Z(0, ["YYYYYY", 6, !0], 0, "year");
j("Y", Ar);
j("YY", Z0, t2);
j("YYYY", zb, cb);
j("YYYYY", ur, zr);
j("YYYYYY", ur, zr);
F0(["YYYYY", "YYYYYY"], D1);
F0("YYYY", function(e, n) {
  n[D1] = e.length === 2 ? I.parseTwoDigitYear(e) : $0(e);
});
F0("YY", function(e, n) {
  n[D1] = I.parseTwoDigitYear(e);
});
F0("Y", function(e, n) {
  n[D1] = parseInt(e, 10);
});
function Wt(e) {
  return fr(e) ? 366 : 365;
}
I.parseTwoDigitYear = function(e) {
  return $0(e) + ($0(e) > 68 ? 1900 : 2e3);
};
var $6 = Pa("FullYear", !0);
function y$() {
  return fr(this.year());
}
function Pa(e, n) {
  return function(a) {
    return a != null ? (L6(this, e, a), I.updateOffset(this, n), this) : Lt(this, e);
  };
}
function Lt(e, n) {
  if (!e.isValid())
    return NaN;
  var a = e._d, t = e._isUTC;
  switch (n) {
    case "Milliseconds":
      return t ? a.getUTCMilliseconds() : a.getMilliseconds();
    case "Seconds":
      return t ? a.getUTCSeconds() : a.getSeconds();
    case "Minutes":
      return t ? a.getUTCMinutes() : a.getMinutes();
    case "Hours":
      return t ? a.getUTCHours() : a.getHours();
    case "Date":
      return t ? a.getUTCDate() : a.getDate();
    case "Day":
      return t ? a.getUTCDay() : a.getDay();
    case "Month":
      return t ? a.getUTCMonth() : a.getMonth();
    case "FullYear":
      return t ? a.getUTCFullYear() : a.getFullYear();
    default:
      return NaN;
  }
}
function L6(e, n, a) {
  var t, r, M, b, d;
  if (!(!e.isValid() || isNaN(a))) {
    switch (t = e._d, r = e._isUTC, n) {
      case "Milliseconds":
        return void (r ? t.setUTCMilliseconds(a) : t.setMilliseconds(a));
      case "Seconds":
        return void (r ? t.setUTCSeconds(a) : t.setSeconds(a));
      case "Minutes":
        return void (r ? t.setUTCMinutes(a) : t.setMinutes(a));
      case "Hours":
        return void (r ? t.setUTCHours(a) : t.setHours(a));
      case "Date":
        return void (r ? t.setUTCDate(a) : t.setDate(a));
      case "FullYear":
        break;
      default:
        return;
    }
    M = a, b = e.month(), d = e.date(), d = d === 29 && b === 1 && !fr(M) ? 28 : d, r ? t.setUTCFullYear(M, b, d) : t.setFullYear(M, b, d);
  }
}
function W$(e) {
  return e = y2(e), ne(this[e]) ? this[e]() : this;
}
function g$(e, n) {
  if (typeof e == "object") {
    e = pb(e);
    var a = O$(e), t, r = a.length;
    for (t = 0; t < r; t++)
      this[a[t].unit](e[a[t].unit]);
  } else if (e = y2(e), ne(this[e]))
    return this[e](n);
  return this;
}
function R$(e, n) {
  return (e % n + n) % n;
}
var s1;
Array.prototype.indexOf ? s1 = Array.prototype.indexOf : s1 = function(e) {
  var n;
  for (n = 0; n < this.length; ++n)
    if (this[n] === e)
      return n;
  return -1;
};
function ub(e, n) {
  if (isNaN(e) || isNaN(n))
    return NaN;
  var a = R$(n, 12);
  return e += (n - a) / 12, a === 1 ? fr(e) ? 29 : 28 : 31 - a % 7 % 2;
}
Z("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
Z("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
Z("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
j("M", Z0, Xa);
j("MM", Z0, t2);
j("MMM", function(e, n) {
  return n.monthsShortRegex(e);
});
j("MMMM", function(e, n) {
  return n.monthsRegex(e);
});
F0(["M", "MM"], function(e, n) {
  n[qe] = $0(e) - 1;
});
F0(["MMM", "MMMM"], function(e, n, a, t) {
  var r = a._locale.monthsParse(e, t, a._strict);
  r != null ? n[qe] = r : O0(a).invalidMonth = e;
});
var $$ = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), _6 = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), N6 = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, L$ = xt, _$ = xt;
function N$(e, n) {
  return e ? X2(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || N6).test(n) ? "format" : "standalone"][e.month()] : X2(this._months) ? this._months : this._months.standalone;
}
function v$(e, n) {
  return e ? X2(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[N6.test(n) ? "format" : "standalone"][e.month()] : X2(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function D$(e, n, a) {
  var t, r, M, b = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], t = 0; t < 12; ++t)
      M = ee([2e3, t]), this._shortMonthsParse[t] = this.monthsShort(
        M,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[t] = this.months(M, "").toLocaleLowerCase();
  return a ? n === "MMM" ? (r = s1.call(this._shortMonthsParse, b), r !== -1 ? r : null) : (r = s1.call(this._longMonthsParse, b), r !== -1 ? r : null) : n === "MMM" ? (r = s1.call(this._shortMonthsParse, b), r !== -1 ? r : (r = s1.call(this._longMonthsParse, b), r !== -1 ? r : null)) : (r = s1.call(this._longMonthsParse, b), r !== -1 ? r : (r = s1.call(this._shortMonthsParse, b), r !== -1 ? r : null));
}
function T$(e, n, a) {
  var t, r, M;
  if (this._monthsParseExact)
    return D$.call(this, e, n, a);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), t = 0; t < 12; t++) {
    if (r = ee([2e3, t]), a && !this._longMonthsParse[t] && (this._longMonthsParse[t] = new RegExp(
      "^" + this.months(r, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[t] = new RegExp(
      "^" + this.monthsShort(r, "").replace(".", "") + "$",
      "i"
    )), !a && !this._monthsParse[t] && (M = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), this._monthsParse[t] = new RegExp(M.replace(".", ""), "i")), a && n === "MMMM" && this._longMonthsParse[t].test(e))
      return t;
    if (a && n === "MMM" && this._shortMonthsParse[t].test(e))
      return t;
    if (!a && this._monthsParse[t].test(e))
      return t;
  }
}
function v6(e, n) {
  if (!e.isValid())
    return e;
  if (typeof n == "string") {
    if (/^\d+$/.test(n))
      n = $0(n);
    else if (n = e.localeData().monthsParse(n), !_e(n))
      return e;
  }
  var a = n, t = e.date();
  return t = t < 29 ? t : Math.min(t, ub(e.year(), a)), e._isUTC ? e._d.setUTCMonth(a, t) : e._d.setMonth(a, t), e;
}
function D6(e) {
  return e != null ? (v6(this, e), I.updateOffset(this, !0), this) : Lt(this, "Month");
}
function S$() {
  return ub(this.year(), this.month());
}
function B$(e) {
  return this._monthsParseExact ? (B0(this, "_monthsRegex") || T6.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (B0(this, "_monthsShortRegex") || (this._monthsShortRegex = L$), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function w$(e) {
  return this._monthsParseExact ? (B0(this, "_monthsRegex") || T6.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (B0(this, "_monthsRegex") || (this._monthsRegex = _$), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function T6() {
  function e(c, O) {
    return O.length - c.length;
  }
  var n = [], a = [], t = [], r, M, b, d;
  for (r = 0; r < 12; r++)
    M = ee([2e3, r]), b = ge(this.monthsShort(M, "")), d = ge(this.months(M, "")), n.push(b), a.push(d), t.push(d), t.push(b);
  n.sort(e), a.sort(e), t.sort(e), this._monthsRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
function C$(e, n, a, t, r, M, b) {
  var d;
  return e < 100 && e >= 0 ? (d = new Date(e + 400, n, a, t, r, M, b), isFinite(d.getFullYear()) && d.setFullYear(e)) : d = new Date(e, n, a, t, r, M, b), d;
}
function _t(e) {
  var n, a;
  return e < 100 && e >= 0 ? (a = Array.prototype.slice.call(arguments), a[0] = e + 400, n = new Date(Date.UTC.apply(null, a)), isFinite(n.getUTCFullYear()) && n.setUTCFullYear(e)) : n = new Date(Date.UTC.apply(null, arguments)), n;
}
function Xo(e, n, a) {
  var t = 7 + n - a, r = (7 + _t(e, 0, t).getUTCDay() - n) % 7;
  return -r + t - 1;
}
function S6(e, n, a, t, r) {
  var M = (7 + a - t) % 7, b = Xo(e, t, r), d = 1 + 7 * (n - 1) + M + b, c, O;
  return d <= 0 ? (c = e - 1, O = Wt(c) + d) : d > Wt(e) ? (c = e + 1, O = d - Wt(e)) : (c = e, O = d), {
    year: c,
    dayOfYear: O
  };
}
function Nt(e, n, a) {
  var t = Xo(e.year(), n, a), r = Math.floor((e.dayOfYear() - t - 1) / 7) + 1, M, b;
  return r < 1 ? (b = e.year() - 1, M = r + Re(b, n, a)) : r > Re(e.year(), n, a) ? (M = r - Re(e.year(), n, a), b = e.year() + 1) : (b = e.year(), M = r), {
    week: M,
    year: b
  };
}
function Re(e, n, a) {
  var t = Xo(e, n, a), r = Xo(e + 1, n, a);
  return (Wt(e) - t + r) / 7;
}
Z("w", ["ww", 2], "wo", "week");
Z("W", ["WW", 2], "Wo", "isoWeek");
j("w", Z0, Xa);
j("ww", Z0, t2);
j("W", Z0, Xa);
j("WW", Z0, t2);
Ft(
  ["w", "ww", "W", "WW"],
  function(e, n, a, t) {
    n[t.substr(0, 1)] = $0(e);
  }
);
function E$(e) {
  return Nt(e, this._week.dow, this._week.doy).week;
}
var X$ = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function P$() {
  return this._week.dow;
}
function k$() {
  return this._week.doy;
}
function I$(e) {
  var n = this.localeData().week(this);
  return e == null ? n : this.add((e - n) * 7, "d");
}
function x$(e) {
  var n = Nt(this, 1, 4).week;
  return e == null ? n : this.add((e - n) * 7, "d");
}
Z("d", 0, "do", "day");
Z("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
Z("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
Z("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
Z("e", 0, 0, "weekday");
Z("E", 0, 0, "isoWeekday");
j("d", Z0);
j("e", Z0);
j("E", Z0);
j("dd", function(e, n) {
  return n.weekdaysMinRegex(e);
});
j("ddd", function(e, n) {
  return n.weekdaysShortRegex(e);
});
j("dddd", function(e, n) {
  return n.weekdaysRegex(e);
});
Ft(["dd", "ddd", "dddd"], function(e, n, a, t) {
  var r = a._locale.weekdaysParse(e, t, a._strict);
  r != null ? n.d = r : O0(a).invalidWeekday = e;
});
Ft(["d", "e", "E"], function(e, n, a, t) {
  n[t] = $0(e);
});
function F$(e, n) {
  return typeof e != "string" ? e : isNaN(e) ? (e = n.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function H$(e, n) {
  return typeof e == "string" ? n.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Ab(e, n) {
  return e.slice(n, 7).concat(e.slice(0, n));
}
var U$ = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), B6 = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), j$ = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), G$ = xt, V$ = xt, Y$ = xt;
function J$(e, n) {
  var a = X2(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(n) ? "format" : "standalone"];
  return e === !0 ? Ab(a, this._week.dow) : e ? a[e.day()] : a;
}
function K$(e) {
  return e === !0 ? Ab(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Z$(e) {
  return e === !0 ? Ab(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Q$(e, n, a) {
  var t, r, M, b = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], t = 0; t < 7; ++t)
      M = ee([2e3, 1]).day(t), this._minWeekdaysParse[t] = this.weekdaysMin(
        M,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[t] = this.weekdaysShort(
        M,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[t] = this.weekdays(M, "").toLocaleLowerCase();
  return a ? n === "dddd" ? (r = s1.call(this._weekdaysParse, b), r !== -1 ? r : null) : n === "ddd" ? (r = s1.call(this._shortWeekdaysParse, b), r !== -1 ? r : null) : (r = s1.call(this._minWeekdaysParse, b), r !== -1 ? r : null) : n === "dddd" ? (r = s1.call(this._weekdaysParse, b), r !== -1 || (r = s1.call(this._shortWeekdaysParse, b), r !== -1) ? r : (r = s1.call(this._minWeekdaysParse, b), r !== -1 ? r : null)) : n === "ddd" ? (r = s1.call(this._shortWeekdaysParse, b), r !== -1 || (r = s1.call(this._weekdaysParse, b), r !== -1) ? r : (r = s1.call(this._minWeekdaysParse, b), r !== -1 ? r : null)) : (r = s1.call(this._minWeekdaysParse, b), r !== -1 || (r = s1.call(this._weekdaysParse, b), r !== -1) ? r : (r = s1.call(this._shortWeekdaysParse, b), r !== -1 ? r : null));
}
function eL(e, n, a) {
  var t, r, M;
  if (this._weekdaysParseExact)
    return Q$.call(this, e, n, a);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), t = 0; t < 7; t++) {
    if (r = ee([2e3, 1]).day(t), a && !this._fullWeekdaysParse[t] && (this._fullWeekdaysParse[t] = new RegExp(
      "^" + this.weekdays(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[t] = new RegExp(
      "^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[t] = new RegExp(
      "^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[t] || (M = "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, ""), this._weekdaysParse[t] = new RegExp(M.replace(".", ""), "i")), a && n === "dddd" && this._fullWeekdaysParse[t].test(e))
      return t;
    if (a && n === "ddd" && this._shortWeekdaysParse[t].test(e))
      return t;
    if (a && n === "dd" && this._minWeekdaysParse[t].test(e))
      return t;
    if (!a && this._weekdaysParse[t].test(e))
      return t;
  }
}
function nL(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var n = Lt(this, "Day");
  return e != null ? (e = F$(e, this.localeData()), this.add(e - n, "d")) : n;
}
function aL(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var n = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? n : this.add(e - n, "d");
}
function tL(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var n = H$(e, this.localeData());
    return this.day(this.day() % 7 ? n : n - 7);
  } else
    return this.day() || 7;
}
function oL(e) {
  return this._weekdaysParseExact ? (B0(this, "_weekdaysRegex") || lb.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (B0(this, "_weekdaysRegex") || (this._weekdaysRegex = G$), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function rL(e) {
  return this._weekdaysParseExact ? (B0(this, "_weekdaysRegex") || lb.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (B0(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = V$), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function iL(e) {
  return this._weekdaysParseExact ? (B0(this, "_weekdaysRegex") || lb.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (B0(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Y$), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function lb() {
  function e(A, m) {
    return m.length - A.length;
  }
  var n = [], a = [], t = [], r = [], M, b, d, c, O;
  for (M = 0; M < 7; M++)
    b = ee([2e3, 1]).day(M), d = ge(this.weekdaysMin(b, "")), c = ge(this.weekdaysShort(b, "")), O = ge(this.weekdays(b, "")), n.push(d), a.push(c), t.push(O), r.push(d), r.push(c), r.push(O);
  n.sort(e), a.sort(e), t.sort(e), r.sort(e), this._weekdaysRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
function fb() {
  return this.hours() % 12 || 12;
}
function ML() {
  return this.hours() || 24;
}
Z("H", ["HH", 2], 0, "hour");
Z("h", ["hh", 2], 0, fb);
Z("k", ["kk", 2], 0, ML);
Z("hmm", 0, 0, function() {
  return "" + fb.apply(this) + Q2(this.minutes(), 2);
});
Z("hmmss", 0, 0, function() {
  return "" + fb.apply(this) + Q2(this.minutes(), 2) + Q2(this.seconds(), 2);
});
Z("Hmm", 0, 0, function() {
  return "" + this.hours() + Q2(this.minutes(), 2);
});
Z("Hmmss", 0, 0, function() {
  return "" + this.hours() + Q2(this.minutes(), 2) + Q2(this.seconds(), 2);
});
function w6(e, n) {
  Z(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      n
    );
  });
}
w6("a", !0);
w6("A", !1);
function C6(e, n) {
  return n._meridiemParse;
}
j("a", C6);
j("A", C6);
j("H", Z0, Ob);
j("h", Z0, Xa);
j("k", Z0, Xa);
j("HH", Z0, t2);
j("hh", Z0, t2);
j("kk", Z0, t2);
j("hmm", g6);
j("hmmss", R6);
j("Hmm", g6);
j("Hmmss", R6);
F0(["H", "HH"], l1);
F0(["k", "kk"], function(e, n, a) {
  var t = $0(e);
  n[l1] = t === 24 ? 0 : t;
});
F0(["a", "A"], function(e, n, a) {
  a._isPm = a._locale.isPM(e), a._meridiem = e;
});
F0(["h", "hh"], function(e, n, a) {
  n[l1] = $0(e), O0(a).bigHour = !0;
});
F0("hmm", function(e, n, a) {
  var t = e.length - 2;
  n[l1] = $0(e.substr(0, t)), n[w2] = $0(e.substr(t)), O0(a).bigHour = !0;
});
F0("hmmss", function(e, n, a) {
  var t = e.length - 4, r = e.length - 2;
  n[l1] = $0(e.substr(0, t)), n[w2] = $0(e.substr(t, 2)), n[he] = $0(e.substr(r)), O0(a).bigHour = !0;
});
F0("Hmm", function(e, n, a) {
  var t = e.length - 2;
  n[l1] = $0(e.substr(0, t)), n[w2] = $0(e.substr(t));
});
F0("Hmmss", function(e, n, a) {
  var t = e.length - 4, r = e.length - 2;
  n[l1] = $0(e.substr(0, t)), n[w2] = $0(e.substr(t, 2)), n[he] = $0(e.substr(r));
});
function bL(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var sL = /[ap]\.?m?\.?/i, dL = Pa("Hours", !0);
function pL(e, n, a) {
  return e > 11 ? a ? "pm" : "PM" : a ? "am" : "AM";
}
var E6 = {
  calendar: QR,
  longDateFormat: t$,
  invalidDate: r$,
  ordinal: M$,
  dayOfMonthOrdinalParse: b$,
  relativeTime: d$,
  months: $$,
  monthsShort: _6,
  week: X$,
  weekdays: U$,
  weekdaysMin: j$,
  weekdaysShort: B6,
  meridiemParse: sL
}, e1 = {}, bt = {}, vt;
function cL(e, n) {
  var a, t = Math.min(e.length, n.length);
  for (a = 0; a < t; a += 1)
    if (e[a] !== n[a])
      return a;
  return t;
}
function Vc(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function zL(e) {
  for (var n = 0, a, t, r, M; n < e.length; ) {
    for (M = Vc(e[n]).split("-"), a = M.length, t = Vc(e[n + 1]), t = t ? t.split("-") : null; a > 0; ) {
      if (r = mr(M.slice(0, a).join("-")), r)
        return r;
      if (t && t.length >= a && cL(M, t) >= a - 1)
        break;
      a--;
    }
    n++;
  }
  return vt;
}
function OL(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function mr(e) {
  var n = null, a;
  if (e1[e] === void 0 && typeof module < "u" && module && module.exports && OL(e))
    try {
      n = vt._abbr, a = require, a("./locale/" + e), en(n);
    } catch {
      e1[e] = null;
    }
  return e1[e];
}
function en(e, n) {
  var a;
  return e && (H1(n) ? a = ve(e) : a = mb(e, n), a ? vt = a : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), vt._abbr;
}
function mb(e, n) {
  if (n !== null) {
    var a, t = E6;
    if (n.abbr = e, e1[e] != null)
      q6(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), t = e1[e]._config;
    else if (n.parentLocale != null)
      if (e1[n.parentLocale] != null)
        t = e1[n.parentLocale]._config;
      else if (a = mr(n.parentLocale), a != null)
        t = a._config;
      else
        return bt[n.parentLocale] || (bt[n.parentLocale] = []), bt[n.parentLocale].push({
          name: e,
          config: n
        }), null;
    return e1[e] = new sb(W4(t, n)), bt[e] && bt[e].forEach(function(r) {
      mb(r.name, r.config);
    }), en(e), e1[e];
  } else
    return delete e1[e], null;
}
function uL(e, n) {
  if (n != null) {
    var a, t, r = E6;
    e1[e] != null && e1[e].parentLocale != null ? e1[e].set(W4(e1[e]._config, n)) : (t = mr(e), t != null && (r = t._config), n = W4(r, n), t == null && (n.abbr = e), a = new sb(n), a.parentLocale = e1[e], e1[e] = a), en(e);
  } else
    e1[e] != null && (e1[e].parentLocale != null ? (e1[e] = e1[e].parentLocale, e === en() && en(e)) : e1[e] != null && delete e1[e]);
  return e1[e];
}
function ve(e) {
  var n;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return vt;
  if (!X2(e)) {
    if (n = mr(e), n)
      return n;
    e = [e];
  }
  return zL(e);
}
function AL() {
  return g4(e1);
}
function qb(e) {
  var n, a = e._a;
  return a && O0(e).overflow === -2 && (n = a[qe] < 0 || a[qe] > 11 ? qe : a[K2] < 1 || a[K2] > ub(a[D1], a[qe]) ? K2 : a[l1] < 0 || a[l1] > 24 || a[l1] === 24 && (a[w2] !== 0 || a[he] !== 0 || a[_n] !== 0) ? l1 : a[w2] < 0 || a[w2] > 59 ? w2 : a[he] < 0 || a[he] > 59 ? he : a[_n] < 0 || a[_n] > 999 ? _n : -1, O0(e)._overflowDayOfYear && (n < D1 || n > K2) && (n = K2), O0(e)._overflowWeeks && n === -1 && (n = q$), O0(e)._overflowWeekday && n === -1 && (n = h$), O0(e).overflow = n), e;
}
var lL = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, fL = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, mL = /Z|[+-]\d\d(?::?\d\d)?/, ao = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], RM = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], qL = /^\/?Date\((-?\d+)/i, hL = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, yL = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function X6(e) {
  var n, a, t = e._i, r = lL.exec(t) || fL.exec(t), M, b, d, c, O = ao.length, A = RM.length;
  if (r) {
    for (O0(e).iso = !0, n = 0, a = O; n < a; n++)
      if (ao[n][1].exec(r[1])) {
        b = ao[n][0], M = ao[n][2] !== !1;
        break;
      }
    if (b == null) {
      e._isValid = !1;
      return;
    }
    if (r[3]) {
      for (n = 0, a = A; n < a; n++)
        if (RM[n][1].exec(r[3])) {
          d = (r[2] || " ") + RM[n][0];
          break;
        }
      if (d == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!M && d != null) {
      e._isValid = !1;
      return;
    }
    if (r[4])
      if (mL.exec(r[4]))
        c = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = b + (d || "") + (c || ""), yb(e);
  } else
    e._isValid = !1;
}
function WL(e, n, a, t, r, M) {
  var b = [
    gL(e),
    _6.indexOf(n),
    parseInt(a, 10),
    parseInt(t, 10),
    parseInt(r, 10)
  ];
  return M && b.push(parseInt(M, 10)), b;
}
function gL(e) {
  var n = parseInt(e, 10);
  return n <= 49 ? 2e3 + n : n <= 999 ? 1900 + n : n;
}
function RL(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function $L(e, n, a) {
  if (e) {
    var t = B6.indexOf(e), r = new Date(
      n[0],
      n[1],
      n[2]
    ).getDay();
    if (t !== r)
      return O0(a).weekdayMismatch = !0, a._isValid = !1, !1;
  }
  return !0;
}
function LL(e, n, a) {
  if (e)
    return yL[e];
  if (n)
    return 0;
  var t = parseInt(a, 10), r = t % 100, M = (t - r) / 100;
  return M * 60 + r;
}
function P6(e) {
  var n = hL.exec(RL(e._i)), a;
  if (n) {
    if (a = WL(
      n[4],
      n[3],
      n[2],
      n[5],
      n[6],
      n[7]
    ), !$L(n[1], a, e))
      return;
    e._a = a, e._tzm = LL(n[8], n[9], n[10]), e._d = _t.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), O0(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function _L(e) {
  var n = qL.exec(e._i);
  if (n !== null) {
    e._d = /* @__PURE__ */ new Date(+n[1]);
    return;
  }
  if (X6(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (P6(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : I.createFromInputFallback(e);
}
I.createFromInputFallback = h2(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Aa(e, n, a) {
  return e ?? n ?? a;
}
function NL(e) {
  var n = new Date(I.now());
  return e._useUTC ? [
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate()
  ] : [n.getFullYear(), n.getMonth(), n.getDate()];
}
function hb(e) {
  var n, a, t = [], r, M, b;
  if (!e._d) {
    for (r = NL(e), e._w && e._a[K2] == null && e._a[qe] == null && vL(e), e._dayOfYear != null && (b = Aa(e._a[D1], r[D1]), (e._dayOfYear > Wt(b) || e._dayOfYear === 0) && (O0(e)._overflowDayOfYear = !0), a = _t(b, 0, e._dayOfYear), e._a[qe] = a.getUTCMonth(), e._a[K2] = a.getUTCDate()), n = 0; n < 3 && e._a[n] == null; ++n)
      e._a[n] = t[n] = r[n];
    for (; n < 7; n++)
      e._a[n] = t[n] = e._a[n] == null ? n === 2 ? 1 : 0 : e._a[n];
    e._a[l1] === 24 && e._a[w2] === 0 && e._a[he] === 0 && e._a[_n] === 0 && (e._nextDay = !0, e._a[l1] = 0), e._d = (e._useUTC ? _t : C$).apply(
      null,
      t
    ), M = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[l1] = 24), e._w && typeof e._w.d < "u" && e._w.d !== M && (O0(e).weekdayMismatch = !0);
  }
}
function vL(e) {
  var n, a, t, r, M, b, d, c, O;
  n = e._w, n.GG != null || n.W != null || n.E != null ? (M = 1, b = 4, a = Aa(
    n.GG,
    e._a[D1],
    Nt(K0(), 1, 4).year
  ), t = Aa(n.W, 1), r = Aa(n.E, 1), (r < 1 || r > 7) && (c = !0)) : (M = e._locale._week.dow, b = e._locale._week.doy, O = Nt(K0(), M, b), a = Aa(n.gg, e._a[D1], O.year), t = Aa(n.w, O.week), n.d != null ? (r = n.d, (r < 0 || r > 6) && (c = !0)) : n.e != null ? (r = n.e + M, (n.e < 0 || n.e > 6) && (c = !0)) : r = M), t < 1 || t > Re(a, M, b) ? O0(e)._overflowWeeks = !0 : c != null ? O0(e)._overflowWeekday = !0 : (d = S6(a, t, r, M, b), e._a[D1] = d.year, e._dayOfYear = d.dayOfYear);
}
I.ISO_8601 = function() {
};
I.RFC_2822 = function() {
};
function yb(e) {
  if (e._f === I.ISO_8601) {
    X6(e);
    return;
  }
  if (e._f === I.RFC_2822) {
    P6(e);
    return;
  }
  e._a = [], O0(e).empty = !0;
  var n = "" + e._i, a, t, r, M, b, d = n.length, c = 0, O, A;
  for (r = h6(e._f, e._locale).match(db) || [], A = r.length, a = 0; a < A; a++)
    M = r[a], t = (n.match(l$(M, e)) || [])[0], t && (b = n.substr(0, n.indexOf(t)), b.length > 0 && O0(e).unusedInput.push(b), n = n.slice(
      n.indexOf(t) + t.length
    ), c += t.length), ha[M] ? (t ? O0(e).empty = !1 : O0(e).unusedTokens.push(M), m$(M, t, e)) : e._strict && !t && O0(e).unusedTokens.push(M);
  O0(e).charsLeftOver = d - c, n.length > 0 && O0(e).unusedInput.push(n), e._a[l1] <= 12 && O0(e).bigHour === !0 && e._a[l1] > 0 && (O0(e).bigHour = void 0), O0(e).parsedDateParts = e._a.slice(0), O0(e).meridiem = e._meridiem, e._a[l1] = DL(
    e._locale,
    e._a[l1],
    e._meridiem
  ), O = O0(e).era, O !== null && (e._a[D1] = e._locale.erasConvertYear(O, e._a[D1])), hb(e), qb(e);
}
function DL(e, n, a) {
  var t;
  return a == null ? n : e.meridiemHour != null ? e.meridiemHour(n, a) : (e.isPM != null && (t = e.isPM(a), t && n < 12 && (n += 12), !t && n === 12 && (n = 0)), n);
}
function TL(e) {
  var n, a, t, r, M, b, d = !1, c = e._f.length;
  if (c === 0) {
    O0(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (r = 0; r < c; r++)
    M = 0, b = !1, n = bb({}, e), e._useUTC != null && (n._useUTC = e._useUTC), n._f = e._f[r], yb(n), Mb(n) && (b = !0), M += O0(n).charsLeftOver, M += O0(n).unusedTokens.length * 10, O0(n).score = M, d ? M < t && (t = M, a = n) : (t == null || M < t || b) && (t = M, a = n, b && (d = !0));
  Ke(e, a || n);
}
function SL(e) {
  if (!e._d) {
    var n = pb(e._i), a = n.day === void 0 ? n.date : n.day;
    e._a = f6(
      [n.year, n.month, a, n.hour, n.minute, n.second, n.millisecond],
      function(t) {
        return t && parseInt(t, 10);
      }
    ), hb(e);
  }
}
function BL(e) {
  var n = new It(qb(k6(e)));
  return n._nextDay && (n.add(1, "d"), n._nextDay = void 0), n;
}
function k6(e) {
  var n = e._i, a = e._f;
  return e._locale = e._locale || ve(e._l), n === null || a === void 0 && n === "" ? cr({ nullInput: !0 }) : (typeof n == "string" && (e._i = n = e._locale.preparse(n)), P2(n) ? new It(qb(n)) : (kt(n) ? e._d = n : X2(a) ? TL(e) : a ? yb(e) : wL(e), Mb(e) || (e._d = null), e));
}
function wL(e) {
  var n = e._i;
  H1(n) ? e._d = new Date(I.now()) : kt(n) ? e._d = new Date(n.valueOf()) : typeof n == "string" ? _L(e) : X2(n) ? (e._a = f6(n.slice(0), function(a) {
    return parseInt(a, 10);
  }), hb(e)) : Dn(n) ? SL(e) : _e(n) ? e._d = new Date(n) : I.createFromInputFallback(e);
}
function I6(e, n, a, t, r) {
  var M = {};
  return (n === !0 || n === !1) && (t = n, n = void 0), (a === !0 || a === !1) && (t = a, a = void 0), (Dn(e) && ib(e) || X2(e) && e.length === 0) && (e = void 0), M._isAMomentObject = !0, M._useUTC = M._isUTC = r, M._l = a, M._i = e, M._f = n, M._strict = t, BL(M);
}
function K0(e, n, a, t) {
  return I6(e, n, a, t, !1);
}
var CL = h2(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = K0.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : cr();
  }
), EL = h2(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = K0.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : cr();
  }
);
function x6(e, n) {
  var a, t;
  if (n.length === 1 && X2(n[0]) && (n = n[0]), !n.length)
    return K0();
  for (a = n[0], t = 1; t < n.length; ++t)
    (!n[t].isValid() || n[t][e](a)) && (a = n[t]);
  return a;
}
function XL() {
  var e = [].slice.call(arguments, 0);
  return x6("isBefore", e);
}
function PL() {
  var e = [].slice.call(arguments, 0);
  return x6("isAfter", e);
}
var kL = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, st = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function IL(e) {
  var n, a = !1, t, r = st.length;
  for (n in e)
    if (B0(e, n) && !(s1.call(st, n) !== -1 && (e[n] == null || !isNaN(e[n]))))
      return !1;
  for (t = 0; t < r; ++t)
    if (e[st[t]]) {
      if (a)
        return !1;
      parseFloat(e[st[t]]) !== $0(e[st[t]]) && (a = !0);
    }
  return !0;
}
function xL() {
  return this._isValid;
}
function FL() {
  return x2(NaN);
}
function qr(e) {
  var n = pb(e), a = n.year || 0, t = n.quarter || 0, r = n.month || 0, M = n.week || n.isoWeek || 0, b = n.day || 0, d = n.hour || 0, c = n.minute || 0, O = n.second || 0, A = n.millisecond || 0;
  this._isValid = IL(n), this._milliseconds = +A + O * 1e3 + // 1000
  c * 6e4 + // 1000 * 60
  d * 1e3 * 60 * 60, this._days = +b + M * 7, this._months = +r + t * 3 + a * 12, this._data = {}, this._locale = ve(), this._bubble();
}
function ho(e) {
  return e instanceof qr;
}
function $4(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function HL(e, n, a) {
  var t = Math.min(e.length, n.length), r = Math.abs(e.length - n.length), M = 0, b;
  for (b = 0; b < t; b++)
    $0(e[b]) !== $0(n[b]) && M++;
  return M + r;
}
function F6(e, n) {
  Z(e, 0, 0, function() {
    var a = this.utcOffset(), t = "+";
    return a < 0 && (a = -a, t = "-"), t + Q2(~~(a / 60), 2) + n + Q2(~~a % 60, 2);
  });
}
F6("Z", ":");
F6("ZZ", "");
j("Z", lr);
j("ZZ", lr);
F0(["Z", "ZZ"], function(e, n, a) {
  a._useUTC = !0, a._tzm = Wb(lr, e);
});
var UL = /([\+\-]|\d\d)/gi;
function Wb(e, n) {
  var a = (n || "").match(e), t, r, M;
  return a === null ? null : (t = a[a.length - 1] || [], r = (t + "").match(UL) || ["-", 0, 0], M = +(r[1] * 60) + $0(r[2]), M === 0 ? 0 : r[0] === "+" ? M : -M);
}
function gb(e, n) {
  var a, t;
  return n._isUTC ? (a = n.clone(), t = (P2(e) || kt(e) ? e.valueOf() : K0(e).valueOf()) - a.valueOf(), a._d.setTime(a._d.valueOf() + t), I.updateOffset(a, !1), a) : K0(e).local();
}
function L4(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
I.updateOffset = function() {
};
function jL(e, n, a) {
  var t = this._offset || 0, r;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Wb(lr, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !a && (e = e * 60);
    return !this._isUTC && n && (r = L4(this)), this._offset = e, this._isUTC = !0, r != null && this.add(r, "m"), t !== e && (!n || this._changeInProgress ? j6(
      this,
      x2(e - t, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, I.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? t : L4(this);
}
function GL(e, n) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, n), this) : -this.utcOffset();
}
function VL(e) {
  return this.utcOffset(0, e);
}
function YL(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(L4(this), "m")), this;
}
function JL() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Wb(u$, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function KL(e) {
  return this.isValid() ? (e = e ? K0(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function ZL() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function QL() {
  if (!H1(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, n;
  return bb(e, this), e = k6(e), e._a ? (n = e._isUTC ? ee(e._a) : K0(e._a), this._isDSTShifted = this.isValid() && HL(e._a, n.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function e_() {
  return this.isValid() ? !this._isUTC : !1;
}
function n_() {
  return this.isValid() ? this._isUTC : !1;
}
function H6() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var a_ = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, t_ = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function x2(e, n) {
  var a = e, t = null, r, M, b;
  return ho(e) ? a = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : _e(e) || !isNaN(+e) ? (a = {}, n ? a[n] = +e : a.milliseconds = +e) : (t = a_.exec(e)) ? (r = t[1] === "-" ? -1 : 1, a = {
    y: 0,
    d: $0(t[K2]) * r,
    h: $0(t[l1]) * r,
    m: $0(t[w2]) * r,
    s: $0(t[he]) * r,
    ms: $0($4(t[_n] * 1e3)) * r
    // the millisecond decimal point is included in the match
  }) : (t = t_.exec(e)) ? (r = t[1] === "-" ? -1 : 1, a = {
    y: hn(t[2], r),
    M: hn(t[3], r),
    w: hn(t[4], r),
    d: hn(t[5], r),
    h: hn(t[6], r),
    m: hn(t[7], r),
    s: hn(t[8], r)
  }) : a == null ? a = {} : typeof a == "object" && ("from" in a || "to" in a) && (b = o_(
    K0(a.from),
    K0(a.to)
  ), a = {}, a.ms = b.milliseconds, a.M = b.months), M = new qr(a), ho(e) && B0(e, "_locale") && (M._locale = e._locale), ho(e) && B0(e, "_isValid") && (M._isValid = e._isValid), M;
}
x2.fn = qr.prototype;
x2.invalid = FL;
function hn(e, n) {
  var a = e && parseFloat(e.replace(",", "."));
  return (isNaN(a) ? 0 : a) * n;
}
function Yc(e, n) {
  var a = {};
  return a.months = n.month() - e.month() + (n.year() - e.year()) * 12, e.clone().add(a.months, "M").isAfter(n) && --a.months, a.milliseconds = +n - +e.clone().add(a.months, "M"), a;
}
function o_(e, n) {
  var a;
  return e.isValid() && n.isValid() ? (n = gb(n, e), e.isBefore(n) ? a = Yc(e, n) : (a = Yc(n, e), a.milliseconds = -a.milliseconds, a.months = -a.months), a) : { milliseconds: 0, months: 0 };
}
function U6(e, n) {
  return function(a, t) {
    var r, M;
    return t !== null && !isNaN(+t) && (q6(
      n,
      "moment()." + n + "(period, number) is deprecated. Please use moment()." + n + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), M = a, a = t, t = M), r = x2(a, t), j6(this, r, e), this;
  };
}
function j6(e, n, a, t) {
  var r = n._milliseconds, M = $4(n._days), b = $4(n._months);
  e.isValid() && (t = t ?? !0, b && v6(e, Lt(e, "Month") + b * a), M && L6(e, "Date", Lt(e, "Date") + M * a), r && e._d.setTime(e._d.valueOf() + r * a), t && I.updateOffset(e, M || b));
}
var r_ = U6(1, "add"), i_ = U6(-1, "subtract");
function G6(e) {
  return typeof e == "string" || e instanceof String;
}
function M_(e) {
  return P2(e) || kt(e) || G6(e) || _e(e) || s_(e) || b_(e) || e === null || e === void 0;
}
function b_(e) {
  var n = Dn(e) && !ib(e), a = !1, t = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], r, M, b = t.length;
  for (r = 0; r < b; r += 1)
    M = t[r], a = a || B0(e, M);
  return n && a;
}
function s_(e) {
  var n = X2(e), a = !1;
  return n && (a = e.filter(function(t) {
    return !_e(t) && G6(e);
  }).length === 0), n && a;
}
function d_(e) {
  var n = Dn(e) && !ib(e), a = !1, t = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], r, M;
  for (r = 0; r < t.length; r += 1)
    M = t[r], a = a || B0(e, M);
  return n && a;
}
function p_(e, n) {
  var a = e.diff(n, "days", !0);
  return a < -6 ? "sameElse" : a < -1 ? "lastWeek" : a < 0 ? "lastDay" : a < 1 ? "sameDay" : a < 2 ? "nextDay" : a < 7 ? "nextWeek" : "sameElse";
}
function c_(e, n) {
  arguments.length === 1 && (arguments[0] ? M_(arguments[0]) ? (e = arguments[0], n = void 0) : d_(arguments[0]) && (n = arguments[0], e = void 0) : (e = void 0, n = void 0));
  var a = e || K0(), t = gb(a, this).startOf("day"), r = I.calendarFormat(this, t) || "sameElse", M = n && (ne(n[r]) ? n[r].call(this, a) : n[r]);
  return this.format(
    M || this.localeData().calendar(r, this, K0(a))
  );
}
function z_() {
  return new It(this);
}
function O_(e, n) {
  var a = P2(e) ? e : K0(e);
  return this.isValid() && a.isValid() ? (n = y2(n) || "millisecond", n === "millisecond" ? this.valueOf() > a.valueOf() : a.valueOf() < this.clone().startOf(n).valueOf()) : !1;
}
function u_(e, n) {
  var a = P2(e) ? e : K0(e);
  return this.isValid() && a.isValid() ? (n = y2(n) || "millisecond", n === "millisecond" ? this.valueOf() < a.valueOf() : this.clone().endOf(n).valueOf() < a.valueOf()) : !1;
}
function A_(e, n, a, t) {
  var r = P2(e) ? e : K0(e), M = P2(n) ? n : K0(n);
  return this.isValid() && r.isValid() && M.isValid() ? (t = t || "()", (t[0] === "(" ? this.isAfter(r, a) : !this.isBefore(r, a)) && (t[1] === ")" ? this.isBefore(M, a) : !this.isAfter(M, a))) : !1;
}
function l_(e, n) {
  var a = P2(e) ? e : K0(e), t;
  return this.isValid() && a.isValid() ? (n = y2(n) || "millisecond", n === "millisecond" ? this.valueOf() === a.valueOf() : (t = a.valueOf(), this.clone().startOf(n).valueOf() <= t && t <= this.clone().endOf(n).valueOf())) : !1;
}
function f_(e, n) {
  return this.isSame(e, n) || this.isAfter(e, n);
}
function m_(e, n) {
  return this.isSame(e, n) || this.isBefore(e, n);
}
function q_(e, n, a) {
  var t, r, M;
  if (!this.isValid())
    return NaN;
  if (t = gb(e, this), !t.isValid())
    return NaN;
  switch (r = (t.utcOffset() - this.utcOffset()) * 6e4, n = y2(n), n) {
    case "year":
      M = yo(this, t) / 12;
      break;
    case "month":
      M = yo(this, t);
      break;
    case "quarter":
      M = yo(this, t) / 3;
      break;
    case "second":
      M = (this - t) / 1e3;
      break;
    case "minute":
      M = (this - t) / 6e4;
      break;
    case "hour":
      M = (this - t) / 36e5;
      break;
    case "day":
      M = (this - t - r) / 864e5;
      break;
    case "week":
      M = (this - t - r) / 6048e5;
      break;
    default:
      M = this - t;
  }
  return a ? M : f2(M);
}
function yo(e, n) {
  if (e.date() < n.date())
    return -yo(n, e);
  var a = (n.year() - e.year()) * 12 + (n.month() - e.month()), t = e.clone().add(a, "months"), r, M;
  return n - t < 0 ? (r = e.clone().add(a - 1, "months"), M = (n - t) / (t - r)) : (r = e.clone().add(a + 1, "months"), M = (n - t) / (r - t)), -(a + M) || 0;
}
I.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
I.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function h_() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function y_(e) {
  if (!this.isValid())
    return null;
  var n = e !== !0, a = n ? this.clone().utc() : this;
  return a.year() < 0 || a.year() > 9999 ? qo(
    a,
    n ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : ne(Date.prototype.toISOString) ? n ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", qo(a, "Z")) : qo(
    a,
    n ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function W_() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", n = "", a, t, r, M;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", n = "Z"), a = "[" + e + '("]', t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", r = "-MM-DD[T]HH:mm:ss.SSS", M = n + '[")]', this.format(a + t + r + M);
}
function g_(e) {
  e || (e = this.isUtc() ? I.defaultFormatUtc : I.defaultFormat);
  var n = qo(this, e);
  return this.localeData().postformat(n);
}
function R_(e, n) {
  return this.isValid() && (P2(e) && e.isValid() || K0(e).isValid()) ? x2({ to: this, from: e }).locale(this.locale()).humanize(!n) : this.localeData().invalidDate();
}
function $_(e) {
  return this.from(K0(), e);
}
function L_(e, n) {
  return this.isValid() && (P2(e) && e.isValid() || K0(e).isValid()) ? x2({ from: this, to: e }).locale(this.locale()).humanize(!n) : this.localeData().invalidDate();
}
function __(e) {
  return this.to(K0(), e);
}
function V6(e) {
  var n;
  return e === void 0 ? this._locale._abbr : (n = ve(e), n != null && (this._locale = n), this);
}
var Y6 = h2(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function J6() {
  return this._locale;
}
var Po = 1e3, ya = 60 * Po, ko = 60 * ya, K6 = (365 * 400 + 97) * 24 * ko;
function Wa(e, n) {
  return (e % n + n) % n;
}
function Z6(e, n, a) {
  return e < 100 && e >= 0 ? new Date(e + 400, n, a) - K6 : new Date(e, n, a).valueOf();
}
function Q6(e, n, a) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, n, a) - K6 : Date.UTC(e, n, a);
}
function N_(e) {
  var n, a;
  if (e = y2(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (a = this._isUTC ? Q6 : Z6, e) {
    case "year":
      n = a(this.year(), 0, 1);
      break;
    case "quarter":
      n = a(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      n = a(this.year(), this.month(), 1);
      break;
    case "week":
      n = a(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      n = a(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      n = a(this.year(), this.month(), this.date());
      break;
    case "hour":
      n = this._d.valueOf(), n -= Wa(
        n + (this._isUTC ? 0 : this.utcOffset() * ya),
        ko
      );
      break;
    case "minute":
      n = this._d.valueOf(), n -= Wa(n, ya);
      break;
    case "second":
      n = this._d.valueOf(), n -= Wa(n, Po);
      break;
  }
  return this._d.setTime(n), I.updateOffset(this, !0), this;
}
function v_(e) {
  var n, a;
  if (e = y2(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (a = this._isUTC ? Q6 : Z6, e) {
    case "year":
      n = a(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      n = a(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      n = a(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      n = a(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      n = a(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      n = a(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      n = this._d.valueOf(), n += ko - Wa(
        n + (this._isUTC ? 0 : this.utcOffset() * ya),
        ko
      ) - 1;
      break;
    case "minute":
      n = this._d.valueOf(), n += ya - Wa(n, ya) - 1;
      break;
    case "second":
      n = this._d.valueOf(), n += Po - Wa(n, Po) - 1;
      break;
  }
  return this._d.setTime(n), I.updateOffset(this, !0), this;
}
function D_() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function T_() {
  return Math.floor(this.valueOf() / 1e3);
}
function S_() {
  return new Date(this.valueOf());
}
function B_() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function w_() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function C_() {
  return this.isValid() ? this.toISOString() : null;
}
function E_() {
  return Mb(this);
}
function X_() {
  return Ke({}, O0(this));
}
function P_() {
  return O0(this).overflow;
}
function k_() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
Z("N", 0, 0, "eraAbbr");
Z("NN", 0, 0, "eraAbbr");
Z("NNN", 0, 0, "eraAbbr");
Z("NNNN", 0, 0, "eraName");
Z("NNNNN", 0, 0, "eraNarrow");
Z("y", ["y", 1], "yo", "eraYear");
Z("y", ["yy", 2], 0, "eraYear");
Z("y", ["yyy", 3], 0, "eraYear");
Z("y", ["yyyy", 4], 0, "eraYear");
j("N", Rb);
j("NN", Rb);
j("NNN", Rb);
j("NNNN", K_);
j("NNNNN", Z_);
F0(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, n, a, t) {
    var r = a._locale.erasParse(e, t, a._strict);
    r ? O0(a).era = r : O0(a).invalidEra = e;
  }
);
j("y", Ea);
j("yy", Ea);
j("yyy", Ea);
j("yyyy", Ea);
j("yo", Q_);
F0(["y", "yy", "yyy", "yyyy"], D1);
F0(["yo"], function(e, n, a, t) {
  var r;
  a._locale._eraYearOrdinalRegex && (r = e.match(a._locale._eraYearOrdinalRegex)), a._locale.eraYearOrdinalParse ? n[D1] = a._locale.eraYearOrdinalParse(e, r) : n[D1] = parseInt(e, 10);
});
function I_(e, n) {
  var a, t, r, M = this._eras || ve("en")._eras;
  for (a = 0, t = M.length; a < t; ++a) {
    switch (typeof M[a].since) {
      case "string":
        r = I(M[a].since).startOf("day"), M[a].since = r.valueOf();
        break;
    }
    switch (typeof M[a].until) {
      case "undefined":
        M[a].until = 1 / 0;
        break;
      case "string":
        r = I(M[a].until).startOf("day").valueOf(), M[a].until = r.valueOf();
        break;
    }
  }
  return M;
}
function x_(e, n, a) {
  var t, r, M = this.eras(), b, d, c;
  for (e = e.toUpperCase(), t = 0, r = M.length; t < r; ++t)
    if (b = M[t].name.toUpperCase(), d = M[t].abbr.toUpperCase(), c = M[t].narrow.toUpperCase(), a)
      switch (n) {
        case "N":
        case "NN":
        case "NNN":
          if (d === e)
            return M[t];
          break;
        case "NNNN":
          if (b === e)
            return M[t];
          break;
        case "NNNNN":
          if (c === e)
            return M[t];
          break;
      }
    else if ([b, d, c].indexOf(e) >= 0)
      return M[t];
}
function F_(e, n) {
  var a = e.since <= e.until ? 1 : -1;
  return n === void 0 ? I(e.since).year() : I(e.since).year() + (n - e.offset) * a;
}
function H_() {
  var e, n, a, t = this.localeData().eras();
  for (e = 0, n = t.length; e < n; ++e)
    if (a = this.clone().startOf("day").valueOf(), t[e].since <= a && a <= t[e].until || t[e].until <= a && a <= t[e].since)
      return t[e].name;
  return "";
}
function U_() {
  var e, n, a, t = this.localeData().eras();
  for (e = 0, n = t.length; e < n; ++e)
    if (a = this.clone().startOf("day").valueOf(), t[e].since <= a && a <= t[e].until || t[e].until <= a && a <= t[e].since)
      return t[e].narrow;
  return "";
}
function j_() {
  var e, n, a, t = this.localeData().eras();
  for (e = 0, n = t.length; e < n; ++e)
    if (a = this.clone().startOf("day").valueOf(), t[e].since <= a && a <= t[e].until || t[e].until <= a && a <= t[e].since)
      return t[e].abbr;
  return "";
}
function G_() {
  var e, n, a, t, r = this.localeData().eras();
  for (e = 0, n = r.length; e < n; ++e)
    if (a = r[e].since <= r[e].until ? 1 : -1, t = this.clone().startOf("day").valueOf(), r[e].since <= t && t <= r[e].until || r[e].until <= t && t <= r[e].since)
      return (this.year() - I(r[e].since).year()) * a + r[e].offset;
  return this.year();
}
function V_(e) {
  return B0(this, "_erasNameRegex") || $b.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Y_(e) {
  return B0(this, "_erasAbbrRegex") || $b.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function J_(e) {
  return B0(this, "_erasNarrowRegex") || $b.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Rb(e, n) {
  return n.erasAbbrRegex(e);
}
function K_(e, n) {
  return n.erasNameRegex(e);
}
function Z_(e, n) {
  return n.erasNarrowRegex(e);
}
function Q_(e, n) {
  return n._eraYearOrdinalRegex || Ea;
}
function $b() {
  var e = [], n = [], a = [], t = [], r, M, b, d, c, O = this.eras();
  for (r = 0, M = O.length; r < M; ++r)
    b = ge(O[r].name), d = ge(O[r].abbr), c = ge(O[r].narrow), n.push(b), e.push(d), a.push(c), t.push(b), t.push(d), t.push(c);
  this._erasRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  );
}
Z(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
Z(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function hr(e, n) {
  Z(0, [e, e.length], 0, n);
}
hr("gggg", "weekYear");
hr("ggggg", "weekYear");
hr("GGGG", "isoWeekYear");
hr("GGGGG", "isoWeekYear");
j("G", Ar);
j("g", Ar);
j("GG", Z0, t2);
j("gg", Z0, t2);
j("GGGG", zb, cb);
j("gggg", zb, cb);
j("GGGGG", ur, zr);
j("ggggg", ur, zr);
Ft(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, n, a, t) {
    n[t.substr(0, 2)] = $0(e);
  }
);
Ft(["gg", "GG"], function(e, n, a, t) {
  n[t] = I.parseTwoDigitYear(e);
});
function eN(e) {
  return eO.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function nN(e) {
  return eO.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function aN() {
  return Re(this.year(), 1, 4);
}
function tN() {
  return Re(this.isoWeekYear(), 1, 4);
}
function oN() {
  var e = this.localeData()._week;
  return Re(this.year(), e.dow, e.doy);
}
function rN() {
  var e = this.localeData()._week;
  return Re(this.weekYear(), e.dow, e.doy);
}
function eO(e, n, a, t, r) {
  var M;
  return e == null ? Nt(this, t, r).year : (M = Re(e, t, r), n > M && (n = M), iN.call(this, e, n, a, t, r));
}
function iN(e, n, a, t, r) {
  var M = S6(e, n, a, t, r), b = _t(M.year, 0, M.dayOfYear);
  return this.year(b.getUTCFullYear()), this.month(b.getUTCMonth()), this.date(b.getUTCDate()), this;
}
Z("Q", 0, "Qo", "quarter");
j("Q", y6);
F0("Q", function(e, n) {
  n[qe] = ($0(e) - 1) * 3;
});
function MN(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
Z("D", ["DD", 2], "Do", "date");
j("D", Z0, Xa);
j("DD", Z0, t2);
j("Do", function(e, n) {
  return e ? n._dayOfMonthOrdinalParse || n._ordinalParse : n._dayOfMonthOrdinalParseLenient;
});
F0(["D", "DD"], K2);
F0("Do", function(e, n) {
  n[K2] = $0(e.match(Z0)[0]);
});
var nO = Pa("Date", !0);
Z("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
j("DDD", Or);
j("DDDD", W6);
F0(["DDD", "DDDD"], function(e, n, a) {
  a._dayOfYear = $0(e);
});
function bN(e) {
  var n = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? n : this.add(e - n, "d");
}
Z("m", ["mm", 2], 0, "minute");
j("m", Z0, Ob);
j("mm", Z0, t2);
F0(["m", "mm"], w2);
var sN = Pa("Minutes", !1);
Z("s", ["ss", 2], 0, "second");
j("s", Z0, Ob);
j("ss", Z0, t2);
F0(["s", "ss"], he);
var dN = Pa("Seconds", !1);
Z("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
Z(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
Z(0, ["SSS", 3], 0, "millisecond");
Z(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
Z(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
Z(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
Z(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
Z(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
Z(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
j("S", Or, y6);
j("SS", Or, t2);
j("SSS", Or, W6);
var Ze, aO;
for (Ze = "SSSS"; Ze.length <= 9; Ze += "S")
  j(Ze, Ea);
function pN(e, n) {
  n[_n] = $0(("0." + e) * 1e3);
}
for (Ze = "S"; Ze.length <= 9; Ze += "S")
  F0(Ze, pN);
aO = Pa("Milliseconds", !1);
Z("z", 0, 0, "zoneAbbr");
Z("zz", 0, 0, "zoneName");
function cN() {
  return this._isUTC ? "UTC" : "";
}
function zN() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var X = It.prototype;
X.add = r_;
X.calendar = c_;
X.clone = z_;
X.diff = q_;
X.endOf = v_;
X.format = g_;
X.from = R_;
X.fromNow = $_;
X.to = L_;
X.toNow = __;
X.get = W$;
X.invalidAt = P_;
X.isAfter = O_;
X.isBefore = u_;
X.isBetween = A_;
X.isSame = l_;
X.isSameOrAfter = f_;
X.isSameOrBefore = m_;
X.isValid = E_;
X.lang = Y6;
X.locale = V6;
X.localeData = J6;
X.max = EL;
X.min = CL;
X.parsingFlags = X_;
X.set = g$;
X.startOf = N_;
X.subtract = i_;
X.toArray = B_;
X.toObject = w_;
X.toDate = S_;
X.toISOString = y_;
X.inspect = W_;
typeof Symbol < "u" && Symbol.for != null && (X[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
X.toJSON = C_;
X.toString = h_;
X.unix = T_;
X.valueOf = D_;
X.creationData = k_;
X.eraName = H_;
X.eraNarrow = U_;
X.eraAbbr = j_;
X.eraYear = G_;
X.year = $6;
X.isLeapYear = y$;
X.weekYear = eN;
X.isoWeekYear = nN;
X.quarter = X.quarters = MN;
X.month = D6;
X.daysInMonth = S$;
X.week = X.weeks = I$;
X.isoWeek = X.isoWeeks = x$;
X.weeksInYear = oN;
X.weeksInWeekYear = rN;
X.isoWeeksInYear = aN;
X.isoWeeksInISOWeekYear = tN;
X.date = nO;
X.day = X.days = nL;
X.weekday = aL;
X.isoWeekday = tL;
X.dayOfYear = bN;
X.hour = X.hours = dL;
X.minute = X.minutes = sN;
X.second = X.seconds = dN;
X.millisecond = X.milliseconds = aO;
X.utcOffset = jL;
X.utc = VL;
X.local = YL;
X.parseZone = JL;
X.hasAlignedHourOffset = KL;
X.isDST = ZL;
X.isLocal = e_;
X.isUtcOffset = n_;
X.isUtc = H6;
X.isUTC = H6;
X.zoneAbbr = cN;
X.zoneName = zN;
X.dates = h2(
  "dates accessor is deprecated. Use date instead.",
  nO
);
X.months = h2(
  "months accessor is deprecated. Use month instead",
  D6
);
X.years = h2(
  "years accessor is deprecated. Use year instead",
  $6
);
X.zone = h2(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  GL
);
X.isDSTShifted = h2(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  QL
);
function ON(e) {
  return K0(e * 1e3);
}
function uN() {
  return K0.apply(null, arguments).parseZone();
}
function tO(e) {
  return e;
}
var w0 = sb.prototype;
w0.calendar = e$;
w0.longDateFormat = o$;
w0.invalidDate = i$;
w0.ordinal = s$;
w0.preparse = tO;
w0.postformat = tO;
w0.relativeTime = p$;
w0.pastFuture = c$;
w0.set = ZR;
w0.eras = I_;
w0.erasParse = x_;
w0.erasConvertYear = F_;
w0.erasAbbrRegex = Y_;
w0.erasNameRegex = V_;
w0.erasNarrowRegex = J_;
w0.months = N$;
w0.monthsShort = v$;
w0.monthsParse = T$;
w0.monthsRegex = w$;
w0.monthsShortRegex = B$;
w0.week = E$;
w0.firstDayOfYear = k$;
w0.firstDayOfWeek = P$;
w0.weekdays = J$;
w0.weekdaysMin = Z$;
w0.weekdaysShort = K$;
w0.weekdaysParse = eL;
w0.weekdaysRegex = oL;
w0.weekdaysShortRegex = rL;
w0.weekdaysMinRegex = iL;
w0.isPM = bL;
w0.meridiem = pL;
function Io(e, n, a, t) {
  var r = ve(), M = ee().set(t, n);
  return r[a](M, e);
}
function oO(e, n, a) {
  if (_e(e) && (n = e, e = void 0), e = e || "", n != null)
    return Io(e, n, a, "month");
  var t, r = [];
  for (t = 0; t < 12; t++)
    r[t] = Io(e, t, a, "month");
  return r;
}
function Lb(e, n, a, t) {
  typeof e == "boolean" ? (_e(n) && (a = n, n = void 0), n = n || "") : (n = e, a = n, e = !1, _e(n) && (a = n, n = void 0), n = n || "");
  var r = ve(), M = e ? r._week.dow : 0, b, d = [];
  if (a != null)
    return Io(n, (a + M) % 7, t, "day");
  for (b = 0; b < 7; b++)
    d[b] = Io(n, (b + M) % 7, t, "day");
  return d;
}
function AN(e, n) {
  return oO(e, n, "months");
}
function lN(e, n) {
  return oO(e, n, "monthsShort");
}
function fN(e, n, a) {
  return Lb(e, n, a, "weekdays");
}
function mN(e, n, a) {
  return Lb(e, n, a, "weekdaysShort");
}
function qN(e, n, a) {
  return Lb(e, n, a, "weekdaysMin");
}
en("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var n = e % 10, a = $0(e % 100 / 10) === 1 ? "th" : n === 1 ? "st" : n === 2 ? "nd" : n === 3 ? "rd" : "th";
    return e + a;
  }
});
I.lang = h2(
  "moment.lang is deprecated. Use moment.locale instead.",
  en
);
I.langData = h2(
  "moment.langData is deprecated. Use moment.localeData instead.",
  ve
);
var ue = Math.abs;
function hN() {
  var e = this._data;
  return this._milliseconds = ue(this._milliseconds), this._days = ue(this._days), this._months = ue(this._months), e.milliseconds = ue(e.milliseconds), e.seconds = ue(e.seconds), e.minutes = ue(e.minutes), e.hours = ue(e.hours), e.months = ue(e.months), e.years = ue(e.years), this;
}
function rO(e, n, a, t) {
  var r = x2(n, a);
  return e._milliseconds += t * r._milliseconds, e._days += t * r._days, e._months += t * r._months, e._bubble();
}
function yN(e, n) {
  return rO(this, e, n, 1);
}
function WN(e, n) {
  return rO(this, e, n, -1);
}
function Jc(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function gN() {
  var e = this._milliseconds, n = this._days, a = this._months, t = this._data, r, M, b, d, c;
  return e >= 0 && n >= 0 && a >= 0 || e <= 0 && n <= 0 && a <= 0 || (e += Jc(_4(a) + n) * 864e5, n = 0, a = 0), t.milliseconds = e % 1e3, r = f2(e / 1e3), t.seconds = r % 60, M = f2(r / 60), t.minutes = M % 60, b = f2(M / 60), t.hours = b % 24, n += f2(b / 24), c = f2(iO(n)), a += c, n -= Jc(_4(c)), d = f2(a / 12), a %= 12, t.days = n, t.months = a, t.years = d, this;
}
function iO(e) {
  return e * 4800 / 146097;
}
function _4(e) {
  return e * 146097 / 4800;
}
function RN(e) {
  if (!this.isValid())
    return NaN;
  var n, a, t = this._milliseconds;
  if (e = y2(e), e === "month" || e === "quarter" || e === "year")
    switch (n = this._days + t / 864e5, a = this._months + iO(n), e) {
      case "month":
        return a;
      case "quarter":
        return a / 3;
      case "year":
        return a / 12;
    }
  else
    switch (n = this._days + Math.round(_4(this._months)), e) {
      case "week":
        return n / 7 + t / 6048e5;
      case "day":
        return n + t / 864e5;
      case "hour":
        return n * 24 + t / 36e5;
      case "minute":
        return n * 1440 + t / 6e4;
      case "second":
        return n * 86400 + t / 1e3;
      case "millisecond":
        return Math.floor(n * 864e5) + t;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function De(e) {
  return function() {
    return this.as(e);
  };
}
var MO = De("ms"), $N = De("s"), LN = De("m"), _N = De("h"), NN = De("d"), vN = De("w"), DN = De("M"), TN = De("Q"), SN = De("y"), BN = MO;
function wN() {
  return x2(this);
}
function CN(e) {
  return e = y2(e), this.isValid() ? this[e + "s"]() : NaN;
}
function kn(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var EN = kn("milliseconds"), XN = kn("seconds"), PN = kn("minutes"), kN = kn("hours"), IN = kn("days"), xN = kn("months"), FN = kn("years");
function HN() {
  return f2(this.days() / 7);
}
var le = Math.round, ma = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function UN(e, n, a, t, r) {
  return r.relativeTime(n || 1, !!a, e, t);
}
function jN(e, n, a, t) {
  var r = x2(e).abs(), M = le(r.as("s")), b = le(r.as("m")), d = le(r.as("h")), c = le(r.as("d")), O = le(r.as("M")), A = le(r.as("w")), m = le(r.as("y")), q = M <= a.ss && ["s", M] || M < a.s && ["ss", M] || b <= 1 && ["m"] || b < a.m && ["mm", b] || d <= 1 && ["h"] || d < a.h && ["hh", d] || c <= 1 && ["d"] || c < a.d && ["dd", c];
  return a.w != null && (q = q || A <= 1 && ["w"] || A < a.w && ["ww", A]), q = q || O <= 1 && ["M"] || O < a.M && ["MM", O] || m <= 1 && ["y"] || ["yy", m], q[2] = n, q[3] = +e > 0, q[4] = t, UN.apply(null, q);
}
function GN(e) {
  return e === void 0 ? le : typeof e == "function" ? (le = e, !0) : !1;
}
function VN(e, n) {
  return ma[e] === void 0 ? !1 : n === void 0 ? ma[e] : (ma[e] = n, e === "s" && (ma.ss = n - 1), !0);
}
function YN(e, n) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var a = !1, t = ma, r, M;
  return typeof e == "object" && (n = e, e = !1), typeof e == "boolean" && (a = e), typeof n == "object" && (t = Object.assign({}, ma, n), n.s != null && n.ss == null && (t.ss = n.s - 1)), r = this.localeData(), M = jN(this, !a, t, r), a && (M = r.pastFuture(+this, M)), r.postformat(M);
}
var $M = Math.abs;
function da(e) {
  return (e > 0) - (e < 0) || +e;
}
function yr() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = $M(this._milliseconds) / 1e3, n = $M(this._days), a = $M(this._months), t, r, M, b, d = this.asSeconds(), c, O, A, m;
  return d ? (t = f2(e / 60), r = f2(t / 60), e %= 60, t %= 60, M = f2(a / 12), a %= 12, b = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", c = d < 0 ? "-" : "", O = da(this._months) !== da(d) ? "-" : "", A = da(this._days) !== da(d) ? "-" : "", m = da(this._milliseconds) !== da(d) ? "-" : "", c + "P" + (M ? O + M + "Y" : "") + (a ? O + a + "M" : "") + (n ? A + n + "D" : "") + (r || t || e ? "T" : "") + (r ? m + r + "H" : "") + (t ? m + t + "M" : "") + (e ? m + b + "S" : "")) : "P0D";
}
var T0 = qr.prototype;
T0.isValid = xL;
T0.abs = hN;
T0.add = yN;
T0.subtract = WN;
T0.as = RN;
T0.asMilliseconds = MO;
T0.asSeconds = $N;
T0.asMinutes = LN;
T0.asHours = _N;
T0.asDays = NN;
T0.asWeeks = vN;
T0.asMonths = DN;
T0.asQuarters = TN;
T0.asYears = SN;
T0.valueOf = BN;
T0._bubble = gN;
T0.clone = wN;
T0.get = CN;
T0.milliseconds = EN;
T0.seconds = XN;
T0.minutes = PN;
T0.hours = kN;
T0.days = IN;
T0.weeks = HN;
T0.months = xN;
T0.years = FN;
T0.humanize = YN;
T0.toISOString = yr;
T0.toString = yr;
T0.toJSON = yr;
T0.locale = V6;
T0.localeData = J6;
T0.toIsoString = h2(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  yr
);
T0.lang = Y6;
Z("X", 0, 0, "unix");
Z("x", 0, 0, "valueOf");
j("x", Ar);
j("X", A$);
F0("X", function(e, n, a) {
  a._d = new Date(parseFloat(e) * 1e3);
});
F0("x", function(e, n, a) {
  a._d = new Date($0(e));
});
//! moment.js
I.version = "2.30.1";
JR(K0);
I.fn = X;
I.min = XL;
I.max = PL;
I.now = kL;
I.utc = ee;
I.unix = ON;
I.months = AN;
I.isDate = kt;
I.locale = en;
I.invalid = cr;
I.duration = x2;
I.isMoment = P2;
I.weekdays = fN;
I.parseZone = uN;
I.localeData = ve;
I.isDuration = ho;
I.monthsShort = lN;
I.weekdaysMin = qN;
I.defineLocale = mb;
I.updateLocale = uL;
I.locales = AL;
I.weekdaysShort = mN;
I.normalizeUnits = y2;
I.relativeTimeRounding = GN;
I.relativeTimeThreshold = VN;
I.calendarFormat = p_;
I.prototype = X;
I.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const JN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I
}, Symbol.toStringTag, { value: "Module" })), KN = /* @__PURE__ */ SW(JN);
(function(e) {
  //! moment-timezone.js
  //! version : 0.5.46
  //! Copyright (c) JS Foundation and other contributors
  //! license : MIT
  //! github.com/moment/moment-timezone
  (function(n, a) {
    e.exports ? e.exports = a(KN) : a(n.moment);
  })(Ln, function(n) {
    n.version === void 0 && n.default && (n = n.default);
    var a = "0.5.46", t = {}, r = {}, M = {}, b = {}, d = {}, c;
    (!n || typeof n.version != "string") && i2("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var O = n.version.split("."), A = +O[0], m = +O[1];
    (A < 2 || A === 2 && m < 6) && i2("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + n.version + ". See momentjs.com");
    function q(W) {
      return W > 96 ? W - 87 : W > 64 ? W - 29 : W - 48;
    }
    function y(W) {
      var T = 0, B = W.split("."), x = B[0], Q = B[1] || "", L0 = 1, o1, _0 = 0, v0 = 1;
      for (W.charCodeAt(0) === 45 && (T = 1, v0 = -1), T; T < x.length; T++)
        o1 = q(x.charCodeAt(T)), _0 = 60 * _0 + o1;
      for (T = 0; T < Q.length; T++)
        L0 = L0 / 60, o1 = q(Q.charCodeAt(T)), _0 += o1 * L0;
      return _0 * v0;
    }
    function $(W) {
      for (var T = 0; T < W.length; T++)
        W[T] = y(W[T]);
    }
    function v(W, T) {
      for (var B = 0; B < T; B++)
        W[B] = Math.round((W[B - 1] || 0) + W[B] * 6e4);
      W[T - 1] = 1 / 0;
    }
    function E(W, T) {
      var B = [], x;
      for (x = 0; x < T.length; x++)
        B[x] = W[T[x]];
      return B;
    }
    function t0(W) {
      var T = W.split("|"), B = T[2].split(" "), x = T[3].split(""), Q = T[4].split(" ");
      return $(B), $(x), $(Q), v(Q, x.length), {
        name: T[0],
        abbrs: E(T[1].split(" "), x),
        offsets: E(B, x),
        untils: Q,
        population: T[5] | 0
      };
    }
    function K(W) {
      W && this._set(t0(W));
    }
    function C(W, T) {
      var B = T.length;
      if (W < T[0])
        return 0;
      if (B > 1 && T[B - 1] === 1 / 0 && W >= T[B - 2])
        return B - 1;
      if (W >= T[B - 1])
        return -1;
      for (var x, Q = 0, L0 = B - 1; L0 - Q > 1; )
        x = Math.floor((Q + L0) / 2), T[x] <= W ? Q = x : L0 = x;
      return L0;
    }
    K.prototype = {
      _set: function(W) {
        this.name = W.name, this.abbrs = W.abbrs, this.untils = W.untils, this.offsets = W.offsets, this.population = W.population;
      },
      _index: function(W) {
        var T = +W, B = this.untils, x;
        if (x = C(T, B), x >= 0)
          return x;
      },
      countries: function() {
        var W = this.name;
        return Object.keys(M).filter(function(T) {
          return M[T].zones.indexOf(W) !== -1;
        });
      },
      parse: function(W) {
        var T = +W, B = this.offsets, x = this.untils, Q = x.length - 1, L0, o1, _0, v0;
        for (v0 = 0; v0 < Q; v0++)
          if (L0 = B[v0], o1 = B[v0 + 1], _0 = B[v0 && v0 - 1], L0 < o1 && H0.moveAmbiguousForward ? L0 = o1 : L0 > _0 && H0.moveInvalidForward && (L0 = _0), T < x[v0] - L0 * 6e4)
            return B[v0];
        return B[Q];
      },
      abbr: function(W) {
        return this.abbrs[this._index(W)];
      },
      offset: function(W) {
        return i2("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(W)];
      },
      utcOffset: function(W) {
        return this.offsets[this._index(W)];
      }
    };
    function s0(W, T) {
      this.name = W, this.zones = T;
    }
    function J(W) {
      var T = W.toTimeString(), B = T.match(/\([a-z ]+\)/i);
      B && B[0] ? (B = B[0].match(/[A-Z]/g), B = B ? B.join("") : void 0) : (B = T.match(/[A-Z]{3,5}/g), B = B ? B[0] : void 0), B === "GMT" && (B = void 0), this.at = +W, this.abbr = B, this.offset = W.getTimezoneOffset();
    }
    function I0(W) {
      this.zone = W, this.offsetScore = 0, this.abbrScore = 0;
    }
    I0.prototype.scoreOffsetAt = function(W) {
      this.offsetScore += Math.abs(this.zone.utcOffset(W.at) - W.offset), this.zone.abbr(W.at).replace(/[^A-Z]/g, "") !== W.abbr && this.abbrScore++;
    };
    function g0(W, T) {
      for (var B, x; x = ((T.at - W.at) / 12e4 | 0) * 6e4; )
        B = new J(new Date(W.at + x)), B.offset === W.offset ? W = B : T = B;
      return W;
    }
    function S0() {
      var W = (/* @__PURE__ */ new Date()).getFullYear() - 2, T = new J(new Date(W, 0, 1)), B = T.offset, x = [T], Q, L0, o1, _0;
      for (_0 = 1; _0 < 48; _0++)
        o1 = new Date(W, _0, 1).getTimezoneOffset(), o1 !== B && (L0 = new J(new Date(W, _0, 1)), Q = g0(T, L0), x.push(Q), x.push(new J(new Date(Q.at + 6e4))), T = L0, B = o1);
      for (_0 = 0; _0 < 4; _0++)
        x.push(new J(new Date(W + _0, 0, 1))), x.push(new J(new Date(W + _0, 6, 1)));
      return x;
    }
    function u0(W, T) {
      return W.offsetScore !== T.offsetScore ? W.offsetScore - T.offsetScore : W.abbrScore !== T.abbrScore ? W.abbrScore - T.abbrScore : W.zone.population !== T.zone.population ? T.zone.population - W.zone.population : T.zone.name.localeCompare(W.zone.name);
    }
    function F2(W, T) {
      var B, x;
      for ($(T), B = 0; B < T.length; B++)
        x = T[B], d[x] = d[x] || {}, d[x][W] = !0;
    }
    function o2(W) {
      var T = W.length, B = {}, x = [], Q = {}, L0, o1, _0, v0;
      for (L0 = 0; L0 < T; L0++)
        if (_0 = W[L0].offset, !Q.hasOwnProperty(_0)) {
          v0 = d[_0] || {};
          for (o1 in v0)
            v0.hasOwnProperty(o1) && (B[o1] = !0);
          Q[_0] = !0;
        }
      for (L0 in B)
        B.hasOwnProperty(L0) && x.push(b[L0]);
      return x;
    }
    function bn() {
      try {
        var W = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (W && W.length > 3) {
          var T = b[H2(W)];
          if (T)
            return T;
          i2("Moment Timezone found " + W + " from the Intl api, but did not have that data loaded.");
        }
      } catch {
      }
      var B = S0(), x = B.length, Q = o2(B), L0 = [], o1, _0, v0;
      for (_0 = 0; _0 < Q.length; _0++) {
        for (o1 = new I0($1(Q[_0])), v0 = 0; v0 < x; v0++)
          o1.scoreOffsetAt(B[v0]);
        L0.push(o1);
      }
      return L0.sort(u0), L0.length > 0 ? L0[0].zone.name : void 0;
    }
    function Fn(W) {
      return (!c || W) && (c = bn()), c;
    }
    function H2(W) {
      return (W || "").toLowerCase().replace(/\//g, "_");
    }
    function sn(W) {
      var T, B, x, Q;
      for (typeof W == "string" && (W = [W]), T = 0; T < W.length; T++)
        x = W[T].split("|"), B = x[0], Q = H2(B), t[Q] = W[T], b[Q] = B, F2(Q, x[2].split(" "));
    }
    function $1(W, T) {
      W = H2(W);
      var B = t[W], x;
      return B instanceof K ? B : typeof B == "string" ? (B = new K(B), t[W] = B, B) : r[W] && T !== $1 && (x = $1(r[W], $1)) ? (B = t[W] = new K(), B._set(x), B.name = b[W], B) : null;
    }
    function re() {
      var W, T = [];
      for (W in b)
        b.hasOwnProperty(W) && (t[W] || t[r[W]]) && b[W] && T.push(b[W]);
      return T.sort();
    }
    function U2() {
      return Object.keys(M);
    }
    function t3(W) {
      var T, B, x, Q;
      for (typeof W == "string" && (W = [W]), T = 0; T < W.length; T++)
        B = W[T].split("|"), x = H2(B[0]), Q = H2(B[1]), r[x] = Q, b[x] = B[0], r[Q] = x, b[Q] = B[1];
    }
    function Hn(W) {
      var T, B, x, Q;
      if (!(!W || !W.length))
        for (T = 0; T < W.length; T++)
          Q = W[T].split("|"), B = Q[0].toUpperCase(), x = Q[1].split(" "), M[B] = new s0(
            B,
            x
          );
    }
    function r2(W) {
      return W = W.toUpperCase(), M[W] || null;
    }
    function Er(W, T) {
      if (W = r2(W), !W) return null;
      var B = W.zones.sort();
      return T ? B.map(function(x) {
        var Q = $1(x);
        return {
          name: x,
          offset: Q.utcOffset(/* @__PURE__ */ new Date())
        };
      }) : B;
    }
    function Xr(W) {
      sn(W.zones), t3(W.links), Hn(W.countries), H0.dataVersion = W.version;
    }
    function ka(W) {
      return ka.didShowError || (ka.didShowError = !0, i2("moment.tz.zoneExists('" + W + "') has been deprecated in favor of !moment.tz.zone('" + W + "')")), !!$1(W);
    }
    function j2(W) {
      var T = W._f === "X" || W._f === "x";
      return !!(W._a && W._tzm === void 0 && !T);
    }
    function i2(W) {
      typeof console < "u" && typeof console.error == "function" && console.error(W);
    }
    function H0(W) {
      var T = Array.prototype.slice.call(arguments, 0, -1), B = arguments[arguments.length - 1], x = n.utc.apply(null, T), Q;
      return !n.isMoment(W) && j2(x) && (Q = $1(B)) && x.add(Q.parse(x), "minutes"), x.tz(B), x;
    }
    H0.version = a, H0.dataVersion = "", H0._zones = t, H0._links = r, H0._names = b, H0._countries = M, H0.add = sn, H0.link = t3, H0.load = Xr, H0.zone = $1, H0.zoneExists = ka, H0.guess = Fn, H0.names = re, H0.Zone = K, H0.unpack = t0, H0.unpackBase60 = y, H0.needsOffset = j2, H0.moveInvalidForward = !0, H0.moveAmbiguousForward = !1, H0.countries = U2, H0.zonesForCountry = Er;
    var h1 = n.fn;
    n.tz = H0, n.defaultZone = null, n.updateOffset = function(W, T) {
      var B = n.defaultZone, x;
      if (W._z === void 0 && (B && j2(W) && !W._isUTC && W.isValid() && (W._d = n.utc(W._a)._d, W.utc().add(B.parse(W), "minutes")), W._z = B), W._z)
        if (x = W._z.utcOffset(W), Math.abs(x) < 16 && (x = x / 60), W.utcOffset !== void 0) {
          var Q = W._z;
          W.utcOffset(-x, T), W._z = Q;
        } else
          W.zone(x, T);
    }, h1.tz = function(W, T) {
      if (W) {
        if (typeof W != "string")
          throw new Error("Time zone name must be a string, got " + W + " [" + typeof W + "]");
        return this._z = $1(W), this._z ? n.updateOffset(this, T) : i2("Moment Timezone has no data for " + W + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this;
      }
      if (this._z)
        return this._z.name;
    };
    function Be(W) {
      return function() {
        return this._z ? this._z.abbr(this) : W.call(this);
      };
    }
    function o3(W) {
      return function() {
        return this._z = null, W.apply(this, arguments);
      };
    }
    function Un(W) {
      return function() {
        return arguments.length > 0 && (this._z = null), W.apply(this, arguments);
      };
    }
    h1.zoneName = Be(h1.zoneName), h1.zoneAbbr = Be(h1.zoneAbbr), h1.utc = o3(h1.utc), h1.local = o3(h1.local), h1.utcOffset = Un(h1.utcOffset), n.tz.setDefault = function(W) {
      return (A < 2 || A === 2 && m < 9) && i2("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + n.version + "."), n.defaultZone = W ? $1(W) : null, n;
    };
    var G2 = n.momentProperties;
    return Object.prototype.toString.call(G2) === "[object Array]" ? (G2.push("_z"), G2.push("_a")) : G2 && (G2._z = null), n;
  });
})(A6);
var ZN = A6.exports;
const QN = "2024b", ev = [
  "Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
  "Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
  "Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
  "Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
  "Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
  "Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5",
  "Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6",
  "Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5",
  "Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
  "Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
  "Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
  "Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
  "Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
  "Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
  "Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
  "Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|",
  "Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
  "Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
  "Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
  "America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
  "America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
  "America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
  "America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
  "America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
  "America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
  "America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
  "America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
  "America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
  "America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
  "America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
  "America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
  "America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
  "America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
  "America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
  "America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
  "America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
  "America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5",
  "America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
  "America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
  "America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
  "America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
  "America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
  "America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
  "America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
  "America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
  "America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
  "America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
  "America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
  "America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
  "America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
  "America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
  "America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
  "America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
  "America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
  "America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
  "America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
  "America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
  "America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
  "America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
  "America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
  "America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3",
  "America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
  "America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
  "America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
  "America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
  "America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
  "America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
  "America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
  "America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
  "America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
  "America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
  "America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
  "America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
  "America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
  "America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
  "America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
  "America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
  "America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
  "America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
  "America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
  "America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
  "America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
  "America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
  "America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5",
  "America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
  "America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
  "America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
  "America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
  "America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5",
  "America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
  "America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
  "America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
  "America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
  "America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
  "America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
  "America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
  "America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
  "America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
  "America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
  "America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
  "America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
  "America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
  "America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
  "America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
  "America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
  "America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
  "America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
  "America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
  "America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
  "America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
  "America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
  "America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
  "America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
  "America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
  "America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
  "America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
  "Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10",
  "Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
  "Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
  "Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
  "Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
  "Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
  "Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
  "Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
  "Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
  "Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
  "Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25",
  "Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
  "Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5",
  "Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
  "Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
  "Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
  "Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
  "Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
  "Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
  "Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
  "Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
  "Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
  "Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
  "Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
  "Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
  "Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
  "Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4",
  "Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
  "Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
  "Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
  "Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
  "Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
  "Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
  "Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
  "Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4",
  "Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
  "Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
  "Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
  "Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5",
  "Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4",
  "Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5",
  "Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
  "Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
  "Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
  "Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
  "Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
  "Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
  "Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
  "Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
  "Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
  "Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
  "Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
  "Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
  "Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
  "Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5",
  "Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
  "Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
  "Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
  "Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
  "Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
  "Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
  "Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
  "Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
  "Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
  "Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
  "Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
  "Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|",
  "Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
  "Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
  "Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
  "Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
  "Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
  "Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
  "Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
  "Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
  "Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
  "Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
  "Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
  "Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
  "Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
  "Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
  "Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
  "Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
  "Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
  "Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
  "Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
  "Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
  "Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
  "Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
  "Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
  "Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
  "Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
  "Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
  "Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
  "Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
  "Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
  "Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
  "Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
  "Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
  "Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
  "Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
  "Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
  "Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
  "Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
  "Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
  "Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
  "Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Etc/GMT-0|GMT|0|0||",
  "Etc/GMT-1|+01|-10|0||",
  "Etc/GMT-10|+10|-a0|0||",
  "Etc/GMT-11|+11|-b0|0||",
  "Etc/GMT-12|+12|-c0|0||",
  "Etc/GMT-13|+13|-d0|0||",
  "Etc/GMT-14|+14|-e0|0||",
  "Etc/GMT-2|+02|-20|0||",
  "Etc/GMT-3|+03|-30|0||",
  "Etc/GMT-4|+04|-40|0||",
  "Etc/GMT-5|+05|-50|0||",
  "Etc/GMT-6|+06|-60|0||",
  "Etc/GMT-7|+07|-70|0||",
  "Etc/GMT-8|+08|-80|0||",
  "Etc/GMT-9|+09|-90|0||",
  "Etc/GMT+1|-01|10|0||",
  "Etc/GMT+10|-10|a0|0||",
  "Etc/GMT+11|-11|b0|0||",
  "Etc/GMT+12|-12|c0|0||",
  "Etc/GMT+2|-02|20|0||",
  "Etc/GMT+3|-03|30|0||",
  "Etc/GMT+4|-04|40|0||",
  "Etc/GMT+5|-05|50|0||",
  "Etc/GMT+6|-06|60|0||",
  "Etc/GMT+7|-07|70|0||",
  "Etc/GMT+8|-08|80|0||",
  "Etc/GMT+9|-09|90|0||",
  "Etc/UTC|UTC|0|0||",
  "Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
  "Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
  "Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
  "Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
  "Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
  "Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
  "Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
  "Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
  "Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
  "Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
  "Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
  "Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
  "Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
  "Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
  "Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
  "Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
  "Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
  "Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
  "Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
  "Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
  "Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
  "Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
  "Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
  "Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
  "Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
  "Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
  "Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
  "Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
  "Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
  "Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
  "Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
  "Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
  "Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
  "Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
  "Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
  "Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
  "Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
  "Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
  "Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
  "Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
  "Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
  "Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
  "Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
  "Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
  "Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
  "Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
  "Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
  "Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
  "Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
  "Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
  "Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
  "Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
  "Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
  "Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
  "Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
  "Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
  "Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
  "Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
  "Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
  "Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3"
], nv = [
  "Africa/Abidjan|Africa/Accra",
  "Africa/Abidjan|Africa/Bamako",
  "Africa/Abidjan|Africa/Banjul",
  "Africa/Abidjan|Africa/Conakry",
  "Africa/Abidjan|Africa/Dakar",
  "Africa/Abidjan|Africa/Freetown",
  "Africa/Abidjan|Africa/Lome",
  "Africa/Abidjan|Africa/Nouakchott",
  "Africa/Abidjan|Africa/Ouagadougou",
  "Africa/Abidjan|Africa/Timbuktu",
  "Africa/Abidjan|Atlantic/Reykjavik",
  "Africa/Abidjan|Atlantic/St_Helena",
  "Africa/Abidjan|Iceland",
  "Africa/Cairo|Egypt",
  "Africa/Johannesburg|Africa/Maseru",
  "Africa/Johannesburg|Africa/Mbabane",
  "Africa/Lagos|Africa/Bangui",
  "Africa/Lagos|Africa/Brazzaville",
  "Africa/Lagos|Africa/Douala",
  "Africa/Lagos|Africa/Kinshasa",
  "Africa/Lagos|Africa/Libreville",
  "Africa/Lagos|Africa/Luanda",
  "Africa/Lagos|Africa/Malabo",
  "Africa/Lagos|Africa/Niamey",
  "Africa/Lagos|Africa/Porto-Novo",
  "Africa/Maputo|Africa/Blantyre",
  "Africa/Maputo|Africa/Bujumbura",
  "Africa/Maputo|Africa/Gaborone",
  "Africa/Maputo|Africa/Harare",
  "Africa/Maputo|Africa/Kigali",
  "Africa/Maputo|Africa/Lubumbashi",
  "Africa/Maputo|Africa/Lusaka",
  "Africa/Nairobi|Africa/Addis_Ababa",
  "Africa/Nairobi|Africa/Asmara",
  "Africa/Nairobi|Africa/Asmera",
  "Africa/Nairobi|Africa/Dar_es_Salaam",
  "Africa/Nairobi|Africa/Djibouti",
  "Africa/Nairobi|Africa/Kampala",
  "Africa/Nairobi|Africa/Mogadishu",
  "Africa/Nairobi|Indian/Antananarivo",
  "Africa/Nairobi|Indian/Comoro",
  "Africa/Nairobi|Indian/Mayotte",
  "Africa/Tripoli|Libya",
  "America/Adak|America/Atka",
  "America/Adak|US/Aleutian",
  "America/Anchorage|US/Alaska",
  "America/Argentina/Buenos_Aires|America/Buenos_Aires",
  "America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
  "America/Argentina/Catamarca|America/Catamarca",
  "America/Argentina/Cordoba|America/Cordoba",
  "America/Argentina/Cordoba|America/Rosario",
  "America/Argentina/Jujuy|America/Jujuy",
  "America/Argentina/Mendoza|America/Mendoza",
  "America/Chicago|CST6CDT",
  "America/Chicago|US/Central",
  "America/Denver|America/Shiprock",
  "America/Denver|MST7MDT",
  "America/Denver|Navajo",
  "America/Denver|US/Mountain",
  "America/Detroit|US/Michigan",
  "America/Edmonton|America/Yellowknife",
  "America/Edmonton|Canada/Mountain",
  "America/Fort_Wayne|America/Indiana/Indianapolis",
  "America/Fort_Wayne|America/Indianapolis",
  "America/Fort_Wayne|US/East-Indiana",
  "America/Godthab|America/Nuuk",
  "America/Halifax|Canada/Atlantic",
  "America/Havana|Cuba",
  "America/Indiana/Knox|America/Knox_IN",
  "America/Indiana/Knox|US/Indiana-Starke",
  "America/Iqaluit|America/Pangnirtung",
  "America/Jamaica|Jamaica",
  "America/Kentucky/Louisville|America/Louisville",
  "America/Los_Angeles|PST8PDT",
  "America/Los_Angeles|US/Pacific",
  "America/Manaus|Brazil/West",
  "America/Mazatlan|Mexico/BajaSur",
  "America/Mexico_City|Mexico/General",
  "America/New_York|EST5EDT",
  "America/New_York|US/Eastern",
  "America/Noronha|Brazil/DeNoronha",
  "America/Panama|America/Atikokan",
  "America/Panama|America/Cayman",
  "America/Panama|America/Coral_Harbour",
  "America/Panama|EST",
  "America/Phoenix|America/Creston",
  "America/Phoenix|MST",
  "America/Phoenix|US/Arizona",
  "America/Puerto_Rico|America/Anguilla",
  "America/Puerto_Rico|America/Antigua",
  "America/Puerto_Rico|America/Aruba",
  "America/Puerto_Rico|America/Blanc-Sablon",
  "America/Puerto_Rico|America/Curacao",
  "America/Puerto_Rico|America/Dominica",
  "America/Puerto_Rico|America/Grenada",
  "America/Puerto_Rico|America/Guadeloupe",
  "America/Puerto_Rico|America/Kralendijk",
  "America/Puerto_Rico|America/Lower_Princes",
  "America/Puerto_Rico|America/Marigot",
  "America/Puerto_Rico|America/Montserrat",
  "America/Puerto_Rico|America/Port_of_Spain",
  "America/Puerto_Rico|America/St_Barthelemy",
  "America/Puerto_Rico|America/St_Kitts",
  "America/Puerto_Rico|America/St_Lucia",
  "America/Puerto_Rico|America/St_Thomas",
  "America/Puerto_Rico|America/St_Vincent",
  "America/Puerto_Rico|America/Tortola",
  "America/Puerto_Rico|America/Virgin",
  "America/Regina|Canada/Saskatchewan",
  "America/Rio_Branco|America/Porto_Acre",
  "America/Rio_Branco|Brazil/Acre",
  "America/Santiago|Chile/Continental",
  "America/Sao_Paulo|Brazil/East",
  "America/St_Johns|Canada/Newfoundland",
  "America/Tijuana|America/Ensenada",
  "America/Tijuana|America/Santa_Isabel",
  "America/Tijuana|Mexico/BajaNorte",
  "America/Toronto|America/Montreal",
  "America/Toronto|America/Nassau",
  "America/Toronto|America/Nipigon",
  "America/Toronto|America/Thunder_Bay",
  "America/Toronto|Canada/Eastern",
  "America/Vancouver|Canada/Pacific",
  "America/Whitehorse|Canada/Yukon",
  "America/Winnipeg|America/Rainy_River",
  "America/Winnipeg|Canada/Central",
  "Asia/Ashgabat|Asia/Ashkhabad",
  "Asia/Bangkok|Asia/Phnom_Penh",
  "Asia/Bangkok|Asia/Vientiane",
  "Asia/Bangkok|Indian/Christmas",
  "Asia/Brunei|Asia/Kuching",
  "Asia/Dhaka|Asia/Dacca",
  "Asia/Dubai|Asia/Muscat",
  "Asia/Dubai|Indian/Mahe",
  "Asia/Dubai|Indian/Reunion",
  "Asia/Ho_Chi_Minh|Asia/Saigon",
  "Asia/Hong_Kong|Hongkong",
  "Asia/Jerusalem|Asia/Tel_Aviv",
  "Asia/Jerusalem|Israel",
  "Asia/Kathmandu|Asia/Katmandu",
  "Asia/Kolkata|Asia/Calcutta",
  "Asia/Kuala_Lumpur|Asia/Singapore",
  "Asia/Kuala_Lumpur|Singapore",
  "Asia/Macau|Asia/Macao",
  "Asia/Makassar|Asia/Ujung_Pandang",
  "Asia/Nicosia|Europe/Nicosia",
  "Asia/Qatar|Asia/Bahrain",
  "Asia/Rangoon|Asia/Yangon",
  "Asia/Rangoon|Indian/Cocos",
  "Asia/Riyadh|Antarctica/Syowa",
  "Asia/Riyadh|Asia/Aden",
  "Asia/Riyadh|Asia/Kuwait",
  "Asia/Seoul|ROK",
  "Asia/Shanghai|Asia/Chongqing",
  "Asia/Shanghai|Asia/Chungking",
  "Asia/Shanghai|Asia/Harbin",
  "Asia/Shanghai|PRC",
  "Asia/Taipei|ROC",
  "Asia/Tehran|Iran",
  "Asia/Thimphu|Asia/Thimbu",
  "Asia/Tokyo|Japan",
  "Asia/Ulaanbaatar|Asia/Choibalsan",
  "Asia/Ulaanbaatar|Asia/Ulan_Bator",
  "Asia/Urumqi|Asia/Kashgar",
  "Atlantic/Faroe|Atlantic/Faeroe",
  "Australia/Adelaide|Australia/South",
  "Australia/Brisbane|Australia/Queensland",
  "Australia/Broken_Hill|Australia/Yancowinna",
  "Australia/Darwin|Australia/North",
  "Australia/Hobart|Australia/Currie",
  "Australia/Hobart|Australia/Tasmania",
  "Australia/Lord_Howe|Australia/LHI",
  "Australia/Melbourne|Australia/Victoria",
  "Australia/Perth|Australia/West",
  "Australia/Sydney|Australia/ACT",
  "Australia/Sydney|Australia/Canberra",
  "Australia/Sydney|Australia/NSW",
  "Etc/GMT-0|Etc/GMT",
  "Etc/GMT-0|Etc/GMT+0",
  "Etc/GMT-0|Etc/GMT0",
  "Etc/GMT-0|Etc/Greenwich",
  "Etc/GMT-0|GMT",
  "Etc/GMT-0|GMT+0",
  "Etc/GMT-0|GMT-0",
  "Etc/GMT-0|GMT0",
  "Etc/GMT-0|Greenwich",
  "Etc/UTC|Etc/UCT",
  "Etc/UTC|Etc/Universal",
  "Etc/UTC|Etc/Zulu",
  "Etc/UTC|UCT",
  "Etc/UTC|UTC",
  "Etc/UTC|Universal",
  "Etc/UTC|Zulu",
  "Europe/Athens|EET",
  "Europe/Belgrade|Europe/Ljubljana",
  "Europe/Belgrade|Europe/Podgorica",
  "Europe/Belgrade|Europe/Sarajevo",
  "Europe/Belgrade|Europe/Skopje",
  "Europe/Belgrade|Europe/Zagreb",
  "Europe/Berlin|Arctic/Longyearbyen",
  "Europe/Berlin|Atlantic/Jan_Mayen",
  "Europe/Berlin|Europe/Copenhagen",
  "Europe/Berlin|Europe/Oslo",
  "Europe/Berlin|Europe/Stockholm",
  "Europe/Brussels|CET",
  "Europe/Brussels|Europe/Amsterdam",
  "Europe/Brussels|Europe/Luxembourg",
  "Europe/Brussels|MET",
  "Europe/Chisinau|Europe/Tiraspol",
  "Europe/Dublin|Eire",
  "Europe/Helsinki|Europe/Mariehamn",
  "Europe/Istanbul|Asia/Istanbul",
  "Europe/Istanbul|Turkey",
  "Europe/Kiev|Europe/Kyiv",
  "Europe/Kiev|Europe/Uzhgorod",
  "Europe/Kiev|Europe/Zaporozhye",
  "Europe/Lisbon|Portugal",
  "Europe/Lisbon|WET",
  "Europe/London|Europe/Belfast",
  "Europe/London|Europe/Guernsey",
  "Europe/London|Europe/Isle_of_Man",
  "Europe/London|Europe/Jersey",
  "Europe/London|GB",
  "Europe/London|GB-Eire",
  "Europe/Moscow|W-SU",
  "Europe/Paris|Europe/Monaco",
  "Europe/Prague|Europe/Bratislava",
  "Europe/Rome|Europe/San_Marino",
  "Europe/Rome|Europe/Vatican",
  "Europe/Warsaw|Poland",
  "Europe/Zurich|Europe/Busingen",
  "Europe/Zurich|Europe/Vaduz",
  "Indian/Maldives|Indian/Kerguelen",
  "Pacific/Auckland|Antarctica/McMurdo",
  "Pacific/Auckland|Antarctica/South_Pole",
  "Pacific/Auckland|NZ",
  "Pacific/Chatham|NZ-CHAT",
  "Pacific/Easter|Chile/EasterIsland",
  "Pacific/Enderbury|Pacific/Kanton",
  "Pacific/Guadalcanal|Pacific/Pohnpei",
  "Pacific/Guadalcanal|Pacific/Ponape",
  "Pacific/Guam|Pacific/Saipan",
  "Pacific/Honolulu|HST",
  "Pacific/Honolulu|Pacific/Johnston",
  "Pacific/Honolulu|US/Hawaii",
  "Pacific/Kwajalein|Kwajalein",
  "Pacific/Pago_Pago|Pacific/Midway",
  "Pacific/Pago_Pago|Pacific/Samoa",
  "Pacific/Pago_Pago|US/Samoa",
  "Pacific/Port_Moresby|Antarctica/DumontDUrville",
  "Pacific/Port_Moresby|Pacific/Chuuk",
  "Pacific/Port_Moresby|Pacific/Truk",
  "Pacific/Port_Moresby|Pacific/Yap",
  "Pacific/Tarawa|Pacific/Funafuti",
  "Pacific/Tarawa|Pacific/Majuro",
  "Pacific/Tarawa|Pacific/Wake",
  "Pacific/Tarawa|Pacific/Wallis"
], av = [
  "AD|Europe/Andorra",
  "AE|Asia/Dubai",
  "AF|Asia/Kabul",
  "AG|America/Puerto_Rico America/Antigua",
  "AI|America/Puerto_Rico America/Anguilla",
  "AL|Europe/Tirane",
  "AM|Asia/Yerevan",
  "AO|Africa/Lagos Africa/Luanda",
  "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa",
  "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
  "AS|Pacific/Pago_Pago",
  "AT|Europe/Vienna",
  "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
  "AW|America/Puerto_Rico America/Aruba",
  "AX|Europe/Helsinki Europe/Mariehamn",
  "AZ|Asia/Baku",
  "BA|Europe/Belgrade Europe/Sarajevo",
  "BB|America/Barbados",
  "BD|Asia/Dhaka",
  "BE|Europe/Brussels",
  "BF|Africa/Abidjan Africa/Ouagadougou",
  "BG|Europe/Sofia",
  "BH|Asia/Qatar Asia/Bahrain",
  "BI|Africa/Maputo Africa/Bujumbura",
  "BJ|Africa/Lagos Africa/Porto-Novo",
  "BL|America/Puerto_Rico America/St_Barthelemy",
  "BM|Atlantic/Bermuda",
  "BN|Asia/Kuching Asia/Brunei",
  "BO|America/La_Paz",
  "BQ|America/Puerto_Rico America/Kralendijk",
  "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
  "BS|America/Toronto America/Nassau",
  "BT|Asia/Thimphu",
  "BW|Africa/Maputo Africa/Gaborone",
  "BY|Europe/Minsk",
  "BZ|America/Belize",
  "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
  "CC|Asia/Yangon Indian/Cocos",
  "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
  "CF|Africa/Lagos Africa/Bangui",
  "CG|Africa/Lagos Africa/Brazzaville",
  "CH|Europe/Zurich",
  "CI|Africa/Abidjan",
  "CK|Pacific/Rarotonga",
  "CL|America/Santiago America/Punta_Arenas Pacific/Easter",
  "CM|Africa/Lagos Africa/Douala",
  "CN|Asia/Shanghai Asia/Urumqi",
  "CO|America/Bogota",
  "CR|America/Costa_Rica",
  "CU|America/Havana",
  "CV|Atlantic/Cape_Verde",
  "CW|America/Puerto_Rico America/Curacao",
  "CX|Asia/Bangkok Indian/Christmas",
  "CY|Asia/Nicosia Asia/Famagusta",
  "CZ|Europe/Prague",
  "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
  "DJ|Africa/Nairobi Africa/Djibouti",
  "DK|Europe/Berlin Europe/Copenhagen",
  "DM|America/Puerto_Rico America/Dominica",
  "DO|America/Santo_Domingo",
  "DZ|Africa/Algiers",
  "EC|America/Guayaquil Pacific/Galapagos",
  "EE|Europe/Tallinn",
  "EG|Africa/Cairo",
  "EH|Africa/El_Aaiun",
  "ER|Africa/Nairobi Africa/Asmara",
  "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
  "ET|Africa/Nairobi Africa/Addis_Ababa",
  "FI|Europe/Helsinki",
  "FJ|Pacific/Fiji",
  "FK|Atlantic/Stanley",
  "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
  "FO|Atlantic/Faroe",
  "FR|Europe/Paris",
  "GA|Africa/Lagos Africa/Libreville",
  "GB|Europe/London",
  "GD|America/Puerto_Rico America/Grenada",
  "GE|Asia/Tbilisi",
  "GF|America/Cayenne",
  "GG|Europe/London Europe/Guernsey",
  "GH|Africa/Abidjan Africa/Accra",
  "GI|Europe/Gibraltar",
  "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
  "GM|Africa/Abidjan Africa/Banjul",
  "GN|Africa/Abidjan Africa/Conakry",
  "GP|America/Puerto_Rico America/Guadeloupe",
  "GQ|Africa/Lagos Africa/Malabo",
  "GR|Europe/Athens",
  "GS|Atlantic/South_Georgia",
  "GT|America/Guatemala",
  "GU|Pacific/Guam",
  "GW|Africa/Bissau",
  "GY|America/Guyana",
  "HK|Asia/Hong_Kong",
  "HN|America/Tegucigalpa",
  "HR|Europe/Belgrade Europe/Zagreb",
  "HT|America/Port-au-Prince",
  "HU|Europe/Budapest",
  "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
  "IE|Europe/Dublin",
  "IL|Asia/Jerusalem",
  "IM|Europe/London Europe/Isle_of_Man",
  "IN|Asia/Kolkata",
  "IO|Indian/Chagos",
  "IQ|Asia/Baghdad",
  "IR|Asia/Tehran",
  "IS|Africa/Abidjan Atlantic/Reykjavik",
  "IT|Europe/Rome",
  "JE|Europe/London Europe/Jersey",
  "JM|America/Jamaica",
  "JO|Asia/Amman",
  "JP|Asia/Tokyo",
  "KE|Africa/Nairobi",
  "KG|Asia/Bishkek",
  "KH|Asia/Bangkok Asia/Phnom_Penh",
  "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
  "KM|Africa/Nairobi Indian/Comoro",
  "KN|America/Puerto_Rico America/St_Kitts",
  "KP|Asia/Pyongyang",
  "KR|Asia/Seoul",
  "KW|Asia/Riyadh Asia/Kuwait",
  "KY|America/Panama America/Cayman",
  "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
  "LA|Asia/Bangkok Asia/Vientiane",
  "LB|Asia/Beirut",
  "LC|America/Puerto_Rico America/St_Lucia",
  "LI|Europe/Zurich Europe/Vaduz",
  "LK|Asia/Colombo",
  "LR|Africa/Monrovia",
  "LS|Africa/Johannesburg Africa/Maseru",
  "LT|Europe/Vilnius",
  "LU|Europe/Brussels Europe/Luxembourg",
  "LV|Europe/Riga",
  "LY|Africa/Tripoli",
  "MA|Africa/Casablanca",
  "MC|Europe/Paris Europe/Monaco",
  "MD|Europe/Chisinau",
  "ME|Europe/Belgrade Europe/Podgorica",
  "MF|America/Puerto_Rico America/Marigot",
  "MG|Africa/Nairobi Indian/Antananarivo",
  "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
  "MK|Europe/Belgrade Europe/Skopje",
  "ML|Africa/Abidjan Africa/Bamako",
  "MM|Asia/Yangon",
  "MN|Asia/Ulaanbaatar Asia/Hovd",
  "MO|Asia/Macau",
  "MP|Pacific/Guam Pacific/Saipan",
  "MQ|America/Martinique",
  "MR|Africa/Abidjan Africa/Nouakchott",
  "MS|America/Puerto_Rico America/Montserrat",
  "MT|Europe/Malta",
  "MU|Indian/Mauritius",
  "MV|Indian/Maldives",
  "MW|Africa/Maputo Africa/Blantyre",
  "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
  "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
  "MZ|Africa/Maputo",
  "NA|Africa/Windhoek",
  "NC|Pacific/Noumea",
  "NE|Africa/Lagos Africa/Niamey",
  "NF|Pacific/Norfolk",
  "NG|Africa/Lagos",
  "NI|America/Managua",
  "NL|Europe/Brussels Europe/Amsterdam",
  "NO|Europe/Berlin Europe/Oslo",
  "NP|Asia/Kathmandu",
  "NR|Pacific/Nauru",
  "NU|Pacific/Niue",
  "NZ|Pacific/Auckland Pacific/Chatham",
  "OM|Asia/Dubai Asia/Muscat",
  "PA|America/Panama",
  "PE|America/Lima",
  "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
  "PG|Pacific/Port_Moresby Pacific/Bougainville",
  "PH|Asia/Manila",
  "PK|Asia/Karachi",
  "PL|Europe/Warsaw",
  "PM|America/Miquelon",
  "PN|Pacific/Pitcairn",
  "PR|America/Puerto_Rico",
  "PS|Asia/Gaza Asia/Hebron",
  "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
  "PW|Pacific/Palau",
  "PY|America/Asuncion",
  "QA|Asia/Qatar",
  "RE|Asia/Dubai Indian/Reunion",
  "RO|Europe/Bucharest",
  "RS|Europe/Belgrade",
  "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
  "RW|Africa/Maputo Africa/Kigali",
  "SA|Asia/Riyadh",
  "SB|Pacific/Guadalcanal",
  "SC|Asia/Dubai Indian/Mahe",
  "SD|Africa/Khartoum",
  "SE|Europe/Berlin Europe/Stockholm",
  "SG|Asia/Singapore",
  "SH|Africa/Abidjan Atlantic/St_Helena",
  "SI|Europe/Belgrade Europe/Ljubljana",
  "SJ|Europe/Berlin Arctic/Longyearbyen",
  "SK|Europe/Prague Europe/Bratislava",
  "SL|Africa/Abidjan Africa/Freetown",
  "SM|Europe/Rome Europe/San_Marino",
  "SN|Africa/Abidjan Africa/Dakar",
  "SO|Africa/Nairobi Africa/Mogadishu",
  "SR|America/Paramaribo",
  "SS|Africa/Juba",
  "ST|Africa/Sao_Tome",
  "SV|America/El_Salvador",
  "SX|America/Puerto_Rico America/Lower_Princes",
  "SY|Asia/Damascus",
  "SZ|Africa/Johannesburg Africa/Mbabane",
  "TC|America/Grand_Turk",
  "TD|Africa/Ndjamena",
  "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
  "TG|Africa/Abidjan Africa/Lome",
  "TH|Asia/Bangkok",
  "TJ|Asia/Dushanbe",
  "TK|Pacific/Fakaofo",
  "TL|Asia/Dili",
  "TM|Asia/Ashgabat",
  "TN|Africa/Tunis",
  "TO|Pacific/Tongatapu",
  "TR|Europe/Istanbul",
  "TT|America/Puerto_Rico America/Port_of_Spain",
  "TV|Pacific/Tarawa Pacific/Funafuti",
  "TW|Asia/Taipei",
  "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
  "UA|Europe/Simferopol Europe/Kyiv",
  "UG|Africa/Nairobi Africa/Kampala",
  "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
  "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
  "UY|America/Montevideo",
  "UZ|Asia/Samarkand Asia/Tashkent",
  "VA|Europe/Rome Europe/Vatican",
  "VC|America/Puerto_Rico America/St_Vincent",
  "VE|America/Caracas",
  "VG|America/Puerto_Rico America/Tortola",
  "VI|America/Puerto_Rico America/St_Thomas",
  "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
  "VU|Pacific/Efate",
  "WF|Pacific/Tarawa Pacific/Wallis",
  "WS|Pacific/Apia",
  "YE|Asia/Riyadh Asia/Aden",
  "YT|Africa/Nairobi Indian/Mayotte",
  "ZA|Africa/Johannesburg",
  "ZM|Africa/Maputo Africa/Lusaka",
  "ZW|Africa/Maputo Africa/Harare"
], tv = {
  version: QN,
  zones: ev,
  links: nv,
  countries: av
};
var ov = u6.exports = ZN;
ov.tz.load(tv);
var rv = u6.exports;
const W0 = /* @__PURE__ */ I2(rv);
var iv = function(e, n) {
  for (var a = [], t = 0; t < e.length - n + 1; t++)
    a.push(Mv(e, t, n));
  return a;
};
function Mv(e, n, a) {
  for (var t = [], r = 0; r < a; r++)
    t.push(e[n + r]);
  return t;
}
const bv = /* @__PURE__ */ I2(iv);
var to = {}, LM, Kc;
function sv() {
  if (Kc) return LM;
  Kc = 1;
  var e, n, a = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, t;
  function r(y) {
    throw {
      name: "SyntaxError",
      message: y,
      at: e,
      text: t
    };
  }
  function M(y) {
    return y && y !== n && r("Expected '" + y + "' instead of '" + n + "'"), n = t.charAt(e), e += 1, n;
  }
  function b() {
    var y, $ = "";
    for (n === "-" && ($ = "-", M("-")); n >= "0" && n <= "9"; )
      $ += n, M();
    if (n === ".")
      for ($ += "."; M() && n >= "0" && n <= "9"; )
        $ += n;
    if (n === "e" || n === "E")
      for ($ += n, M(), (n === "-" || n === "+") && ($ += n, M()); n >= "0" && n <= "9"; )
        $ += n, M();
    return y = Number($), isFinite(y) || r("Bad number"), y;
  }
  function d() {
    var y, $, v = "", E;
    if (n === '"')
      for (; M(); ) {
        if (n === '"')
          return M(), v;
        if (n === "\\")
          if (M(), n === "u") {
            for (E = 0, $ = 0; $ < 4 && (y = parseInt(M(), 16), !!isFinite(y)); $ += 1)
              E = E * 16 + y;
            v += String.fromCharCode(E);
          } else if (typeof a[n] == "string")
            v += a[n];
          else
            break;
        else
          v += n;
      }
    r("Bad string");
  }
  function c() {
    for (; n && n <= " "; )
      M();
  }
  function O() {
    switch (n) {
      case "t":
        return M("t"), M("r"), M("u"), M("e"), !0;
      case "f":
        return M("f"), M("a"), M("l"), M("s"), M("e"), !1;
      case "n":
        return M("n"), M("u"), M("l"), M("l"), null;
      default:
        r("Unexpected '" + n + "'");
    }
  }
  function A() {
    var y = [];
    if (n === "[") {
      if (M("["), c(), n === "]")
        return M("]"), y;
      for (; n; ) {
        if (y.push(q()), c(), n === "]")
          return M("]"), y;
        M(","), c();
      }
    }
    r("Bad array");
  }
  function m() {
    var y, $ = {};
    if (n === "{") {
      if (M("{"), c(), n === "}")
        return M("}"), $;
      for (; n; ) {
        if (y = d(), c(), M(":"), Object.prototype.hasOwnProperty.call($, y) && r('Duplicate key "' + y + '"'), $[y] = q(), c(), n === "}")
          return M("}"), $;
        M(","), c();
      }
    }
    r("Bad object");
  }
  function q() {
    switch (c(), n) {
      case "{":
        return m();
      case "[":
        return A();
      case '"':
        return d();
      case "-":
        return b();
      default:
        return n >= "0" && n <= "9" ? b() : O();
    }
  }
  return LM = function(y, $) {
    var v;
    return t = y, e = 0, n = " ", v = q(), c(), n && r("Syntax error"), typeof $ == "function" ? function E(t0, K) {
      var C, s0, J = t0[K];
      if (J && typeof J == "object")
        for (C in q)
          Object.prototype.hasOwnProperty.call(J, C) && (s0 = E(J, C), typeof s0 > "u" ? delete J[C] : J[C] = s0);
      return $.call(t0, K, J);
    }({ "": v }, "") : v;
  }, LM;
}
var _M, Zc;
function dv() {
  if (Zc) return _M;
  Zc = 1;
  var e = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, n, a, t = {
    // table of character substitutions
    "\b": "\\b",
    "	": "\\t",
    "\n": "\\n",
    "\f": "\\f",
    "\r": "\\r",
    '"': '\\"',
    "\\": "\\\\"
  }, r;
  function M(d) {
    return e.lastIndex = 0, e.test(d) ? '"' + d.replace(e, function(c) {
      var O = t[c];
      return typeof O == "string" ? O : "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4);
    }) + '"' : '"' + d + '"';
  }
  function b(d, c) {
    var O, A, m, q, y = n, $, v = c[d];
    switch (v && typeof v == "object" && typeof v.toJSON == "function" && (v = v.toJSON(d)), typeof r == "function" && (v = r.call(c, d, v)), typeof v) {
      case "string":
        return M(v);
      case "number":
        return isFinite(v) ? String(v) : "null";
      case "boolean":
      case "null":
        return String(v);
      case "object":
        if (!v)
          return "null";
        if (n += a, $ = [], Object.prototype.toString.apply(v) === "[object Array]") {
          for (q = v.length, O = 0; O < q; O += 1)
            $[O] = b(O, v) || "null";
          return m = $.length === 0 ? "[]" : n ? `[
` + n + $.join(`,
` + n) + `
` + y + "]" : "[" + $.join(",") + "]", n = y, m;
        }
        if (r && typeof r == "object")
          for (q = r.length, O = 0; O < q; O += 1)
            A = r[O], typeof A == "string" && (m = b(A, v), m && $.push(M(A) + (n ? ": " : ":") + m));
        else
          for (A in v)
            Object.prototype.hasOwnProperty.call(v, A) && (m = b(A, v), m && $.push(M(A) + (n ? ": " : ":") + m));
        return m = $.length === 0 ? "{}" : n ? `{
` + n + $.join(`,
` + n) + `
` + y + "}" : "{" + $.join(",") + "}", n = y, m;
    }
  }
  return _M = function(d, c, O) {
    var A;
    if (n = "", a = "", typeof O == "number")
      for (A = 0; A < O; A += 1)
        a += " ";
    else typeof O == "string" && (a = O);
    if (r = c, c && typeof c != "function" && (typeof c != "object" || typeof c.length != "number"))
      throw new Error("JSON.stringify");
    return b("", { "": d });
  }, _M;
}
var Qc;
function pv() {
  return Qc || (Qc = 1, to.parse = sv(), to.stringify = dv()), to;
}
var cv = {}.toString, zv = Array.isArray || function(e) {
  return cv.call(e) == "[object Array]";
}, e5 = Object.prototype.toString, bO = function(n) {
  var a = e5.call(n), t = a === "[object Arguments]";
  return t || (t = a !== "[object Array]" && n !== null && typeof n == "object" && typeof n.length == "number" && n.length >= 0 && e5.call(n.callee) === "[object Function]"), t;
}, NM, n5;
function Ov() {
  if (n5) return NM;
  n5 = 1;
  var e;
  if (!Object.keys) {
    var n = Object.prototype.hasOwnProperty, a = Object.prototype.toString, t = bO, r = Object.prototype.propertyIsEnumerable, M = !r.call({ toString: null }, "toString"), b = r.call(function() {
    }, "prototype"), d = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], c = function(q) {
      var y = q.constructor;
      return y && y.prototype === q;
    }, O = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, A = function() {
      if (typeof window > "u")
        return !1;
      for (var q in window)
        try {
          if (!O["$" + q] && n.call(window, q) && window[q] !== null && typeof window[q] == "object")
            try {
              c(window[q]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), m = function(q) {
      if (typeof window > "u" || !A)
        return c(q);
      try {
        return c(q);
      } catch {
        return !1;
      }
    };
    e = function(y) {
      var $ = y !== null && typeof y == "object", v = a.call(y) === "[object Function]", E = t(y), t0 = $ && a.call(y) === "[object String]", K = [];
      if (!$ && !v && !E)
        throw new TypeError("Object.keys called on a non-object");
      var C = b && v;
      if (t0 && y.length > 0 && !n.call(y, 0))
        for (var s0 = 0; s0 < y.length; ++s0)
          K.push(String(s0));
      if (E && y.length > 0)
        for (var J = 0; J < y.length; ++J)
          K.push(String(J));
      else
        for (var I0 in y)
          !(C && I0 === "prototype") && n.call(y, I0) && K.push(String(I0));
      if (M)
        for (var g0 = m(y), S0 = 0; S0 < d.length; ++S0)
          !(g0 && d[S0] === "constructor") && n.call(y, d[S0]) && K.push(d[S0]);
      return K;
    };
  }
  return NM = e, NM;
}
var uv = Array.prototype.slice, Av = bO, a5 = Object.keys, Wo = a5 ? function(n) {
  return a5(n);
} : Ov(), t5 = Object.keys;
Wo.shim = function() {
  if (Object.keys) {
    var n = function() {
      var a = Object.keys(arguments);
      return a && a.length === arguments.length;
    }(1, 2);
    n || (Object.keys = function(t) {
      return Av(t) ? t5(uv.call(t)) : t5(t);
    });
  } else
    Object.keys = Wo;
  return Object.keys || Wo;
};
var lv = Wo, sO = { exports: {} }, fv = "Function.prototype.bind called on incompatible ", mv = Object.prototype.toString, qv = Math.max, hv = "[object Function]", o5 = function(n, a) {
  for (var t = [], r = 0; r < n.length; r += 1)
    t[r] = n[r];
  for (var M = 0; M < a.length; M += 1)
    t[M + n.length] = a[M];
  return t;
}, yv = function(n, a) {
  for (var t = [], r = a, M = 0; r < n.length; r += 1, M += 1)
    t[M] = n[r];
  return t;
}, Wv = function(e, n) {
  for (var a = "", t = 0; t < e.length; t += 1)
    a += e[t], t + 1 < e.length && (a += n);
  return a;
}, gv = function(n) {
  var a = this;
  if (typeof a != "function" || mv.apply(a) !== hv)
    throw new TypeError(fv + a);
  for (var t = yv(arguments, 1), r, M = function() {
    if (this instanceof r) {
      var A = a.apply(
        this,
        o5(t, arguments)
      );
      return Object(A) === A ? A : this;
    }
    return a.apply(
      n,
      o5(t, arguments)
    );
  }, b = qv(0, a.length - t.length), d = [], c = 0; c < b; c++)
    d[c] = "$" + c;
  if (r = Function("binder", "return function (" + Wv(d, ",") + "){ return binder.apply(this,arguments); }")(M), a.prototype) {
    var O = function() {
    };
    O.prototype = a.prototype, r.prototype = new O(), O.prototype = null;
  }
  return r;
}, Rv = gv, Ht = Function.prototype.bind || Rv, dO = Object, $v = Error, Lv = EvalError, _v = RangeError, Nv = ReferenceError, pO = SyntaxError, Ut = TypeError, vv = URIError, Dv = Math.abs, Tv = Math.floor, Sv = Math.max, Bv = Math.min, wv = Math.pow, Cv = Math.round, Ev = Number.isNaN || function(n) {
  return n !== n;
}, Xv = Ev, Pv = function(n) {
  return Xv(n) || n === 0 ? n : n < 0 ? -1 : 1;
}, kv = Object.getOwnPropertyDescriptor, go = kv;
if (go)
  try {
    go([], "length");
  } catch {
    go = null;
  }
var Wr = go, Ro = Object.defineProperty || !1;
if (Ro)
  try {
    Ro({}, "a", { value: 1 });
  } catch {
    Ro = !1;
  }
var gr = Ro, vM, r5;
function Iv() {
  return r5 || (r5 = 1, vM = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var n = {}, a = Symbol("test"), t = Object(a);
    if (typeof a == "string" || Object.prototype.toString.call(a) !== "[object Symbol]" || Object.prototype.toString.call(t) !== "[object Symbol]")
      return !1;
    var r = 42;
    n[a] = r;
    for (var M in n)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(n).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(n).length !== 0)
      return !1;
    var b = Object.getOwnPropertySymbols(n);
    if (b.length !== 1 || b[0] !== a || !Object.prototype.propertyIsEnumerable.call(n, a))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var d = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(n, a)
      );
      if (d.value !== r || d.enumerable !== !0)
        return !1;
    }
    return !0;
  }), vM;
}
var DM, i5;
function xv() {
  if (i5) return DM;
  i5 = 1;
  var e = typeof Symbol < "u" && Symbol, n = Iv();
  return DM = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : n();
  }, DM;
}
var TM, M5;
function cO() {
  return M5 || (M5 = 1, TM = typeof Reflect < "u" && Reflect.getPrototypeOf || null), TM;
}
var SM, b5;
function zO() {
  if (b5) return SM;
  b5 = 1;
  var e = dO;
  return SM = e.getPrototypeOf || null, SM;
}
var BM, s5;
function _b() {
  return s5 || (s5 = 1, BM = Function.prototype.call), BM;
}
var wM, d5;
function OO() {
  return d5 || (d5 = 1, wM = Function.prototype.apply), wM;
}
var CM, p5;
function Fv() {
  return p5 || (p5 = 1, CM = typeof Reflect < "u" && Reflect && Reflect.apply), CM;
}
var EM, c5;
function Hv() {
  if (c5) return EM;
  c5 = 1;
  var e = Ht, n = OO(), a = _b(), t = Fv();
  return EM = t || e.call(a, n), EM;
}
var XM, z5;
function Uv() {
  if (z5) return XM;
  z5 = 1;
  var e = Ht, n = Ut, a = _b(), t = Hv();
  return XM = function(M) {
    if (M.length < 1 || typeof M[0] != "function")
      throw new n("a function is required");
    return t(e, a, M);
  }, XM;
}
var PM, O5;
function jv() {
  if (O5) return PM;
  O5 = 1;
  var e = Uv(), n = Wr, a;
  try {
    a = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (b) {
    if (!b || typeof b != "object" || !("code" in b) || b.code !== "ERR_PROTO_ACCESS")
      throw b;
  }
  var t = !!a && n && n(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), r = Object, M = r.getPrototypeOf;
  return PM = t && typeof t.get == "function" ? e([t.get]) : typeof M == "function" ? (
    /** @type {import('./get')} */
    function(d) {
      return M(d == null ? d : r(d));
    }
  ) : !1, PM;
}
var kM, u5;
function Gv() {
  if (u5) return kM;
  u5 = 1;
  var e = cO(), n = zO(), a = jv();
  return kM = e ? function(r) {
    return e(r);
  } : n ? function(r) {
    if (!r || typeof r != "object" && typeof r != "function")
      throw new TypeError("getProto: not an object");
    return n(r);
  } : a ? function(r) {
    return a(r);
  } : null, kM;
}
var IM, A5;
function Vv() {
  if (A5) return IM;
  A5 = 1;
  var e = Function.prototype.call, n = Object.prototype.hasOwnProperty, a = Ht;
  return IM = a.call(e, n), IM;
}
var q0, Yv = dO, Jv = $v, Kv = Lv, Zv = _v, Qv = Nv, La = pO, ga = Ut, eD = vv, nD = Dv, aD = Tv, tD = Sv, oD = Bv, rD = wv, iD = Cv, MD = Pv, uO = Function, xM = function(e) {
  try {
    return uO('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, Dt = Wr, bD = gr, FM = function() {
  throw new ga();
}, sD = Dt ? function() {
  try {
    return arguments.callee, FM;
  } catch {
    try {
      return Dt(arguments, "callee").get;
    } catch {
      return FM;
    }
  }
}() : FM, pa = xv()(), m1 = Gv(), dD = zO(), pD = cO(), AO = OO(), jt = _b(), la = {}, cD = typeof Uint8Array > "u" || !m1 ? q0 : m1(Uint8Array), Tn = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? q0 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? q0 : ArrayBuffer,
  "%ArrayIteratorPrototype%": pa && m1 ? m1([][Symbol.iterator]()) : q0,
  "%AsyncFromSyncIteratorPrototype%": q0,
  "%AsyncFunction%": la,
  "%AsyncGenerator%": la,
  "%AsyncGeneratorFunction%": la,
  "%AsyncIteratorPrototype%": la,
  "%Atomics%": typeof Atomics > "u" ? q0 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? q0 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? q0 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? q0 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? q0 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Jv,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": Kv,
  "%Float16Array%": typeof Float16Array > "u" ? q0 : Float16Array,
  "%Float32Array%": typeof Float32Array > "u" ? q0 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? q0 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? q0 : FinalizationRegistry,
  "%Function%": uO,
  "%GeneratorFunction%": la,
  "%Int8Array%": typeof Int8Array > "u" ? q0 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? q0 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? q0 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": pa && m1 ? m1(m1([][Symbol.iterator]())) : q0,
  "%JSON%": typeof JSON == "object" ? JSON : q0,
  "%Map%": typeof Map > "u" ? q0 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !pa || !m1 ? q0 : m1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Yv,
  "%Object.getOwnPropertyDescriptor%": Dt,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? q0 : Promise,
  "%Proxy%": typeof Proxy > "u" ? q0 : Proxy,
  "%RangeError%": Zv,
  "%ReferenceError%": Qv,
  "%Reflect%": typeof Reflect > "u" ? q0 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? q0 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !pa || !m1 ? q0 : m1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? q0 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": pa && m1 ? m1(""[Symbol.iterator]()) : q0,
  "%Symbol%": pa ? Symbol : q0,
  "%SyntaxError%": La,
  "%ThrowTypeError%": sD,
  "%TypedArray%": cD,
  "%TypeError%": ga,
  "%Uint8Array%": typeof Uint8Array > "u" ? q0 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? q0 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? q0 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? q0 : Uint32Array,
  "%URIError%": eD,
  "%WeakMap%": typeof WeakMap > "u" ? q0 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? q0 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? q0 : WeakSet,
  "%Function.prototype.call%": jt,
  "%Function.prototype.apply%": AO,
  "%Object.defineProperty%": bD,
  "%Object.getPrototypeOf%": dD,
  "%Math.abs%": nD,
  "%Math.floor%": aD,
  "%Math.max%": tD,
  "%Math.min%": oD,
  "%Math.pow%": rD,
  "%Math.round%": iD,
  "%Math.sign%": MD,
  "%Reflect.getPrototypeOf%": pD
};
if (m1)
  try {
    null.error;
  } catch (e) {
    var zD = m1(m1(e));
    Tn["%Error.prototype%"] = zD;
  }
var OD = function e(n) {
  var a;
  if (n === "%AsyncFunction%")
    a = xM("async function () {}");
  else if (n === "%GeneratorFunction%")
    a = xM("function* () {}");
  else if (n === "%AsyncGeneratorFunction%")
    a = xM("async function* () {}");
  else if (n === "%AsyncGenerator%") {
    var t = e("%AsyncGeneratorFunction%");
    t && (a = t.prototype);
  } else if (n === "%AsyncIteratorPrototype%") {
    var r = e("%AsyncGenerator%");
    r && m1 && (a = m1(r.prototype));
  }
  return Tn[n] = a, a;
}, l5 = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Gt = Ht, xo = Vv(), uD = Gt.call(jt, Array.prototype.concat), AD = Gt.call(AO, Array.prototype.splice), f5 = Gt.call(jt, String.prototype.replace), Fo = Gt.call(jt, String.prototype.slice), lD = Gt.call(jt, RegExp.prototype.exec), fD = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, mD = /\\(\\)?/g, qD = function(n) {
  var a = Fo(n, 0, 1), t = Fo(n, -1);
  if (a === "%" && t !== "%")
    throw new La("invalid intrinsic syntax, expected closing `%`");
  if (t === "%" && a !== "%")
    throw new La("invalid intrinsic syntax, expected opening `%`");
  var r = [];
  return f5(n, fD, function(M, b, d, c) {
    r[r.length] = d ? f5(c, mD, "$1") : b || M;
  }), r;
}, hD = function(n, a) {
  var t = n, r;
  if (xo(l5, t) && (r = l5[t], t = "%" + r[0] + "%"), xo(Tn, t)) {
    var M = Tn[t];
    if (M === la && (M = OD(t)), typeof M > "u" && !a)
      throw new ga("intrinsic " + n + " exists, but is not available. Please file an issue!");
    return {
      alias: r,
      name: t,
      value: M
    };
  }
  throw new La("intrinsic " + n + " does not exist!");
}, Nb = function(n, a) {
  if (typeof n != "string" || n.length === 0)
    throw new ga("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof a != "boolean")
    throw new ga('"allowMissing" argument must be a boolean');
  if (lD(/^%?[^%]*%?$/, n) === null)
    throw new La("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var t = qD(n), r = t.length > 0 ? t[0] : "", M = hD("%" + r + "%", a), b = M.name, d = M.value, c = !1, O = M.alias;
  O && (r = O[0], AD(t, uD([0, 1], O)));
  for (var A = 1, m = !0; A < t.length; A += 1) {
    var q = t[A], y = Fo(q, 0, 1), $ = Fo(q, -1);
    if ((y === '"' || y === "'" || y === "`" || $ === '"' || $ === "'" || $ === "`") && y !== $)
      throw new La("property names with quotes must have matching quotes");
    if ((q === "constructor" || !m) && (c = !0), r += "." + q, b = "%" + r + "%", xo(Tn, b))
      d = Tn[b];
    else if (d != null) {
      if (!(q in d)) {
        if (!a)
          throw new ga("base intrinsic for " + n + " exists, but the property is not available.");
        return;
      }
      if (Dt && A + 1 >= t.length) {
        var v = Dt(d, q);
        m = !!v, m && "get" in v && !("originalValue" in v.get) ? d = v.get : d = d[q];
      } else
        m = xo(d, q), d = d[q];
      m && !c && (Tn[b] = d);
    }
  }
  return d;
}, m5 = gr, yD = pO, ca = Ut, q5 = Wr, WD = function(n, a, t) {
  if (!n || typeof n != "object" && typeof n != "function")
    throw new ca("`obj` must be an object or a function`");
  if (typeof a != "string" && typeof a != "symbol")
    throw new ca("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new ca("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new ca("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new ca("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new ca("`loose`, if provided, must be a boolean");
  var r = arguments.length > 3 ? arguments[3] : null, M = arguments.length > 4 ? arguments[4] : null, b = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 ? arguments[6] : !1, c = !!q5 && q5(n, a);
  if (m5)
    m5(n, a, {
      configurable: b === null && c ? c.configurable : !b,
      enumerable: r === null && c ? c.enumerable : !r,
      value: t,
      writable: M === null && c ? c.writable : !M
    });
  else if (d || !r && !M && !b)
    n[a] = t;
  else
    throw new yD("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, N4 = gr, lO = function() {
  return !!N4;
};
lO.hasArrayLengthDefineBug = function() {
  if (!N4)
    return null;
  try {
    return N4([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var gD = lO, RD = Nb, h5 = WD, $D = gD(), y5 = Wr, W5 = Ut, LD = RD("%Math.floor%"), _D = function(n, a) {
  if (typeof n != "function")
    throw new W5("`fn` is not a function");
  if (typeof a != "number" || a < 0 || a > 4294967295 || LD(a) !== a)
    throw new W5("`length` must be a positive 32-bit integer");
  var t = arguments.length > 2 && !!arguments[2], r = !0, M = !0;
  if ("length" in n && y5) {
    var b = y5(n, "length");
    b && !b.configurable && (r = !1), b && !b.writable && (M = !1);
  }
  return (r || M || !t) && ($D ? h5(
    /** @type {Parameters<define>[0]} */
    n,
    "length",
    a,
    !0,
    !0
  ) : h5(
    /** @type {Parameters<define>[0]} */
    n,
    "length",
    a
  )), n;
};
(function(e) {
  var n = Ht, a = Nb, t = _D, r = Ut, M = a("%Function.prototype.apply%"), b = a("%Function.prototype.call%"), d = a("%Reflect.apply%", !0) || n.call(b, M), c = gr, O = a("%Math.max%");
  e.exports = function(q) {
    if (typeof q != "function")
      throw new r("a function is required");
    var y = d(n, b, arguments);
    return t(
      y,
      1 + O(0, q.length - (arguments.length - 1)),
      !0
    );
  };
  var A = function() {
    return d(n, M, arguments);
  };
  c ? c(e.exports, "apply", { value: A }) : e.exports.apply = A;
})(sO);
var fO = sO.exports, mO = Nb, qO = fO, ND = qO(mO("String.prototype.indexOf")), vD = function(n, a) {
  var t = mO(n, !!a);
  return typeof t == "function" && ND(n, ".prototype.") > -1 ? qO(t) : t;
}, oo = (typeof JSON < "u" ? JSON : pv()).stringify, DD = zv, TD = lv, SD = fO, hO = vD, g5 = hO("Array.prototype.join"), HM = hO("Array.prototype.push"), R5 = function(n, a) {
  for (var t = "", r = 0; r < n; r += 1)
    t += a;
  return t;
}, BD = function(e, n, a) {
  return a;
}, wD = function(n) {
  var a = arguments.length > 1 ? arguments[1] : void 0, t = a && a.space || "";
  typeof t == "number" && (t = R5(t, " "));
  var r = !!a && typeof a.cycles == "boolean" && a.cycles, M = a && a.replacer ? SD(a.replacer) : BD, b = typeof a == "function" ? a : a && a.cmp, d = b && function(O) {
    var A = b.length > 2 && function(q) {
      return O[q];
    };
    return function(m, q) {
      return b(
        { key: m, value: O[m] },
        { key: q, value: O[q] },
        A ? { __proto__: null, get: A } : void 0
      );
    };
  }, c = [];
  return function O(A, m, q, y) {
    var $ = t ? `
` + R5(y, t) : "", v = t ? ": " : ":";
    if (q && q.toJSON && typeof q.toJSON == "function" && (q = q.toJSON()), q = M(A, m, q), q !== void 0) {
      if (typeof q != "object" || q === null)
        return oo(q);
      if (DD(q)) {
        for (var C = [], E = 0; E < q.length; E++) {
          var t0 = O(q, E, q[E], y + 1) || oo(null);
          HM(C, $ + t + t0);
        }
        return "[" + g5(C, ",") + $ + "]";
      }
      if (c.indexOf(q) !== -1) {
        if (r)
          return oo("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      } else
        HM(c, q);
      for (var K = TD(q).sort(d && d(q)), C = [], E = 0; E < K.length; E++) {
        var m = K[E], s0 = O(q, m, q[m], y + 1);
        if (s0) {
          var J = oo(m) + v + s0;
          HM(C, $ + t + J);
        }
      }
      return c.splice(c.indexOf(q), 1), "{" + g5(C, ",") + $ + "}";
    }
  }({ "": n }, "", n, 0);
};
const $5 = /* @__PURE__ */ I2(wD);
var yO = /* @__PURE__ */ ((e) => (e.Date = "YYYYMMDD", e.DateDashed = "YYYY-MM-DD", e.DateSlashed = "YYYY/MM/DD", e.DateDashedTime = "YYYY-MM-DDTHH:mm", e.MonthDayYear = "MMDDYYYY", e.MonthDayYearSlashed = "MM/DD/YYYY", e.ShortDayMonthDayYearSlashed = "ddd MM/DD/YYYY", e.Extended12HrTimeLeadingZeroHour = "hh:mm", e.Extended12HrTime = "h:mm", e.Extended24HrTime = "H:mm", e.Extended24HrTimeLeadingZeroHour = "HH:mm", e.Extended24HrTimeLeadingZeroHourSeconds = "HH:mm:ss", e.ShortDate = "MMM D, YYYY", e.ShortDateFull = "MMM Do, YYYY", e.LongDateFull = "MMMM Do, YYYY", e.FullWeekday = "dddd", e.ShortWeekday = "ddd", e.FullMonth = "MMMM", e.ShortMonth = "MMM", e.FullYear = "YYYY", e.FullDayOfMonth = "Do", e.FullMonthYear = "MMMM, YYYY", e.FullDayMonth = "dddd, MMMM D", e.ShortDayShortMonthFullYear = "ddd, MMM Do, YYYY", e.FullDayMonthLong = "dddd, MMMM Do", e.AmPm = "a", e.TimezoneOffset = "Z", e.ShortMonthYear = "MMM Do, YYYY", e))(yO || {}), G0 = /* @__PURE__ */ ((e) => (e.AMPM = "a", e.ShortMonthDayYear = "DD", e.ISO = "yyyy-MM-dd'T'HH:mm:ss", e.MonthDayYear = "MMddyyyy", e.MonthDayYearSlashed = "MM/dd/yyyy", e.MonthDayYearSlashedTimeAMPM = "D @ t", e.MonthDayYearSlashedTimeAMPMCompact = "MM/dd/yy @ hh:mma", e.MonthDayYearSlashedTime24 = "D @ T", e.MonthDayYearSlashedTimeNoSpace = "MM/dd/yyyy-Hmm", e.Extended12HrTimeAMPM = "t", e.Extended12HrTimePadding = "hh:mm", e.DateWithAbbreviatedMonth = "DD", e.Extended12HrTimeAMPMWithAbbreviatedNamedOffset = "t - ZZZZ", e.Extended24HrTimeWithAbbreviatedNamedOffset = "T - ZZZZ", e.Extended24HrTimeLeadingZeroHourSeconds = "TT", e.Hour12 = "h a", e.Hour24 = "H", e.Extended24HrTime = "T", e.Extended24HrTimeNoPadding = "H:mm", e.LongDateTimeShortMonth = "EEEE, DD @ t", e.LongDateTime24ShortMonthWithAbbreviatedNamedOffset = "EEEE, DD @ T (ZZZZ)", e.LongDateTimeShortMonthWithAbbreviatedNamedOffset = "EEEE, DD @ t (ZZZZ)", e.LongDateTime24ShortDayShortMonthWithAbbreviatedNamedOffset = "EEE, DD @ T (ZZZZ)", e.LongDateTimeShortDayShortMonthWithAbbreviatedNamedOffset = "EEE, DD @ t (ZZZZ)", e.LongDateTime24ShortMonth = "EEEE, DD @ T", e.LongDateLongMonth = "EEEE, MMMM d, yyyy", e.LongDateShortMonth = "EEE, DD", e.ShortMonthDayTimeAMPM = "MMM d @ t", e.ShortMonthDayTime24 = "MMM d @ T", e.ShortMonthYearDayTimeAMPM = "DD @ t", e.ShortMonthYearDayTime24 = "DD @ T", e.IANANamedOffset = "z", e.AbbreviatedNamedOffset = "ZZZZ", e.UnabbreviatedNamedOffset = "ZZZZZ", e.ShortWeekday = "EEE", e.DateDashed = "yyyy-MM-dd", e.ShortDayDateSlashed12HourZone = "EEE, D - hh:mm a (ZZZZ)", e.ShortDayDateSlashed24HourZone = "EEE, D - T (ZZZZ)", e.ShortDayDateSlashed12Hour = "EEE, D - hh:mm a", e.ShortDayDateSlashed24Hour = "EEE, D - HH:mm", e.ShortDayDateSlashed = "EEE, D", e.Extended12HrTimePaddingAMPM = "hh:mm a", e.DateSlashedTimestamp24HourTime = "D @ HH:mm", e.DateSlashedTimestamp12HourTimeAMPM = "D @ hh:mm a", e.DateSlashedDashTimestamp24HourTime = "D - HH:mm", e.DateSlashedDashTimestamp12HourTimeAMPM = "D - hh:mm a", e))(G0 || {}), CD = /* @__PURE__ */ ((e) => (e.enUS = "en-US", e))(CD || {}), WO = /* @__PURE__ */ ((e) => (e.Sunday = "Sunday", e.Monday = "Monday", e.Tuesday = "Tuesday", e.Wednesday = "Wednesday", e.Thursday = "Thursday", e.Friday = "Friday", e.Saturday = "Saturday", e))(WO || {});
const ED = ["US", "CA"], XD = [
  "America/Boise",
  "America/Chicago",
  "America/Denver",
  "America/Detroit",
  "America/Los_Angeles",
  "America/Louisville",
  "America/New_York",
  "America/North_Dakota/Beulah",
  "America/Phoenix",
  "America/Toronto",
  "Canada/Eastern",
  "Canada/Pacific",
  "CST6CDT",
  "PST8PDT",
  "US/Arizona",
  "US/Central",
  "US/Eastern",
  "US/Mountain",
  "US/Pacific",
  "US/Pacific-New"
];
function ok(e, n) {
  const a = new Date(e);
  return a.setDate(a.getDate() + n), a;
}
function rk(e) {
  const { utcDate: n, numberOfWeeks: a, timezone: t } = e;
  return W0(n).tz(t).add(a, "week").toDate();
}
function L5(e) {
  const { weekday: n, utcDate: a, timezone: t } = e, r = W0(a).tz(t), M = W0(a).tz(t).day(n);
  return M > r ? M.toDate() : M.add(1, "week").toDate();
}
function ik(e) {
  const { weekday: n, utcStartDate: a, utcEndDate: t, timezone: r } = e, M = L5({
    weekday: n,
    utcDate: a,
    timezone: r
  }), b = P.fromJSDate(t).setZone(r).day - P.fromJSDate(a).setZone(r).day, d = P.fromJSDate(
    L5({
      weekday: n,
      utcDate: t,
      timezone: r
    })
  ).plus({
    days: b
  }).toJSDate();
  return {
    start: M,
    end: d
  };
}
function Mk() {
  const e = /* @__PURE__ */ new Set();
  for (const n of ED)
    W0.tz.zonesForCountry(n).reduce((a, t) => a.add(t), e);
  return XD.forEach((n) => e.add(n)), [...e].sort();
}
function bk(e) {
  return P.fromJSDate(e).startOf("minute").toJSDate();
}
function PD(e, n) {
  return e < n ? e : n;
}
function kD(e, n) {
  return e > n ? e : n;
}
function ID(e, n) {
  const a = P.fromJSDate(e), t = P.fromJSDate(n);
  return Math.abs(t.diff(a, "millisecond").toMillis());
}
function Ve(e, n, a, t, r, M = "en") {
  return Pn(e) && (e = e.toISOString()), P.fromISO(e, {
    setZone: n === null,
    // Preserve timezone informed in the string, if none explicitly provided.
    zone: n ?? void 0
  }).toFormat(t ? r : a, {
    locale: M
  });
}
function sk(e) {
  if (R1(e) && (e = Number(e)), isNaN(e) || e === 0)
    return e === 0 ? "0 minutes" : "";
  e = Math.abs(e);
  const n = Math.floor(e / 60), a = Math.floor(e % 60), t = n > 0 ? `${n} hour${n > 1 ? "s" : ""}` : "", r = a > 0 ? `${a} minute${a > 1 ? "s" : ""}` : "";
  return [t, r].filter(Boolean).join(" and ");
}
const xD = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "60\\d{8}|(?:1\\d|[39])\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function gO(e, n) {
  var a = Array.prototype.slice.call(n);
  return a.push(xD), e.apply(this, a);
}
function RO() {
  return gO(jR, arguments);
}
function FD() {
  return gO(pr, arguments);
}
var v4 = { exports: {} }, n1 = {}, D4 = { exports: {} }, In = {};
function $O() {
  var e = {};
  return e["align-content"] = !1, e["align-items"] = !1, e["align-self"] = !1, e["alignment-adjust"] = !1, e["alignment-baseline"] = !1, e.all = !1, e["anchor-point"] = !1, e.animation = !1, e["animation-delay"] = !1, e["animation-direction"] = !1, e["animation-duration"] = !1, e["animation-fill-mode"] = !1, e["animation-iteration-count"] = !1, e["animation-name"] = !1, e["animation-play-state"] = !1, e["animation-timing-function"] = !1, e.azimuth = !1, e["backface-visibility"] = !1, e.background = !0, e["background-attachment"] = !0, e["background-clip"] = !0, e["background-color"] = !0, e["background-image"] = !0, e["background-origin"] = !0, e["background-position"] = !0, e["background-repeat"] = !0, e["background-size"] = !0, e["baseline-shift"] = !1, e.binding = !1, e.bleed = !1, e["bookmark-label"] = !1, e["bookmark-level"] = !1, e["bookmark-state"] = !1, e.border = !0, e["border-bottom"] = !0, e["border-bottom-color"] = !0, e["border-bottom-left-radius"] = !0, e["border-bottom-right-radius"] = !0, e["border-bottom-style"] = !0, e["border-bottom-width"] = !0, e["border-collapse"] = !0, e["border-color"] = !0, e["border-image"] = !0, e["border-image-outset"] = !0, e["border-image-repeat"] = !0, e["border-image-slice"] = !0, e["border-image-source"] = !0, e["border-image-width"] = !0, e["border-left"] = !0, e["border-left-color"] = !0, e["border-left-style"] = !0, e["border-left-width"] = !0, e["border-radius"] = !0, e["border-right"] = !0, e["border-right-color"] = !0, e["border-right-style"] = !0, e["border-right-width"] = !0, e["border-spacing"] = !0, e["border-style"] = !0, e["border-top"] = !0, e["border-top-color"] = !0, e["border-top-left-radius"] = !0, e["border-top-right-radius"] = !0, e["border-top-style"] = !0, e["border-top-width"] = !0, e["border-width"] = !0, e.bottom = !1, e["box-decoration-break"] = !0, e["box-shadow"] = !0, e["box-sizing"] = !0, e["box-snap"] = !0, e["box-suppress"] = !0, e["break-after"] = !0, e["break-before"] = !0, e["break-inside"] = !0, e["caption-side"] = !1, e.chains = !1, e.clear = !0, e.clip = !1, e["clip-path"] = !1, e["clip-rule"] = !1, e.color = !0, e["color-interpolation-filters"] = !0, e["column-count"] = !1, e["column-fill"] = !1, e["column-gap"] = !1, e["column-rule"] = !1, e["column-rule-color"] = !1, e["column-rule-style"] = !1, e["column-rule-width"] = !1, e["column-span"] = !1, e["column-width"] = !1, e.columns = !1, e.contain = !1, e.content = !1, e["counter-increment"] = !1, e["counter-reset"] = !1, e["counter-set"] = !1, e.crop = !1, e.cue = !1, e["cue-after"] = !1, e["cue-before"] = !1, e.cursor = !1, e.direction = !1, e.display = !0, e["display-inside"] = !0, e["display-list"] = !0, e["display-outside"] = !0, e["dominant-baseline"] = !1, e.elevation = !1, e["empty-cells"] = !1, e.filter = !1, e.flex = !1, e["flex-basis"] = !1, e["flex-direction"] = !1, e["flex-flow"] = !1, e["flex-grow"] = !1, e["flex-shrink"] = !1, e["flex-wrap"] = !1, e.float = !1, e["float-offset"] = !1, e["flood-color"] = !1, e["flood-opacity"] = !1, e["flow-from"] = !1, e["flow-into"] = !1, e.font = !0, e["font-family"] = !0, e["font-feature-settings"] = !0, e["font-kerning"] = !0, e["font-language-override"] = !0, e["font-size"] = !0, e["font-size-adjust"] = !0, e["font-stretch"] = !0, e["font-style"] = !0, e["font-synthesis"] = !0, e["font-variant"] = !0, e["font-variant-alternates"] = !0, e["font-variant-caps"] = !0, e["font-variant-east-asian"] = !0, e["font-variant-ligatures"] = !0, e["font-variant-numeric"] = !0, e["font-variant-position"] = !0, e["font-weight"] = !0, e.grid = !1, e["grid-area"] = !1, e["grid-auto-columns"] = !1, e["grid-auto-flow"] = !1, e["grid-auto-rows"] = !1, e["grid-column"] = !1, e["grid-column-end"] = !1, e["grid-column-start"] = !1, e["grid-row"] = !1, e["grid-row-end"] = !1, e["grid-row-start"] = !1, e["grid-template"] = !1, e["grid-template-areas"] = !1, e["grid-template-columns"] = !1, e["grid-template-rows"] = !1, e["hanging-punctuation"] = !1, e.height = !0, e.hyphens = !1, e.icon = !1, e["image-orientation"] = !1, e["image-resolution"] = !1, e["ime-mode"] = !1, e["initial-letters"] = !1, e["inline-box-align"] = !1, e["justify-content"] = !1, e["justify-items"] = !1, e["justify-self"] = !1, e.left = !1, e["letter-spacing"] = !0, e["lighting-color"] = !0, e["line-box-contain"] = !1, e["line-break"] = !1, e["line-grid"] = !1, e["line-height"] = !1, e["line-snap"] = !1, e["line-stacking"] = !1, e["line-stacking-ruby"] = !1, e["line-stacking-shift"] = !1, e["line-stacking-strategy"] = !1, e["list-style"] = !0, e["list-style-image"] = !0, e["list-style-position"] = !0, e["list-style-type"] = !0, e.margin = !0, e["margin-bottom"] = !0, e["margin-left"] = !0, e["margin-right"] = !0, e["margin-top"] = !0, e["marker-offset"] = !1, e["marker-side"] = !1, e.marks = !1, e.mask = !1, e["mask-box"] = !1, e["mask-box-outset"] = !1, e["mask-box-repeat"] = !1, e["mask-box-slice"] = !1, e["mask-box-source"] = !1, e["mask-box-width"] = !1, e["mask-clip"] = !1, e["mask-image"] = !1, e["mask-origin"] = !1, e["mask-position"] = !1, e["mask-repeat"] = !1, e["mask-size"] = !1, e["mask-source-type"] = !1, e["mask-type"] = !1, e["max-height"] = !0, e["max-lines"] = !1, e["max-width"] = !0, e["min-height"] = !0, e["min-width"] = !0, e["move-to"] = !1, e["nav-down"] = !1, e["nav-index"] = !1, e["nav-left"] = !1, e["nav-right"] = !1, e["nav-up"] = !1, e["object-fit"] = !1, e["object-position"] = !1, e.opacity = !1, e.order = !1, e.orphans = !1, e.outline = !1, e["outline-color"] = !1, e["outline-offset"] = !1, e["outline-style"] = !1, e["outline-width"] = !1, e.overflow = !1, e["overflow-wrap"] = !1, e["overflow-x"] = !1, e["overflow-y"] = !1, e.padding = !0, e["padding-bottom"] = !0, e["padding-left"] = !0, e["padding-right"] = !0, e["padding-top"] = !0, e.page = !1, e["page-break-after"] = !1, e["page-break-before"] = !1, e["page-break-inside"] = !1, e["page-policy"] = !1, e.pause = !1, e["pause-after"] = !1, e["pause-before"] = !1, e.perspective = !1, e["perspective-origin"] = !1, e.pitch = !1, e["pitch-range"] = !1, e["play-during"] = !1, e.position = !1, e["presentation-level"] = !1, e.quotes = !1, e["region-fragment"] = !1, e.resize = !1, e.rest = !1, e["rest-after"] = !1, e["rest-before"] = !1, e.richness = !1, e.right = !1, e.rotation = !1, e["rotation-point"] = !1, e["ruby-align"] = !1, e["ruby-merge"] = !1, e["ruby-position"] = !1, e["shape-image-threshold"] = !1, e["shape-outside"] = !1, e["shape-margin"] = !1, e.size = !1, e.speak = !1, e["speak-as"] = !1, e["speak-header"] = !1, e["speak-numeral"] = !1, e["speak-punctuation"] = !1, e["speech-rate"] = !1, e.stress = !1, e["string-set"] = !1, e["tab-size"] = !1, e["table-layout"] = !1, e["text-align"] = !0, e["text-align-last"] = !0, e["text-combine-upright"] = !0, e["text-decoration"] = !0, e["text-decoration-color"] = !0, e["text-decoration-line"] = !0, e["text-decoration-skip"] = !0, e["text-decoration-style"] = !0, e["text-emphasis"] = !0, e["text-emphasis-color"] = !0, e["text-emphasis-position"] = !0, e["text-emphasis-style"] = !0, e["text-height"] = !0, e["text-indent"] = !0, e["text-justify"] = !0, e["text-orientation"] = !0, e["text-overflow"] = !0, e["text-shadow"] = !0, e["text-space-collapse"] = !0, e["text-transform"] = !0, e["text-underline-position"] = !0, e["text-wrap"] = !0, e.top = !1, e.transform = !1, e["transform-origin"] = !1, e["transform-style"] = !1, e.transition = !1, e["transition-delay"] = !1, e["transition-duration"] = !1, e["transition-property"] = !1, e["transition-timing-function"] = !1, e["unicode-bidi"] = !1, e["vertical-align"] = !1, e.visibility = !1, e["voice-balance"] = !1, e["voice-duration"] = !1, e["voice-family"] = !1, e["voice-pitch"] = !1, e["voice-range"] = !1, e["voice-rate"] = !1, e["voice-stress"] = !1, e["voice-volume"] = !1, e.volume = !1, e["white-space"] = !1, e.widows = !1, e.width = !0, e["will-change"] = !1, e["word-break"] = !0, e["word-spacing"] = !0, e["word-wrap"] = !0, e["wrap-flow"] = !1, e["wrap-through"] = !1, e["writing-mode"] = !1, e["z-index"] = !1, e;
}
function HD(e, n, a) {
}
function UD(e, n, a) {
}
var jD = /javascript\s*\:/img;
function GD(e, n) {
  return jD.test(n) ? "" : n;
}
In.whiteList = $O();
In.getDefaultWhiteList = $O;
In.onAttr = HD;
In.onIgnoreAttr = UD;
In.safeAttrValue = GD;
var VD = {
  indexOf: function(e, n) {
    var a, t;
    if (Array.prototype.indexOf)
      return e.indexOf(n);
    for (a = 0, t = e.length; a < t; a++)
      if (e[a] === n)
        return a;
    return -1;
  },
  forEach: function(e, n, a) {
    var t, r;
    if (Array.prototype.forEach)
      return e.forEach(n, a);
    for (t = 0, r = e.length; t < r; t++)
      n.call(a, e[t], t, e);
  },
  trim: function(e) {
    return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
  },
  trimRight: function(e) {
    return String.prototype.trimRight ? e.trimRight() : e.replace(/(\s*$)/g, "");
  }
}, dt = VD;
function YD(e, n) {
  e = dt.trimRight(e), e[e.length - 1] !== ";" && (e += ";");
  var a = e.length, t = !1, r = 0, M = 0, b = "";
  function d() {
    if (!t) {
      var A = dt.trim(e.slice(r, M)), m = A.indexOf(":");
      if (m !== -1) {
        var q = dt.trim(A.slice(0, m)), y = dt.trim(A.slice(m + 1));
        if (q) {
          var $ = n(r, b.length, q, y, A);
          $ && (b += $ + "; ");
        }
      }
    }
    r = M + 1;
  }
  for (; M < a; M++) {
    var c = e[M];
    if (c === "/" && e[M + 1] === "*") {
      var O = e.indexOf("*/", M + 2);
      if (O === -1) break;
      M = O + 1, r = M + 1, t = !1;
    } else c === "(" ? t = !0 : c === ")" ? t = !1 : c === ";" ? t || d() : c === `
` && d();
  }
  return dt.trim(b);
}
var JD = YD, ro = In, KD = JD;
function _5(e) {
  return e == null;
}
function ZD(e) {
  var n = {};
  for (var a in e)
    n[a] = e[a];
  return n;
}
function LO(e) {
  e = ZD(e || {}), e.whiteList = e.whiteList || ro.whiteList, e.onAttr = e.onAttr || ro.onAttr, e.onIgnoreAttr = e.onIgnoreAttr || ro.onIgnoreAttr, e.safeAttrValue = e.safeAttrValue || ro.safeAttrValue, this.options = e;
}
LO.prototype.process = function(e) {
  if (e = e || "", e = e.toString(), !e) return "";
  var n = this, a = n.options, t = a.whiteList, r = a.onAttr, M = a.onIgnoreAttr, b = a.safeAttrValue, d = KD(e, function(c, O, A, m, q) {
    var y = t[A], $ = !1;
    if (y === !0 ? $ = y : typeof y == "function" ? $ = y(m) : y instanceof RegExp && ($ = y.test(m)), $ !== !0 && ($ = !1), m = b(A, m), !!m) {
      var v = {
        position: O,
        sourcePosition: c,
        source: q,
        isWhite: $
      };
      if ($) {
        var E = r(A, m, v);
        return _5(E) ? A + ":" + m : E;
      } else {
        var E = M(A, m, v);
        if (!_5(E))
          return E;
      }
    }
  });
  return d;
};
var QD = LO;
(function(e, n) {
  var a = In, t = QD;
  function r(b, d) {
    var c = new t(d);
    return c.process(b);
  }
  n = e.exports = r, n.FilterCSS = t;
  for (var M in a) n[M] = a[M];
  typeof window < "u" && (window.filterCSS = e.exports);
})(D4, D4.exports);
var vb = D4.exports, Db = {
  indexOf: function(e, n) {
    var a, t;
    if (Array.prototype.indexOf)
      return e.indexOf(n);
    for (a = 0, t = e.length; a < t; a++)
      if (e[a] === n)
        return a;
    return -1;
  },
  forEach: function(e, n, a) {
    var t, r;
    if (Array.prototype.forEach)
      return e.forEach(n, a);
    for (t = 0, r = e.length; t < r; t++)
      n.call(a, e[t], t, e);
  },
  trim: function(e) {
    return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function(e) {
    var n = /\s|\n|\t/, a = n.exec(e);
    return a ? a.index : -1;
  }
}, eT = vb.FilterCSS, nT = vb.getDefaultWhiteList, Ho = Db;
function _O() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "preload",
      "src"
    ],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    figcaption: [],
    figure: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height", "loading"],
    ins: ["datetime"],
    kbd: [],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    summary: [],
    sup: [],
    strong: [],
    strike: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "playsinline",
      "poster",
      "preload",
      "src",
      "height",
      "width"
    ]
  };
}
var NO = new eT();
function aT(e, n, a) {
}
function tT(e, n, a) {
}
function oT(e, n, a) {
}
function rT(e, n, a) {
}
function vO(e) {
  return e.replace(MT, "&lt;").replace(bT, "&gt;");
}
function iT(e, n, a, t) {
  if (a = CO(a), n === "href" || n === "src") {
    if (a = Ho.trim(a), a === "#") return "#";
    if (!(a.substr(0, 7) === "http://" || a.substr(0, 8) === "https://" || a.substr(0, 7) === "mailto:" || a.substr(0, 4) === "tel:" || a.substr(0, 11) === "data:image/" || a.substr(0, 6) === "ftp://" || a.substr(0, 2) === "./" || a.substr(0, 3) === "../" || a[0] === "#" || a[0] === "/"))
      return "";
  } else if (n === "background") {
    if (io.lastIndex = 0, io.test(a))
      return "";
  } else if (n === "style") {
    if (N5.lastIndex = 0, N5.test(a) || (v5.lastIndex = 0, v5.test(a) && (io.lastIndex = 0, io.test(a))))
      return "";
    t !== !1 && (t = t || NO, a = t.process(a));
  }
  return a = EO(a), a;
}
var MT = /</g, bT = />/g, sT = /"/g, dT = /&quot;/g, pT = /&#([a-zA-Z0-9]*);?/gim, cT = /&colon;?/gim, zT = /&newline;?/gim, io = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi, N5 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi, v5 = /u\s*r\s*l\s*\(.*/gi;
function DO(e) {
  return e.replace(sT, "&quot;");
}
function TO(e) {
  return e.replace(dT, '"');
}
function SO(e) {
  return e.replace(pT, function(a, t) {
    return t[0] === "x" || t[0] === "X" ? String.fromCharCode(parseInt(t.substr(1), 16)) : String.fromCharCode(parseInt(t, 10));
  });
}
function BO(e) {
  return e.replace(cT, ":").replace(zT, " ");
}
function wO(e) {
  for (var n = "", a = 0, t = e.length; a < t; a++)
    n += e.charCodeAt(a) < 32 ? " " : e.charAt(a);
  return Ho.trim(n);
}
function CO(e) {
  return e = TO(e), e = SO(e), e = BO(e), e = wO(e), e;
}
function EO(e) {
  return e = DO(e), e = vO(e), e;
}
function OT() {
  return "";
}
function uT(e, n) {
  typeof n != "function" && (n = function() {
  });
  var a = !Array.isArray(e);
  function t(b) {
    return a ? !0 : Ho.indexOf(e, b) !== -1;
  }
  var r = [], M = !1;
  return {
    onIgnoreTag: function(b, d, c) {
      if (t(b))
        if (c.isClosing) {
          var O = "[/removed]", A = c.position + O.length;
          return r.push([
            M !== !1 ? M : c.position,
            A
          ]), M = !1, O;
        } else
          return M || (M = c.position), "[removed]";
      else
        return n(b, d, c);
    },
    remove: function(b) {
      var d = "", c = 0;
      return Ho.forEach(r, function(O) {
        d += b.slice(c, O[0]), c = O[1];
      }), d += b.slice(c), d;
    }
  };
}
function AT(e) {
  for (var n = "", a = 0; a < e.length; ) {
    var t = e.indexOf("<!--", a);
    if (t === -1) {
      n += e.slice(a);
      break;
    }
    n += e.slice(a, t);
    var r = e.indexOf("-->", t);
    if (r === -1)
      break;
    a = r + 3;
  }
  return n;
}
function lT(e) {
  var n = e.split("");
  return n = n.filter(function(a) {
    var t = a.charCodeAt(0);
    return t === 127 ? !1 : t <= 31 ? t === 10 || t === 13 : !0;
  }), n.join("");
}
n1.whiteList = _O();
n1.getDefaultWhiteList = _O;
n1.onTag = aT;
n1.onIgnoreTag = tT;
n1.onTagAttr = oT;
n1.onIgnoreTagAttr = rT;
n1.safeAttrValue = iT;
n1.escapeHtml = vO;
n1.escapeQuote = DO;
n1.unescapeQuote = TO;
n1.escapeHtmlEntities = SO;
n1.escapeDangerHtml5Entities = BO;
n1.clearNonPrintableCharacter = wO;
n1.friendlyAttrValue = CO;
n1.escapeAttrValue = EO;
n1.onIgnoreTagStripAll = OT;
n1.StripTagBody = uT;
n1.stripCommentTag = AT;
n1.stripBlankChar = lT;
n1.attributeWrapSign = '"';
n1.cssFilter = NO;
n1.getDefaultCSSWhiteList = nT;
var Rr = {}, Ye = Db;
function fT(e) {
  var n = Ye.spaceIndex(e), a;
  return n === -1 ? a = e.slice(1, -1) : a = e.slice(1, n + 1), a = Ye.trim(a).toLowerCase(), a.slice(0, 1) === "/" && (a = a.slice(1)), a.slice(-1) === "/" && (a = a.slice(0, -1)), a;
}
function mT(e) {
  return e.slice(0, 2) === "</";
}
function qT(e, n, a) {
  var t = "", r = 0, M = !1, b = !1, d = 0, c = e.length, O = "", A = "";
  e: for (d = 0; d < c; d++) {
    var m = e.charAt(d);
    if (M === !1) {
      if (m === "<") {
        M = d;
        continue;
      }
    } else if (b === !1) {
      if (m === "<") {
        t += a(e.slice(r, d)), M = d, r = d;
        continue;
      }
      if (m === ">" || d === c - 1) {
        t += a(e.slice(r, M)), A = e.slice(M, d + 1), O = fT(A), t += n(
          M,
          t.length,
          O,
          A,
          mT(A)
        ), r = d + 1, M = !1;
        continue;
      }
      if (m === '"' || m === "'")
        for (var q = 1, y = e.charAt(d - q); y.trim() === "" || y === "="; ) {
          if (y === "=") {
            b = m;
            continue e;
          }
          y = e.charAt(d - ++q);
        }
    } else if (m === b) {
      b = !1;
      continue;
    }
  }
  return r < c && (t += a(e.substr(r))), t;
}
var hT = /[^a-zA-Z0-9\\_:.-]/gim;
function yT(e, n) {
  var a = 0, t = 0, r = [], M = !1, b = e.length;
  function d(q, y) {
    if (q = Ye.trim(q), q = q.replace(hT, "").toLowerCase(), !(q.length < 1)) {
      var $ = n(q, y || "");
      $ && r.push($);
    }
  }
  for (var c = 0; c < b; c++) {
    var O = e.charAt(c), A, m;
    if (M === !1 && O === "=") {
      M = e.slice(a, c), a = c + 1, t = e.charAt(a) === '"' || e.charAt(a) === "'" ? a : gT(e, c + 1);
      continue;
    }
    if (M !== !1 && c === t) {
      if (m = e.indexOf(O, c + 1), m === -1)
        break;
      A = Ye.trim(e.slice(t + 1, m)), d(M, A), M = !1, c = m, a = c + 1;
      continue;
    }
    if (/\s|\n|\t/.test(O))
      if (e = e.replace(/\s|\n|\t/g, " "), M === !1)
        if (m = WT(e, c), m === -1) {
          A = Ye.trim(e.slice(a, c)), d(A), M = !1, a = c + 1;
          continue;
        } else {
          c = m - 1;
          continue;
        }
      else if (m = RT(e, c - 1), m === -1) {
        A = Ye.trim(e.slice(a, c)), A = D5(A), d(M, A), M = !1, a = c + 1;
        continue;
      } else
        continue;
  }
  return a < e.length && (M === !1 ? d(e.slice(a)) : d(M, D5(Ye.trim(e.slice(a))))), Ye.trim(r.join(" "));
}
function WT(e, n) {
  for (; n < e.length; n++) {
    var a = e[n];
    if (a !== " ")
      return a === "=" ? n : -1;
  }
}
function gT(e, n) {
  for (; n < e.length; n++) {
    var a = e[n];
    if (a !== " ")
      return a === "'" || a === '"' ? n : -1;
  }
}
function RT(e, n) {
  for (; n > 0; n--) {
    var a = e[n];
    if (a !== " ")
      return a === "=" ? n : -1;
  }
}
function $T(e) {
  return e[0] === '"' && e[e.length - 1] === '"' || e[0] === "'" && e[e.length - 1] === "'";
}
function D5(e) {
  return $T(e) ? e.substr(1, e.length - 2) : e;
}
Rr.parseTag = qT;
Rr.parseAttr = yT;
var LT = vb.FilterCSS, A2 = n1, XO = Rr, _T = XO.parseTag, NT = XO.parseAttr, $o = Db;
function Mo(e) {
  return e == null;
}
function vT(e) {
  var n = $o.spaceIndex(e);
  if (n === -1)
    return {
      html: "",
      closing: e[e.length - 2] === "/"
    };
  e = $o.trim(e.slice(n + 1, -1));
  var a = e[e.length - 1] === "/";
  return a && (e = $o.trim(e.slice(0, -1))), {
    html: e,
    closing: a
  };
}
function DT(e) {
  var n = {};
  for (var a in e)
    n[a] = e[a];
  return n;
}
function TT(e) {
  var n = {};
  for (var a in e)
    Array.isArray(e[a]) ? n[a.toLowerCase()] = e[a].map(function(t) {
      return t.toLowerCase();
    }) : n[a.toLowerCase()] = e[a];
  return n;
}
function PO(e) {
  e = DT(e || {}), e.stripIgnoreTag && (e.onIgnoreTag && console.error(
    'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
  ), e.onIgnoreTag = A2.onIgnoreTagStripAll), e.whiteList || e.allowList ? e.whiteList = TT(e.whiteList || e.allowList) : e.whiteList = A2.whiteList, this.attributeWrapSign = e.singleQuotedAttributeValue === !0 ? "'" : A2.attributeWrapSign, e.onTag = e.onTag || A2.onTag, e.onTagAttr = e.onTagAttr || A2.onTagAttr, e.onIgnoreTag = e.onIgnoreTag || A2.onIgnoreTag, e.onIgnoreTagAttr = e.onIgnoreTagAttr || A2.onIgnoreTagAttr, e.safeAttrValue = e.safeAttrValue || A2.safeAttrValue, e.escapeHtml = e.escapeHtml || A2.escapeHtml, this.options = e, e.css === !1 ? this.cssFilter = !1 : (e.css = e.css || {}, this.cssFilter = new LT(e.css));
}
PO.prototype.process = function(e) {
  if (e = e || "", e = e.toString(), !e) return "";
  var n = this, a = n.options, t = a.whiteList, r = a.onTag, M = a.onIgnoreTag, b = a.onTagAttr, d = a.onIgnoreTagAttr, c = a.safeAttrValue, O = a.escapeHtml, A = n.attributeWrapSign, m = n.cssFilter;
  a.stripBlankChar && (e = A2.stripBlankChar(e)), a.allowCommentTag || (e = A2.stripCommentTag(e));
  var q = !1;
  a.stripIgnoreTagBody && (q = A2.StripTagBody(
    a.stripIgnoreTagBody,
    M
  ), M = q.onIgnoreTag);
  var y = _T(
    e,
    function($, v, E, t0, K) {
      var C = {
        sourcePosition: $,
        position: v,
        isClosing: K,
        isWhite: Object.prototype.hasOwnProperty.call(t, E)
      }, s0 = r(E, t0, C);
      if (!Mo(s0)) return s0;
      if (C.isWhite) {
        if (C.isClosing)
          return "</" + E + ">";
        var J = vT(t0), I0 = t[E], g0 = NT(J.html, function(S0, u0) {
          var F2 = $o.indexOf(I0, S0) !== -1, o2 = b(E, S0, u0, F2);
          return Mo(o2) ? F2 ? (u0 = c(E, S0, u0, m), u0 ? S0 + "=" + A + u0 + A : S0) : (o2 = d(E, S0, u0, F2), Mo(o2) ? void 0 : o2) : o2;
        });
        return t0 = "<" + E, g0 && (t0 += " " + g0), J.closing && (t0 += " /"), t0 += ">", t0;
      } else
        return s0 = M(E, t0, C), Mo(s0) ? O(t0) : s0;
    },
    O
  );
  return q && (y = q.remove(y)), y;
};
var ST = PO;
(function(e, n) {
  var a = n1, t = Rr, r = ST;
  function M(d, c) {
    var O = new r(c);
    return O.process(d);
  }
  n = e.exports = M, n.filterXSS = M, n.FilterXSS = r, function() {
    for (var d in a)
      n[d] = a[d];
    for (var c in t)
      n[c] = t[c];
  }(), typeof window < "u" && (window.filterXSS = e.exports);
  function b() {
    return typeof self < "u" && typeof DedicatedWorkerGlobalScope < "u" && self instanceof DedicatedWorkerGlobalScope;
  }
  b() && (self.filterXSS = e.exports);
})(v4, v4.exports);
var BT = v4.exports;
const j0 = {
  AFG: { name: "Afghanistan", iso2: "AF" },
  ALA: { name: "Åland Islands", iso2: "AX" },
  ALB: { name: "Albania", iso2: "AL" },
  DZA: { name: "Algeria", iso2: "DZ" },
  ASM: { name: "American Samoa", iso2: "AS" },
  AND: { name: "Andorra", iso2: "AD" },
  AGO: { name: "Angola", iso2: "AO" },
  AIA: { name: "Anguilla", iso2: "AI" },
  ATA: { name: "Antarctica", iso2: "AQ" },
  ATG: { name: "Antigua and Barbuda", iso2: "AG" },
  ARG: { name: "Argentina", iso2: "AR" },
  ARM: { name: "Armenia", iso2: "AM" },
  ABW: { name: "Aruba", iso2: "AW" },
  AUS: { name: "Australia", iso2: "AU" },
  AUT: { name: "Austria", iso2: "AT" },
  AZE: { name: "Azerbaijan", iso2: "AZ" },
  BHS: { name: "Bahamas", iso2: "BS" },
  BHR: { name: "Bahrain", iso2: "BH" },
  BGD: { name: "Bangladesh", iso2: "BD" },
  BRB: { name: "Barbados", iso2: "BB" },
  BLR: { name: "Belarus", iso2: "BY" },
  BEL: { name: "Belgium", iso2: "BE" },
  BLZ: { name: "Belize", iso2: "BZ" },
  BEN: { name: "Benin", iso2: "BJ" },
  BMU: { name: "Bermuda", iso2: "BM" },
  BTN: { name: "Bhutan", iso2: "BT" },
  BOL: { name: "Bolivia", iso2: "BO" },
  BES: { name: "Bonaire, Sint Eustatius and Saba", iso2: "BQ" },
  BIH: { name: "Bosnia and Herzegovina", iso2: "BA" },
  BWA: { name: "Botswana", iso2: "BW" },
  BVT: { name: "Bouvet Island", iso2: "BV" },
  BRA: { name: "Brazil", iso2: "BR" },
  IOT: { name: "British Indian Ocean Territory", iso2: "IO" },
  BRN: { name: "Brunei Darussalam", iso2: "BN" },
  BGR: { name: "Bulgaria", iso2: "BG" },
  BFA: { name: "Burkina Faso", iso2: "BF" },
  BDI: { name: "Burundi", iso2: "BI" },
  CPV: { name: "Cabo Verde", iso2: "CV" },
  KHM: { name: "Cambodia", iso2: "KH" },
  CMR: { name: "Cameroon", iso2: "CM" },
  CAN: { name: "Canada", iso2: "CA" },
  CYM: { name: "Cayman Islands", iso2: "KY" },
  CAF: { name: "Central African Republic", iso2: "CF" },
  TCD: { name: "Chad", iso2: "TD" },
  CHL: { name: "Chile", iso2: "CL" },
  CHN: { name: "China", iso2: "CN" },
  CXR: { name: "Christmas Island", iso2: "CX" },
  CCK: { name: "Cocos (Keeling) Islands", iso2: "CC" },
  COL: { name: "Colombia", iso2: "CO" },
  COM: { name: "Comoros", iso2: "KM" },
  COG: { name: "Congo", iso2: "CG" },
  COD: { name: "Congo, Democratic Republic of the", iso2: "CD" },
  COK: { name: "Cook Islands", iso2: "CK" },
  CRI: { name: "Costa Rica", iso2: "CR" },
  CIV: { name: 'Côte d"Ivoire', iso2: "CI" },
  HRV: { name: "Croatia", iso2: "HR" },
  CUB: { name: "Cuba", iso2: "CU" },
  CUW: { name: "Curaçao", iso2: "CW" },
  CYP: { name: "Cyprus", iso2: "CY" },
  CZE: { name: "Czechia", iso2: "CZ" },
  DNK: { name: "Denmark", iso2: "DK" },
  DJI: { name: "Djibouti", iso2: "DJ" },
  DMA: { name: "Dominica", iso2: "DM" },
  DOM: { name: "Dominican Republic", iso2: "DO" },
  ECU: { name: "Ecuador", iso2: "EC" },
  EGY: { name: "Egypt", iso2: "EG" },
  SLV: { name: "El Salvador", iso2: "SV" },
  GNQ: { name: "Equatorial Guinea", iso2: "GQ" },
  ERI: { name: "Eritrea", iso2: "ER" },
  EST: { name: "Estonia", iso2: "EE" },
  SWZ: { name: "Eswatini", iso2: "SZ" },
  ETH: { name: "Ethiopia", iso2: "ET" },
  FLK: { name: "Falkland Islands (Malvinas)", iso2: "FK" },
  FRO: { name: "Faroe Islands", iso2: "FO" },
  FJI: { name: "Fiji", iso2: "FJ" },
  FIN: { name: "Finland", iso2: "FI" },
  FRA: { name: "France", iso2: "FR" },
  GUF: { name: "French Guiana", iso2: "GF" },
  PYF: { name: "French Polynesia", iso2: "PF" },
  ATF: { name: "French Southern Territories", iso2: "TF" },
  GAB: { name: "Gabon", iso2: "GA" },
  GMB: { name: "Gambia", iso2: "GM" },
  GEO: { name: "Georgia", iso2: "GE" },
  DEU: { name: "Germany", iso2: "DE" },
  GHA: { name: "Ghana", iso2: "GH" },
  GIB: { name: "Gibraltar", iso2: "GI" },
  GRC: { name: "Greece", iso2: "GR" },
  GRL: { name: "Greenland", iso2: "GL" },
  GRD: { name: "Grenada", iso2: "GD" },
  GLP: { name: "Guadeloupe", iso2: "GP" },
  GUM: { name: "Guam", iso2: "GU" },
  GTM: { name: "Guatemala", iso2: "GT" },
  GGY: { name: "Guernsey", iso2: "GG" },
  GIN: { name: "Guinea", iso2: "GN" },
  GNB: { name: "Guinea-Bissau", iso2: "GW" },
  GUY: { name: "Guyana", iso2: "GY" },
  HTI: { name: "Haiti", iso2: "HT" },
  HMD: { name: "Heard Island and McDonald Islands", iso2: "HM" },
  VAT: { name: "Holy See", iso2: "VA" },
  HND: { name: "Honduras", iso2: "HN" },
  HKG: { name: "Hong Kong", iso2: "HK" },
  HUN: { name: "Hungary", iso2: "HU" },
  ISL: { name: "Iceland", iso2: "IS" },
  IND: { name: "India", iso2: "IN" },
  IDN: { name: "Indonesia", iso2: "ID" },
  IRN: { name: "Iran", iso2: "IR" },
  IRQ: { name: "Iraq", iso2: "IQ" },
  IRL: { name: "Ireland", iso2: "IE" },
  IMN: { name: "Isle of Man", iso2: "IM" },
  ISR: { name: "Israel", iso2: "IL" },
  ITA: { name: "Italy", iso2: "IT" },
  JAM: { name: "Jamaica", iso2: "JM" },
  JPN: { name: "Japan", iso2: "JP" },
  JEY: { name: "Jersey", iso2: "JE" },
  JOR: { name: "Jordan", iso2: "JO" },
  KAZ: { name: "Kazakhstan", iso2: "KZ" },
  KEN: { name: "Kenya", iso2: "KE" },
  KIR: { name: "Kiribati", iso2: "KI" },
  PRK: { name: "North Korea", iso2: "KP" },
  KOR: { name: "South Korea", iso2: "KR" },
  KWT: { name: "Kuwait", iso2: "KW" },
  KGZ: { name: "Kyrgyzstan", iso2: "KG" },
  LAO: { name: "Laos", iso2: "LA" },
  LVA: { name: "Latvia", iso2: "LV" },
  LBN: { name: "Lebanon", iso2: "LB" },
  LSO: { name: "Lesotho", iso2: "LS" },
  LBR: { name: "Liberia", iso2: "LR" },
  LBY: { name: "Libya", iso2: "LY" },
  LIE: { name: "Liechtenstein", iso2: "LI" },
  LTU: { name: "Lithuania", iso2: "LT" },
  LUX: { name: "Luxembourg", iso2: "LU" },
  MAC: { name: "Macao", iso2: "MO" },
  MDG: { name: "Madagascar", iso2: "MG" },
  MWI: { name: "Malawi", iso2: "MW" },
  MYS: { name: "Malaysia", iso2: "MY" },
  MDV: { name: "Maldives", iso2: "MV" },
  MLI: { name: "Mali", iso2: "ML" },
  MLT: { name: "Malta", iso2: "MT" },
  MHL: { name: "Marshall Islands", iso2: "MH" },
  MTQ: { name: "Martinique", iso2: "MQ" },
  MRT: { name: "Mauritania", iso2: "MR" },
  MUS: { name: "Mauritius", iso2: "MU" },
  MYT: { name: "Mayotte", iso2: "YT" },
  MEX: { name: "Mexico", iso2: "MX" },
  FSM: { name: "Micronesia", iso2: "FM" },
  MDA: { name: "Moldova", iso2: "MD" },
  MCO: { name: "Monaco", iso2: "MC" },
  MNG: { name: "Mongolia", iso2: "MN" },
  MNE: { name: "Montenegro", iso2: "ME" },
  MSR: { name: "Montserrat", iso2: "MS" },
  MAR: { name: "Morocco", iso2: "MA" },
  MOZ: { name: "Mozambique", iso2: "MZ" },
  MMR: { name: "Myanmar", iso2: "MM" },
  NAM: { name: "Namibia", iso2: "NA" },
  NRU: { name: "Nauru", iso2: "NR" },
  NPL: { name: "Nepal", iso2: "NP" },
  NLD: { name: "Netherlands", iso2: "NL" },
  NCL: { name: "New Caledonia", iso2: "NC" },
  NZL: { name: "New Zealand", iso2: "NZ" },
  NIC: { name: "Nicaragua", iso2: "NI" },
  NER: { name: "Niger", iso2: "NE" },
  NGA: { name: "Nigeria", iso2: "NG" },
  NIU: { name: "Niue", iso2: "NU" },
  NFK: { name: "Norfolk Island", iso2: "NF" },
  MKD: { name: "North Macedonia", iso2: "MK" },
  MNP: { name: "Northern Mariana Islands", iso2: "MP" },
  NOR: { name: "Norway", iso2: "NO" },
  OMN: { name: "Oman", iso2: "OM" },
  PAK: { name: "Pakistan", iso2: "PK" },
  PLW: { name: "Palau", iso2: "PW" },
  PSE: { name: "Palestine", iso2: "PS" },
  PAN: { name: "Panama", iso2: "PA" },
  PNG: { name: "Papua New Guinea", iso2: "PG" },
  PRY: { name: "Paraguay", iso2: "PY" },
  PER: { name: "Peru", iso2: "PE" },
  PHL: { name: "Philippines", iso2: "PH" },
  PCN: { name: "Pitcairn", iso2: "PN" },
  POL: { name: "Poland", iso2: "PL" },
  PRT: { name: "Portugal", iso2: "PT" },
  PRI: { name: "Puerto Rico", iso2: "PR" },
  QAT: { name: "Qatar", iso2: "QA" },
  REU: { name: "Réunion", iso2: "RE" },
  ROU: { name: "Romania", iso2: "RO" },
  RUS: { name: "Russia", iso2: "RU" },
  RWA: { name: "Rwanda", iso2: "RW" },
  BLM: { name: "Saint Barthélemy", iso2: "BL" },
  SHN: { name: "Saint Helena, Ascension and Tristan da Cunha", iso2: "SH" },
  KNA: { name: "Saint Kitts and Nevis", iso2: "KN" },
  LCA: { name: "Saint Lucia", iso2: "LC" },
  MAF: { name: "Saint Martin (French part)", iso2: "MF" },
  SPM: { name: "Saint Pierre and Miquelon", iso2: "PM" },
  VCT: { name: "Saint Vincent and the Grenadines", iso2: "VC" },
  WSM: { name: "Samoa", iso2: "WS" },
  SMR: { name: "San Marino", iso2: "SM" },
  STP: { name: "Sao Tome and Principe", iso2: "ST" },
  SAU: { name: "Saudi Arabia", iso2: "SA" },
  SEN: { name: "Senegal", iso2: "SN" },
  SRB: { name: "Serbia", iso2: "RS" },
  SYC: { name: "Seychelles", iso2: "SC" },
  SLE: { name: "Sierra Leone", iso2: "SL" },
  SGP: { name: "Singapore", iso2: "SG" },
  SXM: { name: "Sint Maarten (Dutch part)", iso2: "SX" },
  SVK: { name: "Slovakia", iso2: "SK" },
  SVN: { name: "Slovenia", iso2: "SI" },
  SLB: { name: "Solomon Islands", iso2: "SB" },
  SOM: { name: "Somalia", iso2: "SO" },
  ZAF: { name: "South Africa", iso2: "ZA" },
  SGS: { name: "South Georgia and the South Sandwich Islands", iso2: "GS" },
  SSD: { name: "South Sudan", iso2: "SS" },
  ESP: { name: "Spain", iso2: "ES" },
  LKA: { name: "Sri Lanka", iso2: "LK" },
  SDN: { name: "Sudan", iso2: "SD" },
  SUR: { name: "Suriname", iso2: "SR" },
  SJM: { name: "Svalbard and Jan Mayen", iso2: "SJ" },
  SWE: { name: "Sweden", iso2: "SE" },
  CHE: { name: "Switzerland", iso2: "CH" },
  SYR: { name: "Syria", iso2: "SY" },
  TWN: { name: "Taiwan", iso2: "TW" },
  TJK: { name: "Tajikistan", iso2: "TJ" },
  TZA: { name: "Tanzania", iso2: "TZ" },
  THA: { name: "Thailand", iso2: "TH" },
  TLS: { name: "Timor-Leste", iso2: "TL" },
  TGO: { name: "Togo", iso2: "TG" },
  TKL: { name: "Tokelau", iso2: "TK" },
  TON: { name: "Tonga", iso2: "TO" },
  TTO: { name: "Trinidad and Tobago", iso2: "TT" },
  TUN: { name: "Tunisia", iso2: "TN" },
  TUR: { name: "Turkey", iso2: "TR" },
  TKM: { name: "Turkmenistan", iso2: "TM" },
  TCA: { name: "Turks and Caicos Islands", iso2: "TC" },
  TUV: { name: "Tuvalu", iso2: "TV" },
  UGA: { name: "Uganda", iso2: "UG" },
  UKR: { name: "Ukraine", iso2: "UA" },
  ARE: { name: "United Arab Emirates", iso2: "AE" },
  GBR: { name: "United Kingdom", iso2: "GB" },
  UMI: { name: "United States Minor Outlying Islands", iso2: "UM" },
  USA: { name: "United States of America", iso2: "US" },
  URY: { name: "Uruguay", iso2: "UY" },
  UZB: { name: "Uzbekistan", iso2: "UZ" },
  VUT: { name: "Vanuatu", iso2: "VU" },
  VEN: { name: "Venezuela", iso2: "VE" },
  VNM: { name: "Vietnam", iso2: "VN" },
  VGB: { name: "Virgin Islands (British)", iso2: "VG" },
  VIR: { name: "Virgin Islands (U.S.)", iso2: "VI" },
  WLF: { name: "Wallis and Futuna", iso2: "WF" },
  ESH: { name: "Western Sahara", iso2: "EH" },
  YEM: { name: "Yemen", iso2: "YE" },
  ZMB: { name: "Zambia", iso2: "ZM" },
  ZWE: { name: "Zimbabwe", iso2: "ZW" }
}, wT = {
  USA: j0.USA,
  CAN: j0.CAN,
  MEX: j0.MEX,
  AUS: j0.AUS,
  BEL: j0.BEL,
  BRA: j0.BRA,
  COL: j0.COL,
  CHE: j0.CHE,
  DEU: j0.DEU,
  ESP: j0.ESP,
  FRA: j0.FRA,
  GBR: j0.GBR,
  HUN: j0.HUN,
  IRL: j0.IRL,
  ITA: j0.ITA,
  KOR: j0.KOR,
  MLT: j0.MLT,
  NLD: j0.NLD,
  NZL: j0.NZL,
  PHL: j0.PHL,
  POL: j0.POL,
  PRI: j0.PRI,
  PRT: j0.PRT,
  SGP: j0.SGP,
  SWE: j0.SWE,
  TUR: j0.TUR
}, UM = {
  size: 15,
  page: 1
};
function CT(e, n) {
  const a = /* @__PURE__ */ new WeakSet();
  return JSON.stringify(e, (r, M) => {
    if (!a.has(M))
      return typeof M == "object" && M !== null && a.add(M), M;
  }, n);
}
function ET(e) {
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
const dk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  safeParse: ET,
  safeStringify: CT
}, Symbol.toStringTag, { value: "Module" }));
async function XT(e) {
  const n = [];
  for (const a of e)
    n.push(await a());
  return n;
}
const pk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  allSync: XT
}, Symbol.toStringTag, { value: "Module" }));
function Lo(e, n) {
  return e.toString().toLowerCase() === n.toString().toLowerCase();
}
function PT(e, n) {
  const a = (M) => M.match(/[a-zA-Z]+|[0-9]+/gu) || [], t = (M) => isNaN(Number(M)) ? M : Number(M);
  return ((M, b) => {
    const d = Math.min(M.length, b.length);
    for (let c = 0; c < d; c++) {
      const O = t(M.at(c) ?? ""), A = t(b.at(c) ?? "");
      if (O !== A)
        return O > A ? 1 : -1;
    }
    return M.length - b.length;
  })(a(e), a(n));
}
function lt(e) {
  e = e.replace(/<(?<temp1>script|style|iframe|object)[^>]*>[\s\S]*?<\/\1>/giu, "");
  let n;
  do
    n = e, e = e.replace(/<[^>]*>/gu, "");
  while (e !== n);
  return e.replace(/\s+/gu, " ").trim();
}
function kT(e) {
  var a;
  const n = /[^a-zA-Z0-9]/gu;
  return e ? (a = String(e)) == null ? void 0 : a.toUpperCase().replace(n, "") : "";
}
const ck = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compareAlphaNumeric: PT,
  extractTextFromHtml: lt,
  iEqual: Lo,
  toUpperCaseAlphaNumericOnly: kT
}, Symbol.toStringTag, { value: "Module" }));
function IT(...e) {
  if (e.length === 0)
    return 0;
  const n = (a, t) => {
    for ([a, t] = [Math.abs(a), Math.abs(t)]; t !== 0; )
      [a, t] = [t, a % t];
    return a;
  };
  return e.reduce((a, t) => n(a, t));
}
const zk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  greatestCommonDiv: IT
}, Symbol.toStringTag, { value: "Module" }));
var Uo = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Uo.exports;
(function(e, n) {
  (function() {
    var a, t = "4.17.21", r = 200, M = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", b = "Expected a function", d = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", O = 500, A = "__lodash_placeholder__", m = 1, q = 2, y = 4, $ = 1, v = 2, E = 1, t0 = 2, K = 4, C = 8, s0 = 16, J = 32, I0 = 64, g0 = 128, S0 = 256, u0 = 512, F2 = 30, o2 = "...", bn = 800, Fn = 16, H2 = 1, sn = 2, $1 = 3, re = 1 / 0, U2 = 9007199254740991, t3 = 17976931348623157e292, Hn = NaN, r2 = 4294967295, Er = r2 - 1, Xr = r2 >>> 1, ka = [
      ["ary", g0],
      ["bind", E],
      ["bindKey", t0],
      ["curry", C],
      ["curryRight", s0],
      ["flip", u0],
      ["partial", J],
      ["partialRight", I0],
      ["rearg", S0]
    ], j2 = "[object Arguments]", i2 = "[object Array]", H0 = "[object AsyncFunction]", h1 = "[object Boolean]", Be = "[object Date]", o3 = "[object DOMException]", Un = "[object Error]", G2 = "[object Function]", W = "[object GeneratorFunction]", T = "[object Map]", B = "[object Number]", x = "[object Null]", Q = "[object Object]", L0 = "[object Promise]", o1 = "[object Proxy]", _0 = "[object RegExp]", v0 = "[object Set]", jn = "[object String]", r3 = "[object Symbol]", K9 = "[object Undefined]", Ia = "[object WeakMap]", Z9 = "[object WeakSet]", xa = "[object ArrayBuffer]", Gn = "[object DataView]", Pr = "[object Float32Array]", kr = "[object Float64Array]", Ir = "[object Int8Array]", xr = "[object Int16Array]", Fr = "[object Int32Array]", Hr = "[object Uint8Array]", Ur = "[object Uint8ClampedArray]", jr = "[object Uint16Array]", Gr = "[object Uint32Array]", Q9 = /\b__p \+= '';/g, e8 = /\b(__p \+=) '' \+/g, n8 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Os = /&(?:amp|lt|gt|quot|#39);/g, us = /[&<>"']/g, a8 = RegExp(Os.source), t8 = RegExp(us.source), o8 = /<%-([\s\S]+?)%>/g, r8 = /<%([\s\S]+?)%>/g, As = /<%=([\s\S]+?)%>/g, i8 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, M8 = /^\w*$/, b8 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Vr = /[\\^$.*+?()[\]{}|]/g, s8 = RegExp(Vr.source), Yr = /^\s+/, d8 = /\s/, p8 = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, c8 = /\{\n\/\* \[wrapped with (.+)\] \*/, z8 = /,? & /, O8 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, u8 = /[()=,{}\[\]\/\s]/, A8 = /\\(\\)?/g, l8 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ls = /\w*$/, f8 = /^[-+]0x[0-9a-f]+$/i, m8 = /^0b[01]+$/i, q8 = /^\[object .+?Constructor\]$/, h8 = /^0o[0-7]+$/i, y8 = /^(?:0|[1-9]\d*)$/, W8 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, i3 = /($^)/, g8 = /['\n\r\u2028\u2029\\]/g, M3 = "\\ud800-\\udfff", R8 = "\\u0300-\\u036f", $8 = "\\ufe20-\\ufe2f", L8 = "\\u20d0-\\u20ff", fs = R8 + $8 + L8, ms = "\\u2700-\\u27bf", qs = "a-z\\xdf-\\xf6\\xf8-\\xff", _8 = "\\xac\\xb1\\xd7\\xf7", N8 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", v8 = "\\u2000-\\u206f", D8 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", hs = "A-Z\\xc0-\\xd6\\xd8-\\xde", ys = "\\ufe0e\\ufe0f", Ws = _8 + N8 + v8 + D8, Jr = "['’]", T8 = "[" + M3 + "]", gs = "[" + Ws + "]", b3 = "[" + fs + "]", Rs = "\\d+", S8 = "[" + ms + "]", $s = "[" + qs + "]", Ls = "[^" + M3 + Ws + Rs + ms + qs + hs + "]", Kr = "\\ud83c[\\udffb-\\udfff]", B8 = "(?:" + b3 + "|" + Kr + ")", _s = "[^" + M3 + "]", Zr = "(?:\\ud83c[\\udde6-\\uddff]){2}", Qr = "[\\ud800-\\udbff][\\udc00-\\udfff]", Vn = "[" + hs + "]", Ns = "\\u200d", vs = "(?:" + $s + "|" + Ls + ")", w8 = "(?:" + Vn + "|" + Ls + ")", Ds = "(?:" + Jr + "(?:d|ll|m|re|s|t|ve))?", Ts = "(?:" + Jr + "(?:D|LL|M|RE|S|T|VE))?", Ss = B8 + "?", Bs = "[" + ys + "]?", C8 = "(?:" + Ns + "(?:" + [_s, Zr, Qr].join("|") + ")" + Bs + Ss + ")*", E8 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", X8 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ws = Bs + Ss + C8, P8 = "(?:" + [S8, Zr, Qr].join("|") + ")" + ws, k8 = "(?:" + [_s + b3 + "?", b3, Zr, Qr, T8].join("|") + ")", I8 = RegExp(Jr, "g"), x8 = RegExp(b3, "g"), ei = RegExp(Kr + "(?=" + Kr + ")|" + k8 + ws, "g"), F8 = RegExp([
      Vn + "?" + $s + "+" + Ds + "(?=" + [gs, Vn, "$"].join("|") + ")",
      w8 + "+" + Ts + "(?=" + [gs, Vn + vs, "$"].join("|") + ")",
      Vn + "?" + vs + "+" + Ds,
      Vn + "+" + Ts,
      X8,
      E8,
      Rs,
      P8
    ].join("|"), "g"), H8 = RegExp("[" + Ns + M3 + fs + ys + "]"), U8 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, j8 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], G8 = -1, Y0 = {};
    Y0[Pr] = Y0[kr] = Y0[Ir] = Y0[xr] = Y0[Fr] = Y0[Hr] = Y0[Ur] = Y0[jr] = Y0[Gr] = !0, Y0[j2] = Y0[i2] = Y0[xa] = Y0[h1] = Y0[Gn] = Y0[Be] = Y0[Un] = Y0[G2] = Y0[T] = Y0[B] = Y0[Q] = Y0[_0] = Y0[v0] = Y0[jn] = Y0[Ia] = !1;
    var V0 = {};
    V0[j2] = V0[i2] = V0[xa] = V0[Gn] = V0[h1] = V0[Be] = V0[Pr] = V0[kr] = V0[Ir] = V0[xr] = V0[Fr] = V0[T] = V0[B] = V0[Q] = V0[_0] = V0[v0] = V0[jn] = V0[r3] = V0[Hr] = V0[Ur] = V0[jr] = V0[Gr] = !0, V0[Un] = V0[G2] = V0[Ia] = !1;
    var V8 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Y8 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, J8 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, K8 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Z8 = parseFloat, Q8 = parseInt, Cs = typeof Ln == "object" && Ln && Ln.Object === Object && Ln, e7 = typeof self == "object" && self && self.Object === Object && self, y1 = Cs || e7 || Function("return this")(), ni = n && !n.nodeType && n, dn = ni && !0 && e && !e.nodeType && e, Es = dn && dn.exports === ni, ai = Es && Cs.process, M2 = function() {
      try {
        var g = dn && dn.require && dn.require("util").types;
        return g || ai && ai.binding && ai.binding("util");
      } catch {
      }
    }(), Xs = M2 && M2.isArrayBuffer, Ps = M2 && M2.isDate, ks = M2 && M2.isMap, Is = M2 && M2.isRegExp, xs = M2 && M2.isSet, Fs = M2 && M2.isTypedArray;
    function V1(g, N, _) {
      switch (_.length) {
        case 0:
          return g.call(N);
        case 1:
          return g.call(N, _[0]);
        case 2:
          return g.call(N, _[0], _[1]);
        case 3:
          return g.call(N, _[0], _[1], _[2]);
      }
      return g.apply(N, _);
    }
    function n7(g, N, _, U) {
      for (var b0 = -1, C0 = g == null ? 0 : g.length; ++b0 < C0; ) {
        var O1 = g[b0];
        N(U, O1, _(O1), g);
      }
      return U;
    }
    function b2(g, N) {
      for (var _ = -1, U = g == null ? 0 : g.length; ++_ < U && N(g[_], _, g) !== !1; )
        ;
      return g;
    }
    function a7(g, N) {
      for (var _ = g == null ? 0 : g.length; _-- && N(g[_], _, g) !== !1; )
        ;
      return g;
    }
    function Hs(g, N) {
      for (var _ = -1, U = g == null ? 0 : g.length; ++_ < U; )
        if (!N(g[_], _, g))
          return !1;
      return !0;
    }
    function we(g, N) {
      for (var _ = -1, U = g == null ? 0 : g.length, b0 = 0, C0 = []; ++_ < U; ) {
        var O1 = g[_];
        N(O1, _, g) && (C0[b0++] = O1);
      }
      return C0;
    }
    function s3(g, N) {
      var _ = g == null ? 0 : g.length;
      return !!_ && Yn(g, N, 0) > -1;
    }
    function ti(g, N, _) {
      for (var U = -1, b0 = g == null ? 0 : g.length; ++U < b0; )
        if (_(N, g[U]))
          return !0;
      return !1;
    }
    function Q0(g, N) {
      for (var _ = -1, U = g == null ? 0 : g.length, b0 = Array(U); ++_ < U; )
        b0[_] = N(g[_], _, g);
      return b0;
    }
    function Ce(g, N) {
      for (var _ = -1, U = N.length, b0 = g.length; ++_ < U; )
        g[b0 + _] = N[_];
      return g;
    }
    function oi(g, N, _, U) {
      var b0 = -1, C0 = g == null ? 0 : g.length;
      for (U && C0 && (_ = g[++b0]); ++b0 < C0; )
        _ = N(_, g[b0], b0, g);
      return _;
    }
    function t7(g, N, _, U) {
      var b0 = g == null ? 0 : g.length;
      for (U && b0 && (_ = g[--b0]); b0--; )
        _ = N(_, g[b0], b0, g);
      return _;
    }
    function ri(g, N) {
      for (var _ = -1, U = g == null ? 0 : g.length; ++_ < U; )
        if (N(g[_], _, g))
          return !0;
      return !1;
    }
    var o7 = ii("length");
    function r7(g) {
      return g.split("");
    }
    function i7(g) {
      return g.match(O8) || [];
    }
    function Us(g, N, _) {
      var U;
      return _(g, function(b0, C0, O1) {
        if (N(b0, C0, O1))
          return U = C0, !1;
      }), U;
    }
    function d3(g, N, _, U) {
      for (var b0 = g.length, C0 = _ + (U ? 1 : -1); U ? C0-- : ++C0 < b0; )
        if (N(g[C0], C0, g))
          return C0;
      return -1;
    }
    function Yn(g, N, _) {
      return N === N ? f7(g, N, _) : d3(g, js, _);
    }
    function M7(g, N, _, U) {
      for (var b0 = _ - 1, C0 = g.length; ++b0 < C0; )
        if (U(g[b0], N))
          return b0;
      return -1;
    }
    function js(g) {
      return g !== g;
    }
    function Gs(g, N) {
      var _ = g == null ? 0 : g.length;
      return _ ? bi(g, N) / _ : Hn;
    }
    function ii(g) {
      return function(N) {
        return N == null ? a : N[g];
      };
    }
    function Mi(g) {
      return function(N) {
        return g == null ? a : g[N];
      };
    }
    function Vs(g, N, _, U, b0) {
      return b0(g, function(C0, O1, U0) {
        _ = U ? (U = !1, C0) : N(_, C0, O1, U0);
      }), _;
    }
    function b7(g, N) {
      var _ = g.length;
      for (g.sort(N); _--; )
        g[_] = g[_].value;
      return g;
    }
    function bi(g, N) {
      for (var _, U = -1, b0 = g.length; ++U < b0; ) {
        var C0 = N(g[U]);
        C0 !== a && (_ = _ === a ? C0 : _ + C0);
      }
      return _;
    }
    function si(g, N) {
      for (var _ = -1, U = Array(g); ++_ < g; )
        U[_] = N(_);
      return U;
    }
    function s7(g, N) {
      return Q0(N, function(_) {
        return [_, g[_]];
      });
    }
    function Ys(g) {
      return g && g.slice(0, Qs(g) + 1).replace(Yr, "");
    }
    function Y1(g) {
      return function(N) {
        return g(N);
      };
    }
    function di(g, N) {
      return Q0(N, function(_) {
        return g[_];
      });
    }
    function Fa(g, N) {
      return g.has(N);
    }
    function Js(g, N) {
      for (var _ = -1, U = g.length; ++_ < U && Yn(N, g[_], 0) > -1; )
        ;
      return _;
    }
    function Ks(g, N) {
      for (var _ = g.length; _-- && Yn(N, g[_], 0) > -1; )
        ;
      return _;
    }
    function d7(g, N) {
      for (var _ = g.length, U = 0; _--; )
        g[_] === N && ++U;
      return U;
    }
    var p7 = Mi(V8), c7 = Mi(Y8);
    function z7(g) {
      return "\\" + K8[g];
    }
    function O7(g, N) {
      return g == null ? a : g[N];
    }
    function Jn(g) {
      return H8.test(g);
    }
    function u7(g) {
      return U8.test(g);
    }
    function A7(g) {
      for (var N, _ = []; !(N = g.next()).done; )
        _.push(N.value);
      return _;
    }
    function pi(g) {
      var N = -1, _ = Array(g.size);
      return g.forEach(function(U, b0) {
        _[++N] = [b0, U];
      }), _;
    }
    function Zs(g, N) {
      return function(_) {
        return g(N(_));
      };
    }
    function Ee(g, N) {
      for (var _ = -1, U = g.length, b0 = 0, C0 = []; ++_ < U; ) {
        var O1 = g[_];
        (O1 === N || O1 === A) && (g[_] = A, C0[b0++] = _);
      }
      return C0;
    }
    function p3(g) {
      var N = -1, _ = Array(g.size);
      return g.forEach(function(U) {
        _[++N] = U;
      }), _;
    }
    function l7(g) {
      var N = -1, _ = Array(g.size);
      return g.forEach(function(U) {
        _[++N] = [U, U];
      }), _;
    }
    function f7(g, N, _) {
      for (var U = _ - 1, b0 = g.length; ++U < b0; )
        if (g[U] === N)
          return U;
      return -1;
    }
    function m7(g, N, _) {
      for (var U = _ + 1; U--; )
        if (g[U] === N)
          return U;
      return U;
    }
    function Kn(g) {
      return Jn(g) ? h7(g) : o7(g);
    }
    function g2(g) {
      return Jn(g) ? y7(g) : r7(g);
    }
    function Qs(g) {
      for (var N = g.length; N-- && d8.test(g.charAt(N)); )
        ;
      return N;
    }
    var q7 = Mi(J8);
    function h7(g) {
      for (var N = ei.lastIndex = 0; ei.test(g); )
        ++N;
      return N;
    }
    function y7(g) {
      return g.match(ei) || [];
    }
    function W7(g) {
      return g.match(F8) || [];
    }
    var g7 = function g(N) {
      N = N == null ? y1 : Zn.defaults(y1.Object(), N, Zn.pick(y1, j8));
      var _ = N.Array, U = N.Date, b0 = N.Error, C0 = N.Function, O1 = N.Math, U0 = N.Object, ci = N.RegExp, R7 = N.String, s2 = N.TypeError, c3 = _.prototype, $7 = C0.prototype, Qn = U0.prototype, z3 = N["__core-js_shared__"], O3 = $7.toString, k0 = Qn.hasOwnProperty, L7 = 0, ed = function() {
        var o = /[^.]+$/.exec(z3 && z3.keys && z3.keys.IE_PROTO || "");
        return o ? "Symbol(src)_1." + o : "";
      }(), u3 = Qn.toString, _7 = O3.call(U0), N7 = y1._, v7 = ci(
        "^" + O3.call(k0).replace(Vr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), A3 = Es ? N.Buffer : a, Xe = N.Symbol, l3 = N.Uint8Array, nd = A3 ? A3.allocUnsafe : a, f3 = Zs(U0.getPrototypeOf, U0), ad = U0.create, td = Qn.propertyIsEnumerable, m3 = c3.splice, od = Xe ? Xe.isConcatSpreadable : a, Ha = Xe ? Xe.iterator : a, pn = Xe ? Xe.toStringTag : a, q3 = function() {
        try {
          var o = An(U0, "defineProperty");
          return o({}, "", {}), o;
        } catch {
        }
      }(), D7 = N.clearTimeout !== y1.clearTimeout && N.clearTimeout, T7 = U && U.now !== y1.Date.now && U.now, S7 = N.setTimeout !== y1.setTimeout && N.setTimeout, h3 = O1.ceil, y3 = O1.floor, zi = U0.getOwnPropertySymbols, B7 = A3 ? A3.isBuffer : a, rd = N.isFinite, w7 = c3.join, C7 = Zs(U0.keys, U0), u1 = O1.max, L1 = O1.min, E7 = U.now, X7 = N.parseInt, id = O1.random, P7 = c3.reverse, Oi = An(N, "DataView"), Ua = An(N, "Map"), ui = An(N, "Promise"), ea = An(N, "Set"), ja = An(N, "WeakMap"), Ga = An(U0, "create"), W3 = ja && new ja(), na = {}, k7 = ln(Oi), I7 = ln(Ua), x7 = ln(ui), F7 = ln(ea), H7 = ln(ja), g3 = Xe ? Xe.prototype : a, Va = g3 ? g3.valueOf : a, Md = g3 ? g3.toString : a;
      function u(o) {
        if (r1(o) && !d0(o) && !(o instanceof R0)) {
          if (o instanceof d2)
            return o;
          if (k0.call(o, "__wrapped__"))
            return bp(o);
        }
        return new d2(o);
      }
      var aa = /* @__PURE__ */ function() {
        function o() {
        }
        return function(i) {
          if (!a1(i))
            return {};
          if (ad)
            return ad(i);
          o.prototype = i;
          var s = new o();
          return o.prototype = a, s;
        };
      }();
      function R3() {
      }
      function d2(o, i) {
        this.__wrapped__ = o, this.__actions__ = [], this.__chain__ = !!i, this.__index__ = 0, this.__values__ = a;
      }
      u.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: o8,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: r8,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: As,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: u
        }
      }, u.prototype = R3.prototype, u.prototype.constructor = u, d2.prototype = aa(R3.prototype), d2.prototype.constructor = d2;
      function R0(o) {
        this.__wrapped__ = o, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = r2, this.__views__ = [];
      }
      function U7() {
        var o = new R0(this.__wrapped__);
        return o.__actions__ = k1(this.__actions__), o.__dir__ = this.__dir__, o.__filtered__ = this.__filtered__, o.__iteratees__ = k1(this.__iteratees__), o.__takeCount__ = this.__takeCount__, o.__views__ = k1(this.__views__), o;
      }
      function j7() {
        if (this.__filtered__) {
          var o = new R0(this);
          o.__dir__ = -1, o.__filtered__ = !0;
        } else
          o = this.clone(), o.__dir__ *= -1;
        return o;
      }
      function G7() {
        var o = this.__wrapped__.value(), i = this.__dir__, s = d0(o), p = i < 0, z = s ? o.length : 0, l = rl(0, z, this.__views__), f = l.start, h = l.end, R = h - f, D = p ? h : f - 1, S = this.__iteratees__, w = S.length, F = 0, Y = L1(R, this.__takeCount__);
        if (!s || !p && z == R && Y == R)
          return Dd(o, this.__actions__);
        var o0 = [];
        e:
          for (; R-- && F < Y; ) {
            D += i;
            for (var A0 = -1, r0 = o[D]; ++A0 < w; ) {
              var m0 = S[A0], N0 = m0.iteratee, Z1 = m0.type, B1 = N0(r0);
              if (Z1 == sn)
                r0 = B1;
              else if (!B1) {
                if (Z1 == H2)
                  continue e;
                break e;
              }
            }
            o0[F++] = r0;
          }
        return o0;
      }
      R0.prototype = aa(R3.prototype), R0.prototype.constructor = R0;
      function cn(o) {
        var i = -1, s = o == null ? 0 : o.length;
        for (this.clear(); ++i < s; ) {
          var p = o[i];
          this.set(p[0], p[1]);
        }
      }
      function V7() {
        this.__data__ = Ga ? Ga(null) : {}, this.size = 0;
      }
      function Y7(o) {
        var i = this.has(o) && delete this.__data__[o];
        return this.size -= i ? 1 : 0, i;
      }
      function J7(o) {
        var i = this.__data__;
        if (Ga) {
          var s = i[o];
          return s === c ? a : s;
        }
        return k0.call(i, o) ? i[o] : a;
      }
      function K7(o) {
        var i = this.__data__;
        return Ga ? i[o] !== a : k0.call(i, o);
      }
      function Z7(o, i) {
        var s = this.__data__;
        return this.size += this.has(o) ? 0 : 1, s[o] = Ga && i === a ? c : i, this;
      }
      cn.prototype.clear = V7, cn.prototype.delete = Y7, cn.prototype.get = J7, cn.prototype.has = K7, cn.prototype.set = Z7;
      function ie(o) {
        var i = -1, s = o == null ? 0 : o.length;
        for (this.clear(); ++i < s; ) {
          var p = o[i];
          this.set(p[0], p[1]);
        }
      }
      function Q7() {
        this.__data__ = [], this.size = 0;
      }
      function eA(o) {
        var i = this.__data__, s = $3(i, o);
        if (s < 0)
          return !1;
        var p = i.length - 1;
        return s == p ? i.pop() : m3.call(i, s, 1), --this.size, !0;
      }
      function nA(o) {
        var i = this.__data__, s = $3(i, o);
        return s < 0 ? a : i[s][1];
      }
      function aA(o) {
        return $3(this.__data__, o) > -1;
      }
      function tA(o, i) {
        var s = this.__data__, p = $3(s, o);
        return p < 0 ? (++this.size, s.push([o, i])) : s[p][1] = i, this;
      }
      ie.prototype.clear = Q7, ie.prototype.delete = eA, ie.prototype.get = nA, ie.prototype.has = aA, ie.prototype.set = tA;
      function Me(o) {
        var i = -1, s = o == null ? 0 : o.length;
        for (this.clear(); ++i < s; ) {
          var p = o[i];
          this.set(p[0], p[1]);
        }
      }
      function oA() {
        this.size = 0, this.__data__ = {
          hash: new cn(),
          map: new (Ua || ie)(),
          string: new cn()
        };
      }
      function rA(o) {
        var i = X3(this, o).delete(o);
        return this.size -= i ? 1 : 0, i;
      }
      function iA(o) {
        return X3(this, o).get(o);
      }
      function MA(o) {
        return X3(this, o).has(o);
      }
      function bA(o, i) {
        var s = X3(this, o), p = s.size;
        return s.set(o, i), this.size += s.size == p ? 0 : 1, this;
      }
      Me.prototype.clear = oA, Me.prototype.delete = rA, Me.prototype.get = iA, Me.prototype.has = MA, Me.prototype.set = bA;
      function zn(o) {
        var i = -1, s = o == null ? 0 : o.length;
        for (this.__data__ = new Me(); ++i < s; )
          this.add(o[i]);
      }
      function sA(o) {
        return this.__data__.set(o, c), this;
      }
      function dA(o) {
        return this.__data__.has(o);
      }
      zn.prototype.add = zn.prototype.push = sA, zn.prototype.has = dA;
      function R2(o) {
        var i = this.__data__ = new ie(o);
        this.size = i.size;
      }
      function pA() {
        this.__data__ = new ie(), this.size = 0;
      }
      function cA(o) {
        var i = this.__data__, s = i.delete(o);
        return this.size = i.size, s;
      }
      function zA(o) {
        return this.__data__.get(o);
      }
      function OA(o) {
        return this.__data__.has(o);
      }
      function uA(o, i) {
        var s = this.__data__;
        if (s instanceof ie) {
          var p = s.__data__;
          if (!Ua || p.length < r - 1)
            return p.push([o, i]), this.size = ++s.size, this;
          s = this.__data__ = new Me(p);
        }
        return s.set(o, i), this.size = s.size, this;
      }
      R2.prototype.clear = pA, R2.prototype.delete = cA, R2.prototype.get = zA, R2.prototype.has = OA, R2.prototype.set = uA;
      function bd(o, i) {
        var s = d0(o), p = !s && fn(o), z = !s && !p && Fe(o), l = !s && !p && !z && ia(o), f = s || p || z || l, h = f ? si(o.length, R7) : [], R = h.length;
        for (var D in o)
          (i || k0.call(o, D)) && !(f && // Safari 9 has enumerable `arguments.length` in strict mode.
          (D == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          z && (D == "offset" || D == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          l && (D == "buffer" || D == "byteLength" || D == "byteOffset") || // Skip index properties.
          pe(D, R))) && h.push(D);
        return h;
      }
      function sd(o) {
        var i = o.length;
        return i ? o[$i(0, i - 1)] : a;
      }
      function AA(o, i) {
        return P3(k1(o), On(i, 0, o.length));
      }
      function lA(o) {
        return P3(k1(o));
      }
      function Ai(o, i, s) {
        (s !== a && !$2(o[i], s) || s === a && !(i in o)) && be(o, i, s);
      }
      function Ya(o, i, s) {
        var p = o[i];
        (!(k0.call(o, i) && $2(p, s)) || s === a && !(i in o)) && be(o, i, s);
      }
      function $3(o, i) {
        for (var s = o.length; s--; )
          if ($2(o[s][0], i))
            return s;
        return -1;
      }
      function fA(o, i, s, p) {
        return Pe(o, function(z, l, f) {
          i(p, z, s(z), f);
        }), p;
      }
      function dd(o, i) {
        return o && Y2(i, f1(i), o);
      }
      function mA(o, i) {
        return o && Y2(i, x1(i), o);
      }
      function be(o, i, s) {
        i == "__proto__" && q3 ? q3(o, i, {
          configurable: !0,
          enumerable: !0,
          value: s,
          writable: !0
        }) : o[i] = s;
      }
      function li(o, i) {
        for (var s = -1, p = i.length, z = _(p), l = o == null; ++s < p; )
          z[s] = l ? a : Ki(o, i[s]);
        return z;
      }
      function On(o, i, s) {
        return o === o && (s !== a && (o = o <= s ? o : s), i !== a && (o = o >= i ? o : i)), o;
      }
      function p2(o, i, s, p, z, l) {
        var f, h = i & m, R = i & q, D = i & y;
        if (s && (f = z ? s(o, p, z, l) : s(o)), f !== a)
          return f;
        if (!a1(o))
          return o;
        var S = d0(o);
        if (S) {
          if (f = Ml(o), !h)
            return k1(o, f);
        } else {
          var w = _1(o), F = w == G2 || w == W;
          if (Fe(o))
            return Bd(o, h);
          if (w == Q || w == j2 || F && !z) {
            if (f = R || F ? {} : Qd(o), !h)
              return R ? JA(o, mA(f, o)) : YA(o, dd(f, o));
          } else {
            if (!V0[w])
              return z ? o : {};
            f = bl(o, w, h);
          }
        }
        l || (l = new R2());
        var Y = l.get(o);
        if (Y)
          return Y;
        l.set(o, f), _p(o) ? o.forEach(function(r0) {
          f.add(p2(r0, i, s, r0, o, l));
        }) : $p(o) && o.forEach(function(r0, m0) {
          f.set(m0, p2(r0, i, s, m0, o, l));
        });
        var o0 = D ? R ? Ei : Ci : R ? x1 : f1, A0 = S ? a : o0(o);
        return b2(A0 || o, function(r0, m0) {
          A0 && (m0 = r0, r0 = o[m0]), Ya(f, m0, p2(r0, i, s, m0, o, l));
        }), f;
      }
      function qA(o) {
        var i = f1(o);
        return function(s) {
          return pd(s, o, i);
        };
      }
      function pd(o, i, s) {
        var p = s.length;
        if (o == null)
          return !p;
        for (o = U0(o); p--; ) {
          var z = s[p], l = i[z], f = o[z];
          if (f === a && !(z in o) || !l(f))
            return !1;
        }
        return !0;
      }
      function cd(o, i, s) {
        if (typeof o != "function")
          throw new s2(b);
        return at(function() {
          o.apply(a, s);
        }, i);
      }
      function Ja(o, i, s, p) {
        var z = -1, l = s3, f = !0, h = o.length, R = [], D = i.length;
        if (!h)
          return R;
        s && (i = Q0(i, Y1(s))), p ? (l = ti, f = !1) : i.length >= r && (l = Fa, f = !1, i = new zn(i));
        e:
          for (; ++z < h; ) {
            var S = o[z], w = s == null ? S : s(S);
            if (S = p || S !== 0 ? S : 0, f && w === w) {
              for (var F = D; F--; )
                if (i[F] === w)
                  continue e;
              R.push(S);
            } else l(i, w, p) || R.push(S);
          }
        return R;
      }
      var Pe = Pd(V2), zd = Pd(mi, !0);
      function hA(o, i) {
        var s = !0;
        return Pe(o, function(p, z, l) {
          return s = !!i(p, z, l), s;
        }), s;
      }
      function L3(o, i, s) {
        for (var p = -1, z = o.length; ++p < z; ) {
          var l = o[p], f = i(l);
          if (f != null && (h === a ? f === f && !K1(f) : s(f, h)))
            var h = f, R = l;
        }
        return R;
      }
      function yA(o, i, s, p) {
        var z = o.length;
        for (s = z0(s), s < 0 && (s = -s > z ? 0 : z + s), p = p === a || p > z ? z : z0(p), p < 0 && (p += z), p = s > p ? 0 : vp(p); s < p; )
          o[s++] = i;
        return o;
      }
      function Od(o, i) {
        var s = [];
        return Pe(o, function(p, z, l) {
          i(p, z, l) && s.push(p);
        }), s;
      }
      function W1(o, i, s, p, z) {
        var l = -1, f = o.length;
        for (s || (s = dl), z || (z = []); ++l < f; ) {
          var h = o[l];
          i > 0 && s(h) ? i > 1 ? W1(h, i - 1, s, p, z) : Ce(z, h) : p || (z[z.length] = h);
        }
        return z;
      }
      var fi = kd(), ud = kd(!0);
      function V2(o, i) {
        return o && fi(o, i, f1);
      }
      function mi(o, i) {
        return o && ud(o, i, f1);
      }
      function _3(o, i) {
        return we(i, function(s) {
          return ce(o[s]);
        });
      }
      function un(o, i) {
        i = Ie(i, o);
        for (var s = 0, p = i.length; o != null && s < p; )
          o = o[J2(i[s++])];
        return s && s == p ? o : a;
      }
      function Ad(o, i, s) {
        var p = i(o);
        return d0(o) ? p : Ce(p, s(o));
      }
      function T1(o) {
        return o == null ? o === a ? K9 : x : pn && pn in U0(o) ? ol(o) : ll(o);
      }
      function qi(o, i) {
        return o > i;
      }
      function WA(o, i) {
        return o != null && k0.call(o, i);
      }
      function gA(o, i) {
        return o != null && i in U0(o);
      }
      function RA(o, i, s) {
        return o >= L1(i, s) && o < u1(i, s);
      }
      function hi(o, i, s) {
        for (var p = s ? ti : s3, z = o[0].length, l = o.length, f = l, h = _(l), R = 1 / 0, D = []; f--; ) {
          var S = o[f];
          f && i && (S = Q0(S, Y1(i))), R = L1(S.length, R), h[f] = !s && (i || z >= 120 && S.length >= 120) ? new zn(f && S) : a;
        }
        S = o[0];
        var w = -1, F = h[0];
        e:
          for (; ++w < z && D.length < R; ) {
            var Y = S[w], o0 = i ? i(Y) : Y;
            if (Y = s || Y !== 0 ? Y : 0, !(F ? Fa(F, o0) : p(D, o0, s))) {
              for (f = l; --f; ) {
                var A0 = h[f];
                if (!(A0 ? Fa(A0, o0) : p(o[f], o0, s)))
                  continue e;
              }
              F && F.push(o0), D.push(Y);
            }
          }
        return D;
      }
      function $A(o, i, s, p) {
        return V2(o, function(z, l, f) {
          i(p, s(z), l, f);
        }), p;
      }
      function Ka(o, i, s) {
        i = Ie(i, o), o = tp(o, i);
        var p = o == null ? o : o[J2(z2(i))];
        return p == null ? a : V1(p, o, s);
      }
      function ld(o) {
        return r1(o) && T1(o) == j2;
      }
      function LA(o) {
        return r1(o) && T1(o) == xa;
      }
      function _A(o) {
        return r1(o) && T1(o) == Be;
      }
      function Za(o, i, s, p, z) {
        return o === i ? !0 : o == null || i == null || !r1(o) && !r1(i) ? o !== o && i !== i : NA(o, i, s, p, Za, z);
      }
      function NA(o, i, s, p, z, l) {
        var f = d0(o), h = d0(i), R = f ? i2 : _1(o), D = h ? i2 : _1(i);
        R = R == j2 ? Q : R, D = D == j2 ? Q : D;
        var S = R == Q, w = D == Q, F = R == D;
        if (F && Fe(o)) {
          if (!Fe(i))
            return !1;
          f = !0, S = !1;
        }
        if (F && !S)
          return l || (l = new R2()), f || ia(o) ? Jd(o, i, s, p, z, l) : al(o, i, R, s, p, z, l);
        if (!(s & $)) {
          var Y = S && k0.call(o, "__wrapped__"), o0 = w && k0.call(i, "__wrapped__");
          if (Y || o0) {
            var A0 = Y ? o.value() : o, r0 = o0 ? i.value() : i;
            return l || (l = new R2()), z(A0, r0, s, p, l);
          }
        }
        return F ? (l || (l = new R2()), tl(o, i, s, p, z, l)) : !1;
      }
      function vA(o) {
        return r1(o) && _1(o) == T;
      }
      function yi(o, i, s, p) {
        var z = s.length, l = z, f = !p;
        if (o == null)
          return !l;
        for (o = U0(o); z--; ) {
          var h = s[z];
          if (f && h[2] ? h[1] !== o[h[0]] : !(h[0] in o))
            return !1;
        }
        for (; ++z < l; ) {
          h = s[z];
          var R = h[0], D = o[R], S = h[1];
          if (f && h[2]) {
            if (D === a && !(R in o))
              return !1;
          } else {
            var w = new R2();
            if (p)
              var F = p(D, S, R, o, i, w);
            if (!(F === a ? Za(S, D, $ | v, p, w) : F))
              return !1;
          }
        }
        return !0;
      }
      function fd(o) {
        if (!a1(o) || cl(o))
          return !1;
        var i = ce(o) ? v7 : q8;
        return i.test(ln(o));
      }
      function DA(o) {
        return r1(o) && T1(o) == _0;
      }
      function TA(o) {
        return r1(o) && _1(o) == v0;
      }
      function SA(o) {
        return r1(o) && U3(o.length) && !!Y0[T1(o)];
      }
      function md(o) {
        return typeof o == "function" ? o : o == null ? F1 : typeof o == "object" ? d0(o) ? yd(o[0], o[1]) : hd(o) : Ip(o);
      }
      function Wi(o) {
        if (!nt(o))
          return C7(o);
        var i = [];
        for (var s in U0(o))
          k0.call(o, s) && s != "constructor" && i.push(s);
        return i;
      }
      function BA(o) {
        if (!a1(o))
          return Al(o);
        var i = nt(o), s = [];
        for (var p in o)
          p == "constructor" && (i || !k0.call(o, p)) || s.push(p);
        return s;
      }
      function gi(o, i) {
        return o < i;
      }
      function qd(o, i) {
        var s = -1, p = I1(o) ? _(o.length) : [];
        return Pe(o, function(z, l, f) {
          p[++s] = i(z, l, f);
        }), p;
      }
      function hd(o) {
        var i = Pi(o);
        return i.length == 1 && i[0][2] ? np(i[0][0], i[0][1]) : function(s) {
          return s === o || yi(s, o, i);
        };
      }
      function yd(o, i) {
        return Ii(o) && ep(i) ? np(J2(o), i) : function(s) {
          var p = Ki(s, o);
          return p === a && p === i ? Zi(s, o) : Za(i, p, $ | v);
        };
      }
      function N3(o, i, s, p, z) {
        o !== i && fi(i, function(l, f) {
          if (z || (z = new R2()), a1(l))
            wA(o, i, f, s, N3, p, z);
          else {
            var h = p ? p(Fi(o, f), l, f + "", o, i, z) : a;
            h === a && (h = l), Ai(o, f, h);
          }
        }, x1);
      }
      function wA(o, i, s, p, z, l, f) {
        var h = Fi(o, s), R = Fi(i, s), D = f.get(R);
        if (D) {
          Ai(o, s, D);
          return;
        }
        var S = l ? l(h, R, s + "", o, i, f) : a, w = S === a;
        if (w) {
          var F = d0(R), Y = !F && Fe(R), o0 = !F && !Y && ia(R);
          S = R, F || Y || o0 ? d0(h) ? S = h : M1(h) ? S = k1(h) : Y ? (w = !1, S = Bd(R, !0)) : o0 ? (w = !1, S = wd(R, !0)) : S = [] : tt(R) || fn(R) ? (S = h, fn(h) ? S = Dp(h) : (!a1(h) || ce(h)) && (S = Qd(R))) : w = !1;
        }
        w && (f.set(R, S), z(S, R, p, l, f), f.delete(R)), Ai(o, s, S);
      }
      function Wd(o, i) {
        var s = o.length;
        if (s)
          return i += i < 0 ? s : 0, pe(i, s) ? o[i] : a;
      }
      function gd(o, i, s) {
        i.length ? i = Q0(i, function(l) {
          return d0(l) ? function(f) {
            return un(f, l.length === 1 ? l[0] : l);
          } : l;
        }) : i = [F1];
        var p = -1;
        i = Q0(i, Y1(n0()));
        var z = qd(o, function(l, f, h) {
          var R = Q0(i, function(D) {
            return D(l);
          });
          return { criteria: R, index: ++p, value: l };
        });
        return b7(z, function(l, f) {
          return VA(l, f, s);
        });
      }
      function CA(o, i) {
        return Rd(o, i, function(s, p) {
          return Zi(o, p);
        });
      }
      function Rd(o, i, s) {
        for (var p = -1, z = i.length, l = {}; ++p < z; ) {
          var f = i[p], h = un(o, f);
          s(h, f) && Qa(l, Ie(f, o), h);
        }
        return l;
      }
      function EA(o) {
        return function(i) {
          return un(i, o);
        };
      }
      function Ri(o, i, s, p) {
        var z = p ? M7 : Yn, l = -1, f = i.length, h = o;
        for (o === i && (i = k1(i)), s && (h = Q0(o, Y1(s))); ++l < f; )
          for (var R = 0, D = i[l], S = s ? s(D) : D; (R = z(h, S, R, p)) > -1; )
            h !== o && m3.call(h, R, 1), m3.call(o, R, 1);
        return o;
      }
      function $d(o, i) {
        for (var s = o ? i.length : 0, p = s - 1; s--; ) {
          var z = i[s];
          if (s == p || z !== l) {
            var l = z;
            pe(z) ? m3.call(o, z, 1) : Ni(o, z);
          }
        }
        return o;
      }
      function $i(o, i) {
        return o + y3(id() * (i - o + 1));
      }
      function XA(o, i, s, p) {
        for (var z = -1, l = u1(h3((i - o) / (s || 1)), 0), f = _(l); l--; )
          f[p ? l : ++z] = o, o += s;
        return f;
      }
      function Li(o, i) {
        var s = "";
        if (!o || i < 1 || i > U2)
          return s;
        do
          i % 2 && (s += o), i = y3(i / 2), i && (o += o);
        while (i);
        return s;
      }
      function l0(o, i) {
        return Hi(ap(o, i, F1), o + "");
      }
      function PA(o) {
        return sd(Ma(o));
      }
      function kA(o, i) {
        var s = Ma(o);
        return P3(s, On(i, 0, s.length));
      }
      function Qa(o, i, s, p) {
        if (!a1(o))
          return o;
        i = Ie(i, o);
        for (var z = -1, l = i.length, f = l - 1, h = o; h != null && ++z < l; ) {
          var R = J2(i[z]), D = s;
          if (R === "__proto__" || R === "constructor" || R === "prototype")
            return o;
          if (z != f) {
            var S = h[R];
            D = p ? p(S, R, h) : a, D === a && (D = a1(S) ? S : pe(i[z + 1]) ? [] : {});
          }
          Ya(h, R, D), h = h[R];
        }
        return o;
      }
      var Ld = W3 ? function(o, i) {
        return W3.set(o, i), o;
      } : F1, IA = q3 ? function(o, i) {
        return q3(o, "toString", {
          configurable: !0,
          enumerable: !1,
          value: eM(i),
          writable: !0
        });
      } : F1;
      function xA(o) {
        return P3(Ma(o));
      }
      function c2(o, i, s) {
        var p = -1, z = o.length;
        i < 0 && (i = -i > z ? 0 : z + i), s = s > z ? z : s, s < 0 && (s += z), z = i > s ? 0 : s - i >>> 0, i >>>= 0;
        for (var l = _(z); ++p < z; )
          l[p] = o[p + i];
        return l;
      }
      function FA(o, i) {
        var s;
        return Pe(o, function(p, z, l) {
          return s = i(p, z, l), !s;
        }), !!s;
      }
      function v3(o, i, s) {
        var p = 0, z = o == null ? p : o.length;
        if (typeof i == "number" && i === i && z <= Xr) {
          for (; p < z; ) {
            var l = p + z >>> 1, f = o[l];
            f !== null && !K1(f) && (s ? f <= i : f < i) ? p = l + 1 : z = l;
          }
          return z;
        }
        return _i(o, i, F1, s);
      }
      function _i(o, i, s, p) {
        var z = 0, l = o == null ? 0 : o.length;
        if (l === 0)
          return 0;
        i = s(i);
        for (var f = i !== i, h = i === null, R = K1(i), D = i === a; z < l; ) {
          var S = y3((z + l) / 2), w = s(o[S]), F = w !== a, Y = w === null, o0 = w === w, A0 = K1(w);
          if (f)
            var r0 = p || o0;
          else D ? r0 = o0 && (p || F) : h ? r0 = o0 && F && (p || !Y) : R ? r0 = o0 && F && !Y && (p || !A0) : Y || A0 ? r0 = !1 : r0 = p ? w <= i : w < i;
          r0 ? z = S + 1 : l = S;
        }
        return L1(l, Er);
      }
      function _d(o, i) {
        for (var s = -1, p = o.length, z = 0, l = []; ++s < p; ) {
          var f = o[s], h = i ? i(f) : f;
          if (!s || !$2(h, R)) {
            var R = h;
            l[z++] = f === 0 ? 0 : f;
          }
        }
        return l;
      }
      function Nd(o) {
        return typeof o == "number" ? o : K1(o) ? Hn : +o;
      }
      function J1(o) {
        if (typeof o == "string")
          return o;
        if (d0(o))
          return Q0(o, J1) + "";
        if (K1(o))
          return Md ? Md.call(o) : "";
        var i = o + "";
        return i == "0" && 1 / o == -re ? "-0" : i;
      }
      function ke(o, i, s) {
        var p = -1, z = s3, l = o.length, f = !0, h = [], R = h;
        if (s)
          f = !1, z = ti;
        else if (l >= r) {
          var D = i ? null : el(o);
          if (D)
            return p3(D);
          f = !1, z = Fa, R = new zn();
        } else
          R = i ? [] : h;
        e:
          for (; ++p < l; ) {
            var S = o[p], w = i ? i(S) : S;
            if (S = s || S !== 0 ? S : 0, f && w === w) {
              for (var F = R.length; F--; )
                if (R[F] === w)
                  continue e;
              i && R.push(w), h.push(S);
            } else z(R, w, s) || (R !== h && R.push(w), h.push(S));
          }
        return h;
      }
      function Ni(o, i) {
        return i = Ie(i, o), o = tp(o, i), o == null || delete o[J2(z2(i))];
      }
      function vd(o, i, s, p) {
        return Qa(o, i, s(un(o, i)), p);
      }
      function D3(o, i, s, p) {
        for (var z = o.length, l = p ? z : -1; (p ? l-- : ++l < z) && i(o[l], l, o); )
          ;
        return s ? c2(o, p ? 0 : l, p ? l + 1 : z) : c2(o, p ? l + 1 : 0, p ? z : l);
      }
      function Dd(o, i) {
        var s = o;
        return s instanceof R0 && (s = s.value()), oi(i, function(p, z) {
          return z.func.apply(z.thisArg, Ce([p], z.args));
        }, s);
      }
      function vi(o, i, s) {
        var p = o.length;
        if (p < 2)
          return p ? ke(o[0]) : [];
        for (var z = -1, l = _(p); ++z < p; )
          for (var f = o[z], h = -1; ++h < p; )
            h != z && (l[z] = Ja(l[z] || f, o[h], i, s));
        return ke(W1(l, 1), i, s);
      }
      function Td(o, i, s) {
        for (var p = -1, z = o.length, l = i.length, f = {}; ++p < z; ) {
          var h = p < l ? i[p] : a;
          s(f, o[p], h);
        }
        return f;
      }
      function Di(o) {
        return M1(o) ? o : [];
      }
      function Ti(o) {
        return typeof o == "function" ? o : F1;
      }
      function Ie(o, i) {
        return d0(o) ? o : Ii(o, i) ? [o] : Mp(X0(o));
      }
      var HA = l0;
      function xe(o, i, s) {
        var p = o.length;
        return s = s === a ? p : s, !i && s >= p ? o : c2(o, i, s);
      }
      var Sd = D7 || function(o) {
        return y1.clearTimeout(o);
      };
      function Bd(o, i) {
        if (i)
          return o.slice();
        var s = o.length, p = nd ? nd(s) : new o.constructor(s);
        return o.copy(p), p;
      }
      function Si(o) {
        var i = new o.constructor(o.byteLength);
        return new l3(i).set(new l3(o)), i;
      }
      function UA(o, i) {
        var s = i ? Si(o.buffer) : o.buffer;
        return new o.constructor(s, o.byteOffset, o.byteLength);
      }
      function jA(o) {
        var i = new o.constructor(o.source, ls.exec(o));
        return i.lastIndex = o.lastIndex, i;
      }
      function GA(o) {
        return Va ? U0(Va.call(o)) : {};
      }
      function wd(o, i) {
        var s = i ? Si(o.buffer) : o.buffer;
        return new o.constructor(s, o.byteOffset, o.length);
      }
      function Cd(o, i) {
        if (o !== i) {
          var s = o !== a, p = o === null, z = o === o, l = K1(o), f = i !== a, h = i === null, R = i === i, D = K1(i);
          if (!h && !D && !l && o > i || l && f && R && !h && !D || p && f && R || !s && R || !z)
            return 1;
          if (!p && !l && !D && o < i || D && s && z && !p && !l || h && s && z || !f && z || !R)
            return -1;
        }
        return 0;
      }
      function VA(o, i, s) {
        for (var p = -1, z = o.criteria, l = i.criteria, f = z.length, h = s.length; ++p < f; ) {
          var R = Cd(z[p], l[p]);
          if (R) {
            if (p >= h)
              return R;
            var D = s[p];
            return R * (D == "desc" ? -1 : 1);
          }
        }
        return o.index - i.index;
      }
      function Ed(o, i, s, p) {
        for (var z = -1, l = o.length, f = s.length, h = -1, R = i.length, D = u1(l - f, 0), S = _(R + D), w = !p; ++h < R; )
          S[h] = i[h];
        for (; ++z < f; )
          (w || z < l) && (S[s[z]] = o[z]);
        for (; D--; )
          S[h++] = o[z++];
        return S;
      }
      function Xd(o, i, s, p) {
        for (var z = -1, l = o.length, f = -1, h = s.length, R = -1, D = i.length, S = u1(l - h, 0), w = _(S + D), F = !p; ++z < S; )
          w[z] = o[z];
        for (var Y = z; ++R < D; )
          w[Y + R] = i[R];
        for (; ++f < h; )
          (F || z < l) && (w[Y + s[f]] = o[z++]);
        return w;
      }
      function k1(o, i) {
        var s = -1, p = o.length;
        for (i || (i = _(p)); ++s < p; )
          i[s] = o[s];
        return i;
      }
      function Y2(o, i, s, p) {
        var z = !s;
        s || (s = {});
        for (var l = -1, f = i.length; ++l < f; ) {
          var h = i[l], R = p ? p(s[h], o[h], h, s, o) : a;
          R === a && (R = o[h]), z ? be(s, h, R) : Ya(s, h, R);
        }
        return s;
      }
      function YA(o, i) {
        return Y2(o, ki(o), i);
      }
      function JA(o, i) {
        return Y2(o, Kd(o), i);
      }
      function T3(o, i) {
        return function(s, p) {
          var z = d0(s) ? n7 : fA, l = i ? i() : {};
          return z(s, o, n0(p, 2), l);
        };
      }
      function ta(o) {
        return l0(function(i, s) {
          var p = -1, z = s.length, l = z > 1 ? s[z - 1] : a, f = z > 2 ? s[2] : a;
          for (l = o.length > 3 && typeof l == "function" ? (z--, l) : a, f && S1(s[0], s[1], f) && (l = z < 3 ? a : l, z = 1), i = U0(i); ++p < z; ) {
            var h = s[p];
            h && o(i, h, p, l);
          }
          return i;
        });
      }
      function Pd(o, i) {
        return function(s, p) {
          if (s == null)
            return s;
          if (!I1(s))
            return o(s, p);
          for (var z = s.length, l = i ? z : -1, f = U0(s); (i ? l-- : ++l < z) && p(f[l], l, f) !== !1; )
            ;
          return s;
        };
      }
      function kd(o) {
        return function(i, s, p) {
          for (var z = -1, l = U0(i), f = p(i), h = f.length; h--; ) {
            var R = f[o ? h : ++z];
            if (s(l[R], R, l) === !1)
              break;
          }
          return i;
        };
      }
      function KA(o, i, s) {
        var p = i & E, z = et(o);
        function l() {
          var f = this && this !== y1 && this instanceof l ? z : o;
          return f.apply(p ? s : this, arguments);
        }
        return l;
      }
      function Id(o) {
        return function(i) {
          i = X0(i);
          var s = Jn(i) ? g2(i) : a, p = s ? s[0] : i.charAt(0), z = s ? xe(s, 1).join("") : i.slice(1);
          return p[o]() + z;
        };
      }
      function oa(o) {
        return function(i) {
          return oi(Pp(Xp(i).replace(I8, "")), o, "");
        };
      }
      function et(o) {
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return new o();
            case 1:
              return new o(i[0]);
            case 2:
              return new o(i[0], i[1]);
            case 3:
              return new o(i[0], i[1], i[2]);
            case 4:
              return new o(i[0], i[1], i[2], i[3]);
            case 5:
              return new o(i[0], i[1], i[2], i[3], i[4]);
            case 6:
              return new o(i[0], i[1], i[2], i[3], i[4], i[5]);
            case 7:
              return new o(i[0], i[1], i[2], i[3], i[4], i[5], i[6]);
          }
          var s = aa(o.prototype), p = o.apply(s, i);
          return a1(p) ? p : s;
        };
      }
      function ZA(o, i, s) {
        var p = et(o);
        function z() {
          for (var l = arguments.length, f = _(l), h = l, R = ra(z); h--; )
            f[h] = arguments[h];
          var D = l < 3 && f[0] !== R && f[l - 1] !== R ? [] : Ee(f, R);
          if (l -= D.length, l < s)
            return jd(
              o,
              i,
              S3,
              z.placeholder,
              a,
              f,
              D,
              a,
              a,
              s - l
            );
          var S = this && this !== y1 && this instanceof z ? p : o;
          return V1(S, this, f);
        }
        return z;
      }
      function xd(o) {
        return function(i, s, p) {
          var z = U0(i);
          if (!I1(i)) {
            var l = n0(s, 3);
            i = f1(i), s = function(h) {
              return l(z[h], h, z);
            };
          }
          var f = o(i, s, p);
          return f > -1 ? z[l ? i[f] : f] : a;
        };
      }
      function Fd(o) {
        return de(function(i) {
          var s = i.length, p = s, z = d2.prototype.thru;
          for (o && i.reverse(); p--; ) {
            var l = i[p];
            if (typeof l != "function")
              throw new s2(b);
            if (z && !f && E3(l) == "wrapper")
              var f = new d2([], !0);
          }
          for (p = f ? p : s; ++p < s; ) {
            l = i[p];
            var h = E3(l), R = h == "wrapper" ? Xi(l) : a;
            R && xi(R[0]) && R[1] == (g0 | C | J | S0) && !R[4].length && R[9] == 1 ? f = f[E3(R[0])].apply(f, R[3]) : f = l.length == 1 && xi(l) ? f[h]() : f.thru(l);
          }
          return function() {
            var D = arguments, S = D[0];
            if (f && D.length == 1 && d0(S))
              return f.plant(S).value();
            for (var w = 0, F = s ? i[w].apply(this, D) : S; ++w < s; )
              F = i[w].call(this, F);
            return F;
          };
        });
      }
      function S3(o, i, s, p, z, l, f, h, R, D) {
        var S = i & g0, w = i & E, F = i & t0, Y = i & (C | s0), o0 = i & u0, A0 = F ? a : et(o);
        function r0() {
          for (var m0 = arguments.length, N0 = _(m0), Z1 = m0; Z1--; )
            N0[Z1] = arguments[Z1];
          if (Y)
            var B1 = ra(r0), Q1 = d7(N0, B1);
          if (p && (N0 = Ed(N0, p, z, Y)), l && (N0 = Xd(N0, l, f, Y)), m0 -= Q1, Y && m0 < D) {
            var b1 = Ee(N0, B1);
            return jd(
              o,
              i,
              S3,
              r0.placeholder,
              s,
              N0,
              b1,
              h,
              R,
              D - m0
            );
          }
          var L2 = w ? s : this, Oe = F ? L2[o] : o;
          return m0 = N0.length, h ? N0 = fl(N0, h) : o0 && m0 > 1 && N0.reverse(), S && R < m0 && (N0.length = R), this && this !== y1 && this instanceof r0 && (Oe = A0 || et(Oe)), Oe.apply(L2, N0);
        }
        return r0;
      }
      function Hd(o, i) {
        return function(s, p) {
          return $A(s, o, i(p), {});
        };
      }
      function B3(o, i) {
        return function(s, p) {
          var z;
          if (s === a && p === a)
            return i;
          if (s !== a && (z = s), p !== a) {
            if (z === a)
              return p;
            typeof s == "string" || typeof p == "string" ? (s = J1(s), p = J1(p)) : (s = Nd(s), p = Nd(p)), z = o(s, p);
          }
          return z;
        };
      }
      function Bi(o) {
        return de(function(i) {
          return i = Q0(i, Y1(n0())), l0(function(s) {
            var p = this;
            return o(i, function(z) {
              return V1(z, p, s);
            });
          });
        });
      }
      function w3(o, i) {
        i = i === a ? " " : J1(i);
        var s = i.length;
        if (s < 2)
          return s ? Li(i, o) : i;
        var p = Li(i, h3(o / Kn(i)));
        return Jn(i) ? xe(g2(p), 0, o).join("") : p.slice(0, o);
      }
      function QA(o, i, s, p) {
        var z = i & E, l = et(o);
        function f() {
          for (var h = -1, R = arguments.length, D = -1, S = p.length, w = _(S + R), F = this && this !== y1 && this instanceof f ? l : o; ++D < S; )
            w[D] = p[D];
          for (; R--; )
            w[D++] = arguments[++h];
          return V1(F, z ? s : this, w);
        }
        return f;
      }
      function Ud(o) {
        return function(i, s, p) {
          return p && typeof p != "number" && S1(i, s, p) && (s = p = a), i = ze(i), s === a ? (s = i, i = 0) : s = ze(s), p = p === a ? i < s ? 1 : -1 : ze(p), XA(i, s, p, o);
        };
      }
      function C3(o) {
        return function(i, s) {
          return typeof i == "string" && typeof s == "string" || (i = O2(i), s = O2(s)), o(i, s);
        };
      }
      function jd(o, i, s, p, z, l, f, h, R, D) {
        var S = i & C, w = S ? f : a, F = S ? a : f, Y = S ? l : a, o0 = S ? a : l;
        i |= S ? J : I0, i &= ~(S ? I0 : J), i & K || (i &= ~(E | t0));
        var A0 = [
          o,
          i,
          z,
          Y,
          w,
          o0,
          F,
          h,
          R,
          D
        ], r0 = s.apply(a, A0);
        return xi(o) && op(r0, A0), r0.placeholder = p, rp(r0, o, i);
      }
      function wi(o) {
        var i = O1[o];
        return function(s, p) {
          if (s = O2(s), p = p == null ? 0 : L1(z0(p), 292), p && rd(s)) {
            var z = (X0(s) + "e").split("e"), l = i(z[0] + "e" + (+z[1] + p));
            return z = (X0(l) + "e").split("e"), +(z[0] + "e" + (+z[1] - p));
          }
          return i(s);
        };
      }
      var el = ea && 1 / p3(new ea([, -0]))[1] == re ? function(o) {
        return new ea(o);
      } : tM;
      function Gd(o) {
        return function(i) {
          var s = _1(i);
          return s == T ? pi(i) : s == v0 ? l7(i) : s7(i, o(i));
        };
      }
      function se(o, i, s, p, z, l, f, h) {
        var R = i & t0;
        if (!R && typeof o != "function")
          throw new s2(b);
        var D = p ? p.length : 0;
        if (D || (i &= ~(J | I0), p = z = a), f = f === a ? f : u1(z0(f), 0), h = h === a ? h : z0(h), D -= z ? z.length : 0, i & I0) {
          var S = p, w = z;
          p = z = a;
        }
        var F = R ? a : Xi(o), Y = [
          o,
          i,
          s,
          p,
          z,
          S,
          w,
          l,
          f,
          h
        ];
        if (F && ul(Y, F), o = Y[0], i = Y[1], s = Y[2], p = Y[3], z = Y[4], h = Y[9] = Y[9] === a ? R ? 0 : o.length : u1(Y[9] - D, 0), !h && i & (C | s0) && (i &= ~(C | s0)), !i || i == E)
          var o0 = KA(o, i, s);
        else i == C || i == s0 ? o0 = ZA(o, i, h) : (i == J || i == (E | J)) && !z.length ? o0 = QA(o, i, s, p) : o0 = S3.apply(a, Y);
        var A0 = F ? Ld : op;
        return rp(A0(o0, Y), o, i);
      }
      function Vd(o, i, s, p) {
        return o === a || $2(o, Qn[s]) && !k0.call(p, s) ? i : o;
      }
      function Yd(o, i, s, p, z, l) {
        return a1(o) && a1(i) && (l.set(i, o), N3(o, i, a, Yd, l), l.delete(i)), o;
      }
      function nl(o) {
        return tt(o) ? a : o;
      }
      function Jd(o, i, s, p, z, l) {
        var f = s & $, h = o.length, R = i.length;
        if (h != R && !(f && R > h))
          return !1;
        var D = l.get(o), S = l.get(i);
        if (D && S)
          return D == i && S == o;
        var w = -1, F = !0, Y = s & v ? new zn() : a;
        for (l.set(o, i), l.set(i, o); ++w < h; ) {
          var o0 = o[w], A0 = i[w];
          if (p)
            var r0 = f ? p(A0, o0, w, i, o, l) : p(o0, A0, w, o, i, l);
          if (r0 !== a) {
            if (r0)
              continue;
            F = !1;
            break;
          }
          if (Y) {
            if (!ri(i, function(m0, N0) {
              if (!Fa(Y, N0) && (o0 === m0 || z(o0, m0, s, p, l)))
                return Y.push(N0);
            })) {
              F = !1;
              break;
            }
          } else if (!(o0 === A0 || z(o0, A0, s, p, l))) {
            F = !1;
            break;
          }
        }
        return l.delete(o), l.delete(i), F;
      }
      function al(o, i, s, p, z, l, f) {
        switch (s) {
          case Gn:
            if (o.byteLength != i.byteLength || o.byteOffset != i.byteOffset)
              return !1;
            o = o.buffer, i = i.buffer;
          case xa:
            return !(o.byteLength != i.byteLength || !l(new l3(o), new l3(i)));
          case h1:
          case Be:
          case B:
            return $2(+o, +i);
          case Un:
            return o.name == i.name && o.message == i.message;
          case _0:
          case jn:
            return o == i + "";
          case T:
            var h = pi;
          case v0:
            var R = p & $;
            if (h || (h = p3), o.size != i.size && !R)
              return !1;
            var D = f.get(o);
            if (D)
              return D == i;
            p |= v, f.set(o, i);
            var S = Jd(h(o), h(i), p, z, l, f);
            return f.delete(o), S;
          case r3:
            if (Va)
              return Va.call(o) == Va.call(i);
        }
        return !1;
      }
      function tl(o, i, s, p, z, l) {
        var f = s & $, h = Ci(o), R = h.length, D = Ci(i), S = D.length;
        if (R != S && !f)
          return !1;
        for (var w = R; w--; ) {
          var F = h[w];
          if (!(f ? F in i : k0.call(i, F)))
            return !1;
        }
        var Y = l.get(o), o0 = l.get(i);
        if (Y && o0)
          return Y == i && o0 == o;
        var A0 = !0;
        l.set(o, i), l.set(i, o);
        for (var r0 = f; ++w < R; ) {
          F = h[w];
          var m0 = o[F], N0 = i[F];
          if (p)
            var Z1 = f ? p(N0, m0, F, i, o, l) : p(m0, N0, F, o, i, l);
          if (!(Z1 === a ? m0 === N0 || z(m0, N0, s, p, l) : Z1)) {
            A0 = !1;
            break;
          }
          r0 || (r0 = F == "constructor");
        }
        if (A0 && !r0) {
          var B1 = o.constructor, Q1 = i.constructor;
          B1 != Q1 && "constructor" in o && "constructor" in i && !(typeof B1 == "function" && B1 instanceof B1 && typeof Q1 == "function" && Q1 instanceof Q1) && (A0 = !1);
        }
        return l.delete(o), l.delete(i), A0;
      }
      function de(o) {
        return Hi(ap(o, a, pp), o + "");
      }
      function Ci(o) {
        return Ad(o, f1, ki);
      }
      function Ei(o) {
        return Ad(o, x1, Kd);
      }
      var Xi = W3 ? function(o) {
        return W3.get(o);
      } : tM;
      function E3(o) {
        for (var i = o.name + "", s = na[i], p = k0.call(na, i) ? s.length : 0; p--; ) {
          var z = s[p], l = z.func;
          if (l == null || l == o)
            return z.name;
        }
        return i;
      }
      function ra(o) {
        var i = k0.call(u, "placeholder") ? u : o;
        return i.placeholder;
      }
      function n0() {
        var o = u.iteratee || nM;
        return o = o === nM ? md : o, arguments.length ? o(arguments[0], arguments[1]) : o;
      }
      function X3(o, i) {
        var s = o.__data__;
        return pl(i) ? s[typeof i == "string" ? "string" : "hash"] : s.map;
      }
      function Pi(o) {
        for (var i = f1(o), s = i.length; s--; ) {
          var p = i[s], z = o[p];
          i[s] = [p, z, ep(z)];
        }
        return i;
      }
      function An(o, i) {
        var s = O7(o, i);
        return fd(s) ? s : a;
      }
      function ol(o) {
        var i = k0.call(o, pn), s = o[pn];
        try {
          o[pn] = a;
          var p = !0;
        } catch {
        }
        var z = u3.call(o);
        return p && (i ? o[pn] = s : delete o[pn]), z;
      }
      var ki = zi ? function(o) {
        return o == null ? [] : (o = U0(o), we(zi(o), function(i) {
          return td.call(o, i);
        }));
      } : oM, Kd = zi ? function(o) {
        for (var i = []; o; )
          Ce(i, ki(o)), o = f3(o);
        return i;
      } : oM, _1 = T1;
      (Oi && _1(new Oi(new ArrayBuffer(1))) != Gn || Ua && _1(new Ua()) != T || ui && _1(ui.resolve()) != L0 || ea && _1(new ea()) != v0 || ja && _1(new ja()) != Ia) && (_1 = function(o) {
        var i = T1(o), s = i == Q ? o.constructor : a, p = s ? ln(s) : "";
        if (p)
          switch (p) {
            case k7:
              return Gn;
            case I7:
              return T;
            case x7:
              return L0;
            case F7:
              return v0;
            case H7:
              return Ia;
          }
        return i;
      });
      function rl(o, i, s) {
        for (var p = -1, z = s.length; ++p < z; ) {
          var l = s[p], f = l.size;
          switch (l.type) {
            case "drop":
              o += f;
              break;
            case "dropRight":
              i -= f;
              break;
            case "take":
              i = L1(i, o + f);
              break;
            case "takeRight":
              o = u1(o, i - f);
              break;
          }
        }
        return { start: o, end: i };
      }
      function il(o) {
        var i = o.match(c8);
        return i ? i[1].split(z8) : [];
      }
      function Zd(o, i, s) {
        i = Ie(i, o);
        for (var p = -1, z = i.length, l = !1; ++p < z; ) {
          var f = J2(i[p]);
          if (!(l = o != null && s(o, f)))
            break;
          o = o[f];
        }
        return l || ++p != z ? l : (z = o == null ? 0 : o.length, !!z && U3(z) && pe(f, z) && (d0(o) || fn(o)));
      }
      function Ml(o) {
        var i = o.length, s = new o.constructor(i);
        return i && typeof o[0] == "string" && k0.call(o, "index") && (s.index = o.index, s.input = o.input), s;
      }
      function Qd(o) {
        return typeof o.constructor == "function" && !nt(o) ? aa(f3(o)) : {};
      }
      function bl(o, i, s) {
        var p = o.constructor;
        switch (i) {
          case xa:
            return Si(o);
          case h1:
          case Be:
            return new p(+o);
          case Gn:
            return UA(o, s);
          case Pr:
          case kr:
          case Ir:
          case xr:
          case Fr:
          case Hr:
          case Ur:
          case jr:
          case Gr:
            return wd(o, s);
          case T:
            return new p();
          case B:
          case jn:
            return new p(o);
          case _0:
            return jA(o);
          case v0:
            return new p();
          case r3:
            return GA(o);
        }
      }
      function sl(o, i) {
        var s = i.length;
        if (!s)
          return o;
        var p = s - 1;
        return i[p] = (s > 1 ? "& " : "") + i[p], i = i.join(s > 2 ? ", " : " "), o.replace(p8, `{
/* [wrapped with ` + i + `] */
`);
      }
      function dl(o) {
        return d0(o) || fn(o) || !!(od && o && o[od]);
      }
      function pe(o, i) {
        var s = typeof o;
        return i = i ?? U2, !!i && (s == "number" || s != "symbol" && y8.test(o)) && o > -1 && o % 1 == 0 && o < i;
      }
      function S1(o, i, s) {
        if (!a1(s))
          return !1;
        var p = typeof i;
        return (p == "number" ? I1(s) && pe(i, s.length) : p == "string" && i in s) ? $2(s[i], o) : !1;
      }
      function Ii(o, i) {
        if (d0(o))
          return !1;
        var s = typeof o;
        return s == "number" || s == "symbol" || s == "boolean" || o == null || K1(o) ? !0 : M8.test(o) || !i8.test(o) || i != null && o in U0(i);
      }
      function pl(o) {
        var i = typeof o;
        return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? o !== "__proto__" : o === null;
      }
      function xi(o) {
        var i = E3(o), s = u[i];
        if (typeof s != "function" || !(i in R0.prototype))
          return !1;
        if (o === s)
          return !0;
        var p = Xi(s);
        return !!p && o === p[0];
      }
      function cl(o) {
        return !!ed && ed in o;
      }
      var zl = z3 ? ce : rM;
      function nt(o) {
        var i = o && o.constructor, s = typeof i == "function" && i.prototype || Qn;
        return o === s;
      }
      function ep(o) {
        return o === o && !a1(o);
      }
      function np(o, i) {
        return function(s) {
          return s == null ? !1 : s[o] === i && (i !== a || o in U0(s));
        };
      }
      function Ol(o) {
        var i = F3(o, function(p) {
          return s.size === O && s.clear(), p;
        }), s = i.cache;
        return i;
      }
      function ul(o, i) {
        var s = o[1], p = i[1], z = s | p, l = z < (E | t0 | g0), f = p == g0 && s == C || p == g0 && s == S0 && o[7].length <= i[8] || p == (g0 | S0) && i[7].length <= i[8] && s == C;
        if (!(l || f))
          return o;
        p & E && (o[2] = i[2], z |= s & E ? 0 : K);
        var h = i[3];
        if (h) {
          var R = o[3];
          o[3] = R ? Ed(R, h, i[4]) : h, o[4] = R ? Ee(o[3], A) : i[4];
        }
        return h = i[5], h && (R = o[5], o[5] = R ? Xd(R, h, i[6]) : h, o[6] = R ? Ee(o[5], A) : i[6]), h = i[7], h && (o[7] = h), p & g0 && (o[8] = o[8] == null ? i[8] : L1(o[8], i[8])), o[9] == null && (o[9] = i[9]), o[0] = i[0], o[1] = z, o;
      }
      function Al(o) {
        var i = [];
        if (o != null)
          for (var s in U0(o))
            i.push(s);
        return i;
      }
      function ll(o) {
        return u3.call(o);
      }
      function ap(o, i, s) {
        return i = u1(i === a ? o.length - 1 : i, 0), function() {
          for (var p = arguments, z = -1, l = u1(p.length - i, 0), f = _(l); ++z < l; )
            f[z] = p[i + z];
          z = -1;
          for (var h = _(i + 1); ++z < i; )
            h[z] = p[z];
          return h[i] = s(f), V1(o, this, h);
        };
      }
      function tp(o, i) {
        return i.length < 2 ? o : un(o, c2(i, 0, -1));
      }
      function fl(o, i) {
        for (var s = o.length, p = L1(i.length, s), z = k1(o); p--; ) {
          var l = i[p];
          o[p] = pe(l, s) ? z[l] : a;
        }
        return o;
      }
      function Fi(o, i) {
        if (!(i === "constructor" && typeof o[i] == "function") && i != "__proto__")
          return o[i];
      }
      var op = ip(Ld), at = S7 || function(o, i) {
        return y1.setTimeout(o, i);
      }, Hi = ip(IA);
      function rp(o, i, s) {
        var p = i + "";
        return Hi(o, sl(p, ml(il(p), s)));
      }
      function ip(o) {
        var i = 0, s = 0;
        return function() {
          var p = E7(), z = Fn - (p - s);
          if (s = p, z > 0) {
            if (++i >= bn)
              return arguments[0];
          } else
            i = 0;
          return o.apply(a, arguments);
        };
      }
      function P3(o, i) {
        var s = -1, p = o.length, z = p - 1;
        for (i = i === a ? p : i; ++s < i; ) {
          var l = $i(s, z), f = o[l];
          o[l] = o[s], o[s] = f;
        }
        return o.length = i, o;
      }
      var Mp = Ol(function(o) {
        var i = [];
        return o.charCodeAt(0) === 46 && i.push(""), o.replace(b8, function(s, p, z, l) {
          i.push(z ? l.replace(A8, "$1") : p || s);
        }), i;
      });
      function J2(o) {
        if (typeof o == "string" || K1(o))
          return o;
        var i = o + "";
        return i == "0" && 1 / o == -re ? "-0" : i;
      }
      function ln(o) {
        if (o != null) {
          try {
            return O3.call(o);
          } catch {
          }
          try {
            return o + "";
          } catch {
          }
        }
        return "";
      }
      function ml(o, i) {
        return b2(ka, function(s) {
          var p = "_." + s[0];
          i & s[1] && !s3(o, p) && o.push(p);
        }), o.sort();
      }
      function bp(o) {
        if (o instanceof R0)
          return o.clone();
        var i = new d2(o.__wrapped__, o.__chain__);
        return i.__actions__ = k1(o.__actions__), i.__index__ = o.__index__, i.__values__ = o.__values__, i;
      }
      function ql(o, i, s) {
        (s ? S1(o, i, s) : i === a) ? i = 1 : i = u1(z0(i), 0);
        var p = o == null ? 0 : o.length;
        if (!p || i < 1)
          return [];
        for (var z = 0, l = 0, f = _(h3(p / i)); z < p; )
          f[l++] = c2(o, z, z += i);
        return f;
      }
      function hl(o) {
        for (var i = -1, s = o == null ? 0 : o.length, p = 0, z = []; ++i < s; ) {
          var l = o[i];
          l && (z[p++] = l);
        }
        return z;
      }
      function yl() {
        var o = arguments.length;
        if (!o)
          return [];
        for (var i = _(o - 1), s = arguments[0], p = o; p--; )
          i[p - 1] = arguments[p];
        return Ce(d0(s) ? k1(s) : [s], W1(i, 1));
      }
      var Wl = l0(function(o, i) {
        return M1(o) ? Ja(o, W1(i, 1, M1, !0)) : [];
      }), gl = l0(function(o, i) {
        var s = z2(i);
        return M1(s) && (s = a), M1(o) ? Ja(o, W1(i, 1, M1, !0), n0(s, 2)) : [];
      }), Rl = l0(function(o, i) {
        var s = z2(i);
        return M1(s) && (s = a), M1(o) ? Ja(o, W1(i, 1, M1, !0), a, s) : [];
      });
      function $l(o, i, s) {
        var p = o == null ? 0 : o.length;
        return p ? (i = s || i === a ? 1 : z0(i), c2(o, i < 0 ? 0 : i, p)) : [];
      }
      function Ll(o, i, s) {
        var p = o == null ? 0 : o.length;
        return p ? (i = s || i === a ? 1 : z0(i), i = p - i, c2(o, 0, i < 0 ? 0 : i)) : [];
      }
      function _l(o, i) {
        return o && o.length ? D3(o, n0(i, 3), !0, !0) : [];
      }
      function Nl(o, i) {
        return o && o.length ? D3(o, n0(i, 3), !0) : [];
      }
      function vl(o, i, s, p) {
        var z = o == null ? 0 : o.length;
        return z ? (s && typeof s != "number" && S1(o, i, s) && (s = 0, p = z), yA(o, i, s, p)) : [];
      }
      function sp(o, i, s) {
        var p = o == null ? 0 : o.length;
        if (!p)
          return -1;
        var z = s == null ? 0 : z0(s);
        return z < 0 && (z = u1(p + z, 0)), d3(o, n0(i, 3), z);
      }
      function dp(o, i, s) {
        var p = o == null ? 0 : o.length;
        if (!p)
          return -1;
        var z = p - 1;
        return s !== a && (z = z0(s), z = s < 0 ? u1(p + z, 0) : L1(z, p - 1)), d3(o, n0(i, 3), z, !0);
      }
      function pp(o) {
        var i = o == null ? 0 : o.length;
        return i ? W1(o, 1) : [];
      }
      function Dl(o) {
        var i = o == null ? 0 : o.length;
        return i ? W1(o, re) : [];
      }
      function Tl(o, i) {
        var s = o == null ? 0 : o.length;
        return s ? (i = i === a ? 1 : z0(i), W1(o, i)) : [];
      }
      function Sl(o) {
        for (var i = -1, s = o == null ? 0 : o.length, p = {}; ++i < s; ) {
          var z = o[i];
          p[z[0]] = z[1];
        }
        return p;
      }
      function cp(o) {
        return o && o.length ? o[0] : a;
      }
      function Bl(o, i, s) {
        var p = o == null ? 0 : o.length;
        if (!p)
          return -1;
        var z = s == null ? 0 : z0(s);
        return z < 0 && (z = u1(p + z, 0)), Yn(o, i, z);
      }
      function wl(o) {
        var i = o == null ? 0 : o.length;
        return i ? c2(o, 0, -1) : [];
      }
      var Cl = l0(function(o) {
        var i = Q0(o, Di);
        return i.length && i[0] === o[0] ? hi(i) : [];
      }), El = l0(function(o) {
        var i = z2(o), s = Q0(o, Di);
        return i === z2(s) ? i = a : s.pop(), s.length && s[0] === o[0] ? hi(s, n0(i, 2)) : [];
      }), Xl = l0(function(o) {
        var i = z2(o), s = Q0(o, Di);
        return i = typeof i == "function" ? i : a, i && s.pop(), s.length && s[0] === o[0] ? hi(s, a, i) : [];
      });
      function Pl(o, i) {
        return o == null ? "" : w7.call(o, i);
      }
      function z2(o) {
        var i = o == null ? 0 : o.length;
        return i ? o[i - 1] : a;
      }
      function kl(o, i, s) {
        var p = o == null ? 0 : o.length;
        if (!p)
          return -1;
        var z = p;
        return s !== a && (z = z0(s), z = z < 0 ? u1(p + z, 0) : L1(z, p - 1)), i === i ? m7(o, i, z) : d3(o, js, z, !0);
      }
      function Il(o, i) {
        return o && o.length ? Wd(o, z0(i)) : a;
      }
      var xl = l0(zp);
      function zp(o, i) {
        return o && o.length && i && i.length ? Ri(o, i) : o;
      }
      function Fl(o, i, s) {
        return o && o.length && i && i.length ? Ri(o, i, n0(s, 2)) : o;
      }
      function Hl(o, i, s) {
        return o && o.length && i && i.length ? Ri(o, i, a, s) : o;
      }
      var Ul = de(function(o, i) {
        var s = o == null ? 0 : o.length, p = li(o, i);
        return $d(o, Q0(i, function(z) {
          return pe(z, s) ? +z : z;
        }).sort(Cd)), p;
      });
      function jl(o, i) {
        var s = [];
        if (!(o && o.length))
          return s;
        var p = -1, z = [], l = o.length;
        for (i = n0(i, 3); ++p < l; ) {
          var f = o[p];
          i(f, p, o) && (s.push(f), z.push(p));
        }
        return $d(o, z), s;
      }
      function Ui(o) {
        return o == null ? o : P7.call(o);
      }
      function Gl(o, i, s) {
        var p = o == null ? 0 : o.length;
        return p ? (s && typeof s != "number" && S1(o, i, s) ? (i = 0, s = p) : (i = i == null ? 0 : z0(i), s = s === a ? p : z0(s)), c2(o, i, s)) : [];
      }
      function Vl(o, i) {
        return v3(o, i);
      }
      function Yl(o, i, s) {
        return _i(o, i, n0(s, 2));
      }
      function Jl(o, i) {
        var s = o == null ? 0 : o.length;
        if (s) {
          var p = v3(o, i);
          if (p < s && $2(o[p], i))
            return p;
        }
        return -1;
      }
      function Kl(o, i) {
        return v3(o, i, !0);
      }
      function Zl(o, i, s) {
        return _i(o, i, n0(s, 2), !0);
      }
      function Ql(o, i) {
        var s = o == null ? 0 : o.length;
        if (s) {
          var p = v3(o, i, !0) - 1;
          if ($2(o[p], i))
            return p;
        }
        return -1;
      }
      function ef(o) {
        return o && o.length ? _d(o) : [];
      }
      function nf(o, i) {
        return o && o.length ? _d(o, n0(i, 2)) : [];
      }
      function af(o) {
        var i = o == null ? 0 : o.length;
        return i ? c2(o, 1, i) : [];
      }
      function tf(o, i, s) {
        return o && o.length ? (i = s || i === a ? 1 : z0(i), c2(o, 0, i < 0 ? 0 : i)) : [];
      }
      function of(o, i, s) {
        var p = o == null ? 0 : o.length;
        return p ? (i = s || i === a ? 1 : z0(i), i = p - i, c2(o, i < 0 ? 0 : i, p)) : [];
      }
      function rf(o, i) {
        return o && o.length ? D3(o, n0(i, 3), !1, !0) : [];
      }
      function Mf(o, i) {
        return o && o.length ? D3(o, n0(i, 3)) : [];
      }
      var bf = l0(function(o) {
        return ke(W1(o, 1, M1, !0));
      }), sf = l0(function(o) {
        var i = z2(o);
        return M1(i) && (i = a), ke(W1(o, 1, M1, !0), n0(i, 2));
      }), df = l0(function(o) {
        var i = z2(o);
        return i = typeof i == "function" ? i : a, ke(W1(o, 1, M1, !0), a, i);
      });
      function pf(o) {
        return o && o.length ? ke(o) : [];
      }
      function cf(o, i) {
        return o && o.length ? ke(o, n0(i, 2)) : [];
      }
      function zf(o, i) {
        return i = typeof i == "function" ? i : a, o && o.length ? ke(o, a, i) : [];
      }
      function ji(o) {
        if (!(o && o.length))
          return [];
        var i = 0;
        return o = we(o, function(s) {
          if (M1(s))
            return i = u1(s.length, i), !0;
        }), si(i, function(s) {
          return Q0(o, ii(s));
        });
      }
      function Op(o, i) {
        if (!(o && o.length))
          return [];
        var s = ji(o);
        return i == null ? s : Q0(s, function(p) {
          return V1(i, a, p);
        });
      }
      var Of = l0(function(o, i) {
        return M1(o) ? Ja(o, i) : [];
      }), uf = l0(function(o) {
        return vi(we(o, M1));
      }), Af = l0(function(o) {
        var i = z2(o);
        return M1(i) && (i = a), vi(we(o, M1), n0(i, 2));
      }), lf = l0(function(o) {
        var i = z2(o);
        return i = typeof i == "function" ? i : a, vi(we(o, M1), a, i);
      }), ff = l0(ji);
      function mf(o, i) {
        return Td(o || [], i || [], Ya);
      }
      function qf(o, i) {
        return Td(o || [], i || [], Qa);
      }
      var hf = l0(function(o) {
        var i = o.length, s = i > 1 ? o[i - 1] : a;
        return s = typeof s == "function" ? (o.pop(), s) : a, Op(o, s);
      });
      function up(o) {
        var i = u(o);
        return i.__chain__ = !0, i;
      }
      function yf(o, i) {
        return i(o), o;
      }
      function k3(o, i) {
        return i(o);
      }
      var Wf = de(function(o) {
        var i = o.length, s = i ? o[0] : 0, p = this.__wrapped__, z = function(l) {
          return li(l, o);
        };
        return i > 1 || this.__actions__.length || !(p instanceof R0) || !pe(s) ? this.thru(z) : (p = p.slice(s, +s + (i ? 1 : 0)), p.__actions__.push({
          func: k3,
          args: [z],
          thisArg: a
        }), new d2(p, this.__chain__).thru(function(l) {
          return i && !l.length && l.push(a), l;
        }));
      });
      function gf() {
        return up(this);
      }
      function Rf() {
        return new d2(this.value(), this.__chain__);
      }
      function $f() {
        this.__values__ === a && (this.__values__ = Np(this.value()));
        var o = this.__index__ >= this.__values__.length, i = o ? a : this.__values__[this.__index__++];
        return { done: o, value: i };
      }
      function Lf() {
        return this;
      }
      function _f(o) {
        for (var i, s = this; s instanceof R3; ) {
          var p = bp(s);
          p.__index__ = 0, p.__values__ = a, i ? z.__wrapped__ = p : i = p;
          var z = p;
          s = s.__wrapped__;
        }
        return z.__wrapped__ = o, i;
      }
      function Nf() {
        var o = this.__wrapped__;
        if (o instanceof R0) {
          var i = o;
          return this.__actions__.length && (i = new R0(this)), i = i.reverse(), i.__actions__.push({
            func: k3,
            args: [Ui],
            thisArg: a
          }), new d2(i, this.__chain__);
        }
        return this.thru(Ui);
      }
      function vf() {
        return Dd(this.__wrapped__, this.__actions__);
      }
      var Df = T3(function(o, i, s) {
        k0.call(o, s) ? ++o[s] : be(o, s, 1);
      });
      function Tf(o, i, s) {
        var p = d0(o) ? Hs : hA;
        return s && S1(o, i, s) && (i = a), p(o, n0(i, 3));
      }
      function Sf(o, i) {
        var s = d0(o) ? we : Od;
        return s(o, n0(i, 3));
      }
      var Bf = xd(sp), wf = xd(dp);
      function Cf(o, i) {
        return W1(I3(o, i), 1);
      }
      function Ef(o, i) {
        return W1(I3(o, i), re);
      }
      function Xf(o, i, s) {
        return s = s === a ? 1 : z0(s), W1(I3(o, i), s);
      }
      function Ap(o, i) {
        var s = d0(o) ? b2 : Pe;
        return s(o, n0(i, 3));
      }
      function lp(o, i) {
        var s = d0(o) ? a7 : zd;
        return s(o, n0(i, 3));
      }
      var Pf = T3(function(o, i, s) {
        k0.call(o, s) ? o[s].push(i) : be(o, s, [i]);
      });
      function kf(o, i, s, p) {
        o = I1(o) ? o : Ma(o), s = s && !p ? z0(s) : 0;
        var z = o.length;
        return s < 0 && (s = u1(z + s, 0)), j3(o) ? s <= z && o.indexOf(i, s) > -1 : !!z && Yn(o, i, s) > -1;
      }
      var If = l0(function(o, i, s) {
        var p = -1, z = typeof i == "function", l = I1(o) ? _(o.length) : [];
        return Pe(o, function(f) {
          l[++p] = z ? V1(i, f, s) : Ka(f, i, s);
        }), l;
      }), xf = T3(function(o, i, s) {
        be(o, s, i);
      });
      function I3(o, i) {
        var s = d0(o) ? Q0 : qd;
        return s(o, n0(i, 3));
      }
      function Ff(o, i, s, p) {
        return o == null ? [] : (d0(i) || (i = i == null ? [] : [i]), s = p ? a : s, d0(s) || (s = s == null ? [] : [s]), gd(o, i, s));
      }
      var Hf = T3(function(o, i, s) {
        o[s ? 0 : 1].push(i);
      }, function() {
        return [[], []];
      });
      function Uf(o, i, s) {
        var p = d0(o) ? oi : Vs, z = arguments.length < 3;
        return p(o, n0(i, 4), s, z, Pe);
      }
      function jf(o, i, s) {
        var p = d0(o) ? t7 : Vs, z = arguments.length < 3;
        return p(o, n0(i, 4), s, z, zd);
      }
      function Gf(o, i) {
        var s = d0(o) ? we : Od;
        return s(o, H3(n0(i, 3)));
      }
      function Vf(o) {
        var i = d0(o) ? sd : PA;
        return i(o);
      }
      function Yf(o, i, s) {
        (s ? S1(o, i, s) : i === a) ? i = 1 : i = z0(i);
        var p = d0(o) ? AA : kA;
        return p(o, i);
      }
      function Jf(o) {
        var i = d0(o) ? lA : xA;
        return i(o);
      }
      function Kf(o) {
        if (o == null)
          return 0;
        if (I1(o))
          return j3(o) ? Kn(o) : o.length;
        var i = _1(o);
        return i == T || i == v0 ? o.size : Wi(o).length;
      }
      function Zf(o, i, s) {
        var p = d0(o) ? ri : FA;
        return s && S1(o, i, s) && (i = a), p(o, n0(i, 3));
      }
      var Qf = l0(function(o, i) {
        if (o == null)
          return [];
        var s = i.length;
        return s > 1 && S1(o, i[0], i[1]) ? i = [] : s > 2 && S1(i[0], i[1], i[2]) && (i = [i[0]]), gd(o, W1(i, 1), []);
      }), x3 = T7 || function() {
        return y1.Date.now();
      };
      function em(o, i) {
        if (typeof i != "function")
          throw new s2(b);
        return o = z0(o), function() {
          if (--o < 1)
            return i.apply(this, arguments);
        };
      }
      function fp(o, i, s) {
        return i = s ? a : i, i = o && i == null ? o.length : i, se(o, g0, a, a, a, a, i);
      }
      function mp(o, i) {
        var s;
        if (typeof i != "function")
          throw new s2(b);
        return o = z0(o), function() {
          return --o > 0 && (s = i.apply(this, arguments)), o <= 1 && (i = a), s;
        };
      }
      var Gi = l0(function(o, i, s) {
        var p = E;
        if (s.length) {
          var z = Ee(s, ra(Gi));
          p |= J;
        }
        return se(o, p, i, s, z);
      }), qp = l0(function(o, i, s) {
        var p = E | t0;
        if (s.length) {
          var z = Ee(s, ra(qp));
          p |= J;
        }
        return se(i, p, o, s, z);
      });
      function hp(o, i, s) {
        i = s ? a : i;
        var p = se(o, C, a, a, a, a, a, i);
        return p.placeholder = hp.placeholder, p;
      }
      function yp(o, i, s) {
        i = s ? a : i;
        var p = se(o, s0, a, a, a, a, a, i);
        return p.placeholder = yp.placeholder, p;
      }
      function Wp(o, i, s) {
        var p, z, l, f, h, R, D = 0, S = !1, w = !1, F = !0;
        if (typeof o != "function")
          throw new s2(b);
        i = O2(i) || 0, a1(s) && (S = !!s.leading, w = "maxWait" in s, l = w ? u1(O2(s.maxWait) || 0, i) : l, F = "trailing" in s ? !!s.trailing : F);
        function Y(b1) {
          var L2 = p, Oe = z;
          return p = z = a, D = b1, f = o.apply(Oe, L2), f;
        }
        function o0(b1) {
          return D = b1, h = at(m0, i), S ? Y(b1) : f;
        }
        function A0(b1) {
          var L2 = b1 - R, Oe = b1 - D, xp = i - L2;
          return w ? L1(xp, l - Oe) : xp;
        }
        function r0(b1) {
          var L2 = b1 - R, Oe = b1 - D;
          return R === a || L2 >= i || L2 < 0 || w && Oe >= l;
        }
        function m0() {
          var b1 = x3();
          if (r0(b1))
            return N0(b1);
          h = at(m0, A0(b1));
        }
        function N0(b1) {
          return h = a, F && p ? Y(b1) : (p = z = a, f);
        }
        function Z1() {
          h !== a && Sd(h), D = 0, p = R = z = h = a;
        }
        function B1() {
          return h === a ? f : N0(x3());
        }
        function Q1() {
          var b1 = x3(), L2 = r0(b1);
          if (p = arguments, z = this, R = b1, L2) {
            if (h === a)
              return o0(R);
            if (w)
              return Sd(h), h = at(m0, i), Y(R);
          }
          return h === a && (h = at(m0, i)), f;
        }
        return Q1.cancel = Z1, Q1.flush = B1, Q1;
      }
      var nm = l0(function(o, i) {
        return cd(o, 1, i);
      }), am = l0(function(o, i, s) {
        return cd(o, O2(i) || 0, s);
      });
      function tm(o) {
        return se(o, u0);
      }
      function F3(o, i) {
        if (typeof o != "function" || i != null && typeof i != "function")
          throw new s2(b);
        var s = function() {
          var p = arguments, z = i ? i.apply(this, p) : p[0], l = s.cache;
          if (l.has(z))
            return l.get(z);
          var f = o.apply(this, p);
          return s.cache = l.set(z, f) || l, f;
        };
        return s.cache = new (F3.Cache || Me)(), s;
      }
      F3.Cache = Me;
      function H3(o) {
        if (typeof o != "function")
          throw new s2(b);
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return !o.call(this);
            case 1:
              return !o.call(this, i[0]);
            case 2:
              return !o.call(this, i[0], i[1]);
            case 3:
              return !o.call(this, i[0], i[1], i[2]);
          }
          return !o.apply(this, i);
        };
      }
      function om(o) {
        return mp(2, o);
      }
      var rm = HA(function(o, i) {
        i = i.length == 1 && d0(i[0]) ? Q0(i[0], Y1(n0())) : Q0(W1(i, 1), Y1(n0()));
        var s = i.length;
        return l0(function(p) {
          for (var z = -1, l = L1(p.length, s); ++z < l; )
            p[z] = i[z].call(this, p[z]);
          return V1(o, this, p);
        });
      }), Vi = l0(function(o, i) {
        var s = Ee(i, ra(Vi));
        return se(o, J, a, i, s);
      }), gp = l0(function(o, i) {
        var s = Ee(i, ra(gp));
        return se(o, I0, a, i, s);
      }), im = de(function(o, i) {
        return se(o, S0, a, a, a, i);
      });
      function Mm(o, i) {
        if (typeof o != "function")
          throw new s2(b);
        return i = i === a ? i : z0(i), l0(o, i);
      }
      function bm(o, i) {
        if (typeof o != "function")
          throw new s2(b);
        return i = i == null ? 0 : u1(z0(i), 0), l0(function(s) {
          var p = s[i], z = xe(s, 0, i);
          return p && Ce(z, p), V1(o, this, z);
        });
      }
      function sm(o, i, s) {
        var p = !0, z = !0;
        if (typeof o != "function")
          throw new s2(b);
        return a1(s) && (p = "leading" in s ? !!s.leading : p, z = "trailing" in s ? !!s.trailing : z), Wp(o, i, {
          leading: p,
          maxWait: i,
          trailing: z
        });
      }
      function dm(o) {
        return fp(o, 1);
      }
      function pm(o, i) {
        return Vi(Ti(i), o);
      }
      function cm() {
        if (!arguments.length)
          return [];
        var o = arguments[0];
        return d0(o) ? o : [o];
      }
      function zm(o) {
        return p2(o, y);
      }
      function Om(o, i) {
        return i = typeof i == "function" ? i : a, p2(o, y, i);
      }
      function um(o) {
        return p2(o, m | y);
      }
      function Am(o, i) {
        return i = typeof i == "function" ? i : a, p2(o, m | y, i);
      }
      function lm(o, i) {
        return i == null || pd(o, i, f1(i));
      }
      function $2(o, i) {
        return o === i || o !== o && i !== i;
      }
      var fm = C3(qi), mm = C3(function(o, i) {
        return o >= i;
      }), fn = ld(/* @__PURE__ */ function() {
        return arguments;
      }()) ? ld : function(o) {
        return r1(o) && k0.call(o, "callee") && !td.call(o, "callee");
      }, d0 = _.isArray, qm = Xs ? Y1(Xs) : LA;
      function I1(o) {
        return o != null && U3(o.length) && !ce(o);
      }
      function M1(o) {
        return r1(o) && I1(o);
      }
      function hm(o) {
        return o === !0 || o === !1 || r1(o) && T1(o) == h1;
      }
      var Fe = B7 || rM, ym = Ps ? Y1(Ps) : _A;
      function Wm(o) {
        return r1(o) && o.nodeType === 1 && !tt(o);
      }
      function gm(o) {
        if (o == null)
          return !0;
        if (I1(o) && (d0(o) || typeof o == "string" || typeof o.splice == "function" || Fe(o) || ia(o) || fn(o)))
          return !o.length;
        var i = _1(o);
        if (i == T || i == v0)
          return !o.size;
        if (nt(o))
          return !Wi(o).length;
        for (var s in o)
          if (k0.call(o, s))
            return !1;
        return !0;
      }
      function Rm(o, i) {
        return Za(o, i);
      }
      function $m(o, i, s) {
        s = typeof s == "function" ? s : a;
        var p = s ? s(o, i) : a;
        return p === a ? Za(o, i, a, s) : !!p;
      }
      function Yi(o) {
        if (!r1(o))
          return !1;
        var i = T1(o);
        return i == Un || i == o3 || typeof o.message == "string" && typeof o.name == "string" && !tt(o);
      }
      function Lm(o) {
        return typeof o == "number" && rd(o);
      }
      function ce(o) {
        if (!a1(o))
          return !1;
        var i = T1(o);
        return i == G2 || i == W || i == H0 || i == o1;
      }
      function Rp(o) {
        return typeof o == "number" && o == z0(o);
      }
      function U3(o) {
        return typeof o == "number" && o > -1 && o % 1 == 0 && o <= U2;
      }
      function a1(o) {
        var i = typeof o;
        return o != null && (i == "object" || i == "function");
      }
      function r1(o) {
        return o != null && typeof o == "object";
      }
      var $p = ks ? Y1(ks) : vA;
      function _m(o, i) {
        return o === i || yi(o, i, Pi(i));
      }
      function Nm(o, i, s) {
        return s = typeof s == "function" ? s : a, yi(o, i, Pi(i), s);
      }
      function vm(o) {
        return Lp(o) && o != +o;
      }
      function Dm(o) {
        if (zl(o))
          throw new b0(M);
        return fd(o);
      }
      function Tm(o) {
        return o === null;
      }
      function Sm(o) {
        return o == null;
      }
      function Lp(o) {
        return typeof o == "number" || r1(o) && T1(o) == B;
      }
      function tt(o) {
        if (!r1(o) || T1(o) != Q)
          return !1;
        var i = f3(o);
        if (i === null)
          return !0;
        var s = k0.call(i, "constructor") && i.constructor;
        return typeof s == "function" && s instanceof s && O3.call(s) == _7;
      }
      var Ji = Is ? Y1(Is) : DA;
      function Bm(o) {
        return Rp(o) && o >= -U2 && o <= U2;
      }
      var _p = xs ? Y1(xs) : TA;
      function j3(o) {
        return typeof o == "string" || !d0(o) && r1(o) && T1(o) == jn;
      }
      function K1(o) {
        return typeof o == "symbol" || r1(o) && T1(o) == r3;
      }
      var ia = Fs ? Y1(Fs) : SA;
      function wm(o) {
        return o === a;
      }
      function Cm(o) {
        return r1(o) && _1(o) == Ia;
      }
      function Em(o) {
        return r1(o) && T1(o) == Z9;
      }
      var Xm = C3(gi), Pm = C3(function(o, i) {
        return o <= i;
      });
      function Np(o) {
        if (!o)
          return [];
        if (I1(o))
          return j3(o) ? g2(o) : k1(o);
        if (Ha && o[Ha])
          return A7(o[Ha]());
        var i = _1(o), s = i == T ? pi : i == v0 ? p3 : Ma;
        return s(o);
      }
      function ze(o) {
        if (!o)
          return o === 0 ? o : 0;
        if (o = O2(o), o === re || o === -re) {
          var i = o < 0 ? -1 : 1;
          return i * t3;
        }
        return o === o ? o : 0;
      }
      function z0(o) {
        var i = ze(o), s = i % 1;
        return i === i ? s ? i - s : i : 0;
      }
      function vp(o) {
        return o ? On(z0(o), 0, r2) : 0;
      }
      function O2(o) {
        if (typeof o == "number")
          return o;
        if (K1(o))
          return Hn;
        if (a1(o)) {
          var i = typeof o.valueOf == "function" ? o.valueOf() : o;
          o = a1(i) ? i + "" : i;
        }
        if (typeof o != "string")
          return o === 0 ? o : +o;
        o = Ys(o);
        var s = m8.test(o);
        return s || h8.test(o) ? Q8(o.slice(2), s ? 2 : 8) : f8.test(o) ? Hn : +o;
      }
      function Dp(o) {
        return Y2(o, x1(o));
      }
      function km(o) {
        return o ? On(z0(o), -U2, U2) : o === 0 ? o : 0;
      }
      function X0(o) {
        return o == null ? "" : J1(o);
      }
      var Im = ta(function(o, i) {
        if (nt(i) || I1(i)) {
          Y2(i, f1(i), o);
          return;
        }
        for (var s in i)
          k0.call(i, s) && Ya(o, s, i[s]);
      }), Tp = ta(function(o, i) {
        Y2(i, x1(i), o);
      }), G3 = ta(function(o, i, s, p) {
        Y2(i, x1(i), o, p);
      }), xm = ta(function(o, i, s, p) {
        Y2(i, f1(i), o, p);
      }), Fm = de(li);
      function Hm(o, i) {
        var s = aa(o);
        return i == null ? s : dd(s, i);
      }
      var Um = l0(function(o, i) {
        o = U0(o);
        var s = -1, p = i.length, z = p > 2 ? i[2] : a;
        for (z && S1(i[0], i[1], z) && (p = 1); ++s < p; )
          for (var l = i[s], f = x1(l), h = -1, R = f.length; ++h < R; ) {
            var D = f[h], S = o[D];
            (S === a || $2(S, Qn[D]) && !k0.call(o, D)) && (o[D] = l[D]);
          }
        return o;
      }), jm = l0(function(o) {
        return o.push(a, Yd), V1(Sp, a, o);
      });
      function Gm(o, i) {
        return Us(o, n0(i, 3), V2);
      }
      function Vm(o, i) {
        return Us(o, n0(i, 3), mi);
      }
      function Ym(o, i) {
        return o == null ? o : fi(o, n0(i, 3), x1);
      }
      function Jm(o, i) {
        return o == null ? o : ud(o, n0(i, 3), x1);
      }
      function Km(o, i) {
        return o && V2(o, n0(i, 3));
      }
      function Zm(o, i) {
        return o && mi(o, n0(i, 3));
      }
      function Qm(o) {
        return o == null ? [] : _3(o, f1(o));
      }
      function eq(o) {
        return o == null ? [] : _3(o, x1(o));
      }
      function Ki(o, i, s) {
        var p = o == null ? a : un(o, i);
        return p === a ? s : p;
      }
      function nq(o, i) {
        return o != null && Zd(o, i, WA);
      }
      function Zi(o, i) {
        return o != null && Zd(o, i, gA);
      }
      var aq = Hd(function(o, i, s) {
        i != null && typeof i.toString != "function" && (i = u3.call(i)), o[i] = s;
      }, eM(F1)), tq = Hd(function(o, i, s) {
        i != null && typeof i.toString != "function" && (i = u3.call(i)), k0.call(o, i) ? o[i].push(s) : o[i] = [s];
      }, n0), oq = l0(Ka);
      function f1(o) {
        return I1(o) ? bd(o) : Wi(o);
      }
      function x1(o) {
        return I1(o) ? bd(o, !0) : BA(o);
      }
      function rq(o, i) {
        var s = {};
        return i = n0(i, 3), V2(o, function(p, z, l) {
          be(s, i(p, z, l), p);
        }), s;
      }
      function iq(o, i) {
        var s = {};
        return i = n0(i, 3), V2(o, function(p, z, l) {
          be(s, z, i(p, z, l));
        }), s;
      }
      var Mq = ta(function(o, i, s) {
        N3(o, i, s);
      }), Sp = ta(function(o, i, s, p) {
        N3(o, i, s, p);
      }), bq = de(function(o, i) {
        var s = {};
        if (o == null)
          return s;
        var p = !1;
        i = Q0(i, function(l) {
          return l = Ie(l, o), p || (p = l.length > 1), l;
        }), Y2(o, Ei(o), s), p && (s = p2(s, m | q | y, nl));
        for (var z = i.length; z--; )
          Ni(s, i[z]);
        return s;
      });
      function sq(o, i) {
        return Bp(o, H3(n0(i)));
      }
      var dq = de(function(o, i) {
        return o == null ? {} : CA(o, i);
      });
      function Bp(o, i) {
        if (o == null)
          return {};
        var s = Q0(Ei(o), function(p) {
          return [p];
        });
        return i = n0(i), Rd(o, s, function(p, z) {
          return i(p, z[0]);
        });
      }
      function pq(o, i, s) {
        i = Ie(i, o);
        var p = -1, z = i.length;
        for (z || (z = 1, o = a); ++p < z; ) {
          var l = o == null ? a : o[J2(i[p])];
          l === a && (p = z, l = s), o = ce(l) ? l.call(o) : l;
        }
        return o;
      }
      function cq(o, i, s) {
        return o == null ? o : Qa(o, i, s);
      }
      function zq(o, i, s, p) {
        return p = typeof p == "function" ? p : a, o == null ? o : Qa(o, i, s, p);
      }
      var wp = Gd(f1), Cp = Gd(x1);
      function Oq(o, i, s) {
        var p = d0(o), z = p || Fe(o) || ia(o);
        if (i = n0(i, 4), s == null) {
          var l = o && o.constructor;
          z ? s = p ? new l() : [] : a1(o) ? s = ce(l) ? aa(f3(o)) : {} : s = {};
        }
        return (z ? b2 : V2)(o, function(f, h, R) {
          return i(s, f, h, R);
        }), s;
      }
      function uq(o, i) {
        return o == null ? !0 : Ni(o, i);
      }
      function Aq(o, i, s) {
        return o == null ? o : vd(o, i, Ti(s));
      }
      function lq(o, i, s, p) {
        return p = typeof p == "function" ? p : a, o == null ? o : vd(o, i, Ti(s), p);
      }
      function Ma(o) {
        return o == null ? [] : di(o, f1(o));
      }
      function fq(o) {
        return o == null ? [] : di(o, x1(o));
      }
      function mq(o, i, s) {
        return s === a && (s = i, i = a), s !== a && (s = O2(s), s = s === s ? s : 0), i !== a && (i = O2(i), i = i === i ? i : 0), On(O2(o), i, s);
      }
      function qq(o, i, s) {
        return i = ze(i), s === a ? (s = i, i = 0) : s = ze(s), o = O2(o), RA(o, i, s);
      }
      function hq(o, i, s) {
        if (s && typeof s != "boolean" && S1(o, i, s) && (i = s = a), s === a && (typeof i == "boolean" ? (s = i, i = a) : typeof o == "boolean" && (s = o, o = a)), o === a && i === a ? (o = 0, i = 1) : (o = ze(o), i === a ? (i = o, o = 0) : i = ze(i)), o > i) {
          var p = o;
          o = i, i = p;
        }
        if (s || o % 1 || i % 1) {
          var z = id();
          return L1(o + z * (i - o + Z8("1e-" + ((z + "").length - 1))), i);
        }
        return $i(o, i);
      }
      var yq = oa(function(o, i, s) {
        return i = i.toLowerCase(), o + (s ? Ep(i) : i);
      });
      function Ep(o) {
        return Qi(X0(o).toLowerCase());
      }
      function Xp(o) {
        return o = X0(o), o && o.replace(W8, p7).replace(x8, "");
      }
      function Wq(o, i, s) {
        o = X0(o), i = J1(i);
        var p = o.length;
        s = s === a ? p : On(z0(s), 0, p);
        var z = s;
        return s -= i.length, s >= 0 && o.slice(s, z) == i;
      }
      function gq(o) {
        return o = X0(o), o && t8.test(o) ? o.replace(us, c7) : o;
      }
      function Rq(o) {
        return o = X0(o), o && s8.test(o) ? o.replace(Vr, "\\$&") : o;
      }
      var $q = oa(function(o, i, s) {
        return o + (s ? "-" : "") + i.toLowerCase();
      }), Lq = oa(function(o, i, s) {
        return o + (s ? " " : "") + i.toLowerCase();
      }), _q = Id("toLowerCase");
      function Nq(o, i, s) {
        o = X0(o), i = z0(i);
        var p = i ? Kn(o) : 0;
        if (!i || p >= i)
          return o;
        var z = (i - p) / 2;
        return w3(y3(z), s) + o + w3(h3(z), s);
      }
      function vq(o, i, s) {
        o = X0(o), i = z0(i);
        var p = i ? Kn(o) : 0;
        return i && p < i ? o + w3(i - p, s) : o;
      }
      function Dq(o, i, s) {
        o = X0(o), i = z0(i);
        var p = i ? Kn(o) : 0;
        return i && p < i ? w3(i - p, s) + o : o;
      }
      function Tq(o, i, s) {
        return s || i == null ? i = 0 : i && (i = +i), X7(X0(o).replace(Yr, ""), i || 0);
      }
      function Sq(o, i, s) {
        return (s ? S1(o, i, s) : i === a) ? i = 1 : i = z0(i), Li(X0(o), i);
      }
      function Bq() {
        var o = arguments, i = X0(o[0]);
        return o.length < 3 ? i : i.replace(o[1], o[2]);
      }
      var wq = oa(function(o, i, s) {
        return o + (s ? "_" : "") + i.toLowerCase();
      });
      function Cq(o, i, s) {
        return s && typeof s != "number" && S1(o, i, s) && (i = s = a), s = s === a ? r2 : s >>> 0, s ? (o = X0(o), o && (typeof i == "string" || i != null && !Ji(i)) && (i = J1(i), !i && Jn(o)) ? xe(g2(o), 0, s) : o.split(i, s)) : [];
      }
      var Eq = oa(function(o, i, s) {
        return o + (s ? " " : "") + Qi(i);
      });
      function Xq(o, i, s) {
        return o = X0(o), s = s == null ? 0 : On(z0(s), 0, o.length), i = J1(i), o.slice(s, s + i.length) == i;
      }
      function Pq(o, i, s) {
        var p = u.templateSettings;
        s && S1(o, i, s) && (i = a), o = X0(o), i = G3({}, i, p, Vd);
        var z = G3({}, i.imports, p.imports, Vd), l = f1(z), f = di(z, l), h, R, D = 0, S = i.interpolate || i3, w = "__p += '", F = ci(
          (i.escape || i3).source + "|" + S.source + "|" + (S === As ? l8 : i3).source + "|" + (i.evaluate || i3).source + "|$",
          "g"
        ), Y = "//# sourceURL=" + (k0.call(i, "sourceURL") ? (i.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++G8 + "]") + `
`;
        o.replace(F, function(r0, m0, N0, Z1, B1, Q1) {
          return N0 || (N0 = Z1), w += o.slice(D, Q1).replace(g8, z7), m0 && (h = !0, w += `' +
__e(` + m0 + `) +
'`), B1 && (R = !0, w += `';
` + B1 + `;
__p += '`), N0 && (w += `' +
((__t = (` + N0 + `)) == null ? '' : __t) +
'`), D = Q1 + r0.length, r0;
        }), w += `';
`;
        var o0 = k0.call(i, "variable") && i.variable;
        if (!o0)
          w = `with (obj) {
` + w + `
}
`;
        else if (u8.test(o0))
          throw new b0(d);
        w = (R ? w.replace(Q9, "") : w).replace(e8, "$1").replace(n8, "$1;"), w = "function(" + (o0 || "obj") + `) {
` + (o0 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (h ? ", __e = _.escape" : "") + (R ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + w + `return __p
}`;
        var A0 = kp(function() {
          return C0(l, Y + "return " + w).apply(a, f);
        });
        if (A0.source = w, Yi(A0))
          throw A0;
        return A0;
      }
      function kq(o) {
        return X0(o).toLowerCase();
      }
      function Iq(o) {
        return X0(o).toUpperCase();
      }
      function xq(o, i, s) {
        if (o = X0(o), o && (s || i === a))
          return Ys(o);
        if (!o || !(i = J1(i)))
          return o;
        var p = g2(o), z = g2(i), l = Js(p, z), f = Ks(p, z) + 1;
        return xe(p, l, f).join("");
      }
      function Fq(o, i, s) {
        if (o = X0(o), o && (s || i === a))
          return o.slice(0, Qs(o) + 1);
        if (!o || !(i = J1(i)))
          return o;
        var p = g2(o), z = Ks(p, g2(i)) + 1;
        return xe(p, 0, z).join("");
      }
      function Hq(o, i, s) {
        if (o = X0(o), o && (s || i === a))
          return o.replace(Yr, "");
        if (!o || !(i = J1(i)))
          return o;
        var p = g2(o), z = Js(p, g2(i));
        return xe(p, z).join("");
      }
      function Uq(o, i) {
        var s = F2, p = o2;
        if (a1(i)) {
          var z = "separator" in i ? i.separator : z;
          s = "length" in i ? z0(i.length) : s, p = "omission" in i ? J1(i.omission) : p;
        }
        o = X0(o);
        var l = o.length;
        if (Jn(o)) {
          var f = g2(o);
          l = f.length;
        }
        if (s >= l)
          return o;
        var h = s - Kn(p);
        if (h < 1)
          return p;
        var R = f ? xe(f, 0, h).join("") : o.slice(0, h);
        if (z === a)
          return R + p;
        if (f && (h += R.length - h), Ji(z)) {
          if (o.slice(h).search(z)) {
            var D, S = R;
            for (z.global || (z = ci(z.source, X0(ls.exec(z)) + "g")), z.lastIndex = 0; D = z.exec(S); )
              var w = D.index;
            R = R.slice(0, w === a ? h : w);
          }
        } else if (o.indexOf(J1(z), h) != h) {
          var F = R.lastIndexOf(z);
          F > -1 && (R = R.slice(0, F));
        }
        return R + p;
      }
      function jq(o) {
        return o = X0(o), o && a8.test(o) ? o.replace(Os, q7) : o;
      }
      var Gq = oa(function(o, i, s) {
        return o + (s ? " " : "") + i.toUpperCase();
      }), Qi = Id("toUpperCase");
      function Pp(o, i, s) {
        return o = X0(o), i = s ? a : i, i === a ? u7(o) ? W7(o) : i7(o) : o.match(i) || [];
      }
      var kp = l0(function(o, i) {
        try {
          return V1(o, a, i);
        } catch (s) {
          return Yi(s) ? s : new b0(s);
        }
      }), Vq = de(function(o, i) {
        return b2(i, function(s) {
          s = J2(s), be(o, s, Gi(o[s], o));
        }), o;
      });
      function Yq(o) {
        var i = o == null ? 0 : o.length, s = n0();
        return o = i ? Q0(o, function(p) {
          if (typeof p[1] != "function")
            throw new s2(b);
          return [s(p[0]), p[1]];
        }) : [], l0(function(p) {
          for (var z = -1; ++z < i; ) {
            var l = o[z];
            if (V1(l[0], this, p))
              return V1(l[1], this, p);
          }
        });
      }
      function Jq(o) {
        return qA(p2(o, m));
      }
      function eM(o) {
        return function() {
          return o;
        };
      }
      function Kq(o, i) {
        return o == null || o !== o ? i : o;
      }
      var Zq = Fd(), Qq = Fd(!0);
      function F1(o) {
        return o;
      }
      function nM(o) {
        return md(typeof o == "function" ? o : p2(o, m));
      }
      function eh(o) {
        return hd(p2(o, m));
      }
      function nh(o, i) {
        return yd(o, p2(i, m));
      }
      var ah = l0(function(o, i) {
        return function(s) {
          return Ka(s, o, i);
        };
      }), th = l0(function(o, i) {
        return function(s) {
          return Ka(o, s, i);
        };
      });
      function aM(o, i, s) {
        var p = f1(i), z = _3(i, p);
        s == null && !(a1(i) && (z.length || !p.length)) && (s = i, i = o, o = this, z = _3(i, f1(i)));
        var l = !(a1(s) && "chain" in s) || !!s.chain, f = ce(o);
        return b2(z, function(h) {
          var R = i[h];
          o[h] = R, f && (o.prototype[h] = function() {
            var D = this.__chain__;
            if (l || D) {
              var S = o(this.__wrapped__), w = S.__actions__ = k1(this.__actions__);
              return w.push({ func: R, args: arguments, thisArg: o }), S.__chain__ = D, S;
            }
            return R.apply(o, Ce([this.value()], arguments));
          });
        }), o;
      }
      function oh() {
        return y1._ === this && (y1._ = N7), this;
      }
      function tM() {
      }
      function rh(o) {
        return o = z0(o), l0(function(i) {
          return Wd(i, o);
        });
      }
      var ih = Bi(Q0), Mh = Bi(Hs), bh = Bi(ri);
      function Ip(o) {
        return Ii(o) ? ii(J2(o)) : EA(o);
      }
      function sh(o) {
        return function(i) {
          return o == null ? a : un(o, i);
        };
      }
      var dh = Ud(), ph = Ud(!0);
      function oM() {
        return [];
      }
      function rM() {
        return !1;
      }
      function ch() {
        return {};
      }
      function zh() {
        return "";
      }
      function Oh() {
        return !0;
      }
      function uh(o, i) {
        if (o = z0(o), o < 1 || o > U2)
          return [];
        var s = r2, p = L1(o, r2);
        i = n0(i), o -= r2;
        for (var z = si(p, i); ++s < o; )
          i(s);
        return z;
      }
      function Ah(o) {
        return d0(o) ? Q0(o, J2) : K1(o) ? [o] : k1(Mp(X0(o)));
      }
      function lh(o) {
        var i = ++L7;
        return X0(o) + i;
      }
      var fh = B3(function(o, i) {
        return o + i;
      }, 0), mh = wi("ceil"), qh = B3(function(o, i) {
        return o / i;
      }, 1), hh = wi("floor");
      function yh(o) {
        return o && o.length ? L3(o, F1, qi) : a;
      }
      function Wh(o, i) {
        return o && o.length ? L3(o, n0(i, 2), qi) : a;
      }
      function gh(o) {
        return Gs(o, F1);
      }
      function Rh(o, i) {
        return Gs(o, n0(i, 2));
      }
      function $h(o) {
        return o && o.length ? L3(o, F1, gi) : a;
      }
      function Lh(o, i) {
        return o && o.length ? L3(o, n0(i, 2), gi) : a;
      }
      var _h = B3(function(o, i) {
        return o * i;
      }, 1), Nh = wi("round"), vh = B3(function(o, i) {
        return o - i;
      }, 0);
      function Dh(o) {
        return o && o.length ? bi(o, F1) : 0;
      }
      function Th(o, i) {
        return o && o.length ? bi(o, n0(i, 2)) : 0;
      }
      return u.after = em, u.ary = fp, u.assign = Im, u.assignIn = Tp, u.assignInWith = G3, u.assignWith = xm, u.at = Fm, u.before = mp, u.bind = Gi, u.bindAll = Vq, u.bindKey = qp, u.castArray = cm, u.chain = up, u.chunk = ql, u.compact = hl, u.concat = yl, u.cond = Yq, u.conforms = Jq, u.constant = eM, u.countBy = Df, u.create = Hm, u.curry = hp, u.curryRight = yp, u.debounce = Wp, u.defaults = Um, u.defaultsDeep = jm, u.defer = nm, u.delay = am, u.difference = Wl, u.differenceBy = gl, u.differenceWith = Rl, u.drop = $l, u.dropRight = Ll, u.dropRightWhile = _l, u.dropWhile = Nl, u.fill = vl, u.filter = Sf, u.flatMap = Cf, u.flatMapDeep = Ef, u.flatMapDepth = Xf, u.flatten = pp, u.flattenDeep = Dl, u.flattenDepth = Tl, u.flip = tm, u.flow = Zq, u.flowRight = Qq, u.fromPairs = Sl, u.functions = Qm, u.functionsIn = eq, u.groupBy = Pf, u.initial = wl, u.intersection = Cl, u.intersectionBy = El, u.intersectionWith = Xl, u.invert = aq, u.invertBy = tq, u.invokeMap = If, u.iteratee = nM, u.keyBy = xf, u.keys = f1, u.keysIn = x1, u.map = I3, u.mapKeys = rq, u.mapValues = iq, u.matches = eh, u.matchesProperty = nh, u.memoize = F3, u.merge = Mq, u.mergeWith = Sp, u.method = ah, u.methodOf = th, u.mixin = aM, u.negate = H3, u.nthArg = rh, u.omit = bq, u.omitBy = sq, u.once = om, u.orderBy = Ff, u.over = ih, u.overArgs = rm, u.overEvery = Mh, u.overSome = bh, u.partial = Vi, u.partialRight = gp, u.partition = Hf, u.pick = dq, u.pickBy = Bp, u.property = Ip, u.propertyOf = sh, u.pull = xl, u.pullAll = zp, u.pullAllBy = Fl, u.pullAllWith = Hl, u.pullAt = Ul, u.range = dh, u.rangeRight = ph, u.rearg = im, u.reject = Gf, u.remove = jl, u.rest = Mm, u.reverse = Ui, u.sampleSize = Yf, u.set = cq, u.setWith = zq, u.shuffle = Jf, u.slice = Gl, u.sortBy = Qf, u.sortedUniq = ef, u.sortedUniqBy = nf, u.split = Cq, u.spread = bm, u.tail = af, u.take = tf, u.takeRight = of, u.takeRightWhile = rf, u.takeWhile = Mf, u.tap = yf, u.throttle = sm, u.thru = k3, u.toArray = Np, u.toPairs = wp, u.toPairsIn = Cp, u.toPath = Ah, u.toPlainObject = Dp, u.transform = Oq, u.unary = dm, u.union = bf, u.unionBy = sf, u.unionWith = df, u.uniq = pf, u.uniqBy = cf, u.uniqWith = zf, u.unset = uq, u.unzip = ji, u.unzipWith = Op, u.update = Aq, u.updateWith = lq, u.values = Ma, u.valuesIn = fq, u.without = Of, u.words = Pp, u.wrap = pm, u.xor = uf, u.xorBy = Af, u.xorWith = lf, u.zip = ff, u.zipObject = mf, u.zipObjectDeep = qf, u.zipWith = hf, u.entries = wp, u.entriesIn = Cp, u.extend = Tp, u.extendWith = G3, aM(u, u), u.add = fh, u.attempt = kp, u.camelCase = yq, u.capitalize = Ep, u.ceil = mh, u.clamp = mq, u.clone = zm, u.cloneDeep = um, u.cloneDeepWith = Am, u.cloneWith = Om, u.conformsTo = lm, u.deburr = Xp, u.defaultTo = Kq, u.divide = qh, u.endsWith = Wq, u.eq = $2, u.escape = gq, u.escapeRegExp = Rq, u.every = Tf, u.find = Bf, u.findIndex = sp, u.findKey = Gm, u.findLast = wf, u.findLastIndex = dp, u.findLastKey = Vm, u.floor = hh, u.forEach = Ap, u.forEachRight = lp, u.forIn = Ym, u.forInRight = Jm, u.forOwn = Km, u.forOwnRight = Zm, u.get = Ki, u.gt = fm, u.gte = mm, u.has = nq, u.hasIn = Zi, u.head = cp, u.identity = F1, u.includes = kf, u.indexOf = Bl, u.inRange = qq, u.invoke = oq, u.isArguments = fn, u.isArray = d0, u.isArrayBuffer = qm, u.isArrayLike = I1, u.isArrayLikeObject = M1, u.isBoolean = hm, u.isBuffer = Fe, u.isDate = ym, u.isElement = Wm, u.isEmpty = gm, u.isEqual = Rm, u.isEqualWith = $m, u.isError = Yi, u.isFinite = Lm, u.isFunction = ce, u.isInteger = Rp, u.isLength = U3, u.isMap = $p, u.isMatch = _m, u.isMatchWith = Nm, u.isNaN = vm, u.isNative = Dm, u.isNil = Sm, u.isNull = Tm, u.isNumber = Lp, u.isObject = a1, u.isObjectLike = r1, u.isPlainObject = tt, u.isRegExp = Ji, u.isSafeInteger = Bm, u.isSet = _p, u.isString = j3, u.isSymbol = K1, u.isTypedArray = ia, u.isUndefined = wm, u.isWeakMap = Cm, u.isWeakSet = Em, u.join = Pl, u.kebabCase = $q, u.last = z2, u.lastIndexOf = kl, u.lowerCase = Lq, u.lowerFirst = _q, u.lt = Xm, u.lte = Pm, u.max = yh, u.maxBy = Wh, u.mean = gh, u.meanBy = Rh, u.min = $h, u.minBy = Lh, u.stubArray = oM, u.stubFalse = rM, u.stubObject = ch, u.stubString = zh, u.stubTrue = Oh, u.multiply = _h, u.nth = Il, u.noConflict = oh, u.noop = tM, u.now = x3, u.pad = Nq, u.padEnd = vq, u.padStart = Dq, u.parseInt = Tq, u.random = hq, u.reduce = Uf, u.reduceRight = jf, u.repeat = Sq, u.replace = Bq, u.result = pq, u.round = Nh, u.runInContext = g, u.sample = Vf, u.size = Kf, u.snakeCase = wq, u.some = Zf, u.sortedIndex = Vl, u.sortedIndexBy = Yl, u.sortedIndexOf = Jl, u.sortedLastIndex = Kl, u.sortedLastIndexBy = Zl, u.sortedLastIndexOf = Ql, u.startCase = Eq, u.startsWith = Xq, u.subtract = vh, u.sum = Dh, u.sumBy = Th, u.template = Pq, u.times = uh, u.toFinite = ze, u.toInteger = z0, u.toLength = vp, u.toLower = kq, u.toNumber = O2, u.toSafeInteger = km, u.toString = X0, u.toUpper = Iq, u.trim = xq, u.trimEnd = Fq, u.trimStart = Hq, u.truncate = Uq, u.unescape = jq, u.uniqueId = lh, u.upperCase = Gq, u.upperFirst = Qi, u.each = Ap, u.eachRight = lp, u.first = cp, aM(u, function() {
        var o = {};
        return V2(u, function(i, s) {
          k0.call(u.prototype, s) || (o[s] = i);
        }), o;
      }(), { chain: !1 }), u.VERSION = t, b2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(o) {
        u[o].placeholder = u;
      }), b2(["drop", "take"], function(o, i) {
        R0.prototype[o] = function(s) {
          s = s === a ? 1 : u1(z0(s), 0);
          var p = this.__filtered__ && !i ? new R0(this) : this.clone();
          return p.__filtered__ ? p.__takeCount__ = L1(s, p.__takeCount__) : p.__views__.push({
            size: L1(s, r2),
            type: o + (p.__dir__ < 0 ? "Right" : "")
          }), p;
        }, R0.prototype[o + "Right"] = function(s) {
          return this.reverse()[o](s).reverse();
        };
      }), b2(["filter", "map", "takeWhile"], function(o, i) {
        var s = i + 1, p = s == H2 || s == $1;
        R0.prototype[o] = function(z) {
          var l = this.clone();
          return l.__iteratees__.push({
            iteratee: n0(z, 3),
            type: s
          }), l.__filtered__ = l.__filtered__ || p, l;
        };
      }), b2(["head", "last"], function(o, i) {
        var s = "take" + (i ? "Right" : "");
        R0.prototype[o] = function() {
          return this[s](1).value()[0];
        };
      }), b2(["initial", "tail"], function(o, i) {
        var s = "drop" + (i ? "" : "Right");
        R0.prototype[o] = function() {
          return this.__filtered__ ? new R0(this) : this[s](1);
        };
      }), R0.prototype.compact = function() {
        return this.filter(F1);
      }, R0.prototype.find = function(o) {
        return this.filter(o).head();
      }, R0.prototype.findLast = function(o) {
        return this.reverse().find(o);
      }, R0.prototype.invokeMap = l0(function(o, i) {
        return typeof o == "function" ? new R0(this) : this.map(function(s) {
          return Ka(s, o, i);
        });
      }), R0.prototype.reject = function(o) {
        return this.filter(H3(n0(o)));
      }, R0.prototype.slice = function(o, i) {
        o = z0(o);
        var s = this;
        return s.__filtered__ && (o > 0 || i < 0) ? new R0(s) : (o < 0 ? s = s.takeRight(-o) : o && (s = s.drop(o)), i !== a && (i = z0(i), s = i < 0 ? s.dropRight(-i) : s.take(i - o)), s);
      }, R0.prototype.takeRightWhile = function(o) {
        return this.reverse().takeWhile(o).reverse();
      }, R0.prototype.toArray = function() {
        return this.take(r2);
      }, V2(R0.prototype, function(o, i) {
        var s = /^(?:filter|find|map|reject)|While$/.test(i), p = /^(?:head|last)$/.test(i), z = u[p ? "take" + (i == "last" ? "Right" : "") : i], l = p || /^find/.test(i);
        z && (u.prototype[i] = function() {
          var f = this.__wrapped__, h = p ? [1] : arguments, R = f instanceof R0, D = h[0], S = R || d0(f), w = function(m0) {
            var N0 = z.apply(u, Ce([m0], h));
            return p && F ? N0[0] : N0;
          };
          S && s && typeof D == "function" && D.length != 1 && (R = S = !1);
          var F = this.__chain__, Y = !!this.__actions__.length, o0 = l && !F, A0 = R && !Y;
          if (!l && S) {
            f = A0 ? f : new R0(this);
            var r0 = o.apply(f, h);
            return r0.__actions__.push({ func: k3, args: [w], thisArg: a }), new d2(r0, F);
          }
          return o0 && A0 ? o.apply(this, h) : (r0 = this.thru(w), o0 ? p ? r0.value()[0] : r0.value() : r0);
        });
      }), b2(["pop", "push", "shift", "sort", "splice", "unshift"], function(o) {
        var i = c3[o], s = /^(?:push|sort|unshift)$/.test(o) ? "tap" : "thru", p = /^(?:pop|shift)$/.test(o);
        u.prototype[o] = function() {
          var z = arguments;
          if (p && !this.__chain__) {
            var l = this.value();
            return i.apply(d0(l) ? l : [], z);
          }
          return this[s](function(f) {
            return i.apply(d0(f) ? f : [], z);
          });
        };
      }), V2(R0.prototype, function(o, i) {
        var s = u[i];
        if (s) {
          var p = s.name + "";
          k0.call(na, p) || (na[p] = []), na[p].push({ name: i, func: s });
        }
      }), na[S3(a, t0).name] = [{
        name: "wrapper",
        func: a
      }], R0.prototype.clone = U7, R0.prototype.reverse = j7, R0.prototype.value = G7, u.prototype.at = Wf, u.prototype.chain = gf, u.prototype.commit = Rf, u.prototype.next = $f, u.prototype.plant = _f, u.prototype.reverse = Nf, u.prototype.toJSON = u.prototype.valueOf = u.prototype.value = vf, u.prototype.first = u.prototype.head, Ha && (u.prototype[Ha] = Lf), u;
    }, Zn = g7();
    dn ? ((dn.exports = Zn)._ = Zn, ni._ = Zn) : y1._ = Zn;
  }).call(Ln);
})(Uo, Uo.exports);
var y0 = Uo.exports;
function xT(e, n, a) {
  return y0.get(e, n, a) ?? a;
}
function FT(e, ...n) {
  return n.some((a) => e instanceof a);
}
const Ok = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getOrDefault: xT,
  instanceOfAny: FT
}, Symbol.toStringTag, { value: "Module" })), HT = (e) => e != null && typeof e < "u";
function UT(e, n = HT) {
  let [a, t] = [!1, !0];
  for (const r of e) {
    const M = n(r);
    if (a || (a = M), t && (t = M), a && !t)
      break;
  }
  return [a, t];
}
const uk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  someAndEvery: UT
}, Symbol.toStringTag, { value: "Module" }));
class kO extends Error {
  constructor(n) {
    const a = `Exhaustive Match Guard failed for value: ${String(n)}`;
    super(a), this.value = n, this.message = a, this.name = this.constructor.name, Error.captureStackTrace(this, this.constructor);
  }
}
function jT(e) {
  throw new kO(e);
}
const Ak = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ExhaustiveMatchGuardError: kO,
  exhaustiveMatchGuard: jT
}, Symbol.toStringTag, { value: "Module" }));
function lk(e) {
  const n = process.env[e];
  if (!n)
    throw new Error(`Environment variable ${e} is not defined`);
  return n;
}
const IO = "US";
function GT(e, n) {
  return e.reduce((a, t, r) => r % n === 0 ? [...a, [t]] : [...a.slice(0, -1), [...a.slice(-1)[0], t]], []);
}
function Tb(e, n) {
  if (!e || !Array.isArray(e) || e.length === 0)
    return e;
  const a = (t) => (r, M) => r[t] > M[t] ? 1 : M[t] > r[t] ? -1 : 0;
  return e.concat().sort(a(n));
}
function fk(e, n) {
  if (!e || !Array.isArray(e) || e.length === 0)
    return e;
  const a = (t) => (r, M) => {
    const b = typeof r[t] == "string" ? r[t].toLowerCase() : r[t], d = typeof M[t] == "string" ? M[t].toLowerCase() : M[t];
    return b > d ? 1 : d > b ? -1 : 0;
  };
  return e.concat().sort(a(n));
}
function mk(e, n) {
  return e.reduce((a, t) => Math.abs(t - n) < Math.abs(a - n) ? t : a, 0);
}
function qk(e) {
  return e.reduce((n, a) => (n[a] ? n[a]++ : n[a] = 1, n), {});
}
function hk(e, n) {
  if (typeof n == "string" && !e.some((r) => Object.keys(r).includes(n)))
    return e;
  const a = typeof n == "function" ? n : (r) => r[n], t = /* @__PURE__ */ new Map();
  for (const r of e) {
    const M = r === null || typeof r > "u" ? r : a(r);
    t.has(M) || t.set(M, r);
  }
  return [...t.values()];
}
function yk(e) {
  return e && e[Math.floor(Math.random() * e.length)];
}
function Wk(e) {
  return e.toLowerCase().replace(/^\w|[A-Z]|\b\w/gu, (n, a) => a === 0 ? n.toLowerCase() : n.toUpperCase()).replace(/\s+/gu, "");
}
function T4(e) {
  return e.replace(/(?<caps>[A-Z])/gu, " $1").replace(/\s+/gu, " ").trim();
}
function xO(e) {
  return e ? e.charAt(0).toUpperCase() + e.slice(1) : "";
}
function gk(e, n) {
  return e.map((a) => a[n]);
}
function Rk(e, n) {
  if (!(e instanceof Object && n instanceof Object))
    throw new Error("Core: hasSameKeys(): arguments must be Object-like");
  const a = Object.keys(e).sort(), t = Object.keys(n).sort();
  return JSON.stringify(a) === JSON.stringify(t);
}
function Sb(e, n) {
  return Object.keys(e).filter((a) => n(a)).reduce((a, t) => (a[t] = e[t], a), {});
}
function FO(e, n) {
  Object.keys(e).forEach((a) => {
    e[a] && (Array.isArray(e[a]) || typeof e[a] == "object") && FO(e[a], n);
  }), n.forEach((a) => {
    delete e[a];
  });
}
function $k(e) {
  FO(e, ["password", "ssn", "searchableCustomFields"]);
}
function Lk(e) {
  return e instanceof Date ? new Date(e.getTime()) : e instanceof I ? I(e) : JSON.parse(JSON.stringify(e));
}
function VT(e) {
  return e instanceof Object ? Object.fromEntries(
    Object.entries(e).filter(([n, a]) => a !== null).map(([n, a]) => [n, a === Object(a) ? VT(a) : a])
  ) : e;
}
function _k(e, n) {
  return new Date(e).getTime() - new Date(n).getTime();
}
function YT(e, n) {
  return e && JSON.stringify(e).includes(`"${n}":`);
}
function Nk(e) {
  const n = ["http:", "https:"];
  let a;
  try {
    a = new URL(e);
  } catch {
    return !1;
  }
  return e.match(/"/gu) || e.match(/%22/gu) ? !1 : n.includes(a.protocol);
}
function vk(e, n, a = "en") {
  try {
    const t = R1(e) ? P.fromISO(e) : P.fromJSDate(e);
    if (!t.isValid)
      throw new Error(`Invalid date: ${e}`);
    return t.setLocale(a).toFormat(n);
  } catch {
    return `Core: getFormattedTime(): Invalid date ${e} or format ${n}`;
  }
}
function Dk(e, n) {
  const a = e.indexOf(n);
  a > -1 && e.splice(a, 1);
}
function Tk(e, n, a = 0) {
  return e.reduce((t, r) => t + (parseFloat(n ? r[n] : r) || 0), a);
}
function JT(e) {
  return e && Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
}
function Bb(e) {
  return e == null || typeof e == "string" && e.trim() === "" || Array.isArray(e) && e.length === 0 ? !0 : typeof e == "object" && JT(e);
}
function Sk(e) {
  e = typeof e == "number" ? e : parseInt(e, 10), e = isNaN(e) ? 0 : e;
  const n = e / 60, a = Math.floor(n), t = Math.floor((n - a) * 60), r = `hour${a === 1 ? "" : "s"}`;
  return t === 0 ? `${a} ${r}` : a === 0 ? `${t} minutes` : `${a} ${r} and ${t} minutes`;
}
function Bk(e) {
  return e.toLowerCase().split(" ").map((n) => n.charAt(0).toUpperCase() + n.substring(1)).join(" ");
}
function wk(e) {
  var n;
  if (e)
    return (n = String(e).match(/^[a-z]+|[A-Z][a-z]*/gu)) == null ? void 0 : n.map((a) => a[0].toUpperCase() + a.substring(1).toLowerCase()).join(" ");
}
function Ck(e, n = !1, a = null) {
  const t = new Intl.Collator("en", {
    numeric: !0,
    sensitivity: "base"
  }), r = e.sort((M, b) => t.compare(a ? M[a] : M, a ? b[a] : b));
  return n && r.reverse(), r;
}
function Ek(e) {
  return e.filter((n) => n != null && n !== "");
}
function Xk(e) {
  return O6(e) && (e = Number(e)), rb(e) || (e = 6), require("randombytes")(e).toString("hex").slice(0, e);
}
function HO(e) {
  const n = "abcdefghijklmnopqrstuvwxyz", a = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", t = "0123456789", r = "!@#$%^&*()_+-=", M = n + a + t + r;
  let b = "";
  b += n.charAt(Math.floor(Math.random() * n.length)), b += a.charAt(Math.floor(Math.random() * a.length)), b += t.charAt(Math.floor(Math.random() * t.length)), b += r.charAt(Math.floor(Math.random() * r.length));
  for (let d = 4; d < e; d++) {
    const c = Math.floor(Math.random() * M.length);
    b += M.substring(c, c + 1);
  }
  return b;
}
function Pk() {
  return HO(32);
}
function kk() {
  return `!${HO(
    40
  )}`;
}
function Ik(e) {
  return R1(e) ? e.charAt(0).toUpperCase() + e.slice(1).toLowerCase() : e;
}
function xk(e) {
  const n = e;
  for (const a in e)
    e[a] || (n[a] = "");
  return n;
}
function KT(e) {
  const n = nn(e) ? String(e) : e;
  return R1(n) ? n.startsWith("+") ? Hc(n) : Hc(`+1${n}`) : !1;
}
function UO(e, n = IO) {
  var a;
  return R1(e) && ((a = RO(e, n)) == null ? void 0 : a.formatInternational()) || e;
}
function Fk(e, n = IO) {
  var a;
  return R1(e) && ((a = RO(e, n)) == null ? void 0 : a.format("E.164")) || e;
}
function Hk(e, n) {
  return [.../* @__PURE__ */ new Set([...e, ...n])];
}
function S4(e) {
  return e && Object.prototype.toString.call(e) === "[object Date]" && !isNaN(e) || typeof e == "string" && I(e, I.ISO_8601, !0).isValid();
}
function Uk(e) {
  if (!P1(e))
    return;
  Object.getOwnPropertyNames(e).forEach((a) => {
    S4(e[a]) && (e[a] = new Date(e[a]));
  });
}
function ZT(e, n = !0) {
  const t = new BT.FilterXSS({
    whiteList: {
      div: [],
      a: ["href", "target"],
      p: [],
      b: [],
      i: [],
      u: [],
      br: [],
      strong: []
    },
    stripIgnoreTag: !0,
    stripIgnoreTagBody: !1,
    escapeHtml: (r) => r
  }).process(e).replace("[removed]", "");
  return n ? t.replace(/  +/gu, " ").trim() : t;
}
function T5(e, n = !0) {
  return Array.isArray(e) ? e.map((a) => T5(a, n)) : P1(e) && !Pn(e) ? Object.fromEntries(
    Object.entries(e).map(([a, t]) => [
      a,
      T5(t, n)
    ])
  ) : (R1(e) && (e = ZT(e, n)), e);
}
function QT(e) {
  return e ? Object.keys(e).sort().reduce((n, a) => (n[a] = e[a], n), {}) : {};
}
function eS(e, n = 50) {
  return (e == null ? void 0 : e.length) > n;
}
function jk(e, n = 50, a = !0) {
  if (R1(e) || rb(e)) {
    const t = String(e), r = a && eS(t, n), M = "…", b = r ? n - M.length : n;
    return `${t.slice(0, b)}${r ? M : ""}`;
  }
  return "";
}
function jO(e) {
  if (o6(e)) {
    const n = ["loadsmart.", "opendock."], a = e.split("@");
    if (a.length === 2) {
      const t = a[0], r = a[1];
      if (n.find((M) => r.includes(M)) && t.includes("internal"))
        return !0;
    }
  }
  return !1;
}
function Gk(e) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(e);
}
function Vk(e) {
  return [...new Set(e)];
}
function nS(e) {
  return [...new Set(e.map((n) => n.toString()))].map((n) => new Date(n));
}
function Yk(e) {
  return [
    ...new Set(
      e.map((n) => JSON.stringify(n))
    )
  ].map((n) => JSON.parse(n));
}
function Jk(e, n) {
  return wn(e) ? e.filter((a) => wn(n) ? !n.includes(a) : !0) : [];
}
function Kk(e, n) {
  return P1(e) ? !!(n != null && n.some((a) => Object.keys(e).includes(a))) : !1;
}
function Zk(e) {
  if (!R1(e))
    return !1;
  const n = ["jpg", "jpeg", "png"], a = e.split(".").pop();
  return n.includes(a);
}
function Qk(e) {
  const n = {};
  return e.forEach((a) => {
    n[a.id] = a;
  }), n;
}
function eI(e, n) {
  return new Set([...e].filter((a) => !n.has(a)));
}
const Vt = (e, n) => Object.prototype.hasOwnProperty.call(e, n), nI = (e, n) => {
  const a = JSON.stringify(n);
  return e.find((t) => JSON.stringify(t) === a);
};
function S5(e, n = 1, a = "0", t = null) {
  const r = e.toString();
  return t = t ?? r.length + n, r.padStart(t, a);
}
function aI(e, n, a = !0) {
  return a ? Math.ceil(e / n) * n : Math.floor(e / n) * n;
}
function tI(e) {
  return e && e.replace(/\s+/gu, "-").replace(/:/gu, "").replace(/,/gu, "").replace(/(?<lowercase>[a-z])(?<uppercase>[A-Z])/gu, "$1-$2").toLowerCase();
}
function oI(e) {
  return e.replace(/^[-_]*(?<temp1>.)/, (n, a) => a.toUpperCase()).replace(/[-_]+(?<temp1>.)/g, (n, a) => ` ${a.toUpperCase()}`);
}
function aS(e) {
  if (e && typeof e == "object")
    return e;
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
function tS(e, n) {
  if (e === n)
    return !0;
  if (e instanceof Date && n instanceof Date && e.getTime() !== n.getTime() || e !== Object(e) || n !== Object(n))
    return !1;
  const a = Object.keys(e);
  return a.length !== Object.keys(n).length ? !1 : a.every((t) => tS(e[t], n[t]));
}
function rI() {
  const e = Object.values(wT).map((n) => ({
    iso2: n.iso2,
    name: n.name
  }));
  return Object.values(e).map((n) => n.iso2), e.map((n) => ({
    ...n,
    callingCode: FD(n.iso2)
  }));
}
function iI(e) {
  return e.replace(/[^a-z0-9]/giu, "");
}
function oS(e, n, a) {
  return `${e.slice(0, a)}${n}${e.slice(a)}`;
}
function MI(e, n, a) {
  return a = a ?? `${n}s`, Math.abs(e) === 1 ? n : a;
}
function rS(e, n) {
  for (const a in e)
    Object.prototype.hasOwnProperty.call(e, a) && (typeof e[a] == "object" && e[a] !== null && rS(e[a], n), a === n && delete e[a]);
  return e;
}
function bI(e, n) {
  if (!wn(e))
    throw new Error(`Core: paginateArray(): expected array and got ${typeof e}`);
  const a = Math.min((n == null ? void 0 : n.size) ?? UM.size, UM.size), t = e.length, r = Math.ceil(t / a), M = Math.min(Math.max((n == null ? void 0 : n.page) ?? UM.page, 1), r), b = (M - 1) * a, d = a + b, c = e.slice(b, d), O = c.length;
  return { data: c, total: t, count: O, page: M, pageCount: r };
}
function sI(e, n) {
  return n.split(".").reduce((a, t) => a && a[t] !== "undefined" ? a[t] : null, e);
}
function iS(...e) {
  return e.flatMap((n) => (n == null ? void 0 : n.split(" ")) ?? []).map((n) => n == null ? void 0 : n.trim()).filter((n) => ((n == null ? void 0 : n.length) ?? 0) > 0).join(" ");
}
function dI(e, {
  searchableFields: n = [],
  searchFieldsToSplit: a = []
} = {}) {
  return e ? n.reduce((r, M) => {
    var d;
    const b = a.includes(M) ? [{ [M]: { $inL: (d = e == null ? void 0 : e.toLowerCase()) == null ? void 0 : d.split(" ") } }] : [];
    return [...r, { [M]: { $contL: e } }, ...b];
  }, []) : [];
}
function pI(e, n) {
  const a = /* @__PURE__ */ new Map();
  return n.forEach((t, r) => a.set(t, r)), e.sort((t, r) => {
    const M = a.has(t) ? a.get(t) : 1 / 0, b = a.has(r) ? a.get(r) : 1 / 0;
    return M - b;
  });
}
function cI(e, n) {
  return n.split(".").reduce((a, t) => a && a[t], e);
}
const v2 = {
  week: 604800,
  day: 86400,
  hour: 3600,
  minute: 60
}, Cn = {
  week: 604800 * 1e3,
  day: 86400 * 1e3,
  hour: 3600 * 1e3,
  minute: 60 * 1e3,
  second: 1e3
};
function W2(e, n) {
  const a = new Date(e), t = new Date(n);
  if (e && n && a <= t)
    return { start: a, end: t };
  throw new Error(
    `Core: fromDates(): 'start' is after 'end', or invalid dates. start: ${e}, end: ${n}`
  );
}
function _o({ start: e, end: n }) {
  return W2(e, n);
}
function MS(e) {
  return W2(...e);
}
function bS(e) {
  const n = Xb(e);
  if (n)
    throw new Error(`Core: toArray(): ${n}`);
  return [e.start, e.end];
}
function sS(e, n) {
  return $5(e) === $5(n);
}
function GO(e, n) {
  return W2(
    new Date(e.start.getTime() + n),
    new Date(e.end.getTime() + n)
  );
}
function VO(e, n) {
  return GO(e, n * 1e3);
}
function wb(e, n) {
  return VO(e, n * 60);
}
function dS(e, n) {
  return wb(e, n * 60);
}
function pS(e, n) {
  return dS(e, n * 24);
}
function cS(e, n) {
  return pS(e, n * 7);
}
function an(e) {
  const n = Xb(e);
  if (n)
    throw new Error(`Core: duration: invalid interval ${n}`);
  return Number(new Date(e.end)) - Number(new Date(e.start));
}
function zI(e) {
  return e ? e.reduce((n, a) => n + an(a), 0) : 0;
}
function zS(e) {
  return an(e) / 1e3;
}
function OS(e) {
  return zS(e) / 60;
}
function YO(e) {
  return OS(e) / 60;
}
function uS(e) {
  return YO(e) / 24;
}
function AS(e) {
  return uS(e) / 7;
}
function JO(e, n) {
  return e.start <= n.start;
}
function OI(e, n) {
  return e.start >= n.start;
}
function Cb(e, n) {
  return e.end <= n.end;
}
function uI(e, n) {
  return e.end >= n.end;
}
function lS(e, n) {
  return e.start >= n.end;
}
function B4(e, n) {
  return e.end <= n.start;
}
function Yt(e, n) {
  return !e || !n ? !0 : B4(e, n) || lS(e, n);
}
function $r(e, n) {
  return !Yt(e, n);
}
function Eb(e, n) {
  return sS(ZO(e, n)[0], e);
}
function AI(e, n) {
  return n.some((a) => Eb(e, a));
}
function lI(e, n) {
  return n.some((a) => $r(e, a));
}
function fI(e, n) {
  return (n == null ? void 0 : n.filter((a) => $r(e, a)).length) ?? 0;
}
function w4(e, n) {
  return JO(e, n) ? Yt(e, n) ? [_o(e), _o(n)] : Cb(n, e) ? [_o(e)] : [W2(e.start, n.end)] : w4(n, e);
}
function KO(e, n) {
  if (!(e != null && e.length))
    return n;
  if (!(n != null && n.length))
    return e;
  const a = e[0], t = n[0];
  e = e.slice(1), n = n.slice(1);
  let r = w4(a, t);
  return [e, n].forEach((M) => {
    for (; $r(r[r.length - 1], M[0]); ) {
      const b = r.pop(), d = M.shift();
      r = r.concat(w4(b, d));
    }
  }), r.concat(KO(e, n));
}
function mI(e, n) {
  return Lr(KO(e, n));
}
function ZO(e, n) {
  return JO(e, n) ? Yt(e, n) ? [] : Cb(n, e) ? [_o(n)] : [W2(n.start, e.end)] : ZO(n, e);
}
function C4(e, n) {
  if (!(e != null && e.length) || !(n != null && n.length))
    return [];
  const a = [];
  let t = 0, r = 0;
  for (; t < e.length && r < n.length; ) {
    const M = e[t], b = n[r];
    B4(M, b) ? t++ : B4(b, M) ? r++ : (a.push({
      start: kD(M.start, b.start),
      end: PD(M.end, b.end)
    }), Cb(M, b) ? t++ : r++);
  }
  return a;
}
function fS(e) {
  return e.length === 0 ? !0 : (e = Lr(e), bv(e, 2).every((a) => Yt(a[0], a[1])));
}
function qI(e) {
  return !fS(e);
}
function QO(e, n) {
  if (!["start", "end"].includes(n))
    throw new Error(`Core: sortByEdge(): invalid edge ${n}`);
  return e.sort((a, t) => Number(a[n]) - Number(t[n]));
}
function Lr(e) {
  return QO(e, "start");
}
function hI(e) {
  return QO(e, "end");
}
function yI(e) {
  return e.sort((n, a) => an(n) - an(a));
}
function mS(e, n, a = 1e3) {
  const t = [e.start, ...n.flatMap(bS), e.end];
  return GT(t, 2).map(MS).filter((r) => an(r) > a);
}
function WI(e, n, a = 1e3) {
  return mS(e, C4([e], n), a);
}
function qS(e, n, a) {
  if (!Number.isInteger(n) || !Number.isInteger(a))
    throw new Error("Core: repeat(): 'n' and 'offset_s' must be integers");
  let t = [];
  for (let r = 0; r < n; r++)
    t = t.concat(e.map((M) => VO(M, r * a)));
  return _r(t);
}
function hS(e, n) {
  return qS(
    e,
    n,
    604800
    /* seconds in a week */
  );
}
function Xb(e) {
  const n = Object.keys(e), a = ["start", "end"];
  for (const t of a)
    if (!n.includes(t))
      return `Interval missing key: '${t}'`;
  return S4(e.start) ? S4(e.end) ? e.start > e.end ? `Interval 'start' (${e.start}) is later than 'end' (${e.end})` : null : `Interval.end is not a valid Date: '${e.end}'` : `Interval.start is not a valid Date: '${e.start}'`;
}
function _r(e, n = Cn.minute) {
  if (!e || e.length < 2)
    return e;
  const a = [e[0]];
  for (let t = 1; t < e.length; t++) {
    const r = a[a.length - 1], M = e[t];
    if (M.start.getTime() - r.end.getTime() <= n) {
      const d = W2(r.start, M.end);
      a[a.length - 1] = d;
    } else
      a.push(M);
  }
  return a;
}
function gI(e, n) {
  const a = [];
  for (const t of n)
    e <= 0 ? a.push(t) : an(t) <= e ? e -= an(t) : (a.push({
      start: new Date(t.start.getTime() + e),
      end: t.end
    }), e = 0);
  return a;
}
function RI(e, n) {
  return !e || !n ? !1 : e >= n.start && e <= n.end;
}
var i0 = /* @__PURE__ */ ((e) => (e.NoShow = "NoShow", e.Cancelled = "Cancelled", e.Requested = "Requested", e.Scheduled = "Scheduled", e.Arrived = "Arrived", e.InProgress = "InProgress", e.Completed = "Completed", e))(i0 || {});
function k2(e = [
  "Requested",
  "InProgress"
  /* InProgress */
]) {
  const n = {
    Requested: {
      isHappyPath: !0,
      happyPathOrder: 0.5,
      isStartState: !0,
      isEndState: !1,
      canUndo: !1,
      isOptional: !0,
      validNextStatuses: [
        "Scheduled",
        "Cancelled"
        /* Cancelled */
      ],
      undoStatus: null,
      allowUpdateToFutureDate: !0
    },
    Scheduled: {
      isHappyPath: !0,
      happyPathOrder: 1,
      isStartState: !0,
      isEndState: !1,
      canUndo: !0,
      validNextStatuses: [
        "Arrived",
        "NoShow",
        "Cancelled"
        /* Cancelled */
      ],
      undoStatus: "Requested",
      allowUpdateToFutureDate: !0
    },
    Arrived: {
      isHappyPath: !0,
      happyPathOrder: 2,
      isStartState: !1,
      isEndState: !1,
      canUndo: !0,
      validNextStatuses: [
        "InProgress",
        "Completed",
        "Cancelled"
        /* Cancelled */
      ],
      undoStatus: "Scheduled",
      allowUpdateToFutureDate: !0
    },
    InProgress: {
      isHappyPath: !0,
      happyPathOrder: 2.5,
      isStartState: !1,
      isOptional: !0,
      isEndState: !1,
      canUndo: !0,
      validNextStatuses: [
        "Completed"
        /* Completed */
      ],
      undoStatus: "Arrived",
      allowUpdateToFutureDate: !1
    },
    Completed: {
      isHappyPath: !0,
      happyPathOrder: 3,
      isStartState: !1,
      isEndState: !0,
      canUndo: !0,
      validNextStatuses: [],
      // WARNING: This is not exactly true! In practice Neutron
      // will choose either Arrived or InProgress dynamically,
      // based on the timeline. See "computeUndoStatus()".
      undoStatus: "Arrived",
      allowUpdateToFutureDate: !0
    },
    NoShow: {
      isHappyPath: !1,
      happyPathOrder: 0,
      isStartState: !1,
      isEndState: !0,
      canUndo: !0,
      validNextStatuses: [],
      undoStatus: "Scheduled",
      allowUpdateToFutureDate: !0
    },
    Cancelled: {
      isHappyPath: !1,
      happyPathOrder: 0,
      isStartState: !1,
      isEndState: !0,
      canUndo: !1,
      validNextStatuses: [],
      undoStatus: null,
      allowUpdateToFutureDate: !0
    }
  }, a = Object.keys(n).sort((O, A) => n[O].happyPathOrder - n[A].happyPathOrder), t = Object.values(n).filter(
    (O) => !O.isHappyPath
  ).length, r = a.filter((O) => {
    const A = n[O];
    return !A.isOptional || A.isOptional && e.includes(O);
  }).length - t;
  let M = 1, b = r + 1;
  const d = {};
  a.forEach((O) => {
    const A = n[O];
    A.isOptional ? e.includes(O) && (c(M, O, A), M++) : A.isHappyPath ? (c(M, O, A), M++) : (c(b, O, A), b++);
  });
  function c(O, A, m) {
    O === 1 && (m.canUndo = !1), m.stepNumber = O, d[A] = m;
  }
  return d;
}
function E4() {
  return Object.keys(i0);
}
function B5() {
  const e = E4(), n = yS();
  return e.filter((a) => !n.includes(a));
}
function yS() {
  const e = k2(), n = Sb(e, (a) => e[a].isOptional);
  return Object.keys(n);
}
function WS(e, n) {
  const a = k2()[e].allowUpdateToFutureDate === !1;
  return $t(n) && a ? NS(n) : !1;
}
function gS(e) {
  return !!k2()[e].isOptional;
}
function ft(e) {
  return jo().includes(e);
}
function $I(e) {
  return X4(e) && k2()[e].canUndo;
}
function RS(e) {
  return ft(e);
}
function LI(e) {
  return k2()[e].validNextStatuses.includes(
    "Cancelled"
    /* Cancelled */
  );
}
function $S(e, n) {
  return ft(e) && ft(n) || !ft(e) && !ft(n);
}
function jo() {
  const e = Sb(
    k2(),
    (n) => k2()[n].isStartState
  );
  return Object.keys(e);
}
function _I(e) {
  const n = jo(), a = e == null ? void 0 : e.appointmentCreationStatus;
  return n.includes(a) ? a : "Scheduled";
}
function NI() {
  const e = k2(), n = Sb(e, (a) => RS(a));
  return Object.keys(n);
}
function X4(e) {
  return e && Object.keys(i0).includes(e);
}
function vI(e, n) {
  return X4(e) && X4(n) ? e === n || k2()[e].validNextStatuses.includes(n) : !1;
}
function DI(e) {
  if (typeof e != "object")
    return "statusTimeline must be a valid StatusTimeline object";
  const n = Object.keys(e);
  if (!n.every((d) => E4().includes(d)))
    return `statusTimeline must only contain a subset of the following fields: ${E4()}`;
  if (!B5().every(
    (d) => n.includes(d)
  ))
    return `statusTimeline must at least contain the following fields: ${B5()}`;
  for (const d of Object.values(e)) {
    const c = (d == null ? void 0 : d.toString().length) === 0, O = d && !(Pn(d) || $t(d));
    if (c || O)
      return `statusTimeline: '${d}' is not a valid Date string`;
  }
  const a = Object.keys(e).filter(
    (d) => !!e[d] && jo().includes(d)
  );
  if (a.length < 1 || a.length > jo().length)
    return `statusTimeline: Incorrect number of start Statuses: found ${a.length}`;
  const t = k2(), r = y0.map(
    y0.reduce(
      t,
      (d, c, O) => (c.isHappyPath && d.push({ key: O, happyPathOrder: c.happyPathOrder }), y0.sortBy(d, "happyPathOrder")),
      []
    ),
    "key"
  ), M = r.filter((d) => e[d] !== null);
  function b(d) {
    return d && new Date(d);
  }
  for (const d of [r, M])
    for (let c = 1; c < d.length; c++) {
      const O = d[c], A = d[c - 1], m = b(e[O]), q = b(e[A]), y = $S(O, A), $ = gS(A);
      if (y && m && (!($ || q) || m < q))
        return `statusTimeline: You cannot mark an Appointment ${O} before ${A}`;
    }
  for (const [d, c] of Object.entries(e))
    if (WS(d, String(c)))
      return `statusTimeline: '${d}' status timeline cannot be changed into a future date ${c}'`;
  return null;
}
function LS() {
  return Object.entries(k2()).sort(([e, n], [a, t]) => n.happyPathOrder > 0 ? n.happyPathOrder - t.happyPathOrder : 1).map(([e, n]) => e);
}
function TI(e) {
  if (!P1(e))
    return "";
  let n = Object.entries(e).filter(([a, t]) => !!t).map(([a, t]) => ({
    status: a,
    time: t
  }));
  return n = Tb(n, "time").reverse(), (n == null ? void 0 : n.length) > 0 ? n[0].status : "";
}
function SI(e) {
  if (!P1(e))
    return "";
  const n = LS().reverse(), a = Object.entries(e).filter(([r, M]) => !!M).map(([r]) => r);
  let t = "";
  return n.some((r) => a.includes(r) ? (t = r, !0) : !1), t;
}
function BI(e, n) {
  return Object.keys(n).includes(e) && !!n[e];
}
function wI(e, n, a) {
  return n === "Completed" && a.InProgress ? "InProgress" : e[n].undoStatus;
}
function CI(e, n, a = "ddd, MMM Do YYYY @ h:mmA - z") {
  if (!W0.tz.zone(n))
    throw new Error(`Core: renderUtcInTimezone(): Invalid timezone ${n}`);
  return W0(e).tz(n).format(a);
}
function EI(e, n) {
  if (!R1(n) || !W0.tz.zone(n))
    throw new Error(`Core: renderUtcInTimezoneMoment(): Invalid timezone ${n}`);
  return W0(e).tz(n);
}
function XI(e, n) {
  return e.replace(/(GMT)?[+-]\d{1,4}/u, n);
}
function PI(e, n, a = null) {
  if (!W0.tz.zone(n))
    throw new Error(`Core: renderTimezoneInUtc(): Invalid timezone ${n}`);
  return W0.tz(e, n).utc().format(a);
}
function kI(e, n) {
  if (!W0.tz.zone(n))
    throw new Error(`Core: getFullDayIntervalFromDateInUtc(): Invalid timezone ${n}`);
  return {
    start: W0.tz(e, n).startOf("day").utc().format(),
    end: W0.tz(e, n).endOf("day").utc().format()
  };
}
function II(e, n) {
  if (!W0.tz.zone(n))
    throw new Error(`Core: getFullDayIntervalFromDateInTimezone(): Invalid timezone ${n}`);
  return {
    start: W0.tz(e, n).startOf("day").format(),
    end: W0.tz(e, n).endOf("day").format()
  };
}
function xI() {
  return W0().utc(!1).format();
}
function _S() {
  return W0().utc(!1).toDate();
}
function FI(e) {
  const n = new Date(e);
  n.setUTCHours(23, 59, 59, 599);
  const a = /* @__PURE__ */ new Date();
  return a.setUTCHours(23, 59, 59, 599), n < a;
}
function NS(e) {
  return P.fromISO(e).diffNow("seconds").seconds > 0;
}
function vS({
  startDateStr: e,
  endDateStr: n,
  diffUnit: a = "week"
}) {
  const t = "YYYY-MM-DD", r = W0(e, t), M = W0(n, t);
  return Math.abs(M.diff(r, a));
}
function HI(e) {
  let n = P.now();
  return e && (n = n.setZone(e)), n;
}
var eu = {
  error: {
    length: "Length should be a valid positive number",
    password: "Password should be a valid string",
    invalidPlugin: "Plugin should be a valid function"
  },
  regex: {
    digits: "(\\d.*)",
    letters: "([a-zA-Z].*)",
    symbols: "([`~\\!@#\\$%\\^\\&\\*\\(\\)\\-_\\=\\+\\[\\{\\}\\]\\\\|;:\\'\",<.>\\/\\?€£¥₹§±].*)",
    spaces: "([\\s].*)"
  }
}, bo = eu.regex;
function za(e, n) {
  if (n && n > 1) {
    const a = parseInt(n, 10);
    return new RegExp(e + "{" + a + ",}").test(this.password) === this.positive;
  }
  return new RegExp(e).test(this.password) === this.positive;
}
var DS = {
  /**
   * Method to invert the next validations
   *
   * @param {RegExp} [symbol] - custom Regex which should not be present
   */
  not: function(n) {
    return this.positive = !1, n ? za.call(this, n) : !0;
  },
  /**
   * Method to invert the effects of not()
   *
   * @param {RegExp} [symbol] - custom Regex which should be present
   */
  has: function(n) {
    return this.positive = !0, n ? za.call(this, n) : !0;
  },
  /**
   * Method to invert the effects of not() and
   * to make the api readable and chainable
   *
   */
  is: function() {
    return this.positive = !0, !0;
  },
  /**
   * Method to specify a minimum length
   *
   * @param {number} num - minimum length
   */
  min: function(n) {
    return this.password.length >= n;
  },
  /**
   * Method to specify a maximum length
   *
   * @param {number} num - maximum length
   */
  max: function(n) {
    return this.password.length <= n;
  },
  /**
   * Method to validate the presence of digits
   *
   * @param {number} repeat - count of required digits
   */
  digits: function(n) {
    return za.call(this, bo.digits, n);
  },
  /**
   * Method to validate the presence of letters
   *
   * @param {number} repeat - count of required letters
   */
  letters: function(n) {
    return za.call(this, bo.letters, n);
  },
  /**
   * Method to validate the presence of uppercase letters
   *
   * @param {number} repeat - count of required uppercase letters
   */
  uppercase: function(n) {
    if (n && n > 1) {
      let a = 0, t = 0;
      for (; t < n && a < this.password.length; ) {
        const r = this.password.charAt(a);
        r !== r.toLowerCase() && t++, a++;
      }
      return t === n === this.positive;
    }
    return this.password !== this.password.toLowerCase() === this.positive;
  },
  /**
   * Method to validate the presence of lowercase letters
   *
   * @param {number} repeat - count of required lowercase letters
   */
  lowercase: function(n) {
    if (n && n > 1) {
      let a = 0, t = 0;
      for (; t < n && a < this.password.length; ) {
        const r = this.password.charAt(a);
        r !== r.toUpperCase() && t++, a++;
      }
      return t === n === this.positive;
    }
    return this.password !== this.password.toUpperCase() === this.positive;
  },
  /**
   * Method to validate the presence of symbols
   *
   * @param {number} repeat - count of required symbols
   */
  symbols: function(n) {
    return za.call(this, bo.symbols, n);
  },
  /**
   * Method to validate the presence of space
   *
   * @param {number} repeat - count of required spaces
   */
  spaces: function(n) {
    return za.call(this, bo.spaces, n);
  },
  /**
   * Method to provide pre-defined values for password
   *
   * @param {array} list - list of values allowed
   */
  oneOf: function(n) {
    return n.indexOf(this.password) >= 0 === this.positive;
  },
  /**
   * Method to run a plugin function for password
   *
   * @param {function} plugin - A plugin function
   */
  usingPlugin: function(n) {
    try {
      return !!n.call({}, this.password) === this.positive;
    } catch {
      return !1;
    }
  }
}, TS = function(e, n, a) {
  const t = a ? BS : SS;
  return t[e] && t[e](n);
};
const SS = {
  min: (e) => `The string should have a minimum length of ${e} character${N1(e)}`,
  max: (e) => `The string should have a maximum length of ${e} character${N1(e)}`,
  letters: (e = 1) => `The string should have a minimum of ${e} letter${N1(e)}`,
  digits: (e = 1) => `The string should have a minimum of ${e} digit${N1(e)}`,
  uppercase: (e = 1) => `The string should have a minimum of ${e} uppercase letter${N1(e)}`,
  lowercase: (e = 1) => `The string should have a minimum of ${e} lowercase letter${N1(e)}`,
  symbols: (e = 1) => `The string should have a minimum of ${e} symbol${N1(e)}`,
  spaces: (e = 1) => `The string should have a minimum of ${e} space${N1(e)}`,
  oneOf: (e) => `The string should be ${e.length > 1 ? `one of ${e.slice(0, -1).join(", ")} and ` : ""}${e[e.length - 1]}`,
  has: (e) => `The string should have pattern '${e}'`,
  not: (e) => `The string should not have pattern '${e}'`,
  usingPlugin: (e) => `The string should not violate ${e.name || "plugin"}`
}, BS = {
  min: (e) => `The string should have a maximum length of ${e} character${N1(e)}`,
  max: (e) => `The string should have a minimum length of ${e} character${N1(e)}`,
  letters: (e = 0) => `The string should ${e === 0 ? "not have" : `have a maximum of ${e}`} letter${N1(e)}`,
  digits: (e = 0) => `The string should ${e === 0 ? "not have" : `have a maximum of ${e}`} digit${N1(e)}`,
  uppercase: (e = 0) => `The string should ${e === 0 ? "not have" : `have a maximum of ${e}`} uppercase letter${N1(e)}`,
  lowercase: (e = 0) => `The string should ${e === 0 ? "not have" : `have a maximum of ${e}`} lowercase letter${N1(e)}`,
  symbols: (e = 0) => `The string should ${e === 0 ? "not have" : `have a maximum of ${e}`} symbol${N1(e)}`,
  spaces: (e = 0) => `The string should ${e === 0 ? "not have" : `have a maximum of ${e}`} space${N1(e)}`,
  oneOf: (e) => `The string should not be ${e.length > 1 ? `one of ${e.slice(0, -1).join(", ")} and ` : ""}${e[e.length - 1]}`,
  has: (e) => `The string should not have pattern '${e}'`,
  not: (e) => `The string should have pattern '${e}'`,
  usingPlugin: (e) => `The string should violate ${e.name || "plugin"}`
};
function N1(e) {
  return e === 1 ? "" : "s";
}
var wS = DS, nu = eu.error, CS = TS;
function Ue(e) {
  const n = Number(e);
  if (isNaN(n) || !Number.isInteger(n) || n < 1)
    throw new Error(nu.length);
}
function w5(e) {
  return wS[e.method].apply(this, e.arguments);
}
function e2(e, n, a) {
  return this.properties.push({ method: e, arguments: n, description: a }), this;
}
class ES {
  /**
   * Creates a password-validator schema
   *
   * @constructor
   */
  constructor() {
    this.properties = [];
  }
  /**
   * Method to validate the password against schema
   *
   * @param {string} pwd - password to validate
   * @param {object} [options] - optional options to configure validation
   * @param {boolean} [options.list] - asks for a list of validation
   *           failures instead of just true/false
   * @param {boolean} [options.details] - asks for more details about
   *           failed validations including arguments, and error messages
   * @returns {boolean|array} Boolean value indicting the validity
   *           of the password as per schema, if 'options.list' or
   *           'options.details' is not set. Otherwise, it returns an
   *           array of property names which failed validations
   */
  validate(n, a) {
    return this.list = !!(a && a.list), this.details = !!(a && a.details), this.password = String(n), this.positive = !0, this.list || this.details ? this.properties.reduce((t, r) => {
      if (!w5.call(this, r)) {
        var M = r.method;
        if (this.details) {
          M = { validation: r.method }, r.arguments && r.arguments[0] && (M.arguments = r.arguments[0]), !this.positive && r.method !== "not" && (M.inverted = !0);
          var b = r.arguments && r.arguments[1], d = b || CS(r.method, M.arguments, M.inverted);
          M.message = d;
        }
        return t.concat(M);
      }
      return t;
    }, []) : this.properties.every(w5.bind(this));
  }
  /**
   * Rule to mandate the presence of letters in the password
   *
   * @param {number} [count] - minimum number of letters required
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  letters(n, a) {
    return n && Ue(n), e2.call(this, "letters", arguments);
  }
  /**
   * Rule to mandate the presence of digits in the password
   *
   * @param {number} [count] - minimum number of digits required
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  digits(n, a) {
    return n && Ue(n), e2.call(this, "digits", arguments);
  }
  /**
   * Rule to mandate the presence of symbols in the password
   *
   * @param {number} [count] - minimum number of symbols required
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  symbols(n, a) {
    return n && Ue(n), e2.call(this, "symbols", arguments);
  }
  /**
   * Rule to specify a minimum length of the password
   *
   * @param {number} num - minimum length
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  min(n, a) {
    return Ue(n), e2.call(this, "min", arguments);
  }
  /**
   * Rule to specify a maximum length of the password
   *
   * @param {number} num - maximum length
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  max(n, a) {
    return Ue(n), e2.call(this, "max", arguments);
  }
  /**
   * Rule to mandate the presence of lowercase letters in the password
   *
   * @param {number} [count] - minimum number of lowercase letters required
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  lowercase(n, a) {
    return n && Ue(n), e2.call(this, "lowercase", arguments);
  }
  /**
   * Rule to mandate the presence of uppercase letters in the password
   *
   * @param {number} [count] - minimum number of uppercase letters required
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  uppercase(n, a) {
    return n && Ue(n), e2.call(this, "uppercase", arguments);
  }
  /**
   * Rule to mandate the presence of space in the password
   * It can be used along with 'not' to not allow spaces
   * in the password
   *
   * @param {number} [count] - minimum number of spaces required
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  spaces(n, a) {
    return n && Ue(n), e2.call(this, "spaces", arguments);
  }
  /**
   * Rule to invert the effects of 'not'
   * Apart from that, 'has' is also used
   * to make the api readable and chainable
   *
   * @param {string|RegExp} [pattern] - pattern to match
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  has(n, a) {
    return e2.call(this, "has", arguments);
  }
  /**
   * Rule to invert the next applied rules.
   * All the rules applied after 'not' will have opposite effect,
   * until 'has' rule is applied
   *
   * @param {string|RegExp} [pattern] - pattern to not match
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  not(n, a) {
    return e2.call(this, "not", arguments);
  }
  /**
   * Rule to invert the effects of 'not'
   * Apart from that, 'is' is also used
   * to make the api readable and chainable
   *
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  is() {
    return e2.call(this, "is", arguments);
  }
  /**
   * Rule to whitelist words to be used as password
   *
   * @param {array} list - list of values allowed
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  oneOf(n, a) {
    return e2.call(this, "oneOf", arguments);
  }
  /**
   * Insert a plugin function into the validation chain
   *
   * @param {Plugin} fn  - A plugin function
   * @param {string} [description] - description of the validation
   * @returns {PasswordValidator} instance of PasswordValidator schema
   */
  usingPlugin(n, a) {
    if (typeof n != "function")
      throw new Error(nu.invalidPlugin);
    return e2.call(this, "usingPlugin", arguments);
  }
}
var XS = ES;
const PS = /* @__PURE__ */ I2(XS), au = {
  odcInternalUserId: "5b1dd496-f7a4-4011-b4e2-987a41c131f4",
  defaultInternalOrgId: "default-internal"
}, kS = 1, UI = "https://lp.opendock.com/gate-management?utm_source=opendockapp&utm_medium=cta&utm_campaign=od-gate-management-warehouse-opendock-q4-24&utm_content=appt-details", IS = "carriercheckin@example.com", C5 = 60 * 24;
function jI(e) {
  if (rb(e) || R1(e))
    return Number(e) * 1609.34;
  throw new Error(`Invalid miles ${e}`);
}
const xS = {
  "core.appointment.messages.rescheduledOnce": "Rescheduled once",
  "core.appointment.messages.rescheduledTwice": "Rescheduled twice",
  "core.appointment.messages.rescheduledCountTimes": "Rescheduled {count} times",
  "core.customFields.labels.textSingleLine": "Text - Single Line",
  "core.customFields.labels.textMultipleLines": "Text - Multiple Lines",
  "core.customFields.labels.date": "Date",
  "core.customFields.labels.trueFalse": "True/False",
  "core.customFields.labels.singleDocument": "Single Document",
  "core.customFields.labels.multiDocument": "Multi Document",
  "core.customFields.labels.number": "Number",
  "core.customFields.labels.eMail": "E-mail",
  "core.customFields.labels.phone": "Phone",
  "core.customFields.labels.dropDownSingleSelectList": "Drop-down Single Select List",
  "core.customFields.labels.dropDownMultiSelectList": "Drop-down Multi Select List",
  "core.customFields.labels.comboBox": "Combo Box",
  "core.customFields.labels.timestamp": "Timestamp",
  "core.customFields.labels.featureLink": "Feature Link",
  "core.customFields.descriptions.openTextFieldSingleLine": "Open text field, single line",
  "core.customFields.descriptions.openTextFieldMultipleLines": "Open text field, multiple lines",
  "core.customFields.descriptions.formatMmDdYyyy": "Format MM/DD/YYYY",
  "core.customFields.descriptions.toggleButton": "Toggle Button",
  "core.customFields.descriptions.singleFileUploadField": "Single file upload field",
  "core.customFields.descriptions.multipleFileUploadField": "Multiple file upload field",
  "core.customFields.descriptions.numericInputField": " Numeric input field",
  "core.customFields.descriptions.emailAddressInputField": "Email address input field",
  "core.customFields.descriptions.format1XxxXxxXxxx": "Format +1(XXX) XXX-XXXX",
  "core.customFields.descriptions.selectOneOptionFromAList": "Select one option from a list",
  "core.customFields.descriptions.selectMultipleOptionsFromAList": "Select multiple options from a list",
  "core.customFields.descriptions.singleOptionDropDownListOpenTextField": "Single option drop-down list + open text field",
  "core.customFields.descriptions.dateAndTimeFields": "Date and time fields",
  "core.customFields.descriptions.linkToTheFormFeatures": "Link to the form features",
  "core.customForms.customFormsFeaturesData.titles.checkOut": "Check-Out",
  "core.customForms.customFormsFeaturesData.titles.checkInDeprecated": "Check-in (Deprecated)",
  "core.customForms.customFormsFeaturesData.titles.checkIn": "Check-in",
  "core.customForms.customFormsFeaturesData.titles.receivedLoadInspection": "Received Load Inspection",
  "core.customForms.customFormsFeaturesData.titles.shippedLoadVerification": "Shipped Load Verification",
  "core.customForms.customFormsFeaturesData.titles.appointmentsPerLoadType": "Appointments per Load Type",
  "core.customForms.customFormsFeaturesData.titles.assetDetails": "Asset Details",
  "core.customForms.customFormsFeaturesData.titles.yardManagementSystem": "Yard Management System",
  "core.customForms.customFormsFeaturesData.titles.smartGateIntegration": "SmartGate integration",
  "core.customForms.customFormsFeaturesData.titles.gateManagement": "Gate Management",
  "core.customForms.customFormsFeaturesData.subtitles.phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "<strong>Phone number</strong> and <strong>carrier company</strong> will be collected by default",
  "core.customForms.customFormsFeaturesData.descriptions.captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "Capture check-in details from drivers for both planned and unplanned arrivals.",
  "core.customForms.customFormsFeaturesData.descriptions.captureCheckOutDataAfterAnAppointmentIsCompleted": "Capture check-out data after an appointment is completed.",
  "core.customForms.customFormsFeaturesData.descriptions.collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "Collect driver info as they self check-in for their planned appointment. This feature is an optional add-on to our Gate Management solution.",
  "core.customForms.customFormsFeaturesData.descriptions.documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "Document damage, discrepancies or other issues related to the received load.",
  "core.customForms.customFormsFeaturesData.descriptions.documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "Document load integrity and other security measures related to the shipped load.",
  "core.customForms.customFormsFeaturesData.descriptions.captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "Capture load type specific details during appointment scheduling.",
  "core.customForms.customFormsFeaturesData.descriptions.storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "Store and track details of trailers and containers as they arrive at your yard.",
  "core.customForms.customFormsFeaturesData.descriptions.enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "Enable the YMS module for this warehouse, also enable the asset visit fields for the gate management app.",
  "core.customForms.customFormsFeaturesData.descriptions.enableTheSmartGateModuleForThisWarehouse": "Enable the SmartGate module for this warehouse.",
  "core.customForms.customFormsFeaturesData.descriptions.enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "Enable the Gate Management module for this warehouse, which includes the check-in",
  "core.customForms.customFormsFeaturesData.descriptions.enterTheWeightOfTheCargo": "Enter the weight of the cargo",
  "core.customForms.customFormsFeaturesData.descriptions.uploadEvidencesOfTheCheckOutEvent": "Upload evidences of the check-out event",
  "core.customForms.customFormsFeaturesData.descriptions.appointmentCheckOutForm": "Appointment check-out form",
  "core.customForms.customFormsFeaturesData.descriptions.claimTrackingForm": "Claim tracking form",
  "core.customForms.customFormsFeaturesData.descriptions.pleaseFillOutTheRequiredInformationIfYouWantToConfirmTheCheckOutForThisAppointment": "Please fill out the required information if you want to confirm the check-out for this appointment",
  "core.customForms.customFormsFeaturesData.descriptions.selectOneOrMoreOptionsThatBestIdentifyTheTypeOfDamage": "Select one or more options that best identify the type of damage",
  "core.customForms.customFormsFeaturesData.descriptions.provideMoreInformationAboutTheIdentifiedDamageSuchAsExtentAndAffectedAreas": "Provide more information about the identified damage, such as extent and affected areas",
  "core.customForms.customFormsFeaturesData.descriptions.uploadPhotosOrAnyEvidenceOfTheIdentifiedDamage": "Upload photos or any evidence of the identified damage",
  "core.customForms.customFormsFeaturesData.descriptions.selectOneOrMoreTypesOfDiscrepancyObservedInTheReceivedLoad": "Select one or more types of discrepancy observed in the received load",
  "core.customForms.customFormsFeaturesData.descriptions.provideMoreInformationAboutTheIdentifiedDiscrepancySuchAsTheQuantityDifferenceAndMissingItems": "Provide more information about the identified discrepancy, such as the quantity difference and missing items",
  "core.customForms.customFormsFeaturesData.descriptions.uploadPhotosDocumentsOrAnyEvidenceOfTheIdentifiedDiscrepancy": "Upload photos, documents or any evidence of the identified discrepancy",
  "core.customForms.customFormsFeaturesData.descriptions.inboundClaimEvidenceForm": "Inbound Claim Evidence Form",
  "core.customForms.customFormsFeaturesData.descriptions.pleaseFillOutThisFormToDocumentDamageOrOtherIssuesRelatedToTheReceivedLoad": "Please fill out this form to document damage or other issues related to the received load",
  "core.customForms.customFormsFeaturesData.descriptions.informIfTheLoadHasPassedTheSecurityCheck": "Inform if the load has passed the security check",
  "core.customForms.customFormsFeaturesData.descriptions.provideMoreInformationOnHowTheLoadWasSecuredTheOverallIntegrityAndOtherHandlingPrecautionsTaken": "Provide more information on how the load was secured, the overall integrity and other handling precautions taken",
  "core.customForms.customFormsFeaturesData.descriptions.uploadPhotosOfOverallConditionArrangementAndSecurityOfTheLoadAndTrailer": "Upload photos of overall condition, arrangement, and security of the load and trailer",
  "core.customForms.customFormsFeaturesData.descriptions.uploadPhotosOfTheSealsToDocumentTheirIntegrityAndProperPlacement": "Upload photos of the seals to document their integrity and proper placement",
  "core.customForms.customFormsFeaturesData.descriptions.outboundClaimEvidenceForm": "Outbound Claim Evidence Form",
  "core.customForms.customFormsFeaturesData.descriptions.pleaseFillOutThisFormToDocumentSecurityDetailsOrOtherEvidenceRelatedToTheShippedLoad": "Please fill out this form to document security details or other evidence related to the shipped load",
  "core.customForms.customFormsFeaturesData.helpLinks.learnHowItWorksOrContactUsToRequestATrial": '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works</a> or contact us to <a href="https://lp.opendock.com/gate-management" target="_blank">request a trial.</a>.',
  "core.customForms.customFormsFeaturesData.helpLinks.learnHowItWorks": '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works.</a>',
  "core.customForms.customFormsFeaturesData.enableDisclaimers.theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "The drivers will see this form when they are checking themselves in.",
  "core.customForms.customFormsFeaturesData.enableDisclaimers.allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "All Fields on this form will be <strong>available and visible</strong> during appointment scheduling.",
  "core.customForms.customFormsFeaturesData.disableDisclaimers.theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "The drivers will not see this form when they are checking themselves in.",
  "core.customForms.customFormsFeaturesData.disableDisclaimers.allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "All Fields on this form will be <strong>unavailable</strong> during appointment scheduling.<br />You can re-enable this form at any time.",
  "core.customForms.customFormsFeaturesData.labels.checkOutTime": "Check-out Time",
  "core.customForms.customFormsFeaturesData.labels.checkOutWeight": "Check-out Weight",
  "core.customForms.customFormsFeaturesData.labels.checkOutDocument": "Check-out Document",
  "core.customForms.customFormsFeaturesData.labels.checkOutDamage": "Check-out Damage?",
  "core.customForms.customFormsFeaturesData.labels.updateClaimsSupport": "Update Claims Support",
  "core.customForms.customFormsFeaturesData.labels.selectAClaimsSupportToUpdate": "Select a Claims Support to update",
  "core.customForms.customFormsFeaturesData.labels.claimsSupportFormsCanAlsoBeUpdatedDirectlyFromTheClaimsSupportTab": "Claims Support forms can also be updated directly from the Claims Support tab",
  "core.customForms.customFormsFeaturesData.labels.checkOutForm": "Check-out Form",
  "core.customForms.customFormsFeaturesData.labels.claimsForm": "Claims Form",
  "core.customForms.customFormsFeaturesData.labels.damageType": "Damage Type",
  "core.customForms.customFormsFeaturesData.labels.damageDescription": "Damage Description",
  "core.customForms.customFormsFeaturesData.labels.damagePhotos": "Damage Photos",
  "core.customForms.customFormsFeaturesData.labels.discrepancyType": "Discrepancy Type",
  "core.customForms.customFormsFeaturesData.labels.discrepancyDescription": "Discrepancy Description",
  "core.customForms.customFormsFeaturesData.labels.discrepancyPhotos": "Discrepancy Photos",
  "core.customForms.customFormsFeaturesData.labels.inboundClaimEvidenceForm": "Inbound Claim Evidence Form",
  "core.customForms.customFormsFeaturesData.labels.receivedLoadInspection": "Received Load Inspection",
  "core.customForms.customFormsFeaturesData.labels.loadSecurityChecked": "Load Security Checked",
  "core.customForms.customFormsFeaturesData.labels.loadSecurityDescription": "Load Security Description",
  "core.customForms.customFormsFeaturesData.labels.loadIntegrityPhotos": "Load Integrity Photos",
  "core.customForms.customFormsFeaturesData.labels.sealIntegrityPhotos": "Seal Integrity Photos",
  "core.customForms.customFormsFeaturesData.labels.outboundClaimEvidenceForm": "Outbound Claim Evidence Form",
  "core.customForms.customFormsFeaturesData.labels.shippedLoadVerification": "Shipped Load Verification",
  "core.customForms.customFormsFeaturesData.placeholders.enterDetailsAndObservationsAboutTheDamage": "Enter details and observations about the damage",
  "core.customForms.customFormsFeaturesData.placeholders.enterDetailsAndObservationsAboutTheDiscrepancy": "Enter details and observations about the discrepancy",
  "core.customForms.customFormsFeaturesData.placeholders.enterDetailsOnLoadSecuringMeasuresAndOtherObservations": "Enter details on load securing measures and other observations",
  "core.customForms.customFormsFeaturesData.dropdownValues.noDamage": "No Damage",
  "core.customForms.customFormsFeaturesData.dropdownValues.visibleDamage": "Visible Damage",
  "core.customForms.customFormsFeaturesData.dropdownValues.concealedDamage": "Concealed Damage",
  "core.customForms.customFormsFeaturesData.dropdownValues.brokenPalletsCrates": "Broken Pallets/Crates",
  "core.customForms.customFormsFeaturesData.dropdownValues.damageToTrailer": "Damage to Trailer",
  "core.customForms.customFormsFeaturesData.dropdownValues.packagingDamage": "Packaging Damage",
  "core.customForms.customFormsFeaturesData.dropdownValues.unsecuredOrShiftedLoad": "Unsecured or Shifted Load",
  "core.customForms.customFormsFeaturesData.dropdownValues.brokenOrLooseSeal": "Broken or Loose Seal",
  "core.customForms.customFormsFeaturesData.dropdownValues.temperatureRelatedDamage": "Temperature-Related Damage",
  "core.customForms.customFormsFeaturesData.dropdownValues.spillsAndLeaks": "Spills and Leaks",
  "core.customForms.customFormsFeaturesData.dropdownValues.contaminationParasitesMoldSmell": "Contamination(parasites, mold, smell)",
  "core.customForms.customFormsFeaturesData.dropdownValues.noDiscrepancy": "No Discrepancy",
  "core.customForms.customFormsFeaturesData.dropdownValues.loss": "Loss",
  "core.customForms.customFormsFeaturesData.dropdownValues.shortage": "Shortage",
  "core.customForms.customFormsFeaturesData.dropdownValues.overage": "Overage",
  "core.customForms.customFormsFeaturesData.dropdownValues.incorrectDelivery": "Incorrect Delivery",
  "core.customForms.customFormsFeaturesData.dropdownValues.wrongItemShipped": "Wrong Item Shipped",
  "core.customForms.customFormsFeaturesData.dropdownValues.missingOrIncorrectDocumentation": "Missing or Incorrect Documentation",
  "core.customForms.customFormsFeaturesData.dropdownValues.missingOrIncorrectLabel": "Missing or Incorrect Label",
  "core.customForms.customFormsFeaturesData.dropdownValues.incorrectSku": "Incorrect SKU",
  "core.customForms.customFormsFeaturesData.dropdownValues.packagingDiscrepancyWrongTypeOrSize": "Packaging Discrepancy (wrong type or size)",
  "core.customForms.customFormsFeaturesData.dropdownValues.incorrectPalletization": "Incorrect Palletization",
  "core.global.entities.warehouses": "Warehouse | Warehouses",
  "core.global.entities.loadTypes": "Load Type | Load Types",
  "core.global.entities.docks": "Dock | Docks",
  "core.global.entities.appointments": "Appointment | Appointments",
  "core.global.entities.users": "User | Users",
  "core.global.entities.organizations": "Organization | Organizations",
  "core.global.entities.orgs": "Org | Orgs",
  "core.global.entities.companies": "Company | Companies",
  "core.notifications.titles.appointmentDetailsHaveChanged": "Appointment details have changed",
  "core.notifications.titles.appointmentScheduled": "Appointment scheduled",
  "core.notifications.titles.appointmentConfirmed": "Appointment confirmed",
  "core.notifications.titles.appointmentRequested": "Appointment requested",
  "core.notifications.titles.missedAppointment": "Missed appointment",
  "core.notifications.titles.recurringAppointmentSeriesCreated": "Recurring appointment series created",
  "core.notifications.titles.truckArrivedAtFacility": "Truck arrived at facility",
  "core.notifications.titles.appointmentIsInProgressAtFacility": "Appointment is in progress at facility",
  "core.notifications.titles.appointmentRescheduled": "Appointment rescheduled",
  "core.notifications.titles.appointmentCompleted": "Appointment completed",
  "core.notifications.titles.appointmentCancelled": "Appointment cancelled",
  "core.notifications.titles.appointmentTagged": "Appointment tagged",
  "core.notifications.subjects.appointmentDetailsHaveChanged": "Appointment details have changed",
  "core.notifications.subjects.appointmentScheduled": "Appointment scheduled at {orgName} - {warehouseName}",
  "core.notifications.subjects.appointmentConfirmed": "Appointment confirmed at {orgName} - {warehouseName}",
  "core.notifications.subjects.appointmentRequested": "Appointment requested at {orgName} - {warehouseName}",
  "core.notifications.subjects.missedAppointment": "Missed appointment at {orgName} - {warehouseName}",
  "core.notifications.subjects.recurringAppointmentSeriesCreated": "Recurring appointment series has been created",
  "core.notifications.subjects.truckArrivedAtFacility": "Truck arrived at {orgName} - {warehouseName}",
  "core.notifications.subjects.appointmentIsInProgressAtFacility": "Appointment is in progress at {orgName} - {warehouseName}",
  "core.notifications.subjects.appointmentRescheduled": "Appointment rescheduled at {orgName} - {warehouseName}",
  "core.notifications.subjects.appointmentCompleted": "Appointment completed at {orgName} - {warehouseName}",
  "core.notifications.subjects.appointmentCancelled": "Appointment cancelled with {orgName} - {warehouseName}",
  "core.notifications.subjects.appointmentTagged": "Appointment tagged as {tagName} - {warehouseName}",
  "core.notifications.subTitles.appointmentDetailsHaveChanged": "Please check location, date, time and all details below.",
  "core.notifications.subTitles.appointmentScheduled": "Please check location, date, time and all details below.",
  "core.notifications.subTitles.appointmentConfirmed": "Please check location, date, time and all details below.",
  "core.notifications.subTitles.appointmentRequested": "Please wait for warehouse confirmation.",
  "core.notifications.subTitles.missedAppointment": "Carrier did not show for the appointment.",
  "core.notifications.subTitles.recurringAppointmentSeriesCreated": "Please check the details of the recurring appointment below.",
  "core.notifications.subTitles.truckArrivedAtFacility": "Check the status and appointment details below.",
  "core.notifications.subTitles.appointmentIsInProgressAtFacility": "Check the status and appointment details below.",
  "core.notifications.subTitles.appointmentRescheduled": "Check the status and appointment details below.",
  "core.notifications.subTitles.appointmentCompleted": "Check the status and appointment details below.",
  "core.notifications.subTitles.appointmentCancelled": "Please check all details and reason for cancellation.",
  "core.notifications.subTitles.appointmentTagged": "Please check the tag name and information below.",
  "core.notifications.anchorLabels.appointmentDetailsHaveChanged": "View Appointment",
  "core.notifications.anchorLabels.appointmentScheduled": "View Appointment",
  "core.notifications.anchorLabels.appointmentConfirmed": "View Appointment",
  "core.notifications.anchorLabels.appointmentRequested": "View Appointment",
  "core.notifications.anchorLabels.missedAppointment": "View Appointment",
  "core.notifications.anchorLabels.recurringAppointmentSeriesCreated": "View Original Appointment",
  "core.notifications.anchorLabels.truckArrivedAtFacility": "View Appointment",
  "core.notifications.anchorLabels.appointmentIsInProgressAtFacility": "View Appointment",
  "core.notifications.anchorLabels.appointmentRescheduled": "View Appointment",
  "core.notifications.anchorLabels.appointmentCompleted": "View Appointment",
  "core.notifications.anchorLabels.appointmentCancelled": "View Appointment",
  "core.notifications.anchorLabels.appointmentTagged": "View Appointment",
  "core.notifications.meta.contentBlockTitle": "Content Block",
  "core.notifications.meta.contentBlockDescription": "This content is placed below the confirmation/reference number and above the appointment details.",
  "core.notifications.descriptions.appointmentTagged": "Use Appointment Tags setting to enable tags individually",
  "core.settings.groups.referenceNumber": "Reference Number",
  "core.settings.groups.appointmentStartTimes": "Appointment Start Times",
  "core.settings.groups.appointmentNotifications": "Appointment Notifications",
  "core.settings.groups.appointmentStatuses": "Appointment Statuses",
  "core.settings.groups.customAppointmentsGrid": "Custom Appointments Grid",
  "core.settings.groups.limit": "Limit",
  "core.settings.groups.schedulingPortal": "Scheduling Portal",
  "core.settings.groups.dockSelection": "Dock Selection",
  "core.settings.groups.timeDisplay": "Time Display",
  "core.settings.groups.gateManagement": "Gate Management",
  "core.settings.groups.smartGate": "SmartGate",
  "core.settings.groups.appointmentValidation": "Appointment Validation",
  "core.settings.groups.other": "Other",
  "core.settings.groupDescriptions.referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "Reference Number is the reference you can request from carriers when they're scheduling an appointment.",
  "core.settings.groupDescriptions.determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "Determine the time intervals at which appointments will be allowed to start.",
  "core.settings.groupDescriptions.manageAllTypesOfAppointmentNotificationsForThisEntity": "Manage all types of appointment notifications for this {entity}.",
  "core.settings.groupDescriptions.manageTheSchedulingPortalSettingsForThisEntity": "Manage the Scheduling Portal settings for this {entity}",
  "core.settings.labels.minimumAmountOfReferenceNumbers": "Minimum Amount of Reference Numbers",
  "core.settings.labels.maximumAmountOfReferenceNumbers": "Maximum Amount of Reference Numbers",
  "core.settings.labels.includeReferenceNumberFieldOnAllAppointmentForms": "Include Reference Number field on all appointment forms?",
  "core.settings.labels.referenceNumberFieldName": "Reference Number field name",
  "core.settings.labels.referenceNumberHelperText": "Reference Number helper text",
  "core.settings.labels.makeReferenceNumberARequiredField": "Make Reference Number a required field?",
  "core.settings.labels.allowAppointmentsForThisEntityToStartAt": "Allow appointments for this {entity} to start at:",
  "core.settings.labels.enableAppointmentNotificationsForThisEntity": "Enable appointment notifications for this {entity}?",
  "core.settings.labels.selectEachDesiredStartTimeIndividually": "Select each desired start time individually",
  "core.settings.labels.hideTheLoadTypeDuration": "Hide the load type duration?",
  "core.settings.labels.uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "Upload your {entity} logo to display it in the Scheduling Portal and in all email notifications",
  "core.settings.labels.uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "Upload your warehouse yard map to display it in the Scheduling Portal",
  "core.settings.labels.statusForNewlyCreatedAppointments": "Status for newly created appointments",
  "core.settings.labels.muteAppointmentNotifications": "Mute Appointment Notifications",
  "core.settings.labels.allowDockSelectionInSchedulingPortal": "Allow Dock selection in Scheduling Portal?",
  "core.settings.labels.theStatusThatFollowsArrivedIs": "The status that follows 'Arrived' is",
  "core.settings.labels.displayTimeIn": "Display time in:",
  "core.settings.labels.customizeAppointmentDetails": "Customize appointment details",
  "core.settings.labels.gridTileConfig": "Grid tile config",
  "core.settings.labels.enforceGeofencingToRequireDriversToProvideTheirRealTimeLocation": "Enforce geofencing to require drivers to provide their real time location",
  "core.settings.labels.wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "Would you like to show additional information to the drivers after they check in? (optional)",
  "core.settings.labels.preventReschedulingAppointmentsInTheSchedulingPortal": "Prevent rescheduling appointments in the Scheduling Portal?",
  "core.settings.labels.observationMatchAttribute": "Observation Match Attribute",
  "core.settings.labels.observationMatchTimeWindow": "Observation Match Time Window",
  "core.settings.labels.checkInEarlyThreshold": "Check-in Early Threshold",
  "core.settings.labels.checkInLateThreshold": "Check-in Late Threshold",
  "core.settings.labels.technicalContactEmailAddress": "Technical Contact Email Address",
  "core.settings.labels.technicalContactEmailThrottleMinutes": "Technical Contact Email Throttle Minutes",
  "core.settings.labels.requireUniqueReferenceNumbers": "Require Unique Reference Numbers",
  "core.settings.labels.appointmentStartTimeInterval": "Appointment Start Time Interval",
  "core.settings.labels.enableCustomAppointmentStartTimes": "Enable Custom Appointment Start Times",
  "core.settings.labels.referenceNumberInputMode": "Reference Number Input Mode",
  "core.settings.labels.uploadWarehouseYardMap": "Upload your warehouse yard map to display it in the Scheduling Portal",
  "core.settings.descriptions.requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "Require at least this amount of reference numbers for an appointment",
  "core.settings.descriptions.requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "Require at most this amount of reference numbers for an appointment",
  "core.settings.descriptions.theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": 'The display name for the Reference Number field. Eg: "PO Number", "Shipment ID"',
  "core.settings.descriptions.additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": 'Additional information to help fill in the Reference Number field.  Eg: "Reference Number should start with OD-XX"',
  "core.settings.descriptions.requireTheReferenceNumberForAllAppointmentsBeingScheduled": "Require the Reference Number for all appointments being scheduled",
  "core.settings.descriptions.thisOnlyAffectsNewlyCreatedAppointments": "This only affects newly created appointments",
  "core.settings.descriptions.theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "The duration is displayed on the Load Types select list booking an appointment in the Scheduling Portal",
  "core.settings.descriptions.allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "Allow Dock selection when booking an appointment in the Scheduling Portal",
  "core.settings.descriptions.thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "This setting will allow the choice of an alternate 'In Progress' status between 'Arrived' and 'Completed'",
  "core.settings.descriptions.determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "Determine how time will be displayed across the platform for all users of this Org, including the appointments grid and reports.",
  "core.settings.descriptions.enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "Enable to switch to the new customizable appointment details system",
  "core.settings.descriptions.userConfigurationOfHowGridTilesWillBeDisplayed": "User configuration of how grid tiles will be displayed.",
  "core.settings.descriptions.thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "This setting asks for the drivers location and restricts them from checking-in when they are more than one mile away from your warehouse.",
  "core.settings.descriptions.preventCarriersFromReschedulingAppointmentsOptional": "Prevent carriers from rescheduling appointments. (optional)",
  "core.settings.descriptions.attributeToBeUsedForMatchingObservations": "Attribute to be used for matching observations",
  "core.settings.descriptions.theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "The number of minutes to account for an observation before and after the check-in time",
  "core.settings.descriptions.theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "The number of minutes before the appointment start time that a carrier can check in",
  "core.settings.descriptions.theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "The number of minutes after the appointment start time that a carrier can check in",
  "core.settings.descriptions.emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "Email address where technical issues and information will be sent",
  "core.settings.descriptions.theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "The time between notifications sent to the technical contact when a validation server error occurs.",
  "core.settings.descriptions.aListOfMutedAppointmentNotifications": "A list of muted appointment notifications.",
  "core.settings.descriptions.appointmentNotificationsWillBeSent": "Appointment notifications will be sent",
  "core.settings.descriptions.appointmentNotificationsWillNOTBeSentBrStrongCautionStrongALLAppointmentNotificationsWillBeMutedForYourEntityForALLUsersIncludingCarriers": "Appointment notifications will <strong>NOT</strong> be sent.<br/><strong>Caution:</strong> ALL appointment notifications will be muted for your {entity} for ALL users including carriers.",
  "core.settings.descriptions.requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "Require unique Reference Numbers for all appointments being scheduled",
  "core.settings.descriptions.thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "This is the interval minutes between when appointments can start",
  "core.settings.descriptions.enableTheCustomAppointmentStartTimesSetting": "Enable the custom appointment start times setting",
  "core.settings.descriptions.theInputModeForTheReferenceNumberField": "The input mode for the reference number field",
  "core.settings.descriptions.autoDepartAssetsOnReceivingOutgateEvent": "Auto depart assets on receiving outgate event",
  "core.settings.placeholders.referenceNumberAssociatedWithAppointment": "Reference Number associated with appointment",
  "core.settings.placeholders.insertMessageHere": "Insert message here",
  "core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.topOfTheHour00": "Top of the hour (:00)",
  "core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.topAndBottomOfTheHour00And30": "Top and bottom of the hour (:00 and :30)",
  "core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.everyTwentyMinutes0020And40": "Every Twenty Minutes (:00, :20, and :40)",
  "core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.everyQuarterOfTheHour001530And45": "Every quarter of the hour (:00, :15, :30, and :45)",
  "core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.customStartTimes": "Custom start times",
  "core.settings.dropdownOptions.appointmentStartTimeInterval.15Minutes": "15 Minutes",
  "core.settings.dropdownOptions.appointmentStartTimeInterval.30Minutes": "30 Minutes",
  "core.settings.dropdownOptions.appointmentStartTimeInterval.60Minutes": "60 Minutes",
  "core.settings.dropdownOptions.appointmentStartTimeInterval.90Minutes": "90 Minutes",
  "core.settings.dropdownOptions.observationMatchAttribute.licensePlate": "License Plate",
  "core.settings.dropdownOptions.observationMatchAttribute.dotNumber": "DOT Number",
  "core.settings.dropdownOptions.observationMatchAttribute.any": "Any",
  "core.settings.dropdownOptions.referenceNumberInputMode.alphanumeric": "Alphanumeric",
  "core.settings.dropdownOptions.referenceNumberInputMode.numeric": "Numeric",
  "core.settings.dropdownOptions.statusForNewlyCreatedAppointments.scheduled": "Scheduled",
  "core.settings.dropdownOptions.statusForNewlyCreatedAppointments.requested": "Requested",
  "core.settings.dropdownOptions.theStatusThatFollowsArrivedIs.inProgress": "In Progress",
  "core.settings.dropdownOptions.theStatusThatFollowsArrivedIs.completed": "Completed",
  "core.settings.dropdownOptions.includeReferenceNumberFieldOnAllAppointmentForms.noDontIncludeTheReferenceNumberField": "No, don't include the Reference Number field",
  "core.settings.dropdownOptions.includeReferenceNumberFieldOnAllAppointmentForms.yesIncludeTheReferenceNumberField": "Yes, include the Reference Number field",
  "core.settings.dropdownOptions.hideTheLoadTypeDuration.noDontHideTheLoadTypeDuration": "No, don't hide the Load Type duration",
  "core.settings.dropdownOptions.hideTheLoadTypeDuration.yesHideTheLoadTypeDuration": "Yes, hide the Load Type duration",
  "core.settings.dropdownOptions.enableAppointmentNotificationsForThisEntity.noDisableAppointmentNotifications": "No, disable appointment notifications",
  "core.settings.dropdownOptions.enableAppointmentNotificationsForThisEntity.yesEnableAppointmentNotifications": "Yes, enable appointment notifications",
  "core.settings.dropdownOptions.allowDockSelectionInSchedulingPortal.noDontAllowDockSelection": "No, don't allow Dock selection",
  "core.settings.dropdownOptions.allowDockSelectionInSchedulingPortal.yesAllowTheDockSelection": "Yes, allow the Dock selection",
  "core.settings.dropdownOptions.displayTimeIn.regularTime12Hour": "Regular time (12-hour)",
  "core.settings.dropdownOptions.displayTimeIn.militaryTime24Hour": "Military time (24-hour)",
  "core.settings.dropdownOptions.preventReschedulingAppointmentsInTheSchedulingPortal.allowReschedulingInTheSchedulingPortal": "Allow rescheduling in the Scheduling Portal ",
  "core.settings.dropdownOptions.preventReschedulingAppointmentsInTheSchedulingPortal.preventReschedulingInTheSchedulingPortal": "Prevent rescheduling in the Scheduling Portal",
  "core.settings.dropdownOptions.makeReferenceNumberARequiredField.noDontMakeReferenceNumberARequiredField": "No, don't make Reference Number a required field",
  "core.settings.dropdownOptions.makeReferenceNumberARequiredField.yesMakeReferenceNumberARequiredField": "Yes, make Reference Number a required field",
  "core.settings.dropdownOptions.requireUniqueReferenceNumbers.noDontRequireUniqueReferenceNumbers": "No, don't require unique Reference Numbers",
  "core.settings.dropdownOptions.requireUniqueReferenceNumbers.yesRequireUniqueReferenceNumbers": "Yes, require unique Reference Numbers",
  "core.settings.examples.displayTimeIn.eG700Am700Pm": "E.g. 7:00 AM / 7:00 PM",
  "core.settings.examples.displayTimeIn.eG07001900": "E.g. 07:00 / 19:00",
  "core.settings.notes.notesPrefix": "Note:",
  "core.settings.notes.ifLeftEmptyTheDefaultNameWillBeApplied": "If left empty, the default name will be applied",
  "core.settings.notes.ifLeftEmptyTheDefaultHelperTextWillBeApplied": "If left empty, the default helper text will be applied",
  "core.settings.notes.enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "Enabling this option does not impact notifications that are already disabled on the appointment level individually.",
  "core.settings.notes.ifLeftEmptyNoNotificationsWillBeSent": "If left empty, no notifications will be sent",
  "core.settings.notes.referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "Reference number assigned to cancelled or no show appointments may be reused on new appointments",
  "core.settings.messages.leavingThisFieldEmptyWillResultInNoAvailabilityOnTheSchedule": "Leaving this field empty will result in no availability on the schedule.",
  "core.settings.modalText.youCanUseTheZoomFeatureAndDragTheImageToAdjustHowThePreviewWillAppearForTheSchedulingUsersTheyWillBeAbleToClickThePreviewToSeeTheFullImage": "You can use the zoom feature and drag the image to adjust how the preview will appear for the scheduling users. They will be able  to click the preview to see the full image.",
  "core.settings.defaultValues.referenceNumber": "Reference Number",
  "core.user.errors.yourRoleDoesNotAllowThisAction": "Your role does not allow you to {action}",
  "core.user.errors.yourRoleDoesNotAllowYouToPerformThisAction": "Your role does not allow you to perform this action",
  "core.user.errors.mustHaveAtLeast8Characters": "Must have at least 8 characters",
  "core.user.errors.mustContainUpperCaseAndLowerCase": "Must contain upper-case and lower-case",
  "core.user.errors.mustContainAtLeastOneLetter": "Must contain at least one letter",
  "core.user.errors.mustContainAtLeastOneSpecialCharacter": "Must contain at least one special character",
  "core.user.errors.mustContainAtLeastOneNumber": "Must contain at least one number",
  "core.user.descriptions.allPermissionsAndFullControlOverAllAccounts": "All permissions and full control over all accounts.",
  "core.user.descriptions.godRoleWithLessControl": "GOD role with less control.",
  "core.user.descriptions.allPermissionsAndFullControlOverTheOrganizationAccount": "All permissions and full control over the Organization account.",
  "core.user.descriptions.createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "Create/edit/delete Appointments, Warehouses, Load Types, Docks, and Users (except Owners).",
  "core.user.descriptions.createEditCancelAppointments": "Create/edit/cancel Appointments.",
  "core.user.descriptions.editAppointmentStatusTagsAndSubscribers": "Edit Appointment Status, tags, and subscribers.",
  "core.user.descriptions.viewOnlyNoCreateOrEditActionsAllowed": "View only. No create or edit actions allowed.",
  "core.user.descriptions.carrierAdministrator": "Carrier administrator.",
  "core.user.descriptions.carrierUser": "Carrier user",
  "core.user.descriptions.baseUserAccount": "Base user account.",
  "core.yard.assetContainerEvent.types.arrived": "Arrived",
  "core.yard.assetContainerEvent.types.arrivedWaiting": "Arrived/Waiting",
  "core.yard.assetContainerEvent.types.loading": "Loading",
  "core.yard.assetContainerEvent.types.loadingComplete": "Loading Complete",
  "core.yard.assetContainerEvent.types.unloading": "Unloading",
  "core.yard.assetContainerEvent.types.unloadingComplete": "Unloading Complete",
  "core.yard.assetContainerEvent.types.readyForPickup": "Ready for Pickup",
  "core.yard.assetContainerEvent.types.departed": "Departed",
  "core.yard.assetContainerEvent.types.inoperable": "Inoperable",
  "core.yard.assetContainerTypes.trailer": "Trailer",
  "core.yard.assetContainerTypes.container": "Container",
  "core.yard.assetContainerTypes.oversized": "Oversized",
  "core.yard.assetContainerTypes.chassis": "Chassis",
  "core.yard.assetContainerTypes.reefer": "Reefer",
  "core.yard.assetContainerTypes.other": "Other",
  "core.yard.assetVisitTypes.dropVisit": "Drop Visit",
  "core.yard.assetVisitTypes.dropHook": "Drop & Hook",
  "core.yard.assetVisitTypes.pickupVisit": "Pickup Visit",
  "core.yard.assetVisitTypes.liveLoad": "Live Load",
  "core.yard.altAssetVisitTypes.live": "Live",
  "core.yard.altAssetVisitTypes.drop": "Drop",
  "core.yard.altAssetVisitTypes.pickUp": "PickUp",
  "core.yard.altAssetVisitTypes.dropHook": "DropHook",
  "core.yard.altAssetVisitTypes.unknown": "Unknown",
  "core.yard.assetContainerStates.full": "Full",
  "core.yard.assetContainerStates.empty": "Empty",
  "core.yard.assetContainerStates.partiallyLoaded": "Partially Loaded",
  "core.yard.spotStatuses.open": "open",
  "core.yard.spotStatuses.closed": "closed",
  "core.yard.spotStatuses.assigned": "assigned",
  "core.yard.spotStatuses.unknown": "unknown",
  "core.yard.spotTypes.parking": "parking",
  "core.yard.spotTypes.docking": "docking"
};
let P4 = null;
function GI(e) {
  P4 = e;
}
function FS(e, n = {}) {
  return e.replace(/{(?<temp1>[^}]+)}/g, (a, t) => n[t] ?? `{${t}}`);
}
function h0(e, n) {
  if (P4)
    return P4(e, n);
  const a = xS[e];
  return a ? FS(a, n) : (process.env.NODE_ENV !== "production" && console.warn(`[core] Missing translation key: "${e}"`), e);
}
const VI = on.MAX_WAREHOUSE_PER_USER.value, YI = 8, HS = "Smartgate", E5 = 5;
var Pb = /* @__PURE__ */ ((e) => (e.GOD = "role_god", e.INTERNAL = "role_internal", e.OWNER = "role_owner", e.ADMIN = "role_admin", e.OPERATOR = "role_operator", e.ATTENDANT = "role_attendant", e.SPECTATOR = "role_spectator", e.YARD_DRIVER = "role_yard_driver", e.CARRIER_ADMIN = "role_carrier_admin", e.CARRIER = "role_carrier", e.BASE = "role_base", e))(Pb || {}), US = /* @__PURE__ */ ((e) => (e.CARRIER = "carrierUser", e.INTERNAL = "internalUser", e.WAREHOUSE = "warehouseUser", e.BASE = "baseUser", e))(US || {});
const JI = Object.freeze([
  "role_base",
  "role_carrier",
  "role_carrier_admin"
  /* CARRIER_ADMIN */
]);
function jS(e) {
  return [
    "role_god",
    "role_internal"
    /* INTERNAL */
  ].includes(e.role) ? "internalUser" : [
    "role_owner",
    "role_admin",
    "role_operator",
    "role_attendant",
    "role_spectator",
    "role_yard_driver"
    /* YARD_DRIVER */
  ].includes(e.role) ? "warehouseUser" : !Bb(e.companyId) || [
    "role_carrier",
    "role_carrier_admin"
    /* CARRIER_ADMIN */
  ].includes(e.role) ? "carrierUser" : "baseUser";
}
function KI(e) {
  return iS(e == null ? void 0 : e.firstName, e == null ? void 0 : e.lastName) || "Unknown user";
}
function ZI(e) {
  return e ? h0("core.user.errors.yourRoleDoesNotAllowThisAction", { action: e }) : h0("core.user.errors.yourRoleDoesNotAllowYouToPerformThisAction");
}
function QI(e, n, a) {
  const t = jS(e);
  return [
    "carrierUser",
    "internalUser"
    /* INTERNAL */
  ].includes(t) ? !0 : t === "baseUser" || a && e.orgId !== a ? !1 : !Ne(e) || e.warehouseAccessList.includes(n);
}
function Ne(e) {
  return GS(e.role) && wn(e.warehouseAccessList);
}
function GS(e) {
  return e && [
    "role_admin",
    "role_operator",
    "role_attendant",
    "role_spectator",
    "role_yard_driver"
    /* YARD_DRIVER */
  ].includes(e);
}
function ex(e, n) {
  return !!(jO(e) && n === au.defaultInternalOrgId);
}
function nx(e) {
  return {
    // 1 hour
    role_god: v2.hour,
    // 1 day
    role_internal: v2.day,
    // 3 days
    role_owner: 3 * v2.day,
    role_admin: 3 * v2.day,
    // 30 days
    role_operator: 30 * v2.day,
    role_attendant: 30 * v2.day,
    role_spectator: 30 * v2.day,
    role_yard_driver: 30 * v2.day,
    role_carrier_admin: 30 * v2.day,
    role_carrier: 30 * v2.day,
    role_base: 30 * v2.day
  }[e];
}
function ax() {
  return [
    "role_owner",
    "role_admin",
    "role_operator",
    "role_attendant",
    "role_spectator",
    "role_yard_driver"
    /* YARD_DRIVER */
  ];
}
function VS(e) {
  return {
    // Placeholders for GOD and INTERNAL since this doesn't get displayed anywhere at the moment
    role_god: "All permissions and full control over all accounts.",
    role_internal: "GOD role with less control.",
    role_owner: "All permissions and full control over the Organization account.",
    role_admin: "Create/edit/delete Appointments, Warehouses, Load Types, Docks, and Users (except Owners).",
    role_operator: "Create/edit/cancel Appointments.",
    role_attendant: "Edit Appointment Status, tags, and subscribers.",
    role_spectator: "View only. No create or edit actions allowed.",
    role_yard_driver: "Warehouse driver, has limited access to the application.",
    role_carrier_admin: "Carrier administrator.",
    role_carrier: "Carrier user",
    role_base: "Base user account."
  }[e];
}
function tx(e) {
  const n = VS(e);
  if (!n)
    return "";
  const a = y0.camelCase(n);
  return h0(`core.user.descriptions.${a}`);
}
function ox(e) {
  return {
    role_god: "God",
    role_internal: "Internal",
    role_owner: "Owner",
    role_admin: "Admin",
    role_operator: "Operator",
    role_attendant: "Attendant",
    role_spectator: "Spectator",
    role_yard_driver: "Yard Driver",
    role_carrier_admin: "Carrier Admin",
    role_carrier: "Carrier",
    role_base: "Base"
  }[e];
}
function tu(e) {
  return c0(e) && !e.orgId;
}
function rx(e) {
  return c0(e) && e.role === "role_god";
}
function ix(e, n) {
  return c0(e) && c0(n) && e.id && n.id && e.id === n.id;
}
function X5(e) {
  return Go(e) && e === "role_internal";
}
function kb(e) {
  return Go(e) && (e === "role_god" || e === "role_internal");
}
function Mx(e) {
  return kb(e.role) && e.firstName === HS;
}
function ae(e) {
  return c0(e) && rn(e.role) && kb(e.role);
}
function bx(e) {
  return c0(e) && rn(e.role) && !ae(e);
}
function YS(e) {
  return c0(e) && rn(e.role) && e.role === "role_base";
}
function Ib(e) {
  return c0(e) && rn(e.role) && !YS(e) && !ae(e) && !te(e);
}
function sx(e) {
  return c0(e) && rn(e.role) && e.email === IS;
}
function te(e) {
  return c0(e) && rn(e.role) && [
    "role_carrier",
    "role_carrier_admin"
    /* CARRIER_ADMIN */
  ].includes(e.role) && !e.orgId;
}
function dx(e) {
  return c0(e) && rn(e.role) && e.role === "role_owner";
}
function xb(e) {
  const n = [
    "role_owner",
    "role_admin",
    "role_operator",
    "role_attendant",
    "role_spectator",
    "role_yard_driver"
    /* YARD_DRIVER */
  ];
  return c0(e) && n.includes(e.role);
}
function JS(e) {
  return c0(e) && e.id !== au.odcInternalUserId && r6(e == null ? void 0 : e.internalLoginUserId);
}
function px(e) {
  return JS(e) ? e.internalLoginUserId : e.id;
}
function cx(e) {
  return P0(
    e.role,
    "role_admin"
    /* ADMIN */
  );
}
function zx(e) {
  return ae(e) || ou(e);
}
function ou(e) {
  return ae(e) || xb(e) && Nr(e);
}
function Ox(e) {
  return ou(e);
}
function ux(e) {
  return xb(e) && Nr(e);
}
function KS(e) {
  return xb(e) && Nr(e);
}
function Ax(e) {
  return ZS(e);
}
function ZS(e) {
  return ae(e) || KS(e);
}
function lx(e) {
  return P0(
    e.role,
    "role_operator"
    /* OPERATOR */
  );
}
function fx(e, n) {
  return P0(
    e.role,
    "role_operator"
    /* OPERATOR */
  ) && e.orgId === n;
}
function mx(e) {
  return P0(
    e.role,
    "role_admin"
    /* ADMIN */
  );
}
function qx(e) {
  return P0(
    e.role,
    "role_admin"
    /* ADMIN */
  );
}
function hx(e) {
  return P0(
    e.role,
    "role_admin"
    /* ADMIN */
  );
}
function yx(e) {
  return P0(
    e.role,
    "role_admin"
    /* ADMIN */
  );
}
function Wx(e, n) {
  return c0(e) && c0(n) && e.orgId && n.orgId && e.orgId === n.orgId;
}
function gx(e) {
  return !!(c0(e) && !Ne(e) && P0(
    e.role,
    "role_admin"
    /* ADMIN */
  ) && !tu(e));
}
function Nr(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_admin"
    /* ADMIN */
  ));
}
function Rx(e) {
  return Nr(e) && !Ne(e);
}
function $x(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_admin"
    /* ADMIN */
  ));
}
function Lx(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_admin"
    /* ADMIN */
  ));
}
function _x(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_admin"
    /* ADMIN */
  ));
}
function Nx(e, n) {
  return fB(n) ? nB(e) : mB(n) ? eB(e) : tB(e, n);
}
function QS(e) {
  return !!(c0(e) && oe(
    e.role,
    "role_spectator"
    /* SPECTATOR */
  ));
}
function eB(e) {
  return !!(c0(e) && oe(
    e.role,
    "role_spectator"
    /* SPECTATOR */
  ));
}
function vx(e) {
  return !!(c0(e) && oe(
    e.role,
    "role_attendant"
    /* ATTENDANT */
  ));
}
function Dx(e) {
  return !!(c0(e) && e.role !== "role_spectator");
}
function nB(e) {
  return !!(c0(e) && (oe(
    e.role,
    "role_attendant"
    /* ATTENDANT */
  ) || te(e)));
}
function ru(e) {
  return !!(c0(e) && oe(
    e.role,
    "role_attendant"
    /* ATTENDANT */
  ) || te(e));
}
function Tx(e) {
  return ru(e) && !te(e);
}
function aB(e, n) {
  return Fb(
    e.role,
    "role_attendant"
    /* ATTENDANT */
  ) && !te(e) ? qB(n) : cu(n);
}
function tB(e, n) {
  return WB(n) ? oB(e) : aw(n) ? rB(e) : aB(e, n) ? QS(e) : ru(e);
}
function oB(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_attendant"
    /* ATTENDANT */
  ) || te(e));
}
function rB(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_attendant"
    /* ATTENDANT */
  ) || te(e));
}
function iB(e, n) {
  return !!(c0(e) && oe(
    e.role,
    "role_operator"
    /* OPERATOR */
  ) && n !== e.id);
}
function Sx(e, n) {
  return !!(c0(n) && iB(e, n.id) && Fb(n.role, e.role));
}
function iu(e) {
  return !!(c0(e) && oe(
    e.role,
    "role_attendant"
    /* ATTENDANT */
  ));
}
function Bx(e) {
  return iu(e);
}
function wx(e) {
  return iu(e);
}
function Cx() {
  return Object.keys(Pb);
}
function Mu() {
  return Object.values(Pb);
}
function bu(e, n) {
  const a = Mu(), t = a.indexOf(e), r = a.indexOf(n);
  return Go(e) && Go(n) && r - t;
}
function P0(e, n) {
  return bu(e, n) >= 0;
}
function Fb(e, n) {
  return bu(e, n) <= 0;
}
function Ex(e, n) {
  return !P0(e, n);
}
function oe(e, n) {
  return !Fb(e, n);
}
function rn(e) {
  return !!(e && Mu().includes(e));
}
function MB(e) {
  const n = ["id", "email", "orgId", "companyId", "role"];
  return !!(e instanceof Object && Object.keys(e).find((a) => n.includes(a)));
}
function Xx(e) {
  return !!e.passwordResetRequired;
}
function c0(e) {
  if (!MB(e))
    throw new Error(`Core: validateUser(): invalid User ${e}`);
  return !0;
}
function Go(e) {
  if (!rn(e))
    throw new Error(`Core: validateRole(): invalid User Role ${e}`);
  return !0;
}
function Px(e, n) {
  return !!(ae(e) || P0(
    e.role,
    "role_spectator"
    /* SPECTATOR */
  ) && e.orgId === n);
}
function kx(e, n) {
  return !!(ae(e) || P0(
    e.role,
    "role_owner"
    /* OWNER */
  ) && e.orgId === n);
}
function Ix(e) {
  return !!(c0(e) && tu(e) && ![
    "role_carrier_admin",
    "role_carrier"
    /* CARRIER */
  ].includes(e.role));
}
function xx(e, n) {
  return !!(ae(e) || P0(
    e.role,
    "role_admin"
    /* ADMIN */
  ) && !Ne(e) && e.orgId === n);
}
function Fx(e) {
  return !!(c0(e) && oe(
    e.role,
    "role_operator"
    /* OPERATOR */
  ));
}
function Hx(e, n) {
  return e.id === n || c0(e) && oe(
    e.role,
    "role_operator"
    /* OPERATOR */
  );
}
function Ux(e, n) {
  if (Ne(e)) {
    const a = e.warehouseAccessList, t = n == null ? void 0 : n.warehouseAccessList;
    return Ne(n) && t.every((r) => a.includes(r));
  }
  return !0;
}
function jx(e, n, a) {
  var t;
  return Ne(e) && Ne(n) && (a.warehouseAccessList === null || ((t = a.warehouseAccessList) == null ? void 0 : t.length) === 0);
}
function Gx(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_operator"
    /* OPERATOR */
  ));
}
function Vx(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_operator"
    /* OPERATOR */
  ));
}
function Yx(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_operator"
    /* OPERATOR */
  ));
}
function Jx(e) {
  return ae(e);
}
function Kx(e, n, a) {
  if (X5(e)) {
    const t = X5(a) && oe(e, n.role) && jO(n.email), r = !kb(a) && P0(e, n.role);
    return t || r;
  }
  return P0(e, a) && P0(e, n.role);
}
function Zx(e) {
  return c0(e) && P0(
    e.role,
    "role_operator"
    /* OPERATOR */
  );
}
function Qx(e) {
  return c0(e);
}
function eF(e) {
  return Ib(e) && !Ne(e) && P0(
    e.role,
    "role_admin"
    /* ADMIN */
  );
}
function nF(e) {
  return Ib(e) && P0(
    e.role,
    "role_operator"
    /* OPERATOR */
  );
}
function bB(e) {
  const n = new PS();
  n.is().min(8).has().uppercase().has().lowercase().has().symbols().has().digits(1);
  const a = n.validate(e, { list: !0 }), t = [];
  return t.push({
    error: "min",
    message: "Must have at least 8 characters",
    passed: !a.includes("min")
  }), t.push({
    error: "uppercase-and-lowercase",
    message: "Must contain upper-case and lower-case",
    passed: !(a.includes("lowercase") || a.includes("uppercase"))
  }), t.push({
    error: "one-letter",
    message: "Must contain at least one letter",
    passed: !(a.includes("lowercase") && a.includes("uppercase"))
  }), t.push({
    error: "symbols",
    message: "Must contain at least one special character",
    passed: !a.includes("symbols")
  }), t.push({
    error: "one-number",
    message: "Must contain at least one number",
    passed: !a.includes("digits")
  }), t;
}
function aF(e) {
  return bB(e).map((a) => ({
    ...a,
    message: h0(`core.user.errors.${y0.camelCase(a.message)}`)
  }));
}
function tF(e, n = 0) {
  if (!e || !R1(e))
    throw new Error("invalid user email");
  const a = `Your password must be reset for continued access to Opendock. A password reset email has been sent to ${e}`, t = n > 0 && n <= E5 ? ` within the last ${E5} minutes` : "";
  return `${a}${t}.`;
}
function oF(e) {
  let n = e;
  if ($t(e) && (n = P.fromISO(String(e)).toJSDate()), !Pn(n))
    throw new Error("invalid Date");
  let a = 0;
  return n && (a = vS({
    startDateStr: n,
    endDateStr: /* @__PURE__ */ new Date(),
    diffUnit: "minutes"
  })), a;
}
function su(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_admin"
    /* ADMIN */
  ));
}
function rF(e) {
  return su(e);
}
function iF(e) {
  return su(e);
}
function du(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_admin"
    /* ADMIN */
  ));
}
function MF(e) {
  return du(e);
}
function bF(e) {
  return du(e);
}
function pu(e) {
  return !!(c0(e) && P0(
    e.role,
    "role_operator"
    /* OPERATOR */
  ));
}
function sF(e) {
  return pu(e);
}
function dF(e) {
  return pu(e);
}
class so extends Error {
  constructor(n) {
    const a = `NovaDate: invalid value for date: ${n}`;
    super(a), this.value = n, this.message = a, this.name = this.constructor.name, Error.captureStackTrace(this, this.constructor);
  }
}
class D2 {
  constructor(n) {
    this.value = n, this.strFormats = [P.fromISO, P.fromRFC2822, P.fromSQL];
  }
  static tzNow() {
    return new D2(P.now().toUTC());
  }
  stringToDateTime(n) {
    const a = this.strFormats.map((t) => t(n)).find((t) => t.isValid);
    if (!a)
      throw new so(n);
    return a;
  }
  toJSDate() {
    if (P.isDateTime(this.value))
      return this.value.toJSDate();
    if (y0.isDate(this.value))
      return this.value;
    if (y0.isString(this.value))
      return this.stringToDateTime(this.value).toJSDate();
    if (this.value instanceof D2)
      return this.value.toJSDate();
    throw new so(this.value);
  }
  toISOString() {
    if (P.isDateTime(this.value))
      return this.value.toISO();
    if (y0.isDate(this.value))
      return this.value.toISOString();
    if (y0.isString(this.value))
      return this.stringToDateTime(this.value).toISO();
    if (this.value instanceof D2)
      return this.value.toISOString();
    throw new so(this.value);
  }
  toISODateString() {
    return this.truncate("day").format("yyyy-MM-dd");
  }
  toDateTime() {
    if (P.isDateTime(this.value))
      return this.value;
    if (y0.isDate(this.value))
      return P.fromJSDate(this.value);
    if (y0.isString(this.value))
      return this.stringToDateTime(this.value);
    if (this.value instanceof D2)
      return this.value.toDateTime();
    throw new so(this.value);
  }
  truncate(n) {
    return new D2(this.toDateTime().startOf(n));
  }
  /**
   * Formats the DateLike value to `fmt`.
   * If a timezone is specified, it will set the timezone before formatting.
   * If no timezone is specified, but the DateLike value has a timezone
   * defined, it will convert to that timezone before formatting.
   * If no timezone is specified and the DateLike has no timezone or is using
   * the `SystemZone` tz, then it will convert to `UTC` before converting.
   */
  format(n, a = {}) {
    const t = this.toDateTime(), r = t.zone instanceof br ? "utc" : t.zone;
    return t.setZone((a == null ? void 0 : a.tz) ?? r).toFormat(n);
  }
  /**
   * Set the timezone to `tz` while keeping the global time.
   *
   * @example
   * const [year, month, day, hour, minute] = [2025, 7, 17, 11, 29];
   * const dt = DateTime.fromObject({ year, month, day, hour, minute }, { zone: 'utc' });
   * const brt = FixedOffsetZone.parseSpecifier('UTC-3');
   * new NovaDate(dt).setTz(brt).toISOString() // 2025-07-17T08:29:00.000-03:00
   */
  setTz(n) {
    return new D2(this.toDateTime().setZone(n));
  }
  /**
   * Replaces the timezone to `tz` while keeping the local time.
   *
   * @example
   * const [year, month, day, hour, minute] = [2025, 7, 17, 11, 29];
   * const dt = DateTime.fromObject({ year, month, day, hour, minute }, { zone: 'utc' });
   * const brt = FixedOffsetZone.parseSpecifier('UTC-3');
   * new NovaDate(dt).setTz(brt).toISOString() // 2025-07-17T11:29:00.000-03:00
   */
  replaceTz(n) {
    return new D2(this.toDateTime().setZone(n, { keepLocalTime: !0 }));
  }
  valueOf() {
    return this.toDateTime().valueOf();
  }
  /**
   * Compare if two dates represent the same moment regardless of timezone.
   *
   * @param other The NovaDate instance to compare with.
   * @returns True if both instances represent the same date and time, false otherwise.
   *
   * @example ```typescript
   * const dtA = new NovaDate('2025-10-09T14:07:00.000+00:00');
   * const dtB = new NovaDate('2025-10-09T14:07:00.000Z');
   * const dtC = new NovaDate('2025-10-09T14:07:00.000+01:00');
   * console.log(dtA.equals(dtB)); // true
   * console.log(dtA.equals(dtC)); // false
   * ```
   */
  equals(n) {
    return Number(this) === Number(n);
  }
}
const pF = on.MAX_RECURRING_APPOINTMENT_WEEKS.value, sB = 24, dB = [i0.Scheduled];
var pB = /* @__PURE__ */ ((e) => (e.Standard = "Standard", e.Reserve = "Reserve", e))(pB || {});
const cF = 30;
var cB = /* @__PURE__ */ ((e) => (e.refNumber = "refNumber", e.customFields = "customFields", e.notes = "notes", e.tags = "tags", e))(cB || {}), zB = /* @__PURE__ */ ((e) => (e.OnTime = "OnTime", e.Late = "Late", e.Early = "Early", e))(zB || {}), mt = /* @__PURE__ */ ((e) => (e.clonedFromId = "clonedFromId", e.externalValidationFailed = "externalValidationFailed", e.externalValidationErrorMessage = "externalValidationErrorMessage", e))(mt || {});
function OB(e) {
  return e === "Late" ? "running" : "arriving";
}
function zF(e, n, a) {
  let t = "OnTime";
  if (e && n) {
    const r = W0.tz(e, a).startOf("minute"), M = W0.tz(n, a).startOf("minute"), b = W0.duration(r.diff(M)).asMinutes();
    t = b === 0 ? "OnTime" : b < 0 ? "Late" : "Early";
  }
  return t;
}
function OF(e) {
  let n;
  return e === "OnTime" ? n = `${e}` : n = `${OB(e)} ${e}`, xO(T4(n));
}
const uB = "ETA:", uF = {
  isEtaOnWindow: AB,
  isStatusAllowedForETAUpdate: lB
};
function AB(e, n) {
  const a = ID(new Date(e), new Date(n)) / Cn.hour;
  return sB - a >= 0;
}
function AF(e, n) {
  const a = P.now().setZone(n).set({ millisecond: 0, second: 0 });
  let t;
  e instanceof Date ? t = P.fromJSDate(e).setZone(n) : typeof e == "string" ? t = P.fromISO(e).setZone(n) : P.isDateTime(e) && (t = e.setZone(n)), t = t.set({ millisecond: 0, second: 0 });
  const r = a.diff(t, "hours").hours;
  return Math.abs(r) <= 24;
}
function lB(e) {
  return dB.includes(e);
}
function fB(e) {
  return !!(P1(e) && cu(e) && e.status === i0.Cancelled);
}
function lF(e, n) {
  return r6(n.dockId) && n.dockId !== e.dockId;
}
function mB(e) {
  return !!(P1(e) && e.statusTimeline);
}
function qB(e) {
  const n = "status", a = ["lastChangedBy", "orgId"];
  return !P1(e) || !Vt(e, n) ? !1 : Object.keys(e).filter((r) => r !== n).every((r) => a.includes(r));
}
function cu(e) {
  return !!(P1(e) && e.status);
}
function fF(e) {
  let n = e.end;
  return Pn(e.end) || (n = new Date(e.end)), !!n && n <= _S();
}
function hB(e) {
  return zu(e) && e.recurringParentId === e.id;
}
function mF(e) {
  return zu(e) && !hB(e);
}
function zu(e) {
  return !!(e != null && e.recurringParentId);
}
function qF(e) {
  return e.type === "Reserve";
}
function hF(e) {
  if (!e)
    throw Error("No parameter provided");
  if (P1(e)) {
    const n = e;
    if (!Vt(n, "status"))
      throw Error('Object provided does not have a "status" property');
    return n.status === i0.Requested;
  }
  return e === i0.Requested;
}
function yF(e) {
  if (!e)
    throw Error("No parameter provided");
  if (P1(e)) {
    const n = e;
    if (!Vt(n, "status"))
      throw Error('Object provided does not have a "status" property');
    return n.status === i0.Scheduled;
  }
  return e === i0.Scheduled;
}
function WF(e) {
  if (!e)
    throw Error("No parameter provided");
  if (P1(e)) {
    const n = e;
    if (!Vt(n, "status"))
      throw Error('Object provided does not have a "status" property');
    return n.status === i0.InProgress;
  }
  return e === i0.InProgress;
}
function yB(e) {
  if (!e)
    return 0;
  let n = 0;
  const a = /^Rescheduled - [0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z$/u;
  if (Array.isArray(e.tags))
    for (const t of e.tags)
      t && t.match(a) && n++;
  return (e.reschedules ? e.reschedules.length : 0) + n;
}
function gF(e) {
  return e === 1 ? h0("core.appointment.messages.rescheduledOnce") : e === 2 ? h0("core.appointment.messages.rescheduledTwice") : h0("core.appointment.messages.rescheduledCountTimes", { count: e });
}
function RF({ numWeeks: e, weekDays: n }, a, t) {
  const r = W0.tz(a, t).add(e, "weeks");
  return {
    weekDays: n.map((M) => M.slice(0, 3)).join(", "),
    endDate: r.format("MMM D, YYYY"),
    endTime: r.format("h:mma")
  };
}
function $F(e) {
  return `${uB}${e}`;
}
function LF(e, n = !1) {
  let a = e.statusTimeline[i0.Requested] ? i0.Requested : i0.Scheduled;
  return n && (a = a.toLowerCase()), a;
}
function WB(e) {
  const n = ["ccEmails", "lastChangedBy", "orgId"], a = e && Object.keys(e);
  return !!(e && Array.isArray(e.ccEmails) && a.length === 3 && n.every((t) => a.includes(t)));
}
function _F(e) {
  return (e == null ? void 0 : e.length) > 0 ? e.reduce((n, a) => {
    const t = W0(), r = Math.abs(W0(n.start).diff(t)), M = Math.abs(W0(a.start).diff(t));
    return r < M ? n : a;
  }) : null;
}
function NF(e, n, a, t) {
  if (!(e != null && e.id))
    return "Appointment cannot be modified by unknown user";
  if (Ib(e) || ae(e))
    return null;
  if (!(a != null && a.id))
    return "Invalid dock object";
  if (!(t != null && t.id))
    return "Invalid warehouse object";
  const r = P.now().setZone(t.timezone), M = a.minCarrierLeadTimeForUpdates_hr ?? 0;
  if (new D2(n.start).setTz(t.timezone).toDateTime() < r)
    return "Cannot modify past appointment";
  const d = { start: r.toJSDate(), end: n.start };
  return YO(d) < M ? `Appointment cannot be modified within ${M} hours of its start time` : null;
}
const Vo = "H:mm", gB = [Vo, "HH:mm"], vF = { start: "0:00", end: "23:59" };
function RB(e) {
  const [n, a] = e.split(":").map(Number);
  return { hour: n, minute: a };
}
function yn() {
  return { start: "0:00", end: "23:59" };
}
function _a(e) {
  const n = typeof e == "string" && I(e, gB, !0);
  return n instanceof I && n.isValid() && !(e != null && e.startsWith("24:")) ? n : null;
}
function $B(e) {
  var n;
  return typeof e == "string" && !!((n = _a(e)) != null && n.isValid());
}
function k4(e) {
  if (e === null || typeof e > "u" || typeof e != "object")
    return `ClockSpan incorrect type: '${e}'`;
  const n = Object.keys(e), a = ["start", "end"];
  for (const t of a)
    if (!n.includes(t))
      return `ClockSpan missing key: '${t}'`;
  for (const t of n) {
    if (!a.includes(t))
      return `ClockSpan has an invalid key: '${t}'`;
    const r = e[t];
    if (typeof r != "string")
      return `ClockSpan '${t}' should be a string: '${r}'`;
    if (!$B(r))
      return `ClockSpan '${t}' should be a clock time (format ${Vo}): '${r}'`;
  }
  return _a(e.start).isAfter(_a(e.end)) ? `ClockSpan 'start' (${e.start}) is later than 'end' (${e.end})` : null;
}
function Yo(e, n) {
  const a = _a(e).format("HH:mm"), t = I(/* @__PURE__ */ new Date(`2001-01-0${n}T${a}:00.000Z`));
  if (!t.isValid())
    throw new Error(`Core: clockTo2001Format(): Invalid dayOfWeek ${n} or clock ${e}`);
  return t.toDate();
}
function Tt(e, n, a) {
  return W2(
    Yo(e.start, n),
    Yo(e.end, a || n)
  );
}
function DF(e, n, a = 1) {
  return Yt(
    Tt(e, a),
    Tt(n, a)
  );
}
function TF(e, n, a = 1) {
  return $r(
    Tt(e, a),
    Tt(n, a)
  );
}
function LB(e, n = 1e3) {
  const a = Lr(NB(e));
  if (n && typeof n != "number")
    throw new Error(`Core: mergeAdjacentSpans(): invalid gapThreshold_ms ${n}`);
  const t = _r(a, n);
  return vB(t);
}
function _B(e) {
  const n = (e == null ? void 0 : e.start) && I(e.start), a = (e == null ? void 0 : e.end) && I(e.end);
  if (n != null && n.isValid() && (a != null && a.isValid())) {
    const t = {
      start: n.utcOffset(0).format(Vo),
      end: a.utcOffset(0).format(Vo)
    }, r = k4(t);
    if (!k4(t))
      return t;
    throw new Error(`Core: intervalToClockSpan(): ${r}`);
  }
  throw new Error("Core: intervalToClockSpan(): invalid interval");
}
function NB(e, n = 1) {
  return e.map((a) => Tt(a, n));
}
function vB(e) {
  return e.map((n) => _B(n));
}
function DB(e = 30, n = !1) {
  if (!Number.isInteger(e) || e < 1)
    throw new Error("intervalMinutesLength should be an integer greater than or equal 1");
  const a = [], t = _a("0:00"), r = _a("23:59");
  for (; t.isSameOrBefore(r); )
    a.push({
      text: t.clone().format(n ? "H:mm" : "h:mm a"),
      value: t.clone().format("H:mm")
    }), t.add(e, "minutes");
  return a.push({ text: n ? "0:00" : "12:00 am", value: "23:59" }), a;
}
function SF(e = 30, n = !1) {
  return [...DB(e, n)];
}
function BF(e) {
  return parseInt(e.replace(":", ""), 10);
}
const wF = (e) => {
  if (!e && e !== 0 || !nn(e) || e >= 2400 || e < 0)
    throw new Error(`Invalid integer conversion '${e}'`);
  const n = e.toString();
  return `${n.slice(0, -2)}:${n.slice(-2)}`;
};
function CF(e, n = !1) {
  let a = Math.floor(e / 60);
  n && (a = S5(a, 2, "0", 2));
  let t = S5(e % 60, 2, "0", 2);
  return a === 24 && (a = 23, t = "59"), `${a}:${t}`;
}
function EF(e, n) {
  if (!eb(e) || !nn(e) && !e)
    return null;
  function a(A) {
    return A = String(A), !A.includes(":") && A.length > 2 && (A = oS(A, ":", 2)), A;
  }
  function t(A) {
    const m = A.split(":"), q = m[0], y = (m == null ? void 0 : m[1]) ?? "0";
    return { hour: q, minute: y };
  }
  function r(A) {
    return parseInt(A, 10) < 10 && A.substring(0, 1) !== "0" ? d(A) : A;
  }
  function M(A, m) {
    A = r(A);
    const q = parseInt(A, 10), y = parseInt(m, 10);
    if (!n && q > 12 || n && q > 23) {
      const v = A.substring(1);
      A = d(A.substring(0, 1)), y > 59 && (m = m.substring(0, 1)), m = v + m;
    }
    return { hour: A, minute: m };
  }
  function b(A) {
    const m = parseInt(A, 10);
    return m < 10 && (A = d(A)), m > 59 && (A = "59"), A;
  }
  function d(A, m = "left", q = "0") {
    return m === "left" ? q + A : A + q;
  }
  e = a(e);
  let { hour: c, minute: O } = t(e);
  return { hour: c, minute: O } = M(c, O), O = b(O), `${c.slice(-2)}:${O.slice(-2)}`;
}
const Sn = W0.weekdays().map((e) => e.toLowerCase());
Sn.push(Sn.shift());
const Ou = ["version", ...Sn, "closedIntervals"], TB = [1], XF = {
  version: 1,
  monday: [{ end: "17:00", start: "8:00" }],
  tuesday: [{ end: "17:00", start: "8:00" }],
  wednesday: [{ end: "17:00", start: "8:00" }],
  thursday: [{ end: "17:00", start: "8:00" }],
  friday: [{ end: "17:00", start: "8:00" }],
  closedIntervals: []
};
function PF() {
  return {
    version: 1,
    sunday: [yn()],
    monday: [yn()],
    tuesday: [yn()],
    wednesday: [yn()],
    thursday: [yn()],
    friday: [yn()],
    saturday: [yn()]
  };
}
function kF() {
  return { version: 1 };
}
function IF() {
  return {
    sunday: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    version: 1
  };
}
function xF(e) {
  return !!(e instanceof Object && e.schedule instanceof Object && Object.keys(e.schedule).length >= 2 && Object.keys(e.schedule).includes("version") && Object.keys(e.schedule).filter((n) => n !== "version").some((n) => Ou.includes(n)));
}
const No = W2(
  "2001-01-01T00:00:00.000Z",
  "2001-01-08T00:00:00.000Z"
);
function uu(e, n) {
  const a = W0.utc(e);
  return a.isValid() ? a.isoWeekday(1 + n).startOf("isoWeek").toDate() : null;
}
function SB(e) {
  const n = W0.utc(e);
  return n.isoWeekday() === 1 && [n.hours(), n.minutes(), n.seconds()].every((a) => a === 0);
}
function BB(e) {
  return SB(e) ? e : e && uu(e, 7);
}
function wB(e) {
  return e && uu(e, 0);
}
function FF(e) {
  const n = wB(e.start), a = BB(e.end);
  return W2(n, a);
}
function HF(e) {
  const n = Object.keys(e);
  if (!n.includes("version"))
    return "Schedule is missing key: 'version'";
  if (!TB.includes(e.version))
    return `Schedule has invalid version: '${e.version}'`;
  for (const a of n) {
    if (!Ou.includes(a))
      return `Schedule has an invalid key: '${a}'`;
    if (Sn.includes(a)) {
      const t = e[a];
      if (!Array.isArray(t))
        return `Schedule '${a}' type is incorrect: should be array'`;
      for (const r of t) {
        const M = k4(r);
        if (M)
          return `Schedule '${a}' contains an invalid clock span: ${M}`;
      }
    }
    if (a === "closedIntervals") {
      const t = e[a];
      if (!Array.isArray(t))
        return `Schedule '${a}' type is incorrect: should be an array of DateTime interval`;
      for (const r of t) {
        const M = Xb(r);
        if (M)
          return `Schedule '${a}' contains an invalid DateTime interval: ${M}`;
      }
    }
  }
  return null;
}
function CB(e) {
  let n = [];
  return Sn.forEach((a) => {
    e[a] && (n = n.concat(
      e[a].map((t) => {
        const r = Yo(t.start, Sn.indexOf(a) + 1);
        let M = Yo(t.end, Sn.indexOf(a) + 1);
        return M.getMinutes() === 59 && M.getUTCHours() === 23 && (M = new Date(M.getTime() + Cn.minute)), W2(r, M);
      })
    ));
  }), _r(n, Cn.minute);
}
function Au(e) {
  return e < 0 && (e += 10080), e;
}
function EB(e, n) {
  const a = CB(e);
  return n = Au(n), a.map((t) => wb(t, n));
}
function UF(e, n) {
  const a = EB(e, n);
  n = Au(n);
  const t = wb(No, n), r = W2(No.end, t.end);
  let M = C4(a, [r]);
  M = M.map((d) => cS(d, -1));
  const b = C4(
    [No],
    M.concat(a)
  );
  return _r(b, Cn.minute);
}
function XB(e, n) {
  const a = AS(n), t = an(
    W2(No.start, n.start)
  );
  return e = e.map((r) => GO(r, t)), hS(e, a);
}
function jF(e, n, a) {
  const t = XB(e, n), r = kB(t, a);
  return r !== null && t.forEach((M, b) => {
    M.start = P5(a, M.start, r);
    const d = M.end.getUTCHours() === 0 || M.end.getUTCHours() === 23, c = b === t.length - 1, O = M.end.getDay() === 0;
    d && O && r && c || (M.end = P5(a, M.end, r));
  }), t;
}
function GF(e) {
  return e.map((n) => ({
    start: new Date(n.start),
    end: new Date(n.end)
  }));
}
function I4(e, n) {
  return W0(e).tz(n).isDST();
}
function lu(e, n) {
  return I4(e.start, n) || I4(e.end, n);
}
function PB(e, n) {
  return new Set(e.map((a) => lu(a, n))).size > 1;
}
function kB(e, n) {
  return PB(e, n) ? !lu(e[0], n) : null;
}
function IB(e, n) {
  const a = W0.tz({ year: n.getFullYear(), month: 0, day: 1 }, e).utcOffset(), t = W0.tz({ year: n.getFullYear(), month: 5, day: 1 }, e).utcOffset();
  return Math.abs(t - a) * Cn.minute;
}
function P5(e, n, a) {
  const t = IB(e, n);
  if (I4(n, e)) {
    if (a)
      return new Date(n.getTime() - t);
  } else if (a === !1)
    return new Date(n.getTime() + t);
  return n;
}
function VF(e) {
  for (const n of Object.values(WO)) {
    const a = n.toLowerCase();
    e[a] && (e[a] = LB(e[a], Cn.minute));
  }
}
function YF(e, n, a) {
  const t = e.split(":"), r = parseInt(t[0], 10), M = parseInt(t[1], 10), b = P.now().set({ hour: r, minute: M }).toISO();
  return Ve(
    b,
    null,
    G0.Extended12HrTimeAMPM,
    n,
    G0.Extended24HrTime,
    a
  );
}
function JF(e) {
  const n = xO(e);
  return [...m2.weekdays("long"), ...m2.weekdays("short")].includes(n) ? n.substring(0, 3) : `'${e}' is not a valid day of the week.`;
}
function xB(e, n) {
  const a = [];
  for (let t = 0; t < e.length; t++)
    for (let r = 0; r < n.length; r++) {
      const M = Math.max(
        (/* @__PURE__ */ new Date(`1970-01-01 ${e[t].start}`)).getTime(),
        (/* @__PURE__ */ new Date(`1970-01-01 ${n[r].start}`)).getTime()
      ), b = Math.min(
        (/* @__PURE__ */ new Date(`1970-01-01 ${e[t].end}`)).getTime(),
        (/* @__PURE__ */ new Date(`1970-01-01 ${n[r].end}`)).getTime()
      );
      if (M < b) {
        const d = new Date(M).toLocaleTimeString([], {
          hour12: !1,
          hour: "numeric",
          minute: "2-digit"
        }), c = new Date(b).toLocaleTimeString([], {
          hour12: !1,
          hour: "numeric",
          minute: "2-digit"
        });
        a.push({
          start: d,
          end: c
        });
      }
    }
  return a;
}
function FB(e) {
  if (e.length === 0)
    return [];
  e.sort((a, t) => new Date(a.start).getTime() - new Date(t.start).getTime());
  const n = [e[0]];
  for (let a = 1; a < e.length; a++) {
    const t = n[n.length - 1], r = e[a];
    new Date(t.end).getTime() >= new Date(r.start).getTime() ? t.end = new Date(Math.max(new Date(t.end).getTime(), new Date(r.end).getTime())) : n.push(r);
  }
  return n;
}
function KF(e, n) {
  const a = { version: 1, closedIntervals: [] };
  e = e || { version: 1, closedIntervals: [] }, n = n || { version: 1, closedIntervals: [] };
  for (const r of Object.keys(e)) {
    if (r === "closedIntervals" || r === "version")
      continue;
    const M = e[r] || [], b = n[r] || [];
    a[r] = xB(M, b);
  }
  const t = [
    ...e.closedIntervals || [],
    ...n.closedIntervals || []
  ];
  return a.closedIntervals = [...new Set(FB(t))], a;
}
const ZF = on.MAX_MIN_CARRIER_LEADTIME_LIMIT_HRS.value, QF = on.MAX_MAX_CARRIER_LEADTIME_LIMIT_HRS.value, eH = on.MAX_CAPACITY_DOCKS.value, nH = ["schedule", "id", "orgId", "lastChangedBy"], Jo = " --- CAPACITY #";
function HB(e) {
  return !Hb(e);
}
function Hb(e) {
  return !!(e != null && e.capacityParentId);
}
function Ub(e) {
  return Hb(e) && e.capacityParentId === e.id;
}
function aH(e) {
  return Hb(e) && !Ub(e);
}
function UB(e) {
  return e.includes(Jo);
}
function tH(e) {
  return UB(e) ? e.split(Jo)[0] : e;
}
function oH(e) {
  return Ub(e) || HB(e);
}
function k5(e) {
  return Ub(e) ? e == null ? void 0 : e.capacityChildren.length : 1;
}
function rH(e) {
  return Tb(e.capacityChildren, "createDateTime") || [];
}
function iH(e, n, a, t) {
  const r = e.findIndex((O) => {
    var A;
    return O.id === ((A = n[a]) == null ? void 0 : A.id);
  }), M = k5(n[a]);
  if (r < 0)
    return e;
  const b = e.splice(r, M), d = e.findIndex((O) => {
    var A;
    return O.id === ((A = n[t]) == null ? void 0 : A.id);
  });
  if (d < 0)
    return e;
  const c = a < t ? d + k5(n[t]) : d;
  return e.splice(c, 0, ...b), e;
}
function MH(e) {
  return `${e.name}${e.isActive === !1 ? " (Inactive)" : ""}`;
}
function bH(e) {
  return P1(e) ? `${e.street ?? ""}, ${e.city ?? ""}, ${e.state ?? ""} ${e.zip ?? ""}`.trim() : null;
}
var jB = /* @__PURE__ */ ((e) => (e.V1 = "V1", e.V2 = "V2", e))(jB || {}), GB = /* @__PURE__ */ ((e) => (e.LUMPER = "Lumper services", e.RESTROOM = "Drivers restroom", e.OVERNIGHT = "Overnight parking", e.WIFI = "Free Wi-Fi", e))(GB || {}), VB = /* @__PURE__ */ ((e) => (e.MASK = "Face Mask", e.GLASSES = "Safety Glasses", e.HAT = "Hard Hat", e.BOOTS = "Safety Boots", e.GLOVES = "Gloves", e.VISIBLE_VEST = "High Visibility Vest", e.PANTS = "Long Pants", e.SLEEVE = "Long Sleeves", e.NO_SMOKE = "No Smoking", e.HAIR_NET = "Hair and Beard Net", e))(VB || {}), vo = /* @__PURE__ */ ((e) => (e.YMS = "yms", e.GateManagement = "gm", e.SmartGate = "navtrac", e))(vo || {});
function sH(e, n) {
  var a;
  return !!((a = e == null ? void 0 : e.warehouseFeatures) != null && a.find((t) => n === t.featureCode));
}
var YB = /* @__PURE__ */ ((e) => (e.Inbound = "Inbound", e.Outbound = "Outbound", e.InOut = "Inbound/Outbound", e))(YB || {}), JB = /* @__PURE__ */ ((e) => (e.Live = "Live", e.Drop = "Drop", e.Other = "Other", e))(JB || {}), KB = /* @__PURE__ */ ((e) => (e.DryVan = "Dry Van", e.Flatbed = "Flatbed", e.Reefer = "Reefer", e.Other = "Other", e))(KB || {}), ZB = /* @__PURE__ */ ((e) => (e.FTL = "FTL", e.PTL = "PTL", e.Other = "Other", e))(ZB || {});
const dH = on.MAX_LOAD_TYPES_PER_WAREHOUSE.value;
function pH(e) {
  return !!e.warehouseId;
}
function QB(e) {
  return e != null && e.direction ? Lo(
    e.direction,
    "Inbound"
    /* Inbound */
  ) ? "IN" : Lo(
    e.direction,
    "Outbound"
    /* Outbound */
  ) ? "OUT" : Lo(
    e.direction,
    "Inbound/Outbound"
    /* InOut */
  ) ? "IN/OUT" : e.direction : "";
}
const cH = "00000000-0000-0000-0000-000000000000", zH = 1e4;
class OH {
}
var ew = /* @__PURE__ */ ((e) => (e.C = "Create", e.R = "Read", e.U = "Update", e.D = "Delete", e))(ew || {}), nw = /* @__PURE__ */ ((e) => (e.AfterLoad = "AfterLoad", e.BeforeInsert = "BeforeInsert", e.AfterInsert = "AfterInsert", e.BeforeUpdate = "BeforeUpdate", e.AfterUpdate = "AfterUpdate", e.BeforeRemove = "BeforeRemove", e.AfterRemove = "AfterRemove", e))(nw || {}), z1 = /* @__PURE__ */ ((e) => (e.Appointment = "Appointment", e.AssetContainer = "AssetContainer", e.AssetContainerEvent = "AssetContainerEvent", e.AssetVisit = "AssetVisit", e.AssetVisitEvent = "AssetVisitEvent", e.Company = "Company", e.Dock = "Dock", e.LoadType = "LoadType", e.LoadTypeGroup = "LoadTypeGroup", e.OrgCarrierSettings = "OrgCarrierSettings", e.Org = "Org", e.User = "User", e.Warehouse = "Warehouse", e.WarehouseGroup = "WarehouseGroup", e.WarehouseFeature = "WarehouseFeature", e.NotificationConfig = "NotificationConfig", e.MessageThread = "MessageThread", e.MessageThreadMessage = "MessageThreadMessage", e.MessageThreadEvent = "MessageThreadEvent", e.Form = "Form", e.Field = "Field", e.Flow = "Flow", e.CustomFormData = "CustomFormData", e.FormField = "FormField", e.Trigger = "Trigger", e.Spot = "Spot", e.SpotArea = "SpotArea", e.SpotAssignment = "SpotAssignment", e.SpotReserve = "SpotReserve", e.YardTask = "YardTask", e.YardTaskEvent = "YardTaskEvent", e.Site = "Site", e.Gate = "Gate", e.AssetObservation = "AssetObservation", e.VehicleObservation = "VehicleObservation", e.UnitLimit = "UnitLimit", e.UnitLimitCount = "UnitLimitCount", e.Document = "Document", e.Comment = "Comment", e.Bol = "Bol", e))(z1 || {});
function aw(e) {
  const n = ["tags", "lastChangedBy", "orgId"], a = e && Object.keys(e);
  return !!(e && Array.isArray(e.tags) && a.length === 3 && n.every((t) => a.includes(t)));
}
function uH(e) {
  const n = y0.keys(e);
  if (n.length === 1 && n.includes("where")) {
    const a = y0.keys(e.where);
    return a.length === 1 && a.includes("id");
  }
  return !1;
}
const AH = {
  update: { pastTense: "updated", displayName: "Updated" },
  create: { pastTense: "created", displayName: "Created" },
  delete: { pastTense: "deleted", displayName: "Deleted" }
};
var tw = /* @__PURE__ */ ((e) => (e.BROKER = "type_broker", e.CARRIER = "type_carrier", e.CARRIER_BROKER = "type_carrier_broker", e.FORWARDER = "type_forwarder", e))(tw || {}), Ko = /* @__PURE__ */ ((e) => (e.B = "B", e.KB = "KB", e.MB = "MB", e.GB = "GB", e))(Ko || {});
const lH = [
  "application/zip",
  "application/x-zip-compressed",
  "application/vnd.rar",
  "application/x-rar-compressed",
  "multipart/x-zip"
], fH = [
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats",
  "application/x-zip-compressed",
  "application/zip",
  "image/avif",
  "image/gif",
  "image/heic",
  "image/jpeg",
  "image/png",
  "image/webp",
  "text/csv",
  "text/plain"
], mH = [".exe", ".bin", ".hex"], qH = "storage";
function hH(e, n) {
  const a = n.split("/");
  let t;
  try {
    t = decodeURIComponent(a[a.length - 1]);
  } catch {
    t = a[a.length - 1];
  }
  a[a.length - 1] = encodeURIComponent(t);
  const r = a.join("/");
  return `${e}/${r}`;
}
function yH(e, n) {
  return n.replace(`${e}/`, "");
}
const WH = (e, n) => {
  const a = Object.values(Ko).indexOf(n);
  return e / 1024 ** a;
}, ow = 5, rw = 30;
var iw = /* @__PURE__ */ ((e) => (e[e.EVERY_HOUR = 60] = "EVERY_HOUR", e[e.EVERY_THIRTY_MINUTES = 30] = "EVERY_THIRTY_MINUTES", e[e.EVERY_TWENTY_MINUTES = 20] = "EVERY_TWENTY_MINUTES", e[e.EVERY_FIFTEEN_MINUTES = 15] = "EVERY_FIFTEEN_MINUTES", e.CUSTOM = "custom", e))(iw || {}), Mw = /* @__PURE__ */ ((e) => (e.MODE_ALPHANUMERIC = "alphanumeric", e.MODE_NUMERIC = "numeric", e))(Mw || {}), bw = /* @__PURE__ */ ((e) => (e.LICENSE_PLATE = "License Plate", e.DOT_NUMBER = "DOT Number", e.ANY = "Any", e))(bw || {}), sw = /* @__PURE__ */ ((e) => (e.LICENSE_PLATE = "License Plate", e.PHONE_NUMBER = "Phone Number", e.ANY = "Any", e))(sw || {}), fu = /* @__PURE__ */ ((e) => (e.REFERENCE_NUMBER = "Reference Number", e.APPOINTMENT_START_TIMES = "Appointment Start Times", e.APPOINTMENT_NOTIFICATIONS = "Appointment Notifications", e.APPOINTMENT_STATUSES = "Appointment Statuses", e.CUSTOM_APPPOINTMENTS_GRID = "Custom Appointments Grid", e.CARRIER_VIEW = "Scheduling Portal", e.DOCK_SELECTION = "Dock Selection", e.TIME_DISPLAY = "Time Display", e.GATE_MANAGEMENT = "Gate Management", e.SMARTGATE = "SmartGate", e.APPOINTMENT_VALIDATION_V2 = "Appointment Validation", e.HANDLING_UNITS = "Handling Units", e.LIMITER = "Limiter", e.OTHER = "Other", e))(fu || {});
function gH() {
  return Object.values(fu).reduce((e, n) => (e[y0.camelCase(n)] = h0(`core.settings.groups.${y0.camelCase(n)}`), e), {});
}
const dw = Object.freeze({
  "Reference Number": {
    description: "Reference Number is the reference you can request from carriers when they're scheduling an appointment.",
    link: "https://opendock.zendesk.com/hc/en-us/articles/12988594213779-Using-the-Reference-Number-",
    linkLabel: ""
  },
  "Appointment Start Times": {
    description: "Determine the time intervals at which appointments will be allowed to start.",
    link: "",
    linkLabel: ""
  },
  "Appointment Notifications": {
    description: "Manage all types of appointment notifications for this {{entity}}.",
    link: "",
    linkLabel: ""
  },
  "Scheduling Portal": {
    description: "Manage the Scheduling Portal settings for this {{entity}}",
    link: "",
    linkLabel: ""
  },
  "Dock Selection": {
    description: "",
    link: "",
    linkLabel: ""
  },
  "Handling Units": {
    description: "Handling Units is a numeric field for requesting units (e.g. pallets) during appointment scheduling. Add it to your form to also enable the Limiter feature.",
    link: "http://opendock.zendesk.com/hc/en-us/articles/12988594213779-Using-the-Reference-Number-",
    // TODO CHANGE!
    linkLabel: ""
  },
  Limiter: {
    description: "The Limiter allows you to set a maximum number of appointments or handling units (e.g. pallets) that can be scheduled per day.",
    link: "http://opendock.zendesk.com/hc/en-us/articles/12988594213779-Using-the-Reference-Number-",
    linkLabel: ""
  }
});
function RH(e) {
  const n = h0(`core.global.entities.${e.toLowerCase()}s`);
  return Object.entries(dw).reduce(
    (a, [t, r]) => (a[t] = {
      ...r,
      label: h0(`core.settings.groups.${y0.camelCase(t)}`),
      description: r.description ? h0(`core.settings.groupDescriptions.${y0.camelCase(r.description)}`, {
        entity: n
      }) : null
    }, a),
    {}
  );
}
const pw = {
  Org: [],
  Warehouse: [z1.Org],
  Dock: [z1.Warehouse, z1.Org],
  LoadType: [z1.Warehouse, z1.Org]
};
function cw(e, n) {
  const a = pw[e];
  if (n.settings = n.settings ?? {}, !ye[e])
    return {};
  const t = { ...n.settings };
  return a.forEach((r) => {
    Object.keys(ye[e]).forEach((M) => {
      var m;
      const b = ((m = n[r.toLowerCase()]) == null ? void 0 : m.settings) || {}, d = typeof b[M] < "u" && b[M] !== null, c = typeof n.settings[M] < "u" && n.settings[M] !== null, A = Object.keys(V).filter(
        (q) => V[q].group === V[M].group
      ).some((q) => {
        const y = t[q];
        return y && y.value !== null && y.value !== "undefined";
      });
      !c && d && !A && (n.settings[M] = b[M]);
    });
  }), Object.keys(ye[e]).forEach((r) => {
    (typeof n.settings[r] > "u" || n.settings[r] === null) && (n.settings[r] = ye[e][r].defaultValue);
  }), n.settings;
}
const $H = {
  referenceNumberIsVisible: !0,
  referenceNumberIsRequired: !1,
  appointmentStartTimeMinutes: 30,
  appointmentStartTimeInterval: "30",
  muteAppointmentNotifications: "thedefaultvalue"
};
var zw = /* @__PURE__ */ ((e) => (e.String = "string", e.Date = "date", e.Bool = "bool", e.Number = "int", e.Email = "email", e.Phone = "phone", e.DropDown = "dropdown", e.Document = "document", e.ClockArray = "clockArray", e.CheckboxArray = "checkboxArray", e.LongString = "longString", e))(zw || {});
const LH = [
  "clockArray"
  /* ClockArray */
];
function _H(e, n) {
  const a = n ? Ow(e) : ye[e], t = { Other: {} };
  if (!a)
    return t;
  Object.entries(a).forEach(([M, b]) => {
    b.isActive ? (b.group && !t[b.group] && (t[b.group] = {}), b.group ? t[b.group][M] = b : t.Other[M] = b) : delete a[M];
  });
  const r = QT(t);
  if (!Object.keys(r.Other).length)
    delete r.Other;
  else {
    const M = r.Other;
    delete r.Other, r.Other = M;
  }
  return r;
}
function NH(e, n, a) {
  let t = !1;
  const r = n.hiddenUntil;
  return r && Object.keys(r).forEach((M) => {
    Array.isArray(r[M]) ? r[M].includes(a[M]) || (t = !0) : (typeof a[M] > "u" || r[M] !== a[M]) && (t = !0);
  }), t;
}
function vH(e, n, a) {
  let t = !1;
  const r = n.errorConditions;
  return r && Object.keys(r).forEach((M) => {
    Array.isArray(r[M]) ? r[M].forEach((b) => {
      (b === a[M] || JSON.stringify(a[M]) === JSON.stringify(b)) && (t = !0);
    }) : r[M] === a[M] && (t = !0);
  }), t;
}
function DH(e, n) {
  const a = n.requiredFields;
  if (!a)
    return !0;
  let t = !0;
  return Object.keys(a).forEach((r) => {
    a[r] && (typeof e[r] > "u" || e[r] === null) && (t = !1);
  }), t;
}
function TH(e) {
  return Object.keys(e).forEach((n) => {
    const a = V[n], t = a == null ? void 0 : a.overrides;
    t && Object.keys(t).forEach((r) => {
      typeof e[r] > "u" && (e[r] = t[r]);
    });
  }), e;
}
function SH(e, n, a) {
  let t = !0;
  const r = n.requirements;
  return r ? (Object.keys(r).forEach((M) => {
    Array.isArray(r[M]) ? r[M].includes(a[M]) || (t = !1) : (typeof a[M] > "u" || r[M] !== a[M]) && (t = !1), t || delete a[e];
  }), t) : !0;
}
const $n = "<strong>Note: </strong>", V = {
  referenceNumbersMinimumCount: {
    label: "Minimum Amount of Reference Numbers",
    defaultValue: 0,
    description: "Require at least this amount of reference numbers for an appointment",
    inputType: "int",
    valueType: "number",
    isActive: !0,
    group: "Reference Number",
    minValue: 0
  },
  referenceNumbersMaximumCount: {
    label: "Maximum Amount of Reference Numbers",
    defaultValue: 0,
    description: "Require at most this amount of reference numbers for an appointment",
    inputType: "int",
    valueType: "number",
    isActive: !0,
    group: "Reference Number",
    minValue: 0
  },
  referenceNumberIsVisible: {
    label: "Include Reference Number field on all appointment forms?",
    defaultValue: !0,
    inputType: "bool",
    valueType: "boolean",
    booleanDropDownOptions: {
      whenFalse: "No, don't include the Reference Number field",
      whenTrue: "Yes, include the Reference Number field"
    },
    isActive: !0,
    group: "Reference Number",
    overrides: {
      referenceNumberIsRequired: !1
      // That is, when referenceNumberIsRequired is UNDEFINED, force it being FALSE
    }
  },
  referenceNumberDisplayName: {
    label: "Reference Number field name",
    defaultValue: "Reference Number",
    description: 'The display name for the Reference Number field. Eg: "PO Number", "Shipment ID"',
    note: `${$n} If left empty, the default name will be applied`,
    inputType: "string",
    valueType: "string",
    requirements: { referenceNumberIsVisible: !0 },
    isActive: !0,
    group: "Reference Number"
    /* REFERENCE_NUMBER */
  },
  referenceNumberHelperText: {
    label: "Reference Number helper text",
    placeholder: "Reference Number associated with appointment",
    defaultValue: "",
    description: 'Additional information to help fill in the Reference Number field.  Eg: "Reference Number should start with OD-XX"',
    note: `${$n} If left empty, the default helper text will be applied`,
    inputType: "string",
    valueType: "string",
    requirements: { referenceNumberIsVisible: !0 },
    isActive: !0,
    group: "Reference Number"
    /* REFERENCE_NUMBER */
  },
  referenceNumberIsRequired: {
    label: "Make Reference Number a required field?",
    defaultValue: !1,
    description: "Require the Reference Number for all appointments being scheduled",
    inputType: "bool",
    valueType: "boolean",
    booleanDropDownOptions: {
      whenFalse: "No, don't make Reference Number a required field",
      whenTrue: "Yes, make Reference Number a required field"
    },
    requirements: { referenceNumberIsVisible: !0 },
    isActive: !0,
    group: "Reference Number"
    /* REFERENCE_NUMBER */
  },
  referenceNumberIsUnique: {
    label: "Require Unique Reference Numbers",
    defaultValue: !1,
    description: "Require unique Reference Numbers for all appointments being scheduled",
    note: `${$n} Reference Numbers assigned to cancelled or no-show appointments may be reused on new appointments`,
    inputType: "bool",
    valueType: "boolean",
    booleanDropDownOptions: {
      whenFalse: "No, don't require unique Reference Numbers",
      whenTrue: "Yes, require unique Reference Numbers"
    },
    requirements: { referenceNumberIsVisible: !0 },
    isActive: !0,
    group: "Reference Number"
    /* REFERENCE_NUMBER */
  },
  referenceNumberInputMode: {
    label: "Reference Number input mode",
    defaultValue: "alphanumeric",
    description: "The input mode for the Reference Number field",
    inputType: "dropdown",
    valueType: "string",
    dropDownOptions: [
      {
        label: "Alphanumeric",
        value: "alphanumeric"
        /* MODE_ALPHANUMERIC */
      },
      {
        label: "Numeric",
        value: "numeric"
        /* MODE_NUMERIC */
      }
    ],
    isActive: !0,
    group: "Reference Number"
    /* REFERENCE_NUMBER */
  },
  /**
   * @deprecated
   */
  appointmentStartTimeInterval: {
    label: "Appointment Start Time Interval",
    defaultValue: `${rw}`,
    description: "This is the interval (minutes) between when appointments can start",
    inputType: "dropdown",
    valueType: "string",
    dropDownOptions: [
      {
        label: "15 Minutes",
        value: "15"
      },
      {
        label: "30 Minutes",
        value: "30"
      },
      {
        label: "60 Minutes",
        value: "60"
      },
      {
        label: "90 Minutes",
        value: "90"
      }
    ],
    isActive: !1,
    // MEANS THIS IS DEPRECATED!
    group: "Appointment Start Times"
    /* APPOINTMENT_START_TIMES */
  },
  appointmentStartTimeMinutes: {
    label: "Allow appointments for this {{entity}} to start at:",
    defaultValue: 30,
    inputType: "dropdown",
    valueType: "number | string",
    dropDownOptions: [
      {
        label: "Top of the hour (:00)",
        value: 60
        /* EVERY_HOUR */
      },
      {
        label: "Top and bottom of the hour (:00 and :30)",
        value: 30
        /* EVERY_THIRTY_MINUTES */
      },
      {
        label: "Every Twenty Minutes (:00, :20, and :40)",
        value: 20
        /* EVERY_TWENTY_MINUTES */
      },
      {
        label: "Every quarter of the hour (:00, :15, :30, and :45)",
        value: 15
        /* EVERY_FIFTEEN_MINUTES */
      },
      {
        label: "Custom start times",
        value: "custom"
      }
    ],
    isActive: !0,
    group: "Appointment Start Times"
    /* APPOINTMENT_START_TIMES */
  },
  /**
   * TODO: This whole configuration is confusing, we should consider renaming it in the future to "ENABLE appointment
   *  notifications", as the name suggests. The initial idea was indeed "Mute", but we've changed later, which caused
   *  this config to be counter-intuitive.
   */
  muteAppointmentNotifications: {
    label: "Enable appointment notifications for this {{entity}}?",
    defaultValue: !1,
    note: `${$n} Enabling this option does not impact notifications that are already disabled on the appointment level individually.`,
    descriptionEnabled: "Appointment notifications will be sent",
    descriptionDisabled: "Appointment notifications will <strong>NOT</strong> be sent.<br/><strong>Caution:</strong> ALL appointment notifications will be muted for your {{entity}} for ALL users including carriers.",
    inputType: "bool",
    valueType: "boolean",
    booleanDropDownOptions: {
      whenFalse: "No, disable appointment notifications",
      whenTrue: "Yes, enable appointment notifications"
    },
    isActive: !0,
    group: "Appointment Notifications"
    /* APPOINTMENT_NOTIFICATIONS */
  },
  /**
   * @deprecated
   */
  enableCustomAppointmentStartTimes: {
    label: "Enable Custom Appointment Start Times",
    defaultValue: !1,
    description: "Enable the Custom Appointment Start Times setting",
    inputType: "bool",
    valueType: "boolean",
    isActive: !1,
    group: "Appointment Start Times"
    /* APPOINTMENT_START_TIMES */
  },
  customAppointmentStartTimes: {
    label: "Select each desired start time individually",
    defaultValue: [],
    inputType: "clockArray",
    valueType: "array",
    isActive: !0,
    requirements: { appointmentStartTimeMinutes: "custom" },
    group: "Appointment Start Times",
    hiddenUntil: { appointmentStartTimeMinutes: "custom" },
    errorMessage: "Leaving this field empty will result in no availability on the schedule.",
    /* eslint-disable no-undefined */
    errorConditions: { customAppointmentStartTimes: [null, [], void 0] }
  },
  isLoadTypeDurationCarrierViewHidden: {
    label: "Hide the load type duration?",
    defaultValue: !1,
    description: "The duration is displayed on the Load Types select list booking an appointment in the Scheduling Portal",
    inputType: "bool",
    valueType: "boolean",
    booleanDropDownOptions: {
      whenFalse: "No, don't hide the Load Type duration",
      whenTrue: "Yes, hide the Load Type duration"
    },
    isActive: !0,
    group: "Scheduling Portal"
    /* CARRIER_VIEW */
  },
  customLogo: {
    label: "Upload your {{entity}} logo to display it in the Scheduling Portal and in all email notifications",
    defaultValue: null,
    inputType: "document",
    valueType: "document",
    isActive: !0,
    group: "Scheduling Portal",
    maxFileSize: 800,
    fileSizeUnit: Ko.KB,
    documentOptions: {
      aspectRatio: 1,
      cropShape: "circle",
      showCropResult: !0
    },
    allowedMimeTypes: ["image/"]
  },
  yardMap: {
    label: "Upload your warehouse yard map to display it in the Scheduling Portal",
    defaultValue: null,
    inputType: "document",
    valueType: "document",
    isActive: !0,
    group: "Scheduling Portal",
    maxFileSize: 6,
    fileSizeUnit: Ko.MB,
    documentOptions: {
      aspectRatio: null,
      cropShape: "rectangle",
      showCropResult: !1,
      modalHeaderText: "You can use the zoom feature and drag the image to adjust how the preview will appear for the scheduling users. They will be able  to click the preview to see the full image."
    },
    allowedMimeTypes: ["image/"]
  },
  appointmentCreationStatus: {
    label: "Status for newly created appointments",
    defaultValue: i0.Scheduled,
    description: "This only affects newly created appointments",
    inputType: "dropdown",
    valueType: "string",
    isActive: !0,
    group: "Appointment Statuses",
    dropDownOptions: [
      {
        label: i0.Scheduled,
        value: i0.Scheduled
      },
      {
        label: i0.Requested,
        value: i0.Requested
      }
    ]
  },
  mutedAppointmentNotifications: {
    label: "Mute Appointment Notifications",
    defaultValue: [],
    description: "A list of muted appointment notifications.",
    inputType: "checkboxArray",
    valueType: "array",
    isActive: !0,
    group: "Appointment Notifications"
    /* APPOINTMENT_NOTIFICATIONS */
  },
  allowCarrierDockSelection: {
    label: "Allow Dock selection in Scheduling Portal?",
    defaultValue: !1,
    description: "Allow Dock selection when booking an appointment in the Scheduling Portal",
    inputType: "bool",
    valueType: "boolean",
    booleanDropDownOptions: {
      whenFalse: "No, don't allow Dock selection",
      whenTrue: "Yes, allow the Dock selection"
    },
    isActive: !0,
    group: "Dock Selection"
    /* DOCK_SELECTION */
  },
  statusSucceedingArrived: {
    label: "The status that follows 'Arrived' is",
    defaultValue: i0.Completed,
    description: `This setting will allow the choice of an alternate '${T4(
      i0.InProgress
    )}' status between '${i0.Arrived}' and '${i0.Completed}'`,
    inputType: "dropdown",
    valueType: "string",
    isActive: !0,
    group: "Appointment Statuses",
    dropDownOptions: [
      {
        label: T4(i0.InProgress),
        value: i0.InProgress
      },
      {
        label: i0.Completed,
        value: i0.Completed
      }
    ]
  },
  enableMilitaryTime: {
    label: "Display time in:",
    defaultValue: !1,
    description: "Determine how time will be displayed across the platform for all users of this Org, including the appointments grid and reports.",
    inputType: "bool",
    valueType: "boolean",
    isActive: !0,
    group: "Time Display",
    booleanDropDownOptions: {
      whenFalse: "Regular time (12-hour)",
      exampleFalse: "E.g. 7:00 AM / 7:00 PM",
      whenTrue: "Military time (24-hour)",
      exampleTrue: "E.g. 07:00 / 19:00"
    }
  },
  useNewGridTiles: {
    label: "Customize appointment details",
    defaultValue: !1,
    description: "Enable to switch to the new customizable appointment details system",
    inputType: "bool",
    valueType: "boolean",
    isActive: !0,
    group: "Custom Appointments Grid"
    /* CUSTOM_APPPOINTMENTS_GRID */
  },
  gridTileConfig: {
    label: "Grid tile config",
    defaultValue: [],
    description: "User configuration of how grid tiles will be displayed.",
    inputType: "checkboxArray",
    valueType: "array",
    isActive: !0,
    group: "Custom Appointments Grid"
    /* CUSTOM_APPPOINTMENTS_GRID */
  },
  gateManagementRequiresGeofencing: {
    label: "Enforce geofencing to require drivers to provide their real time location",
    defaultValue: !1,
    requiredFields: { geolocation: !0 },
    description: "This setting asks for the drivers location and restricts them from checking-in when they are more than one mile away from your warehouse.",
    inputType: "bool",
    valueType: "boolean",
    isActive: !0,
    group: "Gate Management"
    /* GATE_MANAGEMENT */
  },
  gateManagementGeofenceRadius: {
    label: "Geofence Radius",
    defaultValue: kS,
    description: "The radius in miles that the driver must be within to check-in. This is only applicable if geofencing is enabled.",
    inputType: "int",
    valueType: "number",
    isActive: !1,
    group: "Gate Management",
    minValue: 0
  },
  gateManagementAdditionalInformationText: {
    label: "Would you like to show additional information to the drivers after they check in? (optional)",
    defaultValue: "",
    requiredFields: { geolocation: !0 },
    inputType: "longString",
    valueType: "string",
    isActive: !0,
    group: "Gate Management",
    placeholder: "Insert message here"
  },
  rescheduleByCarrierForbidden: {
    label: "Prevent rescheduling appointments in the Scheduling Portal?",
    defaultValue: !1,
    description: "Prevent carriers from rescheduling appointments. (optional)",
    inputType: "bool",
    valueType: "boolean",
    booleanDropDownOptions: {
      whenFalse: "Allow rescheduling in the Scheduling Portal ",
      whenTrue: "Prevent rescheduling in the Scheduling Portal"
    },
    isActive: !0,
    group: "Scheduling Portal"
    /* CARRIER_VIEW */
  },
  observationEventMatchAttribute: {
    label: "Observation Match Attribute",
    defaultValue: "Any",
    description: "Attribute to be used for matching observations",
    inputType: "dropdown",
    valueType: "string",
    dropDownOptions: [
      {
        label: "License Plate",
        value: "License Plate"
        /* LICENSE_PLATE */
      },
      {
        label: "DOT Number",
        value: "DOT Number"
        /* DOT_NUMBER */
      },
      {
        label: "Any",
        value: "Any"
        /* ANY */
      }
    ],
    isActive: !0,
    group: "SmartGate"
    /* SMARTGATE */
  },
  observationEventMatchTimeWindow: {
    label: "Observation Match Time Window",
    defaultValue: 5,
    description: "The number of minutes to account for an observation before and after the check-in time",
    inputType: "int",
    valueType: "number",
    isActive: !0,
    group: "SmartGate",
    minValue: 1
  },
  autoDepartAssets: {
    label: "Auto Depart Assets",
    description: "Auto depart assets on receiving outgate event",
    inputType: "bool",
    valueType: "boolean",
    defaultValue: !1,
    isActive: !0,
    group: "SmartGate"
    /* SMARTGATE */
  },
  checkInEarlyThreshold: {
    label: "Check-in Early Threshold",
    defaultValue: C5,
    description: "The number of minutes before the appointment start time that a carrier can check in",
    inputType: "int",
    valueType: "number",
    isActive: !0,
    group: "Gate Management",
    minValue: 0
  },
  checkInLateThreshold: {
    label: "Check-in Late Threshold",
    defaultValue: C5,
    description: "The number of minutes after the appointment start time that a carrier can check in",
    inputType: "int",
    valueType: "number",
    isActive: !0,
    group: "Gate Management",
    minValue: 0
  },
  technicalContactEmailAddress: {
    label: "Technical Contact Email Address",
    defaultValue: null,
    description: "Email address where technical issues and information will be sent",
    inputType: "email",
    valueType: "string",
    isActive: !0,
    note: `${$n} If left empty, no notifications will be sent`,
    group: "Appointment Validation"
    /* APPOINTMENT_VALIDATION_V2 */
  },
  externalValidationServerErrorNotifyThrottleMinutes: {
    label: "Technical Contact Email Throttle Minutes",
    defaultValue: ow,
    description: "The time between notifications sent to the technical contact when a validation server error occurs.",
    inputType: "int",
    valueType: "number",
    isActive: !0,
    group: "Appointment Validation",
    minValue: 1,
    maxValue: 120
  },
  overrideExternalAppointmentValidation: {
    label: "Create Appointment on External Validation Failure",
    defaultValue: !1,
    description: "Create appointments even if appointment validation does not pass.",
    inputType: "bool",
    valueType: "boolean",
    isActive: !0,
    group: "Appointment Validation"
    /* APPOINTMENT_VALIDATION_V2 */
  },
  includeHandlingUnitsFieldOnAppointmentForms: {
    label: "Include Handling Units field on all appointment forms?",
    defaultValue: !1,
    inputType: "bool",
    valueType: "boolean",
    booleanDropDownOptions: {
      whenFalse: "No, don't include the Handling Units field",
      whenTrue: "Yes, include the Handling Units field"
    },
    isActive: !0,
    group: "Handling Units"
    /* HANDLING_UNITS */
  },
  handlingUnitsLabel: {
    label: "Handling Units Label",
    defaultValue: "Handling Units",
    description: 'The display name for the unit type field. Eg: "Pallet Count", "Skid Count"',
    note: `${$n} If empty, the default name will be applied`,
    inputType: "string",
    valueType: "string",
    requirements: { includeHandlingUnitsFieldOnAppointmentForms: !0 },
    isActive: !0,
    group: "Handling Units"
    /* HANDLING_UNITS */
  },
  handlingUnitsHelperText: {
    label: "Handling Units Helper Text",
    defaultValue: "",
    description: 'Additional information to help fill in the unit type field. Eg: "Unit Type should be only numbers"',
    inputType: "string",
    valueType: "string",
    requirements: { includeHandlingUnitsFieldOnAppointmentForms: !0 },
    isActive: !0,
    group: "Handling Units"
    /* HANDLING_UNITS */
  },
  isHandlingUnitsRequired: {
    label: "Make Handling Units a required field?",
    defaultValue: !1,
    description: "Require the unit type field for all appointments being scheduled",
    inputType: "bool",
    valueType: "boolean",
    booleanDropDownOptions: {
      whenFalse: "No, don't make Handling Units a required field",
      whenTrue: "Yes, make Handling Units a required field"
    },
    requirements: { includeHandlingUnitsFieldOnAppointmentForms: !0 },
    isActive: !0,
    group: "Handling Units"
    /* HANDLING_UNITS */
  },
  handlingUnitsMinimumThreshold: {
    label: "Handling Units Minimum Threshold",
    defaultValue: 0,
    description: "Sets the minimum numeric value that can be entered for the Handling Units field",
    inputType: "int",
    valueType: "number",
    requirements: { includeHandlingUnitsFieldOnAppointmentForms: !0 },
    isActive: !0,
    group: "Handling Units"
    /* HANDLING_UNITS */
  },
  handlingUnitsMaximumThreshold: {
    label: "Handling Units Maximum Threshold",
    defaultValue: 0,
    description: "Sets the maximum numeric value that can be entered for the Handling Units field",
    inputType: "int",
    valueType: "number",
    requirements: { includeHandlingUnitsFieldOnAppointmentForms: !0 },
    isActive: !0,
    group: "Handling Units"
    /* HANDLING_UNITS */
  },
  checkoutBolSignedRequired: {
    label: "Check-out BOL Signed Required",
    defaultValue: !1,
    description: "Enforce BOL signing on check-out form",
    inputType: "bool",
    valueType: "boolean",
    isActive: !0,
    group: "Gate Management"
    /* GATE_MANAGEMENT */
  },
  checkoutIdentifier: {
    label: "Check-out Identifier",
    defaultValue: "Any",
    description: "The asset attribute the system will use to validate the check-out form",
    inputType: "dropdown",
    valueType: "string",
    dropDownOptions: [
      {
        label: "License Plate",
        value: "License Plate"
        /* LICENSE_PLATE */
      },
      {
        label: "Phone Number",
        value: "Phone Number"
        /* PHONE_NUMBER */
      },
      {
        label: "Any",
        value: "Any"
        /* ANY */
      }
    ],
    isActive: !0,
    group: "Gate Management"
    /* GATE_MANAGEMENT */
  },
  enableOverrideLimiterFunction: {
    label: "Enable Override Limiter Function",
    defaultValue: !1,
    description: "When the limiter is 100% reached, this feature allows only warehouse users to override and create or approve appointments and units",
    inputType: "bool",
    valueType: "boolean",
    isActive: !0,
    group: "Limiter"
    /* LIMITER */
  }
};
function Ow(e) {
  const n = String(e).toLowerCase() === "organization" ? "Org" : e, a = Object.keys(ye[n] || {}), t = h0(`core.global.entities.${String(e).toLowerCase()}s`);
  return Object.fromEntries(
    a.map((r) => {
      var y;
      const M = V[r], b = M.label ? y0.camelCase(M.label) : "", d = M.label ? `core.settings.labels.${b}` : void 0, c = M.description ? `core.settings.descriptions.${y0.camelCase(M.description)}` : void 0, O = M.placeholder ? `core.settings.placeholders.${y0.camelCase(M.placeholder)}` : void 0;
      let A;
      if (M.note) {
        const $ = M.note.replace($n, ""), v = `core.settings.notes.${y0.camelCase($)}`;
        A = `<strong>${h0("core.settings.notes.notesPrefix")}</strong> ${h0(v, { translatedEntity: t })}`;
      }
      const m = (y = M.dropDownOptions) == null ? void 0 : y.map(($) => ({
        ...$,
        label: $.label ? h0(`core.settings.dropdownOptions.${b}.${y0.camelCase($.label)}`, {
          translatedEntity: t
        }) : $.label
      })), q = M.booleanDropDownOptions ? {
        whenTrue: h0(
          `core.settings.dropdownOptions.${b}.${y0.camelCase(
            M.booleanDropDownOptions.whenTrue
          )}`,
          { entity: t }
        ),
        whenFalse: h0(
          `core.settings.dropdownOptions.${b}.${y0.camelCase(
            M.booleanDropDownOptions.whenFalse
          )}`,
          { entity: t }
        ),
        ...M.booleanDropDownOptions.exampleTrue && {
          exampleTrue: h0(
            `core.settings.examples.${b}.${y0.camelCase(
              M.booleanDropDownOptions.exampleTrue
            )}`,
            { entity: t }
          )
        },
        ...M.booleanDropDownOptions.exampleFalse && {
          exampleFalse: h0(
            `core.settings.examples.${b}.${y0.camelCase(
              M.booleanDropDownOptions.exampleFalse
            )}`,
            { entity: t }
          )
        }
      } : void 0;
      return [
        r,
        {
          ...M,
          label: d ? h0(d, { entity: t }) : M.label,
          description: c ? h0(c, { entity: t }) : M.description,
          note: A ?? M.note,
          placeholder: O ? h0(O, { entity: t }) : M.placeholder,
          dropDownOptions: m,
          booleanDropDownOptions: q
        }
      ];
    })
  );
}
const ye = {
  Org: {
    referenceNumbersMinimumCount: V.referenceNumbersMinimumCount,
    referenceNumbersMaximumCount: V.referenceNumbersMaximumCount,
    referenceNumberIsVisible: V.referenceNumberIsVisible,
    referenceNumberDisplayName: V.referenceNumberDisplayName,
    referenceNumberHelperText: V.referenceNumberHelperText,
    referenceNumberIsRequired: V.referenceNumberIsRequired,
    referenceNumberIsUnique: V.referenceNumberIsUnique,
    referenceNumberInputMode: V.referenceNumberInputMode,
    appointmentStartTimeInterval: V.appointmentStartTimeInterval,
    appointmentStartTimeMinutes: V.appointmentStartTimeMinutes,
    customAppointmentStartTimes: V.customAppointmentStartTimes,
    muteAppointmentNotifications: V.muteAppointmentNotifications,
    mutedAppointmentNotifications: V.mutedAppointmentNotifications,
    customLogo: V.customLogo,
    appointmentCreationStatus: V.appointmentCreationStatus,
    statusSucceedingArrived: V.statusSucceedingArrived,
    enableMilitaryTime: V.enableMilitaryTime
  },
  Warehouse: {
    appointmentStartTimeMinutes: V.appointmentStartTimeMinutes,
    customAppointmentStartTimes: V.customAppointmentStartTimes,
    isLoadTypeDurationCarrierViewHidden: V.isLoadTypeDurationCarrierViewHidden,
    customLogo: V.customLogo,
    yardMap: V.yardMap,
    useNewGridTiles: V.useNewGridTiles,
    gridTileConfig: V.gridTileConfig,
    gateManagementRequiresGeofencing: V.gateManagementRequiresGeofencing,
    gateManagementGeofenceRadius: V.gateManagementGeofenceRadius,
    gateManagementAdditionalInformationText: V.gateManagementAdditionalInformationText,
    enableMilitaryTime: V.enableMilitaryTime,
    appointmentCreationStatus: V.appointmentCreationStatus,
    statusSucceedingArrived: V.statusSucceedingArrived,
    mutedAppointmentNotifications: V.mutedAppointmentNotifications,
    muteAppointmentNotifications: V.muteAppointmentNotifications,
    referenceNumbersMinimumCount: V.referenceNumbersMinimumCount,
    referenceNumbersMaximumCount: V.referenceNumbersMaximumCount,
    referenceNumberIsVisible: V.referenceNumberIsVisible,
    referenceNumberDisplayName: V.referenceNumberDisplayName,
    referenceNumberHelperText: V.referenceNumberHelperText,
    referenceNumberIsRequired: V.referenceNumberIsRequired,
    referenceNumberIsUnique: V.referenceNumberIsUnique,
    referenceNumberInputMode: V.referenceNumberInputMode,
    rescheduleByCarrierForbidden: V.rescheduleByCarrierForbidden,
    observationEventMatchAttribute: V.observationEventMatchAttribute,
    observationEventMatchTimeWindow: V.observationEventMatchTimeWindow,
    autoDepartAssets: V.autoDepartAssets,
    checkInEarlyThreshold: V.checkInEarlyThreshold,
    checkInLateThreshold: V.checkInLateThreshold,
    technicalContactEmailAddress: V.technicalContactEmailAddress,
    externalValidationServerErrorNotifyThrottleMinutes: V.externalValidationServerErrorNotifyThrottleMinutes,
    overrideExternalAppointmentValidation: V.overrideExternalAppointmentValidation,
    includeHandlingUnitsFieldOnAppointmentForms: V.includeHandlingUnitsFieldOnAppointmentForms,
    handlingUnitsLabel: V.handlingUnitsLabel,
    handlingUnitsHelperText: V.handlingUnitsHelperText,
    isHandlingUnitsRequired: V.isHandlingUnitsRequired,
    handlingUnitsMaximumThreshold: V.handlingUnitsMaximumThreshold,
    handlingUnitsMinimumThreshold: V.handlingUnitsMinimumThreshold,
    checkoutBolSignedRequired: V.checkoutBolSignedRequired,
    checkoutIdentifier: V.checkoutIdentifier,
    enableOverrideLimiterFunction: V.enableOverrideLimiterFunction
  },
  Dock: {},
  User: {},
  Company: {},
  Appointment: {},
  LoadType: { allowCarrierDockSelection: V.allowCarrierDockSelection }
};
function BH(e) {
  return e ? e.toLowerCase() === "Reference Number".toLowerCase() ? h0("core.settings.groups.referenceNumber") : e : h0("core.settings.groups.referenceNumber");
}
function wH(e) {
  return e ? I(e).format(yO.ShortDate) : "-";
}
function mu(e) {
  if (!e)
    return null;
  const n = (a) => Math.ceil(a.diff(P.utc(), "days").days);
  if (typeof e == "string")
    return n(P.fromISO(e, { zone: "UTC" }));
  if (typeof e == "object")
    return n(P.fromJSDate(e, { zone: "UTC" }));
}
function CH(e) {
  return e ? mu(e) <= uw : !1;
}
function EH(e) {
  let n = mu(e);
  return n === 0 ? "This org will expire today" : n < 0 ? (n *= -1, `This org expired ${n} ${n === 1 ? "day" : "days"} ago`) : n > 0 ? `This org will expire in ${n} ${n === 1 ? "day" : "days"}` : "";
}
const XH = 15, uw = 7;
var Aw = /* @__PURE__ */ ((e) => (e.Trial = "Trial", e.Test = "Test", e.Client = "Client", e))(Aw || {});
function PH(e, n = !1) {
  P1(e) || (e = {});
  for (const [a, t] of Object.entries(ye.Org))
    if (t.inputType !== "string" && typeof e[a] > "u" && t.defaultValue !== null) {
      if (n && Bb(t.defaultValue))
        continue;
      e[a] = t.valueType === "number" ? parseInt(t.defaultValue, 10) : t.defaultValue;
    }
  return e;
}
function kH(e) {
  return `v${e.major}.${e.minor}.${e.patch} - ${e.commit}`;
}
var qu = /* @__PURE__ */ ((e) => (e.String = "str", e.BigString = "bigstr", e.Date = "date", e.Bool = "bool", e.Document = "doc", e.MultiDocument = "multidoc", e.Number = "int", e.Email = "email", e.Phone = "phone", e.DropDown = "dropdown", e.DropDownMultiSelect = "dropdownmultiselect", e.ComboBox = "combobox", e.Timestamp = "timestamp", e.Action = "action", e))(qu || {});
const IH = [
  "doc",
  "multidoc",
  "dropdown",
  "dropdownmultiselect",
  "date",
  "action",
  "bool",
  "timestamp"
  /* Timestamp */
], xH = 1500, lw = {
  str: "Text - Single Line",
  bigstr: "Text - Multiple Lines",
  date: "Date",
  bool: "True/False",
  doc: "Single Document",
  multidoc: "Multi Document",
  int: "Number",
  email: "E-mail",
  phone: "Phone",
  dropdown: "Drop-down Single Select List",
  dropdownmultiselect: "Drop-down Multi Select List",
  combobox: "Combo Box",
  timestamp: "Timestamp",
  action: "Feature Link"
};
function FH() {
  const e = {};
  for (const [n, a] of Object.entries(lw))
    e[n] = h0(`core.customFields.labels.${y0.camelCase(a)}`);
  return e;
}
const fw = {
  str: "Open text field, single line",
  bigstr: "Open text field, multiple lines",
  date: "Format MM/DD/YYYY",
  bool: "Toggle Button",
  doc: "Single file upload field",
  multidoc: "Multiple file upload field",
  int: " Numeric input field",
  email: "Email address input field",
  phone: "Format +1(XXX) XXX-XXXX",
  dropdown: "Select one option from a list",
  dropdownmultiselect: "Select multiple options from a list",
  combobox: "Single option drop-down list + open text field",
  timestamp: "Date and time fields",
  action: "Link to the form features"
};
function HH() {
  const e = {};
  for (const [n, a] of Object.entries(fw))
    e[n] = h0(`core.customFields.descriptions.${y0.camelCase(a)}`);
  return e;
}
const UH = {
  str: "format-letter-case",
  bigstr: "text-box-outline",
  date: "calendar-blank",
  bool: "toggle-switch-off-outline",
  doc: "file-outline",
  multidoc: "file-multiple-outline",
  int: "numeric",
  email: "at",
  phone: "phone-outline",
  dropdown: "arrow-down-drop-circle-outline",
  dropdownmultiselect: "checkbox-multiple-outline",
  combobox: "form-dropdown",
  timestamp: "clock-time-three-outline",
  action: "link-box-variant-outline"
}, mw = on.MULTI_DOC_MAX_FILES_PER_APPOINTMENT.value;
function qw(e) {
  return (!nn(e.minLengthOrValue) || String(e.value).length >= e.minLengthOrValue) && (!nn(e.maxLengthOrValue) || String(e.value).length <= e.maxLengthOrValue);
}
function hw(e) {
  const n = Number(e.value);
  return (!nn(e.minLengthOrValue) || n >= e.minLengthOrValue) && (!nn(e.maxLengthOrValue) || n <= e.maxLengthOrValue);
}
function jH(e) {
  var t;
  if (!(e instanceof Object) || !(e.type || e.value))
    return !1;
  const n = e.value, a = !!R1(n) && qw(e);
  return {
    str: a,
    bigstr: a,
    combobox: a,
    date: !!($t(n) || Pn(n)),
    bool: n === !0 || n === !1,
    doc: !!R1(n) && String(n).length > 0,
    multidoc: Array.isArray(n) && n.length <= mw && n.every((r) => !!R1(r) && String(r).length > 0),
    int: nn(Number(n)) && hw(e),
    email: !!o6(n),
    phone: KT(String(n)),
    timestamp: $t(n),
    dropdown: !!((t = e.dropDownValues) != null && t.includes(String(n))),
    action: !0,
    dropdownmultiselect: (n == null ? void 0 : n.length) === 0 || !!(wn(n) && (n != null && n.every((r) => {
      var M;
      return (M = e.dropDownValues) == null ? void 0 : M.includes(r);
    })))
  }[e.type];
}
function GH(e, n = {}) {
  var t, r, M, b;
  if (!e)
    return null;
  if (e.type === "bool")
    return e.value ? "Yes" : "No";
  const a = (d, c) => c != null && c.generateLink ? `<a href="${d}">${Zo(d)}</a>` : Zo(d);
  if (e.type === "doc")
    return a(e.value, n == null ? void 0 : n.doc);
  if (e.type === "multidoc" && Array.isArray(e.value))
    return e.value.map((d) => a(d, n == null ? void 0 : n.multidoc)).join("<br />");
  if (e.type === "dropdownmultiselect" && wn(e.value))
    return e.value.join(", ");
  if (e.type === "date") {
    const d = String(e.value), c = P.fromISO(d);
    return c.isValid ? c.toFormat("MM/dd/yyyy") : d;
  }
  return e.type === "phone" ? UO(String(e.value)) : e.type === "timestamp" && P.fromISO(String(e.value)).isValid ? Ve(
    String(e.value),
    (t = n == null ? void 0 : n.timestamp) == null ? void 0 : t.timezone,
    ((r = n == null ? void 0 : n.timestamp) == null ? void 0 : r.twelveHoursFormat) || G0.MonthDayYearSlashedTimeAMPM,
    ((M = n == null ? void 0 : n.timestamp) == null ? void 0 : M.formatAsMilitary) || !1,
    ((b = n == null ? void 0 : n.timestamp) == null ? void 0 : b.twentyFourHoursFormat) || G0.MonthDayYearSlashedTime24
  ) : e.type === "bigstr" && typeof e.value == "string" ? e.value.replace(/\n/gu, "<br />") : e.value;
}
function Zo(e, n = 50) {
  if (!e)
    return;
  const a = e.split("/");
  let t = a[a.length - 1] ? decodeURIComponent(a[a.length - 1]) : "Download";
  return t !== "Download" && t.length > n && (t = `${t.substring(0, n - 3)}...`), t;
}
function yw(e) {
  return e.type && e.label ? `${e.type}${e.label}` : "NO_FIELD_TYPE_AND_LABEL";
}
function VH(e, n, a = !1) {
  var r;
  (Bb(e) || !Array.isArray(e)) && (e = null);
  const t = e || ((r = n == null ? void 0 : n.customApptFieldsTemplate) == null ? void 0 : r.filter((M) => a ? !M.hiddenFromCarrier : !0).map((M) => ({
    ...M,
    name: M.name ?? yw(M)
  }))) || [];
  return Array.isArray(t) ? t.map((M) => {
    var d;
    const b = (d = n == null ? void 0 : n.customApptFieldsTemplate) == null ? void 0 : d.find(
      (c) => c.label === M.label && c.type === M.type
    );
    return a && (M.hiddenFromCarrier = (b == null ? void 0 : b.hiddenFromCarrier) ?? !1), M.required = Ww(b ?? M, a), M;
  }) : [];
}
function Ww(e, n = !1) {
  if (!e)
    return !1;
  if (P1(e)) {
    if (n) {
      if (Object.prototype.hasOwnProperty.call(e, "requiredForCarrier"))
        return !!e.requiredForCarrier;
    } else if (Object.prototype.hasOwnProperty.call(e, "requiredForWarehouse"))
      return !!e.requiredForWarehouse;
    return !!e.required;
  }
  return !1;
}
function YH(e) {
  return e && e.filter((n) => !n.hiddenFromCarrier);
}
function JH(e, n, a) {
  if (e) {
    if (!n)
      return [];
  } else return n;
  return n.map((t) => {
    const r = e.find((M) => {
      const b = t.hiddenFromCarrier && te(a);
      return M.label === t.label && M.type === t.type && !b;
    });
    return r ? {
      ...t,
      value: r.value
    } : t;
  });
}
function KH(e, n) {
  var a, t;
  if (e != null && e.length)
    return te(n) ? (a = e.find((r) => r.requiredForCarrier ?? r.required)) == null ? void 0 : a.label : (t = e.find((r) => r.requiredForWarehouse)) == null ? void 0 : t.label;
}
function ZH(e, n) {
  let a;
  if (eb(n))
    try {
      switch (e) {
        case "bool":
          n = n == null ? void 0 : n.toLowerCase(), a = n !== "true" && n !== "false" ? null : n === "true";
          break;
        case "int":
          a = O6(n) ? Number(n) : null;
          break;
        case "multidoc":
          a = n ? JSON.parse(n) : null;
          break;
        case "dropdownmultiselect":
          a = n ? JSON.parse(n) : null;
          break;
        default:
          a = n;
      }
    } catch {
      a = n;
    }
  return a;
}
function QH(e) {
  return !!(e != null && e.customApptFieldsTemplate && Array.isArray(e.customApptFieldsTemplate) && e.customApptFieldsTemplate.length > 0);
}
function eU(e) {
  return Object.values(qu).find((n) => n === e);
}
var gw = /* @__PURE__ */ ((e) => (e.ScheduleConflict = "schedule-conflict", e.AtomicScheduleConflict = "atomic-schedule-conflict", e.UnverifiedEmail = "unverified-email", e.UserNotFound = "user-not-found", e.UserAccountBlocked = "user-account-blocked", e.PasswordLoginForbidden = "password-login-forbidden", e.InternalLoginForbidden = "internal-login-forbidden", e.ReferenceNumberValidationFailure = "reference-number-validation-failure", e.ExternalValidationFailure = "external-validation-failure", e.ExternalValidationServerError = "external-validation-server-error", e.ExternalValidationFailureOverridden = "external-validation-failure-overridden", e))(gw || {}), x4 = /* @__PURE__ */ ((e) => (e.CheckOut = "check-out", e.CheckIn = "check-in", e.CheckInAdditionalAssetDetails = "check-in additional asset details", e.AssetContainerDetails = "asset container details", e.InboundClaim = "Inbound Claim", e.OutboundClaim = "Outbound Claim", e.BookLoadType = "Book Load Type", e))(x4 || {}), hu = /* @__PURE__ */ ((e) => (e.CheckOut = "check-out", e.CheckInAdditionalAssetDetails = "check-in additional asset details", e.InboundClaim = "Inbound Claim", e.OutboundClaim = "Outbound Claim", e.BookLoadType = "Book Load Type", e.AssetContainerDetails = "asset container details", e))(hu || {});
const Rw = [
  "Inbound Claim",
  "Outbound Claim"
  /* OutboundClaim */
], $w = [
  "check-in additional asset details",
  "check-out",
  "asset container details"
  /* AssetContainerDetails */
], nU = [
  ...Rw,
  ...$w
], Lw = {
  "check-out": {
    title: "Check-Out",
    description: "Capture check-out data after an appointment is completed.",
    helpLink: ""
  },
  "check-in": {
    title: "Check-in (Deprecated)",
    description: "Collect driver info as they self check-in for their planned appointment. This feature is an optional add-on to our Gate Management solution.",
    helpLink: '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works</a> or contact us to <a href="https://lp.opendock.com/gate-management" target="_blank">request a trial.</a>'
  },
  "check-in additional asset details": {
    title: "Check-in",
    description: "Capture check-in details from drivers for both planned and unplanned arrivals.",
    enableDisclaimer: "The drivers will see this form when they are checking themselves in.",
    disableDisclaimer: "The drivers will not see this form when they are checking themselves in.",
    subtitle: '<i aria-hidden="true" class="v-icon notranslate mr-2 mdi mdi-information-outline" style="font-size: 12px;"></i> <strong>Phone number</strong> and <strong>carrier company</strong> will be collected by default.',
    helpLink: '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works.</a>'
  },
  "Inbound Claim": {
    title: "Received Load Inspection",
    description: "Document damage, discrepancies or other issues related to the received load.",
    helpLink: ""
  },
  "Outbound Claim": {
    title: "Shipped Load Verification",
    description: "Document load integrity and other security measures related to the shipped load.",
    helpLink: ""
  },
  "Book Load Type": {
    title: "Appointments per Load Type",
    description: "Capture load type specific details during appointment scheduling.",
    enableDisclaimer: "All Fields on this form will be <strong>available and visible</strong> during appointment scheduling.",
    disableDisclaimer: "All Fields on this form will be <strong>unavailable</strong> during appointment scheduling.<br />You can re-enable this form at any time.",
    helpLink: ""
  },
  "asset container details": {
    title: "Asset Details",
    description: "Store and track details of trailers and containers as they arrive at your yard.",
    helpLink: "",
    showNewTag: !0
  },
  [vo.YMS]: {
    title: "Yard Management System",
    description: "Enable the YMS module for this warehouse, also enable the asset visit fields for the gate management app.",
    helpLink: ""
  },
  [vo.SmartGate]: {
    title: "SmartGate Integration",
    description: "Enable the SmartGate module for this warehouse.",
    helpLink: ""
  },
  [vo.GateManagement]: {
    title: "Gate Management",
    description: "Enable the Gate Management module for this warehouse, which includes the check-in",
    helpLink: ""
  }
};
function aU() {
  const e = {};
  for (const [n, a] of Object.entries(Lw)) {
    const t = a, r = "core.customForms.customFormsFeaturesData";
    e[n] = {
      ...t,
      title: h0(`${r}.titles.${y0.camelCase(`${t.title}`)}`),
      description: t.description ? h0(`${r}.descriptions.${y0.camelCase(`${t.description}`)}`) : null,
      helpLink: t.helpLink ? h0(`${r}.helpLinks.${y0.camelCase(lt(t.helpLink))}`) : null,
      enableDisclaimer: t.enableDisclaimer ? h0(`${r}.enableDisclaimers.${y0.camelCase(lt(t.enableDisclaimer))}`) : null,
      disableDisclaimer: t.disableDisclaimer ? h0(
        `${r}.disableDisclaimers.${y0.camelCase(
          lt(t.disableDisclaimer)
        )}`
      ) : null,
      subtitle: t.subtitle ? h0(`${r}.subtitles.${y0.camelCase(lt(t.subtitle))}`) : null
    };
  }
  return e;
}
var _w = /* @__PURE__ */ ((e) => (e.greaterThan = ">", e.lessThan = "<", e.greaterThanOrEquals = ">=", e.lessThanOrEquals = "<=", e.equals = "=", e.notEquals = "<>", e))(_w || {});
function tU(e, n, a, t = y0.isEqual) {
  switch (e = String(e), n = String(n), a) {
    case "=":
      return t(e, n);
    case ">":
      return e > n;
    case "<":
      return e < n;
    case "<>":
      return !t(String(e), String(n));
    case ">=":
      return e >= n;
    case "<=":
      return e <= n;
    default:
      throw new Error("Unsupported operator");
  }
}
var Nw = /* @__PURE__ */ ((e) => (e.Api = "api", e.Warehouse = "warehouse", e.Carrier = "carrier", e.Driver = "driver", e.All = "all", e))(Nw || {}), vw = /* @__PURE__ */ ((e) => (e.appointment = "appointment", e.assetVisit = "assetvisit", e.assetContainer = "assetcontainer", e))(vw || {}), Dw = /* @__PURE__ */ ((e) => (e.loadtype = "loadtype", e.dock = "dock", e.warehouse = "warehouse", e))(Dw || {}), Tw = /* @__PURE__ */ ((e) => (e.appointmentStatusCompleted = "appointmentStatusCompleted", e.appointmentStatusArrived = "appointmentStatusArrived", e.appointmentCreated = "appointmentCreated", e.assetVisitCreated = "assetVisitCreated", e.manualTrigger = "manualTrigger", e))(Tw || {});
class oU {
  constructor(n, a, t) {
    this.dropDownValues = n, this.minLengthOrValue = a, this.maxLengthOrValue = t;
  }
}
function rU(e) {
  return Array.isArray(e) && e.length > 0 ? [...new Set(e == null ? void 0 : e.map((n) => `${n.name} (${QB(n)})`).sort())].join(
    "  •  "
  ) : "N/A";
}
function iU(e) {
  const n = `Custom Forms - ${e}`;
  return { tag: n, description: {
    "Custom Forms - Forms": "Forms are collections of form fields that represent a complete data entry interface. Each Form belongs to a Flow and captures related data points in a structured way. Forms provide the user interface for data collection.",
    "Custom Forms - Triggers": "Triggers are event listeners that activate on specific API or UI events. Each Trigger is associated with exactly one Flow. When a Trigger fires, it initiates its associated Flow, which in turn presents one or two Forms sequentially.",
    "Custom Forms - Form Fields": "Form Fields are instances of global Field definitions within a specific Form. While Fields define the data type and general properties, Form Fields customize these instances with form-specific attributes like required status, custom labels, and validation rules.",
    "Custom Forms - Flows": 'Flows define the sequence and logic of form presentation. Each Flow must have a primary "fromForm" and may optionally include a secondary "formTo" that appears after the first form is completed. Flows connect Triggers to the actual Forms that collect data.',
    "Custom Forms - Data": "Data entities store the actual values submitted through Forms. Each form submission creates multiple Data records - one for each Form Field with a value. These records maintain the relationship between the entity (like an appointment), the form field, and the submitted value.",
    "Custom Forms - Fields": "Fields are global definitions that specify fundamental attributes like data type (text, number, dropdown, etc.), validation rules, and base properties. Fields are organization-wide resources that can be instantiated as Form Fields across multiple Forms."
  }[n] || "" };
}
var Sw = /* @__PURE__ */ ((e) => (e.TODAY = "today", e.WTD = "wtd", e.MTD = "mtd", e.YTD = "ytd", e))(Sw || {});
function MU(e) {
  return {
    today: {
      description: "Appointments Scheduled for Today",
      label: "Today",
      startOf: "day"
    },
    wtd: {
      description: "Week to Date Starting on Sunday",
      label: "Week to Date",
      startOf: "week"
    },
    mtd: {
      description: "Month to Date Starting on the 1st",
      label: "Month to Date",
      startOf: "month"
    },
    ytd: {
      description: "Year to Date Starting January 1st",
      label: "Year to Date",
      startOf: "year"
    }
  }[e];
}
var yu = /* @__PURE__ */ ((e) => (e.CONFIRMATION_NUMBER = "Confirmation #", e.APPOINTMENT_ID = "Appointment ID", e.APPOINTMENT_DATE = "Appt Date", e.APPOINTMENT_TIME = "Appt Time", e.APPOINTMENT_TIMEZONE = "Timezone", e.APPOINTMENT_TYPE = "Appt Type", e.SCHEDULED_DURATION = "Scheduled Duration (mins)", e.STATUS = "Status", e.ARRIVAL_DATE = "Arrival Date", e.ARRIVAL_TIME = "Arrival Time", e.DEPARTURE_DATE = "Departure Date", e.DEPARTURE_TIME = "Departure Time", e.DWELL_TIME = "Dwell Time (mins)", e.ON_TIME = "On-Time (mins)", e.IN_PROGRESS_DATE = "In Progress date", e.IN_PROGRESS_TIME = "In Progress time", e.WAIT_TIME = "Wait time (mins)", e.PROCESSING_TIME = "Processing time (mins)", e.WAREHOUSE = "Warehouse", e.DOCK = "Dock", e.LOAD_TYPE = "Load Type", e.LOAD_TYPE_DIRECTION = "Direction", e.RESCHEDULE_COUNT = "Reschedule Count", e.REFERENCE_NUMBER = "Reference Number", e.HANDLING_UNITS = "Handling Units", e.CREATED_BY = "Created By", e.CREATOR_TYPE = "Creator Type", e.CREATION_DATE = "Creation Date", e.LAST_UPDATED_BY = "Last Updated By", e.LAST_UPDATE_DATE = "Last Update Date", e.LAST_UPDATE_TIME = "Last Update Time", e.CARRIER_COMPANY = "Carrier Company", e.CONTACT_NAME = "Contact Name", e.CONTACT_EMAIL = "Contact Email", e.CONTACT_PHONE = "Contact Phone", e.NOTES = "Notes", e.TAGS = "Tags", e.CUSTOM_FIELDS = "Custom Fields", e.EXTERNAL_VALIDATION_STATUS = "External Validation Status", e.EXTERNAL_VALIDATION_ERROR_MESSAGE = "External Validation Error Message", e))(yu || {});
const Bw = { ...yu, ...hu };
var ww = /* @__PURE__ */ ((e) => (e.APPOINTMENT_DATE = "Appointment Date", e.CREATION_DATE = "Creation Date", e))(ww || {}), Cw = /* @__PURE__ */ ((e) => (e.WAREHOUSE_USER = "Warehouse User", e.CARRIER = "Carrier", e))(Cw || {}), Ew = /* @__PURE__ */ ((e) => (e.WAREHOUSE = "warehouse", e.DOCK = "dock", e.LOAD_TYPE = "loadType", e.DIRECTION = "direction", e))(Ew || {}), Xw = /* @__PURE__ */ ((e) => (e.ASSET_ID = "Asset ID", e.ASSET_TYPE = "Asset Type", e.CARRIER_COMPANY = "Carrier Company", e.CARRIER_VISIT_TYPE = "Carrier Visit Type", e.SPOT = "Spot", e.SPOT_AREA = "Area", e.ARRIVAL_DATE = "Arrival Date", e.ARRIVAL_TIME = "Arrival Time", e.DEPARTURE_DATE = "Departure Date", e.DEPARTURE_TIME = "Departure Time", e.ASSET_STATE = "Asset State", e.PLANNED_ARRIVAL = "Planned Arrival", e.DRIVERS_PHONE_NUMBER = "Driver's Phone Number", e.CHECK_IN_FORM = "Check-in form", e.REFERENCE_NUMBER = "Reference Number", e.CONFIRMATION_NUMBER = "Confirmation Number", e.DRIVER_APPOINTMENT_IDENTIFIER = "Driver Appointment Identifier", e.ASSET_DETAILS_FORM = "Asset Details form", e.DROPOFF_CARRIER_COMPANY = "Dropoff Carrier Company", e.PICKUP_CARRIER_COMPANY = "Pickup Carrier Company", e))(Xw || {});
const bU = on.MAX_CUSTOM_TAGS_PER_ORG.value;
function sU(e) {
  return [
    "$cont",
    "$starts",
    "$ends",
    "$excl",
    "$contL",
    "$startsL",
    "$endsL",
    "$exclL"
  ].some((a) => YT(aS(e), a));
}
var Pw = /* @__PURE__ */ ((e) => (e.APPOINTMENT_UPDATED = "appointment_updated", e.APPOINTMENT_CONFIRMED = "appointment_confirmed", e.APPOINTMENT_NOSHOW = "appointment_noshow", e.APPOINTMENT_RECURRING_SERIES_SCHEDULED = "appointment_recurring_series_scheduled", e.APPOINTMENT_ARRIVED = "appointment_arrived", e.APPOINTMENT_INPROGRESS = "appointment_inprogress", e.APPOINTMENT_RESCHEDULED = "appointment_rescheduled", e.APPOINTMENT_COMPLETED = "appointment_completed", e.APPOINTMENT_CANCELLED = "appointment_cancelled", e.APPOINTMENT_REQUESTED = "appointment_requested", e.APPOINTMENT_REQUESTED_CONFIRMED = "appointment_requested_confirmed", e.APPOINTMENT_TAGGED = "appointment_tagged", e))(Pw || {}), kw = /* @__PURE__ */ ((e) => (e.CONFIRMATION_NUMBER = "confirmation_number", e.REFERENCE_NUMBER = "reference_number", e))(kw || {}), Iw = /* @__PURE__ */ ((e) => (e.STANDARD = "standard", e.INFO = "info", e.ALERT = "alert", e.HIDDEN = "hidden", e))(Iw || {}), xw = /* @__PURE__ */ ((e) => (e.REFERENCE_NUMBER = "reference_number", e.HANDLING_UNITS = "handling_units", e.LOAD_TYPE = "load_type", e.APPOINTMENT_CUSTOM_FIELDS = "appointment_custom_fields", e.WAREHOUSE_INSTRUCTIONS = "warehouse_instructions", e.CARRIER_CONTACT = "carrier_contact", e.NOTES = "notes", e.CONFIRMATION_NUMBER = "confirmation_number", e.APPOINTMENT_ID = "appointment_id", e.WAREHOUSE_PPE_REQUIREMENTS = "warehouse_ppe_requirements", e.DOCK_INSTRUCTIONS = "dock_instructions", e.DOCK_DOOR = "dock_door", e.LOAD_TYPE_DESCRIPTION = "load_type_description", e.AMENITIES_AVAILABLE = "amenities_available", e))(xw || {}), Fw = /* @__PURE__ */ ((e) => (e.APPOINTMENT_PARAGRAPH_ONE = "appointment_paragraph_one", e))(Fw || {});
const dU = [
  {
    blockKey: "appointment_paragraph_one",
    content: "",
    isActive: !0,
    styleType: "standard",
    meta: {
      title: "Content Block",
      description: "This content is placed below the confirmation/reference number and above the appointment details."
    }
  }
], Hw = {
  appointment_updated: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when-solo", "where"],
    emailSubject: "Appointment details have changed",
    key: "appointment_updated",
    title: "Appointment details have changed",
    enabledByDefault: !0,
    context: {
      subTitle: "Please check location, date, time and all details below.",
      appointmentAnchorLabel: "View Appointment"
    }
  },
  appointment_confirmed: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "scheduled", "where"],
    emailSubject: "Appointment scheduled at $$orgName$$ - $$warehouseName$$",
    // TODO confirmed is confusing because of the requested status, look into changing to "scheduled"
    key: "appointment_confirmed",
    title: "Appointment scheduled",
    enabledByDefault: !0,
    context: {
      subTitle: "Please check location, date, time and all details below.",
      appointmentAnchorLabel: "View Appointment"
    },
    UIRenderOptions: {
      defaultStartStatus: i0.Scheduled,
      ignoreOrgStartStatusSetting: !0
    }
  },
  appointment_requested_confirmed: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "scheduled", "where"],
    emailSubject: "Appointment confirmed at $$orgName$$ - $$warehouseName$$",
    title: "Appointment confirmed",
    key: "appointment_requested_confirmed",
    enabledByDefault: !0,
    context: {
      subTitle: "Please check location, date, time and all details below.",
      appointmentAnchorLabel: "View Appointment"
    },
    UIRenderOptions: {
      defaultStartStatus: i0.Requested,
      ignoreOrgStartStatusSetting: !0,
      statusImagePrefix: "requested_"
    }
  },
  appointment_requested: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "requested", "where"],
    emailSubject: "Appointment requested at $$orgName$$ - $$warehouseName$$",
    title: "Appointment requested",
    key: "appointment_requested",
    enabledByDefault: !0,
    context: {
      subTitle: "Please wait for warehouse confirmation.",
      appointmentAnchorLabel: "View Appointment"
    },
    UIRenderOptions: {
      defaultStartStatus: i0.Requested,
      ignoreOrgStartStatusSetting: !0,
      statusImagePrefix: "requested_"
    }
  },
  appointment_noshow: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "missed", "where"],
    emailSubject: "Missed appointment at $$orgName$$ - $$warehouseName$$",
    key: "appointment_noshow",
    title: "Missed appointment",
    enabledByDefault: !0,
    context: {
      subTitle: "Carrier did not show for the appointment.",
      appointmentAnchorLabel: "View Appointment"
    }
  },
  appointment_recurring_series_scheduled: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "recurring", "where"],
    emailSubject: "Recurring appointment series has been created",
    key: "appointment_recurring_series_scheduled",
    title: "Recurring appointment series created",
    enabledByDefault: !0,
    context: {
      subTitle: "Please check the details of the recurring appointment below.",
      appointmentAnchorLabel: "View Original Appointment"
    }
  },
  appointment_arrived: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "arrived", "where"],
    emailSubject: "Truck arrived at $$orgName$$ - $$warehouseName$$",
    key: "appointment_arrived",
    title: "Truck arrived at facility",
    enabledByDefault: !0,
    context: {
      subTitle: "Check the status and appointment details below.",
      appointmentAnchorLabel: "View Appointment"
    }
  },
  appointment_inprogress: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "inprogress", "where"],
    emailSubject: "Appointment is in progress at $$orgName$$ - $$warehouseName$$",
    key: "appointment_inprogress",
    title: "Appointment is in progress at facility",
    enabledByDefault: !0,
    context: {
      subTitle: "Check the status and appointment details below.",
      appointmentAnchorLabel: "View Appointment"
    },
    UIRenderOptions: {
      statusImagePrefix: "inprogress_"
    }
  },
  appointment_rescheduled: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["rescheduled", "where"],
    emailSubject: "Appointment rescheduled at $$orgName$$ - $$warehouseName$$",
    key: "appointment_rescheduled",
    title: "Appointment rescheduled",
    enabledByDefault: !0,
    context: {
      subTitle: "Check the status and appointment details below.",
      appointmentAnchorLabel: "View Appointment"
    }
  },
  appointment_completed: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "completed", "where"],
    emailSubject: "Appointment completed at $$orgName$$ - $$warehouseName$$",
    key: "appointment_completed",
    title: "Appointment completed",
    enabledByDefault: !0,
    context: {
      subTitle: "Check the status and appointment details below.",
      appointmentAnchorLabel: "View Appointment"
    }
  },
  appointment_cancelled: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "cancelled", "where"],
    emailSubject: "Appointment cancelled with $$orgName$$ - $$warehouseName$$",
    key: "appointment_cancelled",
    title: "Appointment cancelled",
    enabledByDefault: !0,
    context: {
      subTitle: "Please check all details and reason for cancellation.",
      appointmentAnchorLabel: "View Appointment"
    }
  },
  appointment_tagged: {
    baseTemplateFile: "appointment.base.template.html",
    templateBlocks: ["when", "tagged", "where"],
    emailSubject: "Appointment tagged as $$tagName$$ - $$warehouseName$$",
    key: "appointment_tagged",
    title: "Appointment tagged",
    enabledByDefault: !1,
    context: {
      subTitle: "Please check the tag name and information below.",
      appointmentAnchorLabel: "View Appointment"
    },
    UIRenderOptions: {
      description: "Use Appointment Tags setting to enable tags individually"
    }
  }
};
function pU() {
  return Object.fromEntries(
    Object.entries(Hw).map(([e, n]) => {
      var t, r, M;
      const a = y0.camelCase(n.title);
      return [
        e,
        {
          ...n,
          title: h0(`core.notifications.titles.${a}`),
          emailSubject: h0(`core.notifications.subjects.${a}`),
          context: {
            ...n.context,
            ...((t = n.context) == null ? void 0 : t.subTitle) && {
              subTitle: h0(`core.notifications.subTitles.${a}`)
            },
            ...((r = n.context) == null ? void 0 : r.appointmentAnchorLabel) && {
              appointmentAnchorLabel: h0(`core.notifications.anchorLabels.${a}`)
            }
          },
          UIRenderOptions: {
            ...n.UIRenderOptions,
            ...((M = n.UIRenderOptions) == null ? void 0 : M.description) && {
              description: h0(`core.notifications.descriptions.${a}`)
            }
          }
        }
      ];
    })
  );
}
const cU = Object.freeze({
  title: "Appointment Email",
  body: null,
  orgName: "Opendock Freight LLC",
  apptConfirmationNumber: "1234",
  apptId: "52d2c52e-13c5-4e9b-a446-b737a043f2c3",
  apptNotes: "Appointment Notes",
  warehouseName: "Opendock Warehouse",
  warehouseFacilityNumber: "1234",
  warehouseAddress: "2828 N Central Ave, Suite 800C",
  warehouseCity: "Phoenix",
  warehouseState: "AZ",
  warehouseZip: "85004",
  warehousePhone: "(480) 483-1199",
  warehouseEmail: "support@opendock.com",
  warehouseGoogleMapsUrl: "https://maps.google.com",
  appointmentDate: "Wednesday, Feb 1, 2023 @ 11:00 AM (MST)",
  appointmentEnd: "Wednesday, Feb 1, 2023 @ 12:00 AM (MST)",
  appointmentLastUpdated: "Wednesday, Jan 15, 2023 @ 11:00 AM (MST)",
  appointmentLastUpdatedBy: "Warehouse User",
  appointmentCompletedBy: "",
  appointmentCustomFields: jM("Custom Field 1:", "Custom Field 1 value") + jM("Custom Field 2:", "Custom Field 2 value"),
  loadtypeDescription: jM(
    "Load Type Description",
    "This loadtype is for testing"
  ),
  truckArrivedAt: "Wednesday, Feb 1, 2023 @ 10:35 AM (MST)",
  loadType: "Frozen",
  refNumber: "---",
  instructions: "Example warehouse instructions",
  dockInstructions: "Example Dock Instructions",
  imagesPath: null,
  myAppointmentUrl: "#",
  carrierCompany: "Carrier Company LLC",
  carrierName: "John Doe Carrier",
  carrierEmail: "carrier@example.com",
  recurringNumWeeks: 2,
  recurringWeekDays: "Tuesday, Wednesday",
  settings: {},
  originalStart: "Wednesday, Feb 2, 2023 @ 11:00 AM (MST)",
  customLogoPath: null,
  statusVerbiage: "scheduled",
  tagName: "Custom Tag",
  tagColor: "#2AAD76",
  tagTextColor: "#FFFFFF",
  apptDockDoor: "123",
  warehouseAmenities: "Free Wi-Fi  •  Overnight Parking",
  warehousePpeRequirements: "Glasses  •  Hard Hat  •  No Smoking",
  statusTimeline: {
    [i0.Requested]: P.now().toISODate(),
    [i0.Scheduled]: P.now().plus({ minute: 1 }).toISODate(),
    [i0.Arrived]: P.now().plus({ minute: 2 }).toISODate(),
    [i0.Completed]: P.now().plus({ minute: 3 }).toISODate(),
    [i0.NoShow]: P.now().plus({ minute: 4 }).toISODate(),
    [i0.Cancelled]: P.now().plus({ minute: 5 }).toISODate()
  }
});
function jM(e, n) {
  if ((e == null ? void 0 : e.length) > 0 && (n == null ? void 0 : n.length) > 0)
    return `<div>
      <strong style="font-size: 16px">${e}</strong><br />
        <span style="font-size: 14px">${n}</span>
      </div>`;
}
function zU(e, n, a, t, r) {
  return `${String(e).replace("$$orgName$$", n).replace("$$tagName$$", r).replace("$$warehouseName$$", a)} - #${t}`;
}
function OU(e) {
  const n = [
    "corewellhealth.org",
    "duosecurity.com",
    "jumpcloud.com",
    "loginmt.com",
    "mainfreight.com",
    "microsoftonline.com",
    "oastify.com",
    "okta.com",
    "onelogin.com",
    "vermeer.com"
  ];
  process.env.NODE_ENV !== "production" && n.push("127.0.0.1", "localhost");
  try {
    const { hostname: a } = new URL(e);
    return n.some(
      (t) => a === t || a.endsWith(`.${t}`)
    );
  } catch {
    return !1;
  }
}
function uU(e, n) {
  let a = n.reduce((t, r) => (t = t.concat(r), t), e);
  return a = Lr(a), a;
}
function AU(e, n) {
  return [
    ...e.map((t) => {
      let r = P.fromJSDate(t.start, { zone: n }), M = P.fromJSDate(t.end, { zone: n });
      r.minute === 59 && r.second === 59 && (r = r.plus({ second: 1 })), M.minute === 0 && M.second === 0 && (M = M.minus({ second: 1 }));
      const b = [r.toFormat(G0.DateDashed)];
      let d = r;
      for (; d < M; )
        d = d.plus({ day: 1 }), d < M ? b.push(d.toFormat(G0.DateDashed)) : b.push(M.toFormat(G0.DateDashed));
      return b;
    }).flat().reduce((t, r) => (t.add(r), t), /* @__PURE__ */ new Set())
  ];
}
function lU(e, n, a, t) {
  const r = [];
  for (const M of e) {
    const b = P.fromJSDate(M.start).setZone(a).startOf("day"), d = Wu(M.end).setZone(a), c = { start: M.start, end: d.toJSDate() }, O = { minutes: t }, A = d.diff(b, "days").days + 1;
    for (let m = 0; m < A; m++) {
      const q = b.plus({ days: m });
      for (const y of n) {
        const $ = RB(y), v = q.set($).toJSDate(), E = q.set($).plus(O).toJSDate(), t0 = { start: v, end: E };
        Eb(t0, c) && r.push(t0.start);
      }
    }
  }
  return r;
}
function fU(e, n, a) {
  const t = [];
  return n <= 0 && (n = 60), e.forEach((r) => {
    const M = P.fromJSDate(
      Uw(r.start, n)
    ), b = Wu(r.end), d = { start: M.toJSDate(), end: b.toJSDate() }, c = { minutes: a }, O = { minutes: n };
    let A = M;
    for (; A <= b; ) {
      const m = {
        start: A.toJSDate(),
        end: A.plus(c).toJSDate()
      };
      Eb(m, d) && t.push(m.start), A = A.plus(O);
    }
  }), nS(t);
}
function Uw(e, n) {
  n <= 0 && (n = 60);
  const a = P.fromJSDate(e), t = Math.ceil(a.minute / n) * n, r = a.plus({ minute: t - a.minute });
  return (a.minute === 0 || a < r ? r : a).toJSDate();
}
function mU(e, n) {
  n <= 0 && (n = 60);
  const a = P.fromJSDate(e), t = Math.floor(a.minute / n) * n;
  return a.set({ minute: t }).toJSDate();
}
function Wu(e) {
  const n = P.fromJSDate(e);
  return n.minute === 59 ? n.plus({ minute: 1 }).set({ second: 0, millisecond: 0 }) : n;
}
function qU(e, n) {
  let a = 0;
  const t = {};
  let r = !1;
  for (; a < e.length; ) {
    const M = e[a];
    let b, d;
    M.startTimes.forEach((c) => {
      const O = P.fromISO(c.toString()).setZone(n), A = O.toFormat(G0.MonthDayYearSlashed);
      d = P.fromISO(c.toString()).setZone(n).toFormat("ZZZZ");
      const m = {
        start: O,
        docks: [],
        isDSTChange: !1
      };
      b && d !== b && (r || (m.isDSTChange = !0), r = !0), Vt(t, A) || (t[A] = []);
      const q = t[A].findIndex((y) => y.start.valueOf() === m.start.valueOf());
      q < 0 ? (m.docks.push(M.dock.id), t[A].push(m)) : t[A][q].docks.push(M.dock.id), b = d;
    }), a++;
  }
  return t;
}
function jw(e) {
  return Object.prototype.toString.call(e);
}
function Gw(e) {
  return typeof e == "object" && e !== null;
}
function gu(e) {
  return Gw(e) && jw(e) === "[object Date]";
}
function Oa(e, n) {
  return n = n || 2, e = Array(n).join("0") + e.toString(), e.substr(e.length - n, n);
}
function Ru(e) {
  const n = parseInt(e, 10);
  if (!isNaN(n))
    return n;
}
function Vw(e) {
  return e ? gu(e) ? e = e.getFullYear() : typeof e == "string" && (e = Ru(e)) : e = (/* @__PURE__ */ new Date()).getFullYear(), e;
}
const I5 = ["year", "month", "day", "hour", "minute", "second"];
class d1 {
  /**
   * constructs a new CalDate instance
   * @param {Object|Date} [opts] - See `set(opts)`
   * @example
   * const CalDate = require('caldate')
   * const caldate = new CalDate('2000-01-01 12:00:00')
   * caldate.year
   * //> 2000
   * caldate.month
   * //> 1
   */
  constructor(n) {
    this.set(n);
  }
  static toYear(n) {
    return Vw(n);
  }
  /**
   * set calendar date
   * @param {Object|Date} [opts] - defaults to `1900-01-01`
   * @param {String} opts.year
   * @param {String} opts.month - January equals to 1, December to 12
   * @param {String} opts.day
   * @param {String} opts.hour
   * @param {String} opts.minute
   * @param {String} opts.second
   * @param {String} opts.duration - defaults to 24 hours
   */
  set(n) {
    return n = n || { year: 1900, month: 1, day: 1 }, gu(n) ? (this.year = n.getFullYear(), this.month = n.getMonth() + 1, this.day = n.getDate(), this.hour = n.getHours(), this.minute = n.getMinutes(), this.second = n.getSeconds()) : (I5.forEach((a) => {
      this[a] = Ru(n[a]) || 0;
    }), this.month = this.month || 1, this.day = this.day || 1), this.duration = n.duration || 24, this;
  }
  /**
   * checks if Date is equal to `calDate`
   * @param {CalDate} calDate
   * @return {Boolean} true if date matches
   */
  isEqualDate(n) {
    let a = !0;
    return this.update(), ["year", "month", "day"].forEach((t) => {
      a &= this[t] === n[t];
    }), !!a;
  }
  /**
   * get day of week
   * @return {Number} day of week 0=sunday, 1=monday, ...
   */
  getDay() {
    return this.toDate().getDay();
  }
  /**
   * set offset per unit
   * @param {Number} number
   * @param {String} [unit='d'] - Unit in days `d`, hours `h, minutes `m`
   * @return {Object} this
   */
  setOffset(n, a) {
    if (n) {
      if (typeof n == "object" && (a = n.unit, n = n.number), a = a || "d", n = parseFloat(n, 10), isNaN(n))
        throw new Error("Number required");
      const t = { day: 0 };
      a === "d" && (t.day = n | 0, n -= t.day, n *= 24), (a === "d" || a === "h") && (t.hour = n % 24 | 0, n -= t.hour, n *= 60), t.minute = n % 60 | 0, n -= t.minute, n *= 60, t.second = n % 60 | 0, this.day += t.day, this.hour += t.hour, this.minute += t.minute, this.second += t.second;
    }
    return this.update(), this;
  }
  /**
   * set time per hour, minute or second while maintaining duration at midnight
   * @param {Number} [hour]
   * @param {Number} [minute]
   * @param {Number} [second]
   * @return {Object} this
   */
  setTime(n, a, t) {
    return n = n || 0, a = a || 0, t = t || 0, this.duration = 24 - (n + a / 60 + t / 3600), this.hour = n, this.minute = a, this.second = t, this.update(), this;
  }
  /**
   * set duration in hours
   * @param {Number} duration in hours
   * @return {Object} this
   */
  setDuration(n) {
    return this.duration = n, this;
  }
  /**
   * update internal data to real date
   * @return {Object} this
   */
  update() {
    if (this.year) {
      const n = new d1(this.toDate());
      I5.forEach((a) => {
        this[a] = n[a];
      });
    }
    return this;
  }
  /**
   * get end date of calendar date
   * @return {CalDate}
   */
  toEndDate() {
    const n = new d1(this.toDate());
    return n.minute += this.duration * 60 | 0, n.update(), n;
  }
  /**
   * move internal date to a date in `timezone`
   * @param {String} timezone - e.g. 'America/New_York'
   * @return {Date}
   */
  toTimezone(n) {
    return n ? new Date(W0.tz(this.toString(), n).format()) : this.toDate();
  }
  /**
   * set date from a given `timezone`
   * @param {Date} dateUTC - date in UTC
   * @param {String} [timezone] - timezone of dateUTC, e.g. 'America/New_York'
   * @return {CalDate} self
   */
  fromTimezone(n, a) {
    if (a) {
      const t = W0.tz(n, a);
      this.year = t.year(), this.month = t.month() + 1, this.day = t.date(), this.hour = t.hours(), this.minute = t.minutes(), this.second = t.seconds();
    } else
      this.set(n);
    return this;
  }
  /**
   * convert to Date
   * @return {Date}
   */
  toDate() {
    return new Date(
      this.year,
      this.month - 1,
      this.day,
      this.hour,
      this.minute,
      this.second,
      0
    );
  }
  /**
   * get Date in ISO format
   */
  toISOString() {
    return this.toString(!0);
  }
  /**
   * get Date as String `YYYY-MM-DD HH:MM:SS`
   */
  toString(n) {
    const a = new d1(this.toDate());
    return Oa(a.year, 4) + "-" + Oa(a.month) + "-" + Oa(a.day) + (n ? "T" : " ") + Oa(a.hour) + ":" + Oa(a.minute) + ":" + Oa(a.second) + (n ? "Z" : "");
  }
}
var Yw = function(n) {
  return Jw(n) && !Kw(n);
};
function Jw(e) {
  return !!e && typeof e == "object";
}
function Kw(e) {
  var n = Object.prototype.toString.call(e);
  return n === "[object RegExp]" || n === "[object Date]" || eC(e);
}
var Zw = typeof Symbol == "function" && Symbol.for, Qw = Zw ? Symbol.for("react.element") : 60103;
function eC(e) {
  return e.$$typeof === Qw;
}
function nC(e) {
  return Array.isArray(e) ? [] : {};
}
function St(e, n) {
  return n.clone !== !1 && n.isMergeableObject(e) ? Na(nC(e), e, n) : e;
}
function aC(e, n, a) {
  return e.concat(n).map(function(t) {
    return St(t, a);
  });
}
function tC(e, n) {
  if (!n.customMerge)
    return Na;
  var a = n.customMerge(e);
  return typeof a == "function" ? a : Na;
}
function oC(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(n) {
    return Object.propertyIsEnumerable.call(e, n);
  }) : [];
}
function x5(e) {
  return Object.keys(e).concat(oC(e));
}
function $u(e, n) {
  try {
    return n in e;
  } catch {
    return !1;
  }
}
function rC(e, n) {
  return $u(e, n) && !(Object.hasOwnProperty.call(e, n) && Object.propertyIsEnumerable.call(e, n));
}
function iC(e, n, a) {
  var t = {};
  return a.isMergeableObject(e) && x5(e).forEach(function(r) {
    t[r] = St(e[r], a);
  }), x5(n).forEach(function(r) {
    rC(e, r) || ($u(e, r) && a.isMergeableObject(n[r]) ? t[r] = tC(r, a)(e[r], n[r], a) : t[r] = St(n[r], a));
  }), t;
}
function Na(e, n, a) {
  a = a || {}, a.arrayMerge = a.arrayMerge || aC, a.isMergeableObject = a.isMergeableObject || Yw, a.cloneUnlessOtherwiseSpecified = St;
  var t = Array.isArray(n), r = Array.isArray(e), M = t === r;
  return M ? t ? a.arrayMerge(e, n, a) : iC(e, n, a) : St(n, a);
}
Na.all = function(n, a) {
  if (!Array.isArray(n))
    throw new Error("first argument should be an array");
  return n.reduce(function(t, r) {
    return Na(t, r, a);
  }, {});
};
var MC = Na, bC = MC;
const sC = /* @__PURE__ */ I2(bC), F4 = (e, n = [], a) => {
  let t = e;
  typeof n == "string" && (n = n.split("."));
  for (const r of n)
    if (t && t[r])
      t = t[r];
    else
      return a;
  return t;
}, dC = (e, n = [], a) => {
  let t, r, M = e;
  for (t of n)
    r = M, toString.call(M[t]) !== "[object Object]" && (M[t] = {}), M = M[t];
  return r[t] = a, e;
}, pC = (e, n = []) => Object.keys(e).filter((a) => !~n.indexOf(a)).reduce((a, t) => (t in e && (a[t] = e[t]), a), {}), cC = (...e) => sC.all(e), zC = (e, n) => {
  const a = Number(e);
  return isNaN(a) ? n : a;
}, w1 = {
  get: F4,
  set: dC,
  omit: pC,
  merge: cC
}, pt = function() {
  const e = {};
  return "sunday|monday|tuesday|wednesday|thursday|friday|saturday".split("|").forEach((n, a) => {
    e[n] = a, e[a] = n;
  }), e;
}();
function OC(e) {
  return Object.prototype.toString.call(e);
}
function uC(e) {
  return typeof e == "object" && e !== null;
}
function AC(e) {
  return uC(e) && OC(e) === "[object Date]";
}
const lC = (e) => e == null;
function p0(e) {
  const n = parseInt(e, 10);
  if (!isNaN(n))
    return n;
}
function fC(e) {
  return e ? e instanceof Date ? e = e.getFullYear() : typeof e == "string" && (e = p0(e)) : e = (/* @__PURE__ */ new Date()).getFullYear(), e;
}
function F5(e, n) {
  const a = /^(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?.*$/.exec((e || "").toString());
  if (a) {
    a.shift();
    const [t, r, M] = a.map((b) => parseInt(b || 1, 10));
    return new Date(t, r - 1, M);
  }
}
class S2 {
  constructor(n, a, t, r) {
    this.opts = S2.splitName(a, t, r) || {}, this.data = n || {};
  }
  /**
   * get all countries from the data
   * @param {String} lang - Iso-639 shortcode
   * @return {Object} shortcode-name value pairs. E.g. `{ AT: 'Österreich', ... }`
   */
  getCountries(n) {
    const a = {}, t = w1.get(this.data, "holidays", {});
    return Object.keys(t).forEach((r) => {
      a[r] = this._name(t, r, n, { country: r });
    }), a;
  }
  /**
   * get all states for a given country from the data
   * @param {String|Object} country
   * @param {String} [lang] - Iso-639 shortcode
   * @return {Object} shortcode-name value pairs. E.g. `{ b: 'Burgenland', ... }`
   */
  getStates(n, a) {
    const t = Object.assign({}, S2.splitName(n)), r = w1.get(this.data, ["holidays", t.country, "states"]) || w1.get(this.data, ["holidays", t.country, "regions"]);
    if (r) {
      const M = {};
      return Object.keys(r).forEach((b) => {
        t.state = b, M[b] = this._name(r, b, a, t);
      }), M;
    }
  }
  /**
   * get all regions for a given country/ state from the data
   * @param {String} country
   * @param {String} state
   * @param {String} [lang] - Iso-639 shortcode
   * @return {Object} shortcode-name value pairs.
   */
  getRegions(n, a, t) {
    const r = Object.assign({}, S2.splitName(n, a)), M = w1.get(this.data, ["holidays", r.country, "states", r.state, "regions"]);
    if (M) {
      const b = {};
      return Object.keys(M).forEach((d) => {
        r.region = d, b[d] = this._name(M, d, t, r);
      }), b;
    }
  }
  /**
   * @private
   */
  _name(n, a, t, r) {
    const M = n[a].names, b = t || this.getLanguages(r)[0] || Object.keys(M)[0], d = S2.majorLang(b);
    return n[a].name || M[b] || M[d] || M[Object.keys(M)[0]];
  }
  /**
   * get languages for selected country, state, region
   * @return {Array} containing ISO 639-1 language shortcodes
   */
  getLanguages(n) {
    return this._getValue("langs", n) || [];
  }
  /**
   * get default day off as weekday
   * @return {String} weekday of day off
   */
  getDayOff() {
    return this._getValue("dayoff");
  }
  /**
   * get timezones for country, state, region
   * @return {Array} of {String}s containing the timezones
   */
  getTimezones() {
    return this._getValue("zones") || [];
  }
  /**
   * get list of raw holiday rules for country/ state/ region
   * @param {Object|String} [country]
   * @param {String} [state]
   * @param {String} [region]
   * @return {Object} holidayname <-> unparsed rule or date pairs
   */
  getRules(n, a, t) {
    const r = {}, M = S2.splitName(n, a, t) || this.opts;
    if (!(M && M.country))
      return r;
    n = M.country.toUpperCase(), a = M.state, t = M.region;
    let b = w1.get(this.data, ["holidays", n]);
    return b && (this._assign(r, b), (a && b.regions && (b = b.regions[a]) || a && b.states && (b = b.states[a])) && (this._assign(r, b), t && b.regions && (b = b.regions[t]) && this._assign(r, b)), Object.keys(r).forEach((d) => {
      const c = r[d]._name;
      c && this.data.names[c] && (delete r[d]._name, r[d] = w1.merge({}, this.data.names[c], r[d]));
    })), r;
  }
  /**
   * get name for substitute name
   * @return {Object} translations of substitute day names
   */
  getSubstitueNames() {
    return w1.get(this.data, ["names", "substitutes", "name"]);
  }
  /**
   * helper to assign objects based on properties
   * @private
   * @param {Object} out - object where obj gets assigned into
   * @param {Object} obj - input obj
   * @return {Object}
   */
  _assign(n, a) {
    let t = {};
    if (a._days) {
      const r = ["holidays"].concat(a._days, "days"), M = w1.get(this.data, r);
      if (!M) throw new Error("unknown path for _days: " + r.join("."));
      t = Object.assign({}, M);
    }
    return (t || a.days) && (t = Object.assign(t, a.days), Object.keys(t).forEach(function(r) {
      if (t[r] === !1) {
        n[r] && delete n[r];
        return;
      }
      n[r] = Object.assign({}, n[r], t[r]), t[r].type || (n[r].type = "public");
    })), n;
  }
  /**
   * get a object from the data tree
   * @private
   * @param {String} key - key to look at
   * @return {Object} return object
   */
  _getValue(n, a = this.opts) {
    return w1.get(this.data, ["holidays", a.country, "states", a.state, "regions", a.regions, n]) || w1.get(this.data, ["holidays", a.country, "states", a.state, n]) || w1.get(this.data, ["holidays", a.country, n]);
  }
}
S2.splitName = function(e, n, a) {
  if (typeof e == "object" && e.country)
    return H5(e);
  if (typeof e == "string") {
    const t = e.split(/[.-]/), r = {
      country: t.shift(),
      state: t.shift() || n,
      region: t.shift() || a
    };
    return H5(r);
  }
};
S2.majorLang = function(e) {
  return (e || "").split(/-/)[0];
};
function H5(e) {
  return ["country", "state", "region"].forEach((n) => {
    typeof e[n] == "string" && (e[n] = e[n].toUpperCase());
  }), e;
}
const mC = "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday".split("|"), fa = (e) => mC.includes(e) ? e.toLowerCase() : e, qC = (e) => e === "day" ? void 0 : fa(e), x0 = function() {
  function e(t, r) {
    return t = t.source, r = r || "", function M(b, d) {
      return b ? (d = d.source || d, d = d.replace(/(^|[^[])\^/g, "$1"), t = t.replace(b, d), M) : new RegExp(t, r);
    };
  }
  const n = {
    _weekdays: "[Ss]unday|[Mm]onday|[Tt]uesday|[Ww]ednesday|[Tt]hursday|[Ff]riday|[Ss]aturday|day",
    _months: "January|February|March|April|May|June|July|August|September|October|November|December",
    _islamicMonths: "Muharram|Safar|Rabi al-awwal|Rabi al-thani|Jumada al-awwal|Jumada al-thani|Rajab|Shaban|Ramadan|Shawwal|Dhu al-Qidah|Dhu al-Hijjah",
    _hebrewMonths: "Nisan|Iyyar|Sivan|Tamuz|Av|Elul|Tishrei|Cheshvan|Kislev|Tevet|Shvat|AdarII|Adar",
    _jalaaliMonths: "Farvardin|Ordibehesht|Khordad|Tir|Mordad|Shahrivar|Mehr|Aban|Azar|Dey|Bahman|Esfand",
    _days: /(_weekdays)s?/,
    _direction: /(before|after|next|previous|in)/,
    _counts: /(\d+)(?:st|nd|rd|th)?/,
    _count_days: /([-+]?\d{1,2}) ?(?:days?|d)?/,
    _timezone: / in ([^\s]*|[+-]\d{2}:\d{2})/,
    _type: /(public|bank|school|observance|optional)/,
    dateMonth: /^(_months)/,
    date: /^(?:0*(\d{1,4})-)?0?(\d{1,2})-0?(\d{1,2})/,
    time: /^(?:T?0?(\d{1,2}):0?(\d{1,2})|T0?(\d{1,2}))/,
    duration: /^P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?)?/,
    // follows ISO 8601
    julian: /^julian date/,
    easter: /^(easter|orthodox)(?: _count_days)?/,
    equinox: /^([Mm]arch|[Jj]une|[Ss]eptember|[Dd]ecember) (?:equinox|solstice)(?:_timezone)?/,
    hebrew: /^0?(\d{1,2}) (_hebrewMonths)(?: 0*(\d{1,}))?/,
    islamic: /^0?(\d{1,2}) (_islamicMonths)(?: 0*(\d{1,}))?/,
    jalaali: /^0?(\d{1,2}) (_jalaaliMonths)(?: 0*(\d{1,}))?/,
    chineseLunar: /^(chinese|korean|vietnamese) (?:(\d+)-(\d{1,2})-)?(\d{1,2})-([01])-(\d{1,2})/,
    chineseSolar: /^(chinese|korean|vietnamese) (?:(\d+)-(\d{1,2})-)?(\d{1,2})-(\d{1,2}) solarterm/,
    bengaliRevised: /^(bengali-revised) (?:-?0*(\d{1,4})-)?0?(\d{1,2})-0?(\d{1,2})/,
    modifier: /^(substitutes|and|if equal|then|if)\b/,
    rule_year: /^(?:in (even|odd|leap|non-leap) years|every (\d+) years? since 0*(\d{1,4}))/,
    rule_weekday: /(not )?on ((?:(?:_weekdays)(?:,\s?)?)*)/,
    rule_date_if_then: /^if ((?:(?:_weekdays)(?:,\s?)?)*) then (?:_direction _days)?/,
    rule_day_dir_date: /^(?:_counts )?_days _direction/,
    rule_bridge: /^is (?:_type )?holiday/,
    rule_if_holiday: /^if is (?:_type )?holiday then (?:_counts )?(?:_direction _days)?(?: omit ((?:(?:_weekdays)(?:,\s?)?)*))?/,
    rule_same_day: /^#\d+/,
    rule_active_from: /^since (0*\d{1,4})(?:-0*(\d{1,2})(?:-0*(\d{1,2})|)|)(?: and|)/,
    rule_active_to: /^prior to (0*\d{1,4})(?:-0*(\d{1,2})(?:-0*(\d{1,2})|)|)/,
    // rule_type_if_then: /if ((?:(?:_weekdays)(?:,\s?)?)*) then/,
    // rule_type_dir: /_days _direction$/,
    // rule_type_bridge: / if .* is .* holiday$/,
    space: /^\s+/
  };
  n._days = e(n._days)(/_weekdays/, n._weekdays)(), n.julian = e(n.julian, "")(/date/, n.date)(), n.easter = e(n.easter, "")(/_count_days/, n._count_days)(), n.equinox = e(n.equinox, "")(/_count_days/g, n._count_days)(/_direction/g, n._direction)(/_timezone/g, n._timezone)(), n.hebrew = e(n.hebrew, "")(/_hebrewMonths/, n._hebrewMonths)(), n.islamic = e(n.islamic, "")(/_islamicMonths/, n._islamicMonths)(), n.jalaali = e(n.jalaali, "")(/_jalaaliMonths/, n._jalaaliMonths)(), n.dateMonth = e(n.dateMonth)(/_months/, n._months)(), n.rule_weekday = e(n.rule_weekday, "")(/_weekdays/g, n._weekdays)(), n.rule_date_if_then = e(n.rule_date_if_then, "")(/_direction/g, n._direction)(/_weekdays/g, n._weekdays)(/_days/g, n._days)(), n.rule_bridge = e(n.rule_bridge, "")(/_type/g, n._type)(), n.rule_if_holiday = e(n.rule_if_holiday, "")(/_type/g, n._type)(/_counts/g, n._counts)(/_direction/g, n._direction)(/_days/g, n._days)(/_weekdays/g, n._weekdays)(), n.rule_day_dir_date = e(n.rule_day_dir_date, "")(/_counts/, n._counts)(/_days/g, n._days)(/_direction/g, n._direction)();
  let a = 1;
  return n.months = {}, n._months.split("|").forEach(function(t) {
    n.months[t] = a++;
  }), a = 1, n.islamicMonths = {}, n._islamicMonths.split("|").forEach(function(t) {
    n.islamicMonths[t] = a++;
  }), a = 1, n.hebrewMonths = {}, n._hebrewMonths.split("|").forEach(function(t) {
    n.hebrewMonths[t] = a++;
  }), n.hebrewMonths.Adar = 12, n.hebrewMonths.AdarII = 13, a = 1, n.jalaaliMonths = {}, n._jalaaliMonths.split("|").forEach(function(t) {
    n.jalaaliMonths[t] = a++;
  }), n;
}();
class jb {
  constructor(n) {
    this.fns = n || [
      "_julian",
      "_date",
      "_easter",
      "_islamic",
      "_hebrew",
      "_jalaali",
      "_equinox",
      "_chineseSolar",
      "_chineseLunar",
      "_bengaliRevised",
      "_dateMonth",
      "_ruleDateIfThen",
      "_ruleWeekday",
      "_ruleYear",
      "_ruleDateDir",
      "_ruleIfHoliday",
      "_ruleBridge",
      "_ruleTime",
      "_ruleDuration",
      "_ruleModifier",
      "_ruleSameDay",
      "_ruleActiveFrom",
      "_ruleActiveTo"
    ], this.tokens = [];
  }
  parse(n) {
    return this.setup = { str: n, rule: n }, this.error = 0, this.tokens = [], this._tokenize(this.setup), this._reorder(), this.tokens;
  }
  /**
   * reorder set of tokens for rule dateDir
   * dateDir: [dateDir2, dateDir1, fn] --> [fn, dateDir1, dateDir2]
   * dateIfThen: [fn, dateIfThen1, dateIfThen2] --> [fn, dateIfThen1, dateIfThen2]
   */
  _reorder() {
    const n = [], a = [];
    this.tokens.forEach((t) => {
      if (t.rule === "dateDir")
        n.push(t);
      else if (a.push(t), n.length)
        for (; n.length; )
          a.push(n.pop());
      if (t.fn && a[0].modifier)
        for (; a[0].modifier; )
          a.push(a.shift());
    }), this.tokens = a;
  }
  _tokenize(n) {
    let a;
    for (; n.str; ) {
      for (let t = 0; t < this.fns.length && !this[this.fns[t]](n); t++)
        ;
      if (this._space(n), a === n.str) {
        this.error++;
        break;
      }
      a = n.str;
    }
  }
  _shorten(n, a) {
    n.str = n.str.substr(a.length, n.str.length);
  }
  _date(n) {
    let a;
    if (a = x0.date.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: "gregorian",
        year: p0(a.shift()),
        month: p0(a.shift()),
        day: p0(a.shift())
      };
      return this.tokens.push(t), !0;
    }
  }
  _julian(n) {
    let a;
    if (a = x0.julian.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: "julian",
        year: p0(a.shift()),
        month: p0(a.shift()),
        day: p0(a.shift())
      };
      return this.tokens.push(t), !0;
    }
  }
  _easter(n) {
    let a;
    if (a = x0.easter.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: "easter",
        type: a.shift(),
        offset: p0(a.shift()) || 0
      };
      return this.tokens.push(t), !0;
    }
  }
  _equinox(n) {
    let a;
    if (a = x0.equinox.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: "equinox",
        season: a.shift().toLowerCase(),
        timezone: a.shift() || "GMT"
      };
      return this.tokens.push(t), !0;
    }
  }
  _hebrew(n) {
    let a;
    if (a = x0.hebrew.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: "hebrew",
        day: p0(a.shift()),
        month: x0.hebrewMonths[a.shift()],
        year: p0(a.shift())
      };
      return this.tokens.push(t), !0;
    }
  }
  _islamic(n) {
    let a;
    if (a = x0.islamic.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: "islamic",
        day: p0(a.shift()),
        month: x0.islamicMonths[a.shift()],
        year: p0(a.shift())
      };
      return this.tokens.push(t), !0;
    }
  }
  _jalaali(n) {
    let a;
    if (a = x0.jalaali.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: "jalaali",
        day: p0(a.shift()),
        month: x0.jalaaliMonths[a.shift()],
        year: p0(a.shift())
      };
      return this.tokens.push(t), !0;
    }
  }
  _chineseSolar(n) {
    let a;
    if (a = x0.chineseSolar.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: a.shift(),
        cycle: p0(a.shift()),
        year: p0(a.shift()),
        solarterm: p0(a.shift()),
        day: p0(a.shift()),
        timezone: a.shift()
      };
      return this.tokens.push(t), !0;
    }
  }
  _chineseLunar(n) {
    let a;
    if (a = x0.chineseLunar.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: a.shift(),
        cycle: p0(a.shift()),
        year: p0(a.shift()),
        month: p0(a.shift()),
        leapMonth: !!p0(a.shift()),
        day: p0(a.shift()),
        timezone: a.shift()
      };
      return this.tokens.push(t), !0;
    }
  }
  _bengaliRevised(n) {
    let a;
    if (a = x0.bengaliRevised.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: a.shift(),
        year: p0(a.shift()),
        month: p0(a.shift()),
        day: p0(a.shift())
      };
      return this.tokens.push(t), !0;
    }
  }
  _dateMonth(n) {
    let a;
    if (a = x0.dateMonth.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        fn: "gregorian",
        day: 1,
        month: x0.months[a.shift()],
        year: void 0
      };
      return this.tokens.push(t), !0;
    }
  }
  _space(n) {
    let a;
    if (a = x0.space.exec(n.str))
      return this._shorten(n, a[0]), !0;
  }
  _ruleSameDay(n) {
    let a;
    if (a = x0.rule_same_day.exec(n.str))
      return this._shorten(n, a[0]), !0;
  }
  _ruleModifier(n) {
    let a;
    if (a = x0.modifier.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        modifier: a.shift()
      };
      return this.tokens.push(t), !0;
    }
  }
  _ruleTime(n) {
    let a;
    if (a = x0.time.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        rule: "time",
        hour: p0(a.shift()) || 0,
        minute: p0(a.shift()) || 0
      };
      return t.hour = t.hour || p0(a.shift()) || 0, this.tokens.push(t), !0;
    }
  }
  _ruleDuration(n) {
    let a;
    if (a = x0.duration.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        days: p0(a.shift()) || 0,
        hours: p0(a.shift()) || 0,
        minutes: p0(a.shift()) || 0
      }, r = {
        rule: "duration",
        // duration is calculated in hours
        duration: t.days * 24 + t.hours + t.minutes / 60
      };
      return this.tokens.push(r), !0;
    }
  }
  _ruleDateIfThen(n) {
    let a;
    if (a = x0.rule_date_if_then.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        rule: "dateIfThen",
        if: a.shift().split(/(?:,\s?)/).map(fa),
        direction: a.shift(),
        then: fa(a.shift())
      }, r = new jb(["_ruleTime", "_ruleDuration"]);
      return r.parse(n.str), r.tokens.length && (t.rules = r.tokens), n.str = " " + r.setup.str, this.tokens.push(t), !0;
    }
  }
  _ruleWeekday(n) {
    let a;
    if (a = x0.rule_weekday.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        rule: "weekday",
        not: !!a.shift(),
        if: a.shift().split(/(?:,\s?)/).map(fa)
      };
      return this.tokens.push(t), !0;
    }
  }
  _ruleDateDir(n) {
    let a;
    if (a = x0.rule_day_dir_date.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        rule: "dateDir",
        count: p0(a.shift()) || 1,
        weekday: fa(a.shift()),
        direction: a.shift()
      };
      return t.direction === "in" && (t.direction = "after"), this.tokens.push(t), !0;
    }
  }
  _ruleYear(n) {
    let a;
    if (a = x0.rule_year.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        rule: "year",
        cardinality: a.shift(),
        every: p0(a.shift()),
        since: p0(a.shift())
      };
      return this.tokens.push(t), !0;
    }
  }
  _ruleIfHoliday(n) {
    let a;
    if (a = x0.rule_if_holiday.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        rule: "ruleIfHoliday",
        type: a.shift(),
        count: p0(a.shift()) || 1,
        direction: a.shift(),
        weekday: fa(a.shift()),
        omit: (a.shift() || "").split(/(?:,\s?)/).map(qC).filter(Boolean)
      };
      return this.tokens.push(t), !0;
    }
  }
  _ruleBridge(n) {
    let a;
    if (a = x0.rule_bridge.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        rule: "bridge",
        type: a.shift()
      };
      return this.tokens.push(t), !0;
    }
  }
  _ruleActiveFrom(n) {
    let a;
    if (a = x0.rule_active_from.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        rule: "activeFrom",
        year: p0(a.shift()),
        month: p0(a.shift()) || 1,
        day: p0(a.shift()) || 1
      };
      return this.tokens.push(t), !0;
    }
  }
  _ruleActiveTo(n) {
    let a;
    if (a = x0.rule_active_to.exec(n.str)) {
      this._shorten(n, a[0]), a.shift();
      const t = {
        rule: "activeTo",
        year: p0(a.shift()),
        month: p0(a.shift()) || 1,
        day: p0(a.shift()) || 1
      };
      return this.tokens.push(t), !0;
    }
  }
}
class Lu {
  /**
  * @param {CalEvent} [calEvent]
   * @param {array} [holidays]
   */
  constructor(n) {
    this.calEvent = n;
  }
  /**
   * @param {CalEvent} calEvent
   */
  setEvent(n) {
    return this.calEvent = n, this;
  }
  /**
   * @return {CalEvent}
   */
  getEvent() {
    return this.calEvent;
  }
  /**
   * @param {string} modifier
   */
  setModifier(n) {
    this.modifier = n;
  }
  /**
   * resolves rule to function
   * @param {object} rule
   */
  resolve(n) {
    return n.rule && typeof this[n.rule] == "function" ? this[n.rule](n) : n.modifier && (this.modifier = n.modifier), this;
  }
  /**
   * @param {CalEvent} [calEvent]
   * @param {object} rule
   * {
   *   rule: "dateDir",
   *   count: 1,
   *   weekday: "tuesday",
   *   direction: "after",
   *   omit: ['sunday']
   * }
   */
  dateDir(n) {
    const a = [].concat(n.omit).map((r) => pt[r]).filter((r) => !lC(r)), t = (r, M) => {
      let b = r + M;
      for (; b < 0; )
        b += 70;
      return a.includes(b % 7);
    };
    this.calEvent.dates.forEach((r) => {
      let M, b = n.count - 1;
      const d = r.getDay(), c = pt[n.weekday], O = ["before", "previous"].includes(n.direction);
      if (n.direction === "next" && d === c && (b += 1), n.weekday === "day") {
        let A = 0;
        if (O)
          for (M = (b + 1) * -1; A++ < 7 && t(M, d); )
            M -= 1;
        else
          for (M = b + 1; A++ < 7 && t(M, d); )
            M += 1;
      } else
        O ? (d === c && b++, M = ((7 + d - c) % 7 + b * 7) * -1) : M = (7 - d + c) % 7 + b * 7;
      M && r.setOffset(M);
    });
  }
  /**
   * @param {object} rule
   * {
   *   rule: "dateIfThen",
   *   if: ["sunday"],
   *   direction: "next",
   *   then: "sunday"
   * }
   */
  dateIfThen(n) {
    const a = [];
    this.calEvent.dates = this.calEvent.dates.map((t) => {
      if (t._lock)
        return t;
      const r = t.getDay();
      if (~n.if.indexOf(pt[r])) {
        this.modifier === "and" && (a.push(new d1(t)), t.substitute = !0), t._filter = !1;
        let M = 0;
        const b = pt[n.then];
        n.then && b !== "undefined" && (n.direction === "previous" ? (M = -1 * ((7 + r - b) % 7), M || (M = -7)) : (M = (7 - r + b) % 7, M || (M = 7)), t.setOffset(M), t._lock = !0, this.modifier === "substitutes" && (t.substitute = !0)), (n.rules || []).forEach((d) => {
          switch (d.rule) {
            case "time":
              t.setTime(d.hour, d.minute);
              break;
            case "duration":
              t.duration = d.duration;
              break;
          }
        });
      } else this.modifier === "substitutes" && (t._filter = !0);
      return t;
    }), this.calEvent.dates = a.concat(this.calEvent.dates);
  }
  /**
   * @param {object} rule
   * {
   *   rule: "weekday",
   *   if: ["sunday", "saturday"],
   *   not: false,
   * }
   */
  weekday(n) {
    this.calEvent.dates = this.calEvent.dates.map((a) => {
      const t = a.getDay();
      let r = n.if.indexOf(pt[t]) !== -1;
      if (n.not && (r = !r), r) return a;
    }).filter((a) => a);
  }
  time(n) {
    this.calEvent.dates.forEach((a) => {
      a.setTime(n.hour, n.minute);
    });
  }
  duration(n) {
    this.calEvent.dates.forEach((a) => {
      a.duration = n.duration;
    });
  }
  bridge() {
    return !0;
  }
  ruleIfHoliday() {
    return !0;
  }
  activeFrom(n) {
    this.calEvent.setActive({ from: new d1(n).toDate() });
  }
  activeTo(n) {
    this.calEvent.setActive({ to: new d1(n).toDate() });
  }
  /**
   * @param {object} rule
   * {
   *   rule: "year",
   *   cardinality: "leap",
   *   every: undefined,
   *   since: undefined
   * }
   */
  year(n) {
    this.calEvent.dates = this.calEvent.dates.map((a) => {
      if (n.cardinality) {
        if (n.cardinality === "leap" && this._isLeapYear(a.year))
          return a;
        if (n.cardinality === "non-leap" && !this._isLeapYear(a.year))
          return a;
        if (n.cardinality === "even" && (a.year + 1) % 2)
          return a;
        if (n.cardinality === "odd" && a.year % 2)
          return a;
      } else if (n.every !== void 0 && n.since !== void 0 && (a.year - n.since) % n.every === 0)
        return a;
    }).filter((a) => a);
  }
  /**
   * @private
   * @return {Boolean} if true year is a leap year
   */
  _isLeapYear(n) {
    return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
  }
}
class Te {
  /**
   * @param {object|Date} opts
   * @param {string} opts.fn function type
   * @param {number} [opts.day]
   * @param {number} [opts.month]
   * @param {number} [opts.year]
   * @param {number} [opts.offset]
   * @param {boolean} [opts.substitute]
   */
  constructor(n) {
    n = n || {}, this.substitute = n.substitute, this.opts = n, this.offset = n.offset, this.dates = [], this.active = void 0, AC(n) && (this.opts = new d1(n));
  }
  /**
   * @param {number} year
   * @returns {this}
   */
  inYear(n) {
    const a = new d1(this.opts).setOffset(this.offset);
    return a.year && a.year !== n || (a.year = n, this.dates.push(a)), this;
  }
  reset() {
    this.dates = [];
  }
  /**
   * @param {CalEvent} calEvent
   * @returns {boolean}
   */
  isEqualDate(n) {
    let a = !1;
    for (const t of this.dates)
      for (const r of n.dates)
        a |= t.isEqualDate(r);
    return !!a;
  }
  /**
   * Filter out disabled dates
   * @param {number} year
   * @param {number} month
   * @returns {this}
   */
  filterDisabled(n, a) {
    return n ? (this.dates = this.dates.filter((t) => !(a ? t.year === n && t.month === a : t.year === n)), this) : this;
  }
  /**
   * @param {number} year - year to filter
   * @param {object[]} active - definition of active ranges `{from: {Date}, [to]: {Date}}`
   * @return {this} for chaining
   */
  filterActive(n, a = this.active) {
    return this.dates = this.dates.filter((t) => {
      if (!t._filter && hC(t, n, a))
        return t;
    }), this;
  }
  /**
   * @param {object} active
   * @param {Date} [active.from ]
   * @param {Date} [active.to]
   * @returns
   */
  setActive(n) {
    const { from: a, to: t } = n;
    let r = !0;
    if (this.active = this.active || [], t && !a) {
      const M = this.active[this.active.length - 1];
      M && M.from && !M.to && (M.to = t, r = !1);
    }
    return r && this.active.push(n), this;
  }
  /**
   * @param {CalEvent} calEvent
   */
  push(n) {
    n && Array.isArray(n.dates) && (this.dates = this.dates.concat(n.dates));
  }
  /**
   * @param {string} timezone
   * @returns
   */
  get(n) {
    return this.dates.map((t) => {
      const r = new d1(t), M = {
        date: r.toString(),
        start: r.toTimezone(n),
        end: r.toEndDate().toTimezone(n)
      };
      return this._addSubstitute(t, M), M;
    });
  }
  _addSubstitute(n, a) {
    (this.substitute || n.substitute) && (a.substitute = !0);
  }
}
function hC(e, n, a) {
  if (!a)
    return e.year === n;
  const t = e.toDate();
  for (const r of a) {
    const { from: M, to: b } = r;
    if (e.year === n && (M && b && M <= t && b > t || M && !b && M <= t || !M && b && b > t))
      return !0;
  }
}
class yC {
  /**
   * @param {String} ruleStr
   * @param {Object} opts
   * @param {Array} [holidays]
   */
  constructor(n, a, t) {
    this.opts = a, this.ruleStr = n, this.ruleSet = t && t[n], this.holidays = t, this.events = [];
  }
  push(n) {
    this.events.push(n);
  }
  /**
   * @param {number} year
   * @returns {CalEvent}
   */
  getEvent(n) {
    const a = this.ruleSet && this.ruleSet.active;
    this.disable(n);
    const t = this.events[0];
    return t.filterActive(n, a), t;
  }
  /**
   * @param {Array} rule
   * @param {number} year
   */
  resolve(n, a) {
    n.rule && typeof this[n.rule] == "function" && this[n.rule](n, a);
  }
  /**
   * @param {Array} rule
   * @param {number} year
   */
  bridge(n, a) {
    const t = new Array(this.events.length).fill(!1);
    t[0] = !0;
    const r = n.type || "public";
    for (const M in this.holidays) {
      const b = this.holidays[M].fn;
      if (b && b.ruleStr !== this.ruleStr) {
        const d = b.inYear(a), c = F4(d, "opts.type") || "public";
        for (let O = 1; O < this.events.length; O++) {
          if (t[O]) continue;
          d.event.isEqualDate(this.events[O]) && c === r && (t[O] = !0);
        }
      }
      if (!~t.indexOf(!1))
        break;
    }
    ~t.indexOf(!1) && this.events[0].reset();
  }
  ruleIfHoliday(n, a) {
    const t = n.type || "public";
    for (const r in this.holidays) {
      const M = this.holidays[r].fn;
      if (M && M.ruleStr !== this.ruleStr) {
        const b = M.inYear(a), d = F4(b, "opts.type") || "public";
        for (let c = 0; c < this.events.length; c++)
          if (b.event.isEqualDate(this.events[c]) && d === t) {
            new Lu(this.events[c]).resolve({ ...n, rule: "dateDir" });
            return;
          }
      }
    }
  }
  /**
   * @param {number} year
   */
  disable(n) {
    const { disable: a, enable: t } = this.opts || {};
    if (!a || !a.length) return;
    const r = this.events[0];
    let M = U5(n, a);
    if (M) {
      M.isEqualDate(r) && (r.reset(), M = U5(n, t), M && (this.events[0] = M));
      return;
    }
    const [b, d] = WC(n, a);
    r.filterDisabled(b, d);
  }
}
const _u = (e) => String(e).split("-").map((n) => zC(n));
function U5(e, n = []) {
  for (const a of n) {
    const [t, r, M] = _u(a);
    if (t === e && r && M)
      return new Te({ year: t, month: r, day: M }).inYear(t);
  }
}
function WC(e, n = []) {
  for (const a of n) {
    const [t, r] = _u(a);
    if (e === t)
      return [t, r];
  }
  return [];
}
function gC(e) {
  return e ? e instanceof Date ? e = e.getFullYear() : typeof e == "string" && (e = parseInt(e, 10)) : e = (/* @__PURE__ */ new Date()).getFullYear(), e;
}
function GM(e, n) {
  n = n || 2;
  const a = "0000" + e;
  return a.substr(a.length - n, n);
}
class RC {
  constructor(n, a, t) {
    this.year = n, this.month = a, this.day = t;
  }
  toString() {
    return [GM(this.year, 4), GM(this.month), GM(this.day)].join("-");
  }
}
function Gb(e, n, a) {
  e = gC(e);
  const t = Math.floor(e / 100);
  let r = 15 + Math.floor((3 * t + 3) / 4) - Math.floor((8 * t + 13) / 25), M = 2 - Math.floor((3 * t + 3) / 4);
  n && (r = 15, M = 0);
  const b = e % 19, d = (19 * b + r) % 30, c = Math.floor((d + b / 11) / 29), O = 21 + d - c, A = 7 - Math.floor(e + e / 4 + M) % 7, m = 7 - (O - A) % 7;
  let q = O + m;
  a && (q = q + Math.floor(e / 100) - Math.floor(e / 400) - 2);
  const y = [0, 31, 28, 31, 30, 31, 30, 31, 31];
  let $ = q, v;
  for (v = 3; v < 8 && !($ <= y[v]); v++)
    $ -= y[v];
  return new RC(e, v, $);
}
function Nu(e) {
  return Gb(e);
}
const $C = Nu;
function LC(e) {
  return Gb(e, !0);
}
function _C(e) {
  return Gb(e, !0, !0);
}
const j5 = {
  easter: $C,
  gregorianEaster: Nu,
  julianEaster: LC,
  orthodoxEaster: _C
};
class NC extends Te {
  /**
   * @param {object} [opts]
   * @param {string} opts.type - type of eastern (easter|orthodox)
   * @param {number|string} opts.offset - offset in days
   */
  constructor(n) {
    n = n || {}, super(n), this._fn = j5.easter, n.type === "orthodox" && (this._fn = j5.orthodoxEaster);
  }
  inYear(n) {
    const a = new d1(this._fn(n)).setOffset(this.offset);
    return this.dates.push(a), this;
  }
}
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module base
 */
const vC = 0.01720209895, DC = 149597870, TC = 0.397777156, SC = 0.917482062;
function BC(e) {
  return 0.0057755183 * e;
}
const wC = 24000005e-1, vr = 2451545, CC = 2415020, Vb = 24150203135e-4, EC = 24332824235e-4, Yb = 365.25, vu = 36525, Jb = 365.2421988, XC = 365.25636;
function PC(e) {
  return vr + Yb * (e - 2e3);
}
function kC(e) {
  return 2e3 + (e - vr) / Yb;
}
function IC(e) {
  return Vb + Jb * (e - 1900);
}
function xC(e) {
  return 1900 + (e - Vb) / Jb;
}
function FC(e) {
  return (e - vr) / vu;
}
function HC(e) {
  return (1 + Math.cos(e)) * 0.5;
}
class Du {
  /**
   * celestial coordinates in right ascension and declination
   * or ecliptic coordinates in longitude and latitude
   *
   * @param {number} ra - right ascension (or longitude)
   * @param {number} dec - declination (or latitude)
   * @param {number} [range] - distance
   * @param {number} [elongation] - elongation
   */
  constructor(n, a, t, r) {
    this._ra = n || 0, this._dec = a || 0, this.range = t, this.elongation = r;
  }
  /**
   * right ascension
   * @return {number}
   */
  get ra() {
    return this._ra;
  }
  set ra(n) {
    this._ra = n;
  }
  /**
   * declination
   * @return {number}
   */
  get dec() {
    return this._dec;
  }
  set dec(n) {
    this._dec = n;
  }
  /**
   * right ascension (or longitude)
   * @return {number}
   */
  get lon() {
    return this._ra;
  }
  set lon(n) {
    this._ra = n;
  }
  /**
   * declination (or latitude)
   * @return {number}
   */
  get lat() {
    return this._dec;
  }
  set lat(n) {
    this._dec = n;
  }
}
function UC(e, n) {
  const a = e.ra, t = e.dec, r = n.ra, M = n.dec, b = Math.sin(t), d = Math.cos(t), c = Math.sin(M), O = Math.cos(M), A = Math.sin(r - a), m = Math.cos(r - a);
  let q = Math.atan2(O * A, c * d - O * b * m);
  return q < 0 && (q += 2 * Math.PI), q;
}
const Tu = 10 * Math.PI / 180 / 60, jC = Math.cos(Tu);
function GC(e, n) {
  let a = e % n;
  return a < 0 && (a += n), a;
}
function VC(e, ...n) {
  Array.isArray(n[0]) && (n = n[0]);
  let a = n.length - 1, t = n[a];
  for (; a > 0; )
    a--, t = t * e + n[a];
  return t;
}
function YC(e, n) {
  const a = e / n;
  return Math.floor(a);
}
function JC(e, n) {
  return e < n ? -1 : e > n ? 1 : 0;
}
function KC(e) {
  return [Math.sin(e), Math.cos(e)];
}
function ZC(e) {
  return Math.PI / 180 * e;
}
function QC(e) {
  return 180 / Math.PI * e;
}
function eE(e) {
  const n = Math.trunc(e), a = Math.abs(e - n);
  return [n, a];
}
function nE(e, n = 14) {
  return parseFloat(e.toFixed(n));
}
function aE(e, n) {
  const a = new Error(e);
  return a.code = n, a;
}
const L = {
  K: vC,
  AU: DC,
  SOblJ2000: TC,
  COblJ2000: SC,
  lightTime: BC,
  JMod: wC,
  J2000: vr,
  J1900: CC,
  B1900: Vb,
  B1950: EC,
  JulianYear: Yb,
  JulianCentury: vu,
  BesselianYear: Jb,
  meanSiderealYear: XC,
  JulianYearToJDE: PC,
  JDEToJulianYear: kC,
  BesselianYearToJDE: IC,
  JDEToBesselianYear: xC,
  J2000Century: FC,
  illuminated: HC,
  Coord: Du,
  limb: UC,
  SmallAngle: Tu,
  CosSmallAngle: jC,
  pmod: GC,
  horner: VC,
  floorDiv: YC,
  cmp: JC,
  sincos: KC,
  toRad: ZC,
  toDeg: QC,
  modf: eE,
  round: nE,
  errorCode: aE
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module interpolation
 */
const tE = Math.trunc, Su = new Error("Argument y must be length 3"), Bu = new Error("Argument y must be length 4"), wu = new Error("Argument y must be length 5"), Jt = new Error("Argument x3 (or x5) cannot equal x1"), Kb = new Error("Interpolating factor n must be in range -1 to 1"), Cu = new Error("No extremum in table"), Qo = new Error("Extremum falls outside of table"), Zb = new Error("Zero falls outside of table"), er = new Error("Failure to converge");
class Eu {
  /**
   * NewLen3 prepares a Len3 object from a table of three rows of x and y values.
   *
   * X values must be equally spaced, so only the first and last are supplied.
   * X1 must not equal to x3.  Y must be a slice of three y values.
   *
   * @throws Error
   * @param {Number} x1 - is the x value corresponding to the first y value of the table.
   * @param {Number} x3 - is the x value corresponding to the last y value of the table.
   * @param {Number[]} y - is all y values in the table. y.length should be >= 3.0
   */
  constructor(n, a, t) {
    if (t.length !== 3)
      throw Su;
    if (a === n)
      throw Jt;
    this.x1 = n, this.x3 = a, this.y = t, this.a = t[1] - t[0], this.b = t[2] - t[1], this.c = this.b - this.a, this.abSum = this.a + this.b, this.xSum = a + n, this.xDiff = a - n;
  }
  /**
   * InterpolateX interpolates for a given x value.
   */
  interpolateX(n) {
    const a = (2 * n - this.xSum) / this.xDiff;
    return this.interpolateN(a);
  }
  /**
   * InterpolateXStrict interpolates for a given x value,
   * restricting x to the range x1 to x3 given to the constructor NewLen3.
   */
  interpolateXStrict(n) {
    const a = (2 * n - this.xSum) / this.xDiff;
    return this.interpolateNStrict(a);
  }
  /**
   * InterpolateN interpolates for (a given interpolating factor n.
   *
   * This is interpolation formula (3.3)
   *
   * @param n - The interpolation factor n is x-x2 in units of the tabular x interval.
   * (See Meeus p. 24.)
   * @return {number} interpolation value
   */
  interpolateN(n) {
    return this.y[1] + n * 0.5 * (this.abSum + n * this.c);
  }
  /**
   * InterpolateNStrict interpolates for (a given interpolating factor n.
   *
   * @param {number} n - n is restricted to the range [-1..1] corresponding to the range x1 to x3
   * given to the constructor of Len3.
   * @return {number} interpolation value
   */
  interpolateNStrict(n) {
    if (n < -1 || n > 1)
      throw Kb;
    return this.interpolateN(n);
  }
  /**
   * Extremum returns the x and y values at the extremum.
   *
   * Results are restricted to the range of the table given to the constructor
   * new Len3.
   */
  extremum() {
    if (this.c === 0)
      throw Cu;
    const n = this.abSum / (-2 * this.c);
    if (n < -1 || n > 1)
      throw Qo;
    const a = 0.5 * (this.xSum + this.xDiff * n), t = this.y[1] - this.abSum * this.abSum / (8 * this.c);
    return [a, t];
  }
  /**
   * Len3Zero finds a zero of the quadratic function represented by the table.
   *
   * That is, it returns an x value that yields y=0.
   *
   * Argument strong switches between two strategies for the estimation step.
   * when iterating to converge on the zero.
   *
   * Strong=false specifies a quick and dirty estimate that works well
   * for gentle curves, but can work poorly or fail on more dramatic curves.
   *
   * Strong=true specifies a more sophisticated and thus somewhat more
   * expensive estimate.  However, if the curve has quick changes, This estimate
   * will converge more reliably and in fewer steps, making it a better choice.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen3.
   */
  zero(n) {
    let a;
    n ? a = (M) => M - (2 * this.y[1] + M * (this.abSum + this.c * M)) / (this.abSum + 2 * this.c * M) : a = (M) => -2 * this.y[1] / (this.abSum + this.c * M);
    const [t, r] = nr(0, a);
    if (!r)
      throw er;
    if (t > 1 || t < -1)
      throw Zb;
    return 0.5 * (this.xSum + this.xDiff * t);
  }
}
function oE(e, n, a, t) {
  let r = t;
  if (t.length > 3) {
    const M = (a - n) / (t.length - 1);
    if (M === 0)
      throw Jt;
    let b = tE((e - n) / M + 0.5);
    b < 1 ? b = 1 : b > t.length - 2 && (b = t.length - 2), r = t.slice(b - 1, b + 2), a = n + (b + 1) * M, n = n + (b - 1) * M;
  }
  return new Eu(n, a, r);
}
const nr = function(e, n) {
  for (let a = 0; a < 50; a++) {
    const t = n(e);
    if (!isFinite(t) || isNaN(t))
      break;
    if (Math.abs((t - e) / e) < 1e-15)
      return [t, !0];
    e = t;
  }
  return [0, !1];
};
function rE(e) {
  if (e.length !== 4)
    throw Bu;
  return (9 * (e[1] + e[2]) - e[0] - e[3]) / 16;
}
class iE {
  /**
   * NewLen5 prepares a Len5 object from a table of five rows of x and y values.
   *
   * X values must be equally spaced, so only the first and last are suppliethis.
   * X1 must not equal x5.  Y must be a slice of five y values.
   */
  constructor(n, a, t) {
    if (t.length !== 5)
      throw wu;
    if (a === n)
      throw Jt;
    this.x1 = n, this.x5 = a, this.y = t, this.y3 = t[2], this.a = t[1] - t[0], this.b = t[2] - t[1], this.c = t[3] - t[2], this.d = t[4] - t[3], this.e = this.b - this.a, this.f = this.c - this.b, this.g = this.d - this.c, this.h = this.f - this.e, this.j = this.g - this.f, this.k = this.j - this.h, this.xSum = a + n, this.xDiff = a - n, this.interpCoeff = [
      // (3.8) p. 28
      this.y3,
      (this.b + this.c) / 2 - (this.h + this.j) / 12,
      this.f / 2 - this.k / 24,
      (this.h + this.j) / 12,
      this.k / 24
    ];
  }
  /**
   * InterpolateX interpolates for (a given x value.
   */
  interpolateX(n) {
    const a = (4 * n - 2 * this.xSum) / this.xDiff;
    return this.interpolateN(a);
  }
  /**
   * InterpolateXStrict interpolates for a given x value,
   * restricting x to the range x1 to x5 given to the the constructor NewLen5.
   */
  interpolateXStrict(n) {
    const a = (4 * n - 2 * this.xSum) / this.xDiff;
    return this.interpolateNStrict(a);
  }
  /**
   * InterpolateN interpolates for (a given interpolating factor n.
   *
   * The interpolation factor n is x-x3 in units of the tabular x interval.
   * (See Meeus p. 28.)
   */
  interpolateN(n) {
    return L.horner(n, ...this.interpCoeff);
  }
  /**
   * InterpolateNStrict interpolates for (a given interpolating factor n.
   *
   * N is restricted to the range [-1..1].  This is only half the range given
   * to the constructor NewLen5, but is the recommendation given on p. 31.0
   */
  interpolateNStrict(n) {
    if (n < -1 || n > 1)
      throw Kb;
    return L.horner(n, ...this.interpCoeff);
  }
  /**
   * Extremum returns the x and y values at the extremum.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen5.  (Meeus actually recommends restricting the range to one unit of
   * the tabular interval, but that seems a little harsh.)
   */
  extremum() {
    const n = [
      6 * (this.b + this.c) - this.h - this.j,
      0,
      3 * (this.h + this.j),
      2 * this.k
    ], a = this.k - 12 * this.f;
    if (a === 0)
      throw Qo;
    const [t, r] = nr(0, function(d) {
      return L.horner(d, ...n) / a;
    });
    if (!r)
      throw er;
    if (t < -2 || t > 2)
      throw Qo;
    const M = 0.5 * this.xSum + 0.25 * this.xDiff * t, b = L.horner(t, ...this.interpCoeff);
    return [M, b];
  }
  /**
   * Len5Zero finds a zero of the quartic function represented by the table.
   *
   * That is, it returns an x value that yields y=0.
   *
   * Argument strong switches between two strategies for the estimation step.
   * when iterating to converge on the zero.
   *
   * Strong=false specifies a quick and dirty estimate that works well
   * for gentle curves, but can work poorly or fail on more dramatic curves.
   *
   * Strong=true specifies a more sophisticated and thus somewhat more
   * expensive estimate.  However, if the curve has quick changes, This estimate
   * will converge more reliably and in fewer steps, making it a better choice.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen5.
   */
  zero(n) {
    let a;
    if (n) {
      const b = this.k / 24, d = (this.h + this.j) / 12, c = this.f / 2 - b, O = (this.b + this.c) / 2 - d, A = [this.y3, O, c, d, b], m = [O, 2 * c, 3 * d, 4 * b];
      a = function(q) {
        return q - L.horner(q, ...A) / L.horner(q, ...m);
      };
    } else {
      const b = [
        -24 * this.y3,
        0,
        this.k - 12 * this.f,
        -2 * (this.h + this.j),
        -this.k
      ], d = 12 * (this.b + this.c) - 2 * (this.h + this.j);
      a = function(c) {
        return L.horner(c, ...b) / d;
      };
    }
    const [t, r] = nr(0, a);
    if (!r)
      throw er;
    if (t > 2 || t < -2)
      throw Zb;
    return 0.5 * this.xSum + 0.25 * this.xDiff * t;
  }
}
function ME(e, n) {
  let a = 0;
  return n.forEach((t, r) => {
    const M = t[0];
    let b = 1;
    n.forEach((d, c) => {
      if (r !== c) {
        const O = d[0];
        b *= (e - O) / (M - O);
      }
    }), a += t[1] * b;
  }), a;
}
function bE(e) {
  const n = new Array(e.length).fill(0), a = new Array(e.length).fill(0), t = e.length - 1;
  for (let r = 0; r < e.length; r++) {
    const M = e[r][0] || e[r].x || 0, b = e[r][1] || e[r].y || 0;
    a[t] = 1;
    let d = 1, c = t;
    for (let O = 0; O < e.length; O++)
      if (r !== O) {
        const A = e[O][0] || e[O].x || 0;
        a[c - 1] = a[c] * -A;
        for (let m = c; m < t; m++)
          a[m] -= a[m + 1] * A;
        c--, d *= M - A;
      }
    a.forEach((O, A) => {
      n[A] += b * O / d;
    });
  }
  return n;
}
function sE(e, n, a, t) {
  const r = (a - n) / (t.length - 1);
  if (r === 0)
    throw Jt;
  let M = Math.floor((e - n) / r);
  M < 0 ? M = 0 : M > t.length - 2 && (M = t.length - 2);
  const b = t.slice(M, M + 2), d = n + M * r;
  return b[0] + (t[1] - t[0]) * (e - d) / r;
}
const Xu = {
  errorNot3: Su,
  errorNot4: Bu,
  errorNot5: wu,
  errorNoXRange: Jt,
  errorNOutOfRange: Kb,
  errorNoExtremum: Cu,
  errorExtremumOutside: Qo,
  errorZeroOutside: Zb,
  errorNoConverge: er,
  Len3: Eu,
  len3ForInterpolateX: oE,
  iterate: nr,
  len4Half: rE,
  Len5: iE,
  lagrange: ME,
  lagrangePoly: bE,
  linear: sE
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sexagesimal
 */
class Qb {
  /**
  * constructs a new Angle value from sign, degree, minute, and second
  * components.
  * @param {Number|Boolean} angleOrNeg - angle in radians or sign, true if negative (required to attribute -0°30')
  * __Four arguments__
  * @param {Number} [d] - (int) degree
  * @param {Number} [m] - (int) minute
  * @param {Number} [s] - (float) second
  */
  constructor(n, a, t, r) {
    arguments.length === 1 ? this.angle = Number(n) : this.setDMS(!!n, a, t, r);
  }
  /**
   * SetDMS sets the value of an FAngle from sign, degree, minute, and second
   * components.
   * The receiver is returned as a convenience.
   * @param {Boolean} neg - sign, true if negative
   * @param {Number} d - (int) degree
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   * @returns {Angle}
   */
  setDMS(n = !1, a = 0, t = 0, r = 0) {
    return this.angle = Dr(n, a, t, r) * Math.PI / 180, this;
  }
  /**
   * sets angle
   * @param {Number} angle - (float) angle in radians
   * @returns {Angle}
   */
  setAngle(n) {
    return this.angle = n, this;
  }
  /**
   * Rad returns the angle in radians.
   * @returns {Number} angle in radians
   */
  rad() {
    return this.angle;
  }
  /**
   * Deg returns the angle in degrees.
   * @returns {Number} angle in degree
   */
  deg() {
    return this.angle * 180 / Math.PI;
  }
  /**
   * toDMS converts to parsed sexagesimal angle component.
   */
  toDMS() {
    return Pu(this.deg());
  }
  /**
   * Print angle in degree using `d°m´s.ss″`
   * @param {Number} [precision] - precision of `s.ss`
   * @returns {String}
   */
  toString(n) {
    let [a, t, r, M] = this.toDMS();
    return M = va(M, n).toString().replace(/^0\./, "."), (a ? "-" : "") + (t + "°") + (r + "′") + (M + "″");
  }
  /**
   * Print angle in degree using `d°.ff`
   * @param {Number} [precision] - precision of `.ff`
   * @returns {String}
   */
  toDegString(n) {
    let [a, t] = ar(this.deg());
    return t = va(t, n).toString().replace(/^0\./, "."), a + "°" + t;
  }
}
class es extends Qb {
  /**
   * NewHourAngle constructs a new HourAngle value from sign, hour, minute,
   * and second components.
   * @param {Boolean} neg
   * @param {Number} h - (int)
   * @param {Number} m - (int)
   * @param {Number} s - (float)
   * @constructor
   */
  /**
   * SetDMS sets the value of an FAngle from sign, degree, minute, and second
   * components.
   * The receiver is returned as a convenience.
   * @param {Boolean} neg - sign, true if negative
   * @param {Number} h - (int) hour
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   * @returns {Angle}
   */
  setDMS(n = !1, a = 0, t = 0, r = 0) {
    return this.angle = Dr(n, a, t, r) * 15 * Math.PI / 180, this;
  }
  /**
   * Hour returns the hour angle as hours of time.
   * @returns hour angle
   */
  hour() {
    return this.angle * 12 / Math.PI;
  }
  deg() {
    return this.hour();
  }
  /**
   * Print angle in `HʰMᵐs.ssˢ`
   * @param {Number} precision - precision of `s.ss`
   * @returns {String}
   */
  toString(n) {
    let [a, t, r, M] = this.toDMS();
    return M = va(M, n).toString().replace(/^0\./, "."), (a ? "-" : "") + (t + "ʰ") + (r + "ᵐ") + (M + "ˢ");
  }
}
function Dr(e, n, a, t) {
  return t = ((n * 60 + a) * 60 + t) / 3600, e ? -t : t;
}
function Pu(e) {
  const n = e < 0;
  e = Math.abs(e);
  let [a, t] = ar(e % 360);
  const [r, M] = ar(t * 60);
  return t = va(M * 60), [n, a, r, t];
}
class dE extends es {
  /**
   * constructs a new RA value from hour, minute, and second components.
   * Negative values are not supported, RA wraps values larger than 24
   * to the range [0,24) hours.
   * @param {Number} h - (int) hour
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   */
  constructor(n = 0, a = 0, t = 0) {
    if (super(!1, n, a, t), [].slice.call(arguments).length === 1)
      this.angle = n;
    else {
      const M = Dr(!1, n, a, t) % 24;
      this.angle = M * 15 * Math.PI / 180;
    }
  }
  hour() {
    return (24 + this.angle * 12 / Math.PI % 24) % 24;
  }
}
class pE {
  /**
   * @param {boolean|number} negOrTimeInSecs - set `true` if negative; if type is number than time in seconds
   * @param {number} [h] - (int) hour
   * @param {number} [m] - (int) minute
   * @param {number} [s] - (float) second
   * @example
   * new sexa.Time(SECS_OF_DAY)
   * new sexa.Time(false, 15, 22, 7)
   */
  constructor(n, a, t, r) {
    typeof n == "number" ? this.time = n : this.setHMS(n, a, t, r);
  }
  setHMS(n = !1, a = 0, t = 0, r = 0) {
    r += (a * 60 + t) * 60, n && (r = -r), this.time = r;
  }
  /**
   * @returns {Number} time in seconds.
   */
  sec() {
    return this.time;
  }
  /**
   * @returns {Number} time in minutes.
   */
  min() {
    return this.time / 60;
  }
  /**
   * @returns {Number} time in hours.
   */
  hour() {
    return this.time / 3600;
  }
  /**
   * @returns {Number} time in days.
   */
  day() {
    return this.time / 3600 / 24;
  }
  /**
   * @returns {Number} time in radians, where 1 day = 2 Pi radians.
   */
  rad() {
    return this.time * Math.PI / 12 / 3600;
  }
  /**
   * convert time to HMS
   * @returns {Array} [neg, h, m, s]
   *  {Boolean} neg - sign, true if negative
   *  {Number} h - (int) hour
   *  {Number} m - (int) minute
   *  {Number} s - (float) second
   */
  toHMS() {
    let n = this.time;
    const a = n < 0;
    n = a ? -n : n;
    const t = Math.trunc(n / 3600);
    n = n - t * 3600;
    const r = Math.trunc(n / 60), M = n - r * 60;
    return [a, t, r, M];
  }
  /**
   * Print time using `HʰMᵐsˢ.ss`
   * @param {Number} precision - precision of `.ss`
   * @returns {String}
   */
  toString(n) {
    const [a, t, r, M] = this.toHMS();
    let [b, d] = ar(M);
    return n === 0 ? (b = va(M, 0), d = 0) : d = va(d, n).toString().substr(1), (a ? "-" : "") + (t + "ʰ") + (r + "ᵐ") + (b + "ˢ") + (d || "");
  }
}
const cE = (e) => e * Math.PI / 180, zE = (e) => e / 60 * Math.PI / 180, OE = (e) => e / 3600 * Math.PI / 180, uE = (e) => e * 180 / Math.PI, AE = (e) => e * 3600 * 180 / Math.PI, lE = (e) => e * 240 * 180 / Math.PI;
function ar(e) {
  const n = Math.trunc(e), a = Math.abs(e - n);
  return [n, a];
}
function va(e, n = 10) {
  return parseFloat(e.toFixed(n));
}
const t1 = {
  Angle: Qb,
  HourAngle: es,
  DMSToDeg: Dr,
  degToDMS: Pu,
  RA: dE,
  Time: pE,
  angleFromDeg: cE,
  angleFromMin: zE,
  angleFromSec: OE,
  degFromAngle: uE,
  secFromAngle: AE,
  secFromHourAngle: lE
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module coord
 */
class Tr {
  /**
   * IMPORTANT: Longitudes are measured *positively* westwards
   * e.g. Washington D.C. +77°04; Vienna -16°23'
   * @param {Number|LonLat} [lon] - Longitude (λ) in radians
   * @param {Number} [lat] - Latitude (β) in radians
   */
  constructor(n, a) {
    typeof n == "object" && (a = n.lat, n = n.lon), this.lon = n || 0, this.lat = a || 0;
  }
  /**
   * converts ecliptic coordinates to equatorial coordinates.
   * @param {Number} ε - Obliquity
   * @returns {Equatorial}
   */
  toEquatorial(n) {
    const [a, t] = L.sincos(n), [r, M] = L.sincos(this.lat), [b, d] = L.sincos(this.lon);
    let c = Math.atan2(b * t - r / M * a, d);
    c < 0 && (c += 2 * Math.PI);
    const O = Math.asin(r * t + M * a * b);
    return new Se(c, O);
  }
}
class Se {
  /**
   * @param {Number} ra - (float) Right ascension (α) in radians
   * @param {Number} dec - (float) Declination (δ) in radians
   */
  constructor(n = 0, a = 0) {
    this.ra = n, this.dec = a;
  }
  /**
   * EqToEcl converts equatorial coordinates to ecliptic coordinates.
   * @param {Number} ε - Obliquity
   * @returns {Ecliptic}
   */
  toEcliptic(n) {
    const [a, t] = L.sincos(n), [r, M] = L.sincos(this.ra), [b, d] = L.sincos(this.dec), c = Math.atan2(r * t + b / d * a, M), O = Math.asin(b * t - d * a * r);
    return new Tr(c, O);
  }
  /**
   * EqToHz computes Horizontal coordinates from equatorial coordinates.
   *
   * Argument g is the location of the observer on the Earth.  Argument st
   * is the sidereal time at Greenwich.
   *
   * Sidereal time must be consistent with the equatorial coordinates.
   * If coordinates are apparent, sidereal time must be apparent as well.
   *
   * @param {GlobeCoord} g - coordinates of observer on Earth
   * @param {Number} st - sidereal time at Greenwich at time of observation
   * @returns {Horizontal}
   */
  toHorizontal(n, a) {
    const t = new t1.Time(a).rad() - n.lon - this.ra, [r, M] = L.sincos(t), [b, d] = L.sincos(n.lat), [c, O] = L.sincos(this.dec), A = Math.atan2(r, M * b - c / O * d), m = Math.asin(b * c + d * O * M);
    return new ku(A, m);
  }
  /**
   * EqToGal converts equatorial coordinates to galactic coordinates.
   *
   * Equatorial coordinates must be referred to the standard equinox of B1950.0.
   * For conversion to B1950, see package precess and utility functions in
   * package "common".
   *
   * @returns {Galactic}
   */
  toGalactic() {
    const [n, a] = L.sincos(Bt.ra - this.ra), [t, r] = L.sincos(Bt.dec), [M, b] = L.sincos(this.dec), d = Math.atan2(n, a * t - M / b * r), c = (ns + 1.5 * Math.PI - d) % (2 * Math.PI), O = Math.asin(M * t + b * r * a);
    return new Iu(c, O);
  }
}
class ku {
  constructor(n = 0, a = 0) {
    this.az = n, this.alt = a;
  }
  /**
   * transforms horizontal coordinates to equatorial coordinates.
   *
   * Sidereal time must be consistent with the equatorial coordinates.
   * If coordinates are apparent, sidereal time must be apparent as well.
   * @param {GlobeCoord} g - coordinates of observer on Earth (lat, lon)
   * @param {Number} st - sidereal time at Greenwich at time of observation.
   * @returns {Equatorial} (right ascension, declination)
   */
  toEquatorial(n, a) {
    const [t, r] = L.sincos(this.az), [M, b] = L.sincos(this.alt), [d, c] = L.sincos(n.lat), O = Math.atan2(t, r * d + M / b * c), A = L.pmod(new t1.Time(a).rad() - n.lon - O, 2 * Math.PI), m = Math.asin(d * M - c * b * r);
    return new Se(A, m);
  }
}
class Iu {
  constructor(n = 0, a = 0) {
    this.lon = n, this.lat = a;
  }
  /**
   * GalToEq converts galactic coordinates to equatorial coordinates.
   *
   * Resulting equatorial coordinates will be referred to the standard equinox of
   * B1950.0.  For subsequent conversion to other epochs, see package precess and
   * utility functions in package meeus.
   *
   * @returns {Equatorial} (right ascension, declination)
   */
  toEquatorial() {
    const [n, a] = L.sincos(this.lon - ns - Math.PI / 2), [t, r] = L.sincos(Bt.dec), [M, b] = L.sincos(this.lat), d = Math.atan2(n, a * t - M / b * r), c = L.pmod(d + Bt.ra - Math.PI, 2 * Math.PI), O = Math.asin(M * t + b * r * a);
    return new Se(c, O);
  }
}
const xu = new Se(
  new t1.RA(12, 49, 0).rad(),
  27.4 * Math.PI / 180
), Bt = xu, Fu = 33 * Math.PI / 180, ns = Fu, H4 = {
  Ecliptic: Tr,
  Equatorial: Se,
  Horizontal: ku,
  Galactic: Iu,
  galacticNorth: xu,
  galacticNorth1950: Bt,
  galacticLon0: Fu,
  galactic0Lon1950: ns
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module nutation
 */
function Hu(e) {
  const n = L.J2000Century(e), a = L.horner(
    n,
    297.85036,
    445267.11148,
    -19142e-7,
    1 / 189474
  ) * Math.PI / 180, t = L.horner(
    n,
    357.52772,
    35999.05034,
    -1603e-7,
    -1 / 3e5
  ) * Math.PI / 180, r = L.horner(
    n,
    134.96298,
    477198.867398,
    86972e-7,
    1 / 56250
  ) * Math.PI / 180, M = L.horner(
    n,
    93.27191,
    483202.017538,
    -36825e-7,
    1 / 327270
  ) * Math.PI / 180, b = L.horner(
    n,
    125.04452,
    -1934.136261,
    20708e-7,
    1 / 45e4
  ) * Math.PI / 180;
  let d = 0, c = 0;
  for (let O = G5.length - 1; O >= 0; O--) {
    const A = G5[O], m = A.d * a + A.m * t + A.n * r + A.f * M + A.ω * b, [q, y] = L.sincos(m);
    d += q * (A.s0 + A.s1 * n), c += y * (A.c0 + A.c1 * n);
  }
  return d *= 1e-4 / 3600 * (Math.PI / 180), c *= 1e-4 / 3600 * (Math.PI / 180), [d, c];
}
function fE(e) {
  const n = (e - L.J2000) / 36525, a = (125.04452 - 1934.136261 * n) * Math.PI / 180, t = (280.4665 + 36000.7698 * n) * Math.PI / 180, r = (218.3165 + 481267.8813 * n) * Math.PI / 180, [M, b] = L.sincos(a), [d, c] = L.sincos(2 * t), [O, A] = L.sincos(2 * r), [m, q] = L.sincos(2 * a), y = (-17.2 * M - 1.32 * d - 0.23 * O + 0.21 * m) / 3600 * (Math.PI / 180), $ = (9.2 * b + 0.57 * c + 0.1 * A - 0.09 * q) / 3600 * (Math.PI / 180);
  return [y, $];
}
function Uu(e) {
  return L.horner(
    L.J2000Century(e),
    new t1.Angle(!1, 23, 26, 21.448).rad(),
    -46.815 / 3600 * (Math.PI / 180),
    -59e-5 / 3600 * (Math.PI / 180),
    1813e-6 / 3600 * (Math.PI / 180)
  );
}
function mE(e) {
  return L.horner(
    L.J2000Century(e) * 0.01,
    new t1.Angle(!1, 23, 26, 21.448).rad(),
    -4680.93 / 3600 * (Math.PI / 180),
    -1.55 / 3600 * (Math.PI / 180),
    1999.25 / 3600 * (Math.PI / 180),
    -51.38 / 3600 * (Math.PI / 180),
    -249.67 / 3600 * (Math.PI / 180),
    -39.05 / 3600 * (Math.PI / 180),
    7.12 / 3600 * (Math.PI / 180),
    27.87 / 3600 * (Math.PI / 180),
    5.79 / 3600 * (Math.PI / 180),
    2.45 / 3600 * (Math.PI / 180)
  );
}
function qE(e) {
  const [n, a] = Hu(e), t = Uu(e);
  return n * Math.cos(t + a);
}
const G5 = function() {
  const e = "d,m,n,f,ω,s0,s1,c0,c1".split(",");
  return [
    [0, 0, 0, 0, 1, -171996, -174.2, 92025, 8.9],
    [-2, 0, 0, 2, 2, -13187, -1.6, 5736, -3.1],
    [0, 0, 0, 2, 2, -2274, -0.2, 977, -0.5],
    [0, 0, 0, 0, 2, 2062, 0.2, -895, 0.5],
    [0, 1, 0, 0, 0, 1426, -3.4, 54, -0.1],
    [0, 0, 1, 0, 0, 712, 0.1, -7, 0],
    [-2, 1, 0, 2, 2, -517, 1.2, 224, -0.6],
    [0, 0, 0, 2, 1, -386, -0.4, 200, 0],
    [0, 0, 1, 2, 2, -301, 0, 129, -0.1],
    [-2, -1, 0, 2, 2, 217, -0.5, -95, 0.3],
    [-2, 0, 1, 0, 0, -158, 0, 0, 0],
    [-2, 0, 0, 2, 1, 129, 0.1, -70, 0],
    [0, 0, -1, 2, 2, 123, 0, -53, 0],
    [2, 0, 0, 0, 0, 63, 0, 0, 0],
    [0, 0, 1, 0, 1, 63, 0.1, -33, 0],
    [2, 0, -1, 2, 2, -59, 0, 26, 0],
    [0, 0, -1, 0, 1, -58, -0.1, 32, 0],
    [0, 0, 1, 2, 1, -51, 0, 27, 0],
    [-2, 0, 2, 0, 0, 48, 0, 0, 0],
    [0, 0, -2, 2, 1, 46, 0, -24, 0],
    [2, 0, 0, 2, 2, -38, 0, 16, 0],
    [0, 0, 2, 2, 2, -31, 0, 13, 0],
    [0, 0, 2, 0, 0, 29, 0, 0, 0],
    [-2, 0, 1, 2, 2, 29, 0, -12, 0],
    [0, 0, 0, 2, 0, 26, 0, 0, 0],
    [-2, 0, 0, 2, 0, -22, 0, 0, 0],
    [0, 0, -1, 2, 1, 21, 0, -10, 0],
    [0, 2, 0, 0, 0, 17, -0.1, 0, 0],
    [2, 0, -1, 0, 1, 16, 0, -8, 0],
    [-2, 2, 0, 2, 2, -16, 0.1, 7, 0],
    [0, 1, 0, 0, 1, -15, 0, 9, 0],
    [-2, 0, 1, 0, 1, -13, 0, 7, 0],
    [0, -1, 0, 0, 1, -12, 0, 6, 0],
    [0, 0, 2, -2, 0, 11, 0, 0, 0],
    [2, 0, -1, 2, 1, -10, 0, 5, 0],
    [2, 0, 1, 2, 2, -8, 0, 3, 0],
    [0, 1, 0, 2, 2, 7, 0, -3, 0],
    [-2, 1, 1, 0, 0, -7, 0, 0, 0],
    [0, -1, 0, 2, 2, -7, 0, 3, 0],
    [2, 0, 0, 2, 1, -7, 0, 3, 0],
    [2, 0, 1, 0, 0, 6, 0, 0, 0],
    [-2, 0, 2, 2, 2, 6, 0, -3, 0],
    [-2, 0, 1, 2, 1, 6, 0, -3, 0],
    [2, 0, -2, 0, 1, -6, 0, 3, 0],
    [2, 0, 0, 0, 1, -6, 0, 3, 0],
    [0, -1, 1, 0, 0, 5, 0, 0, 0],
    [-2, -1, 0, 2, 1, -5, 0, 3, 0],
    [-2, 0, 0, 0, 1, -5, 0, 3, 0],
    [0, 0, 2, 2, 1, -5, 0, 3, 0],
    [-2, 0, 2, 0, 1, 4, 0, 0, 0],
    [-2, 1, 0, 2, 1, 4, 0, 0, 0],
    [0, 0, 1, -2, 0, 4, 0, 0, 0],
    [-1, 0, 1, 0, 0, -4, 0, 0, 0],
    [-2, 1, 0, 0, 0, -4, 0, 0, 0],
    [1, 0, 0, 0, 0, -4, 0, 0, 0],
    [0, 0, 1, 2, 0, 3, 0, 0, 0],
    [0, 0, -2, 2, 2, -3, 0, 0, 0],
    [-1, -1, 1, 0, 0, -3, 0, 0, 0],
    [0, 1, 1, 0, 0, -3, 0, 0, 0],
    [0, -1, 1, 2, 2, -3, 0, 0, 0],
    [2, -1, -1, 2, 2, -3, 0, 0, 0],
    [0, 0, 3, 2, 2, -3, 0, 0, 0],
    [2, -1, 0, 2, 2, -3, 0, 0, 0]
  ].map((a) => {
    const t = {};
    return e.forEach((r, M) => {
      t[r] = a[M];
    }), t;
  });
}(), Da = {
  nutation: Hu,
  approxNutation: fE,
  meanObliquity: Uu,
  meanObliquityLaskar: mE,
  nutationInRA: qE
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module elementequinox
 */
class hE {
  constructor(n, a, t) {
    typeof n == "object" && (a = n.pode, t = n.peri, n = n.inc), this.inc = n || 0, this.node = a || 0, this.peri = t || 0;
  }
}
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module precess
 */
function ju(e, n, a) {
  const [t, r, M] = Gu(n, a), [b, d] = L.sincos(e.ra), c = t + r * b * Math.tan(e.dec), O = M * d, A = new es(!1, 0, 0, c).rad(), m = new Qb(!1, 0, 0, O).rad();
  return { ra: A, dec: m };
}
function Gu(e, n) {
  const a = (n - e) * 0.01, t = 3.07496 + 186e-5 * a, r = 1.33621 - 57e-5 * a, M = 20.0431 - 85e-4 * a;
  return [t, r, M];
}
function yE(e, n, a, t, r) {
  const { ra: M, dec: b } = ju(e, n, a), d = a - n, c = new Se();
  return c.ra = e.ra + (M + t) * d, c.dec = e.dec + (b + r) * d, c;
}
const as = Math.PI / 180, e0 = as / 3600, WE = [2306.2181 * e0, 1.39656 * e0, -139e-6 * e0], gE = [2306.2181 * e0, 1.39656 * e0, -139e-6 * e0], RE = [2004.3109 * e0, -0.8533 * e0, -217e-6 * e0], $E = [2306.2181 * e0, 0.30188 * e0, 0.017998 * e0], LE = [2306.2181 * e0, 1.09468 * e0, 0.018203 * e0], _E = [2004.3109 * e0, -0.42665 * e0, -0.041833 * e0];
class Vu {
  /**
   * constructs a Precessor object and initializes it to precess
   * coordinates from epochFrom to epochTo.
   * @param {Number} epochFrom
   * @param {Number} epochTo
   */
  constructor(n, a) {
    let t = $E, r = LE, M = _E;
    if (n !== 2e3) {
      const c = (n - 2e3) * 0.01;
      t = [
        L.horner(c, ...WE),
        0.30188 * e0 - 344e-6 * e0 * c,
        0.017998 * e0
      ], r = [
        L.horner(c, ...gE),
        1.09468 * e0 + 66e-6 * e0 * c,
        0.018203 * e0
      ], M = [
        L.horner(c, ...RE),
        -0.42665 * e0 - 217e-6 * e0 * c,
        -0.041833 * e0
      ];
    }
    const b = (a - n) * 0.01;
    this.ζ = L.horner(b, ...t) * b, this.z = L.horner(b, ...r) * b;
    const d = L.horner(b, ...M) * b;
    this.sθ = Math.sin(d), this.cθ = Math.cos(d);
  }
  /**
   * Precess precesses coordinates eqFrom, leaving result in eqTo.
   *
   * @param {Equatorial} eqFrom
   * @returns {Equatorial} eqTo
   */
  precess(n) {
    const [a, t] = L.sincos(n.dec), [r, M] = L.sincos(n.ra + this.ζ), b = t * r, d = this.cθ * t * M - this.sθ * a, c = this.sθ * t * M + this.cθ * a, O = new Se();
    return O.ra = Math.atan2(b, d) + this.z, c < L.CosSmallAngle ? O.dec = Math.asin(c) : O.dec = Math.acos(Math.hypot(b, d)), O;
  }
}
function NE(e, n, a, t, r) {
  const M = new Vu(n, a), b = a - n, d = new Se();
  return d.ra = e.ra + t * b, d.dec = e.dec + r * b, M.precess(d);
}
const vE = [47.0029 * e0, -0.06603 * e0, 598e-6 * e0], DE = [174.876384 * as, 3289.4789 * e0, 0.60622 * e0], TE = [5029.0966 * e0, 2.22226 * e0, -42e-6 * e0], SE = [47.0029 * e0, -0.03302 * e0, 6e-5 * e0], BE = [174.876384 * as, -869.8089 * e0, 0.03536 * e0], wE = [5029.0966 * e0, 1.11113 * e0, -6e-6 * e0];
class Yu {
  /**
   * constructs an EclipticPrecessor object and initializes
   * it to precess coordinates from epochFrom to epochTo.
   * @param {Number} epochFrom
   * @param {Number} epochTo
   */
  constructor(n, a) {
    let t = SE, r = BE, M = wE;
    if (n !== 2e3) {
      const c = (n - 2e3) * 0.01;
      t = [
        L.horner(c, ...vE),
        -0.03302 * e0 + 598e-6 * e0 * c,
        6e-5 * e0
      ], r = [
        L.horner(c, ...DE),
        -869.8089 * e0 - 0.50491 * e0 * c,
        0.03536 * e0
      ], M = [
        L.horner(c, ...TE),
        1.11113 * e0 - 42e-6 * e0 * c,
        -6e-6 * e0
      ];
    }
    const b = (a - n) * 0.01;
    this.π = L.horner(b, ...r), this.p = L.horner(b, ...M) * b;
    const d = L.horner(b, ...t) * b;
    this.sη = Math.sin(d), this.cη = Math.cos(d);
  }
  /**
   * EclipticPrecess precesses coordinates eclFrom, leaving result in eclTo.
   *
   * The same struct may be used for eclFrom and eclTo.
   * EclTo is returned for convenience.
   * @param {Ecliptic} eclFrom
   * @returns {Ecliptic} [eclTo]
   */
  precess(n) {
    const [a, t] = L.sincos(n.lat), [r, M] = L.sincos(this.π - n.lon), b = this.cη * t * r - this.sη * a, d = t * M, c = this.cη * a + this.sη * t * r, O = new Tr(this.p + this.π - Math.atan2(b, d));
    return c < L.CosSmallAngle ? O.lat = Math.asin(c) : O.lat = Math.acos(Math.hypot(b, d)), O;
  }
  /**
   * ReduceElements reduces orbital elements of a solar system body from one
   * equinox to another.
   *
   * This function is described in chapter 24, but is located in this
   * package so it can be a method of EclipticPrecessor.
   *
   * @param {Elements} eFrom
   * @returns {Elements} eTo
   */
  reduceElements(n) {
    const a = this.π + this.p, [t, r] = L.sincos(n.inc), [M, b] = L.sincos(n.node - this.π), d = new hE();
    return d.inc = Math.acos(r * this.cη + t * this.sη * b), d.node = Math.atan2(t * M, this.cη * t * b - this.sη * r) + a, d.peri = Math.atan2(-this.sη * M, t * this.cη - r * this.sη * b) + n.peri, d;
  }
}
function CE(e, n, a, t, r) {
  const M = new Yu(n, a);
  if (t && r && (t.rad() !== 0 || r.rad() !== 0)) {
    const { lon: b, lat: d } = Ju(t.rad(), r.rad(), n, e), c = a - n;
    e.lon += b * c, e.lat += d * c;
  }
  return M.precess(e);
}
function Ju(e, n, a, t) {
  const r = Da.meanObliquity(L.JulianYearToJDE(a)), [M, b] = L.sincos(r), { ra: d, dec: c } = t.toEquatorial(r), [O, A] = L.sincos(d), [m, q] = L.sincos(c), y = Math.cos(t.lat), $ = (n * M * A + e * q * (b * q + M * m * O)) / (y * y), v = (n * (b * q + M * m * O) - e * M * A * q) / y;
  return new Tr($, v);
}
function EE(e, n, a, t, r, M, b) {
  const [d, c] = L.sincos(e.ra), [O, A] = L.sincos(e.dec), m = t * A * c, q = t * A * d, y = t * O, $ = r / t, v = y * b.rad(), E = m * $ - v * c - q * M.rad(), t0 = q * $ - v * d + m * M.rad(), K = y * $ + t * b.rad() * A, C = a - n, s0 = m + C * E, J = q + C * t0, I0 = y + C * K, g0 = new Se();
  return g0.ra = Math.atan2(J, s0), g0.dec = Math.atan2(I0, Math.hypot(s0, J)), g0;
}
const V5 = {
  approxAnnualPrecession: ju,
  mn: Gu,
  approxPosition: yE,
  Precessor: Vu,
  position: NE,
  EclipticPrecessor: Yu,
  eclipticPosition: CE,
  properMotion: Ju,
  properMotion3D: EE
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetposition
 */
function ua(e, n) {
  const a = [];
  return Object.keys(n).forEach((r) => {
    a[r] = 0;
    let M = n[r].length - 1;
    for (M; M >= 0; M--) {
      const b = {
        a: n[r][M][0],
        b: n[r][M][1],
        c: n[r][M][2]
      };
      a[r] += b.a * Math.cos(b.b + b.c * e);
    }
  }), L.horner(e, ...a);
}
class XE {
  /**
   * VSOP87 representation of a Planet
   * @constructs Planet
   * @param {object} planet - planet data series
   * @example
   * ```js
   * // for use in browser
   * import {data} from 'astronomia'
   * const earth = new planetposition.Planet(data.vsop87Bearth)
   * ```
   */
  constructor(n) {
    if (typeof n != "object") throw new TypeError("need planet vsop87 data");
    this.name = n.name, this.type = n.type || "B", this.series = n;
  }
  /**
   * Position2000 returns ecliptic position of planets by full VSOP87 theory.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are for the dynamical equinox and ecliptic J2000.
   *  {Number} lon - heliocentric longitude in radians.
   *  {Number} lat - heliocentric latitude in radians.
   *  {Number} range - heliocentric range in AU.
   */
  position2000(n) {
    const t = L.J2000Century(n) * 0.1, r = L.pmod(ua(t, this.series.L), 2 * Math.PI), M = ua(t, this.series.B), b = ua(t, this.series.R);
    switch (this.type) {
      case "B":
        return new L.Coord(r, M, b);
      case "D": {
        const d = new H4.Ecliptic(r, M), c = L.JDEToJulianYear(n), A = V5.eclipticPosition(d, c, 2e3);
        return new L.Coord(A.lon, A.lat, b);
      }
    }
  }
  /**
   * Position returns ecliptic position of planets at equinox and ecliptic of date.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are positions consistent with those from Meeus's
   * Apendix III, that is, at equinox and ecliptic of date.
   *  {Number} lon - heliocentric longitude in radians.
   *  {Number} lat - heliocentric latitude in radians.
   *  {Number} range - heliocentric range in AU.
   */
  position(n) {
    const t = L.J2000Century(n) * 0.1, r = L.pmod(ua(t, this.series.L), 2 * Math.PI), M = ua(t, this.series.B), b = ua(t, this.series.R);
    switch (this.type) {
      case "B": {
        const d = new H4.Ecliptic(r, M), c = 2e3, O = L.JDEToJulianYear(n), A = V5.eclipticPosition(d, c, O);
        return new L.Coord(A.lon, A.lat, b);
      }
      case "D":
        return new L.Coord(r, M, b);
    }
  }
}
function PE(e, n, a) {
  const t = L.J2000Century(a), r = e - t1.angleFromDeg((1.397 + 31e-5 * t) * t), [M, b] = L.sincos(r), d = e + t1.angleFromSec(-0.09033 + 0.03916 * (b + M) * Math.tan(n)), c = n + t1.angleFromSec(0.03916 * (b - M));
  return new L.Coord(d, c);
}
const Ku = {
  Planet: XE,
  toFK5: PE
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solar
 */
function Ta(e) {
  const n = L.horner(e, 280.46646, 36000.76983, 3032e-7) * Math.PI / 180, a = Zu(e), t = (L.horner(e, 1.914602, -4817e-6, -14e-6) * Math.sin(a) + (0.019993 - 101e-6 * e) * Math.sin(2 * a) + 289e-6 * Math.sin(3 * a)) * Math.PI / 180, r = L.pmod(n + t, 2 * Math.PI), M = L.pmod(a + t, 2 * Math.PI);
  return { lon: r, ano: M };
}
function Zu(e) {
  return L.horner(e, 357.52911, 35999.05029, -1537e-7) * Math.PI / 180;
}
function Qu(e) {
  return L.horner(e, 0.016708634, -42037e-9, -1267e-10);
}
function kE(e) {
  const { lon: n, ano: a } = Ta(e), t = Qu(e);
  return 1.000001018 * (1 - t * t) / (1 + t * Math.cos(a));
}
function e9(e) {
  const n = n9(e), { lon: a, ano: t } = Ta(e);
  return a - 569e-5 * Math.PI / 180 - 478e-5 * Math.PI / 180 * Math.sin(n);
}
function n9(e) {
  return 125.04 * Math.PI / 180 - 1934.136 * Math.PI / 180 * e;
}
function IE(e) {
  let { lon: n, ano: a } = Ta(e);
  return n -= 0.01397 * Math.PI / 180 * e * 100, { lon: n, ano: a };
}
function xE(e) {
  const { lon: n, ano: a } = Ta(L.J2000Century(e)), t = Da.meanObliquity(e), [r, M] = L.sincos(n), [b, d] = L.sincos(t), c = Math.atan2(d * r, M), O = b * r;
  return new L.Coord(c, O);
}
function FE(e) {
  const n = L.J2000Century(e), a = e9(n), t = Da.meanObliquity(e), [r, M] = L.sincos(a), [b, d] = L.sincos(t + 256e-5 * Math.PI / 180 * Math.cos(n9(n))), c = Math.atan2(d * r, M), O = Math.asin(b * r);
  return new L.Coord(c, O);
}
function ts(e, n) {
  let { lon: a, lat: t, range: r } = e.position(n);
  const M = a + Math.PI, b = L.horner(
    L.J2000Century(n),
    M,
    -1.397 * Math.PI / 180,
    -31e-5 * Math.PI / 180
  ), [d, c] = L.sincos(b), O = 0.03916 / 3600 * Math.PI / 180 * (c - d);
  return a = L.pmod(M - 0.09033 / 3600 * Math.PI / 180, 2 * Math.PI), t = O - t, new L.Coord(a, t, r);
}
function HE(e, n) {
  let { lon: a, lat: t, range: r } = ts(e, n);
  const M = Da.nutation(n)[0], b = os(r);
  return a = a + M + b, new L.Coord(a, t, r);
}
function UE(e, n) {
  const { lon: a, lat: t, range: r } = ts(e, n), [M, b] = Da.nutation(n), d = os(r), c = a + M + d, O = Da.meanObliquity(n) + b, { ra: A, dec: m } = new H4.Ecliptic(c, t).toEquatorial(O);
  return new Du(A, m, r);
}
function os(e) {
  return -20.4898 / 3600 * Math.PI / 180 / e;
}
const a9 = {
  trueLongitude: Ta,
  true: Ta,
  // BACKWARDS-COMPATIBILITY
  meanAnomaly: Zu,
  eccentricity: Qu,
  radius: kE,
  apparentLongitude: e9,
  true2000: IE,
  trueEquatorial: xE,
  apparentEquatorial: FE,
  trueVSOP87: ts,
  apparentVSOP87: HE,
  apparentEquatorialVSOP87: UE,
  aberration: os
}, Wn = {
  historic: {
    table: [44, 43, 43, 41, 40, 39, 38, 37, 37, 36, 36, 36, 37, 37, 38, 37, 36, 36, 35, 35, 34, 33, 33, 32, 32, 31, 31, 30, 30, 29, 29, 29, 29, 29, 28, 28, 27, 27, 26, 26, 25, 25, 25, 26, 26, 26, 26, 25, 25, 25, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 23, 23, 23, 23, 22, 22, 22, 22, 22, 21, 21, 21, 21, 21, 21, 21, 21, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 20, 20, 20, 20, 20, 19, 19, 19, 19, 19, 20, 20, 20, 20, 19, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21.1, 21, 21, 21, 20.9, 20.8, 20.7, 20.6, 20.4, 20.2, 20, 19.7, 19.4, 19.1, 18.7, 18.3, 17.8, 17.4, 17, 16.8, 16.6, 16.4, 16.1, 15.9, 15.7, 15.5, 15.3, 15, 14.7, 14.5, 14.3, 14.2, 14.1, 14.1, 14.1, 13.9, 13.7, 13.6, 13.5, 13.5, 13.5, 13.5, 13.4, 13.4, 13.4, 13.4, 13.3, 13.3, 13.2, 13.2, 13.2, 13.1, 13.1, 13.1, 13, 13.2, 13.3, 13.4, 13.5, 13.6, 13.7, 13.8, 13.9, 14, 14, 14.1, 14.1, 14.1, 14.1, 14.2, 14.3, 14.4, 14.4, 14.5, 14.6, 14.6, 14.7, 14.7, 14.7, 14.8, 14.8, 14.9, 14.9, 15, 15, 15.1, 15.2, 15.3, 15.4, 15.5, 15.6, 15.6, 15.6, 15.8, 15.9, 15.9, 15.9, 15.8, 15.7, 15.8, 15.7, 15.7, 15.7, 15.8, 15.9, 16.1, 16.1, 16, 15.9, 15.9, 15.7, 15.4, 15.3, 15.4, 15.5, 15.6, 15.6, 15.6, 15.6, 15.6, 15.6, 15.6, 15.5, 15.5, 15.4, 15.3, 15.2, 15.1, 14.9, 14.8, 14.6, 14.4, 14.3, 14.2, 14.1, 14.2, 14.2, 13.9, 13.7, 13.5, 13.3, 13.1, 13, 13.2, 13.2, 13.1, 13.1, 13.2, 13.3, 13.5, 13.5, 13.4, 13.2, 13.2, 13.1, 13.1, 13, 12.8, 12.6, 12.7, 12.6, 12.3, 12, 11.9, 11.8, 11.6, 11.4, 11.2, 11.1, 11.1, 11.1, 11.1, 11.1, 11.2, 11.1, 11.1, 11.2, 11.4, 11.5, 11.3, 11.2, 11.4, 11.7, 11.9, 11.9, 11.9, 11.8, 11.7, 11.8, 11.8, 11.8, 11.7, 11.6, 11.6, 11.5, 11.5, 11.4, 11.4, 11.3, 11.3, 11.13, 11.16, 10.94, 10.72, 10.29, 10.04, 9.94, 9.91, 9.88, 9.86, 9.72, 9.67, 9.66, 9.64, 9.51, 9.4, 9.21, 9, 8.6, 8.29, 7.95, 7.73, 7.59, 7.49, 7.36, 7.26, 7.1, 7, 6.89, 6.82, 6.73, 6.64, 6.39, 6.28, 6.25, 6.27, 6.25, 6.27, 6.22, 6.24, 6.22, 6.27, 6.3, 6.36, 6.35, 6.37, 6.32, 6.33, 6.33, 6.37, 6.37, 6.41, 6.4, 6.44, 6.46, 6.51, 6.48, 6.51, 6.53, 6.58, 6.55, 6.61, 6.69, 6.8, 6.84, 6.94, 7.03, 7.13, 7.15, 7.22, 7.26, 7.3, 7.23, 7.22, 7.21, 7.2, 6.99, 6.98, 7.19, 7.36, 7.35, 7.39, 7.41, 7.45, 7.36, 7.18, 6.95, 6.72, 6.45, 6.24, 5.92, 5.59, 5.15, 4.67, 4.11, 3.52, 2.94, 2.47, 1.97, 1.52, 1.04, 0.6, 0.11, -0.34, -0.82, -1.25, -1.7, -2.08, -2.48, -2.82, -3.19, -3.5, -3.84, -4.14, -4.43, -4.59, -4.79, -4.92, -5.09, -5.24, -5.36, -5.34, -5.37, -5.32, -5.34, -5.33, -5.4, -5.47, -5.58, -5.66, -5.74, -5.68, -5.69, -5.65, -5.67, -5.68, -5.73, -5.72, -5.78, -5.79, -5.86, -5.89, -6.01, -6.13, -6.28, -6.41, -6.53, -6.49, -6.5, -6.45, -6.41, -6.26, -6.11, -5.9, -5.63, -5.13, -4.68, -4.19, -3.72, -3.21, -2.7, -2.09, -1.48, -0.75, -0.08, 0.62, 1.26, 1.95, 2.59, 3.28, 3.92, 4.61, 5.2, 5.73, 6.29, 7, 7.68, 8.45, 9.13, 9.78, 10.38, 10.99, 11.64, 12.47, 13.23, 14, 14.69, 15.38, 16, 16.64, 17.19, 17.72, 18.19, 18.67, 19.13, 19.69, 20.14, 20.54, 20.86, 21.14, 21.41, 21.78, 22.06, 22.3, 22.51, 22.79, 23.01, 23.29, 23.46, 23.55, 23.63, 23.8, 23.95, 24.25, 24.39, 24.42, 24.34, 24.22, 24.1, 24.08, 24.02, 24.04, 23.98, 23.91, 23.89, 23.95, 23.93, 23.92, 23.88, 23.94, 23.91, 23.82, 23.76, 23.87, 23.91, 23.95, 23.96, 24, 24.04, 24.2, 24.35, 24.61, 24.82, 25.09, 25.3, 25.56, 25.77, 26.05, 26.27, 26.54, 26.76, 27.04, 27.27, 27.55, 27.77, 28.03, 28.25, 28.5, 28.7, 28.95, 29.15, 29.38, 29.57, 29.8, 29.97, 30.19, 30.36, 30.57, 30.72, 30.93, 31.07, 31.24, 31.349, 31.516, 31.677, 31.923, 32.166, 32.449, 32.671, 32.919, 33.15, 33.397, 33.584, 33.804, 33.992, 34.24, 34.466, 34.731, 35.03, 35.4, 35.738, 36.147, 36.546, 36.995, 37.429, 37.879, 38.291, 38.753, 39.204, 39.707, 40.182, 40.706, 41.17, 41.686, 42.227, 42.825, 43.373, 43.959, 44.486, 44.997, 45.477, 45.983, 46.458, 46.997, 47.521, 48.034, 48.535, 49.099, 49.589, 50.102, 50.54, 50.975, 51.382, 51.81, 52.168, 52.572, 52.957, 53.434, 53.789, 54.087],
    first: 1657,
    last: 1984.5
  },
  data: {
    table: [43.4724372, 43.5648351, 43.6736863, 43.7782156, 43.8763273, 43.9562443, 44.0314956, 44.1131788, 44.1982187, 44.2951747, 44.3936471, 44.4840562, 44.5646335, 44.6425099, 44.7385767, 44.8370135, 44.9302138, 44.9986146, 45.0583549, 45.1283911, 45.2063835, 45.2980068, 45.3897017, 45.476138, 45.5632485, 45.6450189, 45.7374593, 45.8283721, 45.9132976, 45.9819705, 46.0407484, 46.1067084, 46.1825041, 46.2788561, 46.3713351, 46.4567207, 46.544486, 46.6310899, 46.7302231, 46.8283588, 46.9247443, 46.9969757, 47.0709148, 47.1450515, 47.2361542, 47.3413241, 47.4319364, 47.5213815, 47.6049313, 47.6837388, 47.7781381, 47.8770756, 47.9687104, 48.0348257, 48.0942021, 48.1608205, 48.2460028, 48.3438529, 48.4355405, 48.5344163, 48.6324506, 48.7293718, 48.8365414, 48.9353232, 49.0318781, 49.1013205, 49.1590844, 49.2285534, 49.3069683, 49.4017939, 49.4945263, 49.5861495, 49.6804907, 49.7602264, 49.8555805, 49.9489224, 50.0346777, 50.1018531, 50.1621723, 50.2260014, 50.2967905, 50.3831254, 50.4598772, 50.5387068, 50.6160484, 50.6865941, 50.7658362, 50.8453698, 50.918672, 50.9761148, 51.0278017, 51.084323, 51.1537928, 51.2318645, 51.306308, 51.3807849, 51.4526292, 51.5160394, 51.5985479, 51.680924, 51.7572854, 51.8133335, 51.8532385, 51.9014358, 51.9603433, 52.0328072, 52.0984957, 52.1667826, 52.2316418, 52.2938376, 52.3679897, 52.4465221, 52.5179552, 52.5751485, 52.6178012, 52.666816, 52.7340036, 52.8055792, 52.8792189, 52.9564838, 53.0444971, 53.126769, 53.2196749, 53.3024139, 53.3746645, 53.4335399, 53.4778015, 53.5299937, 53.5845392, 53.6522628, 53.7255844, 53.7882418, 53.8366625, 53.8829665, 53.9442904, 54.0042478, 54.0536342, 54.085644, 54.1084122, 54.1462942, 54.1913988, 54.2452023, 54.2957622, 54.3427024, 54.3910864, 54.4319877, 54.4897699, 54.545636, 54.597741, 54.6354962, 54.6532352, 54.677594, 54.7173643, 54.7740957, 54.8253023, 54.8712512, 54.916146, 54.9580535, 54.9997186, 55.047571, 55.0911778, 55.1132386, 55.132774, 55.1532423, 55.1898003, 55.2415531, 55.283803, 55.3222105, 55.3612676, 55.406262, 55.4628719, 55.5110909, 55.5523777, 55.5811877, 55.6004372, 55.626202, 55.6656271, 55.7167999, 55.7698097, 55.8196609, 55.8615028, 55.9129883, 55.9663474, 56.0220102, 56.0700015, 56.0939035, 56.110463, 56.1313736, 56.1610839, 56.2068432, 56.2582503, 56.3000349, 56.339902, 56.3789995, 56.4282839, 56.4803947, 56.5352164, 56.5697487, 56.5983102, 56.6328326, 56.6738814, 56.7332116, 56.7971596, 56.8552701, 56.9111378, 56.9754725, 57.0470772, 57.1136128, 57.173831, 57.2226068, 57.259731, 57.3072742, 57.3643368, 57.4334281, 57.5015747, 57.5653127, 57.6333396, 57.6972844, 57.7710774, 57.8407427, 57.9057801, 57.9575663, 57.9974929, 58.0425517, 58.1043319, 58.1679128, 58.2389092, 58.3091659, 58.3833021, 58.4536748, 58.5401438, 58.6227714, 58.6916662, 58.7409628, 58.7836189, 58.8405543, 58.898579, 58.9713678, 59.043837, 59.1218414, 59.2002687, 59.274737, 59.3574134, 59.4433827, 59.5242416, 59.5849787, 59.6343497, 59.6927827, 59.758805, 59.8386448, 59.9110567, 59.9844537, 60.056435, 60.123065, 60.2042185, 60.2803745, 60.3530352, 60.4011891, 60.4439959, 60.4900257, 60.5578054, 60.6324446, 60.7058569, 60.7853482, 60.8663504, 60.9386672, 61.0276757, 61.1103448, 61.1870458, 61.2453891, 61.2881024, 61.3377799, 61.4036165, 61.4760366, 61.5524599, 61.6286593, 61.6845819, 61.743306, 61.8132425, 61.8823203, 61.9496762, 61.9968743, 62.0342938, 62.0714108, 62.1202315, 62.1809508, 62.2382046, 62.2950486, 62.3506479, 62.3995381, 62.475395, 62.5463091, 62.6136031, 62.6570739, 62.6941742, 62.7383271, 62.7926305, 62.8566986, 62.9145607, 62.9658689, 63.0216632, 63.0807052, 63.1461718, 63.2052946, 63.2599441, 63.2844088, 63.2961369, 63.3126092, 63.3421622, 63.3871303, 63.4339302, 63.4673369, 63.4978642, 63.5319327, 63.5679441, 63.6104432, 63.6444291, 63.6641815, 63.6739403, 63.692603, 63.7147066, 63.7518055, 63.792717, 63.8285221, 63.8556871, 63.8803854, 63.9075025, 63.9392787, 63.9690744, 63.9798604, 63.9833077, 63.9938011, 64.0093384, 64.0399621, 64.0670429, 64.0907881, 64.1068077, 64.1282125, 64.1584211, 64.1832722, 64.2093975, 64.2116628, 64.2073173, 64.2115565, 64.2222858, 64.2499625, 64.2760973, 64.2998037, 64.3191858, 64.345013, 64.3734584, 64.3943291, 64.4151156, 64.4132064, 64.4118464, 64.4096536, 64.4167832, 64.43292, 64.4510529, 64.4734276, 64.4893377, 64.5053342, 64.5269189, 64.5470942, 64.5596729, 64.5512293, 64.5370906, 64.5359472, 64.5414947, 64.5543634, 64.5654298, 64.5736111, 64.5891142, 64.6014759, 64.6176147, 64.6374397, 64.6548674, 64.6530021, 64.6379271, 64.637161, 64.6399614, 64.6543152, 64.6723164, 64.6876311, 64.7051905, 64.7313433, 64.7575312, 64.7811143, 64.8000929, 64.7994561, 64.7876424, 64.783095, 64.7920604, 64.8096421, 64.8310888, 64.8451826, 64.8597013, 64.8849929, 64.9174991, 64.9480298, 64.9793881, 64.9894772, 65.0028155, 65.0138193, 65.0371432, 65.0772597, 65.112197, 65.1464034, 65.1832638, 65.2145358, 65.2493713, 65.2920645, 65.3279403, 65.3413366, 65.3451881, 65.34964, 65.3711307, 65.3971998, 65.4295547, 65.4573487, 65.486752, 65.5152012, 65.5449916, 65.5780768, 65.612728, 65.6287505, 65.6370091, 65.6493375, 65.6759928, 65.7096966, 65.746092, 65.7768362, 65.8024614, 65.8236695, 65.8595036, 65.8973008, 65.932291, 65.950911, 65.9534105, 65.962833, 65.9838647, 66.0146733, 66.042049, 66.0699217, 66.0961343, 66.1310116, 66.1682713, 66.2071627, 66.2355846, 66.2408549, 66.2335423, 66.2349107, 66.2441095, 66.2751123, 66.3054334, 66.3245568, 66.3405713, 66.3624433, 66.3957101, 66.428903, 66.4618675, 66.4748837, 66.4751281, 66.4828678, 66.5056165, 66.5382912, 66.5705628, 66.6030198, 66.6339689, 66.6569117, 66.6925011, 66.7288729, 66.7578719, 66.7707625, 66.7740427, 66.7846288, 66.810324, 66.840048, 66.8778601, 66.9069091, 66.944259, 66.9762508, 67.0258126, 67.0716286, 67.1100184, 67.1266401, 67.1331391, 67.145797, 67.17174, 67.2091069, 67.2459812, 67.2810383, 67.3136452, 67.3456968, 67.389003, 67.4318433, 67.4666209, 67.4858459, 67.4989147, 67.5110936, 67.5352658, 67.571103, 67.6070253, 67.6439167, 67.6765272, 67.7116693, 67.7590634, 67.8011542, 67.840213, 67.8606318, 67.8821576, 67.9120101, 67.9546462, 68.0054839, 68.051412, 68.1024205, 68.1577127, 68.2043653, 68.2664507, 68.3188171, 68.3703564, 68.3964356, 68.4094472, 68.4304611, 68.4629791, 68.507818, 68.5537018, 68.5927179, 68.6298107, 68.6670627, 68.7135208, 68.7622755, 68.8032843, 68.8244838, 68.8373427, 68.847693, 68.8688567, 68.9005814, 68.9354999, 68.9676423, 68.9875354, 69.0175527, 69.0499081, 69.0823433, 69.1070034, 69.1134027, 69.1141898, 69.1207203, 69.1355578, 69.16459, 69.1964228, 69.2201632, 69.2451564, 69.2732758, 69.3031979, 69.3325675, 69.3540507, 69.3581722, 69.3441594, 69.3376329, 69.3377424, 69.3432191, 69.3540144, 69.3611554, 69.3751703, 69.3889904, 69.4091639, 69.4264662, 69.4386335, 69.4241335, 69.3921241, 69.3693422, 69.3574782, 69.3593242, 69.3630244, 69.359334, 69.3510133, 69.3537917, 69.3582217, 69.367306, 69.3678649, 69.3514228, 69.3273414, 69.3033273, 69.2892463, 69.2880419, 69.2908014, 69.2944974, 69.2913953, 69.286149, 69.2835153, 69.2815422, 69.2806375, 69.2553511, 69.2125426, 69.1847287, 69.17207, 69.1691531, 69.173303, 69.1698064, 69.1589095, 69.1556275, 69.1672253, 69.1771384],
    first: 1973.0849315068492,
    firstYM: [1973, 2],
    last: 2023.3287671232877,
    lastYM: [2023, 5]
  },
  prediction: {
    table: [67.87818, 67.96817999999999, 68.02817999999999, 68.04818, 68.12818, 68.21817999999999, 68.26818, 68.28818, 68.36818, 68.44818, 68.50818, 68.51818, 68.59818, 68.68818, 68.73818, 68.74817999999999, 68.82818, 68.91817999999999, 68.96817999999999, 68.98818, 69.06818, 69.14818, 69.20818, 69.22818, 69.30818, 69.39818, 69.46817999999999, 69.48818, 69.57818, 69.66817999999999, 69.73818, 69.75818, 69.85817999999999, 69.95818, 70.02817999999999, 70.05818, 70.15818, 70.25818, 70.33818, 70.36818, 70.46817999999999],
    first: 2022,
    last: 2032
  }
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module deltat
 */
function jE(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function GE(e) {
  let n;
  if (e < -500)
    n = L.horner((e - 1820) * 0.01, -20, 0, 32);
  else if (e < 500)
    n = L.horner(
      e * 0.01,
      10583.6,
      -1014.41,
      33.78311,
      -5.952053,
      -0.1798452,
      0.022174192,
      0.0090316521
    );
  else if (e < 1600)
    n = L.horner(
      (e - 1e3) * 0.01,
      1574.2,
      -556.01,
      71.23472,
      0.319781,
      -0.8503463,
      -5050998e-9,
      0.0083572073
    );
  else if (e < Wn.historic.first)
    n = L.horner(e - 1600, 120, -0.9808, -0.01532, 1 / 7129);
  else if (e < Wn.data.first)
    n = Y5(e, Wn.historic);
  else if (e < Wn.data.last - 0.25)
    n = VE(e, Wn.data);
  else if (e < Wn.prediction.last)
    n = Y5(e, Wn.prediction);
  else if (e < 2050)
    n = L.horner((e - 2e3) / 100, 62.92, 32.217, 55.89);
  else if (e < 2150)
    n = L.horner((e - 1820) / 100, -205.72, 56.28, 32);
  else {
    const a = (e - 1820) / 100;
    n = -20 + 32 * a * a;
  }
  return n;
}
function Y5(e, n) {
  return Xu.len3ForInterpolateX(
    e,
    n.first,
    n.last,
    n.table
  ).interpolateX(e);
}
function VE(e, n) {
  const [a, t] = n.firstYM, { year: r, month: M, first: b, last: d } = rs(e), c = 12 * (r - a) + (M - t), O = n.table.slice(c, c + 3);
  return new Xu.Len3(b, d, O).interpolateX(e);
}
function rs(e) {
  const n = e | 0, a = e - n, t = jE(n) ? 1 : 0, r = rs.data[t];
  let M = 12;
  for (; M > 0 && r[M] > a; )
    M--;
  const b = n + r[M], d = M < 11 ? n + r[M + 2] : n + 1 + r[(M + 2) % 12];
  return { year: n, month: M, first: b, last: d };
}
rs.data = [
  [
    // non leap year
    0,
    0,
    0.08493150684921602,
    0.16164383561635987,
    0.24657534246580326,
    0.3287671232876619,
    0.4136986301368779,
    0.4958904109589639,
    0.5808219178081799,
    0.6657534246576233,
    0.747945205479482,
    0.832876712328698,
    0.915068493150784
  ],
  [
    // leap year
    0,
    0,
    0.08743169398917416,
    0.1639344262296163,
    0.24863387978143692,
    0.3306010928961314,
    0.4153005464481794,
    0.49726775956287383,
    0.5819672131146945,
    0.6666666666667425,
    0.7486338797814369,
    0.8333333333332575,
    0.9153005464481794
  ]
];
const VM = {
  deltaT: GE
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonphase
 */
const { sin: a0, cos: ct } = Math, Z2 = 1 / 1236.85, M0 = Math.PI / 180, YE = 29.530588861;
function Mn(e) {
  return L.horner(
    e,
    245155009766e-5,
    29.530588861 / Z2,
    15437e-8,
    -15e-8,
    73e-11
  );
}
function Kt(e, n) {
  const a = (e - 2e3) * 12.3685;
  return Math.floor(a - n + 0.5) + n;
}
function JE(e) {
  return Mn(Kt(e, 0) * Z2);
}
function KE(e) {
  return Mn(Kt(e, 0.25) * Z2);
}
function ZE(e) {
  return Mn(Kt(e, 0.5) * Z2);
}
function QE(e) {
  return Mn(Kt(e, 0.75) * Z2);
}
function J5(e) {
  const n = new Sr(e, 0);
  return Mn(n.T) + n.nfc(tX) + n.a();
}
function eX(e) {
  const n = new Sr(e, 0.25);
  return Mn(n.T) + n.flc() + n.w() + n.a();
}
function nX(e) {
  const n = new Sr(e, 0.5);
  return Mn(n.T) + n.nfc(oX) + n.a();
}
function aX(e) {
  const n = new Sr(e, 0.75);
  return Mn(n.T) + n.flc() - n.w() + n.a();
}
class Sr {
  constructor(n, a) {
    this.A = new Array(14);
    const t = this.k = Kt(n, a), r = this.T = this.k * Z2;
    this.E = L.horner(r, 1, -2516e-6, -74e-7), this.M = L.horner(
      r,
      2.5534 * M0,
      29.1053567 * M0 / Z2,
      -14e-7 * M0,
      -11e-8 * M0
    ), this.M_ = L.horner(
      r,
      201.5643 * M0,
      385.81693528 * M0 / Z2,
      0.0107582 * M0,
      1238e-8 * M0,
      -58e-9 * M0
    ), this.F = L.horner(
      r,
      160.7108 * M0,
      390.67050284 * M0 / Z2,
      -16118e-7 * M0,
      -227e-8 * M0,
      11e-9 * M0
    ), this.Ω = L.horner(
      r,
      124.7746 * M0,
      -1.56375588 * M0 / Z2,
      20672e-7 * M0,
      215e-8 * M0
    ), this.A[0] = 299.7 * M0 + 0.107408 * M0 * t - 9173e-6 * r * r, this.A[1] = 251.88 * M0 + 0.016321 * M0 * t, this.A[2] = 251.83 * M0 + 26.651886 * M0 * t, this.A[3] = 349.42 * M0 + 36.412478 * M0 * t, this.A[4] = 84.66 * M0 + 18.206239 * M0 * t, this.A[5] = 141.74 * M0 + 53.303771 * M0 * t, this.A[6] = 207.17 * M0 + 2.453732 * M0 * t, this.A[7] = 154.84 * M0 + 7.30686 * M0 * t, this.A[8] = 34.52 * M0 + 27.261239 * M0 * t, this.A[9] = 207.19 * M0 + 0.121824 * M0 * t, this.A[10] = 291.34 * M0 + 1.844379 * M0 * t, this.A[11] = 161.72 * M0 + 24.198154 * M0 * t, this.A[12] = 239.56 * M0 + 25.513099 * M0 * t, this.A[13] = 331.55 * M0 + 3.592518 * M0 * t;
  }
  // new or full corrections
  nfc(n) {
    const { M: a, M_: t, E: r, F: M, Ω: b } = this;
    return n[0] * a0(t) + n[1] * a0(a) * r + n[2] * a0(2 * t) + n[3] * a0(2 * M) + n[4] * a0(t - a) * r + n[5] * a0(t + a) * r + n[6] * a0(2 * a) * r * r + n[7] * a0(t - 2 * M) + n[8] * a0(t + 2 * M) + n[9] * a0(2 * t + a) * r + n[10] * a0(3 * t) + n[11] * a0(a + 2 * M) * r + n[12] * a0(a - 2 * M) * r + n[13] * a0(2 * t - a) * r + n[14] * a0(b) + n[15] * a0(t + 2 * a) + n[16] * a0(2 * (t - M)) + n[17] * a0(3 * a) + n[18] * a0(t + a - 2 * M) + n[19] * a0(2 * (t + M)) + n[20] * a0(t + a + 2 * M) + n[21] * a0(t - a + 2 * M) + n[22] * a0(t - a - 2 * M) + n[23] * a0(3 * t + a) + n[24] * a0(4 * t);
  }
  // first or last corrections
  flc() {
    const { M: n, M_: a, E: t, F: r, Ω: M } = this;
    return -0.62801 * a0(a) + 0.17172 * a0(n) * t + -0.01183 * a0(a + n) * t + 862e-5 * a0(2 * a) + 804e-5 * a0(2 * r) + 454e-5 * a0(a - n) * t + 204e-5 * a0(2 * n) * t * t + -18e-4 * a0(a - 2 * r) + -7e-4 * a0(a + 2 * r) + -4e-4 * a0(3 * a) + -34e-5 * a0(2 * a - n) * t + 32e-5 * a0(n + 2 * r) * t + 32e-5 * a0(n - 2 * r) * t + -28e-5 * a0(a + 2 * n) * t * t + 27e-5 * a0(2 * a + n) * t + -17e-5 * a0(M) + -5e-5 * a0(a - n - 2 * r) + 4e-5 * a0(2 * a + 2 * r) + -4e-5 * a0(a + n + 2 * r) + 4e-5 * a0(a - 2 * n) + 3e-5 * a0(a + n - 2 * r) + 3e-5 * a0(3 * n) + 2e-5 * a0(2 * a - 2 * r) + 2e-5 * a0(a - n + 2 * r) + -2e-5 * a0(3 * a + n);
  }
  w() {
    const { M: n, M_: a, E: t, F: r } = this;
    return 306e-5 - 38e-5 * t * ct(n) + 26e-5 * ct(a) - 2e-5 * (ct(a - n) - ct(a + n) - ct(2 * r));
  }
  // additional corrections
  a() {
    let n = 0;
    return rX.forEach((a, t) => {
      n += a * a0(this.A[t]);
    }), n;
  }
}
const tX = [
  -0.4072,
  0.17241,
  0.01608,
  0.01039,
  739e-5,
  -514e-5,
  208e-5,
  -111e-5,
  -57e-5,
  56e-5,
  -42e-5,
  42e-5,
  38e-5,
  -24e-5,
  -17e-5,
  -7e-5,
  4e-5,
  4e-5,
  3e-5,
  3e-5,
  -3e-5,
  3e-5,
  -2e-5,
  -2e-5,
  2e-5
], oX = [
  -0.40614,
  0.17302,
  0.01614,
  0.01043,
  734e-5,
  -515e-5,
  209e-5,
  -111e-5,
  -57e-5,
  56e-5,
  -42e-5,
  42e-5,
  38e-5,
  -24e-5,
  -17e-5,
  -7e-5,
  4e-5,
  4e-5,
  3e-5,
  3e-5,
  -3e-5,
  3e-5,
  -2e-5,
  -2e-5,
  2e-5
], rX = [
  325e-6,
  165e-6,
  164e-6,
  126e-6,
  11e-5,
  62e-6,
  6e-5,
  56e-6,
  47e-6,
  42e-6,
  4e-5,
  37e-6,
  35e-6,
  23e-6
], je = {
  meanLunarMonth: YE,
  meanNew: JE,
  meanFirst: KE,
  meanFull: ZE,
  meanLast: QE,
  newMoon: J5,
  new: J5,
  // BACKWARDS-COMPATIBILITY
  first: eX,
  full: nX,
  last: aX
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module julian
 */
const We = Math.trunc, t9 = 22991605e-1, wt = [0, 0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], iX = 86400;
class is {
  /**
   * @param {number|Date} [year] - If `Date` is given then year, month, day is taken from that. Shortcut to `new Calendar().fromDate(date)`
   * @param {number} [month]
   * @param {number} [day]
   */
  constructor(n, a = 1, t = 1) {
    n instanceof Date ? this.fromDate(n) : (this.year = n, this.month = a, this.day = t);
  }
  getDate() {
    return {
      year: this.year,
      month: this.month,
      day: Math.floor(this.day)
    };
  }
  getTime() {
    const n = new t1.Time(this.day * iX), [a, t, r, M] = n.toHMS();
    let [b, d] = L.modf(M);
    return d = Math.trunc(d * 1e3), {
      hour: t % 24,
      minute: r,
      second: b,
      millisecond: d
    };
  }
  toISOString() {
    const { year: n, month: a, day: t } = this.getDate(), { hour: r, minute: M, second: b, millisecond: d } = this.getTime();
    return `${gn(n, 4)}-${gn(a)}-${gn(t)}T${gn(r)}:${gn(M)}:${gn(b)}.${gn(d, 3)}Z`;
  }
  isGregorian() {
    return s9(this.year, this.month, this.day);
  }
  /**
   * Note: Take care for dates < GREGORIAN0JD as `date` is always within the
   * proleptic Gregorian Calender
   * @param {Date} date - proleptic Gregorian date
   */
  fromDate(n) {
    this.year = n.getUTCFullYear(), this.month = n.getUTCMonth() + 1;
    const a = n.getUTCDate(), t = n.getUTCHours(), r = n.getUTCMinutes(), M = n.getUTCSeconds(), b = n.getMilliseconds();
    return this.day = a + (t + (r + (M + b / 1e3) / 60) / 60) / 24, this;
  }
  /**
   * Note: Take care for dates < GREGORIAN0JD as `date` is always within the
   * proleptic Gregorian Calender
   * @returns {Date} proleptic Gregorian date
   */
  toDate() {
    const [n, a] = L.modf(this.day), [t, r] = L.modf(a * 24), [M, b] = L.modf(r * 60), [d, c] = L.modf(b * 60), O = new Date(Date.UTC(
      this.year,
      this.month - 1,
      n,
      t,
      M,
      d,
      Math.round(c * 1e3)
    ));
    return O.setUTCFullYear(this.year), O;
  }
  /**
   * converts a calendar date to decimal year
   * @returns {number} decimal year
   */
  toYear() {
    const [n, a] = L.modf(this.day), t = this.dayOfYear() - 1 + a, r = this.isLeapYear() ? 366 : 365;
    return this.year + t / r;
  }
  /**
   * converts a decimal year to a calendar date
   * @param {number} year - decimal year
   */
  fromYear(n) {
    const [a, t] = L.modf(n);
    this.year = a;
    const r = this.isLeapYear() ? 366 : 365, M = L.round(t * r, 5);
    let b = 12;
    for (; b > 0 && wt[b] > M; )
      b--;
    return this.month = b, this.day = 1 + M - wt[this.month], this;
  }
  isLeapYear() {
    return this.isGregorian() ? Qt(this.year) : Zt(this.year);
  }
  toJD() {
    return Br(this.year, this.month, this.day, !this.isGregorian());
  }
  fromJD(n) {
    const a = !b9(n), { year: t, month: r, day: M } = wr(n, a);
    return this.year = t, this.month = r, this.day = M, this;
  }
  fromJDE(n) {
    this.fromJD(n);
    const a = VM.deltaT(this.toYear());
    return this.day -= a / 86400, this;
  }
  toJDE() {
    const n = VM.deltaT(this.toYear());
    return this.day += n / 86400, this.toJD();
  }
  /**
   * set date to midnight UTC
   */
  midnight() {
    return this.day = Math.floor(this.day), this;
  }
  /**
   * set date to noon UTC
   */
  noon() {
    return this.day = Math.floor(this.day) + 0.5, this;
  }
  /**
   * @param {Boolean} td - if `true` calendar instance is in TD; date gets converted to UT
   *   true  - `UT = TD - ΔT`
   *   false - `TD = UT + ΔT`
   */
  deltaT(n) {
    const a = VM.deltaT(this.toYear());
    return n ? this.day -= a / 86400 : this.day += a / 86400, this;
  }
  dayOfWeek() {
    return d9(this.toJD());
  }
  dayOfYear() {
    return this.isGregorian() ? bs(this.year, this.month, this.day) : ss(this.year, this.month, this.day);
  }
}
class Ms extends is {
  toJD() {
    return r9(this.year, this.month, this.day);
  }
  fromJD(n) {
    const { year: a, month: t, day: r } = M9(n);
    return this.year = a, this.month = t, this.day = r, this;
  }
  isLeapYear() {
    return Zt(this.year);
  }
  dayOfYear() {
    return ss(this.year, this.month, this.day);
  }
  /**
   * toGregorian converts a Julian calendar date to a year, month, and day
   * in the Gregorian calendar.
   * @returns {CalendarGregorian}
   */
  toGregorian() {
    const n = this.toJD();
    return new xn().fromJD(n);
  }
}
class xn extends is {
  toJD() {
    return o9(this.year, this.month, this.day);
  }
  fromJD(n) {
    const { year: a, month: t, day: r } = i9(n);
    return this.year = a, this.month = t, this.day = r, this;
  }
  isLeapYear() {
    return Qt(this.year);
  }
  dayOfYear() {
    return bs(this.year, this.month, this.day);
  }
  /*
  * toJulian converts a Gregorian calendar date to a year, month, and day
  * in the Julian calendar.
  * @returns {CalendarJulian}
  */
  toJulian() {
    const n = this.toJD();
    return new Ms().fromJD(n);
  }
}
function Br(e, n, a, t) {
  let r = 0;
  if (n < 3 && (e--, n += 12), !t) {
    const b = L.floorDiv(e, 100);
    r = 2 - b + L.floorDiv(b, 4);
  }
  return L.floorDiv(36525 * We(e + 4716), 100) + (L.floorDiv(306 * (n + 1), 10) + r) + a - 1524.5;
}
function o9(e, n, a) {
  return Br(e, n, a, !1);
}
function r9(e, n, a) {
  return Br(e, n, a, !0);
}
function Zt(e) {
  return e % 4 === 0;
}
function Qt(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function wr(e, n) {
  const [a, t] = L.modf(e + 0.5);
  let r = a;
  if (!n) {
    const q = L.floorDiv(a * 100 - 186721625, 3652425);
    r = a + 1 + q - L.floorDiv(q, 4);
  }
  const M = r + 1524, b = L.floorDiv(M * 100 - 12210, 36525), d = L.floorDiv(36525 * b, 100), c = We(L.floorDiv((M - d) * 1e4, 306001));
  let O, A;
  const m = We(M - d) - L.floorDiv(306001 * c, 1e4) + t;
  return c === 14 || c === 15 ? A = c - 13 : A = c - 1, A < 3 ? O = We(b) - 4715 : O = We(b) - 4716, { year: O, month: A, day: m };
}
function i9(e) {
  return wr(e, !1);
}
function M9(e) {
  return wr(e, !0);
}
function b9(e) {
  return e >= t9;
}
function s9(e, n = 1, a = 1) {
  return e > 1582 || e === 1582 && n > 10 || e === 1582 && n === 10 && a >= 15;
}
function MX(e) {
  return new xn().fromJD(e).toDate();
}
function bX(e) {
  return new xn().fromDate(e).toJD();
}
function sX(e) {
  return new xn().fromJDE(e).toDate();
}
function dX(e) {
  return new xn().fromDate(e).toJDE();
}
function pX(e) {
  return e + L.JMod;
}
function cX(e) {
  return e - L.JMod;
}
function d9(e) {
  return We(e + 1.5) % 7;
}
function bs(e, n, a) {
  return ds(e, n, We(a), Qt(e));
}
function ss(e, n, a) {
  return ds(e, n, We(a), Zt(e));
}
function ds(e, n, a, t) {
  let r = 0;
  return t && n > 1 && (r = 1), r + wt[n] + We(a);
}
function ps(e, n) {
  let a, t = 0;
  for (n && (t = 1), a = 1; a <= 12; a++)
    if (t + wt[a] > e) {
      a = a - 1;
      break;
    }
  const r = e - t - wt[a];
  return { month: a, day: r };
}
function zX(e, n) {
  const { month: a, day: t } = ps(n, Qt(e));
  return new xn(e, a, t);
}
function OX(e, n) {
  const { month: a, day: t } = ps(n, Zt(e));
  return new Ms(e, a, t);
}
function gn(e, n) {
  n = n || 2;
  const a = e < 0 ? "-" : "";
  e = Math.abs(e);
  const t = "0000" + e;
  return a + t.substr(t.length - n, n);
}
const T2 = {
  GREGORIAN0JD: t9,
  Calendar: is,
  CalendarJulian: Ms,
  CalendarGregorian: xn,
  CalendarToJD: Br,
  CalendarGregorianToJD: o9,
  CalendarJulianToJD: r9,
  LeapYearJulian: Zt,
  LeapYearGregorian: Qt,
  JDToCalendar: wr,
  JDToCalendarGregorian: i9,
  JDToCalendarJulian: M9,
  isJDCalendarGregorian: b9,
  isCalendarGregorian: s9,
  JDToDate: MX,
  DateToJD: bX,
  JDEToDate: sX,
  DateToJDE: dX,
  MJDToJD: pX,
  JDToMJD: cX,
  DayOfWeek: d9,
  DayOfYearGregorian: bs,
  DayOfYearJulian: ss,
  DayOfYear: ds,
  DayOfYearToCalendar: ps,
  DayOfYearToCalendarGregorian: zX,
  DayOfYearToCalendarJulian: OX
};
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonposition
 */
(function() {
  return [
    [0, 0, 1, 0, 6288774, -20905355],
    [2, 0, -1, 0, 1274027, -3699111],
    [2, 0, 0, 0, 658314, -2955968],
    [0, 0, 2, 0, 213618, -569925],
    [0, 1, 0, 0, -185116, 48888],
    [0, 0, 0, 2, -114332, -3149],
    [2, 0, -2, 0, 58793, 246158],
    [2, -1, -1, 0, 57066, -152138],
    [2, 0, 1, 0, 53322, -170733],
    [2, -1, 0, 0, 45758, -204586],
    [0, 1, -1, 0, -40923, -129620],
    [1, 0, 0, 0, -34720, 108743],
    [0, 1, 1, 0, -30383, 104755],
    [2, 0, 0, -2, 15327, 10321],
    [0, 0, 1, 2, -12528, 0],
    [0, 0, 1, -2, 10980, 79661],
    [4, 0, -1, 0, 10675, -34782],
    [0, 0, 3, 0, 10034, -23210],
    [4, 0, -2, 0, 8548, -21636],
    [2, 1, -1, 0, -7888, 24208],
    [2, 1, 0, 0, -6766, 30824],
    [1, 0, -1, 0, -5163, -8379],
    [1, 1, 0, 0, 4987, -16675],
    [2, -1, 1, 0, 4036, -12831],
    [2, 0, 2, 0, 3994, -10445],
    [4, 0, 0, 0, 3861, -11650],
    [2, 0, -3, 0, 3665, 14403],
    [0, 1, -2, 0, -2689, -7003],
    [2, 0, -1, 2, -2602, 0],
    [2, -1, -2, 0, 2390, 10056],
    [1, 0, 1, 0, -2348, 6322],
    [2, -2, 0, 0, 2236, -9884],
    [0, 1, 2, 0, -2120, 5751],
    [0, 2, 0, 0, -2069, 0],
    [2, -2, -1, 0, 2048, -4950],
    [2, 0, 1, -2, -1773, 4130],
    [2, 0, 0, 2, -1595, 0],
    [4, -1, -1, 0, 1215, -3958],
    [0, 0, 2, 2, -1110, 0],
    [3, 0, -1, 0, -892, 3258],
    [2, 1, 1, 0, -810, 2616],
    [4, -1, -2, 0, 759, -1897],
    [0, 2, -1, 0, -713, -2117],
    [2, 2, -1, 0, -700, 2354],
    [2, 1, -2, 0, 691, 0],
    [2, -1, 0, -2, 596, 0],
    [4, 0, 1, 0, 549, -1423],
    [0, 0, 4, 0, 537, -1117],
    [4, -1, 0, 0, 520, -1571],
    [1, 0, -2, 0, -487, -1739],
    [2, 1, 0, -2, -399, 0],
    [0, 0, 2, -2, -381, -4421],
    [1, 1, 1, 0, 351, 0],
    [3, 0, -2, 0, -340, 0],
    [4, 0, -3, 0, 330, 0],
    [2, -1, 2, 0, 327, 0],
    [0, 2, 1, 0, -323, 1165],
    [1, 1, -1, 0, 299, 0],
    [2, 0, 3, 0, 294, 0],
    [2, 0, -1, -2, 0, 8752]
  ].map((n) => {
    const a = {};
    return ["d", "m", "m_", "f", "Σl", "Σr"].forEach((r, M) => {
      a[r] = n[M];
    }), a;
  });
})();
(function() {
  return [
    [0, 0, 0, 1, 5128122],
    [0, 0, 1, 1, 280602],
    [0, 0, 1, -1, 277693],
    [2, 0, 0, -1, 173237],
    [2, 0, -1, 1, 55413],
    [2, 0, -1, -1, 46271],
    [2, 0, 0, 1, 32573],
    [0, 0, 2, 1, 17198],
    [2, 0, 1, -1, 9266],
    [0, 0, 2, -1, 8822],
    [2, -1, 0, -1, 8216],
    [2, 0, -2, -1, 4324],
    [2, 0, 1, 1, 4200],
    [2, 1, 0, -1, -3359],
    [2, -1, -1, 1, 2463],
    [2, -1, 0, 1, 2211],
    [2, -1, -1, -1, 2065],
    [0, 1, -1, -1, -1870],
    [4, 0, -1, -1, 1828],
    [0, 1, 0, 1, -1794],
    [0, 0, 0, 3, -1749],
    [0, 1, -1, 1, -1565],
    [1, 0, 0, 1, -1491],
    [0, 1, 1, 1, -1475],
    [0, 1, 1, -1, -1410],
    [0, 1, 0, -1, -1344],
    [1, 0, 0, -1, -1335],
    [0, 0, 3, 1, 1107],
    [4, 0, 0, -1, 1021],
    [4, 0, -1, 1, 833],
    [0, 0, 1, -3, 777],
    [4, 0, -2, 1, 671],
    [2, 0, 0, -3, 607],
    [2, 0, 2, -1, 596],
    [2, -1, 1, -1, 491],
    [2, 0, -2, 1, -451],
    [0, 0, 3, -1, 439],
    [2, 0, 2, 1, 422],
    [2, 0, -3, -1, 421],
    [2, 1, -1, 1, -366],
    [2, 1, 0, 1, -351],
    [4, 0, 0, 1, 331],
    [2, -1, 1, 1, 315],
    [2, -2, 0, -1, 302],
    [0, 0, 1, 3, -283],
    [2, 1, 1, -1, -229],
    [1, 1, 0, -1, 223],
    [1, 1, 0, 1, 223],
    [0, 1, -2, -1, -220],
    [2, 1, -1, -1, -220],
    [1, 0, 1, 1, -185],
    [2, -1, -2, -1, 181],
    [0, 1, 2, 1, -177],
    [4, 0, -2, -1, 176],
    [4, -1, -1, -1, 166],
    [1, 0, 1, -1, -164],
    [4, 0, 1, -1, 132],
    [1, 0, -1, -1, -119],
    [4, -1, 0, -1, 115],
    [2, -2, 0, 1, 107]
  ].map((n) => {
    const a = {};
    return ["d", "m", "m_", "f", "Σb"].forEach((r, M) => {
      a[r] = n[M];
    }), a;
  });
})();
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module refraction
 */
new t1.Angle(!1, 0, 0, 58.294).rad();
new t1.Angle(!1, 0, 0, 0.0668).rad();
new t1.Angle(!1, 0, 0, 58.276).rad();
new t1.Angle(!1, 0, 0, 0.0824).rad();
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module rise
 */
L.errorCode("always above horizon", -1);
L.errorCode("always below horizon", 1);
const uX = new t1.Angle(!1, 0, 34, 0).rad();
-uX, new t1.Angle(!0, 0, 50, 0).rad(), t1.angleFromDeg(0.7275), t1.angleFromDeg(0.125);
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solstice
 */
const { abs: AX, cos: YM, sin: lX } = Math, JM = Math.PI / 180, p9 = [172113929189e-5, 365242.1374, 0.06134, 111e-5, -71e-5], c9 = [172123325401e-5, 365241.72562, -0.05323, 907e-5, 25e-5], z9 = [172132570455e-5, 365242.49558, -0.11677, -297e-5, 74e-5], O9 = [172141439987e-5, 365242.88257, -769e-5, -933e-5, -6e-5], u9 = [245162380984e-5, 365242.37404, 0.05169, -411e-5, -57e-5], A9 = [245171656767e-5, 365241.62603, 325e-5, 888e-5, -3e-4], l9 = [245181021715e-5, 365242.01767, -0.11575, 337e-5, 78e-5], f9 = [245190005952e-5, 365242.74049, -0.06223, -823e-5, 32e-5], K5 = function() {
  return [
    [485, 324.96, 1934.136],
    [203, 337.23, 32964.467],
    [199, 342.08, 20.186],
    [182, 27.85, 445267.112],
    [156, 73.14, 45036.886],
    [136, 171.52, 22518.443],
    [77, 222.54, 65928.934],
    [74, 296.72, 3034.906],
    [70, 243.58, 9037.513],
    [58, 119.81, 33718.147],
    [52, 297.17, 150.678],
    [50, 21.02, 2281.226],
    [45, 247.54, 29929.562],
    [44, 325.15, 31555.956],
    [29, 60.93, 4443.417],
    [18, 155.12, 67555.328],
    [17, 288.79, 4562.452],
    [16, 198.04, 62894.029],
    [14, 199.76, 31436.921],
    [12, 95.39, 14577.848],
    [12, 287.11, 31931.756],
    [12, 320.81, 34777.259],
    [9, 227.73, 1222.114],
    [8, 15.45, 16859.074]
  ].map((n) => ({
    a: n[0],
    b: n[1],
    c: n[2]
  }));
}();
function fX(e) {
  return e < 1e3 ? tn(e, p9) : tn(e - 2e3, u9);
}
function mX(e) {
  return e < 1e3 ? tn(e, c9) : tn(e - 2e3, A9);
}
function qX(e) {
  return e < 1e3 ? tn(e, z9) : tn(e - 2e3, l9);
}
function hX(e) {
  return e < 1e3 ? tn(e, O9) : tn(e - 2e3, f9);
}
function tn(e, n) {
  const a = L.horner(e * 1e-3, n), t = L.J2000Century(a), r = 35999.373 * JM * t - 2.47 * JM, M = 1 + 0.0334 * YM(r) + 7e-4 * YM(2 * r);
  let b = 0;
  for (let d = K5.length - 1; d >= 0; d--) {
    const c = K5[d];
    b += c.a * YM((c.b + c.c * t) * JM);
  }
  return a + 1e-5 * b / M;
}
function yX(e, n) {
  return e3(e, n, 0);
}
function WX(e, n) {
  return e3(e, n, Math.PI / 2);
}
function gX(e, n) {
  return e3(e, n, Math.PI);
}
function RX(e, n) {
  return e3(e, n, Math.PI * 3 / 2);
}
function e3(e, n, a) {
  let t, r;
  return e < 1e3 ? r = [p9, c9, z9, O9] : (r = [u9, A9, l9, f9], e -= 2e3), a = a % (Math.PI * 2), a < Math.PI / 2 ? t = r[0] : a < Math.PI ? t = r[1] : a < Math.PI * 3 / 2 ? t = r[2] : t = r[3], $X(e, n, a, t);
}
function $X(e, n, a, t) {
  let r = L.horner(e * 1e-3, t);
  for (; ; ) {
    const M = a9.apparentVSOP87(n, r), b = 58 * lX(a - M.lon);
    if (r += b, AX(b) < 5e-6)
      break;
  }
  return r;
}
const Nn = {
  march: fX,
  june: mX,
  september: qX,
  december: hX,
  march2: yX,
  june2: WX,
  september2: gX,
  december2: RX,
  longitude: e3
};
/**
 * @copyright 2016 commenthol
 * @license MIT
 * @module sunrise
 */
new t1.Angle(!0, 0, 50, 0).rad(), new t1.Angle(!0, 0, 18, 0).rad(), new t1.Angle(!0, 6, 0, 0).rad(), new t1.Angle(!0, 12, 0, 0).rad(), new t1.Angle(!0, 18, 0, 0).rad(), new t1.Angle(!1, 6, 0, 0).rad();
class LX extends Te {
  inYear(n) {
    if (this.opts.year && this.opts.year !== n)
      return this;
    const a = new T2.CalendarJulian(n, this.opts.month, this.opts.day).toGregorian(), t = new d1(a).setOffset(this.offset);
    return this.dates.push(t), this;
  }
}
class m9 extends Te {
  constructor(n) {
    super(n), this.calendar = {};
  }
  inYear(n) {
    if (!(this.calendar[n] && this.calendar[n + 1] && this.calendar[n - 1]))
      return this;
    for (let a = n - 1; a <= n + 1; a++) {
      const t = this.calendar[a][this.opts.month - 1];
      if (t)
        for (let r = 0; r < t.length; r += 3) {
          if (this.opts.year) {
            const b = this.calendar.year + t[r + 2];
            if (this.opts.year !== b)
              continue;
          }
          const M = new d1({
            year: a,
            month: t[r] + 1,
            day: t[r + 1]
          }).setOffset(this.opts.day - 1);
          M.year === n && this.dates.push(M);
        }
    }
    return this;
  }
}
const _X = { 1968: [null, null, null, null, null, null, [8, 23, 0], [9, 23, 0], [10, 22, 0], [11, 22, 0]], 1969: [[2, 20, 0], [3, 19, 0], [4, 18, 0], [5, 17, 0], [6, 16, 0], [7, 15, 0], [8, 13, 1], [9, 13, 1], [10, 11, 1], [11, 10, 1], [0, 20, 0], [1, 19, 0], [1, 19, 0]], 1970: [[3, 7, 1], [4, 7, 1], [5, 5, 1], [6, 5, 1], [7, 3, 1], [8, 2, 1], [9, 1, 2], [9, 31, 2], [10, 29, 2], [11, 29, 2], [0, 8, 1], [1, 7, 1], [2, 9, 1]], 1971: [[2, 27, 2], [3, 26, 2], [4, 25, 2], [5, 24, 2], [6, 23, 2], [7, 22, 2], [8, 20, 3], [9, 20, 3], [10, 19, 3], [11, 19, 3], [0, 27, 2], [1, 26, 2], [1, 26, 2]], 1972: [[2, 16, 3], [3, 15, 3], [4, 14, 3], [5, 13, 3], [6, 12, 3], [7, 11, 3], [8, 9, 4], [9, 9, 4], [10, 7, 4], [11, 6, 4], [0, 17, 3], [1, 16, 3], [1, 16, 3]], 1973: [[3, 3, 4], [4, 3, 4], [5, 1, 4], [6, 1, 4], [6, 30, 4], [7, 29, 4], [8, 27, 5], [9, 27, 5], [10, 26, 5], [11, 26, 5], [0, 4, 4], [1, 3, 4], [2, 5, 4]], 1974: [[2, 24, 5], [3, 23, 5], [4, 22, 5], [5, 21, 5], [6, 20, 5], [7, 19, 5], [8, 17, 6], [9, 17, 6], [10, 15, 6], [11, 15, 6], [0, 24, 5], [1, 23, 5], [1, 23, 5]], 1975: [[2, 13, 6], [3, 12, 6], [4, 11, 6], [5, 10, 6], [6, 9, 6], [7, 8, 6], [8, 6, 7], [9, 6, 7], [10, 5, 7], [11, 5, 7], [0, 13, 6], [1, 12, 6], [1, 12, 6]], 1976: [[3, 1, 7], [4, 1, 7], [4, 30, 7], [5, 29, 7], [6, 28, 7], [7, 27, 7], [8, 25, 8], [9, 25, 8], [10, 23, 8], [11, 22, 8], [0, 3, 7], [1, 2, 7], [2, 3, 7]], 1977: [[2, 20, 8], [3, 19, 8], [4, 18, 8], [5, 17, 8], [6, 16, 8], [7, 15, 8], [8, 13, 9], [9, 13, 9], [10, 11, 9], [11, 11, 9], [0, 20, 8], [1, 19, 8], [1, 19, 8]], 1978: [[3, 8, 9], [4, 8, 9], [5, 6, 9], [6, 6, 9], [7, 4, 9], [8, 3, 9], [9, 2, 10], [10, 1, 10], [11, 1, 10], [11, 31, 10], [0, 9, 9], [1, 8, 9], [2, 10, 9]], 1979: [[2, 29, 10], [3, 28, 10], [4, 27, 10], [5, 26, 10], [6, 25, 10], [7, 24, 10], [8, 22, 11], [9, 22, 11], [10, 21, 11], [11, 21, 11], [0, 29, 10], [1, 28, 10], [1, 28, 10]], 1980: [[2, 18, 11], [3, 17, 11], [4, 16, 11], [5, 15, 11], [6, 14, 11], [7, 13, 11], [8, 11, 12], [9, 11, 12], [10, 9, 12], [11, 8, 12], [0, 19, 11], [1, 18, 11], [1, 18, 11]], 1981: [[3, 5, 12], [4, 5, 12], [5, 3, 12], [6, 3, 12], [7, 1, 12], [7, 31, 12], [8, 29, 13], [9, 29, 13], [10, 27, 13], [11, 27, 13], [0, 6, 12], [1, 5, 12], [2, 7, 12]], 1982: [[2, 25, 13], [3, 24, 13], [4, 23, 13], [5, 22, 13], [6, 21, 13], [7, 20, 13], [8, 18, 14], [9, 18, 14], [10, 17, 14], [11, 17, 14], [0, 25, 13], [1, 24, 13], [1, 24, 13]], 1983: [[2, 15, 14], [3, 14, 14], [4, 13, 14], [5, 12, 14], [6, 11, 14], [7, 10, 14], [8, 8, 15], [9, 8, 15], [10, 7, 15], [11, 7, 15], [0, 15, 14], [1, 14, 14], [1, 14, 14]], 1984: [[3, 3, 15], [4, 3, 15], [5, 1, 15], [6, 1, 15], [6, 30, 15], [7, 29, 15], [8, 27, 16], [9, 27, 16], [10, 25, 16], [11, 25, 16], [0, 5, 15], [1, 4, 15], [2, 5, 15]], 1985: [[2, 23, 16], [3, 22, 16], [4, 21, 16], [5, 20, 16], [6, 19, 16], [7, 18, 16], [8, 16, 17], [9, 16, 17], [10, 14, 17], [11, 13, 17], [0, 23, 16], [1, 22, 16], [1, 22, 16]], 1986: [[3, 10, 17], [4, 10, 17], [5, 8, 17], [6, 8, 17], [7, 6, 17], [8, 5, 17], [9, 4, 18], [10, 3, 18], [11, 3, 18], null, [0, 11, 17], [1, 10, 17], [2, 12, 17]], 1987: [[2, 31, 18], [3, 30, 18], [4, 29, 18], [5, 28, 18], [6, 27, 18], [7, 26, 18], [8, 24, 19], [9, 24, 19], [10, 22, 19], [0, 2, 18, 11, 22, 19], [0, 31, 18], [2, 2, 18], [2, 2, 18]], 1988: [[2, 19, 19], [3, 18, 19], [4, 17, 19], [5, 16, 19], [6, 15, 19], [7, 14, 19], [8, 12, 20], [9, 12, 20], [10, 10, 20], [11, 9, 20], [0, 20, 19], [1, 19, 19], [1, 19, 19]], 1989: [[3, 6, 20], [4, 6, 20], [5, 4, 20], [6, 4, 20], [7, 2, 20], [8, 1, 20], [8, 30, 21], [9, 30, 21], [10, 29, 21], [11, 29, 21], [0, 7, 20], [1, 6, 20], [2, 8, 20]], 1990: [[2, 27, 21], [3, 26, 21], [4, 25, 21], [5, 24, 21], [6, 23, 21], [7, 22, 21], [8, 20, 22], [9, 20, 22], [10, 18, 22], [11, 18, 22], [0, 27, 21], [1, 26, 21], [1, 26, 21]], 1991: [[2, 16, 22], [3, 15, 22], [4, 14, 22], [5, 13, 22], [6, 12, 22], [7, 11, 22], [8, 9, 23], [9, 9, 23], [10, 8, 23], [11, 8, 23], [0, 16, 22], [1, 15, 22], [1, 15, 22]], 1992: [[3, 4, 23], [4, 4, 23], [5, 2, 23], [6, 2, 23], [6, 31, 23], [7, 30, 23], [8, 28, 24], [9, 28, 24], [10, 26, 24], [11, 25, 24], [0, 6, 23], [1, 5, 23], [2, 6, 23]], 1993: [[2, 23, 24], [3, 22, 24], [4, 21, 24], [5, 20, 24], [6, 19, 24], [7, 18, 24], [8, 16, 25], [9, 16, 25], [10, 15, 25], [11, 15, 25], [0, 23, 24], [1, 22, 24], [1, 22, 24]], 1994: [[2, 13, 25], [3, 12, 25], [4, 11, 25], [5, 10, 25], [6, 9, 25], [7, 8, 25], [8, 6, 26], [9, 6, 26], [10, 4, 26], [11, 4, 26], [0, 13, 25], [1, 12, 25], [1, 12, 25]], 1995: [[3, 1, 26], [4, 1, 26], [4, 30, 26], [5, 29, 26], [6, 28, 26], [7, 27, 26], [8, 25, 27], [9, 25, 27], [10, 24, 27], [11, 24, 27], [0, 2, 26], [1, 1, 26], [2, 3, 26]], 1996: [[2, 21, 27], [3, 20, 27], [4, 19, 27], [5, 18, 27], [6, 17, 27], [7, 16, 27], [8, 14, 28], [9, 14, 28], [10, 12, 28], [11, 11, 28], [0, 22, 27], [1, 21, 27], [1, 21, 27]], 1997: [[3, 8, 28], [4, 8, 28], [5, 6, 28], [6, 6, 28], [7, 4, 28], [8, 3, 28], [9, 2, 29], [10, 1, 29], [10, 30, 29], [11, 30, 29], [0, 9, 28], [1, 8, 28], [2, 10, 28]], 1998: [[2, 28, 29], [3, 27, 29], [4, 26, 29], [5, 25, 29], [6, 24, 29], [7, 23, 29], [8, 21, 30], [9, 21, 30], [10, 20, 30], [11, 20, 30], [0, 28, 29], [1, 27, 29], [1, 27, 29]], 1999: [[2, 18, 30], [3, 17, 30], [4, 16, 30], [5, 15, 30], [6, 14, 30], [7, 13, 30], [8, 11, 31], [9, 11, 31], [10, 10, 31], [11, 10, 31], [0, 18, 30], [1, 17, 30], [1, 17, 30]], 2e3: [[3, 6, 31], [4, 6, 31], [5, 4, 31], [6, 4, 31], [7, 2, 31], [8, 1, 31], [8, 30, 32], [9, 30, 32], [10, 28, 32], [11, 27, 32], [0, 8, 31], [1, 7, 31], [2, 8, 31]], 2001: [[2, 25, 32], [3, 24, 32], [4, 23, 32], [5, 22, 32], [6, 21, 32], [7, 20, 32], [8, 18, 33], [9, 18, 33], [10, 16, 33], [11, 16, 33], [0, 25, 32], [1, 24, 32], [1, 24, 32]], 2002: [[2, 14, 33], [3, 13, 33], [4, 12, 33], [5, 11, 33], [6, 10, 33], [7, 9, 33], [8, 7, 34], [9, 7, 34], [10, 6, 34], [11, 6, 34], [0, 14, 33], [1, 13, 33], [1, 13, 33]], 2003: [[3, 3, 34], [4, 3, 34], [5, 1, 34], [6, 1, 34], [6, 30, 34], [7, 29, 34], [8, 27, 35], [9, 27, 35], [10, 26, 35], [11, 26, 35], [0, 4, 34], [1, 3, 34], [2, 5, 34]], 2004: [[2, 23, 35], [3, 22, 35], [4, 21, 35], [5, 20, 35], [6, 19, 35], [7, 18, 35], [8, 16, 36], [9, 16, 36], [10, 14, 36], [11, 13, 36], [0, 24, 35], [1, 23, 35], [1, 23, 35]], 2005: [[3, 10, 36], [4, 10, 36], [5, 8, 36], [6, 8, 36], [7, 6, 36], [8, 5, 36], [9, 4, 37], [10, 3, 37], [11, 2, 37], null, [0, 11, 36], [1, 10, 36], [2, 12, 36]], 2006: [[2, 30, 37], [3, 29, 37], [4, 28, 37], [5, 27, 37], [6, 26, 37], [7, 25, 37], [8, 23, 38], [9, 23, 38], [10, 22, 38], [0, 1, 37, 11, 22, 38], [0, 30, 37], [2, 1, 37], [2, 1, 37]], 2007: [[2, 20, 38], [3, 19, 38], [4, 18, 38], [5, 17, 38], [6, 16, 38], [7, 15, 38], [8, 13, 39], [9, 13, 39], [10, 11, 39], [11, 10, 39], [0, 20, 38], [1, 19, 38], [1, 19, 38]], 2008: [[3, 6, 39], [4, 6, 39], [5, 4, 39], [6, 4, 39], [7, 2, 39], [8, 1, 39], [8, 30, 40], [9, 30, 40], [10, 28, 40], [11, 28, 40], [0, 8, 39], [1, 7, 39], [2, 8, 39]], 2009: [[2, 26, 40], [3, 25, 40], [4, 24, 40], [5, 23, 40], [6, 22, 40], [7, 21, 40], [8, 19, 41], [9, 19, 41], [10, 18, 41], [11, 18, 41], [0, 26, 40], [1, 25, 40], [1, 25, 40]], 2010: [[2, 16, 41], [3, 15, 41], [4, 14, 41], [5, 13, 41], [6, 12, 41], [7, 11, 41], [8, 9, 42], [9, 9, 42], [10, 8, 42], [11, 8, 42], [0, 16, 41], [1, 15, 41], [1, 15, 41]], 2011: [[3, 5, 42], [4, 5, 42], [5, 3, 42], [6, 3, 42], [7, 1, 42], [7, 31, 42], [8, 29, 43], [9, 29, 43], [10, 27, 43], [11, 27, 43], [0, 6, 42], [1, 5, 42], [2, 7, 42]], 2012: [[2, 24, 43], [3, 23, 43], [4, 22, 43], [5, 21, 43], [6, 20, 43], [7, 19, 43], [8, 17, 44], [9, 17, 44], [10, 15, 44], [11, 14, 44], [0, 25, 43], [1, 24, 43], [1, 24, 43]], 2013: [[2, 12, 44], [3, 11, 44], [4, 10, 44], [5, 9, 44], [6, 8, 44], [7, 7, 44], [8, 5, 45], [9, 5, 45], [10, 4, 45], [11, 4, 45], [0, 12, 44], [1, 11, 44], [1, 11, 44]], 2014: [[3, 1, 45], [4, 1, 45], [4, 30, 45], [5, 29, 45], [6, 28, 45], [7, 27, 45], [8, 25, 46], [9, 25, 46], [10, 23, 46], [11, 23, 46], [0, 2, 45], [1, 1, 45], [2, 3, 45]], 2015: [[2, 21, 46], [3, 20, 46], [4, 19, 46], [5, 18, 46], [6, 17, 46], [7, 16, 46], [8, 14, 47], [9, 14, 47], [10, 13, 47], [11, 13, 47], [0, 21, 46], [1, 20, 46], [1, 20, 46]], 2016: [[3, 9, 47], [4, 9, 47], [5, 7, 47], [6, 7, 47], [7, 5, 47], [8, 4, 47], [9, 3, 48], [10, 2, 48], [11, 1, 48], [11, 30, 48], [0, 11, 47], [1, 10, 47], [2, 11, 47]], 2017: [[2, 28, 48], [3, 27, 48], [4, 26, 48], [5, 25, 48], [6, 24, 48], [7, 23, 48], [8, 21, 49], [9, 21, 49], [10, 19, 49], [11, 19, 49], [0, 28, 48], [1, 27, 48], [1, 27, 48]], 2018: [[2, 17, 49], [3, 16, 49], [4, 15, 49], [5, 14, 49], [6, 13, 49], [7, 12, 49], [8, 10, 50], [9, 10, 50], [10, 9, 50], [11, 9, 50], [0, 17, 49], [1, 16, 49], [1, 16, 49]], 2019: [[3, 6, 50], [4, 6, 50], [5, 4, 50], [6, 4, 50], [7, 2, 50], [8, 1, 50], [8, 30, 51], [9, 30, 51], [10, 29, 51], [11, 29, 51], [0, 7, 50], [1, 6, 50], [2, 8, 50]], 2020: [[2, 26, 51], [3, 25, 51], [4, 24, 51], [5, 23, 51], [6, 22, 51], [7, 21, 51], [8, 19, 52], [9, 19, 52], [10, 17, 52], [11, 16, 52], [0, 27, 51], [1, 26, 51], [1, 26, 51]], 2021: [[2, 14, 52], [3, 13, 52], [4, 12, 52], [5, 11, 52], [6, 10, 52], [7, 9, 52], [8, 7, 53], [9, 7, 53], [10, 5, 53], [11, 5, 53], [0, 14, 52], [1, 13, 52], [1, 13, 52]], 2022: [[3, 2, 53], [4, 2, 53], [4, 31, 53], [5, 30, 53], [6, 29, 53], [7, 28, 53], [8, 26, 54], [9, 26, 54], [10, 25, 54], [11, 25, 54], [0, 3, 53], [1, 2, 53], [2, 4, 53]], 2023: [[2, 23, 54], [3, 22, 54], [4, 21, 54], [5, 20, 54], [6, 19, 54], [7, 18, 54], [8, 16, 55], [9, 16, 55], [10, 14, 55], [11, 13, 55], [0, 23, 54], [1, 22, 54], [1, 22, 54]], 2024: [[3, 9, 55], [4, 9, 55], [5, 7, 55], [6, 7, 55], [7, 5, 55], [8, 4, 55], [9, 3, 56], [10, 2, 56], [11, 2, 56], null, [0, 11, 55], [1, 10, 55], [2, 11, 55]], 2025: [[2, 30, 56], [3, 29, 56], [4, 28, 56], [5, 27, 56], [6, 26, 56], [7, 25, 56], [8, 23, 57], [9, 23, 57], [10, 21, 57], [0, 1, 56, 11, 21, 57], [0, 30, 56], [2, 1, 56], [2, 1, 56]], 2026: [[2, 19, 57], [3, 18, 57], [4, 17, 57], [5, 16, 57], [6, 15, 57], [7, 14, 57], [8, 12, 58], [9, 12, 58], [10, 11, 58], [11, 11, 58], [0, 19, 57], [1, 18, 57], [1, 18, 57]], 2027: [[3, 8, 58], [4, 8, 58], [5, 6, 58], [6, 6, 58], [7, 4, 58], [8, 3, 58], [9, 2, 59], [10, 1, 59], [11, 1, 59], [11, 31, 59], [0, 9, 58], [1, 8, 58], [2, 10, 58]], 2028: [[2, 28, 59], [3, 27, 59], [4, 26, 59], [5, 25, 59], [6, 24, 59], [7, 23, 59], [8, 21, 60], [9, 21, 60], [10, 19, 60], [11, 19, 60], [0, 29, 59], [1, 28, 59], [1, 28, 59]], 2029: [[2, 17, 60], [3, 16, 60], [4, 15, 60], [5, 14, 60], [6, 13, 60], [7, 12, 60], [8, 10, 61], [9, 10, 61], [10, 8, 61], [11, 7, 61], [0, 17, 60], [1, 16, 60], [1, 16, 60]], 2030: [[3, 4, 61], [4, 4, 61], [5, 2, 61], [6, 2, 61], [6, 31, 61], [7, 30, 61], [8, 28, 62], [9, 28, 62], [10, 27, 62], [11, 27, 62], [0, 5, 61], [1, 4, 61], [2, 6, 61]], 2031: [[2, 25, 62], [3, 24, 62], [4, 23, 62], [5, 22, 62], [6, 21, 62], [7, 20, 62], [8, 18, 63], [9, 18, 63], [10, 16, 63], [11, 16, 63], [0, 25, 62], [1, 24, 62], [1, 24, 62]], 2032: [[2, 13, 63], [3, 12, 63], [4, 11, 63], [5, 10, 63], [6, 9, 63], [7, 8, 63], [8, 6, 64], [9, 6, 64], [10, 4, 64], [11, 3, 64], [0, 14, 63], [1, 13, 63], [1, 13, 63]], 2033: [[2, 31, 64], [3, 30, 64], [4, 29, 64], [5, 28, 64], [6, 27, 64], [7, 26, 64], [8, 24, 65], [9, 24, 65], [10, 23, 65], [11, 23, 65], [0, 1, 64], [0, 31, 64], [2, 2, 64]], 2034: [[2, 21, 65], [3, 20, 65], [4, 19, 65], [5, 18, 65], [6, 17, 65], [7, 16, 65], [8, 14, 66], [9, 14, 66], [10, 13, 66], [11, 13, 66], [0, 21, 65], [1, 20, 65], [1, 20, 65]], 2035: [[3, 10, 66], [4, 10, 66], [5, 8, 66], [6, 8, 66], [7, 6, 66], [8, 5, 66], [9, 4, 67], [10, 3, 67], [11, 2, 67], null, [0, 11, 66], [1, 10, 66], [2, 12, 66]], 2036: [[2, 29, 67], [3, 28, 67], [4, 27, 67], [5, 26, 67], [6, 25, 67], [7, 24, 67], [8, 22, 68], [9, 22, 68], [10, 20, 68], [0, 1, 67, 11, 19, 68], [0, 30, 67], [1, 29, 67], [1, 29, 67]], 2037: [[2, 17, 68], [3, 16, 68], [4, 15, 68], [5, 14, 68], [6, 13, 68], [7, 12, 68], [8, 10, 69], [9, 10, 69], [10, 9, 69], [11, 9, 69], [0, 17, 68], [1, 16, 68], [1, 16, 68]], 2038: [[3, 6, 69], [4, 6, 69], [5, 4, 69], [6, 4, 69], [7, 2, 69], [8, 1, 69], [8, 30, 70], [9, 30, 70], [10, 28, 70], [11, 28, 70], [0, 7, 69], [1, 6, 69], [2, 8, 69]], 2039: [[2, 26, 70], [3, 25, 70], [4, 24, 70], [5, 23, 70], [6, 22, 70], [7, 21, 70], [8, 19, 71], [9, 19, 71], [10, 18, 71], [11, 18, 71], [0, 26, 70], [1, 25, 70], [1, 25, 70]], 2040: [[2, 15, 71], [3, 14, 71], [4, 13, 71], [5, 12, 71], [6, 11, 71], [7, 10, 71], [8, 8, 72], [9, 8, 72], [10, 6, 72], [11, 5, 72], [0, 16, 71], [1, 15, 71], [1, 15, 71]], 2041: [[3, 2, 72], [4, 2, 72], [4, 31, 72], [5, 30, 72], [6, 29, 72], [7, 28, 72], [8, 26, 73], [9, 26, 73], [10, 24, 73], [11, 24, 73], [0, 3, 72], [1, 2, 72], [2, 4, 72]], 2042: [[2, 22, 73], [3, 21, 73], [4, 20, 73], [5, 19, 73], [6, 18, 73], [7, 17, 73], [8, 15, 74], [9, 15, 74], [10, 14, 74], [11, 14, 74], [0, 22, 73], [1, 21, 73], [1, 21, 73]], 2043: [[3, 11, 74], [4, 11, 74], [5, 9, 74], [6, 9, 74], [7, 7, 74], [8, 6, 74], [9, 5, 75], [10, 4, 75], [11, 3, 75], null, [0, 12, 74], [1, 11, 74], [2, 13, 74]], 2044: [[2, 29, 75], [3, 28, 75], [4, 27, 75], [5, 26, 75], [6, 25, 75], [7, 24, 75], [8, 22, 76], [9, 22, 76], [10, 21, 76], [0, 1, 75, 11, 21, 76], [0, 30, 75], [1, 29, 75], [1, 29, 75]], 2045: [[2, 19, 76], [3, 18, 76], [4, 17, 76], [5, 16, 76], [6, 15, 76], [7, 14, 76], [8, 12, 77], [9, 12, 77], [10, 10, 77], [11, 10, 77], [0, 19, 76], [1, 18, 76], [1, 18, 76]], 2046: [[3, 7, 77], [4, 7, 77], [5, 5, 77], [6, 5, 77], [7, 3, 77], [8, 2, 77], [9, 1, 78], [9, 31, 78], [10, 30, 78], [11, 30, 78], [0, 8, 77], [1, 7, 77], [2, 9, 77]], 2047: [[2, 28, 78], [3, 27, 78], [4, 26, 78], [5, 25, 78], [6, 24, 78], [7, 23, 78], [8, 21, 79], [9, 21, 79], [10, 19, 79], [11, 18, 79], [0, 28, 78], [1, 27, 78], [1, 27, 78]], 2048: [[2, 15, 79], [3, 14, 79], [4, 13, 79], [5, 12, 79], [6, 11, 79], [7, 10, 79], [8, 8, 80], [9, 8, 80], [10, 6, 80], [11, 6, 80], [0, 16, 79], [1, 15, 79], [1, 15, 79]], 2049: [[3, 3, 80], [4, 3, 80], [5, 1, 80], [6, 1, 80], [6, 30, 80], [7, 29, 80], [8, 27, 81], [9, 27, 81], [10, 26, 81], [11, 26, 81], [0, 4, 80], [1, 3, 80], [2, 5, 80]], 2050: [[2, 24, 81], [3, 23, 81], [4, 22, 81], [5, 21, 81], [6, 20, 81], [7, 19, 81], [8, 17, 82], [9, 17, 82], [10, 16, 82], [11, 16, 82], [0, 24, 81], [1, 23, 81], [1, 23, 81]], 2051: [[2, 14, 82], [3, 13, 82], [4, 12, 82], [5, 11, 82], [6, 10, 82], [7, 9, 82], [8, 7, 83], [9, 7, 83], [10, 5, 83], [11, 4, 83], [0, 14, 82], [1, 13, 82], [1, 13, 82]], 2052: [[2, 31, 83], [3, 30, 83], [4, 29, 83], [5, 28, 83], [6, 27, 83], [7, 26, 83], [8, 24, 84], [9, 24, 84], [10, 22, 84], [11, 22, 84], [0, 2, 83], [1, 1, 83], [2, 2, 83]], 2053: [[2, 20, 84], [3, 19, 84], [4, 18, 84], [5, 17, 84], [6, 16, 84], [7, 15, 84], [8, 13, 85], [9, 13, 85], [10, 12, 85], [11, 12, 85], [0, 20, 84], [1, 19, 84], [1, 19, 84]], 2054: [[3, 9, 85], [4, 9, 85], [5, 7, 85], [6, 7, 85], [7, 5, 85], [8, 4, 85], [9, 3, 86], [10, 2, 86], [11, 2, 86], null, [0, 10, 85], [1, 9, 85], [2, 11, 85]], 2055: [[2, 30, 86], [3, 29, 86], [4, 28, 86], [5, 27, 86], [6, 26, 86], [7, 25, 86], [8, 23, 87], [9, 23, 87], [10, 21, 87], [0, 1, 86, 11, 21, 87], [0, 30, 86], [2, 1, 86], [2, 1, 86]], 2056: [[2, 18, 87], [3, 17, 87], [4, 16, 87], [5, 15, 87], [6, 14, 87], [7, 13, 87], [8, 11, 88], [9, 11, 88], [10, 9, 88], [11, 8, 88], [0, 19, 87], [1, 18, 87], [1, 18, 87]], 2057: [[3, 5, 88], [4, 5, 88], [5, 3, 88], [6, 3, 88], [7, 1, 88], [7, 31, 88], [8, 29, 89], [9, 29, 89], [10, 28, 89], [11, 28, 89], [0, 6, 88], [1, 5, 88], [2, 7, 88]], 2058: [[2, 26, 89], [3, 25, 89], [4, 24, 89], [5, 23, 89], [6, 22, 89], [7, 21, 89], [8, 19, 90], [9, 19, 90], [10, 17, 90], [11, 17, 90], [0, 26, 89], [1, 25, 89], [1, 25, 89]], 2059: [[2, 15, 90], [3, 14, 90], [4, 13, 90], [5, 12, 90], [6, 11, 90], [7, 10, 90], [8, 8, 91], [9, 8, 91], [10, 6, 91], [11, 5, 91], [0, 15, 90], [1, 14, 90], [1, 14, 90]], 2060: [[3, 1, 91], [4, 1, 91], [4, 30, 91], [5, 29, 91], [6, 28, 91], [7, 27, 91], [8, 25, 92], [9, 25, 92], [10, 24, 92], [11, 24, 92], [0, 3, 91], [1, 2, 91], [2, 3, 91]], 2061: [[2, 22, 92], [3, 21, 92], [4, 20, 92], [5, 19, 92], [6, 18, 92], [7, 17, 92], [8, 15, 93], [9, 15, 93], [10, 14, 93], [11, 14, 93], [0, 22, 92], [1, 21, 92], [1, 21, 92]], 2062: [[3, 11, 93], [4, 11, 93], [5, 9, 93], [6, 9, 93], [7, 7, 93], [8, 6, 93], [9, 5, 94], [10, 4, 94], [11, 3, 94], null, [0, 12, 93], [1, 11, 93], [2, 13, 93]], 2063: [[2, 31, 94], [3, 30, 94], [4, 29, 94], [5, 28, 94], [6, 27, 94], [7, 26, 94], [8, 24, 95], [9, 24, 95], [10, 22, 95], [0, 2, 94, 11, 21, 95], [0, 31, 94], [2, 2, 94], [2, 2, 94]], 2064: [[2, 18, 95], [3, 17, 95], [4, 16, 95], [5, 15, 95], [6, 14, 95], [7, 13, 95], [8, 11, 96], [9, 11, 96], [10, 10, 96], [11, 10, 96], [0, 19, 95], [1, 18, 95], [1, 18, 95]], 2065: [[3, 7, 96], [4, 7, 96], [5, 5, 96], [6, 5, 96], [7, 3, 96], [8, 2, 96], [9, 1, 97], [9, 31, 97], [10, 29, 97], [11, 29, 97], [0, 8, 96], [1, 7, 96], [2, 9, 96]], 2066: [[2, 27, 97], [3, 26, 97], [4, 25, 97], [5, 24, 97], [6, 23, 97], [7, 22, 97], [8, 20, 98], [9, 20, 98], [10, 19, 98], [11, 19, 98], [0, 27, 97], [1, 26, 97], [1, 26, 97]], 2067: [[2, 17, 98], [3, 16, 98], [4, 15, 98], [5, 14, 98], [6, 13, 98], [7, 12, 98], [8, 10, 99], [9, 10, 99], [10, 8, 99], [11, 7, 99], [0, 17, 98], [1, 16, 98], [1, 16, 98]], 2068: [[3, 3, 99], [4, 3, 99], [5, 1, 99], [6, 1, 99], [6, 30, 99], [7, 29, 99], [8, 27, 100], [9, 27, 100], [10, 25, 100], [11, 25, 100], [0, 5, 99], [1, 4, 99], [2, 5, 99]], 2069: [[2, 23, 100], [3, 22, 100], [4, 21, 100], [5, 20, 100], [6, 19, 100], [7, 18, 100], [8, 16, 101], [9, 16, 101], [10, 15, 101], [11, 15, 101], [0, 23, 100], [1, 22, 100], [1, 22, 100]], 2070: [[2, 13, 101], [3, 12, 101], [4, 11, 101], [5, 10, 101], [6, 9, 101], [7, 8, 101], [8, 6, 102], [9, 6, 102], [10, 4, 102], [11, 3, 102], [0, 13, 101], [1, 12, 101], [1, 12, 101]], 2071: [[2, 31, 102], [3, 30, 102], [4, 29, 102], [5, 28, 102], [6, 27, 102], [7, 26, 102], [8, 24, 103], [9, 24, 103], [10, 23, 103], [11, 23, 103], [0, 1, 102], [0, 31, 102], [2, 2, 102]], 2072: [[2, 20, 103], [3, 19, 103], [4, 18, 103], [5, 17, 103], [6, 16, 103], [7, 15, 103], [8, 13, 104], [9, 13, 104], [10, 11, 104], [11, 11, 104], [0, 21, 103], [1, 20, 103], [1, 20, 103]], 2073: [[3, 8, 104], [4, 8, 104], [5, 6, 104], [6, 6, 104], [7, 4, 104], [8, 3, 104], [9, 2, 105], [10, 1, 105], [11, 1, 105], [11, 31, 105], [0, 9, 104], [1, 8, 104], [2, 10, 104]], 2074: [[2, 29, 105], [3, 28, 105], [4, 27, 105], [5, 26, 105], [6, 25, 105], [7, 24, 105], [8, 22, 106], [9, 22, 106], [10, 20, 106], [11, 19, 106], [0, 29, 105], [1, 28, 105], [1, 28, 105]], 2075: [[2, 17, 106], [3, 16, 106], [4, 15, 106], [5, 14, 106], [6, 13, 106], [7, 12, 106], [8, 10, 107], [9, 10, 107], [10, 8, 107], [11, 8, 107], [0, 17, 106], [1, 16, 106], [1, 16, 106]], 2076: [[3, 4, 107], [4, 4, 107], [5, 2, 107], [6, 2, 107], [6, 31, 107], [7, 30, 107], [8, 28, 108], [9, 28, 108], [10, 27, 108], [11, 27, 108], [0, 6, 107], [1, 5, 107], [2, 6, 107]], 2077: [[2, 25, 108], [3, 24, 108], [4, 23, 108], [5, 22, 108], [6, 21, 108], [7, 20, 108], [8, 18, 109], [9, 18, 109], [10, 17, 109], [11, 17, 109], [0, 25, 108], [1, 24, 108], [1, 24, 108]], 2078: [[2, 15, 109], [3, 14, 109], [4, 13, 109], [5, 12, 109], [6, 11, 109], [7, 10, 109], [8, 8, 110], [9, 8, 110], [10, 6, 110], [11, 5, 110], [0, 15, 109], [1, 14, 109], [1, 14, 109]], 2079: [[3, 2, 110], [4, 2, 110], [4, 31, 110], [5, 30, 110], [6, 29, 110], [7, 28, 110], [8, 26, 111], [9, 26, 111], [10, 24, 111], [11, 24, 111], [0, 3, 110], [1, 2, 110], [2, 4, 110]], 2080: [[2, 21, 111], [3, 20, 111], [4, 19, 111], [5, 18, 111], [6, 17, 111], [7, 16, 111], [8, 14, 112], [9, 14, 112], [10, 13, 112], [11, 13, 112], [0, 22, 111], [1, 21, 111], [1, 21, 111]], 2081: [[3, 10, 112], [4, 10, 112], [5, 8, 112], [6, 8, 112], [7, 6, 112], [8, 5, 112], [9, 4, 113], [10, 3, 113], [11, 3, 113], null, [0, 11, 112], [1, 10, 112], [2, 12, 112]], 2082: [[2, 31, 113], [3, 30, 113], [4, 29, 113], [5, 28, 113], [6, 27, 113], [7, 26, 113], [8, 24, 114], [9, 24, 114], [10, 22, 114], [0, 2, 113, 11, 22, 114], [0, 31, 113], [2, 2, 113], [2, 2, 113]], 2083: [[2, 20, 114], [3, 19, 114], [4, 18, 114], [5, 17, 114], [6, 16, 114], [7, 15, 114], [8, 13, 115], [9, 13, 115], [10, 11, 115], [11, 10, 115], [0, 20, 114], [1, 19, 114], [1, 19, 114]], 2084: [[3, 6, 115], [4, 6, 115], [5, 4, 115], [6, 4, 115], [7, 2, 115], [8, 1, 115], [8, 30, 116], [9, 30, 116], [10, 29, 116], [11, 29, 116], [0, 8, 115], [1, 7, 115], [2, 8, 115]], 2085: [[2, 27, 116], [3, 26, 116], [4, 25, 116], [5, 24, 116], [6, 23, 116], [7, 22, 116], [8, 20, 117], [9, 20, 117], [10, 18, 117], [11, 18, 117], [0, 27, 116], [1, 26, 116], [1, 26, 116]], 2086: [[2, 16, 117], [3, 15, 117], [4, 14, 117], [5, 13, 117], [6, 12, 117], [7, 11, 117], [8, 9, 118], [9, 9, 118], [10, 7, 118], [11, 6, 118], [0, 16, 117], [1, 15, 117], [1, 15, 117]], 2087: [[3, 3, 118], [4, 3, 118], [5, 1, 118], [6, 1, 118], [6, 30, 118], [7, 29, 118], [8, 27, 119], [9, 27, 119], [10, 26, 119], [11, 26, 119], [0, 4, 118], [1, 3, 118], [2, 5, 118]], 2088: [[2, 23, 119], [3, 22, 119], [4, 21, 119], [5, 20, 119], [6, 19, 119], [7, 18, 119], [8, 16, 120], [9, 16, 120], [10, 14, 120], [11, 14, 120], [0, 24, 119], [1, 23, 119], [1, 23, 119]], 2089: [[2, 12, 120], [3, 11, 120], [4, 10, 120], [5, 9, 120], [6, 8, 120], [7, 7, 120], [8, 5, 121], [9, 5, 121], [10, 4, 121], [11, 4, 121], [0, 12, 120], [1, 11, 120], [1, 11, 120]], 2090: [[3, 1, 121], [4, 1, 121], [4, 30, 121], [5, 29, 121], [6, 28, 121], [7, 27, 121], [8, 25, 122], [9, 25, 122], [10, 23, 122], [11, 22, 122], [0, 2, 121], [1, 1, 121], [2, 3, 121]], 2091: [[2, 20, 122], [3, 19, 122], [4, 18, 122], [5, 17, 122], [6, 16, 122], [7, 15, 122], [8, 13, 123], [9, 13, 123], [10, 12, 123], [11, 12, 123], [0, 20, 122], [1, 19, 122], [1, 19, 122]], 2092: [[3, 8, 123], [4, 8, 123], [5, 6, 123], [6, 6, 123], [7, 4, 123], [8, 3, 123], [9, 2, 124], [10, 1, 124], [10, 30, 124], [11, 30, 124], [0, 10, 123], [1, 9, 123], [2, 10, 123]], 2093: [[2, 28, 124], [3, 27, 124], [4, 26, 124], [5, 25, 124], [6, 24, 124], [7, 23, 124], [8, 21, 125], [9, 21, 125], [10, 20, 125], [11, 20, 125], [0, 28, 124], [1, 27, 124], [1, 27, 124]], 2094: [[2, 18, 125], [3, 17, 125], [4, 16, 125], [5, 15, 125], [6, 14, 125], [7, 13, 125], [8, 11, 126], [9, 11, 126], [10, 9, 126], [11, 8, 126], [0, 18, 125], [1, 17, 125], [1, 17, 125]], 2095: [[3, 5, 126], [4, 5, 126], [5, 3, 126], [6, 3, 126], [7, 1, 126], [7, 31, 126], [8, 29, 127], [9, 29, 127], [10, 27, 127], [11, 27, 127], [0, 6, 126], [1, 5, 126], [2, 7, 126]], 2096: [[2, 24, 127], [3, 23, 127], [4, 22, 127], [5, 21, 127], [6, 20, 127], [7, 19, 127], [8, 17, 128], [9, 17, 128], [10, 16, 128], [11, 16, 128], [0, 25, 127], [1, 24, 127], [1, 24, 127]], 2097: [[2, 14, 128], [3, 13, 128], [4, 12, 128], [5, 11, 128], [6, 10, 128], [7, 9, 128], [8, 7, 129], [9, 7, 129], [10, 6, 129], [11, 6, 129], [0, 14, 128], [1, 13, 128], [1, 13, 128]], 2098: [[3, 3, 129], [4, 3, 129], [5, 1, 129], [6, 1, 129], [6, 30, 129], [7, 29, 129], [8, 27, 130], [9, 27, 130], [10, 25, 130], [11, 24, 130], [0, 4, 129], [1, 3, 129], [2, 5, 129]], 2099: [[2, 22, 130], [3, 21, 130], [4, 20, 130], [5, 19, 130], [6, 18, 130], [7, 17, 130], [8, 15, 131], [9, 15, 131], [10, 13, 131], [11, 13, 131], [0, 22, 130], [1, 21, 130], [1, 21, 130]], 2100: [[3, 10, 131], [4, 10, 131], [5, 8, 131], [6, 8, 131], [7, 6, 131], [8, 5, 131], null, null, null, null, [0, 11, 131], [1, 10, 131], [2, 12, 131]], months: 13, year: 5729 };
class NX extends m9 {
  constructor(n) {
    super(n), this.calendar = _X;
  }
  get(n) {
    return this.dates.map((t) => {
      const r = new d1(t), M = {
        date: r.toString() + " -0600",
        start: r.setOffset(-6, "h").toTimezone(n),
        end: r.toEndDate().toTimezone(n)
      };
      return this._addSubstitute(t, M), M;
    });
  }
}
const vX = { 1969: [[2, 19, 0], [3, 18, 0], [4, 17, 0], [5, 16, 0], [6, 15, 0], [7, 14, 0], [8, 12, 0], [9, 12, 0], [10, 10, 0], [11, 10, 0]], 1970: [[2, 9, 1], [3, 8, 1], [4, 7, 1], [5, 6, 1], [6, 5, 1], [7, 4, 1], [8, 2, 1], [9, 2, 1], [10, 1, 1], [10, 30, 1], [0, 8, 0, 11, 30, 1], [1, 7, 0]], 1971: [[1, 26, 2], [2, 28, 2], [3, 26, 2], [4, 26, 2], [5, 24, 2], [6, 24, 2], [7, 22, 2], [8, 21, 2], [9, 20, 2], [10, 19, 2], [11, 18, 2], [0, 28, 1]], 1972: [[1, 16, 3], [2, 16, 3], [3, 14, 3], [4, 14, 3], [5, 12, 3], [6, 12, 3], [7, 10, 3], [8, 9, 3], [9, 8, 3], [10, 7, 3], [11, 6, 3], [0, 17, 2]], 1973: [[1, 4, 4], [2, 6, 4], [3, 4, 4], [4, 4, 4], [5, 2, 4], [6, 1, 4], [6, 30, 4], [7, 29, 4], [8, 27, 4], [9, 27, 4], [10, 25, 4], [0, 5, 3, 11, 25, 4]], 1974: [[0, 24, 5], [1, 23, 5], [2, 24, 5], [3, 23, 5], [4, 22, 5], [5, 21, 5], [6, 20, 5], [7, 19, 5], [8, 17, 5], [9, 16, 5], [10, 15, 5], [11, 15, 5]], 1975: [[0, 13, 6], [1, 12, 6], [2, 13, 6], [3, 12, 6], [4, 12, 6], [5, 10, 6], [6, 10, 6], [7, 8, 6], [8, 6, 6], [9, 6, 6], [10, 4, 6], [11, 4, 6]], 1976: [[0, 2, 7, 11, 22, 8], [1, 1, 7], [2, 1, 7], [2, 31, 7], [3, 30, 7], [4, 30, 7], [5, 28, 7], [6, 28, 7], [7, 26, 7], [8, 24, 7], [9, 24, 7], [10, 22, 7]], 1977: [[11, 11, 9], [0, 20, 8], [1, 19, 8], [2, 20, 8], [3, 19, 8], [4, 19, 8], [5, 17, 8], [6, 17, 8], [7, 15, 8], [8, 14, 8], [9, 13, 8], [10, 12, 8]], 1978: [[11, 1, 10], [0, 10, 9, 11, 30, 10], [1, 8, 9], [2, 10, 9], [3, 8, 9], [4, 8, 9], [5, 6, 9], [6, 6, 9], [7, 5, 9], [8, 3, 9], [9, 3, 9], [10, 1, 9]], 1979: [[10, 20, 11], [11, 20, 11], [0, 29, 10], [1, 27, 10], [2, 29, 10], [3, 27, 10], [4, 27, 10], [5, 25, 10], [6, 25, 10], [7, 23, 10], [8, 22, 10], [9, 22, 10]], 1980: [[10, 9, 12], [11, 8, 12], [0, 19, 11], [1, 17, 11], [2, 18, 11], [3, 16, 11], [4, 15, 11], [5, 14, 11], [6, 13, 11], [7, 12, 11], [8, 10, 11], [9, 10, 11]], 1981: [[9, 28, 13], [10, 27, 13], [0, 7, 12, 11, 27, 13], [1, 5, 12], [2, 7, 12], [3, 5, 12], [4, 5, 12], [5, 3, 12], [6, 2, 12], [7, 1, 12], [7, 30, 12], [8, 29, 12]], 1982: [[9, 18, 14], [10, 16, 14], [11, 16, 14], [0, 26, 13], [1, 24, 13], [2, 26, 13], [3, 24, 13], [4, 24, 13], [5, 22, 13], [6, 21, 13], [7, 20, 13], [8, 18, 13]], 1983: [[9, 7, 15], [10, 5, 15], [11, 5, 15], [0, 15, 14], [1, 14, 14], [2, 15, 14], [3, 14, 14], [4, 13, 14], [5, 12, 14], [6, 11, 14], [7, 9, 14], [8, 8, 14]], 1984: [[8, 26, 16], [9, 25, 16], [10, 23, 16], [0, 4, 15, 11, 23, 16], [1, 2, 15], [2, 3, 15], [3, 2, 15], [4, 2, 15], [4, 31, 15], [5, 30, 15], [6, 29, 15], [7, 27, 15]], 1985: [[8, 15, 17], [9, 15, 17], [10, 13, 17], [11, 13, 17], [0, 22, 16], [1, 20, 16], [2, 22, 16], [3, 21, 16], [4, 20, 16], [5, 19, 16], [6, 18, 16], [7, 17, 16]], 1986: [[8, 5, 18], [9, 4, 18], [10, 3, 18], [11, 2, 18], [0, 11, 17], [1, 10, 17], [2, 11, 17], [3, 10, 17], [4, 9, 17], [5, 8, 17], [6, 8, 17], [7, 6, 17]], 1987: [[7, 25, 19], [8, 24, 19], [9, 23, 19], [10, 22, 19], [0, 1, 18, 11, 21, 19], [0, 30, 18], [2, 1, 18], [2, 30, 18], [3, 29, 18], [4, 28, 18], [5, 27, 18], [6, 26, 18]], 1988: [[7, 13, 20], [8, 12, 20], [9, 11, 20], [10, 10, 20], [11, 10, 20], [0, 20, 19], [1, 18, 19], [2, 19, 19], [3, 17, 19], [4, 16, 19], [5, 15, 19], [6, 14, 19]], 1989: [[7, 2, 21], [8, 1, 21], [8, 30, 21], [9, 30, 21], [10, 29, 21], [0, 8, 20, 11, 29, 21], [1, 7, 20], [2, 8, 20], [3, 7, 20], [4, 6, 20], [5, 4, 20], [6, 4, 20]], 1990: [[6, 23, 22], [7, 21, 22], [8, 20, 22], [9, 19, 22], [10, 18, 22], [11, 18, 22], [0, 27, 21], [1, 26, 21], [2, 27, 21], [3, 26, 21], [4, 25, 21], [5, 23, 21]], 1991: [[6, 12, 23], [7, 11, 23], [8, 9, 23], [9, 8, 23], [10, 7, 23], [11, 7, 23], [0, 16, 22], [1, 15, 22], [2, 17, 22], [3, 15, 22], [4, 15, 22], [5, 13, 22]], 1992: [[6, 1, 24], [6, 30, 24], [7, 29, 24], [8, 27, 24], [9, 26, 24], [10, 25, 24], [0, 5, 23, 11, 25, 24], [1, 4, 23], [2, 5, 23], [3, 4, 23], [4, 3, 23], [5, 2, 23]], 1993: [[5, 21, 25], [6, 20, 25], [7, 18, 25], [8, 17, 25], [9, 16, 25], [10, 14, 25], [11, 14, 25], [0, 23, 24], [1, 22, 24], [2, 24, 24], [3, 22, 24], [4, 22, 24]], 1994: [[5, 10, 26], [6, 9, 26], [7, 8, 26], [8, 6, 26], [9, 6, 26], [10, 4, 26], [11, 3, 26], [0, 12, 25], [1, 11, 25], [2, 13, 25], [3, 12, 25], [4, 11, 25]], 1995: [[4, 30, 27], [5, 29, 27], [6, 28, 27], [7, 27, 27], [8, 25, 27], [9, 25, 27], [10, 23, 27], [0, 2, 26, 11, 23, 27], [0, 31, 26], [2, 2, 26], [3, 1, 26], [3, 30, 26]], 1996: [[4, 18, 28], [5, 17, 28], [6, 16, 28], [7, 15, 28], [8, 13, 28], [9, 13, 28], [10, 12, 28], [11, 11, 28], [0, 21, 27], [1, 19, 27], [2, 20, 27], [3, 18, 27]], 1997: [[4, 7, 29], [5, 6, 29], [6, 5, 29], [7, 4, 29], [8, 2, 29], [9, 2, 29], [10, 1, 29], [11, 1, 29], [0, 10, 28, 11, 30, 29], [1, 8, 28], [2, 10, 28], [3, 8, 28]], 1998: [[3, 27, 30], [4, 26, 30], [5, 25, 30], [6, 24, 30], [7, 23, 30], [8, 21, 30], [9, 21, 30], [10, 20, 30], [11, 19, 30], [0, 29, 29], [1, 27, 29], [2, 29, 29]], 1999: [[3, 17, 31], [4, 16, 31], [5, 15, 31], [6, 14, 31], [7, 12, 31], [8, 11, 31], [9, 10, 31], [10, 9, 31], [11, 9, 31], [0, 18, 30], [1, 17, 30], [2, 18, 30]], 2e3: [[3, 6, 32], [4, 5, 32], [5, 3, 32], [6, 3, 32], [7, 1, 32], [7, 30, 32], [8, 28, 32], [9, 28, 32], [10, 27, 32], [0, 8, 31, 11, 27, 32], [1, 7, 31], [2, 7, 31]], 2001: [[2, 26, 33], [3, 25, 33], [4, 24, 33], [5, 22, 33], [6, 22, 33], [7, 20, 33], [8, 18, 33], [9, 17, 33], [10, 16, 33], [11, 16, 33], [0, 26, 32], [1, 24, 32]], 2002: [[2, 15, 34], [3, 14, 34], [4, 13, 34], [5, 12, 34], [6, 11, 34], [7, 10, 34], [8, 8, 34], [9, 7, 34], [10, 6, 34], [11, 5, 34], [0, 15, 33], [1, 13, 33]], 2003: [[2, 4, 35], [3, 3, 35], [4, 2, 35], [5, 1, 35], [6, 1, 35], [6, 30, 35], [7, 29, 35], [8, 27, 35], [9, 26, 35], [10, 25, 35], [0, 4, 34, 11, 24, 35], [1, 2, 34]], 2004: [[1, 21, 36], [2, 22, 36], [3, 20, 36], [4, 20, 36], [5, 19, 36], [6, 18, 36], [7, 17, 36], [8, 15, 36], [9, 15, 36], [10, 14, 36], [11, 13, 36], [0, 23, 35]], 2005: [[1, 10, 37], [2, 11, 37], [3, 10, 37], [4, 9, 37], [5, 8, 37], [6, 7, 37], [7, 6, 37], [8, 5, 37], [9, 4, 37], [10, 3, 37], [11, 3, 37], [0, 12, 36]], 2006: [[0, 31, 38], [2, 1, 38], [2, 30, 38], [3, 29, 38], [4, 28, 38], [5, 26, 38], [6, 26, 38], [7, 25, 38], [8, 24, 38], [9, 23, 38], [10, 22, 38], [0, 1, 37, 11, 22, 38]], 2007: [[0, 20, 39], [1, 19, 39], [2, 20, 39], [3, 18, 39], [4, 18, 39], [5, 16, 39], [6, 15, 39], [7, 14, 39], [8, 13, 39], [9, 13, 39], [10, 11, 39], [11, 11, 39]], 2008: [[0, 10, 40, 11, 29, 41], [1, 8, 40], [2, 9, 40], [3, 7, 40], [4, 6, 40], [5, 5, 40], [6, 4, 40], [7, 2, 40], [8, 1, 40], [9, 1, 40], [9, 30, 40], [10, 29, 40]], 2009: [[11, 18, 42], [0, 27, 41], [1, 26, 41], [2, 28, 41], [3, 26, 41], [4, 25, 41], [5, 24, 41], [6, 23, 41], [7, 22, 41], [8, 20, 41], [9, 20, 41], [10, 18, 41]], 2010: [[11, 7, 43], [0, 16, 42], [1, 15, 42], [2, 17, 42], [3, 15, 42], [4, 15, 42], [5, 13, 42], [6, 13, 42], [7, 11, 42], [8, 10, 42], [9, 9, 42], [10, 7, 42]], 2011: [[10, 26, 44], [0, 5, 43, 11, 26, 44], [1, 4, 43], [2, 6, 43], [3, 5, 43], [4, 4, 43], [5, 3, 43], [6, 2, 43], [7, 1, 43], [7, 30, 43], [8, 29, 43], [9, 28, 43]], 2012: [[10, 15, 45], [11, 14, 45], [0, 24, 44], [1, 23, 44], [2, 24, 44], [3, 22, 44], [4, 22, 44], [5, 21, 44], [6, 20, 44], [7, 19, 44], [8, 17, 44], [9, 17, 44]], 2013: [[10, 4, 46], [11, 4, 46], [0, 13, 45], [1, 11, 45], [2, 13, 45], [3, 11, 45], [4, 11, 45], [5, 10, 45], [6, 9, 45], [7, 8, 45], [8, 7, 45], [9, 6, 45]], 2014: [[9, 25, 47], [10, 23, 47], [0, 2, 46, 11, 23, 47], [1, 1, 46], [2, 2, 46], [3, 1, 46], [3, 30, 46], [4, 30, 46], [5, 28, 46], [6, 28, 46], [7, 27, 46], [8, 25, 46]], 2015: [[9, 14, 48], [10, 13, 48], [11, 12, 48], [0, 21, 47], [1, 20, 47], [2, 21, 47], [3, 20, 47], [4, 19, 47], [5, 18, 47], [6, 17, 47], [7, 16, 47], [8, 14, 47]], 2016: [[9, 2, 49], [10, 1, 49], [10, 30, 49], [0, 11, 48, 11, 30, 49], [1, 10, 48], [2, 10, 48], [3, 8, 48], [4, 8, 48], [5, 6, 48], [6, 6, 48], [7, 4, 48], [8, 2, 48]], 2017: [[8, 21, 50], [9, 21, 50], [10, 19, 50], [11, 19, 50], [0, 29, 49], [1, 28, 49], [2, 29, 49], [3, 27, 49], [4, 27, 49], [5, 25, 49], [6, 24, 49], [7, 23, 49]], 2018: [[8, 11, 51], [9, 10, 51], [10, 9, 51], [11, 8, 51], [0, 18, 50], [1, 17, 50], [2, 18, 50], [3, 17, 50], [4, 16, 50], [5, 15, 50], [6, 14, 50], [7, 12, 50]], 2019: [[7, 31, 52], [8, 30, 52], [9, 29, 52], [10, 28, 52], [0, 7, 51, 11, 27, 52], [1, 6, 51], [2, 8, 51], [3, 6, 51], [4, 6, 51], [5, 4, 51], [6, 4, 51], [7, 2, 51]], 2020: [[7, 20, 53], [8, 18, 53], [9, 18, 53], [10, 16, 53], [11, 16, 53], [0, 26, 52], [1, 25, 52], [2, 25, 52], [3, 24, 52], [4, 24, 52], [5, 22, 52], [6, 22, 52]], 2021: [[7, 9, 54], [8, 8, 54], [9, 7, 54], [10, 6, 54], [11, 5, 54], [0, 14, 53], [1, 13, 53], [2, 14, 53], [3, 13, 53], [4, 13, 53], [5, 11, 53], [6, 11, 53]], 2022: [[6, 30, 55], [7, 28, 55], [8, 27, 55], [9, 26, 55], [10, 25, 55], [0, 4, 54, 11, 25, 55], [1, 2, 54], [2, 4, 54], [3, 2, 54], [4, 2, 54], [4, 31, 54], [5, 30, 54]], 2023: [[6, 19, 56], [7, 17, 56], [8, 16, 56], [9, 16, 56], [10, 15, 56], [11, 14, 56], [0, 23, 55], [1, 21, 55], [2, 23, 55], [3, 21, 55], [4, 21, 55], [5, 19, 55]], 2024: [[6, 7, 57], [7, 5, 57], [8, 4, 57], [9, 4, 57], [10, 3, 57], [11, 3, 57], [0, 13, 56], [1, 11, 56], [2, 11, 56], [3, 10, 56], [4, 9, 56], [5, 7, 56]], 2025: [[5, 26, 58], [6, 26, 58], [7, 24, 58], [8, 23, 58], [9, 23, 58], [10, 22, 58], [0, 1, 57, 11, 21, 58], [0, 31, 57], [2, 1, 57], [2, 30, 57], [3, 29, 57], [4, 28, 57]], 2026: [[5, 16, 59], [6, 15, 59], [7, 14, 59], [8, 12, 59], [9, 12, 59], [10, 11, 59], [11, 10, 59], [0, 20, 58], [1, 18, 58], [2, 20, 58], [3, 18, 58], [4, 18, 58]], 2027: [[5, 6, 60], [6, 5, 60], [7, 3, 60], [8, 2, 60], [9, 1, 60], [9, 31, 60], [10, 29, 60], [0, 9, 59, 11, 29, 60], [1, 8, 59], [2, 9, 59], [3, 8, 59], [4, 7, 59]], 2028: [[4, 25, 61], [5, 24, 61], [6, 23, 61], [7, 22, 61], [8, 20, 61], [9, 19, 61], [10, 18, 61], [11, 17, 61], [0, 28, 60], [1, 26, 60], [2, 27, 60], [3, 26, 60]], 2029: [[4, 14, 62], [5, 13, 62], [6, 13, 62], [7, 11, 62], [8, 10, 62], [9, 9, 62], [10, 7, 62], [11, 7, 62], [0, 16, 61], [1, 14, 61], [2, 16, 61], [3, 15, 61]], 2030: [[4, 3, 63], [5, 2, 63], [6, 2, 63], [7, 1, 63], [7, 30, 63], [8, 29, 63], [9, 28, 63], [10, 26, 63], [0, 5, 62, 11, 26, 63], [1, 4, 62], [2, 5, 62], [3, 4, 62]], 2031: [[3, 23, 64], [4, 22, 64], [5, 21, 64], [6, 21, 64], [7, 20, 64], [8, 18, 64], [9, 17, 64], [10, 16, 64], [11, 15, 64], [0, 24, 63], [1, 23, 63], [2, 24, 63]], 2032: [[3, 11, 65], [4, 10, 65], [5, 9, 65], [6, 9, 65], [7, 8, 65], [8, 6, 65], [9, 6, 65], [10, 4, 65], [11, 4, 65], [0, 14, 64], [1, 12, 64], [2, 13, 64]], 2033: [[3, 1, 66], [3, 30, 66], [4, 29, 66], [5, 28, 66], [6, 28, 66], [7, 26, 66], [8, 25, 66], [9, 24, 66], [10, 23, 66], [0, 2, 65, 11, 23, 66], [1, 1, 65], [2, 2, 65]], 2034: [[2, 21, 67], [3, 20, 67], [4, 19, 67], [5, 17, 67], [6, 17, 67], [7, 15, 67], [8, 14, 67], [9, 13, 67], [10, 12, 67], [11, 12, 67], [0, 21, 66], [1, 20, 66]], 2035: [[2, 11, 68], [3, 9, 68], [4, 9, 68], [5, 7, 68], [6, 6, 68], [7, 5, 68], [8, 3, 68], [9, 2, 68], [10, 1, 68], [11, 1, 68], [0, 11, 67, 11, 30, 68], [1, 9, 67]], 2036: [[1, 28, 69], [2, 29, 69], [3, 27, 69], [4, 27, 69], [5, 25, 69], [6, 24, 69], [7, 23, 69], [8, 21, 69], [9, 20, 69], [10, 19, 69], [11, 19, 69], [0, 29, 68]], 2037: [[1, 16, 70], [2, 18, 70], [3, 17, 70], [4, 16, 70], [5, 15, 70], [6, 14, 70], [7, 12, 70], [8, 11, 70], [9, 10, 70], [10, 8, 70], [11, 8, 70], [0, 17, 69]], 2038: [[1, 5, 71], [2, 7, 71], [3, 6, 71], [4, 5, 71], [5, 4, 71], [6, 3, 71], [7, 2, 71], [7, 31, 71], [8, 30, 71], [9, 29, 71], [10, 27, 71], [0, 7, 70, 11, 27, 71]], 2039: [[0, 26, 72], [1, 24, 72], [2, 26, 72], [3, 24, 72], [4, 24, 72], [5, 23, 72], [6, 22, 72], [7, 21, 72], [8, 19, 72], [9, 19, 72], [10, 17, 72], [11, 17, 72]], 2040: [[0, 15, 73], [1, 14, 73], [2, 14, 73], [3, 13, 73], [4, 12, 73], [5, 11, 73], [6, 10, 73], [7, 9, 73], [8, 7, 73], [9, 7, 73], [10, 6, 73], [11, 5, 73]], 2041: [[0, 4, 74, 11, 24, 75], [1, 2, 74], [2, 4, 74], [3, 2, 74], [4, 1, 74], [4, 31, 74], [5, 29, 74], [6, 29, 74], [7, 28, 74], [8, 26, 74], [9, 26, 74], [10, 25, 74]], 2042: [[11, 14, 76], [0, 23, 75], [1, 21, 75], [2, 23, 75], [3, 21, 75], [4, 20, 75], [5, 19, 75], [6, 18, 75], [7, 17, 75], [8, 15, 75], [9, 15, 75], [10, 14, 75]], 2043: [[11, 3, 77], [0, 12, 76], [1, 11, 76], [2, 12, 76], [3, 11, 76], [4, 10, 76], [5, 8, 76], [6, 8, 76], [7, 6, 76], [8, 4, 76], [9, 4, 76], [10, 3, 76]], 2044: [[10, 21, 78], [0, 2, 77, 11, 21, 78], [0, 31, 77], [2, 1, 77], [2, 30, 77], [3, 29, 77], [4, 28, 77], [5, 26, 77], [6, 26, 77], [7, 24, 77], [8, 23, 77], [9, 22, 77]], 2045: [[10, 10, 79], [11, 10, 79], [0, 19, 78], [1, 18, 78], [2, 20, 78], [3, 18, 78], [4, 18, 78], [5, 16, 78], [6, 15, 78], [7, 14, 78], [8, 12, 78], [9, 12, 78]], 2046: [[9, 31, 80], [10, 29, 80], [0, 8, 79, 11, 28, 80], [1, 7, 79], [2, 9, 79], [3, 7, 79], [4, 7, 79], [5, 5, 79], [6, 5, 79], [7, 3, 79], [8, 2, 79], [9, 1, 79]], 2047: [[9, 20, 81], [10, 19, 81], [11, 18, 81], [0, 27, 80], [1, 26, 80], [2, 27, 80], [3, 26, 80], [4, 26, 80], [5, 24, 80], [6, 24, 80], [7, 23, 80], [8, 21, 80]], 2048: [[9, 9, 82], [10, 7, 82], [11, 7, 82], [0, 16, 81], [1, 15, 81], [2, 16, 81], [3, 14, 81], [4, 14, 81], [5, 12, 81], [6, 12, 81], [7, 11, 81], [8, 10, 81]], 2049: [[8, 28, 83], [9, 28, 83], [10, 26, 83], [0, 5, 82, 11, 26, 83], [1, 3, 82], [2, 5, 82], [3, 3, 82], [4, 3, 82], [5, 2, 82], [6, 1, 82], [6, 31, 82], [7, 30, 82]], 2050: [[8, 17, 84], [9, 17, 84], [10, 15, 84], [11, 15, 84], [0, 24, 83], [1, 23, 83], [2, 24, 83], [3, 22, 83], [4, 22, 83], [5, 20, 83], [6, 20, 83], [7, 19, 83]], 2051: [[8, 6, 85], [9, 6, 85], [10, 5, 85], [11, 4, 85], [0, 14, 84], [1, 12, 84], [2, 14, 84], [3, 12, 84], [4, 11, 84], [5, 10, 84], [6, 9, 84], [7, 8, 84]], 2052: [[7, 26, 86], [8, 24, 86], [9, 24, 86], [10, 22, 86], [0, 3, 85, 11, 22, 86], [1, 2, 85], [2, 2, 85], [3, 1, 85], [3, 30, 85], [4, 29, 85], [5, 28, 85], [6, 27, 85]], 2053: [[7, 15, 87], [8, 13, 87], [9, 13, 87], [10, 11, 87], [11, 11, 87], [0, 21, 86], [1, 20, 86], [2, 21, 86], [3, 20, 86], [4, 19, 86], [5, 17, 86], [6, 17, 86]], 2054: [[7, 5, 88], [8, 3, 88], [9, 2, 88], [10, 1, 88], [10, 30, 88], [0, 10, 87, 11, 30, 88], [1, 9, 87], [2, 10, 87], [3, 9, 87], [4, 9, 87], [5, 7, 87], [6, 6, 87]], 2055: [[6, 25, 89], [7, 24, 89], [8, 22, 89], [9, 21, 89], [10, 20, 89], [11, 19, 89], [0, 29, 88], [1, 27, 88], [2, 29, 88], [3, 28, 88], [4, 28, 88], [5, 26, 88]], 2056: [[6, 14, 90], [7, 12, 90], [8, 11, 90], [9, 10, 90], [10, 8, 90], [11, 8, 90], [0, 18, 89], [1, 17, 89], [2, 17, 89], [3, 16, 89], [4, 16, 89], [5, 14, 89]], 2057: [[6, 3, 91], [7, 1, 91], [7, 31, 91], [8, 30, 91], [9, 29, 91], [10, 27, 91], [0, 6, 90, 11, 27, 91], [1, 5, 90], [2, 6, 90], [3, 5, 90], [4, 5, 90], [5, 3, 90]], 2058: [[5, 22, 92], [6, 21, 92], [7, 20, 92], [8, 19, 92], [9, 18, 92], [10, 17, 92], [11, 17, 92], [0, 25, 91], [1, 24, 91], [2, 25, 91], [3, 24, 91], [4, 23, 91]], 2059: [[5, 11, 93], [6, 11, 93], [7, 9, 93], [8, 8, 93], [9, 8, 93], [10, 6, 93], [11, 6, 93], [0, 15, 92], [1, 14, 92], [2, 15, 92], [3, 13, 92], [4, 13, 92]], 2060: [[4, 31, 94], [5, 29, 94], [6, 28, 94], [7, 27, 94], [8, 26, 94], [9, 25, 94], [10, 24, 94], [0, 5, 93, 11, 24, 94], [1, 3, 93], [2, 4, 93], [3, 2, 93], [4, 1, 93]], 2061: [[4, 20, 95], [5, 19, 95], [6, 18, 95], [7, 16, 95], [8, 15, 95], [9, 15, 95], [10, 13, 95], [11, 13, 95], [0, 23, 94], [1, 21, 94], [2, 23, 94], [3, 21, 94]], 2062: [[4, 10, 96], [5, 8, 96], [6, 8, 96], [7, 6, 96], [8, 4, 96], [9, 4, 96], [10, 3, 96], [11, 2, 96], [0, 12, 95], [1, 10, 95], [2, 12, 95], [3, 11, 95]], 2063: [[3, 30, 97], [4, 29, 97], [5, 27, 97], [6, 27, 97], [7, 25, 97], [8, 24, 97], [9, 23, 97], [10, 22, 97], [0, 1, 96, 11, 21, 97], [0, 31, 96], [2, 1, 96], [2, 31, 96]], 2064: [[3, 18, 98], [4, 17, 98], [5, 16, 98], [6, 15, 98], [7, 14, 98], [8, 12, 98], [9, 12, 98], [10, 10, 98], [11, 9, 98], [0, 20, 97], [1, 18, 97], [2, 19, 97]], 2065: [[3, 7, 99], [4, 6, 99], [5, 5, 99], [6, 5, 99], [7, 3, 99], [8, 2, 99], [9, 1, 99], [9, 31, 99], [10, 29, 99], [0, 8, 98, 11, 28, 99], [1, 6, 98], [2, 8, 98]], 2066: [[2, 27, 100], [3, 25, 100], [4, 25, 100], [5, 24, 100], [6, 24, 100], [7, 22, 100], [8, 21, 100], [9, 20, 100], [10, 19, 100], [11, 18, 100], [0, 27, 99], [1, 25, 99]], 2067: [[2, 16, 101], [3, 15, 101], [4, 14, 101], [5, 13, 101], [6, 13, 101], [7, 11, 101], [8, 10, 101], [9, 10, 101], [10, 8, 101], [11, 8, 101], [0, 16, 100], [1, 15, 100]], 2068: [[2, 5, 102], [3, 3, 102], [4, 3, 102], [5, 1, 102], [6, 1, 102], [6, 30, 102], [7, 29, 102], [8, 28, 102], [9, 27, 102], [10, 26, 102], [0, 6, 101, 11, 25, 102], [1, 4, 101]], 2069: [[1, 23, 103], [2, 24, 103], [3, 22, 103], [4, 22, 103], [5, 20, 103], [6, 20, 103], [7, 18, 103], [8, 17, 103], [9, 16, 103], [10, 15, 103], [11, 15, 103], [0, 24, 102]], 2070: [[1, 12, 104], [2, 14, 104], [3, 12, 104], [4, 11, 104], [5, 10, 104], [6, 9, 104], [7, 8, 104], [8, 6, 104], [9, 5, 104], [10, 4, 104], [11, 4, 104], [0, 13, 103]], 2071: [[1, 1, 105], [2, 3, 105], [3, 2, 105], [4, 1, 105], [4, 30, 105], [5, 29, 105], [6, 28, 105], [7, 26, 105], [8, 25, 105], [9, 24, 105], [10, 23, 105], [0, 2, 104, 11, 22, 105]], 2072: [[0, 21, 106], [1, 20, 106], [2, 21, 106], [3, 19, 106], [4, 19, 106], [5, 17, 106], [6, 17, 106], [7, 15, 106], [8, 13, 106], [9, 13, 106], [10, 11, 106], [11, 11, 106]], 2073: [[0, 9, 107, 11, 30, 108], [1, 8, 107], [2, 10, 107], [3, 9, 107], [4, 8, 107], [5, 7, 107], [6, 6, 107], [7, 5, 107], [8, 3, 107], [9, 2, 107], [10, 1, 107], [10, 30, 107]], 2074: [[11, 19, 109], [0, 28, 108], [1, 27, 108], [2, 29, 108], [3, 27, 108], [4, 27, 108], [5, 26, 108], [6, 25, 108], [7, 23, 108], [8, 22, 108], [9, 21, 108], [10, 20, 108]], 2075: [[11, 9, 110], [0, 18, 109], [1, 16, 109], [2, 18, 109], [3, 16, 109], [4, 16, 109], [5, 15, 109], [6, 14, 109], [7, 13, 109], [8, 11, 109], [9, 11, 109], [10, 9, 109]], 2076: [[10, 27, 111], [0, 7, 110, 11, 27, 111], [1, 6, 110], [2, 6, 110], [3, 5, 110], [4, 4, 110], [5, 3, 110], [6, 2, 110], [7, 1, 110], [7, 30, 110], [8, 29, 110], [9, 29, 110]], 2077: [null, null, [0, 26, 111], [1, 24, 111], [2, 25, 111], [3, 24, 111], [4, 23, 111], [5, 21, 111], [6, 21, 111], [7, 19, 111], [8, 18, 111], [9, 18, 111]], year: 1389 };
class DX extends m9 {
  constructor(n) {
    super(n), this.calendar = vX;
  }
  get(n) {
    return this.dates.map((t) => {
      const r = new d1(t), M = {
        date: r.toString() + " -0600",
        start: r.setOffset(-6, "h").toTimezone(n),
        end: r.toEndDate().toTimezone(n)
      };
      return this._addSubstitute(t, M), M;
    });
  }
}
var TX = {
  toJalaali: SX,
  toGregorian: q9,
  isValidJalaaliDate: BX,
  isLeapJalaaliYear: h9,
  jalaaliMonthLength: y9,
  jalCal: cs,
  j2d: tr,
  d2j: or,
  g2d: Cr,
  d2g: zs,
  jalaaliToDateObject: W9,
  jalaaliWeek: CX
}, Qe = [
  -61,
  9,
  38,
  199,
  426,
  686,
  756,
  818,
  1111,
  1181,
  1210,
  1635,
  2060,
  2097,
  2192,
  2262,
  2324,
  2394,
  2456,
  3178
];
function SX(e, n, a) {
  return Object.prototype.toString.call(e) === "[object Date]" && (a = e.getDate(), n = e.getMonth() + 1, e = e.getFullYear()), or(Cr(e, n, a));
}
function q9(e, n, a) {
  return zs(tr(e, n, a));
}
function BX(e, n, a) {
  return e >= -61 && e <= 3177 && n >= 1 && n <= 12 && a >= 1 && a <= y9(e, n);
}
function h9(e) {
  return wX(e) === 0;
}
function y9(e, n) {
  return n <= 6 ? 31 : n <= 11 || h9(e) ? 30 : 29;
}
function wX(e) {
  var n = Qe.length, a = Qe[0], t, r, M, b, d;
  if (e < a || e >= Qe[n - 1])
    throw new Error("Invalid Jalaali year " + e);
  for (d = 1; d < n && (t = Qe[d], r = t - a, !(e < t)); d += 1)
    a = t;
  return b = e - a, r - b < 6 && (b = b - r + J0(r + 4, 33) * 33), M = n2(n2(b + 1, 33) - 1, 4), M === -1 && (M = 4), M;
}
function cs(e, n) {
  var a = Qe.length, t = e + 621, r = -14, M = Qe[0], b, d, c, O, A, m, q;
  if (e < M || e >= Qe[a - 1])
    throw new Error("Invalid Jalaali year " + e);
  for (q = 1; q < a && (b = Qe[q], d = b - M, !(e < b)); q += 1)
    r = r + J0(d, 33) * 8 + J0(n2(d, 33), 4), M = b;
  return m = e - M, r = r + J0(m, 33) * 8 + J0(n2(m, 33) + 3, 4), n2(d, 33) === 4 && d - m === 4 && (r += 1), O = J0(t, 4) - J0((J0(t, 100) + 1) * 3, 4) - 150, A = 20 + r - O, n ? { gy: t, march: A } : (d - m < 6 && (m = m - d + J0(d + 4, 33) * 33), c = n2(n2(m + 1, 33) - 1, 4), c === -1 && (c = 4), {
    leap: c,
    gy: t,
    march: A
  });
}
function tr(e, n, a) {
  var t = cs(e, !0);
  return Cr(t.gy, 3, t.march) + (n - 1) * 31 - J0(n, 7) * (n - 7) + a - 1;
}
function or(e) {
  var n = zs(e).gy, a = n - 621, t = cs(a, !1), r = Cr(n, 3, t.march), M, b, d;
  if (d = e - r, d >= 0) {
    if (d <= 185)
      return b = 1 + J0(d, 31), M = n2(d, 31) + 1, {
        jy: a,
        jm: b,
        jd: M
      };
    d -= 186;
  } else
    a -= 1, d += 179, t.leap === 1 && (d += 1);
  return b = 7 + J0(d, 30), M = n2(d, 30) + 1, {
    jy: a,
    jm: b,
    jd: M
  };
}
function Cr(e, n, a) {
  var t = J0((e + J0(n - 8, 6) + 100100) * 1461, 4) + J0(153 * n2(n + 9, 12) + 2, 5) + a - 34840408;
  return t = t - J0(J0(e + 100100 + J0(n - 8, 6), 100) * 3, 4) + 752, t;
}
function zs(e) {
  var n, a, t, r, M;
  return n = 4 * e + 139361631, n = n + J0(J0(4 * e + 183187720, 146097) * 3, 4) * 4 - 3908, a = J0(n2(n, 1461), 4) * 5 + 308, t = J0(n2(a, 153), 5) + 1, r = n2(J0(a, 153), 12) + 1, M = J0(n, 1461) - 100100 + J0(8 - r, 6), {
    gy: M,
    gm: r,
    gd: t
  };
}
function CX(e, n, a) {
  var t = W9(e, n, a).getDay(), r = t == 6 ? 0 : -(t + 1), M = 6 + r;
  return {
    saturday: or(tr(e, n, a + r)),
    friday: or(tr(e, n, a + M))
  };
}
function W9(e, n, a, t, r, M, b) {
  var d = q9(e, n, a);
  return new Date(
    d.gy,
    d.gm - 1,
    d.gd,
    t || 0,
    r || 0,
    M || 0,
    b || 0
  );
}
function J0(e, n) {
  return ~~(e / n);
}
function n2(e, n) {
  return e - ~~(e / n) * n;
}
const EX = /* @__PURE__ */ I2(TX), { toJalaali: XX, toGregorian: PX } = EX;
class kX extends Te {
  /**
   * @param {number} year gregorian year
   * @returns
   */
  inYear(n) {
    const a = XX(n, 1, 1);
    if (this.opts.year && a.jy !== this.opts.year)
      return this;
    const { gy: t, gm: r, gd: M } = PX(this.opts.year || a.jy, this.opts.month, this.opts.day), b = new d1({ year: t, month: r, day: M }).setOffset(this.offset);
    return this.dates.push(b), this;
  }
}
const g9 = {
  L: {
    0: [
      [1.75347045673, 0, 0],
      [0.03341656453, 4.66925680415, 6283.0758499914],
      [34894275e-11, 4.62610242189, 12566.1516999828],
      [3417572e-11, 2.82886579754, 3.523118349],
      [3497056e-11, 2.74411783405, 5753.3848848968],
      [3135899e-11, 3.62767041756, 77713.7714681205],
      [2676218e-11, 4.41808345438, 7860.4193924392],
      [2342691e-11, 6.13516214446, 3930.2096962196],
      [1273165e-11, 2.03709657878, 529.6909650946],
      [1324294e-11, 0.74246341673, 11506.7697697936],
      [901854e-11, 2.04505446477, 26.2983197998],
      [1199167e-11, 1.10962946234, 1577.3435424478],
      [857223e-11, 3.50849152283, 398.1490034082],
      [779786e-11, 1.17882681962, 5223.6939198022],
      [99025e-10, 5.23268072088, 5884.9268465832],
      [753141e-11, 2.53339052847, 5507.5532386674],
      [505267e-11, 4.58292599973, 18849.2275499742],
      [492392e-11, 4.20505711826, 775.522611324],
      [356672e-11, 2.91954114478, 0.0673103028],
      [284125e-11, 1.89869240932, 796.2980068164],
      [242879e-11, 0.34481445893, 5486.777843175],
      [317087e-11, 5.84901948512, 11790.6290886588],
      [271112e-11, 0.31486255375, 10977.078804699],
      [206217e-11, 4.80646631478, 2544.3144198834],
      [205478e-11, 1.86953770281, 5573.1428014331],
      [202318e-11, 2.45767790232, 6069.7767545534],
      [126225e-11, 1.08295459501, 20.7753954924],
      [155516e-11, 0.83306084617, 213.299095438],
      [115132e-11, 0.64544911683, 0.9803210682],
      [102851e-11, 0.63599845579, 4694.0029547076],
      [101724e-11, 4.2667980198, 7.1135470008],
      [99206e-11, 6.20992926918, 2146.1654164752],
      [132212e-11, 3.41118292683, 2942.4634232916],
      [97607e-11, 0.68101342359, 155.4203994342],
      [85128e-11, 1.29870764804, 6275.9623029906],
      [74651e-11, 1.755089133, 5088.6288397668],
      [101895e-11, 0.97569280312, 15720.8387848784],
      [84711e-11, 3.67080093031, 71430.69561812909],
      [73547e-11, 4.67926633877, 801.8209311238],
      [73874e-11, 3.50319414955, 3154.6870848956],
      [78757e-11, 3.03697458703, 12036.4607348882],
      [79637e-11, 1.80791287082, 17260.1546546904],
      [85803e-11, 5.9832263126, 161000.6857376741],
      [56963e-11, 2.78430458592, 6286.5989683404],
      [61148e-11, 1.81839892984, 7084.8967811152],
      [69627e-11, 0.83297621398, 9437.762934887],
      [56116e-11, 4.38694865354, 14143.4952424306],
      [62449e-11, 3.97763912806, 8827.3902698748],
      [51145e-11, 0.28306832879, 5856.4776591154],
      [55577e-11, 3.47006059924, 6279.5527316424],
      [41036e-11, 5.36817592855, 8429.2412664666],
      [51605e-11, 1.33282739866, 1748.016413067],
      [51992e-11, 0.18914947184, 12139.5535091068],
      [49e-8, 0.48735014197, 1194.4470102246],
      [392e-9, 6.16833020996, 10447.3878396044],
      [3557e-10, 1.775968892, 6812.766815086],
      [3677e-10, 6.04133863162, 10213.285546211],
      [36596e-11, 2.56957481827, 1059.3819301892],
      [33296e-11, 0.59310278598, 17789.845619785],
      [35954e-11, 1.70875808777, 2352.8661537718],
      [40938e-11, 2.39850938714, 19651.048481098],
      [30047e-11, 2.73975124088, 1349.8674096588],
      [30412e-11, 0.44294464169, 83996.84731811189],
      [23663e-11, 0.48473622521, 8031.0922630584],
      [23574e-11, 2.06528133162, 3340.6124266998],
      [21089e-11, 4.14825468851, 951.7184062506],
      [24738e-11, 0.21484762138, 3.5904286518],
      [25352e-11, 3.16470891653, 4690.4798363586],
      [22823e-11, 5.22195230819, 4705.7323075436],
      [21419e-11, 1.42563910473, 16730.4636895958],
      [21891e-11, 5.55594302779, 553.5694028424],
      [17481e-11, 4.56052900312, 135.0650800354],
      [19927e-11, 5.22209149316, 12168.0026965746],
      [1986e-10, 5.77470242235, 6309.3741697912],
      [203e-9, 0.37133792946, 283.8593188652],
      [14421e-11, 4.19315052005, 242.728603974],
      [16225e-11, 5.98837767951, 11769.8536931664],
      [15077e-11, 4.1956716337, 6256.7775301916],
      [19124e-11, 3.82219958698, 23581.2581773176],
      [18888e-11, 5.38626892076, 149854.4001348079],
      [14346e-11, 3.72355084422, 38.0276726358],
      [17898e-11, 2.21490566029, 13367.9726311066],
      [12054e-11, 2.62229602614, 955.5997416086],
      [11287e-11, 0.17739329984, 4164.311989613],
      [13973e-11, 4.40134615007, 6681.2248533996],
      [13621e-11, 1.88934516495, 7632.9432596502],
      [12503e-11, 1.13052412208, 5.5229243074],
      [10498e-11, 5.35909979317, 1592.5960136328],
      [9803e-11, 0.99948172646, 11371.7046897582],
      [922e-10, 4.57138585348, 4292.3308329504],
      [10327e-11, 6.19982170609, 6438.4962494256],
      [12003e-11, 1.00351462266, 632.7837393132],
      [10827e-11, 0.32734523824, 103.0927742186],
      [8356e-11, 4.53902748706, 25132.3033999656],
      [10005e-11, 6.0291496328, 5746.271337896],
      [8409e-11, 3.29946177848, 7234.794256242],
      [8006e-11, 5.82145271855, 28.4491874678],
      [10523e-11, 0.93870455544, 11926.2544136688],
      [7686e-11, 3.1214364064, 7238.6755916],
      [9378e-11, 2.62413793196, 5760.4984318976],
      [8127e-11, 6.11227839253, 4732.0306273434],
      [9232e-11, 0.48344234496, 522.5774180938],
      [9802e-11, 5.24413877132, 27511.4678735372],
      [7871e-11, 0.99590133077, 5643.1785636774],
      [8123e-11, 6.27053020099, 426.598190876],
      [9048e-11, 5.33686323585, 6386.16862421],
      [8621e-11, 4.16537179089, 7058.5984613154],
      [6297e-11, 4.71723143652, 6836.6452528338],
      [7575e-11, 3.97381357237, 11499.6562227928],
      [7756e-11, 2.95728422442, 23013.5395395872],
      [7314e-11, 0.60652522715, 11513.8833167944],
      [5955e-11, 2.87641047954, 6283.14316029419],
      [6534e-11, 5.79046406784, 18073.7049386502],
      [7188e-11, 3.99831461988, 74.7815985673],
      [7346e-11, 4.38582423903, 316.3918696566],
      [5413e-11, 5.39199023275, 419.4846438752],
      [5127e-11, 2.36059551778, 10973.55568635],
      [7056e-11, 0.32258442532, 263.0839233728],
      [6624e-11, 3.6647416584, 17298.1823273262],
      [6762e-11, 5.91131766896, 90955.5516944961],
      [4938e-11, 5.73672172371, 9917.6968745098],
      [5547e-11, 2.45152589382, 12352.8526045448],
      [5958e-11, 3.3205134466, 6283.0085396886],
      [4471e-11, 2.06386138131, 7079.3738568078],
      [6153e-11, 1.45823347458, 233141.3144043615],
      [4348e-11, 4.42338625285, 5216.5803728014],
      [6124e-11, 1.07494838623, 19804.8272915828],
      [4488e-11, 3.65285033073, 206.1855484372],
      [402e-10, 0.83995823171, 20.3553193988],
      [5188e-11, 4.06503864016, 6208.2942514241],
      [5307e-11, 0.38216728132, 31441.6775697568],
      [3785e-11, 2.34369213733, 3.881335358],
      [4497e-11, 3.27230792447, 11015.1064773348],
      [4132e-11, 0.92129851256, 3738.761430108],
      [3521e-11, 5.9784480361, 3894.1818295422],
      [4215e-11, 1.90601721876, 245.8316462294],
      [3701e-11, 5.03067498875, 536.8045120954],
      [3866e-11, 1.82632980909, 11856.2186514245],
      [3652e-11, 1.01840564429, 16200.7727245012],
      [339e-10, 0.97784870142, 8635.9420037632],
      [3737e-11, 2.9537891957, 3128.3887650958],
      [3507e-11, 3.71291946317, 6290.1893969922],
      [3086e-11, 3.64646921512, 10.6366653498],
      [3397e-11, 1.10589356888, 14712.317116458],
      [3334e-11, 0.83684903082, 6496.3749454294],
      [2805e-11, 2.58503711584, 14314.1681130498],
      [365e-10, 1.08344142571, 88860.05707098669],
      [3388e-11, 3.20182380957, 5120.6011455836],
      [3252e-11, 3.47857474229, 6133.5126528568],
      [2553e-11, 3.9486902726, 1990.745017041],
      [352e-10, 2.05559692878, 244287.60000722768],
      [2565e-11, 1.56072409371, 23543.23050468179],
      [2621e-11, 3.85639359951, 266.6070417218],
      [2954e-11, 3.39692614359, 9225.539273283],
      [2876e-11, 6.02633318445, 154717.6098876827],
      [2395e-11, 1.16130078696, 10984.1923516998],
      [3161e-11, 1.32798862116, 10873.9860304804],
      [3163e-11, 5.08946546862, 21228.3920235458],
      [2361e-11, 4.27212461943, 6040.3472460174],
      [303e-10, 1.80210001168, 35371.8872659764],
      [2343e-11, 3.57688971514, 10969.9652576982],
      [2618e-11, 2.57870151918, 22483.84857449259],
      [2113e-11, 3.71711179417, 65147.6197681377],
      [2019e-11, 0.81393923319, 170.6728706192],
      [2003e-11, 0.38091017375, 6172.869528772],
      [2506e-11, 3.74378169126, 10575.4066829418],
      [2381e-11, 0.10581361289, 7.046236698],
      [1949e-11, 4.86892513469, 36.0278666774],
      [2074e-11, 4.22802468213, 5650.2921106782],
      [1924e-11, 5.59460549844, 6282.0955289232],
      [1949e-11, 1.06999605576, 5230.807466803],
      [1988e-11, 5.19734705445, 6262.300454499],
      [1887e-11, 3.74365662683, 23.8784377478],
      [1787e-11, 1.25929659066, 12559.038152982],
      [1883e-11, 1.90364058477, 15.252471185],
      [1816e-11, 3.68083794819, 15110.4661198662],
      [1701e-11, 4.41109562589, 110.2063212194],
      [199e-10, 3.93295788548, 6206.8097787158],
      [2103e-11, 0.75354936681, 13521.7514415914],
      [1774e-11, 0.48750515837, 1551.045222648],
      [1882e-11, 0.86685462305, 22003.9146348698],
      [1924e-11, 1.22901099088, 709.9330485583],
      [2073e-11, 4.62531597856, 6037.244203762],
      [1924e-11, 0.60231842492, 6284.0561710596],
      [1596e-11, 3.98332879712, 13916.0191096416],
      [1664e-11, 4.41947015623, 8662.240323563],
      [1971e-11, 1.04560686192, 18209.33026366019],
      [1942e-11, 4.31335979989, 6244.9428143536],
      [1476e-11, 0.93274523818, 2379.1644735716],
      [181e-10, 0.49112137707, 1.4844727083],
      [1346e-11, 1.51574753411, 4136.9104335162],
      [1528e-11, 5.61833568587, 6127.6554505572],
      [1791e-11, 3.22191142746, 39302.096962196],
      [1747e-11, 3.05595292589, 18319.5365848796],
      [1432e-11, 4.51123984264, 20426.571092422],
      [1695e-11, 0.22049418623, 25158.6017197654],
      [1242e-11, 4.46665354536, 17256.6315363414],
      [1463e-11, 4.69248613506, 14945.3161735544],
      [1205e-11, 1.86911906771, 4590.910180489],
      [119e-10, 2.74169967367, 12569.6748183318],
      [1222e-11, 5.18120087481, 5333.9002410216],
      [139e-10, 5.42888623322, 143571.32428481648],
      [1473e-11, 1.70487100866, 11712.9553182308],
      [1362e-11, 2.61069503292, 6062.6632075526],
      [1148e-11, 6.0300843061, 3634.6210245184],
      [1198e-11, 5.15296117339, 10177.2576795336],
      [1266e-11, 0.11422490557, 18422.62935909819],
      [1411e-11, 1.09910890045, 3496.032826134],
      [1349e-11, 2.99804623019, 17654.7805397496],
      [1253e-11, 2.79844902576, 167283.7615876655],
      [1311e-11, 1.609410743, 5481.2549188676],
      [1079e-11, 6.20304501787, 3.2863574178],
      [1181e-11, 1.20653777627, 131.5419616864],
      [1254e-11, 5.45103277799, 6076.8903015542],
      [1036e-11, 2.32136959491, 7342.4577801806],
      [1117e-11, 0.38842340979, 949.1756089698],
      [966e-11, 3.18352079941, 11087.2851259184],
      [1171e-11, 3.39635167732, 12562.6285816338],
      [1121e-11, 0.72631814699, 220.4126424388],
      [1024e-11, 2.19381113265, 11403.676995575],
      [888e-11, 3.91167196431, 4686.8894077068],
      [91e-10, 1.98802695087, 735.8765135318],
      [823e-11, 0.48822202854, 24072.9214697764],
      [1096e-11, 6.17377835617, 5436.9930152402],
      [908e-11, 0.44959148878, 7477.522860216],
      [974e-11, 1.52996313552, 9623.6882766912],
      [84e-10, 1.79540573407, 5429.8794682394],
      [778e-11, 6.17703744517, 38.1330356378],
      [776e-11, 4.09859968447, 14.2270940016],
      [1068e-11, 4.64209577648, 43232.3066584156],
      [954e-11, 1.49985885818, 1162.4747044078],
      [907e-11, 0.86986870809, 10344.2950653858],
      [931e-11, 4.06049877517, 28766.924424484],
      [739e-11, 5.04368192034, 639.897286314],
      [965e-11, 3.44286716197, 1589.0728952838],
      [763e-11, 5.86304776787, 16858.4825329332],
      [953e-11, 4.20801492835, 11190.377900137],
      [708e-11, 1.72432323967, 13095.8426650774],
      [969e-11, 1.64437243011, 29088.811415985],
      [717e-11, 0.16688678895, 11.729352836],
      [962e-11, 3.53101876172, 12416.5885028482],
      [745e-11, 5.77741082302, 12592.4500197826],
      [672e-11, 1.91091228744, 3.9321532631],
      [671e-11, 5.46240758839, 18052.9295431578],
      [675e-11, 6.28311649798, 4535.0594369244],
      [684e-11, 0.39975011401, 5849.3641121146],
      [799e-11, 0.29859056777, 12132.439962106],
      [758e-11, 0.96370719224, 1052.2683831884],
      [782e-11, 5.33875702541, 13517.8701062334],
      [73e-10, 1.70114998543, 17267.26820169119],
      [749e-11, 2.59607005624, 11609.8625440122],
      [734e-11, 2.7842049778, 640.8776073822],
      [688e-11, 5.15097673557, 16496.3613962024],
      [77e-10, 1.62459252416, 4701.1165017084],
      [633e-11, 2.20588443066, 25934.1243310894],
      [76e-10, 4.21317219403, 377.3736079158],
      [584e-11, 2.13420121623, 10557.5941608238],
      [572e-11, 0.24649745829, 9779.1086761254],
      [573e-11, 3.16435264609, 533.2140834436],
      [685e-11, 3.19344289472, 12146.6670561076],
      [675e-11, 0.96179234176, 10454.5013866052],
      [648e-11, 1.46327342554, 6268.8487559898],
      [589e-11, 2.50543543638, 3097.88382272579],
      [551e-11, 5.28106257475, 9388.0059094152],
      [696e-11, 3.6534215555, 4804.209275927],
      [669e-11, 2.5103005926, 2388.8940204492],
      [55e-10, 0.06883090057, 20199.094959633],
      [629e-11, 4.13350997495, 45892.73043315699],
      [678e-11, 6.09190163533, 135.62532501],
      [593e-11, 1.50129499103, 226858.23855437007],
      [542e-11, 3.58582033525, 6148.010769956],
      [599e-11, 6.12058050643, 18875.525869774],
      [682e-11, 5.0221361683, 17253.04110768959],
      [565e-11, 4.29309214275, 11933.3679606696],
      [486e-11, 0.77746204893, 27.4015560968],
      [503e-11, 0.58974557727, 15671.0817594066],
      [616e-11, 4.06539884128, 227.476132789],
      [537e-11, 2.15064382406, 21954.15760939799],
      [669e-11, 6.06995500278, 47162.5163546352],
      [54e-10, 2.83444221432, 5326.7866940208],
      [474e-11, 0.40346826846, 6915.8595893046],
      [532e-11, 5.26131065063, 10988.808157535],
      [582e-11, 3.24533095664, 153.7788104848],
      [641e-11, 3.24711790399, 2107.0345075424],
      [619e-11, 3.08302108547, 33019.0211122046],
      [466e-11, 3.14982369789, 10440.2742926036],
      [466e-11, 0.90708835651, 5966.6839803348],
      [528e-11, 0.8192645447, 813.5502839598],
      [603e-11, 3.81378921927, 316428.22867391503],
      [559e-11, 1.8189498573, 17996.0311682222],
      [437e-11, 2.28631745987, 6303.8512454838],
      [518e-11, 4.86068318058, 20597.2439630412],
      [424e-11, 6.23520018697, 6489.2613984286],
      [518e-11, 6.17617826756, 0.2438174835],
      [404e-11, 5.72804304258, 5642.1982426092],
      [458e-11, 1.34117773914, 6287.0080032545],
      [548e-11, 5.6845445832, 155427.542936241],
      [547e-11, 1.03391472434, 3646.3503773544],
      [428e-11, 4.6980968782, 846.0828347512],
      [413e-11, 6.0252069939, 6279.4854213396],
      [534e-11, 3.03030638223, 66567.48586525429],
      [383e-11, 1.4905558804, 19800.9459562248],
      [411e-11, 5.28384176408, 18451.07854656599],
      [352e-11, 4.68891600525, 4907.3020501456],
      [48e-10, 5.36572651091, 348.924420448],
      [344e-11, 5.89157452889, 6546.1597733642],
      [34e-10, 0.37557440365, 13119.72110282519],
      [434e-11, 4.98417856239, 6702.5604938666],
      [332e-11, 2.6890934443, 29296.6153895786],
      [448e-11, 2.16478480251, 5905.7022420756],
      [344e-11, 2.06546633735, 49.7570254718],
      [315e-11, 1.24023810969, 4061.2192153944],
      [324e-11, 2.30897526929, 5017.508371365],
      [413e-11, 0.17171692945, 6286.6662786432],
      [431e-11, 3.8660110138, 12489.8856287072],
      [349e-11, 4.55372493131, 4933.2084403326],
      [323e-11, 0.41971136084, 10770.8932562618],
      [341e-11, 2.68612860807, 11.0457002639],
      [316e-11, 3.52966641606, 17782.7320727842],
      [315e-11, 5.63357264999, 568.8218740274],
      [34e-10, 3.83571212349, 10660.6869350424],
      [296e-11, 0.62703270489, 20995.3929664494],
      [405e-11, 1.00084965393, 16460.33352952499],
      [414e-11, 1.21998752076, 51092.7260508548],
      [336e-11, 4.71465945215, 6179.9830757728],
      [361e-11, 3.71235613733, 28237.2334593894],
      [327e-11, 1.05606504715, 11919.140866668],
      [327e-11, 6.1422242098, 6254.6266625236],
      [268e-11, 2.47224339737, 664.75604513],
      [269e-11, 1.86210872453, 23141.5583829246],
      [345e-11, 0.93461290184, 6058.7310542895],
      [353e-11, 4.50033650657, 36949.2308084242],
      [344e-11, 6.26166140367, 24356.7807886416],
      [3e-9, 4.46964001975, 6418.1409300268],
      [26e-10, 4.04967464725, 6525.8044539654],
      [298e-11, 2.20018811054, 156137.47598479927],
      [253e-11, 3.49930797865, 29864.334027309],
      [254e-11, 2.44883530154, 5331.3574437408],
      [296e-11, 0.84341183907, 5729.506447149],
      [241e-11, 2.00721298729, 16737.5772365966],
      [311e-11, 1.23668016336, 6281.5913772831],
      [332e-11, 3.55576945724, 7668.6374249425],
      [236e-11, 2.47437156031, 6245.0481773556],
      [264e-11, 4.43924412283, 12964.300703391],
      [257e-11, 1.79654471948, 11080.1715789176],
      [26e-10, 3.3307759606, 5888.4499649322],
      [285e-11, 0.3088636143, 11823.1616394502],
      [29e-10, 5.70141882483, 77.673770428],
      [255e-11, 4.00939662024, 5881.4037282342],
      [253e-11, 4.73318512715, 16723.350142595],
      [228e-11, 0.95333661324, 5540.0857894588],
      [281e-11, 1.29199646396, 22805.7355659936],
      [319e-11, 1.38633229189, 163096.18036118348],
      [224e-11, 1.65156322696, 10027.9031957292],
      [226e-11, 0.34125379653, 17796.9591667858],
      [236e-11, 4.19817431922, 19.66976089979],
      [281e-11, 4.14114899916, 12539.853380183],
      [275e-11, 5.50306930248, 32.5325507914],
      [223e-11, 5.23334210294, 56.8983749356],
      [217e-11, 6.08598789777, 6805.6532680852],
      [228e-11, 5.17114391778, 11720.0688652316],
      [274e-11, 4.50716805713, 6016.4688082696],
      [245e-11, 3.96486270306, 22.7752014508],
      [22e-10, 4.7207808197, 6.62855890001],
      [207e-11, 5.71701403951, 41.5507909848],
      [204e-11, 3.9122741125, 2699.7348193176],
      [209e-11, 0.86881969024, 6321.1035226272],
      [2e-9, 2.11984442601, 4274.5183108324],
      [2e-9, 5.39839888151, 6019.9919266186],
      [209e-11, 5.67606291663, 11293.4706743556],
      [252e-11, 1.6496572935, 9380.9596727172],
      [275e-11, 5.04826903506, 73.297125859],
      [208e-11, 1.88207277133, 11300.5842213564],
      [206e-11, 5.0728488933, 6277.552925684],
      [272e-11, 0.74640924904, 1975.492545856],
      [199e-11, 3.30813142103, 22743.4093795164],
      [269e-11, 4.48560812155, 64471.99124174489],
      [192e-11, 2.17463565107, 5863.5912061162],
      [228e-11, 5.85373115869, 128.0188433374],
      [261e-11, 2.64321183295, 55022.9357470744],
      [196e-11, 2.4853762232, 16062.1845261168],
      [187e-11, 1.3189176028, 29826.3063546732],
      [22e-10, 5.75012110079, 29.429508536],
      [187e-11, 4.03230554718, 467.9649903544],
      [2e-9, 5.60555262896, 1066.49547719],
      [231e-11, 1.09802712785, 12341.8069042809],
      [198e-11, 0.29474229005, 149.5631971346],
      [249e-11, 5.1047702317, 7875.6718636242],
      [179e-11, 0.87066197995, 12721.572099417],
      [203e-11, 1.56914310573, 28286.9904848612],
      [198e-11, 3.54061588502, 30.914125635],
      [171e-11, 3.45366018621, 5327.4761083828],
      [183e-11, 0.72325421604, 6272.0301497275],
      [216e-11, 2.97175184412, 19402.7969528166],
      [168e-11, 2.51559879907, 23937.856389741],
      [195e-11, 0.09045393425, 156.4007205024],
      [216e-11, 0.42162375972, 23539.7073863328],
      [189e-11, 0.37542530191, 9814.6041002912],
      [207e-11, 2.01752547259, 238004.5241572363],
      [218e-11, 2.36835893645, 16627.3709153772],
      [166e-11, 4.23182960518, 16840.67001081519],
      [2e-9, 2.02153258098, 16097.6799502826],
      [169e-11, 0.91318727, 95.9792272178],
      [211e-11, 5.73370637657, 151.8972810852],
      [204e-11, 0.42643085174, 515.463871093],
      [212e-11, 3.00223140894, 12043.574281889],
      [192e-11, 5.46153589821, 6379.0550772092],
      [16e-10, 6.23798383332, 202.2533951741],
      [215e-11, 0.20889073407, 5621.8429232104],
      [15e-10, 3.12999753018, 799.8211251654],
      [187e-11, 2.12345787867, 491.6632924588],
      [192e-11, 1.33928820063, 394.6258850592],
      [149e-11, 2.65697593276, 21.335640467],
      [146e-11, 5.58021191726, 412.3710968744],
      [156e-11, 3.7565767638, 12323.4230960088],
      [143e-11, 3.28248547724, 29.8214381488],
      [144e-11, 1.07862546598, 1265.5674786264],
      [148e-11, 0.2338663109, 10021.8372800994],
      [164e-11, 0.94288727597, 14919.0178537546],
      [193e-11, 5.92751083827, 40879.4405046438],
      [14e-10, 4.97612440269, 158.9435177832],
      [148e-11, 2.61651818006, 17157.0618804718],
      [14e-10, 3.66947933935, 26084.0218062162],
      [147e-11, 5.09968173403, 661.232926781],
      [147e-11, 1.36976712162, 4171.4255366138],
      [134e-11, 4.79432636012, 111.1866422876],
      [14e-10, 1.27748013377, 107.6635239386],
      [171e-11, 2.77586207403, 26735.9452622132],
      [183e-11, 5.43418358741, 369.6998159404],
      [134e-11, 3.09132862833, 17.812522118],
      [132e-11, 3.05633896779, 22490.9621214934],
      [181e-11, 4.22950689891, 966.9708774356],
      [166e-11, 3.67660435776, 15508.6151232744],
      [152e-11, 5.28885813387, 12669.2444742014],
      [15e-10, 5.86819430895, 97238.62754448749],
      [145e-11, 5.07330784304, 87.30820453981],
      [133e-11, 5.65471067133, 31.9723058168],
      [124e-11, 2.83326216907, 12566.2190102856],
      [14e-10, 5.84212721453, 22476.73502749179],
      [134e-11, 3.12858101887, 32217.2001810808],
      [137e-11, 0.86487461904, 9924.8104215106],
      [172e-11, 1.98369595114, 174242.4659640497],
      [17e-10, 4.41115280254, 327574.51427678124],
      [128e-11, 4.49087631612, 31415.379249957],
      [151e-11, 0.46542092001, 39609.6545831656],
      [153e-11, 3.78801830344, 17363.24742890899],
      [165e-11, 5.31654110459, 16943.7627850338],
      [165e-11, 4.06747587817, 58953.145443294],
      [118e-11, 0.63846333239, 6.0659156298],
      [159e-11, 0.86086959274, 221995.02880149524],
      [119e-11, 5.96432932413, 1385.8952763362],
      [114e-11, 5.16516114595, 25685.872802808],
      [112e-11, 4.92889233335, 56.8032621698],
      [119e-11, 2.40626699328, 18635.9284545362],
      [115e-11, 0.23374479051, 418.9243989006],
      [113e-11, 2.7938757674, 6272.4391846416],
      [122e-11, 0.936940724, 24492.40611365159],
      [133e-11, 4.87155573413, 22345.2603761082],
      [113e-11, 3.80362889046, 6293.7125153412],
      [13e-10, 3.72996018683, 12573.2652469836],
      [107e-11, 3.40227152756, 21393.5419698576],
      [122e-11, 1.00385670948, 95143.1329209781],
      [14e-10, 1.094130757, 44809.6502008634],
      [112e-11, 6.05462382871, 433.7117378768],
      [123e-11, 4.55640196386, 239424.39025435288],
      [104e-11, 1.54931540602, 127.9515330346],
      [111e-11, 3.04186517428, 8982.810669309],
      [102e-11, 4.12448497391, 15664.03552270859],
      [107e-11, 4.67919356465, 77690.75950573849],
      [118e-11, 4.5232017012, 19004.6479494084],
      [107e-11, 5.71774478555, 77736.78343050249],
      [103e-11, 4.79332126649, 33794.5437235286],
      [143e-11, 1.81201813018, 4214.0690150848],
      [102e-11, 3.7581778657, 58864.5439181463],
      [125e-11, 1.14419195615, 625.6701923124],
      [124e-11, 3.27736513892, 12566.08438968],
      [11e-10, 1.08705709966, 2787.0430238574],
      [102e-11, 4.75119578149, 12242.6462833254],
      [101e-11, 4.91289409429, 401.6721217572],
      [138e-11, 2.89578979744, 9411.4646150872],
      [129e-11, 1.23516042371, 12029.3471878874],
      [138e-11, 2.45654707076, 7576.560073574],
      [98e-11, 5.4477176502, 29026.48522950779],
      [134e-11, 1.43105174912, 86464.6133168312],
      [108e-11, 0.9898977494, 5636.0650166766],
      [117e-11, 5.17362847134, 34520.3093093808],
      [97e-11, 3.34717130592, 16310.9790457206],
      [107e-11, 2.94547931851, 24602.61243487099],
      [98e-11, 4.37041908717, 34513.2630726828],
      [125e-11, 2.72182830814, 24065.80792277559],
      [111e-11, 0.58899131543, 6303.4311693902],
      [102e-11, 0.66938025772, 10239.5838660108],
      [119e-11, 1.21666517886, 1478.8665740644],
      [111e-11, 1.04321934681, 16522.6597160022],
      [94e-11, 4.31076339857, 26880.3198130326],
      [98e-11, 4.14248433763, 6599.467719648],
      [95e-11, 2.89807657534, 34911.412076091],
      [97e-11, 0.89642320201, 71980.63357473118],
      [95e-11, 0.65717727948, 6288.5987742988],
      [116e-11, 4.19967201116, 206.7007372966],
      [95e-11, 1.78315464297, 18139.2945014159],
      [99e-11, 1.37437847718, 1039.0266107904],
      [126e-11, 3.21642544972, 305281.9430710488],
      [94e-11, 0.6899503186, 7834.1210726394],
      [95e-11, 5.58111421744, 3104.9300594238],
      [108e-11, 0.52696637156, 276.7457718644],
      [124e-11, 3.43899862683, 172146.9713405403],
      [87e-11, 1.18764938806, 18842.11400297339],
      [87e-11, 0.09094166389, 15141.390794312],
      [108e-11, 1.03363414379, 82576.9812209953],
      [119e-11, 2.86729109648, 90394.82301305079],
      [104e-11, 3.39218586218, 290.972865866],
      [94e-11, 5.68284937444, 32367.0976562076],
      [117e-11, 0.78475956902, 83286.91426955358],
      [105e-11, 3.96551057233, 6357.8574485587],
      [94e-11, 4.03443174853, 13341.6743113068],
      [96e-11, 0.92742567538, 1062.9050485382],
      [89e-11, 4.45371820659, 792.7748884674],
      [87e-11, 0.40013481685, 90279.92316810328],
      [113e-11, 2.48165313368, 48739.859897083],
      [87e-11, 3.43122851097, 27707.5424942948],
      [101e-11, 5.32081603011, 2301.58581590939],
      [84e-11, 0.67020912458, 28628.3362260996],
      [82e-11, 0.87060089842, 10241.2022911672],
      [86e-11, 4.6206479229, 36147.4098773004],
      [8e-10, 4.77649625396, 6819.8803620868],
      [95e-11, 2.87032913492, 23020.65308658799],
      [107e-11, 5.77864921649, 34115.1140692746],
      [11e-10, 3.32898859416, 72140.6286666874],
      [87e-11, 4.40657711727, 142.1786270362],
      [103e-11, 4.2250672681, 30666.1549584328],
      [82e-11, 3.89404392552, 5547.1993364596],
      [109e-11, 1.94546065204, 24279.10701821359],
      [87e-11, 4.32472045435, 742.9900605326],
      [107e-11, 4.91580912547, 277.0349937414],
      [88e-11, 2.10180817713, 26482.1708096244],
      [86e-11, 4.01895021483, 12491.3701014155],
      [106e-11, 5.49092372854, 62883.3551395136],
      [8e-10, 6.1978570495, 6709.6740408674],
      [105e-11, 2.44166529175, 6298.3283211764],
      [83e-11, 4.90662164029, 51.28033786241],
      [74e-11, 2.34622575625, 7018.9523635232],
      [78e-11, 6.06947270265, 148434.53403769128],
      [79e-11, 3.03048221644, 838.9692877504],
      [73e-11, 3.05008665738, 567.7186377304],
      [102e-11, 3.59223815483, 22380.755800274],
      [84e-11, 0.46604373274, 45.1412196366],
      [92e-11, 4.12917744733, 18216.443810661],
      [91e-11, 0.49382398887, 6453.7487206106],
      [73e-11, 1.72446569088, 21424.4666443034],
      [69e-11, 1.4937267773, 21548.9623692918],
      [69e-11, 4.73181018058, 8858.3149443206],
      [77e-11, 0.47683782532, 11520.9968637952],
      [78e-11, 5.4394263099, 15265.8865193004],
      [77e-11, 2.53773750372, 76.2660712756],
      [69e-11, 2.53932635192, 9910.583327509],
      [75e-11, 0.1559472921, 23006.42599258639],
      [78e-11, 2.41004950269, 6393.2821712108],
      [67e-11, 5.05152846816, 57375.8019008462],
      [77e-11, 3.9107560486, 24383.0791084414],
      [67e-11, 0.78239147387, 12779.4507954208],
      [71e-11, 1.24817900687, 10419.9862835076],
      [67e-11, 5.7785122776, 6311.5250374592],
      [61e-11, 2.66705754411, 18852.7506683232],
      [79e-11, 1.89137330427, 6528.9074962208],
      [84e-11, 5.11523704221, 50317.2034395308],
      [59e-11, 3.38290426621, 35707.7100829074],
      [65e-11, 4.66767908854, 26709.6469424134],
      [79e-11, 5.59773848156, 71960.38658322369],
      [61e-11, 3.30733768968, 18845.7044316252],
      [57e-11, 3.90831298022, 5999.2165311262],
      [58e-11, 3.92572820333, 30348.883772767],
      [61e-11, 0.05695045822, 7856.89627409019],
      [61e-11, 5.63297960691, 7863.9425107882],
      [68e-11, 2.53986117507, 20452.8694122218],
      [53e-11, 5.44021645443, 32370.9789915656],
      [59e-11, 4.95695131145, 11925.2740926006],
      [59e-11, 5.34668243273, 137288.2484348251],
      [56e-11, 4.05779957425, 17892.93839400359],
      [53e-11, 3.94182462468, 18624.8827542723],
      [49e-11, 2.11782803206, 22594.05489571199],
      [62e-11, 2.47154086715, 12345.739057544],
      [49e-11, 5.7659693738, 18606.4989460002],
      [52e-11, 6.20902099741, 21947.1113727],
      [51e-11, 3.13287981215, 33326.5787331742],
      [57e-11, 6.17003357597, 61306.0115970658],
      [64e-11, 5.66596451842, 34596.3646546524],
      [66e-11, 3.922623355, 69853.3520756813],
      [53e-11, 5.51119362049, 77710.24834977149],
      [53e-11, 4.88573986965, 77717.29458646949],
      [48e-11, 2.71399112516, 20760.4270331914],
      [46e-11, 6.08376164442, 29822.7832363242],
      [52e-11, 0.3139748138, 37724.7534197482],
      [45e-11, 5.53587248663, 6262.7205305926],
      [59e-11, 2.45437896854, 69166.430989505],
      [6e-10, 5.24261569842, 56600.2792895222],
      [51e-11, 6.15794342172, 11616.976091013],
      [6e-10, 1.74758109828, 44034.1275895394],
      [49e-11, 5.08973141046, 33990.6183442862],
      [44e-11, 3.28270864884, 29424.634232916],
      [52e-11, 5.34866947943, 28313.288804661],
      [59e-11, 2.12384971916, 36173.7081971002],
      [5e-10, 0.46480931695, 25287.7237993998],
      [44e-11, 2.0550351721, 63658.8777508376],
      [44e-11, 1.71009200258, 13362.4497067992],
      [41e-11, 3.91721318316, 6279.1945146334],
      [42e-11, 1.52106001448, 23550.34405168259],
      [42e-11, 3.10938258068, 84672.47584450469],
      [41e-11, 3.78863023321, 35050.00027447539],
      [42e-11, 5.57543459263, 38500.2760310722],
      [4e-10, 5.55145719363, 12565.1713789146],
      [54e-11, 0.889354921, 50290.905119731],
      [55e-11, 2.50268487636, 77828.671313068],
      [54e-11, 4.16257918787, 22910.44676536859],
      [41e-11, 2.32141215064, 6286.9571853494],
      [45e-11, 3.18590576311, 45585.1728121874],
      [45e-11, 2.24348941683, 23646.32327890039],
      [43e-11, 3.8789211095, 6549.6828917132],
      [48e-11, 2.11364139445, 31570.7996493912],
      [43e-11, 5.55099558987, 12359.9661515456],
      [41e-11, 4.88191569433, 23536.11695768099],
      [49e-11, 2.44790922235, 13613.804277336],
      [47e-11, 3.5818169391, 4797.0957289262]
    ],
    1: [
      [6283.0758499914, 0, 0],
      [0.00206058863, 2.67823455808, 6283.0758499914],
      [4303419e-11, 2.63512233481, 12566.1516999828],
      [425264e-11, 1.59046982018, 3.523118349],
      [109017e-11, 2.96631010675, 1577.3435424478],
      [93479e-11, 2.59211109542, 18849.2275499742],
      [119305e-11, 5.79555765566, 26.2983197998],
      [72121e-11, 1.13840581212, 529.6909650946],
      [67784e-11, 1.87453300345, 398.1490034082],
      [6735e-10, 4.40932832004, 5507.5532386674],
      [59045e-11, 2.88815790631, 5223.6939198022],
      [55976e-11, 2.17471740035, 155.4203994342],
      [45411e-11, 0.39799502896, 796.2980068164],
      [36298e-11, 0.46875437227, 775.522611324],
      [28962e-11, 2.64732254645, 7.1135470008],
      [19097e-11, 1.84628376049, 5486.777843175],
      [20844e-11, 5.34138275149, 0.9803210682],
      [18508e-11, 4.96855179468, 213.299095438],
      [16233e-11, 0.03216587315, 2544.3144198834],
      [17293e-11, 2.9911676063, 6275.9623029906],
      [15832e-11, 1.43049301283, 2146.1654164752],
      [14608e-11, 1.2046979369, 10977.078804699],
      [11877e-11, 3.25805082007, 5088.6288397668],
      [11514e-11, 2.07502080082, 4694.0029547076],
      [9721e-11, 4.2392586526, 1349.8674096588],
      [9969e-11, 1.30263423409, 6286.5989683404],
      [9452e-11, 2.69956827011, 242.728603974],
      [12461e-11, 2.83432282119, 1748.016413067],
      [11808e-11, 5.27379760438, 1194.4470102246],
      [8577e-11, 5.6447608598, 951.7184062506],
      [10641e-11, 0.76614722966, 553.5694028424],
      [7576e-11, 5.30056172859, 2352.8661537718],
      [5764e-11, 1.77228445837, 1059.3819301892],
      [6385e-11, 2.65034514038, 9437.762934887],
      [5223e-11, 5.66135782131, 71430.69561812909],
      [5315e-11, 0.91110018969, 3154.6870848956],
      [6101e-11, 4.66633726278, 4690.4798363586],
      [4335e-11, 0.23934560382, 6812.766815086],
      [5041e-11, 1.42489704722, 6438.4962494256],
      [4259e-11, 0.77355543889, 10447.3878396044],
      [52e-9, 1.85528830215, 801.8209311238],
      [3744e-11, 2.00119905572, 8031.0922630584],
      [3553e-11, 2.42789590229, 14143.4952424306],
      [3372e-11, 3.86210786421, 1592.5960136328],
      [338e-10, 0.88545388924, 12036.4607348882],
      [3196e-11, 3.19713328141, 4705.7323075436],
      [3221e-11, 0.6160104899, 8429.2412664666],
      [4132e-11, 5.23992584671, 7084.8967811152],
      [297e-10, 6.07029819073, 4292.3308329504],
      [29e-9, 2.32464208411, 20.3553193988],
      [3504e-11, 4.79976712702, 6279.5527316424],
      [295e-10, 1.43108874817, 5746.271337896],
      [2697e-11, 4.80365209201, 7234.794256242],
      [2531e-11, 6.22289990904, 6836.6452528338],
      [2745e-11, 0.93466065396, 5760.4984318976],
      [325e-10, 3.39951915286, 7632.9432596502],
      [2278e-11, 5.00339914806, 17789.845619785],
      [2076e-11, 3.95551309007, 10213.285546211],
      [2061e-11, 2.2240771919, 5856.4776591154],
      [2252e-11, 5.67166717686, 11499.6562227928],
      [2148e-11, 5.20182663314, 11513.8833167944],
      [1886e-11, 0.53198539077, 3340.6124266998],
      [1875e-11, 4.73511969924, 83996.84731811189],
      [206e-10, 2.54985307819, 25132.3033999656],
      [1794e-11, 1.47435300254, 4164.311989613],
      [1778e-11, 3.02473091781, 5.5229243074],
      [2036e-11, 0.90908165072, 6256.7775301916],
      [2064e-11, 2.27051326957, 522.5774180938],
      [1773e-11, 3.03090500693, 5753.3848848968],
      [1569e-11, 6.12406216872, 5216.5803728014],
      [159e-10, 4.63713748247, 3.2863574178],
      [1533e-11, 4.20305593883, 13367.9726311066],
      [1427e-11, 1.19087535126, 3894.1818295422],
      [1376e-11, 4.24955891338, 426.598190876],
      [1375e-11, 3.09301252193, 135.0650800354],
      [1308e-11, 3.0849213889, 5643.1785636774],
      [134e-10, 5.76513167968, 6040.3472460174],
      [125e-10, 3.07748196332, 11926.2544136688],
      [1551e-11, 3.07664090662, 6681.2248533996],
      [1148e-11, 3.24144202282, 12168.0026965746],
      [1268e-11, 2.09201189992, 6290.1893969922],
      [1248e-11, 3.44506939791, 536.8045120954],
      [1118e-11, 2.31830078762, 16730.4636895958],
      [1105e-11, 5.31966001019, 23.8784377478],
      [1012e-11, 3.74953487087, 7860.4193924392],
      [1025e-11, 2.4468377161, 1990.745017041],
      [962e-11, 0.81771017882, 3.881335358],
      [911e-11, 0.41724352112, 7079.3738568078],
      [1091e-11, 3.98233608618, 11506.7697697936],
      [957e-11, 4.07671436153, 6127.6554505572],
      [835e-11, 5.28348689371, 11790.6290886588],
      [802e-11, 3.88779080089, 10973.55568635],
      [773e-11, 2.41044394817, 1589.0728952838],
      [758e-11, 1.30034365873, 103.0927742186],
      [749e-11, 4.96281442361, 6496.3749454294],
      [765e-11, 3.36312388424, 36.0278666774],
      [915e-11, 5.41549763095, 206.1855484372],
      [776e-11, 2.57589060224, 11371.7046897582],
      [772e-11, 3.98363364977, 955.5997416086],
      [749e-11, 5.17900231417, 10969.9652576982],
      [806e-11, 0.34226117299, 9917.6968745098],
      [728e-11, 5.20962563787, 38.0276726358],
      [685e-11, 2.77592961854, 20.7753954924],
      [636e-11, 4.28242193632, 28.4491874678],
      [608e-11, 5.63278510221, 10984.1923516998],
      [704e-11, 5.60739437733, 3738.761430108],
      [685e-11, 0.38876148682, 15.252471185],
      [601e-11, 0.73489602442, 419.4846438752],
      [716e-11, 2.65286869987, 6309.3741697912],
      [584e-11, 5.54508741381, 17298.1823273262],
      [628e-11, 1.11733054796, 7058.5984613154],
      [688e-11, 2.59684132401, 3496.032826134],
      [485e-11, 0.44470714066, 12352.8526045448],
      [562e-11, 2.82510352358, 3930.2096962196],
      [597e-11, 5.27675789973, 10575.4066829418],
      [583e-11, 3.1893153986, 4732.0306273434],
      [526e-11, 5.01737745304, 5884.9268465832],
      [54e-10, 1.29182747488, 640.8776073822],
      [481e-11, 5.49721461067, 5230.807466803],
      [406e-11, 5.21253018484, 220.4126424388],
      [395e-11, 1.87489912123, 16200.7727245012],
      [367e-11, 0.88533542945, 6283.14316029419],
      [369e-11, 3.84778078192, 18073.7049386502],
      [379e-11, 0.37991716505, 10177.2576795336],
      [356e-11, 3.84152910109, 11712.9553182308],
      [374e-11, 5.01577520608, 7.046236698],
      [381e-11, 4.30250406634, 6062.6632075526],
      [471e-11, 0.86388942467, 6069.7767545534],
      [367e-11, 1.3294383993, 6283.0085396886],
      [46e-10, 5.19667219582, 6284.0561710596],
      [333e-11, 5.54250425107, 4686.8894077068],
      [341e-11, 4.36524495363, 7238.6755916],
      [336e-11, 4.00205876835, 3097.88382272579],
      [359e-11, 6.22679790284, 245.8316462294],
      [307e-11, 2.35299010924, 170.6728706192],
      [343e-11, 3.77164927142, 6076.8903015542],
      [296e-11, 5.44138799494, 17260.1546546904],
      [328e-11, 0.13817705132, 11015.1064773348],
      [269e-11, 1.13308244952, 12569.6748183318],
      [263e-11, 0.0055073751, 4136.9104335162],
      [282e-11, 5.04399588559, 7477.522860216],
      [28e-10, 3.13703211405, 12559.038152982],
      [259e-11, 0.93882269388, 5642.1982426092],
      [292e-11, 1.98426314297, 12132.439962106],
      [247e-11, 3.84244798673, 5429.8794682394],
      [319e-11, 5.0417014879, 90617.7374312997],
      [245e-11, 5.70469737024, 65147.6197681377],
      [318e-11, 1.35581968834, 78051.5857313169],
      [241e-11, 0.99469787369, 3634.6210245184],
      [246e-11, 3.06168069393, 110.2063212194],
      [239e-11, 6.11854529589, 11856.2186514245],
      [267e-11, 0.65297608414, 21228.3920235458],
      [262e-11, 1.51070507866, 12146.6670561076],
      [23e-10, 1.75923794017, 9779.1086761254],
      [223e-11, 2.00967043606, 6172.869528772],
      [246e-11, 1.10411690861, 6282.0955289232],
      [214e-11, 4.03840492266, 14314.1681130498],
      [212e-11, 2.13695623228, 5849.3641121146],
      [207e-11, 3.07724246401, 11.729352836],
      [207e-11, 6.10303325026, 23543.23050468179],
      [266e-11, 1.00720021877, 2388.8940204492],
      [217e-11, 6.27840212312, 17267.26820169119],
      [231e-11, 5.37372783468, 13916.0191096416],
      [204e-11, 2.34615348695, 266.6070417218],
      [195e-11, 5.55015549753, 6133.5126528568],
      [203e-11, 4.65616806503, 24072.9214697764],
      [188e-11, 2.52682282169, 6525.8044539654],
      [177e-11, 1.73426919199, 154717.6098876827],
      [187e-11, 4.76501318048, 4535.0594369244],
      [186e-11, 4.63080493407, 10440.2742926036],
      [183e-11, 3.20060840641, 8635.9420037632],
      [172e-11, 1.45551703877, 9225.539273283],
      [162e-11, 3.30665137166, 639.897286314],
      [168e-11, 2.17671416605, 27.4015560968],
      [16e-10, 1.6816871275, 15110.4661198662],
      [194e-11, 2.79243768345, 7342.4577801806],
      [183e-11, 0.56273524797, 13517.8701062334],
      [172e-11, 5.97039514134, 4701.1165017084],
      [179e-11, 3.58450811616, 87.30820453981],
      [152e-11, 2.84070476839, 5650.2921106782],
      [156e-11, 1.07156076421, 18319.5365848796],
      [182e-11, 0.44053620124, 17253.04110768959],
      [142e-11, 1.4629013752, 11087.2851259184],
      [131e-11, 5.40912137746, 2699.7348193176],
      [144e-11, 2.07312089638, 25158.6017197654],
      [147e-11, 6.15107800602, 9623.6882766912],
      [141e-11, 5.55739979498, 10454.5013866052],
      [135e-11, 0.0609812943, 16723.350142595],
      [123e-11, 5.81194797368, 17256.6315363414],
      [124e-11, 2.36269386269, 4933.2084403326],
      [126e-11, 3.47483886466, 22483.84857449259],
      [159e-11, 5.63944722033, 5729.506447149],
      [137e-11, 1.93811728826, 20426.571092422],
      [123e-11, 3.92815962825, 17996.0311682222],
      [148e-11, 3.02542567608, 1551.045222648],
      [121e-11, 0.05537321071, 13095.8426650774],
      [12e-10, 5.91904349732, 6206.8097787158],
      [134e-11, 3.11122937825, 21954.15760939799],
      [119e-11, 5.52143897201, 709.9330485583],
      [122e-11, 3.00840036775, 19800.9459562248],
      [127e-11, 1.37534182407, 14945.3161735544],
      [141e-11, 2.56886299638, 1052.2683831884],
      [123e-11, 2.83671175442, 11919.140866668],
      [118e-11, 0.81918292547, 5331.3574437408],
      [151e-11, 2.68728567951, 11769.8536931664],
      [119e-11, 5.08654046247, 5481.2549188676],
      [113e-11, 4.42675663942, 18422.62935909819],
      [153e-11, 2.46021790779, 11933.3679606696],
      [108e-11, 1.04936452151, 11403.676995575],
      [128e-11, 0.99810456461, 8827.3902698748],
      [144e-11, 2.54869747042, 227.476132789],
      [15e-10, 4.50631437136, 2379.1644735716],
      [109e-11, 0.29269062317, 16737.5772365966],
      [122e-11, 4.23040027813, 29.429508536],
      [111e-11, 5.16970710025, 17782.7320727842],
      [105e-11, 1.61738153441, 13119.72110282519],
      [1e-9, 3.52204690579, 18052.9295431578],
      [108e-11, 1.08493117155, 16858.4825329332],
      [135e-11, 3.2016061697, 6262.300454499],
      [106e-11, 1.96085069786, 74.7815985673],
      [129e-11, 4.85949366504, 16496.3613962024],
      [11e-10, 2.30605777952, 16460.33352952499],
      [97e-11, 3.5091894021, 5333.9002410216],
      [99e-11, 3.56417337974, 735.8765135318],
      [96e-11, 3.40918487598, 15720.8387848784],
      [94e-11, 5.01601027363, 3128.3887650958],
      [97e-11, 1.65579893894, 533.2140834436],
      [92e-11, 0.89219199493, 29296.6153895786],
      [123e-11, 3.16062062663, 9380.9596727172],
      [102e-11, 1.20493500565, 23020.65308658799],
      [88e-11, 2.21265504437, 12721.572099417],
      [89e-11, 1.5432266957, 20199.094959633],
      [121e-11, 6.19860353182, 9388.0059094152],
      [89e-11, 4.08082274765, 22805.7355659936],
      [98e-11, 1.09176668094, 12043.574281889],
      [86e-11, 1.13649001466, 143571.32428481648],
      [88e-11, 5.96980472191, 107.6635239386],
      [82e-11, 5.01561173481, 22003.9146348698],
      [94e-11, 1.69615700473, 23006.42599258639],
      [81e-11, 3.00664741995, 2118.7638603784],
      [98e-11, 1.39215287161, 8662.240323563],
      [8e-10, 5.16340988714, 17796.9591667858],
      [82e-11, 5.86893959287, 2787.0430238574],
      [77e-11, 0.80723694712, 167283.7615876655],
      [91e-11, 5.74902425304, 21424.4666443034],
      [76e-11, 5.67183650604, 14.2270940016],
      [81e-11, 6.16619455699, 1039.0266107904],
      [76e-11, 3.21449884756, 111.1866422876],
      [78e-11, 1.37531518377, 21947.1113727],
      [74e-11, 3.58814195051, 11609.8625440122],
      [77e-11, 4.84846488388, 22743.4093795164],
      [9e-10, 1.48869013606, 15671.0817594066],
      [82e-11, 3.48618398216, 29088.811415985],
      [71e-11, 2.2159156119, 12029.3471878874],
      [69e-11, 1.93625656075, 135.62532501],
      [7e-10, 2.66552760898, 18875.525869774],
      [69e-11, 5.41478093731, 26735.9452622132],
      [79e-11, 5.15158156951, 12323.4230960088],
      [78e-11, 4.17014063638, 1066.49547719],
      [65e-11, 5.64584720343, 12139.5535091068],
      [71e-11, 3.89804774037, 22779.4372461938],
      [63e-11, 4.53968787714, 8982.810669309],
      [76e-11, 3.29088891716, 2942.4634232916],
      [69e-11, 0.94232113005, 14919.0178537546],
      [63e-11, 4.0918653549, 16062.1845261168],
      [65e-11, 3.34580407184, 51.28033786241],
      [65e-11, 5.75757544877, 52670.0695933026],
      [57e-11, 5.25050277534, 20995.3929664494],
      [61e-11, 1.92290673861, 6805.6532680852],
      [61e-11, 0.08878901558, 13362.4497067992],
      [76e-11, 1.86947679415, 25287.7237993998],
      [56e-11, 4.25396542622, 6709.6740408674],
      [58e-11, 4.79429715781, 6286.3622074092],
      [73e-11, 0.53299090807, 2301.58581590939],
      [7e-10, 4.31243357502, 19402.7969528166],
      [67e-11, 2.53852336668, 377.3736079158],
      [56e-11, 3.20816844695, 24889.5747959916],
      [54e-11, 5.17336469511, 26084.0218062162],
      [53e-11, 3.17675406016, 18451.07854656599],
      [53e-11, 3.61529270216, 77.673770428],
      [53e-11, 0.45467549335, 30666.1549584328],
      [53e-11, 2.97761644192, 21548.9623692918],
      [61e-11, 0.14805728543, 23013.5395395872],
      [51e-11, 3.32803972907, 56.8983749356],
      [52e-11, 3.41304011355, 23141.5583829246],
      [58e-11, 3.13638677202, 309.2783226558],
      [54e-11, 1.60896548545, 13341.6743113068],
      [53e-11, 5.81426394852, 16193.65917750039],
      [67e-11, 6.27917920454, 22345.2603761082],
      [5e-10, 0.42577644151, 25685.872802808],
      [48e-11, 0.70204553352, 1162.4747044078],
      [66e-11, 3.64350022359, 15265.8865193004],
      [5e-10, 5.7438291744, 19.66976089979],
      [54e-11, 1.97277370837, 23581.2581773176],
      [51e-11, 1.23713196525, 12539.853380183],
      [46e-11, 5.41431704639, 33019.0211122046],
      [46e-11, 4.80640843261, 19651.048481098],
      [5e-10, 1.23847511223, 22476.73502749179],
      [51e-11, 4.91913434178, 12592.4500197826],
      [46e-11, 2.41369976086, 98068.53671630539],
      [45e-11, 3.45227074337, 30774.5016425748],
      [45e-11, 4.39659083856, 433.7117378768],
      [45e-11, 3.71921056816, 18209.33026366019],
      [44e-11, 2.47683925106, 24356.7807886416],
      [49e-11, 2.17835058609, 13521.7514415914],
      [46e-11, 0.26142733448, 11.0457002639],
      [45e-11, 2.46230645202, 51868.2486621788],
      [43e-11, 4.29458463014, 28230.18722269139],
      [48e-11, 0.89551707131, 56600.2792895222],
      [42e-11, 3.63410684699, 4590.910180489],
      [49e-11, 3.17757670967, 6303.8512454838],
      [43e-11, 4.93350349236, 10021.8372800994],
      [52e-11, 3.65410195699, 7872.1487452752],
      [41e-11, 4.82166756935, 10988.808157535],
      [4e-10, 1.81891629936, 34596.3646546524],
      [43e-11, 1.94164978061, 1903.4368125012],
      [41e-11, 0.74461854136, 23937.856389741],
      [45e-11, 5.4557501753, 60530.4889857418],
      [5e-10, 5.67355640472, 18216.443810661],
      [4e-10, 0.04502010161, 38526.574350872],
      [53e-11, 3.64807615995, 11925.2740926006],
      [42e-11, 5.19292937193, 19004.6479494084],
      [41e-11, 0.94309683296, 9924.8104215106],
      [39e-11, 4.61184303844, 95.9792272178],
      [49e-11, 2.05532526216, 12573.2652469836],
      [45e-11, 3.73717824543, 7875.6718636242],
      [43e-11, 1.14078465002, 49.7570254718],
      [39e-11, 1.70539366023, 32217.2001810808],
      [37e-11, 1.29390383811, 310.8407988684],
      [38e-11, 0.9597092595, 664.75604513],
      [39e-11, 0.85957361635, 16522.6597160022],
      [4e-10, 1.00170796001, 36949.2308084242],
      [4e-10, 3.78164718776, 55798.4583583984],
      [37e-11, 5.42237070904, 6286.6662786432],
      [36e-11, 1.68167662194, 10344.2950653858],
      [4e-10, 5.13217319067, 15664.03552270859],
      [49e-11, 3.62741283878, 77713.7714681205],
      [45e-11, 6.15877872538, 28286.9904848612],
      [36e-11, 3.32158458257, 16207.886271502],
      [35e-11, 5.83917764292, 6321.1035226272],
      [36e-11, 1.80784164083, 6279.7894925736],
      [35e-11, 4.60279245362, 28237.2334593894],
      [33e-11, 0.47301775923, 18635.9284545362],
      [35e-11, 4.36571027474, 48739.859897083],
      [31e-11, 3.06828028412, 6819.8803620868],
      [31e-11, 2.4020319848, 28628.3362260996],
      [34e-11, 1.90096411242, 12964.300703391],
      [29e-11, 6.09291010354, 18606.4989460002],
      [28e-11, 3.42046112698, 6288.5987742988],
      [28e-11, 3.437361406, 34115.1140692746],
      [29e-11, 1.48920816078, 6489.2613984286],
      [28e-11, 3.07474749886, 29822.7832363242],
      [38e-11, 2.44608264663, 31415.379249957],
      [28e-11, 2.98392582088, 6277.552925684],
      [27e-11, 5.03556015623, 12779.4507954208],
      [27e-11, 5.40812977287, 26087.9031415742],
      [38e-11, 5.56439937893, 27832.0382192832],
      [26e-11, 3.87685883153, 6262.7205305926],
      [27e-11, 6.1556539284, 28759.81087748319],
      [25e-11, 5.17122153205, 6915.8595893046],
      [27e-11, 4.03132006944, 9910.583327509],
      [33e-11, 3.97763407373, 12410.7313005486],
      [24e-11, 5.31307120044, 29026.48522950779],
      [25e-11, 0.81055213297, 36173.7081971002],
      [24e-11, 1.2870610131, 24491.4257925834],
      [21e-11, 2.02548478742, 28766.924424484],
      [21e-11, 6.07545114034, 18139.2945014159],
      [22e-11, 2.31199937131, 6303.4311693902],
      [23e-11, 1.35235057478, 49515.382508407],
      [23e-11, 2.92765926961, 65236.2212932854],
      [19e-11, 0.03636659763, 29864.334027309],
      [2e-10, 0.91374066194, 45585.1728121874],
      [21e-11, 4.45003013294, 22490.9621214934],
      [22e-11, 1.97119365888, 34513.2630726828],
      [2e-10, 4.11682669951, 17157.0618804718],
      [24e-11, 1.40243942415, 14712.317116458],
      [22e-11, 2.19759737115, 31570.7996493912],
      [21e-11, 1.48739821208, 61306.0115970658],
      [25e-11, 5.71465573409, 25934.1243310894]
    ],
    2: [
      [8721859e-11, 1.07253635559, 6283.0758499914],
      [99099e-10, 3.14159265359, 0],
      [294833e-11, 0.43717350256, 12566.1516999828],
      [27338e-11, 0.05295636147, 3.523118349],
      [16333e-11, 5.18820215724, 26.2983197998],
      [15745e-11, 3.68504712183, 155.4203994342],
      [9425e-11, 0.29667114694, 18849.2275499742],
      [8938e-11, 2.05706319592, 77713.7714681205],
      [694e-10, 0.82691541038, 775.522611324],
      [5061e-11, 4.6624323168, 1577.3435424478],
      [406e-10, 1.03067032318, 7.1135470008],
      [3464e-11, 5.14021224609, 796.2980068164],
      [3172e-11, 6.05479318507, 5507.5532386674],
      [302e-10, 1.19240008524, 242.728603974],
      [2885e-11, 6.11705865396, 529.6909650946],
      [3809e-11, 3.44043369494, 5573.1428014331],
      [2719e-11, 0.30363248164, 398.1490034082],
      [2365e-11, 4.37666117992, 5223.6939198022],
      [2538e-11, 2.27966434314, 553.5694028424],
      [2078e-11, 3.75435095487, 0.9803210682],
      [1675e-11, 0.90149951436, 951.7184062506],
      [1534e-11, 5.75895831192, 1349.8674096588],
      [1224e-11, 2.97285792195, 2146.1654164752],
      [1449e-11, 4.36401639552, 1748.016413067],
      [1341e-11, 3.72019379666, 1194.4470102246],
      [1253e-11, 2.9488872631, 6438.4962494256],
      [999e-11, 5.98665341008, 6286.5989683404],
      [917e-11, 4.79722195184, 5088.6288397668],
      [829e-11, 3.31021398862, 213.299095438],
      [1102e-11, 1.27094359244, 161000.6857376741],
      [764e-11, 3.41231607038, 5486.777843175],
      [1046e-11, 0.60374190029, 3154.6870848956],
      [887e-11, 5.23364022595, 7084.8967811152],
      [644e-11, 1.59974355582, 2544.3144198834],
      [681e-11, 3.42742947469, 4694.0029547076],
      [606e-11, 2.47688996663, 10977.078804699],
      [706e-11, 6.19369692903, 4690.4798363586],
      [643e-11, 1.98119869589, 801.8209311238],
      [502e-11, 1.44415463861, 6836.6452528338],
      [49e-10, 2.33889753806, 1592.5960136328],
      [458e-11, 1.30867922972, 4292.3308329504],
      [431e-11, 0.03542536476, 7234.794256242],
      [349e-11, 0.98779272263, 6040.3472460174],
      [385e-11, 1.57065592218, 71430.69561812909],
      [371e-11, 3.16149051601, 6309.3741697912],
      [348e-11, 0.64980950594, 1059.3819301892],
      [458e-11, 3.81505682017, 149854.4001348079],
      [302e-11, 1.91723873447, 10447.3878396044],
      [306e-11, 3.55405857884, 8031.0922630584],
      [395e-11, 4.93742673052, 7632.9432596502],
      [314e-11, 3.18058352846, 2352.8661537718],
      [281e-11, 4.41751404023, 9437.762934887],
      [276e-11, 2.71075791682, 3894.1818295422],
      [298e-11, 2.52045757001, 6127.6554505572],
      [272e-11, 0.24370191144, 25132.3033999656],
      [251e-11, 0.55449375765, 6279.5527316424],
      [224e-11, 1.40790249012, 4705.7323075436],
      [258e-11, 5.29510765044, 6812.766815086],
      [178e-11, 0.92636669742, 1990.745017041],
      [217e-11, 0.68543630022, 6256.7775301916],
      [154e-11, 0.77808632062, 14143.4952424306],
      [15e-10, 2.40636982736, 426.598190876],
      [196e-11, 6.06877865012, 640.8776073822],
      [137e-11, 2.21947617717, 8429.2412664666],
      [127e-11, 5.47380312768, 12036.4607348882],
      [121e-11, 3.32740512021, 17789.845619785],
      [123e-11, 2.16004509785, 10213.285546211],
      [116e-11, 0.49705139709, 7058.5984613154],
      [138e-11, 2.36181661472, 11506.7697697936],
      [101e-11, 0.86299995919, 6290.1893969922],
      [118e-11, 5.82317768355, 7860.4193924392],
      [92e-11, 5.11639978593, 7079.3738568078],
      [125e-11, 2.65424538513, 88860.05707098669],
      [88e-11, 4.3118823616, 83996.84731811189],
      [84e-11, 3.57682769713, 16730.4636895958],
      [97e-11, 5.58011309774, 13367.9726311066],
      [102e-11, 2.05853060226, 87.30820453981],
      [8e-10, 4.73827128421, 11926.2544136688],
      [8e-10, 5.41344057121, 10973.55568635],
      [106e-11, 4.10978997399, 3496.032826134],
      [75e-11, 4.89166898876, 5643.1785636774],
      [1e-9, 3.62645659087, 244287.60000722768],
      [96e-11, 1.39443577787, 6681.2248533996],
      [69e-11, 1.88399189965, 10177.2576795336],
      [87e-11, 0.40842153208, 11015.1064773348],
      [66e-11, 0.99444831932, 6525.8044539654],
      [66e-11, 1.42471816453, 9917.6968745098],
      [67e-11, 5.5124099707, 3097.88382272579],
      [76e-11, 2.7156469351, 4164.311989613],
      [85e-11, 0.4965552367, 10575.4066829418],
      [77e-11, 3.51693861509, 11856.2186514245],
      [62e-11, 3.6258762869, 16496.3613962024],
      [54e-11, 5.25957420065, 3340.6124266998],
      [53e-11, 1.10902178415, 8635.9420037632],
      [49e-11, 5.65761054625, 20426.571092422],
      [64e-11, 5.79211164779, 2388.8940204492],
      [46e-11, 5.45092696155, 6275.9623029906],
      [57e-11, 4.97077155798, 14945.3161735544],
      [43e-11, 3.30685683359, 9779.1086761254],
      [42e-11, 1.61412785248, 12168.0026965746],
      [49e-11, 3.92715473768, 5729.506447149],
      [42e-11, 0.6348125893, 2699.7348193176],
      [56e-11, 4.34038639086, 90955.5516944961],
      [4e-10, 5.66871428338, 11712.9553182308],
      [39e-11, 3.10911294009, 16200.7727245012],
      [4e-10, 5.71338386146, 709.9330485583],
      [53e-11, 6.17067257683, 233141.3144043615],
      [37e-11, 0.32095173508, 24356.7807886416],
      [35e-11, 0.95557073457, 17298.1823273262],
      [35e-11, 0.64913397996, 25158.6017197654],
      [41e-11, 1.53850422484, 65147.6197681377],
      [35e-11, 0.77655626359, 13916.0191096416],
      [31e-11, 5.35897350775, 5331.3574437408],
      [3e-10, 4.48114682755, 23543.23050468179],
      [32e-11, 3.45976963453, 7477.522860216],
      [29e-11, 3.46648040769, 13119.72110282519],
      [38e-11, 2.90863974625, 12721.572099417],
      [29e-11, 3.13390968321, 4136.9104335162],
      [35e-11, 3.79717126309, 143571.32428481648],
      [27e-11, 0.95726093828, 12559.038152982],
      [26e-11, 4.9532687703, 5753.3848848968],
      [32e-11, 3.49943896928, 6284.0561710596],
      [26e-11, 4.59276256636, 5884.9268465832],
      [26e-11, 1.53958920253, 154717.6098876827],
      [23e-11, 4.88012908735, 13095.8426650774],
      [23e-11, 0.35935706511, 31415.379249957],
      [24e-11, 5.11515116629, 18319.5365848796],
      [21e-11, 5.73872879912, 12569.6748183318],
      [21e-11, 1.32901200081, 10988.808157535],
      [19e-11, 2.24263229491, 18073.7049386502],
      [19e-11, 3.14253175605, 6496.3749454294],
      [21e-11, 2.80122025076, 6282.0955289232],
      [23e-11, 0.14288760398, 6283.0085396886],
      [19e-11, 4.28209473754, 3930.2096962196],
      [16e-11, 0.25933207663, 11790.6290886588],
      [15e-11, 6.0962350124, 13517.8701062334],
      [2e-10, 5.06358906224, 6283.14316029419],
      [15e-11, 1.0768066315, 4933.2084403326],
      [19e-11, 5.74000581249, 3128.3887650958],
      [16e-11, 6.18924226747, 7342.4577801806],
      [13e-11, 1.69105044945, 4535.0594369244],
      [15e-11, 3.36968394452, 17260.1546546904],
      [1e-10, 3.78885035015, 22003.9146348698],
      [11e-11, 2.12851973876, 7875.6718636242]
    ],
    3: [
      [289058e-11, 5.84173149732, 6283.0758499914],
      [20712e-11, 6.0498393902, 12566.1516999828],
      [2962e-11, 5.1956057957, 155.4203994342],
      [2527e-11, 3.14159265359, 0],
      [1288e-11, 4.7219761197, 3.523118349],
      [635e-11, 5.96904899168, 242.728603974],
      [57e-10, 5.54182903238, 18849.2275499742],
      [402e-11, 3.78606612895, 553.5694028424],
      [72e-11, 4.37131884946, 6286.5989683404],
      [67e-11, 0.91133898967, 6127.6554505572],
      [37e-11, 5.28611190997, 6438.4962494256],
      [21e-11, 2.94917211527, 6309.3741697912],
      [15e-11, 3.63037493932, 71430.69561812909],
      [11e-11, 4.83261533939, 25132.3033999656],
      [11e-11, 5.84259014283, 6525.8044539654],
      [12e-11, 3.82296977522, 7058.5984613154],
      [13e-11, 2.39991715131, 5729.506447149],
      [8e-11, 0.55390332094, 6040.3472460174],
      [8e-11, 1.46298993048, 11856.2186514245],
      [8e-11, 5.07535888338, 6256.7775301916],
      [6e-11, 2.88803526743, 5507.5532386674],
      [5e-11, 3.87019253131, 12036.4607348882],
      [5e-11, 2.70838853362, 83996.84731811189]
    ],
    4: [
      [7714e-11, 4.14117321449, 6283.0758499914],
      [1016e-11, 3.27573644241, 12566.1516999828],
      [42e-10, 0.41892851415, 155.4203994342],
      [47e-11, 3.50591071186, 18849.2275499742],
      [41e-11, 3.14032562331, 3.523118349],
      [35e-11, 5.0111077, 5573.1428014331],
      [1e-10, 5.64816633449, 6127.6554505572],
      [13e-11, 0.48609240774, 77713.7714681205],
      [7e-11, 2.84139222289, 161000.6857376741],
      [4e-11, 3.6550904707, 25132.3033999656],
      [2e-11, 0.54880603487, 6438.4962494256]
    ],
    5: [
      [172e-11, 2.74854172392, 6283.0758499914],
      [5e-10, 2.01352986713, 155.4203994342],
      [28e-11, 2.93369985477, 12566.1516999828],
      [5e-11, 1.93829214518, 18849.2275499742]
    ]
  },
  B: {
    0: [
      [27962e-10, 3.19870156017, 84334.66158130829],
      [101643e-11, 5.42248619256, 5507.5532386674],
      [80445e-11, 3.88013204458, 5223.6939198022],
      [43806e-11, 3.70444689759, 2352.8661537718],
      [31933e-11, 4.00026369781, 1577.3435424478],
      [22724e-11, 3.9847383156, 1047.7473117547],
      [16392e-11, 3.56456119782, 5856.4776591154],
      [18141e-11, 4.98367470262, 6283.0758499914],
      [14443e-11, 3.70275614915, 9437.762934887],
      [14304e-11, 3.41117857526, 10213.285546211],
      [11246e-11, 4.82820690527, 14143.4952424306],
      [109e-9, 2.08574562329, 6812.766815086],
      [9714e-11, 3.47303947751, 4694.0029547076],
      [10367e-11, 4.05663927945, 71092.88135493269],
      [8775e-11, 4.44016515666, 5753.3848848968],
      [8366e-11, 4.99251512183, 7084.8967811152],
      [6921e-11, 4.32559054073, 6275.9623029906],
      [9145e-11, 1.14182646613, 6620.8901131878],
      [7194e-11, 3.60193205744, 529.6909650946],
      [7698e-11, 5.55425745881, 167621.5758508619],
      [5285e-11, 2.48446991536, 4705.7323075436],
      [5208e-11, 6.24992674532, 18073.7049386502],
      [4529e-11, 2.33827747356, 6309.3741697912],
      [5579e-11, 4.41023653719, 7860.4193924392],
      [4743e-11, 0.70995680136, 5884.9268465832],
      [4301e-11, 1.10255777773, 6681.2248533996],
      [3849e-11, 1.82229412532, 5486.777843175],
      [4093e-11, 5.11700141197, 13367.9726311066],
      [3681e-11, 0.43793170336, 3154.6870848956],
      [342e-10, 5.42034800952, 6069.7767545534],
      [3617e-11, 6.04641937568, 3930.2096962196],
      [367e-10, 4.58210192227, 12194.0329146209],
      [2918e-11, 1.95463881136, 10977.078804699],
      [2797e-11, 5.61259274877, 11790.6290886588],
      [2502e-11, 0.60499729368, 6496.3749454294],
      [2319e-11, 5.01648216088, 1059.3819301892],
      [2684e-11, 1.39470396487, 22003.9146348698],
      [2428e-11, 3.24183056545, 78051.5857313169],
      [212e-10, 4.30691000285, 5643.1785636774],
      [2257e-11, 3.15557225087, 90617.7374312997],
      [1813e-11, 3.75574218286, 3340.6124266998],
      [2226e-11, 2.79699346673, 12036.4607348882],
      [1888e-11, 0.86991545944, 8635.9420037632],
      [1517e-11, 1.9585205571, 398.1490034082],
      [1581e-11, 3.19976230948, 5088.6288397668],
      [1421e-11, 6.25530883828, 2544.3144198834],
      [1595e-11, 0.25619915132, 17298.1823273262],
      [1391e-11, 4.69964175574, 7058.5984613154],
      [1478e-11, 2.81808207569, 25934.1243310894],
      [1481e-11, 3.6582355461, 11506.7697697936],
      [1693e-11, 4.95689385293, 156475.2902479957],
      [1183e-11, 1.29343060777, 775.522611324],
      [1114e-11, 2.37889311847, 3738.761430108],
      [994e-11, 4.30088900425, 9225.539273283],
      [924e-11, 3.06451026809, 4164.311989613],
      [867e-11, 0.55606931068, 8429.2412664666],
      [988e-11, 5.97286104208, 7079.3738568078],
      [824e-11, 1.50984806177, 10447.3878396044],
      [915e-11, 0.12635654605, 11015.1064773348],
      [742e-11, 1.99159139281, 26087.9031415742],
      [1039e-11, 3.14159265359, 0],
      [85e-10, 4.24120016095, 29864.334027309],
      [755e-11, 2.89631873314, 4732.0306273434],
      [714e-11, 1.37548118605, 2146.1654164752],
      [708e-11, 1.91406542362, 8031.0922630584],
      [746e-11, 0.57893808622, 796.2980068164],
      [802e-11, 5.12339137235, 2942.4634232916],
      [751e-11, 1.67479850166, 21228.3920235458],
      [602e-11, 4.099765389, 64809.80550494129],
      [594e-11, 3.49580704849, 16496.3613962024],
      [592e-11, 4.59481504319, 4690.4798363586],
      [53e-10, 5.73979295194, 8827.3902698748],
      [503e-11, 5.66433137112, 33794.5437235286],
      [483e-11, 1.57106522322, 801.8209311238],
      [438e-11, 0.0670773372, 3128.3887650958],
      [423e-11, 2.86944596145, 12566.1516999828],
      [504e-11, 3.2620766916, 7632.9432596502],
      [552e-11, 1.02926440457, 239762.20451754928],
      [427e-11, 3.67434378208, 213.299095438],
      [404e-11, 1.4619329736, 15720.8387848784],
      [503e-11, 4.85802444134, 6290.1893969922],
      [417e-11, 0.81920713533, 5216.5803728014],
      [365e-11, 0.01002966145, 12168.0026965746],
      [363e-11, 1.28376436579, 6206.8097787158],
      [353e-11, 4.7005913311, 7234.794256242],
      [415e-11, 0.96862624176, 4136.9104335162],
      [387e-11, 3.09145061418, 25158.6017197654],
      [373e-11, 2.65119262808, 7342.4577801806],
      [361e-11, 2.97762937735, 9623.6882766912],
      [418e-11, 3.75759994446, 5230.807466803],
      [396e-11, 1.22507712354, 6438.4962494256],
      [322e-11, 1.21162178805, 8662.240323563],
      [284e-11, 5.64170320179, 1589.0728952838],
      [379e-11, 1.72248432756, 14945.3161735544],
      [32e-10, 3.94161159658, 7330.8231617461],
      [313e-11, 5.47602376451, 1194.4470102246],
      [292e-11, 1.38971327568, 11769.8536931664],
      [305e-11, 0.80429352049, 37724.7534197482],
      [257e-11, 5.81382810029, 426.598190876],
      [265e-11, 6.10358507671, 6836.6452528338],
      [25e-10, 4.56452895547, 7477.522860216],
      [266e-11, 2.62926282354, 7238.6755916],
      [263e-11, 6.22089501237, 6133.5126528568],
      [306e-11, 2.79682380532, 1748.016413067],
      [236e-11, 2.46093023707, 11371.7046897582],
      [316e-11, 1.62662805006, 250908.4901204155],
      [216e-11, 3.68721275185, 5849.3641121146],
      [23e-10, 0.36165162947, 5863.5912061162],
      [233e-11, 5.03509933618, 20426.571092422],
      [2e-9, 5.86073159059, 4535.0594369244],
      [277e-11, 4.65400292395, 82239.1669577989],
      [209e-11, 3.72323200803, 10973.55568635],
      [199e-11, 5.05186622555, 5429.8794682394],
      [256e-11, 2.40923279886, 19651.048481098],
      [21e-10, 4.50691909144, 29088.811415985],
      [181e-11, 6.00294783127, 4292.3308329504],
      [249e-11, 0.12900984422, 154379.7956244863],
      [209e-11, 3.87759458541, 17789.845619785],
      [225e-11, 3.18339652605, 18875.525869774],
      [191e-11, 4.53897489216, 18477.1087646123],
      [172e-11, 2.0969418273, 13095.8426650774],
      [182e-11, 3.16107943487, 16730.4636895958],
      [188e-11, 2.22746128596, 41654.9631159678],
      [164e-11, 5.18686274999, 5481.2549188676],
      [16e-10, 2.4929885502, 12592.4500197826],
      [155e-11, 1.59595438224, 10021.8372800994],
      [135e-11, 0.21349051305, 10988.808157535],
      [178e-11, 3.80375178044, 23581.2581773176],
      [123e-11, 1.66800739151, 15110.4661198662],
      [122e-11, 2.72678272224, 18849.2275499742],
      [126e-11, 1.17675512872, 14919.0178537546],
      [142e-11, 3.95053440992, 337.8142631964],
      [116e-11, 6.06340906212, 6709.6740408674],
      [137e-11, 3.52143246244, 12139.5535091068],
      [136e-11, 2.92179113491, 32217.2001810808],
      [11e-10, 3.51203379263, 18052.9295431578],
      [147e-11, 4.63371971408, 22805.7355659936],
      [108e-11, 5.45280815225, 7.1135470008],
      [148e-11, 0.65447253687, 95480.9471841745],
      [119e-11, 5.92110458985, 33019.0211122046],
      [11e-10, 5.34824206403, 639.897286314],
      [106e-11, 3.71081682614, 14314.1681130498],
      [139e-11, 6.17607198262, 24356.7807886416],
      [118e-11, 5.59738712949, 161338.5000008705],
      [117e-11, 3.6506527164, 45585.1728121874],
      [127e-11, 4.74596574209, 49515.382508407],
      [12e-10, 1.04211499785, 6915.8595893046],
      [12e-10, 5.60638811846, 5650.2921106782],
      [115e-11, 3.10668213303, 14712.317116458],
      [99e-11, 0.6901893993, 12779.4507954208],
      [97e-11, 1.07908724794, 9917.6968745098],
      [93e-11, 2.62295197146, 17260.1546546904],
      [99e-11, 4.45774681732, 4933.2084403326],
      [123e-11, 1.37488921994, 28286.9904848612],
      [121e-11, 5.19767249869, 27511.4678735372],
      [105e-11, 0.87192268229, 77375.95720492408],
      [87e-11, 3.9363781295, 17654.7805397496],
      [122e-11, 2.2395606868, 83997.09113559539],
      [87e-11, 4.18201600921, 22779.4372461938],
      [104e-11, 4.59580877285, 1349.8674096588],
      [102e-11, 2.83545248595, 12352.8526045448],
      [102e-11, 3.97386522171, 10818.1352869158],
      [101e-11, 4.32892825818, 36147.4098773004],
      [94e-11, 5.00001709338, 150192.2143980043],
      [77e-11, 3.971993693, 1592.5960136328],
      [1e-9, 6.07733097102, 26735.9452622132],
      [86e-11, 5.2602963825, 28313.288804661],
      [93e-11, 4.31900620254, 44809.6502008634],
      [76e-11, 6.22743405935, 13521.7514415914],
      [72e-11, 1.55820597747, 6256.7775301916],
      [82e-11, 4.95202664555, 10575.4066829418],
      [82e-11, 1.69647647075, 1990.745017041],
      [75e-11, 2.29836095644, 3634.6210245184],
      [75e-11, 2.66367876557, 16200.7727245012],
      [87e-11, 0.26630214764, 31441.6775697568],
      [77e-11, 2.25530952876, 5235.3285382367],
      [76e-11, 1.09869730334, 12903.9659631792],
      [58e-11, 4.28246137794, 12559.038152982],
      [64e-11, 5.51112829602, 173904.65170085328],
      [56e-11, 2.60133794851, 73188.3759784421],
      [55e-11, 5.81483150022, 143233.51002162008],
      [54e-11, 3.38482031504, 323049.11878710287],
      [39e-11, 3.28500401937, 71768.50988132549],
      [39e-11, 3.11239910096, 96900.81328129109]
    ],
    1: [
      [0.00227777722, 3.4137662053, 6283.0758499914],
      [3805678e-11, 3.37063423795, 12566.1516999828],
      [3619589e-11, 0, 0],
      [71542e-11, 3.32777549735, 18849.2275499742],
      [7655e-11, 1.79489607186, 5223.6939198022],
      [8107e-11, 3.89190403643, 5507.5532386674],
      [6456e-11, 5.1978942475, 2352.8661537718],
      [3894e-11, 2.15568517178, 6279.5527316424],
      [3892e-11, 1.53021064904, 6286.5989683404],
      [3897e-11, 4.87293945629, 10213.285546211],
      [3812e-11, 1.43523182316, 12036.4607348882],
      [3577e-11, 2.32913869227, 83996.84731811189],
      [357e-10, 4.92637739003, 71430.69561812909],
      [3494e-11, 2.20864641831, 529.6909650946],
      [2421e-11, 6.22876183393, 7860.4193924392],
      [2056e-11, 3.06747139741, 14143.4952424306],
      [1399e-11, 0.50107877909, 6309.3741697912],
      [1417e-11, 3.28454570977, 25132.3033999656],
      [1544e-11, 1.82062047625, 5856.4776591154],
      [1457e-11, 1.75339303307, 5884.9268465832],
      [1497e-11, 2.19673914456, 9437.762934887],
      [1549e-11, 5.73650061398, 17789.845619785],
      [1277e-11, 3.9672171733, 4705.7323075436],
      [1038e-11, 2.9481870117, 6256.7775301916],
      [1018e-11, 2.24114547164, 6681.2248533996],
      [1021e-11, 1.4679502613, 11790.6290886588],
      [916e-11, 3.72965830745, 1059.3819301892],
      [1156e-11, 6.04591336669, 398.1490034082],
      [124e-10, 0.77195902957, 6812.766815086],
      [1115e-11, 3.92255876225, 12168.0026965746],
      [908e-11, 1.78447918237, 3930.2096962196],
      [833e-11, 0.09941579828, 11506.7697697936],
      [79e-10, 2.45555993228, 775.522611324],
      [666e-11, 4.40761401665, 5753.3848848968],
      [52e-10, 1.60179602491, 4694.0029547076],
      [382e-11, 0.26754532042, 1577.3435424478],
      [405e-11, 1.97558286872, 6283.0085396886],
      [405e-11, 1.53147989887, 6283.14316029419],
      [388e-11, 2.59563818411, 7058.5984613154],
      [341e-11, 3.61275156842, 13367.9726311066],
      [28e-10, 4.63052251735, 796.2980068164],
      [276e-11, 0.43350778219, 7079.3738568078],
      [311e-11, 5.28219636656, 17260.1546546904],
      [275e-11, 5.27597553634, 11769.8536931664],
      [286e-11, 2.98639716345, 6275.9623029906],
      [251e-11, 2.81315684448, 6290.1893969922],
      [239e-11, 5.77837903893, 10977.078804699],
      [228e-11, 0.14375973844, 3738.761430108],
      [227e-11, 2.51020991853, 7084.8967811152],
      [211e-11, 4.7202946547, 6496.3749454294],
      [234e-11, 3.1153527401, 709.9330485583],
      [234e-11, 0.5707581762, 11856.2186514245],
      [237e-11, 2.38791907394, 213.299095438],
      [227e-11, 1.12059781634, 12352.8526045448],
      [169e-11, 3.20148089605, 5486.777843175],
      [159e-11, 3.14604135756, 8827.3902698748],
      [16e-10, 1.14784478002, 5643.1785636774],
      [144e-11, 5.23285657431, 78051.5857313169],
      [144e-11, 1.16454654602, 90617.7374312997],
      [144e-11, 3.81203756929, 6262.300454499],
      [143e-11, 5.97809021355, 6303.8512454838],
      [138e-11, 4.29829933273, 1589.0728952838],
      [161e-11, 3.03298851492, 20426.571092422],
      [165e-11, 5.09134896587, 17298.1823273262],
      [128e-11, 4.41590143012, 6127.6554505572],
      [158e-11, 2.00984506334, 5230.807466803],
      [13e-10, 1.44170683802, 12569.6748183318],
      [125e-11, 1.69950379498, 3128.3887650958],
      [152e-11, 4.96946111415, 65147.6197681377],
      [131e-11, 4.24961399629, 6282.0955289232],
      [131e-11, 5.54051222995, 6284.0561710596],
      [161e-11, 3.32421999691, 6283.3196674749],
      [123e-11, 2.93221463795, 15720.8387848784],
      [152e-11, 1.56488157456, 18319.5365848796],
      [114e-11, 1.89110005546, 18073.7049386502],
      [113e-11, 4.95214866677, 4136.9104335162],
      [111e-11, 4.79699611405, 8429.2412664666],
      [118e-11, 3.06184958762, 22003.9146348698],
      [128e-11, 2.09693027395, 12562.6285816338],
      [138e-11, 0.84648544836, 6069.7767545534],
      [1e-9, 0.41938790104, 5481.2549188676],
      [101e-11, 4.43791289246, 19651.048481098],
      [116e-11, 1.87002428935, 77713.7714681205],
      [95e-11, 0.68638183645, 3340.6124266998],
      [104e-11, 4.90822646457, 8635.9420037632],
      [114e-11, 0.36008214928, 23543.23050468179],
      [91e-11, 1.1761121931, 9225.539273283],
      [91e-11, 2.74682631104, 5216.5803728014],
      [86e-11, 3.09315282195, 1194.4470102246],
      [93e-11, 6.2764351319, 12559.038152982],
      [87e-11, 3.64926989547, 7.1135470008],
      [83e-11, 0.37008971174, 11371.7046897582],
      [98e-11, 4.68473306376, 167283.7615876655],
      [98e-11, 0.99865886857, 154717.6098876827],
      [86e-11, 4.41152307486, 25934.1243310894],
      [98e-11, 4.98209568932, 16496.3613962024],
      [85e-11, 2.35438163823, 3154.6870848956],
      [83e-11, 0.24859477658, 21228.3920235458],
      [76e-11, 5.46661600296, 29864.334027309],
      [69e-11, 3.22045334237, 801.8209311238],
      [68e-11, 2.19928242745, 37724.7534197482],
      [7e-10, 5.33711014698, 2544.3144198834],
      [55e-11, 5.37872238211, 11015.1064773348],
      [51e-11, 5.03600618727, 5863.5912061162],
      [59e-11, 3.54984809612, 4535.0594369244],
      [53e-11, 1.50812064137, 7342.4577801806],
      [44e-11, 1.33712241647, 4164.311989613],
      [55e-11, 5.38460045253, 7477.522860216],
      [49e-11, 5.61844340512, 24072.9214697764],
      [57e-11, 6.17973522898, 8031.0922630584],
      [52e-11, 4.24379064407, 5088.6288397668],
      [41e-11, 3.41960196246, 26087.9031415742],
      [52e-11, 1.68150981131, 25158.6017197654],
      [53e-11, 0.11041408311, 29088.811415985],
      [43e-11, 0.53354396923, 2146.1654164752],
      [5e-10, 0.60270799844, 33794.5437235286],
      [45e-11, 1.69577010458, 6702.5604938666],
      [37e-11, 6.09033460795, 64809.80550494129],
      [44e-11, 2.67993061247, 15110.4661198662],
      [47e-11, 3.62555676035, 41654.9631159678],
      [36e-11, 0.47219666269, 13095.8426650774],
      [35e-11, 5.99520523215, 23581.2581773176],
      [43e-11, 4.08726331262, 156137.47598479927],
      [43e-11, 5.17376496602, 18422.62935909819],
      [34e-11, 2.14460100274, 4933.2084403326],
      [3e-10, 4.12992793541, 426.598190876],
      [36e-11, 2.28596930002, 90279.92316810328],
      [32e-11, 0.81117747619, 26.2983197998],
      [28e-11, 4.07036560467, 14712.317116458],
      [25e-11, 1.92905243842, 1748.016413067],
      [24e-11, 5.06152880842, 16730.4636895958],
      [23e-11, 3.24047012195, 31415.379249957],
      [27e-11, 3.90672018305, 18451.07854656599],
      [21e-11, 3.51419811826, 10447.3878396044]
    ],
    2: [
      [9721424e-11, 5.1519280992, 6283.0758499914],
      [233002e-11, 3.14159265359, 0],
      [134188e-11, 0.64406212977, 12566.1516999828],
      [6504e-11, 1.07333397797, 18849.2275499742],
      [1662e-11, 1.62746869551, 84334.66158130829],
      [635e-11, 3.51985338656, 6279.5527316424],
      [492e-11, 2.41382223971, 1047.7473117547],
      [307e-11, 6.10181422085, 5223.6939198022],
      [322e-11, 0.37660897389, 6286.5989683404],
      [326e-11, 2.35727931602, 5507.5532386674],
      [274e-11, 1.65307581765, 7860.4193924392],
      [228e-11, 1.14082932988, 25132.3033999656],
      [202e-11, 0.4983668253, 2352.8661537718],
      [201e-11, 0.155527656, 10213.285546211],
      [167e-11, 3.98005254015, 529.6909650946],
      [17e-10, 5.28668290523, 6256.7775301916],
      [166e-11, 3.04613930284, 12036.4607348882],
      [153e-11, 4.06779216239, 83996.84731811189],
      [15e-10, 3.18772213951, 71430.69561812909],
      [12e-10, 3.13558669517, 5884.9268465832],
      [123e-11, 4.17102530625, 6309.3741697912],
      [1e-9, 1.46356761368, 11506.7697697936],
      [1e-9, 3.00322421365, 11790.6290886588],
      [77e-11, 1.65643898948, 4705.7323075436],
      [68e-11, 6.03791904123, 6812.766815086],
      [75e-11, 4.85191600582, 14143.4952424306],
      [79e-11, 4.12628805658, 5753.3848848968],
      [64e-11, 2.7194416046, 6127.6554505572],
      [63e-11, 0.78655326011, 6438.4962494256],
      [75e-11, 0.84213523741, 167621.5758508619],
      [51e-11, 4.55059044701, 5486.777843175],
      [5e-10, 5.29314320585, 7079.3738568078],
      [45e-11, 0.33147576416, 775.522611324],
      [43e-11, 3.6179371164, 1577.3435424478],
      [57e-11, 6.15295833679, 12194.0329146209],
      [45e-11, 1.18274698508, 17789.845619785],
      [47e-11, 1.11643162773, 398.1490034082],
      [47e-11, 5.5298423843, 12168.0026965746],
      [42e-11, 2.6437530062, 10988.808157535],
      [37e-11, 0.31226891972, 6681.2248533996],
      [46e-11, 3.38617099014, 156475.2902479957],
      [33e-11, 1.26266496002, 6290.1893969922],
      [33e-11, 2.25067065498, 6275.9623029906],
      [27e-11, 1.72859626293, 1059.3819301892],
      [28e-11, 2.88681054153, 796.2980068164],
      [3e-10, 5.52021264181, 7058.5984613154],
      [21e-11, 6.22275008403, 6069.7767545534],
      [24e-11, 5.83690442827, 6282.0955289232],
      [24e-11, 3.95322179797, 6284.0561710596],
      [21e-11, 4.87022458966, 3738.761430108],
      [21e-11, 3.58048145762, 6496.3749454294],
      [22e-11, 1.97770318395, 7.1135470008],
      [19e-11, 3.4597988877, 4136.9104335162],
      [15e-11, 2.81379880771, 1589.0728952838],
      [15e-11, 1.61313151838, 1194.4470102246],
      [15e-11, 0.63083434831, 11769.8536931664],
      [19e-11, 0.28082047767, 17260.1546546904],
      [17e-11, 1.35165136146, 78051.5857313169],
      [15e-11, 2.3094159956, 11856.2186514245],
      [12e-11, 1.12997370513, 90617.7374312997],
      [12e-11, 0.00611601597, 18073.7049386502],
      [12e-11, 1.70058636365, 12559.038152982]
    ],
    3: [
      [275993e-11, 0.59480097092, 6283.0758499914],
      [17034e-11, 3.14159265359, 0],
      [3617e-11, 0.11750575325, 12566.1516999828],
      [339e-11, 5.66087461682, 18849.2275499742],
      [56e-11, 5.02765554835, 6279.5527316424],
      [19e-11, 5.99007646261, 6256.7775301916],
      [18e-11, 3.80004734567, 6309.3741697912],
      [18e-11, 1.21049250774, 6127.6554505572],
      [18e-11, 2.29734567137, 6438.4962494256],
      [15e-11, 4.72881467263, 6286.5989683404],
      [12e-11, 0.41481671808, 83996.84731811189],
      [13e-11, 5.54637369296, 25132.3033999656],
      [1e-10, 2.91937214232, 71430.69561812909],
      [6e-11, 2.1417324121, 11856.2186514245]
    ],
    4: [
      [5745e-11, 2.26734029843, 6283.0758499914],
      [87e-10, 0, 0],
      [119e-11, 4.26807972611, 12566.1516999828],
      [17e-11, 4.0742262044, 18849.2275499742],
      [5e-11, 0.84308705203, 1047.7473117547],
      [5e-11, 0.05711572303, 84334.66158130829]
    ],
    5: [
      [114e-11, 4.31455980099, 6283.0758499914],
      [24e-11, 0, 0]
    ]
  },
  R: {
    0: [
      [1.00013988784, 0, 0],
      [0.01670699632, 3.09846350258, 6283.0758499914],
      [13956024e-11, 3.05524609456, 12566.1516999828],
      [308372e-10, 5.19846674381, 77713.7714681205],
      [1628463e-11, 1.17387558054, 5753.3848848968],
      [1575572e-11, 2.84685214877, 7860.4193924392],
      [924799e-11, 5.45292236722, 11506.7697697936],
      [542439e-11, 4.56409151453, 3930.2096962196],
      [47211e-10, 3.66100022149, 5884.9268465832],
      [32878e-10, 5.89983686142, 5223.6939198022],
      [345969e-11, 0.96368627272, 5507.5532386674],
      [306784e-11, 0.29867139512, 5573.1428014331],
      [174844e-11, 3.01193636733, 18849.2275499742],
      [243181e-11, 4.2734953079, 11790.6290886588],
      [211836e-11, 5.84714461348, 1577.3435424478],
      [18574e-10, 5.02199710705, 10977.078804699],
      [109835e-11, 5.0551063586, 5486.777843175],
      [98316e-11, 0.88681311278, 6069.7767545534],
      [865e-9, 5.68956418946, 15720.8387848784],
      [85831e-11, 1.27079125277, 161000.6857376741],
      [62917e-11, 0.92177053978, 529.6909650946],
      [57056e-11, 2.01374292245, 83996.84731811189],
      [64908e-11, 0.27251341435, 17260.1546546904],
      [49384e-11, 3.24501240359, 2544.3144198834],
      [55736e-11, 5.2415979917, 71430.69561812909],
      [4252e-10, 6.01110257982, 6275.9623029906],
      [46966e-11, 2.57799853213, 775.522611324],
      [38963e-11, 5.36063832897, 4694.0029547076],
      [44666e-11, 5.53715663816, 9437.762934887],
      [35661e-11, 1.67447135798, 12036.4607348882],
      [31922e-11, 0.18368299942, 5088.6288397668],
      [31846e-11, 1.77775642078, 398.1490034082],
      [33193e-11, 0.24370221704, 7084.8967811152],
      [38245e-11, 2.39255343973, 8827.3902698748],
      [28468e-11, 1.21344887533, 6286.5989683404],
      [37486e-11, 0.82961281844, 19651.048481098],
      [36957e-11, 4.90107587287, 12139.5535091068],
      [34537e-11, 1.84270693281, 2942.4634232916],
      [26275e-11, 4.58896863104, 10447.3878396044],
      [24596e-11, 3.78660838036, 8429.2412664666],
      [23587e-11, 0.26866098169, 796.2980068164],
      [27795e-11, 1.89934427832, 6279.5527316424],
      [23927e-11, 4.99598548145, 5856.4776591154],
      [20345e-11, 4.65282190725, 2146.1654164752],
      [23287e-11, 2.80783632869, 14143.4952424306],
      [22099e-11, 1.95002636847, 3154.6870848956],
      [19509e-11, 5.38233922479, 2352.8661537718],
      [17958e-11, 0.1987136996, 6812.766815086],
      [17178e-11, 4.43322156854, 10213.285546211],
      [1619e-10, 5.23159323213, 17789.845619785],
      [17315e-11, 6.15224075188, 16730.4636895958],
      [13814e-11, 5.18962074032, 8031.0922630584],
      [18834e-11, 0.67280058021, 149854.4001348079],
      [1833e-10, 2.25348717053, 23581.2581773176],
      [13639e-11, 3.68511810757, 4705.7323075436],
      [13142e-11, 0.65267698994, 13367.9726311066],
      [10414e-11, 4.33285688501, 11769.8536931664],
      [9978e-11, 4.20126336356, 6309.3741697912],
      [1017e-10, 1.59366684542, 4690.4798363586],
      [7564e-11, 2.62560597391, 6256.7775301916],
      [9654e-11, 3.67583728703, 27511.4678735372],
      [6743e-11, 0.56269927047, 3340.6124266998],
      [8743e-11, 6.06359123461, 1748.016413067],
      [7786e-11, 3.67371235367, 12168.0026965746],
      [6633e-11, 5.66149277789, 11371.7046897582],
      [7712e-11, 0.31242577788, 7632.9432596502],
      [6586e-11, 3.13580054586, 801.8209311238],
      [746e-10, 5.6475806666, 11926.2544136688],
      [6933e-11, 2.92384586372, 6681.2248533996],
      [6805e-11, 1.42327153767, 23013.5395395872],
      [6118e-11, 5.13395999022, 1194.4470102246],
      [6477e-11, 2.64986648493, 19804.8272915828],
      [5233e-11, 4.62432817299, 6438.4962494256],
      [6147e-11, 3.02863936662, 233141.3144043615],
      [4608e-11, 1.72194702724, 7234.794256242],
      [4221e-11, 1.55697533726, 7238.6755916],
      [531e-10, 2.40821524293, 11499.6562227928],
      [5128e-11, 5.3239896569, 11513.8833167944],
      [477e-10, 0.2555431173, 11856.2186514245],
      [5519e-11, 2.09089153789, 17298.1823273262],
      [5625e-11, 4.34052903053, 90955.5516944961],
      [4578e-11, 4.4656964157, 5746.271337896],
      [3788e-11, 4.9072829481, 4164.311989613],
      [5337e-11, 5.09957905103, 31441.6775697568],
      [3967e-11, 1.20054555175, 1349.8674096588],
      [4005e-11, 3.02853885902, 1059.3819301892],
      [348e-10, 0.76066308841, 10973.55568635],
      [4232e-11, 1.05485713117, 5760.4984318976],
      [4582e-11, 3.76570026763, 6386.16862421],
      [3335e-11, 3.13829943354, 6836.6452528338],
      [342e-10, 3.00043974511, 4292.3308329504],
      [3595e-11, 5.70703236079, 5643.1785636774],
      [3236e-11, 4.16387400645, 9917.6968745098],
      [4154e-11, 2.59940749519, 7058.5984613154],
      [3362e-11, 4.54577164994, 4732.0306273434],
      [2978e-11, 1.3056126882, 6283.14316029419],
      [2765e-11, 0.51311975671, 26.2983197998],
      [2807e-11, 5.66230537649, 8635.9420037632],
      [2927e-11, 5.7378783408, 16200.7727245012],
      [3167e-11, 1.691817599, 11015.1064773348],
      [2598e-11, 2.96244118358, 25132.3033999656],
      [3519e-11, 3.62639325753, 244287.60000722768],
      [2676e-11, 4.20727719487, 18073.7049386502],
      [2978e-11, 1.74971565805, 6283.0085396886],
      [2287e-11, 1.06976449088, 14314.1681130498],
      [2863e-11, 5.92838917309, 14712.317116458],
      [3071e-11, 0.23793217, 35371.8872659764],
      [2656e-11, 0.89959301615, 12352.8526045448],
      [2415e-11, 2.799751768, 709.9330485583],
      [2811e-11, 3.51513864541, 21228.3920235458],
      [1977e-11, 2.61358297551, 951.7184062506],
      [2548e-11, 2.47684686575, 6208.2942514241],
      [1999e-11, 0.56090396506, 7079.3738568078],
      [2305e-11, 1.05376463592, 22483.84857449259],
      [1855e-11, 2.86093570752, 5216.5803728014],
      [2157e-11, 1.31395211105, 154717.6098876827],
      [197e-10, 4.36931551625, 167283.7615876655],
      [1754e-11, 2.14452400686, 6290.1893969922],
      [1628e-11, 5.85704450617, 10984.1923516998],
      [2154e-11, 6.03828353794, 10873.9860304804],
      [1714e-11, 3.70158195222, 1592.5960136328],
      [1541e-11, 6.21599512982, 23543.23050468179],
      [1602e-11, 1.99860679677, 10969.9652576982],
      [1712e-11, 1.34295218697, 3128.3887650958],
      [1647e-11, 5.54948299069, 6496.3749454294],
      [1495e-11, 5.43980459648, 155.4203994342],
      [1827e-11, 5.91227480351, 3738.761430108],
      [1726e-11, 2.16765465036, 10575.4066829418],
      [1532e-11, 5.35683107063, 13521.7514415914],
      [1824e-11, 1.66056145084, 39302.096962196],
      [1605e-11, 1.90930973224, 6133.5126528568],
      [1282e-11, 2.46013372544, 13916.0191096416],
      [1211e-11, 4.4136063155, 3894.1818295422],
      [1394e-11, 1.7780192925, 9225.539273283],
      [1571e-11, 4.95512957606, 25158.6017197654],
      [1205e-11, 1.19212756308, 3.523118349],
      [1132e-11, 2.69830084955, 6040.3472460174],
      [1504e-11, 5.77577388271, 18209.33026366019],
      [1393e-11, 1.62625077326, 5120.6011455836],
      [1081e-11, 2.93726744446, 17256.6315363414],
      [1232e-11, 0.71651766504, 143571.32428481648],
      [1087e-11, 0.99769687961, 955.5997416086],
      [1068e-11, 5.28472576591, 65147.6197681377],
      [1169e-11, 3.11663802316, 14945.3161735544],
      [975e-11, 5.1088726078, 6172.869528772],
      [1202e-11, 4.02992510403, 553.5694028424],
      [979e-11, 2.00000879106, 15110.4661198662],
      [962e-11, 4.023807714, 6282.0955289232],
      [999e-11, 3.6264300279, 6262.300454499],
      [103e-10, 5.84987815239, 213.299095438],
      [1014e-11, 2.84227679965, 8662.240323563],
      [1185e-11, 1.51330629149, 17654.7805397496],
      [967e-11, 2.67081017562, 5650.2921106782],
      [1222e-11, 2.65423784904, 88860.05707098669],
      [986e-11, 2.36212814824, 6206.8097787158],
      [1034e-11, 0.13634950642, 11712.9553182308],
      [1103e-11, 3.08477302937, 43232.3066584156],
      [781e-11, 2.53374971725, 16496.3613962024],
      [1019e-11, 3.04569392376, 6037.244203762],
      [795e-11, 5.80662989126, 5230.807466803],
      [813e-11, 3.57702871938, 10177.2576795336],
      [962e-11, 5.31470594766, 6284.0561710596],
      [717e-11, 5.95797471837, 12559.038152982],
      [967e-11, 2.74413738053, 6244.9428143536],
      [921e-11, 0.1016016083, 29088.811415985],
      [719e-11, 5.91788189939, 4136.9104335162],
      [688e-11, 3.89489045092, 1589.0728952838],
      [772e-11, 4.05505380285, 6127.6554505572],
      [706e-11, 5.49323197725, 22003.9146348698],
      [665e-11, 1.60002747134, 11087.2851259184],
      [69e-10, 4.50539825729, 426.598190876],
      [854e-11, 3.2610464506, 20426.571092422],
      [656e-11, 4.3241018294, 16858.4825329332],
      [84e-10, 2.59572585212, 28766.924424484],
      [686e-11, 0.61944033771, 11403.676995575],
      [7e-9, 3.40901412473, 7.1135470008],
      [728e-11, 0.04050185963, 5481.2549188676],
      [653e-11, 1.0386945123, 6062.6632075526],
      [559e-11, 4.79221805695, 20199.094959633],
      [633e-11, 5.70229959167, 45892.73043315699],
      [591e-11, 6.10986487621, 9623.6882766912],
      [52e-10, 3.62310356479, 5333.9002410216],
      [602e-11, 5.58381898589, 10344.2950653858],
      [496e-11, 2.21027756314, 1990.745017041],
      [691e-11, 1.96733114988, 12416.5885028482],
      [64e-10, 1.59062417043, 18319.5365848796],
      [625e-11, 3.82358168221, 13517.8701062334],
      [475e-11, 1.1702590418, 12569.6748183318],
      [66e-10, 5.08498512995, 283.8593188652],
      [664e-11, 4.50029469969, 47162.5163546352],
      [569e-11, 0.16318535463, 17267.26820169119],
      [568e-11, 3.86100969474, 6076.8903015542],
      [462e-11, 0.26368763517, 4590.910180489],
      [535e-11, 4.83225423196, 18422.62935909819],
      [466e-11, 0.75873879417, 7342.4577801806],
      [541e-11, 3.07212190556, 226858.23855437007],
      [61e-10, 1.53597089605, 33019.0211122046],
      [617e-11, 2.62356328726, 11190.377900137],
      [548e-11, 4.55798855803, 18875.525869774],
      [633e-11, 4.60110281228, 66567.48586525429],
      [587e-11, 5.78087907808, 632.7837393132],
      [603e-11, 5.38458554802, 316428.22867391503],
      [525e-11, 5.01522072363, 12132.439962106],
      [469e-11, 0.59975173763, 21954.15760939799],
      [548e-11, 3.50627043672, 17253.04110768959],
      [502e-11, 0.98804327589, 11609.8625440122],
      [568e-11, 1.98497313089, 7668.6374249425],
      [482e-11, 1.62460405687, 12146.6670561076],
      [391e-11, 3.68718382972, 18052.9295431578],
      [457e-11, 3.7721489661, 156137.47598479927],
      [401e-11, 5.2922154024, 15671.0817594066],
      [469e-11, 1.80963351735, 12562.6285816338],
      [514e-11, 3.37031288919, 20597.2439630412],
      [452e-11, 5.66811219778, 10454.5013866052],
      [375e-11, 4.98528185039, 9779.1086761254],
      [523e-11, 0.97215560834, 155427.542936241],
      [403e-11, 5.1394818977, 1551.045222648],
      [372e-11, 3.69883738807, 9388.0059094152],
      [367e-11, 4.43875659833, 4535.0594369244],
      [406e-11, 4.20863156497, 12592.4500197826],
      [362e-11, 2.55099560446, 242.728603974],
      [471e-11, 4.61907324819, 5436.9930152402],
      [388e-11, 4.960209284, 24356.7807886416],
      [441e-11, 5.83872966262, 3496.032826134],
      [349e-11, 6.16307810648, 19800.9459562248],
      [356e-11, 0.2381908124, 5429.8794682394],
      [346e-11, 5.60809622572, 2379.1644735716],
      [38e-10, 2.72105213132, 11933.3679606696],
      [432e-11, 0.24215988572, 17996.0311682222],
      [378e-11, 5.22516848076, 7477.522860216],
      [337e-11, 5.10885555836, 5849.3641121146],
      [315e-11, 0.57827745123, 10557.5941608238],
      [318e-11, 4.4994900732, 3634.6210245184],
      [323e-11, 1.55850824803, 10440.2742926036],
      [314e-11, 5.77154773334, 20.7753954924],
      [303e-11, 2.34615580398, 4686.8894077068],
      [414e-11, 5.9323760231, 51092.7260508548],
      [362e-11, 2.17561997119, 28237.2334593894],
      [288e-11, 0.18377405421, 13095.8426650774],
      [277e-11, 5.1295220503, 13119.72110282519],
      [325e-11, 6.18608287927, 6268.8487559898],
      [273e-11, 0.30522428863, 23141.5583829246],
      [267e-11, 5.76152585786, 5966.6839803348],
      [345e-11, 2.94246040875, 36949.2308084242],
      [253e-11, 5.20994580359, 24072.9214697764],
      [342e-11, 5.76212804329, 16460.33352952499],
      [307e-11, 6.01039067183, 22805.7355659936],
      [261e-11, 2.00304796059, 6148.010769956],
      [238e-11, 5.08241964961, 6915.8595893046],
      [249e-11, 2.94762789744, 135.0650800354],
      [306e-11, 3.89765478921, 10988.808157535],
      [308e-11, 0.05451027736, 4701.1165017084],
      [319e-11, 2.95712862064, 163096.18036118348],
      [272e-11, 2.07967681309, 4804.209275927],
      [209e-11, 4.43768461442, 6546.1597733642],
      [217e-11, 0.73691592312, 6303.8512454838],
      [203e-11, 0.32033085531, 25934.1243310894],
      [205e-11, 5.22936478995, 20995.3929664494],
      [213e-11, 0.20671418919, 28286.9904848612],
      [197e-11, 0.4828613129, 16737.5772365966],
      [23e-10, 6.06567392849, 6287.0080032545],
      [219e-11, 1.291942163, 5326.7866940208],
      [201e-11, 1.74700937253, 22743.4093795164],
      [207e-11, 4.45440927276, 6279.4854213396],
      [269e-11, 6.0564044503, 64471.99124174489],
      [19e-10, 0.99261116842, 29296.6153895786],
      [194e-11, 3.82656562755, 419.4846438752],
      [262e-11, 5.26961924126, 522.5774180938],
      [21e-10, 4.68618183158, 6254.6266625236],
      [197e-11, 2.80624554186, 4933.2084403326],
      [252e-11, 4.3622015462, 40879.4405046438],
      [261e-11, 1.07241516738, 55022.9357470744],
      [233e-11, 5.41751014958, 39609.6545831656],
      [185e-11, 4.14324541379, 5642.1982426092],
      [247e-11, 3.44855612987, 6702.5604938666],
      [205e-11, 4.04424043226, 536.8045120954],
      [191e-11, 3.15807087926, 16723.350142595],
      [222e-11, 5.16259496507, 23539.7073863328],
      [18e-10, 4.56214752149, 6489.2613984286],
      [227e-11, 0.60156339452, 5905.7022420756],
      [17e-10, 0.93185903228, 16062.1845261168],
      [159e-11, 0.92751013112, 23937.856389741],
      [157e-11, 4.69607868164, 6805.6532680852],
      [218e-11, 0.8553337343, 16627.3709153772],
      [169e-11, 0.94641052064, 3097.88382272579],
      [207e-11, 4.88410451334, 6286.6662786432],
      [16e-10, 4.95943826819, 10021.8372800994],
      [175e-11, 6.12762824563, 239424.39025435288],
      [173e-11, 3.13887234973, 6179.9830757728],
      [157e-11, 3.62822057807, 18451.07854656599],
      [206e-11, 5.74617821138, 3646.3503773544],
      [157e-11, 4.67695912207, 6709.6740408674],
      [146e-11, 3.09506069745, 4907.3020501456],
      [165e-11, 2.2713912876, 10660.6869350424],
      [144e-11, 3.96947747592, 6019.9919266186],
      [171e-11, 5.91302216729, 6058.7310542895],
      [144e-11, 2.1315565512, 26084.0218062162],
      [151e-11, 0.67417383565, 2388.8940204492],
      [196e-11, 1.67718461229, 2107.0345075424],
      [146e-11, 5.10373877968, 10770.8932562618],
      [187e-11, 1.23915444627, 19402.7969528166],
      [137e-11, 1.26247412216, 12566.2190102856],
      [191e-11, 5.03547476279, 263.0839233728],
      [137e-11, 3.52825454595, 639.897286314],
      [135e-11, 0.73840670927, 5017.508371365],
      [164e-11, 2.39195095081, 6357.8574485587],
      [168e-11, 0.05515907462, 9380.9596727172],
      [161e-11, 1.15721259392, 26735.9452622132],
      [144e-11, 1.76097645199, 5888.4499649322],
      [131e-11, 2.51859277344, 6599.467719648],
      [142e-11, 2.43802911123, 5881.4037282342],
      [159e-11, 5.90325893762, 6281.5913772831],
      [151e-11, 3.72338532519, 12669.2444742014],
      [132e-11, 2.38417741883, 6525.8044539654],
      [127e-11, 0.00254936441, 10027.9031957292],
      [148e-11, 2.85102145528, 6418.1409300268],
      [143e-11, 5.7446027956, 26087.9031415742],
      [172e-11, 0.4128996224, 174242.4659640497],
      [136e-11, 4.15497742275, 6311.5250374592],
      [17e-10, 5.98194913129, 327574.51427678124],
      [136e-11, 2.48430537541, 13341.6743113068],
      [149e-11, 0.33002271275, 245.8316462294],
      [165e-11, 2.496679246, 58953.145443294],
      [123e-11, 1.67328384813, 32217.2001810808],
      [123e-11, 3.45660563754, 6277.552925684],
      [117e-11, 0.86065134175, 6245.0481773556],
      [149e-11, 5.61358281003, 5729.506447149],
      [128e-11, 0.71204006448, 103.0927742186],
      [159e-11, 2.43166592149, 221995.02880149524],
      [137e-11, 1.706577092, 12566.08438968],
      [129e-11, 2.80667872683, 6016.4688082696],
      [113e-11, 3.58302904101, 25685.872802808],
      [109e-11, 3.26403795962, 6819.8803620868],
      [122e-11, 0.34120688202, 1162.4747044078],
      [106e-11, 1.59721172719, 17782.7320727842],
      [144e-11, 2.28891651774, 12489.8856287072],
      [137e-11, 5.82029768354, 44809.6502008634],
      [134e-11, 1.26539983018, 5331.3574437408],
      [103e-11, 5.96518130595, 6321.1035226272],
      [109e-11, 0.33808549034, 11300.5842213564],
      [129e-11, 5.8918727719, 12029.3471878874],
      [122e-11, 5.77325634636, 11919.140866668],
      [107e-11, 6.2499898935, 77690.75950573849],
      [107e-11, 1.00535580713, 77736.78343050249],
      [115e-11, 5.86963518266, 12721.572099417],
      [102e-11, 5.66283467269, 5540.0857894588],
      [143e-11, 0.24122178432, 4214.0690150848],
      [143e-11, 0.88529649733, 7576.560073574],
      [107e-11, 2.92124030351, 31415.379249957],
      [1e-9, 5.99485644501, 4061.2192153944],
      [103e-11, 2.41941934525, 5547.1993364596],
      [104e-11, 4.44106051277, 2118.7638603784],
      [11e-10, 0.37559635174, 5863.5912061162],
      [124e-11, 2.55619029611, 12539.853380183],
      [11e-10, 3.66952094465, 238004.5241572363],
      [112e-11, 4.32512422724, 97238.62754448749],
      [12e-10, 1.26895630075, 12043.574281889],
      [97e-11, 5.42612959752, 7834.1210726394],
      [94e-11, 2.56461130309, 19004.6479494084],
      [105e-11, 5.68272475301, 16522.6597160022],
      [117e-11, 3.65425622684, 34520.3093093808],
      [108e-11, 1.24206843948, 84672.47584450469],
      [98e-11, 0.13589994287, 11080.1715789176],
      [97e-11, 2.46722096722, 71980.63357473118],
      [95e-11, 5.36958330451, 6288.5987742988],
      [96e-11, 0.20796618776, 18139.2945014159],
      [111e-11, 5.01961920313, 11823.1616394502],
      [9e-10, 2.72355843779, 26880.3198130326],
      [99e-11, 0.90164266199, 18635.9284545362],
      [126e-11, 4.78722177847, 305281.9430710488],
      [124e-11, 5.00979495566, 172146.9713405403],
      [9e-10, 4.50544881196, 40077.61957352],
      [104e-11, 5.6367968071, 2787.0430238574],
      [91e-11, 5.43564326147, 6272.0301497275],
      [1e-9, 2.00639461597, 12323.4230960088],
      [117e-11, 2.35555589778, 83286.91426955358],
      [105e-11, 2.59824000109, 30666.1549584328],
      [9e-10, 2.35779490026, 12491.3701014155],
      [89e-11, 3.57152453732, 11720.0688652316],
      [95e-11, 5.67015349858, 14919.0178537546],
      [87e-11, 1.86043406047, 27707.5424942948],
      [106e-11, 3.04150600352, 22345.2603761082],
      [82e-11, 5.58298993353, 10241.2022911672],
      [83e-11, 3.10607039533, 36147.4098773004],
      [94e-11, 5.47749711149, 9924.8104215106],
      [82e-11, 4.71988314145, 15141.390794312],
      [96e-11, 3.89073946348, 6379.0550772092],
      [11e-10, 4.92131611151, 5621.8429232104],
      [11e-10, 4.89978492291, 72140.6286666874],
      [97e-11, 5.20764563059, 6303.4311693902],
      [85e-11, 1.61269222311, 33326.5787331742],
      [93e-11, 1.32651591333, 23020.65308658799],
      [9e-10, 0.5773301638, 26482.1708096244],
      [78e-11, 3.99588630754, 11293.4706743556],
      [106e-11, 3.92012705073, 62883.3551395136],
      [98e-11, 2.94397773524, 316.3918696566],
      [76e-11, 3.96310417608, 29026.48522950779],
      [98e-11, 0.95914722366, 48739.859897083],
      [78e-11, 1.97068528043, 90279.92316810328],
      [76e-11, 0.23027966596, 21424.4666443034],
      [79e-11, 1.46227790922, 8982.810669309],
      [78e-11, 2.28840998832, 266.6070417218],
      [71e-11, 1.5194076559, 33794.5437235286],
      [76e-11, 0.22880641443, 57375.8019008462],
      [97e-11, 0.39449562097, 24279.10701821359],
      [75e-11, 2.77638584795, 12964.300703391],
      [77e-11, 5.18846946344, 11520.9968637952],
      [68e-11, 0.50006599129, 4274.5183108324],
      [75e-11, 2.07323762803, 15664.03552270859],
      [77e-11, 0.4666517878, 16207.886271502],
      [81e-11, 4.10452219483, 161710.6187862324],
      [71e-11, 3.91415328513, 7875.6718636242],
      [81e-11, 0.91938383406, 74.7815985673],
      [83e-11, 4.69916218791, 23006.42599258639],
      [69e-11, 0.98999300277, 6393.2821712108],
      [65e-11, 5.41938745446, 28628.3362260996],
      [73e-11, 2.45564765251, 15508.6151232744],
      [65e-11, 3.02336771694, 5959.570433334],
      [64e-11, 0.18375587635, 1066.49547719],
      [8e-10, 5.81239171612, 12341.8069042809],
      [66e-11, 2.15105504851, 38.0276726358],
      [67e-11, 5.14047250153, 9814.6041002912],
      [62e-11, 2.43313614978, 10138.1095169486],
      [68e-11, 2.24442548639, 24383.0791084414],
      [78e-11, 1.39649333997, 9411.4646150872],
      [59e-11, 4.95362151577, 35707.7100829074],
      [73e-11, 1.35229143121, 5327.4761083828],
      [57e-11, 3.16018882154, 5490.300961524],
      [72e-11, 5.91833527334, 10881.0995774812],
      [67e-11, 0.66414713064, 29864.334027309],
      [65e-11, 0.30352816135, 7018.9523635232],
      [59e-11, 5.36231868425, 10239.5838660108],
      [56e-11, 3.22196331515, 2636.725472637],
      [68e-11, 5.32086226658, 3116.6594122598],
      [59e-11, 1.63156134967, 61306.0115970658],
      [54e-11, 4.29491690425, 21947.1113727],
      [7e-10, 0.29271565928, 6528.9074962208],
      [57e-11, 5.89190132575, 34513.2630726828],
      [54e-11, 2.51856815404, 6279.1945146334],
      [74e-11, 1.38235845304, 9967.4538999816],
      [54e-11, 0.92276712152, 6286.9571853494],
      [7e-10, 5.00933012248, 6453.7487206106],
      [53e-11, 3.86543309344, 32370.9789915656],
      [55e-11, 4.51794544854, 34911.412076091],
      [63e-11, 5.41479412056, 11502.8376165305],
      [63e-11, 2.34416220742, 11510.7019230567],
      [56e-11, 0.91310629913, 9910.583327509],
      [67e-11, 4.03308763854, 34596.3646546524],
      [6e-10, 5.57024703495, 5756.9080032458],
      [72e-11, 2.80863088166, 10866.8724834796],
      [66e-11, 6.12047940728, 12074.488407524],
      [51e-11, 2.59519527563, 11396.5634485742],
      [62e-11, 5.14746754396, 25287.7237993998],
      [54e-11, 2.50994032776, 5999.2165311262],
      [51e-11, 4.51195861837, 29822.7832363242],
      [59e-11, 0.44167237876, 250570.6758572191],
      [51e-11, 3.6884906676, 6262.7205305926],
      [49e-11, 0.54704693048, 22594.05489571199],
      [65e-11, 2.38423614501, 52670.0695933026],
      [69e-11, 5.34363738671, 66813.5648357332],
      [56e-11, 2.67216180349, 17892.93839400359],
      [49e-11, 4.18361320516, 18606.4989460002],
      [55e-11, 0.83886167974, 20452.8694122218],
      [5e-10, 1.46327331958, 37455.7264959744],
      [58e-11, 3.34847975377, 33990.6183442862],
      [65e-11, 1.45522693982, 76251.32777062019],
      [56e-11, 2.356506642, 37724.7534197482],
      [48e-11, 1.80689447612, 206.1855484372],
      [56e-11, 3.84224878744, 5483.254724826],
      [53e-11, 0.17334326094, 77717.29458646949],
      [53e-11, 0.79879700631, 77710.24834977149],
      [47e-11, 0.43240779709, 735.8765135318],
      [53e-11, 4.58786566028, 11616.976091013],
      [48e-11, 6.20230111054, 4171.4255366138],
      [52e-11, 2.9171905303, 6993.0088985497],
      [57e-11, 3.42008310383, 50317.2034395308],
      [48e-11, 0.12356889012, 13362.4497067992],
      [6e-10, 5.52056066934, 949.1756089698],
      [45e-11, 3.37963782356, 10763.779709261],
      [47e-11, 5.50958184902, 12779.4507954208],
      [52e-11, 5.42770349015, 310145.1528239236],
      [61e-11, 2.93237974631, 5791.4125575326],
      [44e-11, 2.87440620802, 8584.6616659008],
      [46e-11, 4.0314179656, 10667.8004820432],
      [44e-11, 1.21579107625, 6272.4391846416],
      [47e-11, 2.57670800912, 11492.542675792],
      [44e-11, 3.62570223167, 63658.8777508376],
      [51e-11, 0.84531181151, 12345.739057544],
      [46e-11, 1.17584556517, 149.5631971346],
      [43e-11, 0.01524970172, 37853.8754993826],
      [43e-11, 0.79038834934, 640.8776073822],
      [44e-11, 2.22554419931, 6293.7125153412],
      [49e-11, 1.01528394907, 149144.46708624958],
      [41e-11, 3.27146326065, 8858.3149443206],
      [45e-11, 3.03765521215, 65236.2212932854],
      [58e-11, 5.45843180927, 1975.492545856],
      [41e-11, 1.32190847146, 2547.8375382324],
      [47e-11, 3.67626039848, 28313.288804661],
      [47e-11, 6.21438985953, 10991.3058987006],
      [4e-10, 2.37237751212, 8273.8208670324],
      [56e-11, 1.09773690181, 77376.2010224076],
      [4e-10, 2.35698541041, 2699.7348193176],
      [43e-11, 5.28030897946, 17796.9591667858],
      [54e-11, 2.59175932091, 22910.44676536859],
      [55e-11, 0.07988985505, 83467.15635301729],
      [41e-11, 4.47510694062, 5618.3198048614],
      [4e-10, 1.35670430524, 27177.8515292002],
      [41e-11, 2.48011323946, 6549.6828917132],
      [5e-10, 2.56387920528, 82576.9812209953],
      [42e-11, 4.78798367468, 7856.89627409019],
      [47e-11, 2.75482175292, 18202.21671665939],
      [39e-11, 1.97008298629, 24491.4257925834],
      [42e-11, 4.04346599946, 7863.9425107882],
      [39e-11, 3.0103393642, 853.196381752],
      [38e-11, 0.49178679251, 38650.173506199],
      [44e-11, 1.35931241699, 21393.5419698576],
      [36e-11, 4.86047906533, 4157.1984426122],
      [43e-11, 5.64354880978, 1062.9050485382],
      [39e-11, 3.92736779879, 3903.9113764198],
      [4e-10, 5.3969491832, 9498.2122306346],
      [43e-11, 2.40863861919, 29424.634232916],
      [46e-11, 2.08022244271, 12573.2652469836],
      [5e-10, 6.15760345261, 78051.34191383338]
    ],
    1: [
      [0.00103018607, 1.10748968172, 6283.0758499914],
      [1721238e-11, 1.06442300386, 12566.1516999828],
      [702217e-11, 3.14159265359, 0],
      [32345e-11, 1.02168583254, 18849.2275499742],
      [30801e-11, 2.84358443952, 5507.5532386674],
      [24978e-11, 1.31906570344, 5223.6939198022],
      [18487e-11, 1.42428709076, 1577.3435424478],
      [10077e-11, 5.91385248388, 10977.078804699],
      [8635e-11, 0.27158192945, 5486.777843175],
      [8654e-11, 1.42046854427, 6275.9623029906],
      [5069e-11, 1.68613408916, 5088.6288397668],
      [4985e-11, 6.01402338185, 6286.5989683404],
      [4667e-11, 5.98749245692, 529.6909650946],
      [4395e-11, 0.51800423445, 4694.0029547076],
      [387e-10, 4.74932206877, 2544.3144198834],
      [3755e-11, 5.07053801166, 796.2980068164],
      [41e-9, 1.08424801084, 9437.762934887],
      [3518e-11, 0.02290216978, 83996.84731811189],
      [3436e-11, 0.94937503872, 71430.69561812909],
      [3221e-11, 6.15628775321, 2146.1654164752],
      [3418e-11, 5.4115158188, 775.522611324],
      [2863e-11, 5.48433323746, 10447.3878396044],
      [2525e-11, 0.24296913555, 398.1490034082],
      [2205e-11, 4.94892172085, 6812.766815086],
      [2186e-11, 0.41991932164, 8031.0922630584],
      [2828e-11, 3.41986300734, 2352.8661537718],
      [2554e-11, 6.13241770582, 6438.4962494256],
      [1932e-11, 5.31374587091, 8429.2412664666],
      [2427e-11, 3.09118902115, 4690.4798363586],
      [173e-10, 1.53685999718, 4705.7323075436],
      [225e-10, 3.6883639562, 7084.8967811152],
      [2094e-11, 1.281690604, 1748.016413067],
      [1483e-11, 3.22226346483, 7234.794256242],
      [1434e-11, 0.81293662216, 14143.4952424306],
      [1754e-11, 3.22883705112, 6279.5527316424],
      [1583e-11, 4.09815978783, 11499.6562227928],
      [1575e-11, 5.53890314149, 3154.6870848956],
      [1847e-11, 1.82041234937, 7632.9432596502],
      [1499e-11, 3.63177937611, 11513.8833167944],
      [1337e-11, 4.64442556061, 6836.6452528338],
      [1275e-11, 2.69329661394, 1349.8674096588],
      [1348e-11, 6.15284035323, 5746.271337896],
      [1126e-11, 3.35676107739, 17789.845619785],
      [147e-10, 3.65282991735, 1194.4470102246],
      [1101e-11, 4.4974742767, 4292.3308329504],
      [1168e-11, 2.58033028504, 13367.9726311066],
      [1236e-11, 5.64980098028, 5760.4984318976],
      [985e-11, 0.65326301914, 5856.4776591154],
      [928e-11, 2.3255501829, 10213.285546211],
      [1073e-11, 5.82672338169, 12036.4607348882],
      [918e-11, 0.76907130762, 16730.4636895958],
      [876e-11, 1.50335727807, 11926.2544136688],
      [1023e-11, 5.62071200879, 6256.7775301916],
      [853e-11, 0.6567813463, 155.4203994342],
      [802e-11, 4.10519132094, 951.7184062506],
      [859e-11, 1.42880883564, 5753.3848848968],
      [992e-11, 1.1423800161, 1059.3819301892],
      [814e-11, 1.63584008733, 6681.2248533996],
      [664e-11, 4.55039663226, 5216.5803728014],
      [627e-11, 1.50782904323, 5643.1785636774],
      [644e-11, 4.19480024859, 6040.3472460174],
      [59e-10, 6.18371704849, 4164.311989613],
      [635e-11, 0.5242358477, 6290.1893969922],
      [65e-10, 0.97935492869, 25132.3033999656],
      [568e-11, 2.30121525349, 10973.55568635],
      [549e-11, 5.26737827342, 3340.6124266998],
      [547e-11, 2.20143332641, 1592.5960136328],
      [526e-11, 0.92464258271, 11371.7046897582],
      [493e-11, 5.91036281399, 3894.1818295422],
      [483e-11, 1.6600571154, 12168.0026965746],
      [514e-11, 3.59683072524, 10969.9652576982],
      [516e-11, 3.97164781773, 17298.1823273262],
      [529e-11, 5.0353867768, 9917.6968745098],
      [487e-11, 2.50544745305, 6127.6554505572],
      [419e-11, 4.05235655996, 10984.1923516998],
      [538e-11, 5.54081539813, 553.5694028424],
      [402e-11, 2.16859478359, 7860.4193924392],
      [552e-11, 2.32219865498, 11506.7697697936],
      [367e-11, 3.39145698451, 6496.3749454294],
      [36e-10, 5.34467204596, 7079.3738568078],
      [334e-11, 3.61346365667, 11790.6290886588],
      [454e-11, 0.28755421898, 801.8209311238],
      [419e-11, 3.69613970002, 10575.4066829418],
      [319e-11, 0.30793759304, 16200.7727245012],
      [376e-11, 5.81560210508, 7058.5984613154],
      [364e-11, 1.08425056923, 6309.3741697912],
      [294e-11, 4.54798604178, 11856.2186514245],
      [29e-10, 1.26451946335, 8635.9420037632],
      [394e-11, 4.15683669084, 26.2983197998],
      [26e-10, 5.09424572996, 10177.2576795336],
      [241e-11, 2.25766000302, 11712.9553182308],
      [239e-11, 1.06936978753, 242.728603974],
      [276e-11, 3.44260568764, 5884.9268465832],
      [255e-11, 5.38496803122, 21228.3920235458],
      [307e-11, 4.24313885601, 3738.761430108],
      [213e-11, 3.44661200485, 213.299095438],
      [198e-11, 0.69427265195, 1990.745017041],
      [195e-11, 5.16563409007, 12352.8526045448],
      [213e-11, 3.89937836808, 13916.0191096416],
      [214e-11, 4.00445200772, 5230.807466803],
      [184e-11, 5.59805976614, 6283.14316029419],
      [184e-11, 2.85275392124, 7238.6755916],
      [179e-11, 2.54259058252, 14314.1681130498],
      [236e-11, 5.58826125715, 6069.7767545534],
      [189e-11, 2.72689937708, 6062.6632075526],
      [184e-11, 6.04216273598, 6283.0085396886],
      [225e-11, 1.66128561344, 4732.0306273434],
      [23e-10, 3.62591335086, 6284.0561710596],
      [172e-11, 0.97566476085, 3930.2096962196],
      [162e-11, 2.19467339429, 18073.7049386502],
      [215e-11, 1.04672844028, 3496.032826134],
      [182e-11, 5.17782354566, 17253.04110768959],
      [167e-11, 2.17754938066, 6076.8903015542],
      [167e-11, 4.75672473773, 17267.26820169119],
      [149e-11, 0.80944185798, 709.9330485583],
      [149e-11, 0.17584214812, 9779.1086761254],
      [192e-11, 5.00680790235, 11015.1064773348],
      [141e-11, 4.38420380014, 4136.9104335162],
      [158e-11, 4.60969054283, 9623.6882766912],
      [133e-11, 3.30507062245, 154717.6098876827],
      [166e-11, 6.13191098325, 3.523118349],
      [181e-11, 1.60715321141, 7.1135470008],
      [15e-10, 5.28136702046, 13517.8701062334],
      [142e-11, 0.49788089569, 25158.6017197654],
      [124e-11, 6.03440459813, 9225.539273283],
      [124e-11, 0.99251562639, 65147.6197681377],
      [128e-11, 1.92032744711, 22483.84857449259],
      [124e-11, 3.99739675184, 4686.8894077068],
      [121e-11, 2.37814805239, 167283.7615876655],
      [123e-11, 5.6231511294, 5642.1982426092],
      [117e-11, 5.81755956156, 12569.6748183318],
      [157e-11, 3.40236948518, 16496.3613962024],
      [13e-10, 2.10499918142, 1589.0728952838],
      [116e-11, 0.55839966736, 5849.3641121146],
      [123e-11, 5.81645568991, 6282.0955289232],
      [11e-10, 0.42176497674, 6172.869528772],
      [15e-10, 4.26279600865, 3128.3887650958],
      [106e-11, 2.27436561182, 5429.8794682394],
      [114e-11, 1.52894564202, 12559.038152982],
      [121e-11, 0.39459045915, 12132.439962106],
      [104e-11, 2.41845930933, 426.598190876],
      [109e-11, 5.82786999856, 16858.4825329332],
      [102e-11, 4.4662648491, 23543.23050468179],
      [1e-9, 2.93812275274, 4535.0594369244],
      [97e-11, 3.97935904984, 6133.5126528568],
      [98e-11, 0.87616810121, 6525.8044539654],
      [11e-10, 6.22339014386, 12146.6670561076],
      [98e-11, 3.17344332543, 10440.2742926036],
      [96e-11, 2.44128701699, 3097.88382272579],
      [99e-11, 5.75642493267, 7342.4577801806],
      [9e-10, 0.18984343165, 13119.72110282519],
      [99e-11, 5.58884724219, 2388.8940204492],
      [91e-11, 6.04278320182, 20426.571092422],
      [8e-10, 1.29028142103, 5650.2921106782],
      [86e-11, 3.94529200528, 10454.5013866052],
      [85e-11, 1.92836879835, 29088.811415985],
      [76e-11, 2.70726317966, 143571.32428481648],
      [91e-11, 5.63859073351, 8827.3902698748],
      [76e-11, 1.80783856698, 28286.9904848612],
      [75e-11, 3.40858032804, 5481.2549188676],
      [7e-10, 4.53719487231, 17256.6315363414],
      [89e-11, 1.10064490942, 11769.8536931664],
      [66e-11, 2.78384937771, 536.8045120954],
      [68e-11, 3.88199295043, 17260.1546546904],
      [88e-11, 3.88075269535, 7477.522860216],
      [61e-11, 6.17558202197, 11087.2851259184],
      [6e-10, 4.34824715818, 6206.8097787158],
      [82e-11, 4.59843208943, 9388.0059094152],
      [79e-11, 1.63139280394, 4933.2084403326],
      [81e-11, 1.55550779371, 9380.9596727172],
      [78e-11, 4.20905757519, 5729.506447149],
      [58e-11, 5.76889633224, 3634.6210245184],
      [6e-10, 0.93813100594, 12721.572099417],
      [71e-11, 6.11408885148, 8662.240323563],
      [57e-11, 5.48112524468, 18319.5365848796],
      [7e-10, 0.01749174864, 14945.3161735544],
      [74e-11, 1.0997604582, 16460.33352952499],
      [56e-11, 1.63036186739, 15720.8387848784],
      [55e-11, 4.86788348404, 13095.8426650774],
      [6e-10, 5.93729841267, 12539.853380183],
      [54e-11, 0.22608242982, 15110.4661198662],
      [54e-11, 2.30250047594, 16062.1845261168],
      [64e-11, 2.13513754101, 7875.6718636242],
      [59e-11, 5.87963500139, 5331.3574437408],
      [58e-11, 2.30546168615, 955.5997416086],
      [49e-11, 1.93839278478, 5333.9002410216],
      [54e-11, 5.80331607119, 12043.574281889],
      [54e-11, 4.44671053809, 4701.1165017084],
      [49e-11, 0.30241161485, 6805.6532680852],
      [46e-11, 2.76898193028, 6709.6740408674],
      [46e-11, 3.98449608961, 98068.53671630539],
      [49e-11, 3.72022009896, 12323.4230960088],
      [45e-11, 3.30065998328, 22003.9146348698],
      [48e-11, 0.71071357303, 6303.4311693902],
      [61e-11, 1.66030429494, 6262.300454499],
      [47e-11, 1.26317154881, 11919.140866668],
      [51e-11, 1.08020906825, 10988.808157535],
      [45e-11, 0.89150445122, 51868.2486621788],
      [43e-11, 0.57756724285, 24356.7807886416],
      [43e-11, 1.61526242998, 6277.552925684],
      [45e-11, 2.96132920534, 8982.810669309],
      [43e-11, 5.74295325645, 11403.676995575],
      [55e-11, 3.14274403422, 33019.0211122046],
      [57e-11, 0.06379726305, 15671.0817594066],
      [41e-11, 2.53761820726, 6262.7205305926],
      [4e-10, 1.53130436944, 18451.07854656599],
      [52e-11, 1.71451922581, 1551.045222648],
      [55e-11, 0.89439119424, 11933.3679606696],
      [45e-11, 3.88495384656, 60530.4889857418],
      [4e-10, 4.75740908001, 38526.574350872],
      [4e-10, 3.77498297348, 26087.9031415742],
      [39e-11, 2.97113832621, 2118.7638603784],
      [4e-10, 3.36050962605, 10021.8372800994],
      [47e-11, 1.67051113434, 6303.8512454838],
      [52e-11, 5.21827368711, 77713.7714681205],
      [47e-11, 4.26356628717, 21424.4666443034],
      [37e-11, 1.66712389942, 6819.8803620868],
      [37e-11, 0.65746800933, 12029.3471878874],
      [35e-11, 3.36255650927, 24072.9214697764],
      [36e-11, 0.11087914947, 10344.2950653858],
      [4e-10, 4.14725582115, 2787.0430238574],
      [35e-11, 5.93650887012, 31570.7996493912],
      [36e-11, 2.15108874765, 30774.5016425748],
      [36e-11, 1.75078825382, 16207.886271502],
      [34e-11, 2.75708224536, 12139.5535091068],
      [34e-11, 6.168913788, 24491.4257925834],
      [34e-11, 2.31528650443, 55798.4583583984],
      [32e-11, 4.21446357042, 15664.03552270859],
      [34e-11, 3.19783054699, 32217.2001810808],
      [39e-11, 1.24979117796, 6418.1409300268],
      [38e-11, 5.89832942685, 640.8776073822],
      [33e-11, 4.80200120107, 16723.350142595],
      [32e-11, 1.72442327688, 27433.88921587499],
      [35e-11, 4.44608896525, 18202.21671665939],
      [31e-11, 4.5279073128, 6702.5604938666],
      [34e-11, 3.96287980676, 18216.443810661],
      [3e-10, 5.06259854444, 226858.23855437007],
      [34e-11, 1.43910280005, 49515.382508407],
      [3e-10, 0.29303163371, 13521.7514415914],
      [29e-11, 2.0263384022, 11609.8625440122],
      [3e-10, 2.5492323024, 9924.8104215106],
      [32e-11, 4.91793198558, 11300.5842213564],
      [3e-10, 0.23284423547, 23581.2581773176],
      [29e-11, 1.62807736495, 639.897286314],
      [28e-11, 3.84568936822, 2699.7348193176],
      [29e-11, 1.83149729794, 29822.7832363242],
      [33e-11, 4.60320094415, 19004.6479494084],
      [27e-11, 1.86151121799, 6288.5987742988],
      [3e-10, 4.4649407224, 36147.4098773004],
      [28e-11, 5.19684492912, 5863.5912061162],
      [35e-11, 4.52695674113, 36949.2308084242],
      [27e-11, 3.52528177609, 10770.8932562618],
      [26e-11, 1.48499438453, 11080.1715789176],
      [35e-11, 2.82154380962, 19402.7969528166],
      [25e-11, 2.46339998836, 6279.4854213396],
      [26e-11, 4.97688894643, 16737.5772365966],
      [27e-11, 0.408271125, 12964.300703391],
      [29e-11, 4.15148654061, 45892.73043315699],
      [26e-11, 4.56404104286, 17796.9591667858],
      [25e-11, 2.89309528854, 6286.6662786432],
      [26e-11, 4.82914580957, 1066.49547719],
      [31e-11, 3.93096113738, 29864.334027309],
      [24e-11, 6.14987193584, 18606.4989460002],
      [24e-11, 3.74225964547, 29026.48522950779],
      [25e-11, 5.70460621565, 27707.5424942948],
      [25e-11, 5.33928840652, 15141.390794312],
      [23e-11, 2.37624087345, 17996.0311682222],
      [26e-11, 1.34231351782, 18875.525869774],
      [22e-11, 5.5079162612, 6245.0481773556],
      [24e-11, 1.33998410121, 19800.9459562248],
      [23e-11, 0.2251228089, 6279.7894925736],
      [22e-11, 1.17576471775, 11925.2740926006],
      [22e-11, 3.5860360664, 6915.8595893046],
      [23e-11, 3.21621246666, 6286.3622074092],
      [29e-11, 2.09564449439, 15265.8865193004],
      [22e-11, 4.74660932338, 28230.18722269139],
      [21e-11, 2.30688751432, 5999.2165311262],
      [28e-11, 3.92087592807, 18208.349942592],
      [21e-11, 3.22643339385, 25934.1243310894],
      [21e-11, 3.04956726238, 6566.9351688566],
      [27e-11, 5.35645770522, 33794.5437235286],
      [25e-11, 5.91542362188, 6489.2613984286],
      [2e-10, 1.52296293311, 135.0650800354],
      [19e-11, 1.78134428631, 156137.47598479927],
      [19e-11, 0.34388684087, 5327.4761083828],
      [26e-11, 3.41701003233, 25287.7237993998],
      [19e-11, 2.86664271911, 18422.62935909819],
      [19e-11, 4.71432851499, 77690.75950573849],
      [19e-11, 2.54227398241, 77736.78343050249],
      [2e-10, 5.91915117116, 48739.859897083]
    ],
    2: [
      [4359385e-11, 5.78455133808, 6283.0758499914],
      [123633e-11, 5.57935427994, 12566.1516999828],
      [12342e-11, 3.14159265359, 0],
      [8792e-11, 3.62777893099, 77713.7714681205],
      [5689e-11, 1.86958905084, 5573.1428014331],
      [3302e-11, 5.47034879713, 18849.2275499742],
      [1471e-11, 4.47964125007, 5507.5532386674],
      [1013e-11, 2.81323115556, 5223.6939198022],
      [854e-11, 3.107765669, 1577.3435424478],
      [1102e-11, 2.84173992403, 161000.6857376741],
      [648e-11, 5.47348203398, 775.522611324],
      [608e-11, 1.37894173533, 6438.4962494256],
      [499e-11, 4.4164924225, 6286.5989683404],
      [416e-11, 0.90332697974, 10977.078804699],
      [404e-11, 3.2056726953, 5088.6288397668],
      [351e-11, 1.81081728907, 5486.777843175],
      [466e-11, 3.65086758149, 7084.8967811152],
      [458e-11, 5.38585314743, 149854.4001348079],
      [304e-11, 3.51015066341, 796.2980068164],
      [266e-11, 6.17413982699, 6836.6452528338],
      [281e-11, 1.8387467254, 4694.0029547076],
      [262e-11, 1.41420110644, 2146.1654164752],
      [264e-11, 3.14103683911, 71430.69561812909],
      [319e-11, 5.35037932146, 3154.6870848956],
      [238e-11, 2.17695432424, 155.4203994342],
      [229e-11, 4.7596958807, 7234.794256242],
      [291e-11, 4.61776401638, 4690.4798363586],
      [211e-11, 0.21864885298, 4705.7323075436],
      [204e-11, 4.22895113488, 1349.8674096588],
      [195e-11, 4.58550676556, 529.6909650946],
      [255e-11, 2.81442711144, 1748.016413067],
      [182e-11, 5.70454011389, 6040.3472460174],
      [18e-10, 6.02147727878, 4292.3308329504],
      [186e-11, 1.58690991244, 6309.3741697912],
      [167e-11, 2.88802733052, 9437.762934887],
      [166e-11, 1.99990574734, 8031.0922630584],
      [16e-10, 0.04412738495, 2544.3144198834],
      [197e-11, 2.01089431842, 1194.4470102246],
      [165e-11, 5.78372596774, 83996.84731811189],
      [214e-11, 3.38300910371, 7632.9432596502],
      [14e-10, 0.36669664351, 10447.3878396044],
      [151e-11, 0.95519595275, 6127.6554505572],
      [136e-11, 1.48417295645, 2352.8661537718],
      [128e-11, 5.48057748834, 951.7184062506],
      [126e-11, 5.26866506592, 6279.5527316424],
      [127e-11, 3.77552907014, 6812.766815086],
      [103e-11, 4.95897533789, 398.1490034082],
      [104e-11, 0.70183576826, 1592.5960136328],
      [101e-11, 1.14481598642, 3894.1818295422],
      [131e-11, 0.76624310306, 553.5694028424],
      [109e-11, 5.41063597567, 6256.7775301916],
      [78e-11, 5.84775340741, 242.728603974],
      [97e-11, 1.94685257714, 11856.2186514245],
      [1e-9, 5.19725292131, 244287.60000722768],
      [76e-11, 0.70480774041, 8429.2412664666],
      [8e-10, 6.18430772683, 1059.3819301892],
      [68e-11, 5.29561709093, 14143.4952424306],
      [85e-11, 5.39487308005, 25132.3033999656],
      [55e-11, 5.16874637579, 7058.5984613154],
      [63e-11, 0.48494730699, 801.8209311238],
      [58e-11, 4.07254840265, 13367.9726311066],
      [51e-11, 3.89696552232, 12036.4607348882],
      [51e-11, 5.56335232286, 1990.745017041],
      [6e-10, 2.2504659671, 8635.9420037632],
      [49e-11, 5.58163417371, 6290.1893969922],
      [51e-11, 3.87240194908, 26.2983197998],
      [51e-11, 4.19300909995, 7860.4193924392],
      [41e-11, 3.97169191582, 10973.55568635],
      [41e-11, 3.5708091923, 7079.3738568078],
      [56e-11, 2.76959005761, 90955.5516944961],
      [42e-11, 1.91461189163, 7477.522860216],
      [42e-11, 0.42775891995, 10213.285546211],
      [42e-11, 1.06925480488, 709.9330485583],
      [38e-11, 6.17935925345, 9917.6968745098],
      [5e-10, 0.81691517401, 11506.7697697936],
      [53e-11, 1.45828359397, 233141.3144043615],
      [38e-11, 3.32444534628, 5643.1785636774],
      [47e-11, 6.21543665927, 6681.2248533996],
      [37e-11, 0.3635930998, 10177.2576795336],
      [45e-11, 5.29587706357, 10575.4066829418],
      [34e-11, 5.63446915337, 6525.8044539654],
      [34e-11, 5.36385158519, 4933.2084403326],
      [35e-11, 5.36152295839, 25158.6017197654],
      [42e-11, 5.08837645072, 11015.1064773348],
      [42e-11, 4.22496037505, 88860.05707098669],
      [39e-11, 1.99171699618, 6284.0561710596],
      [29e-11, 3.1908862817, 11926.2544136688],
      [29e-11, 0.14996158324, 12168.0026965746],
      [3e-10, 1.58346276808, 9779.1086761254],
      [26e-11, 4.16210340581, 12569.6748183318],
      [36e-11, 2.74684637873, 3738.761430108],
      [26e-11, 0.7282491532, 1589.0728952838],
      [31e-11, 5.34906371821, 143571.32428481648],
      [25e-11, 0.10240267494, 22483.84857449259],
      [3e-10, 3.47110495524, 14945.3161735544],
      [26e-11, 3.89359701125, 5753.3848848968],
      [24e-11, 1.18744224678, 4535.0594369244],
      [33e-11, 2.99317143244, 3930.2096962196],
      [24e-11, 1.57253767584, 6496.3749454294],
      [24e-11, 3.47434797542, 4136.9104335162],
      [22e-11, 3.91230073719, 6275.9623029906],
      [25e-11, 4.02978941287, 3128.3887650958],
      [23e-11, 1.07724492065, 12721.572099417],
      [21e-11, 1.89591807148, 16730.4636895958],
      [25e-11, 2.42198937013, 5729.506447149],
      [2e-10, 1.78163489101, 17789.845619785],
      [21e-11, 0.49258939822, 29088.811415985],
      [26e-11, 4.14947806747, 2388.8940204492],
      [27e-11, 2.54785812264, 3496.032826134],
      [2e-10, 4.29944129273, 16858.4825329332],
      [21e-11, 5.97796936723, 7.1135470008],
      [19e-11, 0.80292033311, 16062.1845261168],
      [24e-11, 4.89894141052, 17260.1546546904],
      [25e-11, 1.37003752175, 6282.0955289232],
      [22e-11, 4.92663152168, 18875.525869774],
      [23e-11, 5.68902059771, 16460.33352952499],
      [23e-11, 3.03021283729, 66567.48586525429],
      [16e-11, 3.89713736666, 5331.3574437408],
      [16e-11, 5.68562539832, 12559.038152982],
      [16e-11, 3.95085099736, 3097.88382272579],
      [16e-11, 3.99041783945, 6283.14316029419],
      [2e-10, 6.106439191, 167283.7615876655],
      [15e-11, 4.09775914607, 11712.9553182308],
      [16e-11, 5.717699407, 17298.1823273262],
      [16e-11, 3.28894009404, 5884.9268465832],
      [15e-11, 4.4256424368, 13517.8701062334],
      [16e-11, 4.4345208093, 6283.0085396886],
      [14e-11, 1.44384279999, 4164.311989613],
      [14e-11, 4.47380919159, 11790.6290886588],
      [14e-11, 4.77646531825, 7342.4577801806],
      [11e-11, 2.56768522896, 5481.2549188676],
      [11e-11, 1.514433322, 16200.7727245012],
      [11e-11, 0.88708889185, 21228.3920235458],
      [14e-11, 4.50116508534, 640.8776073822]
    ],
    3: [
      [144595e-11, 4.27319433901, 6283.0758499914],
      [6729e-11, 3.91706261708, 12566.1516999828],
      [774e-11, 0, 0],
      [247e-11, 3.73021571217, 18849.2275499742],
      [36e-11, 2.8008140905, 6286.5989683404],
      [33e-11, 5.62990083112, 6127.6554505572],
      [18e-11, 3.72826142555, 6438.4962494256],
      [16e-11, 4.26011484232, 6525.8044539654],
      [14e-11, 3.47817116396, 6256.7775301916],
      [12e-11, 3.55747379482, 25132.3033999656],
      [1e-10, 4.43995693209, 4705.7323075436],
      [1e-10, 4.2804525547, 83996.84731811189],
      [9e-11, 5.36457057335, 6040.3472460174],
      [8e-11, 1.78458957263, 5507.5532386674],
      [9e-11, 0.4727519993, 6279.5527316424],
      [9e-11, 1.34741231639, 6309.3741697912],
      [9e-11, 0.77092900708, 5729.506447149],
      [7e-11, 3.50146897332, 7058.5984613154],
      [5e-11, 2.890710617, 775.522611324],
      [6e-11, 2.36514111314, 6836.6452528338]
    ],
    4: [
      [3858e-11, 2.56389016346, 6283.0758499914],
      [306e-11, 2.26911740541, 12566.1516999828],
      [53e-11, 3.44031471924, 5573.1428014331],
      [15e-11, 2.03136359366, 18849.2275499742],
      [13e-11, 2.05688873673, 77713.7714681205],
      [7e-11, 4.4121885448, 161000.6857376741],
      [4e-11, 5.33854414781, 6438.4962494256],
      [6e-11, 3.81514213664, 149854.4001348079],
      [4e-11, 4.26602478239, 6127.6554505572]
    ],
    5: [
      [86e-11, 1.21805304895, 6283.0758499914],
      [12e-11, 0.65572878044, 12566.1516999828]
    ]
  },
  name: "earth",
  type: "B"
}, IX = g9, po = new Ku.Planet(IX);
class xX extends Te {
  /**
   * @param {object} [opts]
   * @param {string} opts.season - type of season (spring|summer|autumn|winter)
   * @param {number|string} opts.offset - offset in days
   */
  constructor(n) {
    n = n || {}, super(n), this._season = n.season, this._timezone = n.timezone || "GMT";
  }
  inYear(n) {
    let a;
    switch (this._season) {
      case "march": {
        a = Nn.march2(n, po);
        break;
      }
      case "june": {
        a = Nn.june2(n, po);
        break;
      }
      case "september": {
        a = Nn.september2(n, po);
        break;
      }
      case "december": {
        a = Nn.december2(n, po);
        break;
      }
    }
    const t = new T2.Calendar().fromJDE(a).toDate().toISOString();
    let r;
    /^[+-]\d{2}:\d{2}?$/.test(this._timezone) ? r = W0(t).utcOffset(this._timezone) : r = W0(t).tz(this._timezone);
    const M = {
      year: n,
      month: r.month() + 1,
      day: r.date()
    }, b = new d1(M).setOffset(this.offset);
    return this.dates.push(b), this;
  }
}
const FX = g9;
/**
 * @copyright 2016 commenthol
 * @license MIT
 */
const co = new Ku.Planet(FX), zo = je.meanLunarMonth / 2, Z5 = 180 / Math.PI, R9 = -2636, HX = new T2.CalendarGregorian(R9, 2, 15).toJDE();
function Oo(e) {
  return new T2.CalendarGregorian().fromJDE(e).toYear();
}
function zt(e, n) {
  return parseFloat(e.toFixed(n), 10);
}
class n3 {
  /**
   * constructor
   *
   * @param {Number|Array|Object} cycle - chinese 60 year cicle; if `{Array}` than `[cycle, year, ..., day]`
   * @param {Number} year - chinese year of cycle
   * @param {Number} month - chinese month
   * @param {Number} leap - `true` if leap month
   * @param {Number} day - chinese day
   */
  constructor(n, a, t, r, M) {
    this.set(n, a, t, r, M), this._epochY = R9, this._epoch = HX, this._cache = {
      // cache for results
      lon: {},
      sue: {},
      ny: {}
    };
  }
  /**
   * set a new chinese date
   *
   * @param {Number|Array|Object} cycle - chinese 60 year cicle; if `{Array}` than `[cycle, year, ..., day]`
   * @param {Number} year - chinese year of cycle
   * @param {Number} month - chinese month
   * @param {Number} leap - `true` if leap month
   * @param {Number} day - chinese day
   */
  set(n, a, t, r, M) {
    return n instanceof n3 ? (this.cycle = n.cycle, this.year = n.year, this.month = n.month, this.leap = n.leap, this.day = n.day) : Array.isArray(n) ? (this.cycle = n[0], this.year = n[1], this.month = n[2], this.leap = n[3], this.day = n[4]) : (this.cycle = n, this.year = a, this.month = t, this.leap = r, this.day = M), this;
  }
  /**
   * returns chinese date
   * @returns {Array}
   */
  get() {
    return [this.cycle, this.year, this.month, this.leap, this.day];
  }
  /**
   * get Gregorian year from Epoch / Cycle
   * @return {Number} year
   */
  yearFromEpochCycle() {
    return this._epochY + (this.cycle - 1) * 60 + (this.year - 1);
  }
  /**
   * convert gregorian date to chinese calendar date
   *
   * @param {Number} year - (int) year in Gregorian or Julian Calendar
   * @param {Number} month - (int)
   * @param {Number} day - needs to be in correct (chinese) timezone
   * @return {Object} this
   */
  fromGregorian(n, a, t) {
    const r = this.midnight(new T2.CalendarGregorian(n, a, t).toJDE());
    return a === 1 && t <= 20 && n--, this._from(r, n), this;
  }
  /**
   * convert date to chinese calendar date
   *
   * @param {Date} date - javascript date object
   * @return {Object} this
   */
  fromDate(n) {
    const a = this.midnight(new T2.CalendarGregorian().fromDate(n).toJDE());
    return this._from(a, n.getFullYear()), this;
  }
  /**
   * convert JDE to chinese calendar date
   *
   * @param {Number} jde - date in JDE
   * @return {Object} this
   */
  fromJDE(n) {
    const a = this.midnight(n), t = new T2.CalendarGregorian().fromJDE(a);
    return t.month === 1 && t.day < 20 && t.year--, this._from(a, t.year), this;
  }
  /**
   * common conversion from JDE, year to chinese date
   *
   * @private
   * @param {Number} j - date in JDE
   * @param {Number} year - gregorian year
   */
  _from(n, a) {
    let t = this.newYear(a);
    t > n && (t = this.newYear(a - 1));
    let r = this.previousNewMoon(n);
    r < t && (r = t);
    const M = 1.5 + (t - this._epoch) / L.BesselianYear;
    this.cycle = 1 + Math.trunc((M - 1) / 60), this.year = 1 + Math.trunc((M - 1) % 60), this.month = this.inMajorSolarTerm(r).term;
    const b = Math.round((r - t) / je.meanLunarMonth);
    b === 0 ? (this.month = 1, this.leap = !1) : this.leap = this.isLeapMonth(r), b > this.month ? this.month = b : this.leap && this.month--, this.day = 1 + Math.trunc(zt(n, 3) - zt(r, 3));
  }
  /**
   * convert chinese date to gregorian date
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @return {Object} date in gregorian (preleptic) calendar; Timezone is Standard Chinese / Bejing Time
   *   {Number} year - (int)
   *   {Number} month - (int)
   *   {Number} day - (int)
   */
  toGregorian(n) {
    const a = this.toJDE(n), t = new T2.CalendarGregorian().fromJDE(a + 0.5);
    return {
      year: t.year,
      month: t.month,
      day: Math.trunc(t.day)
    };
  }
  /**
   * convert chinese date to Date
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @return {Date} javascript date object in gregorian (preleptic) calendar
   */
  toDate(n) {
    const a = this.toJDE(n);
    return new T2.CalendarGregorian().fromJDE(zt(a, 4)).toDate();
  }
  /**
   * convert chinese date to JDE
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @return {Number} date in JDE
   */
  toJDE(n) {
    const a = n || this.yearFromEpochCycle(), t = this.newYear(a);
    let r = t;
    if (this.month > 1) {
      r = this.previousNewMoon(t + this.month * 29);
      const b = this.inMajorSolarTerm(r).term, d = this.isLeapMonth(r);
      b > this.month ? r = this.previousNewMoon(r - 1) : (b < this.month || d && !this.leap) && (r = this.nextNewMoon(r + 1));
    }
    return this.leap && (r = this.nextNewMoon(r + 1)), r + this.day - 1;
  }
  /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */
  timeshiftUTC(n) {
    return n.toYear() >= 1929 ? 8 / 24 : 1397 / 180 / 24;
  }
  /**
   * time/date at midnight - truncate `jde` to actual day
   *
   * @param {Number} jde - julian ephemeris day
   * @return {Number} truncated jde
   */
  midnight(n) {
    const a = new T2.CalendarGregorian().fromJDE(n), t = 0.5 - this.timeshiftUTC(a);
    let r = Math.trunc(a.toJD() - t) + t;
    return r = a.fromJD(r).toJDE(), zt(n, 5) === zt(r, 5) + 1 ? n : r;
  }
  /**
   * get major solar term `Z1...Z12` for a given date in JDE
   *
   * @param {Number} jde - date of new moon
   * @returns {Number} major solar term part of that month
   */
  inMajorSolarTerm(n) {
    const a = this._cache.lon[n] || a9.apparentVSOP87(co, n).lon;
    this._cache.lon[n] = a;
    const t = a * Z5 - 1e-13;
    return { term: (2 + Math.floor(t / 30)) % 12 + 1, lon: t };
  }
  /**
   * Test if date `jde` is inside a leap month
   * `jde` and previous new moon need to have the same major solar term
   *
   * @param {Number} jde - date of new moon
   * @returns {Boolean} `true` if previous new moon falls into same solar term
   */
  isLeapMonth(n) {
    const a = this.inMajorSolarTerm(n), t = this.nextNewMoon(this.midnight(n + zo)), r = this.inMajorSolarTerm(t);
    return a.term === r.term;
  }
  /**
   * next new moon since `jde`
   *
   * @param {Number} jde - date in julian ephemeris days
   * @return {Number} jde at midnight
   */
  nextNewMoon(n) {
    let a = this.midnight(je.newMoon(Oo(n))), t = 0;
    for (; a < n && t++ < 4; )
      a = this.midnight(je.newMoon(Oo(n + t * zo)));
    return a;
  }
  /**
   * next new moon since `jde`
   *
   * @param {Number} jde - date in julian ephemeris days
   * @return {Number} jde at midnight
   */
  previousNewMoon(n) {
    let a = this.midnight(je.newMoon(Oo(n))), t = 0;
    for (; a > n && t++ < 4; )
      a = this.midnight(je.newMoon(Oo(n - t * zo)));
    return a;
  }
  /**
   * chinese new year for a given gregorian year
   *
   * @param {Number} gyear - gregorian year (int)
   * @param {Number} jde at midnight
   */
  newYear(n) {
    if (n = Math.trunc(n), this._cache.ny[n]) return this._cache.ny[n];
    const a = this._cache.sue[n - 1] || Nn.december2(n - 1, co), t = this._cache.sue[n] || Nn.december2(n, co);
    this._cache.sue[n - 1] = a, this._cache.sue[n] = t;
    const r = this.previousNewMoon(this.midnight(t + 1)), M = this.nextNewMoon(this.midnight(a + 1)), b = this.nextNewMoon(this.midnight(M + zo));
    this.leapSui = Math.round((r - M) / je.meanLunarMonth) === 12;
    let d = b;
    return this.leapSui && (this.isLeapMonth(M) || this.isLeapMonth(b)) && (d = this.nextNewMoon(this.midnight(b + je.meanLunarMonth / 2))), this._cache.ny[n] = d, d;
  }
  /**
   * get solar term from solar longitude
   *
   * @param {Number} term - jiéqì solar term 1 .. 24
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */
  solarTerm(n, a) {
    a && n <= 3 && a--;
    const t = a || this.yearFromEpochCycle(), r = (n + 20) % 24 * 15 % 360;
    let M = Nn.longitude(t, co, r / Z5);
    return M = this.midnight(M), M;
  }
  /**
   * get major solar term
   *
   * @param {Number} term - zhōngqì solar term Z1 .. Z12
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */
  majorSolarTerm(n, a) {
    return this.solarTerm(n * 2, a);
  }
  /**
   * get minor solar term
   *
   * @param {Number} term - jiéqì solar term J1 .. J12
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */
  minorSolarTerm(n, a) {
    return this.solarTerm(n * 2 - 1, a);
  }
  /**
   * Qı̄ngmíng - Pure brightness Festival
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */
  qingming(n) {
    return this.solarTerm(5, n);
  }
}
/**
 * @copyright 2016 commenthol
 * @license MIT
 */
const $9 = -2333, UX = new T2.CalendarGregorian($9, 1, 27).toJDE(), KM = [
  {
    date: /* @__PURE__ */ new Date("1961-10-09T15:00:00.000Z"),
    // 1961-10-10T00:00:00+0900
    shift: 9 / 24
  },
  // +9:00:00h (135° East)
  {
    date: /* @__PURE__ */ new Date("1954-03-20T15:30:00.000Z"),
    // 1954-03-21T00:00:00+0830
    shift: 8.5 / 24
  },
  {
    date: /* @__PURE__ */ new Date("1911-12-31T15:00:00.000Z"),
    // 1912-01-01T00:00:00+0900
    shift: 9 / 24
  },
  {
    date: /* @__PURE__ */ new Date("1908-03-31T15:30:00.000Z"),
    // 1908-04-01T00:00:00+0830
    shift: 8.5 / 24
  }
];
class jX extends n3 {
  constructor(n, a, t, r, M) {
    super(n, a, t, r, M), this._epochY = $9, this._epoch = UX;
  }
  /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */
  timeshiftUTC(n) {
    const a = n.toDate();
    for (const t in KM)
      if (a >= KM[t].date)
        return KM[t].shift;
    return 3809 / 450 / 24;
  }
}
/**
 * @copyright 2016 commenthol
 * @license MIT
 */
class GX extends n3 {
  /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */
  timeshiftUTC(n) {
    return n.toYear() >= 1968 ? 7 / 24 : 8 / 24;
  }
}
class VX extends Te {
  /**
   * @param {object} [opts]
   */
  constructor(n) {
    switch (n = n || {}, super(n), n.fn) {
      case "chinese":
        this.cal = new n3();
        break;
      case "korean":
        this.cal = new jX();
        break;
      case "vietnamese":
        this.cal = new GX();
        break;
    }
  }
  inYear(n) {
    let a, t, r;
    const M = this.opts;
    return M.solarterm ? (t = this.cal.solarTerm(M.solarterm, n), r = this.cal.fromJDE(t).toGregorian(), a = new d1(r).setOffset(M.day - 1)) : (this.cal.set(M.cycle, M.year, M.month, M.leapMonth, M.day), t = this.cal.toJDE(n), r = this.cal.fromJDE(t).toGregorian(), a = new d1(r)), this.dates.push(a), this;
  }
}
const L9 = ["বৈশাখ", "জ্যৈষ্ঠ", "আষাঢ়", "শ্রাবণ", "ভাদ্র", "আশ্বিন", "কার্তিক", "অগ্রহায়ণ", "পৌষ", "মাঘ", "ফাল্গুন", "চৈত্র"], YX = ["রবিবার", "সোমবার", "মঙ্গলবার", "বুধবার", "বৃহস্পতিবার", "শুক্রবার", "শনিবার"], JX = ["গ্রীষ্ম", "বর্ষা", "শরৎ", "হেমন্ত", "শীত", "বসন্ত"], _9 = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];
let U4;
const KX = () => {
  U4 = _9.reduce((e, n, a) => (e[n] = a, e), {});
}, ZM = (e) => String(e).replace(/\d/g, (n) => _9[n]), QM = (e) => {
  U4 || KX();
  const n = L9.indexOf(e), a = n !== -1 ? n + 1 : String(e).replace(/./g, (t) => {
    const r = U4[t];
    return r !== void 0 ? r : t;
  });
  return Number(a);
}, ZX = (e) => YX[e], QX = (e) => L9[e - 1], eP = (e) => JX[Math.floor((e - 1) / 2)];
/**
 * @copyright 2018-present commenthol
 * @license MIT
 */
const Q5 = 593, ez = 864e5, nz = [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30], az = [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 31, 30], tz = (e) => e % 4 === 0 && e % 100 !== 0 || e % 400 === 0, N9 = 6, oz = (e) => Date.UTC(e, 3, 13, N9);
class nP {
  /**
   * @constructor
   * @param {Number|String} year - bengali year
   * @param {Number|String} month - (int) 1...12
   * @param {Number|String} day - 1...31
   * @return {Object} this
   */
  constructor(n, a, t) {
    Object.assign(this, {
      year: QM(n),
      month: QM(a) || 1,
      day: QM(t) || 1
    });
  }
  /**
   * convert gregorian date to bengali calendar date
   * @param {Number} year - (int) year in Gregorian Calendar
   * @param {Number} month - (int)
   * @param {Number} day - (int)
   * @return {Object} this
   */
  fromGregorian(n, a, t) {
    const r = tz(n) ? az : nz;
    let M = n;
    (a < 4 || a === 4 && t < 14) && (M -= 1), this.year = M - Q5;
    const b = Date.UTC(n, a - 1, t, N9);
    let d = Math.floor((b - oz(M)) / ez);
    for (let c = 0; c < r.length; c++) {
      if (d <= r[c]) {
        this.month = c + 1;
        break;
      }
      d -= r[c];
    }
    return this.day = d, this;
  }
  /**
   * convert date to bengali calendar date
   * @param {Date} date - javascript date object - uses local date
   * @return {Object} this
   */
  fromDate(n) {
    return this.fromGregorian(n.getFullYear(), n.getMonth() + 1, n.getDate());
  }
  /**
   * convert bengali date to gregorian date
   * @return {Object} date in gregorian (preleptic) calendar
   *   {Number} year - (int)
   *   {Number} month - (int) 1...12
   *   {Number} day - (int) 1...31
   */
  toGregorian() {
    const n = this.toDate();
    return {
      year: n.getUTCFullYear(),
      month: n.getUTCMonth() + 1,
      day: n.getUTCDate()
    };
  }
  /**
   * convert bengali date to Date
   * @return {Date} javascript date object in gregorian (preleptic) calendar
   */
  toDate() {
    const n = this.year + Q5, a = oz(n), t = this.month > 10 ? n + 1 : n, r = tz(t) ? az : nz;
    let M = this.day;
    for (let d = 0; d < this.month - 1; d++)
      M += r[d];
    return new Date(M * ez + a);
  }
  /**
   * format date in bengali
   * @param {String} formatStr - string formatter
   *
   * | Input | Description  |
   * | ----- | ------------ |
   * | Y     | Year with any number of digits and sign |
   * | Q     | Season Name  |
   * | M     | Month number |
   * | MMMM  | Month name   |
   * | D     | Day of month |
   * | dddd  | Day name     |
   *
   * @return {String}
   */
  format(n) {
    if (n = n || "D M, Y", /dddd/.test(n)) {
      const a = this.toDate();
      n = n.replace(/dddd/g, ZX(a.getUTCDay()));
    }
    return n.replace(/Y/g, ZM(this.year)).replace(/Q/g, eP(this.month)).replace(/MMMM/g, QX(this.month)).replace(/M/g, ZM(this.month)).replace(/D/g, ZM(this.day));
  }
}
class aP extends Te {
  /**
   * @param {object} [opts]
   */
  constructor(n) {
    n = n || {}, super(n);
  }
  inYear(n) {
    const a = this.opts, t = new nP(n - 593, a.month, a.day).toGregorian(), r = new d1(t);
    return this.dates.push(r), this;
  }
}
class tP {
  constructor(n) {
    switch (n.fn) {
      case "easter":
        return new NC(n);
      case "julian":
        return new LX(n);
      case "hebrew":
        return new NX(n);
      case "islamic":
        return new DX(n);
      case "jalaali":
        return new kX(n);
      case "equinox":
        return new xX(n);
      case "chinese":
      case "korean":
      case "vietnamese":
        return new VX(n);
      case "bengali-revised":
        return new aP(n);
      default:
        return new Te(n);
    }
  }
}
class oP {
  /**
   * @param {string} rule - unparsed rule
   * @param {array} holidays - all holidays rules (required for bridge day calculations)
   */
  constructor(n, a) {
    const t = new jb();
    this.ruleStr = n, this.rules = t.parse(n), this.ok = !t.error, this.holidays = a, this.opts = a ? a[n] : {}, this.event = void 0, this.cache = /* @__PURE__ */ new Map();
  }
  /**
   * @param {number} year
   * @returns {this}
   */
  inYear(n) {
    if (this.cache.has(n))
      return this.event = this.cache.get(n), this;
    let a;
    const t = new yC(this.ruleStr, this.opts, this.holidays);
    this.rules.forEach((M) => {
      if (M.fn) {
        const b = new tP(M).inYear(n - 1).inYear(n).inYear(n + 1);
        t.push(b), a = new Lu(b);
      } else
        a.resolve(M) && t.resolve(M, n);
    });
    const r = t.getEvent(n);
    return this.cache.set(n, r), this.event = r, this;
  }
  get(n) {
    return this.event.get(n);
  }
}
class rz {
  constructor(n) {
    const { rule: a, fn: t, opts: r, ...M } = n;
    Object.assign(this, { rule: a, ...M });
  }
  /**
   * disable rule in year (month)
   * @param {number} year
   * @param {number} [month] - 1..12
   */
  disableIn(n, a) {
    if (!p0(n)) return;
    a = a < 1 && a > 12 ? void 0 : a < 10 ? "0" + Number(a) : a;
    const t = [n, a].filter(Boolean).join("-");
    this.disable = (this.disable || []).concat(t).sort();
  }
}
/**
 * @copyright 2016- (c) commenthol
 * @license ISC
 */
const rP = ["observance", "optional", "school", "bank", "public"];
let iP = class {
  constructor(n, a, t, r, M) {
    if (!n)
      throw new TypeError("need holiday data");
    this._data = n, this.init(a, t, r, M);
  }
  /**
   * initialize holidays for a country/state/region
   * @param {String|Object} country - if object, use `{ country: {String}, state: {String}, region: {String} }`
   * @param {String} [state] - specifies state
   * @param {String} [region] - specifies region
   * @param {Object} [opts] - options
   * @param {Array|String} [opts.languages] - set language(s) with ISO 639-1 shortcodes
   * @param {String} [opts.timezone] - set timezone
   * @param {Array} [opts.types] - holiday types to consider; priority is in ascending order (low ... high)
   */
  init(...n) {
    const [a, t, r, M] = MP(...n);
    this.__conf = null, this.__types = M.types && M.types.length ? M.types : rP, this.holidays = {}, this.setLanguages(), this.__conf = S2.splitName(a, t, r), this.__data = new S2(M.data || this._data, this.__conf), M.languages ? this.setLanguages(M.languages) : this.setLanguages(this.__data.getLanguages(this.__conf));
    const b = this.__data.getRules();
    if (b)
      return this.__timezone = M.timezone || this.__data.getTimezones()[0], Object.keys(b).forEach((d) => {
        this.setHoliday(d, b[d]);
      }), !0;
  }
  /**
   * set (custom) holiday
   * @throws {TypeError}
   * @param {String} rule - rule for holiday (check supported grammar) or date in ISO Format, e.g. 12-31 for 31st Dec
   * @param {Object|String} [opts] - holiday options (if String, then opts is used as name)
   * @param {Object} opts.name - translated holiday names e.g. `{ en: 'name', es: 'nombre', ... }`
   * @param {String} opts.type - holiday type `public|bank|school|observance`
   * @returns {Boolean} `true` if holiday could be set
   */
  setHoliday(n, a) {
    if (a === !1)
      return this.holidays[n] ? (this.holidays[n] = !1, !0) : !1;
    if (!a || typeof a == "string") {
      a = a || n;
      const r = this.getLanguages()[0];
      a = w1.set({ type: "public" }, ["name", r], a);
    }
    if (a.active) {
      if (!Array.isArray(a.active))
        throw TypeError(".active is not of type Array: " + n);
      a.active = a.active.map((r) => {
        const M = F5(r.from), b = F5(r.to);
        if (!(M || b))
          throw TypeError(".active needs .from or .to property: " + n);
        return { from: M, to: b };
      });
    }
    if (!this.__types.includes(a.type))
      return !1;
    this.holidays[n] = a;
    const t = new oP(n, this.holidays);
    return t.ok ? (this.holidays[n].fn = t, !0) : (console.error("could not parse rule: " + n), !1);
  }
  /**
   * get all holidays for `year` with names using preferred `language`
   * @param {String|Date} [year] - if omitted, the current year is chosen
   * @param {String} [language] - ISO 639-1 code for language
   * @returns {Holiday[]} of found holidays in given year sorted by Date:
   * ```
   * {String} date - ISO Date String of (start)-date in local format
   * {Date} start - start date of holiday
   * {Date} end - end date of holiday
   * {String} name - name of holiday using `language` (if available)
   * {String} type - type of holiday `public|bank|school|observance`
   * ```
   */
  getHolidays(n, a) {
    n = fC(n);
    const t = this.getLanguages();
    a && t.unshift(a);
    const r = (q, y) => +q.start - +y.start, M = (q) => this.__types.indexOf(q.type), b = (q, y) => M(y) - M(q), d = (q) => /substitutes|and if /.test(q.rule) ? 1 : 0, c = (q) => String(q.rule || "").length, O = (q, y) => d(q) - d(y) || c(q) - c(y), A = {};
    return Object.keys(this.holidays).reduce((q, y) => (this.holidays[y].fn && this._dateByRule(n, y).forEach(($) => {
      q.push({ ...this._translate($, t), rule: y });
    }), q), []).sort((q, y) => r(q, y) || b(q, y) || O(q, y)).filter((q) => {
      const y = q.name + +q.start;
      return A[y] ? !1 : (A[y] = !0, !0);
    });
  }
  /**
   * check whether `date` is a holiday or not
   * @param {Date|String} [date]
   * @returns {Holiday[]|false} holiday:
   * ```
   * {String} date - ISO Date String of (start)-date in local format
   * {Date} start - start date of holiday
   * {Date} end - end date of holiday
   * {String} name - name of holiday using `language` (if available)
   * {String} type - type of holiday `public|bank|school|observance`
   * ```
   */
  isHoliday(n) {
    n = n ? new Date(n) : /* @__PURE__ */ new Date();
    const a = new d1();
    a.fromTimezone(n, this.__timezone);
    const t = a.year, r = Object.keys(this.holidays), M = [];
    for (const b of r) {
      const d = [].concat(this._dateByRule(t, b));
      for (const c of d)
        c && n >= c.start && n < c.end && M.push(this._translate(c));
    }
    return M.length ? M : !1;
  }
  /**
   * set or update rule
   * @param {HolidayRule|object} holidayRule
   * @returns {boolean} `true` if holiday could be set, returns `true`
   */
  setRule(n) {
    const { rule: a, ...t } = n;
    return this.setHoliday(a, t);
  }
  /**
   * unset rule
   * @param {String} rule - rule for holiday (check supported grammar) or date in ISO Format, e.g. 12-31 for 31st Dec
   * @returns {boolean} `true` if holiday could be set, returns `true`
   */
  unsetRule(n) {
    return this.setHoliday(n, !1);
  }
  /**
   * get available rules for selected country, (state, region)
   * @returns {HolidayRule[]}
   */
  getRules() {
    return Object.entries(this.holidays).map(([n, a]) => new rz({ ...a, rule: n }));
  }
  /**
   * get rule for selected country, (state, region)
   * @param {String} rule - rule for holiday (check supported grammar) or date in ISO Format, e.g. 12-31 for 31st Dec
   * @returns {HolidayRule|undefined}
   */
  getRule(n) {
    if (this.holidays[n])
      return new rz({ ...this.holidays[n], rule: n });
  }
  /**
   * Query for available Countries, States, Regions
   * @param {String} [country]
   * @param {String} [state]
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported countries, states, regions
   */
  query(n, a, t) {
    const r = S2.splitName(n, a);
    return !r || !r.country ? this.getCountries(t) : r.state ? this.getRegions(r.country, r.state, t) : this.getStates(r.country, t);
  }
  /**
   * get supported countries
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported countries
   * ```js
   * { AD: 'Andorra',
   *   US: 'United States' }
   * ```
   */
  getCountries(n) {
    return this.__data.getCountries(n);
  }
  /**
   * get supported states for a given country
   * @param {String} country - shortcode of country
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported states, regions
   * ```js
   * { al: 'Alabama', ...
   *   wy: 'Wyoming' }
   * ```
   */
  getStates(n, a) {
    return this.__data.getStates(n, a);
  }
  /**
   * get supported regions for a given country, state
   * @param {String} country - shortcode of country
   * @param {String} state - shortcode of state
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported regions
   * ```js
   * { no: 'New Orleans' }
   * ```
   */
  getRegions(n, a, t) {
    return this.__data.getRegions(n, a, t);
  }
  /**
   * sets timezone
   * @param {String} timezone - see `moment-timezone`
   * if `timezone` is `undefined`, then all dates are considered local dates
   */
  setTimezone(n) {
    this.__timezone = n;
  }
  /**
   * get timezones for country, state, region
   * @returns {Array} of {String}s containing the timezones
   */
  getTimezones() {
    if (this.__data)
      return this.__data.getTimezones();
  }
  /**
   * set language(s) for holiday names
   * @param {Array|String} language
   * @returns {Array} set languages
   */
  setLanguages(n) {
    typeof n == "string" && (n = [n]);
    const a = {};
    this.__languages = [].concat(
      n,
      this.__conf ? this.__data.getLanguages(this.__conf) : [],
      "en"
    ).filter(function(t) {
      return !t || a[t] ? !1 : (a[t] = 1, !0);
    });
  }
  /**
   * get languages for selected country, state, region
   * @returns {Array} containing ISO 639-1 language shortcodes
   */
  getLanguages() {
    return this.__languages;
  }
  /**
   * get default day off as weekday
   * @returns {String} weekday of day off
   */
  getDayOff() {
    if (this.__conf)
      return this.__data.getDayOff();
  }
  /**
   * @private
   * @param {Number} year
   * @param {String} rule
   */
  _dateByRule(n, a) {
    const t = this.holidays[a];
    return t.fn.inYear(n).get(this.__timezone).map((M) => {
      const b = w1.merge(
        {},
        w1.omit(M, ["substitute"]),
        w1.omit(t, ["fn", "enable", "disable", "substitute", "active"])
      );
      return t.substitute && M.substitute && (b.substitute = !0), b;
    });
  }
  /**
   * translate holiday object `o` to a language
   * @private
   * @param {Object} o
   * @param {Array} langs - languages for translation
   * @returns {Object} translated holiday object
   */
  _translate(n, a) {
    if (n && typeof n.name == "object") {
      a = a || this.getLanguages();
      for (const t of a) {
        const r = n.name[t];
        if (r) {
          n.name = r;
          break;
        }
      }
      if (n.substitute)
        for (const t of a) {
          const M = this.__data.getSubstitueNames()[t];
          if (M) {
            n.name += " (" + M + ")";
            break;
          }
        }
    }
    return n;
  }
};
function MP(e, n, a, t) {
  return typeof a == "object" ? (t = a, a = null) : typeof n == "object" ? (t = n, n = null) : typeof e == "object" && !e.country && (t = e), t = t || {}, [e, n, a, t];
}
const bP = {
  version: "2024-05-04",
  license: "CC-BY-SA-3",
  holidays: {
    AD: {
      names: {
        ca: "Andorra",
        es: "Andorra",
        en: "Andorra"
      },
      dayoff: "sunday",
      langs: [
        "ca",
        "es"
      ],
      zones: [
        "Europe/Andorra"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        "03-14": {
          _name: "Constitution Day"
        },
        "05-01": {
          _name: "05-01"
        },
        "08-15": {
          _name: "08-15"
        },
        "09-08": {
          name: {
            en: "Our Lady of Meritxell",
            es: "Nuestra Sra. De Meritxell",
            ca: "Mare de Déu de Meritxell"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "12-08": {
          _name: "12-08"
        },
        "12-24": {
          type: "bank",
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "easter -47": {
          _name: "easter -47"
        },
        "easter -3 14:00": {
          type: "bank",
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        }
      },
      regions: {
        "07": {
          name: "Andorra la Vella",
          days: {
            "1st saturday in August P3D": {
              name: {
                en: "Andorra La Vella Festival",
                ca: "Andorra La Vella Festival"
              }
            }
          }
        }
      }
    },
    AE: {
      names: {
        en: "United Arab Emirates",
        ar: "دولة الإمارات العربية المتحدة"
      },
      langs: [
        "ar"
      ],
      zones: [
        "Asia/Dubai"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01",
          name: {
            ar: "رأس السنة الميلادية"
          }
        },
        "12-02": {
          name: {
            en: "National Day",
            ar: "اليوم الوطني"
          }
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "1 Shawwal P3D": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah P3D": {
          _name: "10 Dhu al-Hijjah"
        },
        "27 Rajab": {
          _name: "27 Rajab"
        },
        "1 Ramadan": {
          _name: "1 Ramadan"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        }
      }
    },
    AG: {
      names: {
        en: "Antigua & Barbuda"
      },
      langs: [
        "en"
      ],
      dayoff: "sunday",
      weekend: [
        "saturday",
        "sunday"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      days: {
        "01-01 and if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "08-01": {
          name: {
            en: "J'Ouvert Morning"
          }
        },
        "08-02": {
          name: {
            en: "Last Lap"
          }
        },
        "11-01 if saturday,sunday then next monday": {
          _name: "Independence Day"
        },
        "12-09": {
          name: {
            en: "V.C Bird Day"
          }
        },
        "12-25 and if saturday then next monday if sunday then next tuesday": {
          _name: "12-25",
          substitute: !0
        },
        "12-26 and if sunday then next monday": {
          _name: "12-26",
          substitute: !0
        }
      },
      regions: {
        10: {
          name: "Barbuda",
          days: {
            "easter 47 P4D": {
              name: {
                en: "Caribana"
              },
              type: "observance"
            }
          }
        }
      }
    },
    AI: {
      names: {
        en: "Anguilla"
      },
      langs: [
        "en"
      ],
      dayoff: "sunday",
      weekend: [
        "saturday",
        "sunday"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-02": {
          name: {
            en: "James Ronald Webster Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-30": {
          name: {
            en: "Anguilla Day"
          }
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "2nd monday in June": {
          name: {
            en: "Celebration of the Birthday of Her Majesty the Queen"
          }
        },
        "1st monday in August": {
          name: {
            en: "August Monday"
          }
        },
        "1st thursday in August": {
          name: {
            en: "August Thursday"
          }
        },
        "1st friday in August": {
          _name: "Constitution Day"
        },
        "12-19": {
          name: {
            en: "National Heroes and Heroines Day"
          }
        },
        "12-25 and if saturday then next monday if sunday then next tuesday": {
          _name: "12-25",
          substitute: !0
        },
        "12-26 and if sunday then next monday": {
          _name: "12-26",
          substitute: !0
        }
      }
    },
    AL: {
      names: {
        sq: "Shqipëri",
        en: "Albania"
      },
      dayoff: "sunday",
      langs: [
        "sq",
        "es"
      ],
      zones: [
        "Europe/Tirane"
      ],
      days: {
        "01-01 and if sunday then next tuesday": {
          _name: "01-01",
          substitute: !0
        },
        "01-02 and if sunday then next monday": {
          name: {
            sq: "Festa e Vitit të Ri",
            en: "New Year Holiday"
          },
          substitute: !0
        },
        "03-02": {
          name: {
            sq: "Dita e Besëlidhjes së Lezhës",
            en: "League of Lezhë day"
          },
          type: "observance"
        },
        "03-07": {
          name: {
            sq: "Dita e Mësuesit",
            en: "Teacher's Day"
          },
          type: "observance"
        },
        "03-08": {
          _name: "Mothers Day",
          type: "observance"
        },
        "03-14 and if sunday then next monday": {
          name: {
            sq: "Dita e Verës",
            en: "Summer Day"
          },
          substitute: !0
        },
        "03-22 and if sunday then next monday": {
          name: {
            sq: "Dita e Sulltan Nevruzit",
            en: "Sultan Nevruz's Day"
          },
          substitute: !0
        },
        "04-01": {
          _name: "04-01",
          type: "observance"
        },
        easter: {
          name: {
            sq: "Pashkët Katolike",
            en: "Catholic Easter"
          }
        },
        "easter 1": {
          name: {
            sq: "Pashkët Katolike",
            en: "Catholic Easter"
          }
        },
        orthodox: {
          name: {
            sq: "Pashkët Ortodokse",
            en: "Orthodox Easter"
          }
        },
        "orthodox 1": {
          name: {
            sq: "Pashkët Ortodokse",
            en: "Orthodox Easter"
          }
        },
        "05-01 and if sunday then next monday": {
          _name: "05-01",
          substitute: !0
        },
        "06-01": {
          name: {
            sq: "Dita Ndërkombëtare e Fëmijëve",
            en: "Children's Day"
          },
          type: "observance"
        },
        "10-19 and if sunday then next monday": {
          name: {
            sq: "Dita e Nënë Terezës",
            en: "Mother Teresa Day"
          },
          substitute: !0,
          active: [
            {
              from: 2004
            }
          ]
        },
        "11-22": {
          name: {
            sq: "Dita e Alfabetit",
            en: "Alphabet Day"
          },
          type: "observance"
        },
        "11-28 and if sunday then next monday": {
          _name: "Independence Day",
          substitute: !0
        },
        "11-29 and if sunday then next monday": {
          _name: "Liberation Day",
          substitute: !0
        },
        "12-08 and if sunday then next monday": {
          name: {
            sq: "Dita Kombëtare e Rinisë",
            en: "Youth Day"
          },
          substitute: !0,
          active: [
            {
              from: 2010
            }
          ]
        },
        "12-24": {
          _name: "12-24",
          type: "bank"
        },
        "12-25 and if sunday then next monday": {
          _name: "12-25",
          substitute: !0
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      },
      regions: {}
    },
    AM: {
      names: {
        hy: "Հայաստան",
        en: "Armenia"
      },
      dayoff: "sunday",
      langs: [
        "hy"
      ],
      zones: [
        "Asia/Yerevan"
      ],
      days: {
        "12-31": {
          _name: "12-31"
        },
        "01-01 P2D": {
          _name: "01-01"
        },
        "01-03 P3D": {
          name: {
            en: "Pre-Christmas holidays",
            hy: "Նախածննդյան տոներ"
          }
        },
        "01-06": {
          _name: "12-25"
        },
        "01-28": {
          name: {
            en: "Army Day",
            hy: "Բանակի օր"
          }
        },
        "02-21": {
          name: {
            en: "Mother Language Day",
            hy: "Մայրենի լեզվի օր"
          },
          type: "observance"
        },
        "easter -52": {
          name: {
            en: "St. Vartan the good work and the duty days",
            hy: "Սուրբ Վարդանանց տոն՝ բարի գործի եւ ազգային տուրքի օր"
          },
          type: "observance"
        },
        "03-08": {
          _name: "03-08"
        },
        "04-07": {
          name: {
            en: "Motherhood and Beauty Day",
            hy: "Մայրության, գեղեցկության եւ սիրո տոն"
          },
          type: "observance"
        },
        "04-24": {
          _name: "Mothers Day"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-08": {
          name: {
            en: "Yerkrapah Day",
            hy: "Երկրապահի օր"
          },
          type: "observance"
        },
        "05-09": {
          name: {
            en: "Victory and Peace Day",
            hy: "Հաղթանակի եւ Խաղաղության տոն"
          }
        },
        "05-28": {
          name: {
            en: "Republic Day",
            hy: "Հանրապետության օր"
          }
        },
        "06-01": {
          name: {
            en: "The day of protection of children rights",
            hy: "Երեխաների իրավունքների պաշտպանության օր"
          },
          type: "observance"
        },
        "07-05": {
          _name: "Constitution Day"
        },
        "09-01": {
          name: {
            en: "Knowledge, Literacy and Education Day",
            hy: "Գիտելիքի, գրի եւ դպրության օր"
          },
          type: "observance"
        },
        "09-21": {
          _name: "Independence Day"
        },
        "2nd saturday in October": {
          name: {
            en: "Translator's Day",
            hy: "Թարգմանչաց տոն"
          },
          type: "observance"
        },
        "12-07": {
          name: {
            en: "Earthquake Remembrance Day",
            hy: "Երկրաշարժի զոհերի հիշատակի օր"
          },
          type: "observance"
        }
      }
    },
    AO: {
      names: {
        pt: "Angola",
        en: "Angola"
      },
      dayoff: "sunday",
      zones: [
        "Africa/Lagos"
      ],
      langs: [
        "pt"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-04": {
          name: {
            pt: "Dia do Início da Luta Armada de Libertação Nacional",
            en: "Liberation Day"
          }
        },
        "easter -47": {
          _name: "easter -47"
        },
        "03-08": {
          name: {
            pt: "Dia Internacional da Mulher",
            en: "International Woman's Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "04-04": {
          name: {
            pt: "Dia da Paz",
            en: "Peace Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "1st sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "09-17": {
          name: {
            pt: "Fundador da Nação e Dia dos Heróis Nacionais",
            en: "National Hero Day"
          }
        },
        "11-02": {
          _name: "11-02"
        },
        "11-11": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    AR: {
      names: {
        es: "Argentina",
        en: "Argentina"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Argentina/Buenos_Aires",
        "America/Argentina/Cordoba",
        "America/Argentina/Salta",
        "America/Argentina/Jujuy",
        "America/Argentina/Tucuman",
        "America/Argentina/Catamarca",
        "America/Argentina/La_Rioja",
        "America/Argentina/San_Juan",
        "America/Argentina/Mendoza",
        "America/Argentina/San_Luis",
        "America/Argentina/Rio_Gallegos",
        "America/Argentina/Ushuaia"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if tuesday then previous monday if thursday then next friday": {
          _name: "Bridge Day",
          disable: [
            2015
          ]
        },
        "easter -48": {
          _name: "easter -48"
        },
        "easter -47": {
          _name: "easter -47"
        },
        "03-24": {
          name: {
            en: "Day of Remembrance for Truth and Justice",
            es: "Día de la Memoria por la Verdad y la Justicia"
          }
        },
        "substitutes 03-24 if tuesday then previous monday if thursday then next friday": {
          _name: "Bridge Day"
        },
        "2020-03-30": {
          _name: "Bridge Day"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "04-02": {
          name: {
            en: "Day of the veterans and the fallen in Malvinas War",
            es: "Día del Veterano y de los Caídos en la Guerra de Malvinas"
          }
        },
        "substitutes 04-02 if tuesday then previous monday if thursday then next friday": {
          _name: "Bridge Day"
        },
        "05-01": {
          _name: "05-01"
        },
        "substitutes 05-01 if tuesday then previous monday if thursday then next friday": {
          _name: "Bridge Day"
        },
        "05-25": {
          name: {
            en: "Day of the First National Government",
            es: "Primer Gobierno Patrio"
          }
        },
        "substitutes 05-25 if tuesday then previous monday if thursday then next friday": {
          _name: "Bridge Day"
        },
        "06-20": {
          name: {
            en: "National Flag Day",
            es: "Día de la Bandera"
          }
        },
        "substitutes 06-20 if tuesday then previous monday if thursday then next friday": {
          _name: "Bridge Day"
        },
        "07-09": {
          _name: "Independence Day"
        },
        "substitutes 07-09 if tuesday then previous monday if thursday then next friday if saturday then previous friday": {
          _name: "Bridge Day",
          disable: [
            2015,
            2022
          ]
        },
        "3rd monday in August": {
          name: {
            en: "Anniversary of the death of General José de San Martín",
            es: "Día del Libertador José de San Martín"
          }
        },
        "10-12 if tuesday,wednesday then previous monday if thursday,friday,saturday,sunday then next monday": {
          name: {
            en: "Day of Respect for Cultural Diversity",
            es: "Día del Respeto a la Diversidad Cultural"
          }
        },
        "substitutes 10-12 if monday,tuesday,wednesday then previous friday": {
          _name: "Bridge Day",
          disable: [
            2015,
            2016,
            2020
          ]
        },
        "11-20 if tuesday,wednesday then previous monday if friday then next monday": {
          name: {
            en: "Day of National Sovereignty",
            es: "Día de la Soberanía nacional"
          }
        },
        "substitutes 11-20 if saturday,sunday then next monday": {
          _name: "Bridge Day",
          disable: [
            2016
          ]
        },
        "12-08": {
          _name: "12-08"
        },
        "substitutes 12-08 if tuesday then previous monday if thursday then next friday": {
          _name: "Bridge Day"
        },
        "12-24 12:00": {
          _name: "12-24",
          type: "optional"
        },
        "substitutes 12-24 if tuesday then previous monday": {
          _name: "Bridge Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "substitutes 12-25 if tuesday then previous monday if thursday then next friday": {
          _name: "Bridge Day"
        },
        "12-31 12:00": {
          _name: "12-31",
          type: "optional"
        }
      }
    },
    AS: {
      names: {
        en: "American Samoa"
      },
      dayoff: "sunday",
      zones: [
        "Pacific/Pago_Pago"
      ],
      langs: [
        "en"
      ],
      _days: [
        "US"
      ],
      days: {
        "3rd monday in February": {
          name: {
            en: "Washington's Birthday"
          }
        },
        "03-17": !1,
        "04-15 if friday then next monday if saturday,sunday then next tuesday": !1,
        "04-17 and if sunday then next monday": {
          name: {
            en: "American Samoa Flag Day"
          },
          substitute: !0
        },
        "07-16": {
          name: {
            en: "Manu'a Cession Day"
          },
          type: "optional",
          note: "Goverment offices closed"
        },
        "2nd sunday in October": {
          name: {
            en: "White Sunday"
          },
          type: "observance",
          note: "christian"
        },
        "12-24 12:00": {
          _name: "12-24",
          type: "bank"
        },
        "12-31 12:00": {
          _name: "12-31",
          type: "bank"
        }
      }
    },
    AT: {
      names: {
        "de-at": "Österreich",
        en: "Austria"
      },
      dayoff: "sunday",
      zones: [
        "Europe/Vienna"
      ],
      langs: [
        "de-at",
        "de"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        "easter -2 prior to 2019": {
          _name: "easter -2",
          type: "optional"
        },
        "easter -1": {
          _name: "easter -1",
          type: "observance"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          name: {
            "de-at": "Staatsfeiertag"
          }
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "08-15": {
          _name: "08-15"
        },
        "10-26": {
          _name: "National Holiday"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-08": {
          _name: "12-08"
        },
        "12-24 14:00 if sunday then 00:00": {
          _name: "12-24",
          type: "bank"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31 14:00 if sunday then 00:00": {
          _name: "12-31",
          type: "bank"
        }
      },
      states: {
        1: {
          name: "Burgenland",
          days: {
            "11-11": {
              name: {
                "de-at": "Martinstag"
              }
            }
          }
        },
        2: {
          names: {
            de: "Kärnten",
            en: "Carinthia"
          },
          days: {
            "03-19": {
              _name: "03-19",
              type: "school"
            },
            "10-10": {
              name: {
                "de-at": "Tag der Volksabstimmung"
              }
            }
          }
        },
        3: {
          names: {
            de: "Niederösterreich",
            en: "Lower Austria"
          },
          days: {
            "11-15": {
              name: {
                "de-at": "Leopoldi-Tag"
              },
              type: "optional",
              note: "In Niederösterreich haben nur Schüler und Beamten frei"
            }
          }
        },
        4: {
          names: {
            de: "Oberösterreich",
            en: "Upper Austria"
          },
          days: {
            "05-04": {
              name: {
                "de-at": "Florian"
              }
            }
          }
        },
        5: {
          names: {
            de: "Land Salzburg",
            en: "Salzburg"
          },
          days: {
            "09-24": {
              name: {
                "de-at": "Rupert"
              }
            }
          }
        },
        6: {
          names: {
            de: "Steiermark",
            en: "Styria"
          },
          days: {
            "03-19": {
              _name: "03-19",
              type: "school"
            }
          }
        },
        7: {
          names: {
            de: "Tirol",
            en: "Tyrol"
          },
          days: {
            "03-19": {
              _name: "03-19",
              type: "school"
            }
          }
        },
        8: {
          name: "Vorarlberg",
          days: {
            "03-19": {
              _name: "03-19",
              type: "school"
            }
          }
        },
        9: {
          names: {
            de: "Wien",
            en: "Vienna"
          },
          days: {
            "11-15": {
              name: {
                "de-at": "Leopoldi-Tag"
              },
              type: "optional",
              note: "In Wien haben nur Schüler frei"
            }
          }
        }
      }
    },
    AU: {
      names: {
        en: "Australia"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "Australia/Sydney",
        "Australia/Lord_Howe",
        "Antarctica/Macquarie",
        "Australia/Hobart",
        "Australia/Currie",
        "Australia/Melbourne",
        "Australia/Broken_Hill",
        "Australia/Brisbane",
        "Australia/Lindeman",
        "Australia/Adelaide",
        "Australia/Darwin",
        "Australia/Perth",
        "Australia/Eucla"
      ],
      days: {
        "01-01 and if saturday,sunday then next monday": {
          _name: "01-01"
        },
        "01-26 if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            en: "Australia Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-25": {
          name: {
            en: "Anzac Day"
          }
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "1st sunday in September": {
          _name: "Fathers Day",
          type: "observance"
        },
        "12-25 and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "12-26"
        },
        "2022-09-22": {
          name: {
            en: "National Day of Mourning for Queen Elizabeth II"
          }
        }
      },
      states: {
        ACT: {
          name: "Australian Capital Territory",
          zones: [
            "Australia/Sydney"
          ],
          days: {
            "2nd monday in March": {
              name: {
                en: "Canberra Day"
              }
            },
            "04-25": !1,
            "04-25 if sunday then next monday": {
              substitute: !0,
              name: {
                en: "Anzac Day"
              }
            },
            "2020-04-27": {
              name: {
                en: "Declared public holiday"
              },
              type: "public"
            },
            "monday after 05-27": {
              name: {
                en: "Reconciliation Day"
              }
            },
            "2nd monday in June": {
              name: {
                en: "Queen's Birthday"
              },
              active: [
                {
                  to: "2022-09-08"
                }
              ]
            },
            "2nd monday in June #1": {
              name: {
                en: "King's Birthday"
              },
              active: [
                {
                  from: "2022-09-09"
                }
              ]
            },
            "1st monday in October": {
              name: {
                en: "Labour Day"
              }
            }
          }
        },
        NSW: {
          name: "New South Wales",
          zones: [
            "Australia/Sydney"
          ],
          days: {
            "2nd monday in June": {
              name: {
                en: "Queen's Birthday"
              },
              active: [
                {
                  to: "2022-09-08"
                }
              ]
            },
            "2nd monday in June #1": {
              name: {
                en: "King's Birthday"
              },
              active: [
                {
                  from: "2022-09-09"
                }
              ]
            },
            "1st monday in August": {
              name: {
                en: "Bank Holiday"
              },
              type: "bank"
            },
            "1st monday in October": {
              name: {
                en: "Labour Day"
              }
            }
          }
        },
        NT: {
          name: "Northern Territory",
          zones: [
            "Australia/Darwin"
          ],
          days: {
            easter: !1,
            "04-25": !1,
            "04-25 if sunday then next monday": {
              substitute: !0,
              name: {
                en: "Anzac Day"
              }
            },
            "1st monday in May": {
              name: {
                en: "May Day"
              }
            },
            "2nd monday in June": {
              name: {
                en: "Queen's Birthday"
              },
              active: [
                {
                  to: "2022-09-08"
                }
              ]
            },
            "2nd monday in June #1": {
              name: {
                en: "King's Birthday"
              },
              active: [
                {
                  from: "2022-09-09"
                }
              ]
            },
            "1st monday in August": {
              name: {
                en: "Picnic Day"
              }
            },
            "1st monday in October": !1,
            "12-24 19:00": {
              _name: "12-24"
            },
            "12-25 and if saturday then next monday if sunday then next tuesday": !1,
            "12-25 if saturday then next monday if sunday then next tuesday": {
              substitute: !0,
              _name: "12-25"
            },
            "12-26 and if saturday then next monday if sunday then next tuesday": !1,
            "12-26 if saturday then next monday if sunday then next tuesday": {
              substitute: !0,
              _name: "12-26"
            },
            "12-31 19:00": {
              _name: "12-31"
            }
          }
        },
        QLD: {
          name: "Queensland",
          zones: [
            "Australia/Brisbane",
            "Australia/Lindeman"
          ],
          days: {
            "04-25": !1,
            "04-25 if sunday then next monday": {
              substitute: !0,
              name: {
                en: "Anzac Day"
              }
            },
            "1st monday in May": {
              name: {
                en: "Labour Day"
              }
            },
            "2nd monday in June": !1,
            "1st monday in October": {
              name: {
                en: "Queen's Birthday"
              },
              active: [
                {
                  to: "2022-09-08"
                }
              ]
            },
            "1st monday in October #1": {
              name: "King's Birthday",
              active: [
                {
                  from: "2022-09-09"
                }
              ]
            },
            "12-24 18:00": {
              _name: "12-24"
            }
          }
        },
        SA: {
          name: "South Australia",
          zones: [
            "Australia/Adelaide"
          ],
          days: {
            easter: !1,
            "2nd monday in March": {
              name: {
                en: "Adelaide Cup Day"
              }
            },
            "2nd monday in June": {
              name: {
                en: "Queen's Birthday"
              },
              active: [
                {
                  to: "2022-09-08"
                }
              ]
            },
            "2nd monday in June #1": {
              name: {
                en: "King's Birthday"
              },
              active: [
                {
                  from: "2022-09-09"
                }
              ]
            },
            "1st monday in October": {
              name: {
                en: "Labour Day"
              }
            },
            "12-24 19:00": {
              _name: "12-24"
            },
            "12-25 and if saturday then next monday if sunday then next tuesday": !1,
            "12-25 if saturday then next monday if sunday then next tuesday": {
              substitute: !0,
              _name: "12-25"
            },
            "12-26 and if saturday then next monday if sunday then next tuesday": !1,
            "12-26 if saturday then next monday if sunday then next tuesday": {
              substitute: !0,
              name: "Proclamation Day"
            },
            "12-31 19:00": {
              _name: "12-31"
            }
          }
        },
        TAS: {
          name: "Tasmania",
          zones: [
            "Australia/Hobart"
          ],
          days: {
            "01-01 and if saturday,sunday then next monday": !1,
            "01-01 if saturday then next monday if sunday then next tuesday": {
              substitute: !0,
              _name: "01-01"
            },
            "2nd monday in March": {
              name: {
                en: "Eight Hours Day"
              }
            },
            "easter -1": !1,
            easter: !1,
            "easter +2": {
              name: "Easter Tuesday",
              type: "optional",
              note: "Public Service employees or contract dependent"
            },
            "2nd monday in June": {
              name: {
                en: "Queen's Birthday"
              },
              active: [
                {
                  to: "2022-09-08"
                }
              ]
            },
            "2nd monday in June #1": {
              name: {
                en: "King's Birthday"
              },
              active: [
                {
                  from: "2022-09-09"
                }
              ]
            },
            "1st monday in October": !1,
            "12-26 and if saturday then next monday if sunday then next tuesday": !1,
            "12-26 if saturday then next monday if sunday then next tuesday": {
              substitute: !0,
              _name: "12-26"
            }
          }
        },
        VIC: {
          name: "Victoria",
          zones: [
            "Australia/Melbourne"
          ],
          days: {
            "2nd monday in March": {
              name: {
                en: "Labour Day"
              }
            },
            "2nd monday in June": {
              name: {
                en: "Queen's Birthday"
              },
              active: [
                {
                  to: "2022-09-08"
                }
              ]
            },
            "2nd monday in June #1": {
              name: {
                en: "King's Birthday"
              },
              active: [
                {
                  from: "2022-09-09"
                }
              ]
            },
            "1st monday in October": !1,
            "1st friday before October": {
              name: {
                en: "AFL Grand Final Friday"
              },
              note: "Date might differ as dependent on AFL schedule"
            },
            "1st tuesday in November": {
              name: {
                en: "Melbourne Cup"
              }
            }
          }
        },
        WA: {
          name: "Western Australia",
          zones: [
            "Australia/Perth",
            "Australia/Eucla"
          ],
          days: {
            "1st monday in March": {
              name: {
                en: "Labour Day"
              }
            },
            "easter -1": !1,
            easter: !1,
            "04-25": !1,
            "04-25 and if saturday,sunday then next monday": {
              substitute: !0,
              name: {
                en: "Anzac Day"
              }
            },
            "1st monday in June": {
              name: {
                en: "Western Australia Day"
              }
            },
            "2nd monday in June": !1,
            "monday before October": {
              name: {
                en: "Queen's Birthday"
              },
              note: "Might be on a different day; is proclaimed by Governor",
              active: [
                {
                  to: "2022-09-08"
                }
              ]
            },
            "monday before October #1": {
              name: {
                en: "King's Birthday"
              },
              note: "Might be on a different day; is proclaimed by Governor",
              active: [
                {
                  from: "2022-09-09"
                }
              ]
            },
            "1st monday in October": !1
          }
        }
      }
    },
    AW: {
      names: {
        pap: "Aruba",
        nl: "Aruba",
        en: "Aruba"
      },
      dayoff: "sunday",
      zones: [
        "America/Curacao"
      ],
      langs: [
        "pap",
        "nl"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-25": {
          name: {
            pap: "Dia di Betico",
            nl: "Herdenking G. F. Croes",
            en: "Betico Croes Day"
          }
        },
        "easter -48": {
          _name: "easter -48"
        },
        "03-18 and if saturday then previous friday if sunday then next monday": {
          substitute: !0,
          name: {
            pap: "Dia di Himno y Bandera",
            nl: "Herdenking Vlag en Volkslied",
            en: "National Anthem and Flag Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-27": {
          name: {
            pap: "Aña di Rey",
            nl: "Koningsdag",
            en: "Kings Day"
          }
        },
        "05-01 if sunday then next monday": {
          _name: "05-01"
        },
        "06-24": {
          name: {
            pap: "Dera Gai",
            nl: "Dera Gai",
            en: "Dera Gai"
          },
          type: "observance"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "12-05": {
          name: {
            nl: "Sinterklaasavond",
            en: "St. Nicholas' Eve"
          },
          type: "observance"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    AX: {
      names: {
        sv: "Landskapet Åland",
        en: "Åland Islands"
      },
      dayoff: "sunday",
      zones: [
        "Europe/Helsinki"
      ],
      langs: [
        "sv"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        "03-30": {
          name: {
            sv: "Ålands demilitariseringsdag",
            en: "Demilitarization Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "06-09": {
          name: {
            sv: "Självstyrelsedagen",
            en: "Autonomy Day"
          }
        },
        "friday after 06-19": {
          name: {
            sv: "Midsommarafton",
            en: "Midsummer Eve"
          },
          type: "bank"
        },
        "saturday after 06-20": {
          name: {
            sv: "Midsommardagen",
            en: "Midsummer Day"
          }
        },
        "12-06": {
          _name: "Independence Day"
        },
        "12-24 12:00": {
          _name: "12-24",
          type: "bank"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31 12:00": {
          _name: "12-31",
          type: "bank"
        }
      }
    },
    AZ: {
      names: {
        az: "Azərbaycan Respublikası",
        en: "Azerbaijan"
      },
      dayoff: "sunday",
      weekend: [
        "saturday",
        "sunday"
      ],
      zones: [
        "Asia/Baku"
      ],
      langs: [
        "az"
      ],
      days: {
        "01-01 and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-02 and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-20": {
          name: {
            az: "Qara Yanvar",
            en: "Martyrs' Day"
          },
          type: "observance"
        },
        "03-08 and if saturday,sunday then next monday": {
          substitute: !0,
          _name: "03-08"
        },
        "03-20": {
          name: {
            az: "Novruz",
            en: "Spring Festival"
          },
          active: [
            {
              from: 2011
            }
          ]
        },
        "05-09 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            az: "Faşizm üzərində qələbə günü",
            en: "Day of Victory over Fascism"
          }
        },
        "05-28 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            az: "Respublika günü",
            en: "Republic Day"
          }
        },
        "06-15 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            az: "Azərbaycan xalqının Milli Qurtuluş günü",
            en: "National Salvation Day"
          }
        },
        "06-26 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            az: "Azərbaycan Respublikasının Silahlı Qüvvələri günü",
            en: "Azerbaijan Armed Forces Day"
          }
        },
        "10-18 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            az: "Dövlət Müstəqilliyi günü",
            en: "Independence Day"
          }
        },
        "11-09 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            az: "Dövlət Bayrağı günü",
            en: "Flag Day"
          }
        },
        "11-12": {
          name: {
            az: "Konstitusiya günü",
            en: "Constitution Day"
          }
        },
        "11-17": {
          name: {
            az: "Milli Dirçəliş günü",
            en: "National Revival Day"
          }
        },
        "12-31 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            az: "Dünya azərbaycanlıların həmrəyliyi günü",
            en: "International Solidarity Day of Azerbaijanis"
          }
        },
        "1 Shawwal and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "1 Shawwal"
        },
        "2 Shawwal and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "10 Dhu al-Hijjah"
        },
        "11 Dhu al-Hijjah and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    BA: {
      names: {
        bs: "Bosna i Hercegovina",
        sr: "Боснa и Херцеговина",
        hr: "Bosna i Hercegovina",
        en: "Bosnia and Herzegovina"
      },
      langs: [
        "bs",
        "sr",
        "hr"
      ],
      zones: [
        "Europe/Belgrade"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if sunday then next tuesday": {
          _name: "01-01",
          substitute: !0
        },
        "01-02 and if sunday then next monday": {
          name: {
            en: "2nd day of the New Year",
            bs: "Drugi dan Nove Godine"
          },
          substitute: !0
        },
        "05-01 and if sunday then next tuesday": {
          _name: "05-01",
          substitute: !0
        },
        "05-02 and if sunday then next monday": {
          name: {
            en: "2nd day of the Labour Day",
            bs: "Drugi dan Dana rada"
          },
          substitute: !0
        },
        "01-06": {
          _name: "01-06"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "11-02": {
          _name: "11-02"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "julian 01-01": {
          _name: "julian 01-01"
        },
        orthodox: {
          _name: "orthodox"
        },
        "julian 08-15": {
          _name: "08-15",
          note: "orthodox"
        },
        "julian 12-25": {
          _name: "julian 12-25"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "10 Dhu al-Hijjah P4D": {
          _name: "10 Dhu al-Hijjah"
        },
        "1 Shawwal P3D": {
          _name: "1 Shawwal"
        }
      },
      states: {
        BIH: {
          name: "Federation of Bosnia and Herzegovina",
          days: {
            "03-01": {
              _name: "Independence Day"
            },
            "11-25": {
              name: {
                en: "Statehood Day",
                bs: "Dan državnosti"
              }
            }
          },
          regions: {
            W: {
              name: "Western Herzegovina",
              days: {
                "11-25": !1
              }
            }
          }
        },
        BRC: {
          name: "Brčko District",
          days: {
            "03-08": {
              name: {
                en: "Day of the Establishment of the District"
              }
            }
          }
        },
        SRP: {
          name: "Republika Srpska",
          days: {
            "01-09": {
              name: {
                en: "Republic Day",
                bs: "Dan Republike"
              }
            },
            "05-09": {
              name: {
                en: "Victory Day",
                bs: "Dan pobjede"
              }
            },
            "11-21": {
              name: {
                en: "Dayton Agreement Day",
                bs: "Dan uspostave Opšteg okvirnog sporazuma za mir u Bosni i Hercegovini"
              }
            }
          }
        }
      }
    },
    BB: {
      names: {
        en: "Barbados"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "America/Barbados"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-21": {
          name: {
            en: "Errol Barrow Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-28": {
          name: {
            en: "National Heroes Day"
          }
        },
        "05-01 if sunday then next monday": {
          name: {
            en: "May Day"
          }
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "08-01": {
          name: {
            en: "Emancipation Day"
          }
        },
        "1st monday in August": {
          name: {
            en: "Kadooment Day"
          }
        },
        "11-30": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "substitutes 12-25 if sunday then next tuesday": {
          _name: "Public Holiday"
        },
        "12-26": {
          _name: "12-26"
        },
        "substitutes 12-26 if sunday then next monday": {
          _name: "Public Holiday"
        }
      }
    },
    BD: {
      names: {
        bn: "গণপ্রজাতন্ত্রী বাংলাদেশ",
        en: "People's Republic of Bangladesh"
      },
      langs: [
        "bn"
      ],
      zones: [
        "Asia/Dhaka"
      ],
      dayoff: "friday",
      weekend: [
        "friday",
        "saturday"
      ],
      days: {
        "bengali-revised 11-9": {
          name: {
            bn: "শহীদ দিবস",
            en: "Language Martyrs' Day"
          }
        },
        "bengali-revised 12-3": {
          name: {
            bn: "মুজিব জয়ন",
            en: "Mujib's Birthday & Children's Day"
          }
        },
        "bengali-revised 12-12": {
          name: {
            bn: "স্বাধীনতা দিবস",
            en: "Independence Day"
          }
        },
        "bengali-revised 1-1": {
          name: {
            bn: "পহেলা বৈশাখ",
            en: "Bengali New Year's Day"
          }
        },
        "bengali-revised 1-18": {
          _name: "05-01",
          name: {
            bn: "মে দিবস",
            en: "May Day"
          }
        },
        "bengali-revised 4-31": {
          name: {
            bn: "জাতীয় শোক দিবস",
            en: "National Mourning Day"
          }
        },
        "bengali-revised 9-2": {
          name: {
            bn: "বিজয় দিবস",
            en: "Victory Day"
          }
        },
        "10 Muharram": {
          _name: "10 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal P3D": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah P3D": {
          _name: "10 Dhu al-Hijjah"
        },
        "05-19": {
          name: {
            bn: "বুদ্ধ পূর্ণিমা",
            en: "Buddha's Birthday"
          },
          enable: [
            "2016-05-21",
            "2017-05-10",
            "2018-04-29",
            "2019-05-19",
            "2020-05-07"
          ],
          disable: [
            "2016-05-19",
            "2017-05-19",
            "2018-05-19",
            "2019-05-19",
            "2020-05-19"
          ]
        },
        "08-24": {
          name: {
            bn: "জন্মাষ্টমী",
            en: "Krishna Janmashtami"
          },
          enable: [
            "2016-08-25",
            "2017-08-14",
            "2018-09-02",
            "2019-08-24",
            "2020-08-11"
          ],
          disable: [
            "2016-08-24",
            "2017-08-24",
            "2018-08-24",
            "2019-08-24",
            "2020-08-24"
          ]
        },
        "10-08": {
          name: {
            bn: "দুর্গা পূজা",
            en: "Durga Puja"
          },
          enable: [
            "2016-10-11",
            "2017-09-30",
            "2018-10-19",
            "2019-10-08",
            "2020-10-25"
          ],
          disable: [
            "2016-10-08",
            "2017-10-08",
            "2018-10-08",
            "2019-10-08",
            "2020-10-08"
          ]
        },
        "bengali-revised 9-11": {
          _name: "12-25"
        },
        "03-25": {
          name: {
            en: "Genocide Remembrance Day"
          },
          type: "observance"
        },
        "11-21": {
          name: {
            en: "Armed Forces Day"
          },
          type: "observance"
        },
        "12-14": {
          name: {
            en: "Martyred Intellectuals Day"
          },
          type: "observance"
        }
      }
    },
    BE: {
      names: {
        fr: "Belgique",
        nl: "België",
        de: "Belgien",
        en: "Belgium"
      },
      dayoff: "sunday",
      zones: [
        "Europe/Brussels"
      ],
      langs: [
        "fr",
        "nl",
        "de"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06",
          name: {
            de: "Erscheinung des Herrn"
          },
          type: "observance"
        },
        "02-14": {
          _name: "02-14",
          type: "observance"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "07-21": {
          _name: "National Holiday"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "11-02": {
          _name: "11-02",
          type: "observance"
        },
        "11-11": {
          name: {
            de: "Waffenstillstand",
            fr: "Armistice",
            nl: "Wapenstilstand"
          }
        },
        "11-15": {
          name: {
            nl: "Koningsdag",
            fr: "Fête du Roi",
            de: "Festtag des Königs"
          },
          type: "observance"
        },
        "12-06": {
          _name: "12-06",
          type: "observance"
        },
        "12-25": {
          _name: "12-25"
        }
      },
      states: {
        BRU: {
          name: "Bruxelles",
          langs: [
            "fr",
            "nl"
          ],
          days: {
            "05-08": {
              name: {
                nl: "Feest van de Iris",
                fr: "Fête de l'Iris"
              },
              type: "observance"
            }
          }
        },
        DE: {
          name: "Deutschsprachige Gemeinschaft",
          langs: [
            "de"
          ],
          days: {
            "11-15": {
              name: {
                de: "Tag der Deutschsprachigen Gemeinschaft",
                fr: "Jour de la Communauté Germanophone",
                nl: "Feestdag van de Duitstalige Gemeenschap"
              },
              type: "observance"
            }
          }
        },
        VLG: {
          name: "Vlaamse Gemeenschap",
          langs: [
            "nl"
          ],
          days: {
            "07-11": {
              name: {
                de: "Festtag der Wallonischen Region",
                fr: "Fête de la Région wallonne",
                nl: "Feestdag van de Vlaamse Gemeenschap"
              },
              type: "observance"
            },
            "11-02": {
              _name: "11-02",
              type: "observance",
              note: "day-off for employees of the flemish government"
            },
            "11-15": {
              name: {
                nl: "Koningsdag",
                fr: "Fête du Roi",
                de: "Festtag des Königs"
              },
              type: "observance",
              note: "day-off for employees of the flemish government"
            },
            "12-26": {
              _name: "12-26",
              type: "observance",
              note: "day-off for employees of the flemish government"
            }
          }
        },
        WAL: {
          name: "Communauté française",
          langs: [
            "fr"
          ],
          days: {
            "09-27": {
              name: {
                de: "Tag der Französischsprachigen Gemeinschaft",
                fr: "La fête de la communauté française",
                nl: "Feestdag van de Franse Gemeenschap"
              },
              type: "observance"
            }
          }
        }
      }
    },
    BF: {
      names: {
        fr: "Burkina Faso",
        en: "Burkina Faso"
      },
      langs: [
        "fr"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-03": {
          name: {
            fr: "Soulèvement populaire",
            en: "Anniversary of the 1966 Upper Voltan coup d'état"
          }
        },
        "03-08": {
          _name: "03-08"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "05-01": {
          _name: "05-01"
        },
        "08-05": {
          _name: "Independence Day"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-11": {
          name: {
            fr: "Fête nationale",
            en: "Proclamation of the Republic"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    BG: {
      names: {
        bg: "България",
        en: "Bulgaria"
      },
      langs: [
        "bg"
      ],
      zones: [
        "Europe/Sofia"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-01": {
          name: {
            bg: "Баба Марта",
            en: "Granny March Day"
          },
          type: "observance"
        },
        "03-03": {
          name: {
            bg: "Ден на Освобождението на България от Османската Империя",
            en: "Liberation Day"
          }
        },
        "03-08": {
          _name: "03-08",
          type: "observance"
        },
        "orthodox -2": {
          _name: "easter -2"
        },
        orthodox: {
          _name: "easter"
        },
        "orthodox 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-06": {
          name: {
            bg: "Гергьовден",
            en: "St. George's Day"
          }
        },
        "05-07": {
          name: {
            bg: "Ден на радиото и телевизията",
            en: "Radio and Television Day"
          },
          type: "observance"
        },
        "05-24": {
          name: {
            bg: "Ден на азбуката, културата и просветата",
            en: "Bulgarian Education and Culture, and Slavonic Literature Day"
          }
        },
        "09-06": {
          name: {
            bg: "Ден на съединението",
            en: "Unification Day"
          }
        },
        "09-22": {
          _name: "Independence Day"
        },
        "11-01": {
          name: {
            bg: "Ден на народните будители",
            en: "Revival Leaders' Day"
          },
          type: "school"
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26",
          type: "observance"
        }
      }
    },
    BH: {
      names: {
        ar: "مملكة البحرين",
        en: "Bahrain"
      },
      langs: [
        "ar"
      ],
      zones: [
        "Asia/Qatar"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "05-01": {
          _name: "05-01",
          name: {
            ar: "يوم العمال"
          }
        },
        "12-16": {
          name: {
            ar: "اليوم الوطني",
            en: "National Day"
          }
        },
        "12-17": {
          name: {
            ar: "يوم الجلوس",
            en: "Accession Day"
          }
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "10 Muharram": {
          _name: "10 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "9 Dhu al-Hijjah": {
          _name: "9 Dhu al-Hijjah"
        },
        "10 Dhu al-Hijjah P3D": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    BI: {
      names: {
        rn: "Republika y'Uburundi",
        fr: "République du Burundi",
        en: "Burundi"
      },
      dayoff: "sunday",
      langs: [
        "fr",
        "en"
      ],
      zones: [
        "Africa/Maputo"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-05": {
          name: {
            fr: "Jour de l'Unité",
            en: "Unity Day"
          }
        },
        "04-06": {
          name: {
            fr: "Jour de Ntaryamira",
            en: "Ntaryamira Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "07-01": {
          _name: "Independence Day"
        },
        "08-15": {
          _name: "08-15"
        },
        "10-13": {
          name: {
            fr: "Jour de Rwagasore",
            en: "Rwagasore Day"
          }
        },
        "10-21": {
          name: {
            fr: "Jour de Ndadaye",
            en: "Ndadaye Day"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "2015-07-24": {
          _name: "Public Holiday",
          name: {
            fr: "Jour l'élection des Sénateurs"
          }
        }
      }
    },
    BJ: {
      names: {
        fr: "République du Bénin",
        en: "Benin"
      },
      langs: [
        "fr"
      ],
      zones: [
        "Africa/Lagos"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-10": {
          name: {
            fr: "Fête du Vodoun"
          }
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "05-01": {
          _name: "05-01"
        },
        "08-01": {
          _name: "Independence Day",
          name: {
            fr: "Fête Nationale"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        }
      }
    },
    BL: {
      names: {
        fr: "St. Barthélemy",
        en: "St. Barths"
      },
      langs: [
        "fr"
      ],
      zones: [
        "America/St_Barthelemy"
      ],
      _days: "FR",
      days: {
        "easter -48": {
          _name: "easter -48",
          type: "observance"
        },
        "easter -47": {
          _name: "easter -47",
          type: "Observance"
        },
        "easter -46": {
          _name: "easter -46",
          type: "observance"
        },
        "easter -21": {
          name: {
            fr: "Mi-Carême",
            en: "Laetare Sunday"
          },
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2",
          type: "bank"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "08-24": {
          name: {
            fr: "Fête de Saint Barthélemy",
            en: "Saint Barth"
          },
          type: "observance"
        },
        "10-09": {
          _name: "Abolition of Slavery"
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    BM: {
      names: {
        en: "Bermuda"
      },
      langs: [
        "en"
      ],
      zones: [
        "Atlantic/Bermuda"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if saturday, sunday then next monday": {
          _name: "01-01",
          substitute: !0,
          type: "bank",
          note: "Goverment offices close"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "friday before 06-01": {
          name: {
            en: "Bermuda Day"
          }
        },
        "3nd monday in June": {
          name: {
            en: "National Heroes Day"
          }
        },
        "thursday before 08-04": {
          name: {
            en: "Emancipation Day"
          }
        },
        "friday before 08-05": {
          name: {
            en: "Somers' Day"
          }
        },
        "monday after 09-01": {
          name: {
            en: "Labour Day"
          }
        },
        "11-11": {
          name: {
            en: "Remembrance Day"
          }
        },
        "substitutes 11-11 if saturday, sunday then next monday": {
          name: {
            en: "Remembrance Day"
          },
          substitute: !0,
          type: "bank",
          note: "Goverment offices close"
        },
        "12-25": {
          _name: "12-25"
        },
        "substitutes 12-25 if saturday then next monday if sunday then next tuesday": {
          _name: "12-25",
          substitute: !0,
          type: "bank",
          note: "Goverment offices close"
        },
        "12-26": {
          _name: "12-26"
        },
        "substitutes 12-26 if saturday then next monday if sunday then next tuesday": {
          _name: "12-26",
          substitute: !0,
          type: "bank",
          note: "Goverment offices close"
        }
      }
    },
    BN: {
      names: {
        ms: "Negara Brunei Darussalam",
        en: "Brunei"
      },
      langs: [
        "ms",
        "en"
      ],
      zones: [
        "Asia/Brunei"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01",
          name: {
            ms: "Awal Tahun Masihi"
          }
        },
        "02-23": {
          name: {
            en: "National Day",
            ms: "Hari Kebangsaan"
          }
        },
        "03-31": {
          name: {
            en: "Armed Forces Day",
            ms: "Hari Angkatan Bersenjata Diraja Brunei"
          }
        },
        "07-15": {
          name: {
            en: "Sultan's Birthday",
            ms: "Hari Keputeraan KDYMM Sultan Brunei"
          }
        },
        "1 Ramadan": {
          _name: "1 Ramadan"
        },
        "17 Ramadan": {
          name: {
            en: "Nuzul Al-Quran",
            ms: "Hari Nuzul Al-Quran"
          }
        },
        "1 Shawwal P3D": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "27 Rajab": {
          _name: "27 Rajab"
        },
        "12-25": {
          _name: "12-25"
        },
        "chinese 01-0-01": {
          name: {
            en: "Chinese New Year",
            ms: "Tahun Baru Cina"
          }
        }
      }
    },
    BO: {
      names: {
        es: "Bolivia",
        en: "Bolivia"
      },
      dayoff: "sunday",
      langs: [
        "es",
        "qu",
        "ay"
      ],
      zones: [
        "America/La_Paz"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if sunday then next monday": {
          name: {
            en: "New Year's Day (substitutes)",
            es: "Año Nuevo (substituto)"
          }
        },
        "01-22": {
          name: {
            en: "Plurinational State Foundation Day",
            es: "Día de la Creación del Estado Plurinacional de Bolivia"
          }
        },
        "substitutes 01-22 if sunday then next monday": {
          name: {
            en: "Plurinational State Foundation Day (substitutes)",
            es: "Día de la Creación del Estado Plurinacional de Bolivia (substituto)"
          }
        },
        "02-02": {
          name: {
            en: "Feast of the Virgin of Candelaria",
            qu: "Mamacha Candelaria",
            es: "Fiesta de la Virgen de Candelaria"
          },
          type: "observance"
        },
        "easter -48": {
          _name: "easter -48",
          name: {
            es: "Lunes de Carnaval"
          }
        },
        "easter -47": {
          _name: "easter -47",
          name: {
            es: "Martes de Carnaval"
          }
        },
        "03-19": {
          name: {
            en: "Father's Day",
            es: "Día del Padre"
          },
          type: "observance"
        },
        "03-23": {
          name: {
            en: "Day of the Sea",
            es: "Día del Mar"
          },
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "04-12": {
          name: {
            en: "Children's Day",
            es: "Día del Niño"
          },
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "substitutes 05-01 if sunday then next monday": {
          _name: "05-01",
          name: {
            en: "Labour Day (substitutes)",
            es: "Día del Trabajo (substituto)"
          }
        },
        "05-27": {
          name: {
            en: "Mother's Day",
            es: "Día de la Madre"
          },
          type: "observance"
        },
        "06-06": {
          name: {
            en: "Teacher's Day",
            es: "Día del Maestro"
          },
          type: "observance"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "06-21": {
          name: {
            en: "Andean Amazonian Chaqueño New Year",
            ay: "Willkakuti",
            es: "Año Nuevo Andino Amazónico Chaqueño"
          }
        },
        "substitutes 06-21 if sunday then next monday": {
          name: {
            en: "Andean Amazonic Chacoan New Year (substitutes)",
            ay: "Willkakuti (substituto)",
            es: "Año Nuevo Andino Amazónico Chaqueño (substituto)"
          }
        },
        "08-06": {
          _name: "Independence Day"
        },
        "substitutes 08-06 if sunday then next monday": {
          name: {
            en: "Independence Day (substitutes)",
            es: "Día de la Independencia (substituto)"
          }
        },
        "08-17": {
          name: {
            en: "Flag Day",
            es: "Día de la Bandera"
          },
          type: "observance"
        },
        "09-21": {
          name: {
            en: "Student's Day",
            es: "Día del Estudiante"
          },
          type: "observance"
        },
        "10-11": {
          name: {
            es: "Día de la Mujer Boliviana",
            en: "Bolivian Woman's Day"
          },
          type: "observance"
        },
        "11-01": {
          _name: "11-01",
          name: {
            es: "Todos Santos"
          },
          type: "observance"
        },
        "11-02": {
          _name: "11-02",
          name: {
            es: "Todos Santos"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "substitutes 12-25 if sunday then next monday": {
          _name: "12-25",
          name: {
            en: "Christmas Day (substitutes)",
            es: "Navidad (substituto)"
          }
        }
      },
      states: {
        B: {
          name: "Beni",
          days: {
            "11-18": {
              name: {
                es: "Efemérides del Beni",
                en: "Beni Day"
              }
            },
            "substitutes 11-18 if sunday then next monday": {
              name: {
                es: "Efemérides del Beni (substituto)",
                en: "Beni Day (substitutes)"
              }
            }
          }
        },
        C: {
          name: "Cochabamba",
          days: {
            "09-14": {
              name: {
                es: "Efemérides de Cochabamba",
                en: "Cochabamba Day"
              }
            },
            "substitutes 09-14 if sunday then next monday": {
              name: {
                es: "Efemérides de Cochabamba (substituto)",
                en: "Cochabamba Day (substitutes)"
              }
            }
          }
        },
        H: {
          name: "Chuquisaca",
          days: {
            "05-25": {
              name: {
                es: "Efemérides de Chuquisaca",
                en: "Chuquisaca Day"
              }
            },
            "substitutes 05-25 if sunday then next monday": {
              name: {
                es: "Efemérides de Chuquisaca (substituto)",
                en: "Chuquisaca Day (substitutes)"
              }
            }
          }
        },
        L: {
          name: "La Paz",
          days: {
            "07-16": {
              name: {
                es: "Efemérides de La Paz",
                en: "La Paz Day"
              }
            },
            "substitutes 07-16 if sunday then next monday": {
              name: {
                es: "Efemérides de La Paz (substituto)",
                en: "La Paz Day (substitutes)"
              }
            }
          }
        },
        N: {
          name: "Pando",
          days: {
            "09-24": {
              name: {
                es: "Efemérides de Pando",
                en: "Pando Day"
              }
            },
            "substitutes 09-24 if sunday then next monday": {
              name: {
                es: "Efemérides de Pando (substituto)",
                en: "Pando Day (substitutes)"
              }
            }
          }
        },
        O: {
          name: "Oruro",
          days: {
            "02-10": {
              name: {
                es: "Efemérides de Oruro",
                en: "Oruro Day"
              }
            },
            "substitutes 02-10 if sunday then next monday": {
              name: {
                es: "Efemérides de Oruro (substituto)",
                en: "Oruro Day (substitutes)"
              }
            }
          }
        },
        P: {
          name: "Potosí",
          days: {
            "11-10": {
              name: {
                es: "Efemérides de Potosí",
                en: "Potosí Day"
              }
            },
            "substitutes 11-10 if sunday then next monday": {
              name: {
                es: "Efemérides de Potosí (substituto)",
                en: "Potosí Day (substitutes)"
              }
            }
          }
        },
        S: {
          name: "Santa Cruz",
          days: {
            "09-24": {
              name: {
                es: "Efemérides de Santa Cruz",
                en: "Santa Cruz Day"
              }
            },
            "substitutes 09-24 if sunday then next monday": {
              name: {
                es: "Efemérides de Santa Cruz (substituto)",
                en: "Santa Cruz Day (substitutes)"
              }
            }
          }
        },
        T: {
          name: "Tarija",
          days: {
            "04-15": {
              name: {
                es: "Efemérides de Tarija",
                en: "Tarija Day"
              }
            },
            "substitutes 04-15 if sunday then next monday": {
              name: {
                es: "Efemérides de Tarija (substituto)",
                en: "Tarija Day (substitutes)"
              }
            }
          }
        }
      }
    },
    BQ: {
      names: {
        nl: "Caribisch Nederland",
        en: "Caribbean Netherlands"
      },
      dayoff: "sunday",
      zones: [
        "America/Curacao"
      ],
      langs: [
        "nl",
        "en",
        "pap"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-27": {
          name: {
            pap: "Aña di Rey",
            nl: "Koningsdag",
            en: "Kings Day"
          }
        },
        "05-01 if sunday then next monday": {
          substitute: !0,
          _name: "05-01"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "3rd sunday in June": {
          _name: "Fathers Day",
          type: "observance"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "12-05": {
          name: {
            nl: "Sinterklaasavond",
            en: "St. Nicholas' Eve"
          },
          type: "observance"
        },
        "12-15": {
          name: {
            pap: "Dia di Reino",
            nl: "Koninkrijksdag",
            en: "Kingdom Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      },
      regions: {
        BO: {
          name: "Bonaire",
          days: {
            "easter -48": {
              _name: "easter -48",
              name: {
                en: "Carnival Monday"
              }
            },
            "04-30": {
              name: {
                en: "Rincon Day",
                pap: "Dia di Rincon"
              }
            },
            "09-06": {
              name: {
                nl: "Boneiru Dag",
                en: "Bonaire Day",
                pap: "Dia di Boneiru"
              }
            }
          }
        },
        SA: {
          name: "Saba",
          days: {
            "1st monday in August": {
              _name: "easter -48",
              name: {
                en: "Carnival Monday"
              }
            },
            "1st friday in December": {
              name: {
                en: "Saba Day"
              }
            }
          }
        },
        SE: {
          name: "Sint Eustatius",
          days: {
            "08-01": {
              name: {
                en: "Emancipation Day"
              }
            },
            "11-16": {
              name: {
                en: "Statia Day"
              }
            }
          }
        }
      }
    },
    BR: {
      names: {
        pt: "Brasil",
        en: "Brazil"
      },
      dayoff: "sunday",
      langs: [
        "pt"
      ],
      zones: [
        "America/Sao_Paulo",
        "America/Noronha",
        "America/Belem",
        "America/Fortaleza",
        "America/Recife",
        "America/Araguaina",
        "America/Maceio",
        "America/Bahia",
        "America/Campo_Grande",
        "America/Cuiaba",
        "America/Santarem",
        "America/Porto_Velho",
        "America/Boa_Vista",
        "America/Manaus",
        "America/Eirunepe",
        "America/Rio_Branco"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "04-21": {
          name: {
            pt: "Dia de Tiradentes",
            en: "Tiradentes' Day"
          }
        },
        "easter -50 PT110H": {
          name: {
            pt: "Carnaval",
            en: "Carnival"
          },
          type: "optional"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 60": {
          _name: "easter 60",
          type: "optional"
        },
        "06-12": {
          name: {
            pt: "Dia dos Namorados",
            en: "Lovers' Day"
          },
          type: "observance"
        },
        "2nd sunday in August": {
          _name: "Fathers Day",
          type: "observance"
        },
        "09-07": {
          _name: "Independence Day"
        },
        "10-12": {
          name: {
            pt: "Nossa Senhora Aparecida",
            en: "Our Lady of Aparecida"
          }
        },
        "1st sunday in October in even years": {
          name: {
            pt: "Dia de Eleição",
            en: "Election Day"
          }
        },
        "1st sunday before 11-01 in even years": {
          name: {
            pt: "Dia de Eleição",
            en: "Election Day"
          }
        },
        "11-02": {
          _name: "11-02"
        },
        "11-15": {
          name: {
            pt: "Proclamação da República",
            en: "Republic Day"
          }
        },
        "12-24 14:00": {
          _name: "12-24",
          type: "optional"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-31 14:00": {
          _name: "12-31",
          type: "optional"
        }
      },
      states: {
        AC: {
          name: "Acre",
          zones: [
            "America/Rio_Branco"
          ],
          days: {
            "01-12": {
              name: {
                pt: "Dia do evangélico"
              },
              active: [
                {
                  from: "2004-01-29T00:00:00.000Z"
                }
              ]
            },
            "03-08": {
              name: {
                pt: "Alusivo ao Dia Internacional da Mulher"
              },
              active: [
                {
                  from: "2001-09-14T00:00:00.000Z"
                }
              ]
            },
            "06-15": {
              name: {
                pt: "Aniversário do estado"
              },
              active: [
                {
                  from: "1964-09-02T00:00:00.000Z"
                }
              ]
            },
            "09-05": {
              name: {
                pt: "Dia da Amazônia"
              },
              active: [
                {
                  from: "2004-01-05T00:00:00.000Z"
                }
              ]
            },
            "11-17": {
              name: {
                pt: "Assinatura do Tratado de Petrópolis"
              },
              type: "optional",
              active: [
                {
                  from: "2012-02-21T00:00:00.000Z"
                }
              ]
            }
          }
        },
        AL: {
          name: "Alagoas",
          zones: [
            "America/Maceio"
          ],
          days: {
            "06-24": {
              name: {
                pt: "São João"
              },
              active: [
                {
                  from: "1993-07-07T00:00:00.000Z"
                }
              ]
            },
            "06-29": {
              name: {
                pt: "São Pedro"
              },
              active: [
                {
                  from: "1993-07-07T00:00:00.000Z"
                }
              ]
            },
            "09-16": {
              name: {
                pt: "Emancipação política"
              }
            },
            "11-20": {
              name: {
                pt: "Morte de Zumbi dos Palmares"
              },
              active: [
                {
                  from: "1995-08-01T00:00:00.000Z"
                }
              ]
            }
          }
        },
        AM: {
          name: "Amazonas",
          zones: [
            "America/Manaus"
          ],
          days: {
            "09-05": {
              name: {
                pt: "Elevação do Amazonas à categoria de província"
              },
              active: [
                {
                  from: "1977-12-21T00:00:00.000Z"
                }
              ]
            },
            "11-20": {
              name: {
                pt: "Dia da Consciência Negra"
              },
              active: [
                {
                  from: "2010-07-08T00:00:00.000Z"
                }
              ]
            }
          }
        },
        AP: {
          name: "Amapá",
          zones: [
            "America/Belem"
          ],
          days: {
            "03-19": {
              name: {
                pt: "Dia de São José"
              },
              note: "Santo padroeiro do Estado do Amapá",
              active: [
                {
                  from: "2002-04-16T00:00:00.000Z"
                }
              ]
            },
            "09-13": {
              name: {
                pt: "Criação do Território Federal"
              }
            }
          }
        },
        BA: {
          name: "Bahia",
          zones: [
            "America/Bahia"
          ],
          days: {
            "07-02": {
              name: {
                pt: "Independência da Bahia"
              }
            }
          }
        },
        CE: {
          name: "Ceará",
          zones: [
            "America/Fortaleza"
          ],
          days: {
            "03-25": {
              name: {
                pt: "Data magna do estado"
              },
              active: [
                {
                  from: "2011-12-01T00:00:00.000Z"
                }
              ]
            }
          }
        },
        DF: {
          name: "Distrito Federal",
          zones: [
            "America/Sao_Paulo"
          ],
          days: {
            "04-21": {
              name: {
                pt: "Fundação de Brasília"
              }
            },
            "11-30": {
              name: {
                pt: "Dia do Evangélico"
              },
              type: "public",
              active: [
                {
                  from: "1995-12-04T00:00:00.000Z"
                }
              ]
            }
          }
        },
        MA: {
          name: "Maranhão",
          zones: [
            "America/Belem"
          ],
          days: {
            "07-28": {
              name: {
                pt: "Adesão do Maranhão à independência do Brasil"
              },
              active: [
                {
                  from: "1964-10-02T00:00:00.000Z"
                }
              ]
            }
          }
        },
        MG: {
          name: "Minas Gerais",
          zones: [
            "America/Sao_Paulo"
          ],
          days: {
            "04-21": {
              name: {
                pt: "Data magna do estado"
              }
            }
          },
          regions: {
            BH: {
              name: "Belo Horizonte",
              days: {
                "08-15": {
                  _name: "08-15",
                  name: {
                    pt: "Assunção de Nossa Senhora"
                  },
                  type: "public"
                },
                "12-08": {
                  _name: "12-08",
                  type: "public"
                }
              }
            }
          }
        },
        MS: {
          name: "Mato Grosso do Sul",
          zones: [
            "America/Campo_Grande"
          ],
          days: {
            "10-11": {
              name: {
                pt: "Criação do estado"
              },
              active: [
                {
                  from: "1979-10-29T00:00:00.000Z"
                }
              ]
            }
          }
        },
        MT: {
          name: "Mato Grosso",
          zones: [
            "America/Cuiaba"
          ],
          days: {
            "11-20": {
              name: {
                pt: "Dia da Consciência Negra"
              },
              active: [
                {
                  from: "2002-12-27T00:00:00.000Z"
                }
              ]
            }
          }
        },
        PA: {
          name: "Pará",
          zones: [
            "America/Santarem"
          ],
          days: {
            "08-15": {
              name: {
                pt: "Adesão do Grão-Pará à independência do Brasil"
              },
              active: [
                {
                  from: "1996-09-10T00:00:00.000Z"
                }
              ]
            }
          }
        },
        PB: {
          name: "Paraíba",
          zones: [
            "America/Recife"
          ],
          days: {
            "07-26": {
              name: {
                pt: "Homenagem à memória do ex-presidente João Pessoa"
              }
            },
            "08-05": {
              name: {
                pt: "Nossa Senhora das Neves"
              },
              note: "Fundação do Estado em 1585 e dia da sua padroeira",
              active: [
                {
                  from: "1967-08-30T00:00:00.000Z"
                }
              ]
            }
          }
        },
        PE: {
          name: "Pernambuco",
          zones: [
            "America/Recife"
          ],
          days: {
            "1st sunday in March": {
              name: {
                pt: "Revolução Pernambucana de 1817"
              },
              active: [
                {
                  from: "2009-07-02T00:00:00.000Z"
                }
              ]
            }
          },
          regions: {
            RE: {
              name: "Recife",
              days: {
                "06-24": {
                  name: {
                    pt: "São João",
                    en: "Saint John's Day"
                  },
                  type: "public"
                },
                "07-16": {
                  name: {
                    pt: "Nossa Senhora do Carmo"
                  },
                  type: "public"
                },
                "12-08": {
                  _name: "12-08",
                  name: {
                    pt: "Nossa Senhora da Conceição"
                  },
                  type: "public"
                }
              }
            }
          }
        },
        PI: {
          name: "Piauí",
          zones: [
            "America/Fortaleza"
          ],
          days: {
            "10-19": {
              name: {
                pt: "Dia do Piauí"
              },
              active: [
                {
                  from: "1937-01-01T00:00:00.000Z"
                }
              ]
            }
          }
        },
        PR: {
          name: "Paraná",
          zones: [
            "America/Sao_Paulo"
          ],
          days: {
            "12-19": {
              name: {
                pt: "Emancipação política do estado do Paraná"
              },
              active: [
                {
                  from: "1962-12-18T00:00:00.000Z"
                }
              ]
            }
          },
          regions: {
            CU: {
              name: "Curitiba",
              days: {
                "09-08": {
                  name: {
                    pt: "Nossa Senhora da Luz dos Pinhais"
                  },
                  type: "public"
                }
              }
            }
          }
        },
        RJ: {
          name: "Rio de Janeiro",
          zones: [
            "America/Sao_Paulo"
          ],
          days: {
            "easter -47": {
              name: {
                pt: "Carnaval"
              },
              active: [
                {
                  from: "2008-05-14T00:00:00.000Z"
                }
              ]
            },
            "04-23": {
              name: {
                pt: "Dia de São Jorge"
              },
              active: [
                {
                  from: "2008-03-05T00:00:00.000Z"
                }
              ]
            },
            "3rd tuesday in October": {
              name: {
                pt: "Dia do Comércio"
              },
              type: "observance",
              note: "feriado para os comerciantes e trabalhadores da construção civil"
            },
            "11-20": {
              name: {
                pt: "Dia da Consciência Negra"
              },
              active: [
                {
                  from: "2002-11-11T00:00:00.000Z"
                }
              ]
            }
          },
          regions: {
            RJ: {
              name: "Rio de Janeiro",
              days: {
                "01-20": {
                  name: {
                    pt: "Dia de São Sebastião"
                  },
                  type: "public",
                  active: [
                    {
                      from: "1988-06-27T00:00:00.000Z"
                    }
                  ]
                }
              }
            }
          }
        },
        RN: {
          name: "Rio Grande do Norte",
          zones: [
            "America/Recife"
          ],
          days: {
            "10-03": {
              name: {
                pt: "Mártires de Cunhaú e Uruaçu"
              },
              active: [
                {
                  from: "2006-12-06T00:00:00.000Z"
                }
              ]
            }
          }
        },
        RO: {
          name: "Rondônia",
          zones: [
            "America/Porto_Velho"
          ],
          days: {
            "01-04": {
              name: {
                pt: "Criação do estado"
              },
              active: [
                {
                  from: "2010-04-22T00:00:00.000Z"
                }
              ]
            },
            "06-18": {
              name: {
                pt: "Dia do evangélico"
              },
              active: [
                {
                  from: "2001-12-20T00:00:00.000Z"
                }
              ]
            }
          }
        },
        RR: {
          name: "Roraima",
          zones: [
            "America/Boa_Vista"
          ],
          days: {
            "10-05": {
              name: {
                pt: "Criação do estado"
              }
            }
          }
        },
        RS: {
          name: "Rio Grande do Sul",
          zones: [
            "America/Sao_Paulo"
          ],
          days: {
            "09-20": {
              name: {
                pt: "Proclamação da República Rio-Grandense"
              }
            }
          }
        },
        SC: {
          name: "Santa Catarina",
          zones: [
            "America/Sao_Paulo"
          ],
          days: {
            "08-11": {
              name: {
                pt: "Dia de Santa Catarina"
              },
              active: [
                {
                  from: "2004-01-22T00:00:00.000Z",
                  to: "2005-07-15T00:00:00.000Z"
                }
              ]
            },
            "08-11 if monday,tuesday,wednesday,thursday,friday,saturday then next sunday": {
              name: {
                pt: "Dia de Santa Catarina"
              },
              active: [
                {
                  from: "2005-07-15T00:00:00.000Z"
                }
              ]
            },
            "11-25": {
              name: {
                pt: "Dia de Santa Catarina de Alexandria"
              },
              active: [
                {
                  from: "1996-12-26T00:00:00.000Z",
                  to: "2005-07-15T00:00:00.000Z"
                }
              ]
            },
            "11-25 if monday,tuesday,wednesday,thursday,friday,saturday then next sunday": {
              name: {
                pt: "Dia de Santa Catarina de Alexandria"
              },
              active: [
                {
                  from: "2005-07-15T00:00:00.000Z"
                }
              ]
            }
          }
        },
        SE: {
          name: "Sergipe",
          zones: [
            "America/Recife"
          ],
          days: {
            "07-08": {
              name: {
                pt: "Emancipação política de Sergipe"
              }
            }
          }
        },
        SP: {
          name: "São Paulo",
          zones: [
            "America/Sao_Paulo"
          ],
          days: {
            "07-09": {
              name: {
                pt: "Revolução Constitucionalista"
              },
              active: [
                {
                  from: "1997-03-05T00:00:00.000Z"
                }
              ]
            },
            "11-20": {
              name: {
                pt: "Dia da Consciência Negra"
              },
              active: [
                {
                  from: "2023-09-12T00:00:00.000Z"
                }
              ]
            }
          },
          regions: {
            SP: {
              name: "São Paulo",
              days: {
                "easter 60": {
                  _name: "easter 60",
                  type: "public"
                },
                "01-25": {
                  name: {
                    pt: "Aniversário da Cidade",
                    en: "City Birthday"
                  },
                  type: "public"
                },
                "11-20": {
                  name: {
                    pt: "Dia da Consciência Negra"
                  },
                  active: [
                    {
                      from: "2004-01-07T00:00:00.000Z"
                    }
                  ]
                }
              }
            }
          }
        },
        TO: {
          name: "Tocantins",
          zones: [
            "America/Araguaina"
          ],
          days: {
            "10-05": {
              name: {
                pt: "Criação do estado"
              },
              active: [
                {
                  from: "1989-11-17T00:00:00.000Z"
                }
              ]
            },
            "03-18": {
              name: {
                pt: "Autonomia do Estado"
              },
              active: [
                {
                  from: "1998-03-17T00:00:00.000Z"
                }
              ]
            },
            "09-08": {
              name: {
                pt: "Nossa Senhora da Natividade"
              },
              note: "Padroeira do Estado",
              active: [
                {
                  from: "1993-12-28T00:00:00.000Z"
                }
              ]
            }
          }
        }
      }
    },
    BS: {
      names: {
        en: "Bahamas"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "America/Nassau"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-10 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            en: "Majority Rule Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "1st friday in June": {
          _name: "05-01",
          name: {
            en: "Randol Fawkes Labour Day"
          }
        },
        "07-10 and if saturday,sunday then next monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "1st monday in August": {
          name: {
            en: "Emancipation Day"
          }
        },
        "10-12 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            en: "National Heroes' Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    BW: {
      names: {
        en: "Botswana"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "Africa/Maputo"
      ],
      days: {
        "01-01": {
          _name: "01-01",
          note: "except mining industy"
        },
        "01-02": {
          name: {
            en: "New Year's Holiday"
          },
          note: "except mining industy"
        },
        "substitutes 01-02 if monday then next tuesday": {
          name: {
            en: "Public Holiday"
          },
          note: "except mining industy"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1",
          note: "except mining industy"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1",
          note: "except mining industy"
        },
        "easter 39": {
          _name: "easter 39",
          note: "except mining industy"
        },
        "05-01": {
          _name: "05-01",
          note: "except mining industy"
        },
        "substitutes 05-01 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          },
          note: "except mining industy"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "07-01": {
          name: {
            en: "Sir Seretse Khama Day"
          },
          note: "except mining industy"
        },
        "substitutes 07-01 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          },
          note: "except mining industy"
        },
        "3rd monday in July": {
          name: {
            en: "President’s Day"
          },
          note: "except mining industy"
        },
        "tuesday after 3rd monday in July": {
          name: {
            en: "President’s Day Holiday"
          },
          note: "except mining industy"
        },
        "09-30": {
          name: {
            en: "Botswana Day"
          }
        },
        "substitutes 09-30 if saturday,sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26",
          name: {
            en: "Family Day"
          },
          note: "except mining industy"
        },
        "substitutes 12-26 if monday then next tuesday": {
          name: {
            en: "Public Holiday"
          }
        }
      }
    },
    BY: {
      names: {
        be: "Рэспубліка Беларусь",
        ru: "Республика Беларусь",
        en: "Belarus"
      },
      zones: [
        "Europe/Minsk"
      ],
      langs: [
        "be",
        "ru"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "julian 12-25": {
          _name: "12-25",
          name: {
            be: "Каляды праваслаўныя"
          }
        },
        easter: {
          _name: "easter",
          name: {
            be: "Вялiкдзень каталiцкi"
          },
          type: "observance"
        },
        orthodox: {
          name: {
            en: "Orthodox Easter",
            be: "Вялiкдзень праваслаўны"
          },
          type: "observance"
        },
        "orthodox +9": {
          name: {
            en: "Commemoration Day",
            be: "Радунiца"
          }
        },
        "03-08": {
          _name: "03-08"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-09": {
          name: {
            en: "Victory Day",
            be: "Дзень Перамогi"
          }
        },
        "07-03": {
          _name: "Independence Day",
          active: [
            {
              from: 1996
            }
          ]
        },
        "11-07": {
          name: {
            en: "October Revolution Day",
            be: "Дзень Кастрычніцкай рэвалюцыі"
          }
        },
        "12-25": {
          _name: "12-25",
          name: {
            be: "Каляды каталiцкiя"
          }
        }
      }
    },
    BZ: {
      names: {
        en: "Belize"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "America/Belize"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-09 if friday,saturday,sunday then next monday if tuesday,wednesday,thursday then previous monday": {
          name: {
            en: "Baron Bliss Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01 if sunday then next monday": {
          _name: "05-01"
        },
        "05-24 if friday,saturday,sunday then next monday if tuesday,wednesday,thursday then previous monday": {
          name: {
            en: "Commonwealth Day, Sovereign's Day"
          }
        },
        "09-10 if sunday then next monday": {
          name: {
            en: "Saint George's Caye Day, National Day"
          }
        },
        "09-21 if sunday then next monday": {
          _name: "Independence Day"
        },
        "10-12 if friday,saturday,sunday then next monday if tuesday,wednesday,thursday then previous monday": {
          name: {
            en: "Day of the Americas"
          }
        },
        "11-19 if sunday then next monday": {
          name: {
            en: "Garifuna Settlement Day"
          }
        },
        "12-25 and if sunday then next tuesday": {
          _name: "12-25",
          substitute: !0
        },
        "12-26 and if sunday then next monday": {
          _name: "12-26",
          substitute: !0
        }
      }
    },
    CA: {
      names: {
        en: "Canada",
        fr: "Canada"
      },
      zones: [
        "America/Toronto",
        "America/St_Johns",
        "America/Halifax",
        "America/Glace_Bay",
        "America/Moncton",
        "America/Goose_Bay",
        "America/Blanc-Sablon",
        "America/Nipigon",
        "America/Thunder_Bay",
        "America/Iqaluit",
        "America/Pangnirtung",
        "America/Resolute",
        "America/Atikokan",
        "America/Rankin_Inlet",
        "America/Winnipeg",
        "America/Rainy_River",
        "America/Regina",
        "America/Swift_Current",
        "America/Edmonton",
        "America/Cambridge_Bay",
        "America/Yellowknife",
        "America/Inuvik",
        "America/Creston",
        "America/Dawson_Creek",
        "America/Fort_Nelson",
        "America/Vancouver",
        "America/Whitehorse",
        "America/Dawson"
      ],
      langs: [
        "en",
        "fr"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-02": {
          name: {
            en: "Groundhog Day",
            fr: "Jour de la marmotte"
          },
          type: "observance"
        },
        "02-14": {
          _name: "02-14",
          type: "observance"
        },
        "03-17": {
          name: {
            en: "St. Patrick’s Day",
            fr: "Fête de la Saint-Patrick"
          },
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "2nd sunday after 05-01": {
          _name: "Mothers Day",
          type: "observance"
        },
        "monday before 05-25": {
          name: {
            en: "Victoria Day",
            fr: "Fête de la Reine"
          }
        },
        "3rd sunday after 06-01": {
          _name: "Fathers Day",
          type: "observance"
        },
        "07-01": {
          name: {
            en: "Canada Day",
            fr: "Fête du Canada"
          }
        },
        "monday after 08-01": {
          name: {
            en: "Civic Holiday",
            fr: "Premier lundi d’août"
          }
        },
        "1st monday in September": {
          _name: "05-01"
        },
        "09-30 since 2021": {
          name: {
            en: "National Day for Truth and Reconciliation",
            fr: "Journée nationale de la vérité et de la réconciliation"
          }
        },
        "2nd monday after 10-01": {
          name: {
            en: "Thanksgiving",
            fr: "Action de grâce"
          }
        },
        "10-31 18:00": {
          name: {
            en: "Halloween",
            fr: "l'Halloween"
          },
          type: "observance"
        },
        "11-11": {
          name: {
            en: "Remembrance Day",
            fr: "Jour du Souvenir"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      },
      states: {
        AB: {
          name: "Alberta",
          zones: [
            "America/Edmonton"
          ],
          days: {
            "3rd monday after 02-01": {
              name: {
                en: "Family Day",
                fr: "Fête de la famille"
              }
            },
            "easter 1": {
              _name: "easter 1",
              type: "optional"
            },
            "monday after 08-01": {
              name: {
                en: "Heritage Day",
                fr: "Fête du patrimoine"
              },
              type: "optional"
            }
          }
        },
        BC: {
          name: "British Columbia",
          zones: [
            "America/Vancouver",
            "America/Edmonton",
            "America/Creston",
            "America/Dawson_Creek"
          ],
          days: {
            "2nd monday after 02-01": {
              name: {
                en: "Family Day",
                fr: "Fête de la famille"
              },
              active: [
                {
                  to: 2019
                }
              ]
            },
            "3rd monday after 02-01": {
              name: {
                en: "Family Day",
                fr: "Fête de la famille"
              },
              active: [
                {
                  from: 2019
                }
              ]
            }
          }
        },
        MB: {
          name: "Manitoba",
          zones: [
            "America/Winnipeg"
          ],
          days: {
            "3rd monday after 02-01": {
              name: {
                en: "Louis Riel Day",
                fr: "Journée Louis Riel"
              }
            }
          }
        },
        NB: {
          name: "New Brunswick",
          zones: [
            "America/Moncton"
          ],
          days: {
            "monday after 08-01": {
              name: {
                en: "New Brunswick Day",
                fr: "Jour de Nouveau Brunswick"
              }
            }
          }
        },
        NL: {
          name: "Newfoundland and Labrador",
          zones: [
            "America/St_Johns",
            "America/Goose_Bay"
          ],
          days: {
            "03-17": {
              name: {
                en: "Saint Patrick's Day",
                fr: "Jour de la Saint-Patrick"
              },
              type: "optional"
            },
            "04-23": {
              name: {
                en: "Saint George's Day",
                fr: "Jour de St. George"
              },
              type: "optional"
            },
            "06-24": {
              name: {
                en: "Discovery Day",
                fr: "Journée découverte"
              },
              type: "optional"
            },
            "07-12": {
              name: {
                en: "Orangemen's Day",
                fr: "Fête des orangistes"
              },
              type: "optional"
            },
            "11-11": {
              name: {
                en: "Armistice Day",
                fr: "Jour de l'Armistice"
              }
            }
          }
        },
        NS: {
          name: "Nova Scotia",
          zones: [
            "America/Halifax",
            "America/Moncton"
          ],
          days: {
            "3rd monday after 02-01": {
              name: {
                en: "Heritage Day",
                fr: "Fête du Patrimoine"
              }
            },
            "monday after 08-01": {
              name: {
                en: "Natal Day",
                fr: "Jour de la Fondation"
              }
            }
          }
        },
        NT: {
          name: "Northwest Territories",
          zones: [
            "America/Yellowknife",
            "America/Inuvik"
          ],
          days: {
            "06-21": {
              name: {
                en: "National Indigenous Peoples Day",
                fr: "Journée nationale des Autochthones"
              }
            }
          }
        },
        NU: {
          name: "Nunavut",
          zones: [
            "America/Iqaluit",
            "America/Pangnirtung",
            "America/Resolute",
            "America/Rankin_Inlet",
            "America/Atikokan",
            "America/Cambridge_Bay"
          ],
          days: {
            "07-09": {
              name: {
                en: "Nunavut Day"
              },
              type: "bank"
            }
          }
        },
        ON: {
          name: "Ontario",
          zones: [
            "America/Toronto",
            "America/Nipigon",
            "America/Thunder_Bay",
            "America/Atikokan",
            "America/Rainy_River",
            "America/Winnipeg"
          ],
          days: {
            "3rd monday after 02-01": {
              name: {
                en: "Family Day",
                fr: "Fête de la famille"
              }
            },
            "easter 1": {
              _name: "easter 1"
            }
          }
        },
        PE: {
          name: "Prince Edward Island",
          days: {
            "3rd monday after 02-01": {
              name: {
                en: "Islander Day",
                fr: "Fête des Insulaires"
              }
            },
            "easter 1": {
              _name: "easter 1",
              type: "optional"
            },
            "3rd friday after 08-01": {
              name: {
                en: "Gold Cup Parade Day",
                fr: "Défilé de la Coupe d'or"
              }
            }
          }
        },
        QC: {
          name: "Quebec",
          zones: [
            "America/Blanc-Sablon",
            "America/Toronto",
            "America/Nipigon"
          ],
          days: {
            "easter -2": {
              _name: "easter -2",
              note: "Either Good Friday or Easter Monday, at the employer’s option"
            },
            "easter 1": {
              _name: "easter 1",
              note: "Either Good Friday or Easter Monday, at the employer’s option"
            },
            "monday before 05-25": {
              name: {
                en: "National Patriots' Day",
                fr: "Journée nationale des patriotes"
              }
            },
            "06-24": {
              name: {
                en: "National Holiday",
                fr: "Fête nationale du Québec"
              }
            },
            "monday after 08-01": !1
          }
        },
        SK: {
          name: "Saskatchewan",
          zones: [
            "America/Regina",
            "America/Swift_Current",
            "America/Edmonton"
          ],
          days: {
            "3rd monday after 02-01": {
              name: {
                en: "Family Day",
                fr: "Fête de la famille"
              }
            },
            "3rd monday after 08-01": {
              name: {
                en: "Saskatchewan Day"
              }
            }
          }
        },
        YT: {
          name: "Yukon",
          zones: [
            "America/Whitehorse",
            "America/Dawson"
          ],
          days: {
            "easter 1": {
              _name: "easter 1"
            },
            "3rd monday after 08-01": {
              name: {
                en: "Discovery Day",
                fr: "Jour de la Découverte"
              }
            }
          }
        }
      }
    },
    CC: {
      names: {
        en: "Cocos (Keeling) Islands"
      },
      langs: [
        "en"
      ],
      zones: [
        "Indian/Cocos"
      ],
      dayoff: "sunday",
      days: {
        "chinese 01-0-01 and if sunday then next tuesday if saturday then next monday": {
          name: {
            en: "Chinese New Year"
          },
          substitute: !0
        },
        "chinese 01-0-02 and if sunday then next tuesday if saturday then next monday": {
          name: {
            en: "Chinese New Year (2nd Day)"
          },
          substitute: !0
        },
        "01-01": {
          _name: "01-01"
        },
        "01-26": {
          name: {
            en: "Australia Day"
          }
        },
        "03-20": {
          name: {
            en: "Labour Day"
          }
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-06": {
          name: {
            en: "Self Determination Day"
          }
        },
        "04-25": {
          name: {
            en: "Anzac Day"
          }
        },
        "12-25 and if sunday then next tuesday": {
          _name: "12-25",
          substitute: !0
        },
        "12-26 and if sunday then next monday": {
          _name: "12-26",
          substitute: !0
        },
        "1 Muharram and if sunday then next monday": {
          substitute: !0,
          _name: "1 Muharram"
        },
        "1 Shawwal and if sunday then next monday": {
          substitute: !0,
          _name: "1 Shawwal",
          name: {
            en: "Hari Raya Puasa"
          }
        },
        "10 Dhu al-Hijjah and if sunday then next monday": {
          substitute: !0,
          _name: "10 Dhu al-Hijjah",
          name: {
            en: "Hari Raya Haji"
          }
        },
        "12 Rabi al-awwal and if sunday then next monday": {
          substitute: !0,
          _name: "12 Rabi al-awwal",
          name: {
            en: "Hari Maulaud Nabi"
          }
        }
      }
    },
    CD: {
      names: {
        fr: "République démocratique du Congo",
        en: "Democratic Republic of the Congo"
      },
      dayoff: "sunday",
      langs: [
        "fr"
      ],
      zones: [
        "Africa/Maputo",
        "Africa/Lagos"
      ],
      days: {
        "01-01 and if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-04 and if sunday then next monday": {
          substitute: !0,
          name: {
            fr: "Martyrs de l'Indépendance",
            en: "Day of the Martyrs"
          }
        },
        "01-16 and if sunday then next tuesday": {
          substitute: !0,
          name: {
            fr: "Journée du Héro National Laurent Désiré Kabila",
            en: "Anniversary of President Laurent Kabila"
          }
        },
        "01-17 and if sunday then next monday": {
          substitute: !0,
          name: {
            fr: "Journée du Héro National Patrice Emery Lumumba",
            en: "Anniversary of Prime Minister Patrice Emery Lumumba"
          }
        },
        "05-01 and if sunday then next monday": {
          substitute: !0,
          _name: "05-01"
        },
        "05-17 and if sunday then next monday": {
          substitute: !0,
          name: {
            fr: "Journée de la Révolution et des Forces Armées",
            en: "Liberation Day"
          }
        },
        "06-30 and if sunday then next monday": {
          substitute: !0,
          _name: "Independence Day",
          name: {
            fr: "Anniversaire de Indépendance"
          }
        },
        "08-01 and if sunday then next monday": {
          substitute: !0,
          name: {
            fr: "Fête des parents",
            en: "Parents' Day"
          }
        },
        "12-25 and if sunday then next monday": {
          substitute: !0,
          _name: "12-25"
        },
        "2016-01-15": {
          _name: "Public Holiday"
        }
      }
    },
    CF: {
      names: {
        fr: "République centrafricaine",
        sg: "Ködörösêse tî Bêafrîka",
        en: "Central African Republic"
      },
      dayoff: "sunday",
      langs: [
        "fr",
        "sg"
      ],
      zones: [
        "Africa/Lagos"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-29": {
          name: {
            fr: "Décès du Fondateur Barthélémy Boganda",
            en: "Boganda Day"
          }
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "06-30": {
          name: {
            fr: "Journée de prière",
            en: "General Prayer Day"
          }
        },
        "08-13": {
          _name: "Independence Day"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-01": {
          name: {
            fr: "Jour de la République",
            en: "Republic Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    CG: {
      names: {
        fr: "République du Congo",
        en: "Republic of the Congo"
      },
      dayoff: "sunday",
      langs: [
        "fr",
        "en"
      ],
      zones: [
        "Africa/Lagos"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "06-10": {
          name: {
            fr: "Fête de la commémoration de la conférence nationale souveraine"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "11-28": {
          name: {
            fr: "Journée nationale de la République"
          }
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    CH: {
      names: {
        de: "Schweiz",
        fr: "Suisse",
        it: "Svizzera",
        en: "Switzerland"
      },
      dayoff: "sunday",
      langs: [
        "de-ch",
        "de",
        "fr",
        "it"
      ],
      zones: [
        "Europe/Zurich"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -3": {
          _name: "easter -3",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 39": {
          _name: "easter 39",
          name: {
            de: "Auffahrt"
          }
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "1st sunday in June": {
          name: {
            de: "Vätertag",
            fr: "Fête des pères"
          },
          type: "observance",
          active: [
            {
              from: "2009-01-01"
            }
          ]
        },
        "08-01": {
          name: {
            de: "Bundesfeiertag",
            fr: "Fête nationale",
            it: "Giorno festivo federale"
          }
        },
        "3rd sunday after 09-01": {
          name: {
            de: "Eidg. Dank-, Buss- und Bettag",
            fr: "Jeûne fédéral",
            it: "Digiuno federale",
            en: "Federal Day of Thanksgiving, Repentance and Prayer"
          }
        },
        "12-25": {
          _name: "12-25",
          name: {
            de: "Weihnachtstag"
          }
        },
        "12-26": {
          _name: "12-26",
          name: {
            de: "Stephanstag",
            fr: "Saint-Etienne"
          }
        }
      },
      states: {
        ZH: {
          names: {
            de: "Kanton Zürich",
            fr: "Canton de Zurich",
            it: "Canton Zurigo",
            en: "Canton of Zürich"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "optional"
            },
            "05-01": {
              _name: "05-01"
            },
            "easter 50": {
              _name: "easter 50"
            },
            "monday after 2nd saturday in September 13:00": {
              name: {
                de: "Knabenschiessen"
              },
              type: "optional"
            }
          }
        },
        BE: {
          names: {
            de: "Kanton Bern",
            fr: "Canton de Berne",
            it: "Canton Berna",
            en: "Canton of Bern"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "2 janvier"
              }
            }
          }
        },
        LU: {
          names: {
            de: "Kanton Luzern",
            fr: "Canton de Lucerne",
            it: "Canton Lucerna",
            en: "Canton of Lucerne"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "optional"
            },
            "03-19": {
              _name: "03-19",
              type: "observance"
            },
            "easter 1": {
              _name: "easter 1",
              type: "optional"
            },
            "easter 50": {
              _name: "easter 50",
              type: "optional"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "11-01": {
              _name: "11-01"
            },
            "12-08": {
              _name: "12-08"
            }
          }
        },
        UR: {
          names: {
            de: "Kanton Uri",
            fr: "Canton d'Uri",
            it: "Canton Uri",
            en: "Canton of Uri"
          },
          days: {
            "01-06": {
              _name: "01-06"
            },
            "03-19": {
              _name: "03-19"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "11-01": {
              _name: "11-01"
            },
            "12-08": {
              _name: "12-08"
            },
            "12-26": !1,
            "12-26 not on monday, friday": {
              _name: "12-26"
            }
          }
        },
        SZ: {
          names: {
            de: "Kanton Schwyz",
            fr: "Canton de Schwytz",
            it: "Canton Svitto",
            en: "Canton of Schwyz"
          },
          days: {
            "01-06": {
              _name: "01-06"
            },
            "03-19": {
              _name: "03-19"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "11-01": {
              _name: "11-01"
            },
            "12-08": {
              _name: "12-08"
            }
          }
        },
        OW: {
          names: {
            de: "Kanton Obwalden",
            fr: "Canton d'Obwald",
            it: "Canton Obvaldo",
            en: "Canton of Obwalden"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "optional"
            },
            "easter 1": {
              _name: "easter 1",
              type: "optional"
            },
            "easter 50": {
              _name: "easter 50",
              type: "optional"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "09-25": {
              name: {
                de: "Bruderklausenfest",
                fr: "Saint-Nicholas-de-Flüe",
                en: "Saint Nicholas of Flüe"
              }
            },
            "11-01": {
              _name: "11-01"
            },
            "12-08": {
              _name: "12-08"
            },
            "12-26": {
              _name: "12-26",
              type: "optional"
            }
          }
        },
        NW: {
          names: {
            de: "Kanton Nidwalden",
            fr: "Canton de Nidwald",
            it: "Canton Nidvaldo",
            en: "Canton of Nidwalden"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "bank"
            },
            "03-19": {
              _name: "03-19"
            },
            "easter 1": {
              _name: "easter 1",
              type: "optional"
            },
            "easter 50": {
              _name: "easter 50",
              type: "optional"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "11-01": {
              _name: "11-01"
            },
            "12-08": {
              _name: "12-08"
            },
            "12-26": {
              _name: "12-26",
              type: "optional"
            }
          }
        },
        GL: {
          sources: [
            "https://www.gl.ch/verwaltung/staatskanzlei/oeffentliche-feiertage.html/1335"
          ],
          names: {
            de: "Kanton Glarus",
            fr: "Canton de Glaris",
            it: "Canton Glarona",
            en: "Canton of Glarus"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "optional"
            },
            "Thursday after 04-02 if is observance holiday then next Thursday": {
              name: {
                de: "Näfelser Fahrt",
                fr: "Bataille de Näfels"
              }
            },
            "3rd sunday after 09-01": !1,
            "11-01": {
              _name: "11-01"
            },
            "12-24": {
              _name: "12-24"
            },
            "12-31": {
              _name: "12-31"
            }
          }
        },
        ZG: {
          names: {
            de: "Kanton Zug",
            fr: "Canton de Zoug",
            it: "Canton Zugo",
            en: "Canton of Zug"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "optional"
            },
            "easter 1": {
              _name: "easter 1",
              type: "optional"
            },
            "easter 50": {
              _name: "easter 50",
              type: "optional"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "11-01": {
              _name: "11-01"
            },
            "12-08": {
              _name: "12-08"
            },
            "12-26": {
              _name: "12-26",
              type: "optional"
            }
          }
        },
        FR: {
          names: {
            fr: "Canton de Fribourg",
            de: "Kanton Freiburg",
            it: "Canton Friburgo",
            en: "Canton of Fribourg"
          },
          langs: [
            "fr",
            "de-ch",
            "de",
            "it"
          ],
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "optional"
            },
            "easter 1": {
              _name: "easter 1",
              type: "optional"
            },
            "easter 50": {
              _name: "easter 50",
              type: "optional"
            },
            "easter 60": {
              _name: "easter 60",
              note: `excluding communities: Agriswil, Altavilla, Büchslen, Cordast, Courgevaux, Courlevon, Fräschels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully
`
            },
            "08-15": {
              _name: "08-15",
              note: `excluding communities: Agriswil, Altavilla, Büchslen, Cordast, Courgevaux, Courlevon, Fräschels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully
`
            },
            "11-01": {
              _name: "11-01",
              note: `excluding communities: Agriswil, Altavilla, Büchslen, Cordast, Courgevaux, Courlevon, Fräschels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully
`
            },
            "12-08": {
              _name: "12-08",
              note: `excluding communities: Agriswil, Altavilla, Büchslen, Cordast, Courgevaux, Courlevon, Fräschels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully
`
            },
            "12-26": {
              _name: "12-26",
              type: "optional"
            }
          }
        },
        SO: {
          names: {
            de: "Kanton Solothurn",
            fr: "Canton de Soleure",
            it: "Canton Soletta",
            en: "Canton of Solothurn"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "optional"
            },
            "03-19": {
              _name: "03-19",
              note: `Only in communities: Fulenbach, Walterswil, Wisen, Metzerlen, Nulgar-St. Pantaleon, Rodersdorf, Bärschwil, Büsserach
`
            },
            "easter 1": {
              _name: "easter 1",
              type: "optional"
            },
            "05-01 12:00": {
              _name: "05-01"
            },
            "easter 50": {
              _name: "easter 50",
              type: "optional"
            },
            "easter 60": {
              _name: "easter 60",
              note: "is optional in Bucheggberg"
            },
            "08-15": {
              _name: "08-15",
              note: "is optional in Bucheggberg"
            },
            "11-01": {
              _name: "11-01",
              note: "is optional in Bucheggberg"
            },
            "12-26": {
              _name: "12-26",
              type: "optional"
            }
          }
        },
        BS: {
          names: {
            de: "Kanton Basel-Stadt",
            fr: "Canton de Bâle-Ville",
            it: "Canton Basilea Città",
            en: "Canton of Basel-City"
          },
          days: {
            "05-01": {
              _name: "05-01"
            }
          }
        },
        BL: {
          names: {
            de: "Kanton Basel-Landschaft",
            fr: "Canton de Bâle-Campagne",
            it: "Canton Basilea Campagna",
            en: "Canton of Basel-Country"
          },
          days: {
            "05-01": {
              _name: "05-01"
            },
            "easter 60": {
              _name: "easter 60",
              type: "observance"
            }
          }
        },
        SH: {
          names: {
            de: "Kanton Schaffhausen",
            fr: "Canton de Schaffhouse",
            it: "Canton Sciaffusa",
            en: "Canton of Schaffhausen"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "optional"
            },
            "05-01": {
              _name: "05-01"
            }
          }
        },
        AR: {
          names: {
            de: "Kanton Appenzell Ausserrhoden",
            fr: "Canton d'Appenzell Rhodes-Extérieures",
            it: "Canton Appenzello Esterno",
            en: "Canton of Appenzell Outer Rhodes"
          },
          days: {
            "12-26": !1,
            "12-26 not on monday": {
              _name: "12-26"
            }
          }
        },
        AI: {
          names: {
            de: "Kanton Appenzell Innerrhoden",
            fr: "Canton d'Appenzell Rhodes-Intérieures",
            it: "Canton Appenzello Interno",
            en: "Canton of Appenzell Inner-Rhodes"
          },
          days: {
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "09-22": {
              name: {
                de: "Mauritiustag"
              },
              note: `excluding: Bezirk Oberegg
`
            },
            "11-01": {
              _name: "11-01"
            },
            "12-26": {
              type: "observance"
            },
            "12-26 not on tuesday, saturday": {
              _name: "12-26"
            }
          }
        },
        SG: {
          names: {
            de: "Kanton St. Gallen",
            fr: "Canton de Saint-Gall",
            it: "Canton San Gallo",
            en: "Canton of St. Gallen"
          },
          days: {
            "11-01": {
              _name: "11-01"
            }
          }
        },
        GR: {
          names: {
            de: "Kanton Graubünden",
            it: "Cantone dei Grigioni",
            fr: "Canton des Grisons",
            en: "Canton of Grisons"
          },
          langs: [
            "de-ch",
            "de",
            "it",
            "fr"
          ],
          days: {
            "01-06": {
              _name: "01-06",
              type: "observance"
            },
            "03-19": {
              _name: "03-19",
              type: "observance"
            },
            "easter -2": {
              _name: "easter -2",
              type: "optional"
            },
            "easter 60": {
              _name: "easter 60",
              type: "observance"
            },
            "08-15": {
              _name: "08-15",
              type: "observance"
            },
            "11-01": {
              _name: "11-01",
              type: "observance"
            },
            "12-08": {
              _name: "12-08",
              type: "observance"
            }
          }
        },
        AG: {
          names: {
            de: "Kanton Aargau",
            fr: "Canton d'Argovie",
            it: "Canton Argovia",
            en: "Canton of Aargau"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              }
            },
            "05-01": {
              _name: "05-01"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "11-01": {
              _name: "11-01"
            },
            "12-08": {
              _name: "12-08"
            }
          }
        },
        TG: {
          names: {
            de: "Kanton Thurgau",
            fr: "Canton de Thurgovie",
            it: "Canton Turgovia",
            en: "Canton of Thurgau"
          },
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              }
            },
            "05-01": {
              _name: "05-01"
            }
          }
        },
        TI: {
          names: {
            it: "Canton Ticino",
            de: "Kanton Tessin",
            fr: "Canton du Tessin",
            en: "Canton of Ticino"
          },
          langs: [
            "it",
            "de-ch",
            "de",
            "fr"
          ],
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "bank"
            },
            "01-06": {
              _name: "01-06",
              name: {
                it: "Epifania"
              }
            },
            "03-19": {
              _name: "03-19"
            },
            "easter -2": !1,
            "easter 60": {
              _name: "easter 60"
            },
            "05-01": {
              _name: "05-01"
            },
            "06-29": {
              _name: "06-29"
            },
            "1st sunday in June": !1,
            "08-15": {
              _name: "08-15",
              name: {
                it: "Assunzione"
              }
            },
            "11-01": {
              _name: "11-01"
            },
            "12-08": {
              _name: "12-08"
            }
          }
        },
        VD: {
          names: {
            fr: "Canton de Vaud",
            de: "Kanton Waadt",
            it: "Canton Vaud",
            en: "Canton of Vaud"
          },
          langs: [
            "fr",
            "de-ch",
            "de",
            "it"
          ],
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "2 Janvier"
              }
            },
            "monday after 3rd sunday in September": {
              name: {
                de: "Bettagsmontag",
                fr: "Lundi du Jeûne Fédéral",
                en: "Monday after Federal Day of Thanksgiving, Repentance and Prayer"
              }
            },
            "12-26": !1
          }
        },
        VS: {
          names: {
            fr: "Canton du Valais",
            de: "Kanton Wallis",
            it: "Canton Vallese",
            en: "Canton of Valais"
          },
          langs: [
            "fr",
            "de-ch",
            "de",
            "it"
          ],
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "Saint-Berthold"
              },
              type: "bank"
            },
            "03-19": {
              _name: "03-19"
            },
            "easter -2": !1,
            "easter 1": {
              _name: "easter 1",
              type: "optional"
            },
            "05-01 12:00": {
              _name: "05-01"
            },
            "easter 50": {
              _name: "easter 50"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "monday after 3rd sunday after 09-01": {
              name: {
                de: "Bettagsmontag",
                fr: "Lundi du Jeûne Fédéral",
                en: "Monday after Federal Day of Thanksgiving, Repentance and Prayer"
              },
              type: "bank"
            },
            "11-01": {
              _name: "11-01"
            },
            "12-08": {
              _name: "12-08"
            },
            "12-24 12:00": {
              _name: "12-24"
            },
            "12-26": {
              type: "optional"
            }
          }
        },
        NE: {
          names: {
            fr: "Canton de Neuchâtel",
            de: "Kanton Neuenburg",
            it: "Canton Neuchâtel",
            en: "Canton of Neuchâtel"
          },
          langs: [
            "fr",
            "de-ch",
            "de",
            "it"
          ],
          days: {
            "01-02 on monday": {
              name: {
                de: "Berchtoldstag",
                fr: "2 Janvier"
              }
            },
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "2 Janvier"
              },
              type: "observance"
            },
            "03-01": {
              name: {
                fr: "Instauration de la République",
                de: "Jahrestag Ausrufung der Republik"
              }
            },
            "easter -2": {
              _name: "easter -2"
            },
            "05-01": {
              _name: "05-01"
            },
            "easter 50": {
              _name: "easter 50",
              type: "observance"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "monday after 3rd sunday in September": {
              name: {
                de: "Bettagsmontag",
                fr: "Lundi du Jeûne Fédéral",
                en: "Monday after Federal Day of Thanksgiving, Repentance and Prayer"
              },
              type: "optional"
            },
            "12-26": {
              type: "observance"
            },
            "12-26 on monday": {
              _name: "12-26"
            }
          }
        },
        GE: {
          names: {
            fr: "Canton de Genève",
            de: "Kanton Genf",
            it: "Canton Ginevra",
            en: "Canton of Geneva"
          },
          langs: [
            "fr",
            "de-ch",
            "de",
            "it"
          ],
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "2 Janvier"
              },
              type: "bank"
            },
            "thursday after 1st sunday after 09-01": {
              name: {
                de: "Genfer Bettag",
                fr: "Jeûne Genevois"
              }
            },
            "12-26": {
              type: "bank"
            },
            "12-31": {
              name: {
                de: "Wiederherstellung der Republik",
                fr: "Restauration de la République",
                en: "Restoration of the Republic"
              }
            },
            "3rd sunday after 09-01": !1
          }
        },
        JU: {
          names: {
            fr: "Canton du Jura",
            de: "Kanton Jura",
            it: "Canton Giura",
            en: "Canton of Jura"
          },
          langs: [
            "fr",
            "de-ch",
            "de",
            "it"
          ],
          days: {
            "01-02": {
              name: {
                de: "Berchtoldstag",
                fr: "2 Janvier"
              }
            },
            "05-01": {
              _name: "05-01"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "06-23": {
              name: {
                fr: "Plébiscite jurassien",
                en: "Jura Plebiscite",
                de: "Fest der Unabhängigkeit"
              }
            },
            "08-15": {
              _name: "08-15"
            },
            "11-01": {
              _name: "11-01"
            },
            "12-26": !1
          }
        }
      }
    },
    CI: {
      names: {
        fr: "République de Côte d'Ivoire",
        en: "Republic of Côte d'Ivoire"
      },
      langs: [
        "fr",
        "en"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "08-07 since 1960": {
          _name: "Independence Day"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "11-15 since 1996": {
          name: {
            en: "National Peace Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "27 Ramadan": {
          _name: "27 Ramadan"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    CK: {
      names: {
        rar: "Kūki 'Āirani",
        en: "Cook Islands"
      },
      langs: [
        "en",
        "rar"
      ],
      zones: [
        "Pacific/Rarotonga"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-02 and if Saturday then next Monday if Monday, Sunday then next Tuesday": {
          substitute: !0,
          name: {
            en: "Day after New Year's Day"
          }
        },
        "04-25": {
          name: {
            en: "Anzac Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "1st Monday in June": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "1st Friday in July": {
          name: {
            en: "Ra o te Ui Ariki (House of Ariki)",
            rar: "Ra o te Ui Ariki"
          }
        },
        "08-04 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "Constitution Day"
        },
        "10-26 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "National Gospel Day"
          }
        },
        "12-25 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if Saturday then next Monday if Monday, Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-26"
        }
      },
      states: {
        Aitutaki: {
          names: {
            en: "Aitutaki"
          },
          days: {
            "10-26 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Aitutaki Gospel Day"
              }
            }
          }
        },
        Atiu: {
          names: {
            en: "Atiu"
          },
          days: {
            "07-19 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Atiu Gospel Day"
              }
            }
          }
        },
        Mangaia: {
          names: {
            en: "Mangaia"
          },
          days: {
            "06-15 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Mangaia Gospel Day"
              }
            }
          }
        },
        Manihiki: {
          names: {
            en: "Manihiki"
          },
          days: {
            "08-08 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Manihiki Gospel Day"
              }
            }
          }
        },
        Mitiaro: {
          names: {
            en: "Mitiaro"
          },
          days: {
            "07-21 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Mitiaro Gospel Day"
              }
            }
          }
        },
        Palmerston: {
          names: {
            en: "Palmerston"
          },
          days: {
            "05-25 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Palmerston Gospel Day"
              }
            }
          }
        },
        Penrhyn: {
          names: {
            en: "Penrhyn"
          },
          days: {
            "05-13 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Penrhyn Gospel Day"
              }
            }
          }
        },
        Pukapuka: {
          names: {
            en: "Pukapuka"
          },
          days: {
            "12-06 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Pukapuka Gospel Day"
              }
            }
          }
        },
        Rakahanga: {
          names: {
            en: "Rakahanga"
          },
          days: {
            "08-15 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Rakahanga Gospel Day"
              }
            }
          }
        },
        Rarotonga: {
          names: {
            en: "Rarotonga"
          },
          days: {
            "07-25 and if Saturday, Sunday then next Monday": {
              substitute: !0,
              name: {
                en: "Rarotonga Gospel Day"
              }
            }
          }
        }
      }
    },
    CL: {
      names: {
        es: "Chile",
        en: "Chile"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Santiago",
        "Pacific/Easter"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-02 on monday since 2017": {
          name: "Día adicional",
          active: [
            {
              from: 2017
            }
          ]
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-21": {
          name: {
            en: "Navy Day",
            es: "Día de las Glorias Navales"
          }
        },
        "06-21 since 2023": {
          name: {
            en: "Indigenous People's Day",
            es: "Día de los Pueblos Indígenas"
          }
        },
        "06-29 if tuesday, wednesday, thursday then previous monday if friday then next monday": {
          _name: "06-29"
        },
        "07-16": {
          name: {
            en: "Our Lady of Mount Carmel",
            es: "Virgen del Carmen"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "2022-09-16": {
          name: {
            es: "Fiestas Patrias",
            en: "National Holiday"
          }
        },
        "09-17 on friday, monday since 2017": {
          name: {
            en: "National holiday",
            es: "Feriado Adicional Fiestas Patrias"
          }
        },
        "09-18": {
          name: {
            en: "National holiday",
            es: "Fiestas Patrias"
          }
        },
        "09-19": {
          name: {
            en: "Army Day",
            es: "Día de las Glorias del Ejército"
          }
        },
        "09-20 on friday": {
          name: {
            es: "Feriado Adicional Fiestas Patrias",
            en: "National Holiday"
          }
        },
        "10-12 if tuesday, wednesday, thursday then previous monday if friday then next monday": {
          name: {
            en: "Columbus Day",
            es: "Encuentro de Dos Mundos"
          }
        },
        "10-31 if wednesday then next friday if tuesday then previous friday": {
          _name: "Reformation Day"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-08": {
          _name: "12-08"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-31": {
          _name: "12-31",
          type: "bank"
        }
      },
      states: {
        AP: {
          name: "Arica y Parinacota",
          days: {
            "06-07": {
              name: {
                en: "Battle of Arica",
                es: "Asalto y Toma del Morro de Arica"
              }
            }
          }
        },
        BI: {
          name: "Biobío",
          regions: {
            CH: {
              name: "Chillán y Chillán Viejo",
              days: {
                "08-20": {
                  name: {
                    en: "Nativity of Liberator Bernardo O'Higgins",
                    es: "Nacimiento del Prócer de la Independencia"
                  },
                  active: [
                    {
                      to: "2017-08-19"
                    }
                  ]
                }
              }
            }
          }
        },
        NU: {
          name: "Ñuble",
          regions: {
            CH: {
              name: "Chillán y Chillán Viejo",
              days: {
                "08-20": {
                  name: {
                    en: "Nativity of Liberator Bernardo O'Higgins",
                    es: "Nacimiento del Prócer de la Independencia"
                  },
                  active: [
                    {
                      from: "2017-08-19"
                    }
                  ]
                }
              }
            }
          }
        },
        TA: {
          name: "Tarapacá",
          days: {
            "08-10": {
              name: {
                en: "Saint Lawrence",
                es: "San Lorenzo de Tarapacá"
              },
              type: "observance",
              disable: [
                2015
              ]
            },
            "2015-08-10": {
              name: {
                en: "Saint Lawrence",
                es: "San Lorenzo de Tarapacá"
              }
            }
          }
        }
      }
    },
    CM: {
      names: {
        fr: "Cameroun",
        en: "Cameroon"
      },
      dayoff: "sunday",
      langs: [
        "fr",
        "en"
      ],
      zones: [
        "Africa/Lagos"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-11": {
          name: {
            fr: "Fête de la Jeunesse",
            en: "Youth Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "05-01 if sunday then next monday": {
          _name: "05-01"
        },
        "05-20": {
          name: {
            fr: "Fête nationale ou de l'unité",
            en: "National Day"
          }
        },
        "easter 39": {
          _name: "easter 39"
        },
        "08-15": {
          _name: "08-15"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    CN: {
      names: {
        en: "China",
        zh: "中华人民共和国"
      },
      dayoff: "sunday",
      langs: [
        "zh",
        "en"
      ],
      zones: [
        "Asia/Shanghai",
        "Asia/Urumqi"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-08 12:00": {
          _name: "03-08",
          note: "Women"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-04 12:00": {
          name: {
            en: "Youth Day",
            zh: "青年节"
          },
          note: "Youth from the age of 14 to 28"
        },
        "06-01": {
          name: {
            en: "Children's Day",
            zh: "六一儿童节"
          },
          note: "Children below the age of 14"
        },
        "08-01 12:00": {
          name: {
            en: "Army Day",
            zh: "建军节"
          },
          note: "Military personnel in active service"
        },
        "10-01": {
          name: {
            en: "National Day",
            zh: "国庆节"
          }
        },
        "10-02": {
          name: {
            en: "National Day",
            zh: "国庆节"
          }
        },
        "10-03": {
          name: {
            en: "National Day",
            zh: "国庆节"
          }
        },
        "chinese 01-0-00": {
          name: {
            en: "Spring Festival",
            zh: "春节"
          }
        },
        "chinese 01-0-01": {
          name: {
            en: "Spring Festival",
            zh: "春节"
          }
        },
        "chinese 01-0-02": {
          name: {
            en: "Spring Festival",
            zh: "春节"
          }
        },
        "chinese 5-01 solarterm": {
          name: {
            en: "Qingming Festival",
            zh: "清明节 清明節"
          }
        },
        "chinese 05-0-05": {
          name: {
            en: "Dragon Boat Festival",
            zh: "端午节"
          }
        },
        "chinese 08-0-15": {
          name: {
            en: "Mid-Autumn Festival",
            zh: "中秋节"
          }
        },
        "2021-01-02": {
          _name: "01-01"
        },
        "2021-01-03": {
          _name: "01-01"
        },
        "2021-02-14": {
          name: {
            en: "Spring Festival",
            zh: "春节"
          },
          note: "Work on Sun February 7 and Sat February 20."
        },
        "2021-02-15": {
          name: {
            en: "Spring Festival",
            zh: "春节"
          }
        },
        "2021-02-16": {
          name: {
            en: "Spring Festival",
            zh: "春节"
          }
        },
        "2021-02-17": {
          name: {
            en: "Spring Festival",
            zh: "春节"
          }
        },
        "2021-04-03": {
          name: {
            en: "Qingming Festival",
            zh: "清明节 清明節"
          }
        },
        "2021-04-05": {
          name: {
            en: "Qingming Festival",
            zh: "清明节 清明節"
          }
        },
        "2021-05-02": {
          _name: "05-01",
          note: "Work on Sun April 25 and Sat May 8."
        },
        "2021-05-03": {
          _name: "05-01"
        },
        "2021-05-04": {
          _name: "05-01"
        },
        "2021-05-05": {
          _name: "05-01"
        },
        "2021-06-12": {
          name: {
            en: "Dragon Boat Festival",
            zh: "端午节"
          }
        },
        "2021-06-13": {
          name: {
            en: "Dragon Boat Festival",
            zh: "端午节"
          }
        },
        "2021-09-19": {
          name: {
            en: "Mid-Autumn Festival",
            zh: "中秋节"
          },
          note: "Work on Sat September 18."
        },
        "2021-09-20": {
          name: {
            en: "Mid-Autumn Festival",
            zh: "中秋节"
          }
        },
        "2021-10-04": {
          name: {
            en: "National Day",
            zh: "国庆节"
          },
          note: "Work on Sun September 26 and Sat October 9."
        },
        "2021-10-05": {
          name: {
            en: "National Day",
            zh: "国庆节"
          }
        },
        "2021-10-06": {
          name: {
            en: "National Day",
            zh: "国庆节"
          }
        },
        "2021-10-07": {
          name: {
            en: "National Day",
            zh: "国庆节"
          }
        }
      }
    },
    CO: {
      names: {
        es: "Colombia",
        en: "Colombia"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Bogota"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "monday after 01-06": {
          _name: "01-06"
        },
        "monday after 03-19": {
          _name: "03-19"
        },
        "easter -7": {
          _name: "easter -7",
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 43": {
          _name: "easter 39"
        },
        "easter 64": {
          _name: "easter 60"
        },
        "easter 71": {
          name: {
            es: "Sagrado Corazón de Jesús",
            en: "Sacred Heart"
          }
        },
        "monday after 06-29": {
          _name: "06-29"
        },
        "07-20": {
          _name: "Independence Day"
        },
        "08-07": {
          name: {
            en: "Battle of Boyacá",
            es: "Batalla de Boyacá"
          }
        },
        "monday after 08-15": {
          _name: "08-15"
        },
        "monday after 10-12": {
          name: {
            es: "Día de la Raza",
            en: "Columbus Day"
          }
        },
        "1st monday in November": {
          _name: "11-01"
        },
        "monday after 11-11": {
          name: {
            es: "Independencia de Cartagena",
            en: "Independence of Cartagena"
          }
        },
        "12-08": {
          _name: "12-08"
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    CR: {
      names: {
        es: "Costa Rica",
        en: "Costa Rica"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Costa_Rica"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "04-11": {
          name: {
            es: "Gesta Heroica de Juan Santamaría"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "07-25": {
          name: {
            en: "Guanacaste Day",
            es: "Anexión del Partido de Nicoya"
          }
        },
        "08-02": {
          name: {
            en: "Our Lady of Los Ángeles",
            es: "Día de la Virgen de los Ángeles"
          }
        },
        "08-15": {
          _name: "Mothers Day"
        },
        "09-15": {
          _name: "Independence Day"
        },
        "10-12 if monday then previous friday": {
          name: {
            en: "Columbus Day",
            es: "Día de la Raza"
          }
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    CU: {
      names: {
        es: "Cuba",
        en: "Cuba"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Havana"
      ],
      days: {
        "01-01": {
          name: {
            es: "Triunfo de la Revolución",
            en: "Triumph of the Revolution"
          }
        },
        "01-02": {
          name: {
            es: "Día de Victoria de las Fuerzas Armadas",
            en: "Victory of Armed Forces Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "05-01": {
          _name: "05-01"
        },
        "07-25": {
          name: {
            es: "Conmemoración del asalto a Moncada",
            en: "Day before the Commemoration of the Assault of the Moncada garrison"
          }
        },
        "07-26": {
          name: {
            es: "Día de la Rebeldía Nacional",
            en: "Commemoration of the Assault of the Moncada garrison"
          }
        },
        "07-27": {
          name: {
            es: "Conmemoración del asalto a Moncada",
            en: "Day after the Commemoration of the Assault of the Moncada garrison"
          }
        },
        "10-10": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    CV: {
      names: {
        pt: "República de Cabo Verde",
        en: "Cape Verde"
      },
      langs: [
        "pt"
      ],
      zones: [
        "Atlantic/Cape_Verde"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-13": {
          name: {
            pt: "Dia da Democracia",
            en: "Democracy Day"
          }
        },
        "01-20": {
          name: {
            pt: "Dia dos Heróis Nacionais",
            en: "Heroes' Day"
          }
        },
        "easter -47": {
          _name: "easter -47"
        },
        "easter -46": {
          _name: "easter -46"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "06-01": {
          name: {
            pt: "Dia das Crianças",
            en: "Children's Day"
          }
        },
        "07-05": {
          _name: "Independence Day"
        },
        "08-15": {
          _name: "08-15",
          name: {
            pt: "Dia da Padroeira Nacional"
          }
        },
        "09-12": {
          name: {
            pt: "Dia Nacional",
            en: "National Day"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "12-25": {
          _name: "12-25"
        }
      },
      states: {
        S: {
          name: "Sotavento Islands",
          regions: {
            PR: {
              name: "Praia",
              days: {
                "05-19": {
                  name: {
                    pt: "Dia do Município da Praia"
                  }
                }
              }
            }
          }
        }
      }
    },
    CW: {
      names: {
        nl: "Curaçao",
        pap: "Kòrsou",
        en: "Curaçao"
      },
      langs: [
        "nl",
        "pap",
        "en"
      ],
      zones: [
        "America/Curacao"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -48": {
          _name: "easter -48",
          name: {
            en: "Carnival Monday"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-27": {
          name: {
            pap: "Aña di Rey",
            nl: "Koningsdag",
            en: "Kings Day"
          }
        },
        "05-01 if sunday then next monday": {
          _name: "05-01"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "1st sunday in June": {
          _name: "Fathers Day",
          type: "observance"
        },
        "easter 39": {
          _name: "easter 39",
          name: {
            nl: "Hemelvaartsdag"
          }
        },
        "07-02": {
          name: {
            nl: "Dag van het volkslied en de Vlag",
            pap: "Dia di Himno i Bandera",
            en: "Flag Day"
          }
        },
        "10-10": {
          name: {
            nl: "Dag van het land Curaçao",
            pap: "Pais Kòrsou",
            en: "Curaçao Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31 12:00": {
          _name: "12-31"
        }
      }
    },
    CX: {
      names: {
        en: "Christmas Island"
      },
      langs: [
        "en",
        "ms"
      ],
      zones: [
        "Indian/Christmas"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-26": {
          name: {
            en: "Australia Day"
          }
        },
        "chinese 01-0-01 P2D": {
          name: {
            en: "Chinese New Year",
            zh: "春节"
          }
        },
        "4th monday in March": {
          _name: "05-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "04-25": {
          name: {
            en: "Anzac Day"
          }
        },
        "1 Shawwal": {
          _name: "1 Shawwal",
          name: {
            ms: "Hari Raya Puasa"
          }
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          name: {
            ms: "Hari Raya Haji"
          }
        },
        "10-06": {
          name: {
            en: "Territory Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    CY: {
      names: {
        el: "Κύπρος",
        en: "Cyprus"
      },
      dayoff: "",
      langs: [
        "el"
      ],
      zones: [
        "Asia/Nicosia"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        "orthodox -48": {
          name: {
            el: "Καθαρά Δευτέρα",
            en: "Ash Sunday"
          },
          type: "observance"
        },
        "orthodox -47": {
          name: {
            el: "Καθαρά Δευτέρα",
            en: "Clean Monday"
          }
        },
        "03-25": {
          name: {
            el: "Ευαγγελισμός, Εθνική Εορτή",
            en: "Annunciation, Anniversary of 1821 Revolution"
          }
        },
        "04-01": {
          name: {
            en: "Cyprus National Day",
            el: "Κύπρος Εθνική Εορτή"
          }
        },
        "orthodox -2": {
          _name: "easter -2"
        },
        orthodox: {
          _name: "easter"
        },
        "orthodox 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "orthodox 49": {
          _name: "easter 49"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "08-15": {
          _name: "08-15"
        },
        "10-01": {
          name: {
            en: "Cyprus Independence Day",
            el: "Ημέρα της Ανεξαρτησίας Κύπρος"
          }
        },
        "10-28": {
          _name: "National Holiday",
          name: {
            el: "Επέτειος του Όχι"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    CZ: {
      names: {
        cz: "Česká republika",
        en: "Czech Republic"
      },
      langs: [
        "cz"
      ],
      zones: [
        "Europe/Prague"
      ],
      days: {
        "01-01": {
          _name: "01-01",
          name: {
            cz: "Nový rok a Den obnovy samostatného českého státu"
          }
        },
        "easter -4": {
          name: {
            cz: "Škaredá středa",
            en: "Ugly Wednesday"
          },
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1",
          type: "observance"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-08": {
          name: {
            cz: "Den vítězství",
            en: "Liberation Day"
          }
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "07-05": {
          name: {
            cz: "Den slovanských věrozvěstů Cyrila a Metoděje",
            en: "Saints Cyril and Methodius Day"
          }
        },
        "07-06": {
          name: {
            cz: "Den upálení mistra Jana Husa",
            en: "Jan Hus Day"
          }
        },
        "09-28": {
          name: {
            cz: "Den české státnosti",
            en: "St. Wenceslas Day (Czech Statehood Day)"
          }
        },
        "10-28": {
          name: {
            cz: "Den vzniku samostatného československého státu",
            en: "Independent Czechoslovak State Day"
          }
        },
        "11-17": {
          name: {
            cz: "Den boje za svobodu a demokracii",
            en: "Struggle for Freedom and Democracy Day"
          }
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    DE: {
      names: {
        de: "Deutschland",
        en: "Germany"
      },
      dayoff: "sunday",
      zones: [
        "Europe/Berlin"
      ],
      langs: [
        "de"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-14": {
          _name: "02-14",
          type: "observance"
        },
        "easter -52": {
          name: {
            de: "Weiberfastnacht",
            en: "Women's Carnival Day"
          },
          type: "observance"
        },
        "easter -48": {
          name: {
            de: "Rosenmontag",
            en: "Shrove Monday"
          },
          type: "observance"
        },
        "easter -47 14:00": {
          _name: "easter -47",
          type: "observance"
        },
        "easter -46": {
          _name: "easter -46",
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01",
          name: {
            de: "Maifeiertag"
          }
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "10-03": {
          _name: "National Holiday",
          name: {
            de: "Tag der Deutschen Einheit"
          }
        },
        "11-01": {
          _name: "11-01",
          type: "observance"
        },
        "11-02": {
          _name: "11-02",
          type: "observance"
        },
        "11-11": {
          _name: "11-11",
          type: "observance"
        },
        "wednesday before 11-23": {
          _name: "Buß- und Bettag",
          type: "observance"
        },
        "6th sunday before 12-25": {
          name: {
            de: "Volkstrauertag",
            en: "Memorial Day"
          },
          type: "observance"
        },
        "5th sunday before 12-25": {
          name: {
            de: "Totensonntag"
          },
          type: "observance"
        },
        "4th sunday before 12-25": {
          name: {
            de: "1. Advent"
          },
          type: "observance"
        },
        "3th sunday before 12-25": {
          name: {
            de: "2. Advent"
          },
          type: "observance"
        },
        "2nd sunday before 12-25": {
          name: {
            de: "3. Advent"
          },
          type: "observance"
        },
        "1st sunday before 12-25": {
          name: {
            de: "4. Advent"
          },
          type: "observance"
        },
        "12-24 14:00 if sunday then 00:00": {
          _name: "12-24",
          type: "bank"
        },
        "12-25": {
          _name: "12-25",
          name: {
            de: "1. Weihnachtstag"
          }
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31 14:00 if sunday then 00:00": {
          _name: "12-31",
          type: "bank"
        },
        "2017-10-31": {
          _name: "Reformation Day"
        }
      },
      states: {
        BB: {
          name: "Brandenburg",
          days: {
            easter: {
              _name: "easter"
            },
            "easter 49": {
              _name: "easter 49"
            },
            "10-31": {
              _name: "Reformation Day"
            }
          }
        },
        BE: {
          name: "Berlin",
          days: {
            "03-08": {
              _name: "03-08",
              active: [
                {
                  from: "2019-01-01T00:00:00.000Z"
                }
              ]
            },
            easter: {
              _name: "easter",
              type: "observance"
            },
            "easter 49": {
              _name: "easter 49",
              type: "observance"
            },
            "2020-05-08": {
              name: {
                de: "Tag der Befreiung (75. Jahrestag)",
                en: "Liberation Day (75th Anniversary)"
              }
            }
          }
        },
        BW: {
          name: "Baden-Württemberg",
          days: {
            "01-06": {
              _name: "01-06"
            },
            "easter -3": {
              _name: "easter -3",
              type: "school"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "10-31": {
              _name: "Reformation Day",
              type: "school"
            },
            "11-01": {
              _name: "11-01"
            }
          }
        },
        BY: {
          name: "Bayern",
          days: {
            "01-06": {
              _name: "01-06"
            },
            "02-02": {
              _name: "02-02",
              type: "observance"
            },
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "11-01": {
              _name: "11-01"
            },
            "wednesday before 11-23": {
              _name: "Buß- und Bettag",
              type: "school"
            }
          },
          regions: {
            A: {
              name: "Stadt Augsburg",
              days: {
                "08-08": {
                  name: {
                    de: "Augsburger Friedensfest",
                    en: "Augsburg Peace Festival"
                  }
                }
              }
            },
            EVANG: {
              names: {
                de: "Überwiegend evangelische Gemeinden",
                en: "Predominantly protestant communities"
              },
              days: {
                "08-15": {
                  _name: "08-15",
                  type: "school"
                }
              }
            }
          }
        },
        HB: {
          name: "Hansestadt Bremen",
          days: {
            "10-31": {
              _name: "Reformation Day",
              active: [
                {
                  from: "2018-01-01T00:00:00.000Z"
                }
              ]
            }
          }
        },
        HE: {
          name: "Hessen",
          days: {
            easter: {
              _name: "easter"
            },
            "easter 49": {
              _name: "easter 49"
            },
            "easter 60": {
              _name: "easter 60"
            }
          }
        },
        HH: {
          name: "Hansestadt Hamburg",
          days: {
            "10-31": {
              _name: "Reformation Day",
              active: [
                {
                  from: "2018-01-01T00:00:00.000Z"
                }
              ]
            }
          }
        },
        MV: {
          name: "Mecklenburg Vorpommern",
          days: {
            "03-08 since 2023": {
              _name: "03-08"
            },
            "10-31": {
              _name: "Reformation Day"
            }
          }
        },
        NI: {
          name: "Niedersachsen",
          days: {
            "10-31": {
              _name: "Reformation Day",
              active: [
                {
                  from: "2018-01-01T00:00:00.000Z"
                }
              ]
            }
          }
        },
        NW: {
          name: "Nordrhein-Westfalen",
          days: {
            "easter 60": {
              _name: "easter 60"
            },
            "11-01": {
              _name: "11-01"
            }
          }
        },
        RP: {
          name: "Rheinland-Pfalz",
          days: {
            "easter 60": {
              _name: "easter 60"
            },
            "11-01": {
              _name: "11-01"
            }
          }
        },
        SH: {
          name: "Schleswig-Holstein",
          days: {
            "10-31": {
              _name: "Reformation Day",
              active: [
                {
                  from: "2018-01-01T00:00:00.000Z"
                }
              ]
            }
          }
        },
        SL: {
          name: "Saarland",
          days: {
            "easter 60": {
              _name: "easter 60"
            },
            "08-15": {
              _name: "08-15"
            },
            "11-01": {
              _name: "11-01"
            }
          }
        },
        SN: {
          name: "Sachsen",
          days: {
            "easter 60": {
              _name: "easter 60",
              type: "observance"
            },
            "10-31": {
              _name: "Reformation Day"
            },
            "wednesday before 11-23": {
              _name: "Buß- und Bettag"
            }
          },
          regions: {
            BZ: {
              name: "Landkreis Bautzen",
              days: {
                "easter 60": {
                  _name: "easter 60",
                  type: "public",
                  note: "Bautzen (nur in den Ortsteilen Bolbritz und Salzenforst), Crostwitz, Göda (nur im Ortsteil Prischwitz), Großdubrau (nur im Ortsteil Sdier), Hoyerswerda (nur im Ortsteil Dörgenhausen), Königswartha (nicht im Ortsteil Wartha), Nebelschütz, Neschwitz (nur in den Ortsteilen Neschwitz und Saritsch), Panschwitz-Kuckau, Puschwitz, Räckelwitz, Radibor, Ralbitz-Rosenthal und Wittichenau."
                }
              }
            }
          }
        },
        ST: {
          name: "Sachsen-Anhalt",
          days: {
            "01-06": {
              _name: "01-06"
            },
            "10-31": {
              _name: "Reformation Day"
            }
          }
        },
        TH: {
          name: "Thüringen",
          days: {
            "easter 60": {
              _name: "easter 60",
              type: "observance"
            },
            "09-20": {
              name: {
                de: "Weltkindertag",
                en: "International Children's Day"
              },
              active: [
                {
                  from: 2019
                }
              ]
            },
            "10-31": {
              _name: "Reformation Day"
            }
          },
          regions: {
            EIC: {
              name: "Landkreis Eichfeld",
              days: {
                "easter 60": {
                  _name: "easter 60",
                  type: "public"
                }
              }
            },
            UH: {
              name: "Unstrut-Hainich-Kreis",
              days: {
                "easter 60": {
                  _name: "easter 60",
                  type: "public",
                  note: "In Anrode (nur in den Ortsteilen Bickenriede und Zella), Dünwald (nur in den Ortsteilen Beberstedt und Hüpstedt), Rodeberg (nur im Ortsteil Struth), Südeichsfeld"
                }
              }
            },
            WAK: {
              name: "Wartburgkreis",
              days: {
                "easter 60": {
                  _name: "easter 60",
                  type: "public",
                  note: "In Brunnhartshausen (nur in den Ortsteilen Föhlritz und Steinberg), Buttlar, Geisa, Schleid, Zella/Rhön"
                }
              }
            }
          }
        }
      }
    },
    DJ: {
      names: {
        fr: "République de Djibouti",
        ar: "جمهورية جيبوتي",
        so: "Jamhuuriyadda Jabuuti",
        aa: "Gabuutih Ummuuno",
        en: "Djibouti"
      },
      langs: [
        "fr",
        "ar",
        "en"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "05-01": {
          _name: "05-01"
        },
        "06-27 since 1977": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "27 Rajab": {
          _name: "27 Rajab"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "9 Dhu al-Hijjah": {
          _name: "9 Dhu al-Hijjah"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    DK: {
      names: {
        da: "Danmark",
        en: "Denmark"
      },
      langs: [
        "da"
      ],
      zones: [
        "Europe/Copenhagen"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -48": {
          name: {
            da: "Fastelavn"
          },
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 26 prior to 2024": {
          name: {
            da: "Store Bededag",
            en: "Prayer Day",
            de: "Buß- und Bettag"
          }
        },
        "easter 39": {
          _name: "easter 39"
        },
        "05-01": {
          _name: "05-01",
          type: "observance",
          note: "Full holiday for blue collar workers"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "06-05": {
          _name: "Constitution Day",
          type: "observance",
          note: "Shops are closed"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "12-24": {
          _name: "12-24",
          type: "observance",
          note: "Shops are closed"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    DM: {
      names: {
        en: "Dominica"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if sunday then next monday": {
          _name: "01-01",
          substitute: !0
        },
        "easter -48": {
          _name: "easter -48",
          name: {
            en: "Carnival Monday"
          }
        },
        "easter -47": {
          _name: "easter -47",
          name: {
            en: "Carnival Tuesday"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "1st monday in August": {
          name: {
            en: "Emancipation Day"
          }
        },
        "11-03 if sunday then next monday": {
          _name: "Independence Day"
        },
        "11-04 if sunday then next monday if monday then next tuesday": {
          name: {
            en: "National Day of Community Service"
          }
        },
        "12-25 and if sunday then next tuesday": {
          _name: "12-25",
          substitute: !0
        },
        "12-26 and if sunday then next monday": {
          _name: "12-26",
          substitute: !0
        }
      }
    },
    DO: {
      names: {
        es: "República Dominicana",
        en: "Dominican Republic"
      },
      dayoff: "sunday",
      zones: [
        "America/Santo_Domingo"
      ],
      langs: [
        "es"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
          _name: "01-06"
        },
        "01-21": {
          name: {
            es: "Nuestra Señora de la Altagracia",
            en: "Our Lady of Altagracia"
          }
        },
        "01-26 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
          name: {
            es: "Día de Duarte",
            en: "Duarte's Birthday"
          }
        },
        "02-27": {
          _name: "Independence Day"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "05-01 if tuesday,wednesday then previous monday if thursday,friday,sunday then next monday": {
          _name: "05-01"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "08-16": {
          name: {
            es: "Día de la Restauración",
            en: "Restoration Day"
          }
        },
        "09-24": {
          name: {
            es: "Nuestra Señora de las Mercedes",
            en: "Our Lady of las Mercedes"
          }
        },
        "11-06 if tuesday,wednesday,thursday,friday,saturday then next monday": {
          _name: "Constitution Day"
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    DZ: {
      names: {
        ar: "الجمهورية الجزائرية الديمقراطية الشعبية",
        fr: "République algérienne démocratique et populaire",
        en: "Algeria"
      },
      langs: [
        "ar",
        "fr",
        "en"
      ],
      zones: [
        "Africa/Algiers"
      ],
      dayoff: "saturday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-12": {
          name: {
            ar: "رأس السنة الأمازيغية",
            fr: "Nouvel an amazigh",
            en: "Amazigh New Year"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "07-05": {
          _name: "Independence Day"
        },
        "11-01": {
          _name: "Revolution Day"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "10 Muharram": {
          _name: "10 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    EC: {
      names: {
        es: "Ecuador",
        en: "Ecuador"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Guayaquil",
        "Pacific/Galapagos"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -48": {
          name: {
            en: "Carnival",
            es: "Carnaval"
          }
        },
        "easter -47": {
          _name: "easter -47"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-24": {
          name: {
            en: "The Battle of Pichincha",
            es: "Batalla del Pichincha"
          }
        },
        "07-24": {
          name: {
            en: "The Birthday of Simón Bolívar",
            es: "El Natalicio de Simón Bolívar"
          },
          type: "observance"
        },
        "08-10": {
          name: {
            en: "Declaration of Independence of Quito",
            es: "Día del Primer Grito de Independencia de Quito"
          }
        },
        "09-10": {
          name: {
            en: "Independence of Guayaquil",
            es: "Independencia de Guayaquil"
          }
        },
        "10-31": {
          name: {
            en: "Flag Day",
            es: "Dia de La Bandera"
          },
          type: "observance"
        },
        "11-02": {
          _name: "11-02"
        },
        "11-03": {
          name: {
            en: "Independence of Cuenca",
            es: "Independencia de Cuenca"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-31": {
          _name: "12-31",
          type: "observance"
        }
      },
      states: {
        P: {
          name: "Pichincha",
          regions: {
            QU: {
              name: "Quito",
              days: {
                "12-06": {
                  name: {
                    en: "Foundation of Quito",
                    es: "Aniversario de la fundación de Quito"
                  },
                  type: "observance"
                }
              }
            }
          }
        }
      }
    },
    EE: {
      names: {
        et: "Eesti",
        en: "Estonia"
      },
      dayoff: "sunday",
      langs: [
        "et"
      ],
      zones: [
        "Europe/Tallinn"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06",
          type: "observance"
        },
        "02-02": {
          name: {
            et: "Tartu rahulepingu aastapäev",
            en: "Anniversary of the Tartu Peace Treaty"
          },
          type: "observance"
        },
        "02-24": {
          _name: "Independence Day",
          type: "public"
        },
        "03-14": {
          name: {
            et: "emakeelepäev",
            en: "Native Language Day"
          },
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "05-01": {
          _name: "05-01"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "06-04": {
          name: {
            et: "Eesti lipu päev",
            en: "National Flag Day"
          },
          type: "observance"
        },
        "06-14": {
          name: {
            et: "leinapäev",
            en: "Day of Mourning and Commemoration"
          },
          type: "observance"
        },
        "06-23": {
          name: {
            et: "võidupüha",
            en: "Victory Day"
          }
        },
        "06-24": {
          name: {
            et: "jaanipäev",
            en: "Midsummer Day"
          }
        },
        "08-20": {
          name: {
            et: "taasiseseisvumispäev",
            en: "Day of Restoration of Independence"
          }
        },
        "08-23": {
          name: {
            et: "kommunismi ja natsismi ohvrite mälestuspäev",
            en: "European Day of Remembrance for Victims of Stalinism and Nazism"
          },
          type: "observance"
        },
        "2nd sunday in September": {
          name: {
            et: "vanavanemate päev",
            en: "Grandparents Day"
          },
          type: "observance"
        },
        "09-22": {
          name: {
            et: "vastupanuvõitluse päev",
            en: "Resistance Fighting Day"
          },
          type: "observance"
        },
        "11-02": {
          _name: "11-02",
          type: "observance"
        },
        "2nd sunday in November": {
          _name: "Fathers Day",
          type: "observance"
        },
        "11-16": {
          name: {
            et: "taassünni päev",
            en: "Day of Declaration of Sovereignty"
          },
          type: "observance"
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    EG: {
      names: {
        ar: "جمهورية مصر العربية",
        en: "Egypt"
      },
      langs: [
        "ar",
        "en"
      ],
      zones: [
        "Africa/Cairo"
      ],
      dayoff: "saturday",
      days: {
        "01-25 since 2011": {
          name: {
            ar: "عيد ثورة 25 يناير",
            en: "Revolution Day 2011"
          }
        },
        "01-25": {
          name: {
            ar: "عيد الشرطة",
            en: "National Police Day"
          }
        },
        "04-25": {
          name: {
            ar: "عيد تحرير سيناء",
            en: "Sinai Liberation Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "06-30": {
          name: {
            ar: "عيد ثورة 30 يونيو",
            en: "30 June Day"
          }
        },
        "07-23": {
          _name: "Revolution Day"
        },
        "10-06": {
          name: {
            ar: "عيد القوات المسلحة",
            en: "Armed Forces Day"
          }
        },
        "orthodox 1": {
          name: {
            ar: "شم النسيم",
            en: "Sham El Nessim"
          }
        },
        "julian 12-25": {
          _name: "12-25"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal P3D": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah P4D": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    EH: {
      names: {
        ar: "الجمهورية العربية الصحراوية الديمقراطية",
        en: "Western Sahara"
      },
      langs: [],
      zones: [
        "Africa/El_Aaiun"
      ],
      dayoff: "",
      days: {
        "02-27": {
          _name: "Independence Day"
        },
        "03-08": {
          name: {
            en: "First Martyr"
          }
        },
        "05-10": {
          name: {
            en: "May 20 Revolution"
          }
        },
        "06-09": {
          name: {
            en: "Day of the Martyrs"
          }
        },
        "06-17": {
          name: {
            en: "Day of National Unity"
          }
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal P2D": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah P2D": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    ER: {
      names: {
        en: "Eritrea"
      },
      langs: [
        "ti",
        "en"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "julian 12-25": {
          _name: "julian 12-25"
        },
        "julian 01-06": {
          _name: "01-06"
        },
        "02-10": {
          name: {
            ti: "ፈንቅል",
            en: "Fenkil Day"
          }
        },
        "03-08": {
          _name: "03-08"
        },
        "orthodox -2": {
          _name: "orthodox -2"
        },
        orthodox: {
          _name: "orthodox"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-24": {
          _name: "Independence Day"
        },
        "06-20": {
          name: {
            en: "Martyrs' Day",
            ti: "መዓልቲ ስውኣት"
          }
        },
        "09-01": {
          _name: "Revolution Day"
        },
        "09-11 in non-leap years": {
          name: {
            en: "Geez New Year",
            ti: "ግዕዝ አዲስ ዓመት"
          }
        },
        "09-12 in leap years": {
          name: {
            en: "Geez New Year",
            ti: "ግዕዝ አዲስ ዓመት"
          }
        },
        "09-27 in non-leap years": {
          name: {
            en: "Meskel"
          }
        },
        "09-28 in leap years": {
          name: {
            en: "Meskel"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    ES: {
      names: {
        es: "España",
        ca: "Espanya",
        en: "Spain"
      },
      langs: [
        "es"
      ],
      zones: [
        "Europe/Madrid",
        "Africa/Ceuta",
        "Atlantic/Canary"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if sunday then next monday": {
          type: "observance",
          substitute: !0,
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        "substitutes 01-06 if sunday then next monday": {
          type: "observance",
          substitute: !0,
          _name: "01-06"
        },
        "03-19": {
          _name: "03-19",
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "1st sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "07-25": {
          name: {
            es: "Santiago Apostol"
          },
          type: "observance",
          note: "regional"
        },
        "08-15": {
          _name: "08-15"
        },
        "10-12": {
          name: {
            es: "Fiesta Nacional de España"
          }
        },
        "substitutes 10-12 if sunday then next monday": {
          substitute: !0,
          type: "observance",
          name: {
            es: "Fiesta Nacional de España"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "substitutes 11-01 if sunday then next monday": {
          substitute: !0,
          type: "observance",
          _name: "11-01"
        },
        "12-06": {
          name: {
            es: "Día de la Constitución Española"
          }
        },
        "substitutes 12-06 if sunday then next monday": {
          type: "observance",
          substitute: !0,
          name: {
            es: "Día de la Constitución Española"
          }
        },
        "12-08": {
          _name: "12-08"
        },
        "substitutes 12-08 if sunday then next monday": {
          type: "observance",
          substitute: !0,
          _name: "12-08"
        },
        "12-25": {
          _name: "12-25"
        },
        "substitutes 12-25 if sunday then next monday": {
          substitute: !0,
          _name: "12-25"
        }
      },
      states: {
        AN: {
          name: "Andalucía",
          days: {
            "02-28": {
              name: {
                es: "Día de Andalucía"
              }
            },
            "substitutes 02-28 if Sunday then next Monday": {
              substitute: !0,
              name: {
                es: "Día de Andalucía"
              }
            },
            "substitutes 05-01 if Sunday then next Monday": {
              substitute: !0,
              _name: "05-01"
            },
            "substitutes 08-15 if Sunday then next Monday": {
              substitute: !0,
              _name: "08-15"
            },
            "easter -3": {
              _name: "easter -3"
            }
          }
        },
        AR: {
          name: "Aragón",
          days: {
            "04-23": {
              name: {
                es: "Día de Aragón"
              }
            },
            "substitutes 04-23 if Sunday then next Monday": {
              substitute: !0,
              name: {
                es: "Día de Aragón"
              }
            },
            "substitutes 05-01 if Sunday then next Monday": {
              substitute: !0,
              _name: "05-01"
            },
            "substitutes 08-15 if Sunday then next Monday": {
              substitute: !0,
              _name: "08-15"
            }
          }
        },
        AS: {
          name: "Asturias",
          days: {
            "substitutes 05-01 if Sunday then next Monday": {
              substitute: !0,
              _name: "05-01"
            },
            "substitutes 08-15 if Sunday then next Monday": {
              substitute: !0,
              _name: "08-15"
            },
            "09-08": {
              name: "Día de Asturias"
            },
            "substitutes 09-08 if Sunday then next Monday": {
              substitute: !0,
              name: "Día de Asturias"
            }
          }
        },
        CB: {
          name: "Cantabria",
          days: {
            "06-28": {
              name: "Día de las Instituciones de Cantabria"
            },
            "substitutes 06-28 if Sunday then next Monday": {
              name: "Día de las Instituciones de Cantabria"
            },
            "09-15": {
              name: "La Bien Aparecida"
            },
            "substitutes 09-15 if Sunday then next Monday": {
              name: "La Bien Aparecida"
            }
          }
        },
        CE: {
          name: "Ciudad de Ceuta",
          days: {
            "08-05": {
              name: "Nuestra Señora de África"
            },
            "substitutes 08-05 if Sunday then next Monday": {
              substitute: !0,
              name: "Nuestra Señora de África"
            },
            "09-02": {
              name: "Día de Ceuta"
            },
            "substitutes 09-02 if Sunday then next Monday": {
              substitute: !0,
              name: "Día de Ceuta"
            },
            "9 Dhu al-Hijjah": {
              _name: "9 Dhu al-Hijjah"
            }
          }
        },
        CL: {
          names: {
            es: "Castilla y León",
            en: "Castile and León"
          },
          days: {
            "04-23": {
              name: "Fiesta de Castilla y León"
            },
            "substitutes 04-23 if Sunday then next Monday": {
              substitute: !0,
              name: "Fiesta de Castilla y León"
            },
            "substitutes 05-01 if Sunday then next Monday": {
              substitute: !0,
              _name: "05-01"
            },
            "substitutes 08-15 if Sunday then next Monday": {
              substitute: !0,
              _name: "08-15"
            }
          }
        },
        CM: {
          name: "Castile-La Mancha",
          days: {
            "05-31 since 2020": {
              name: "Día de Castilla-La Mancha"
            },
            "substitutes 05-31 if Sunday then next Monday since 2020": {
              substitute: !0,
              name: "Día de Castilla-La Mancha"
            },
            "easter 60": {
              _name: "easter 60"
            }
          }
        },
        CN: {
          names: {
            es: "Islas Canarias",
            en: "Canary Islands"
          },
          zones: [
            "Atlantic/Canary"
          ],
          dayoff: "sunday",
          _days: "IC",
          regions: {
            EH: {
              names: {
                es: "El Hierro"
              },
              _days: [
                "IC",
                "regions",
                "EH"
              ]
            },
            FU: {
              names: {
                es: "Fuerteventura"
              },
              _days: [
                "IC",
                "regions",
                "FU"
              ]
            },
            GC: {
              names: {
                es: "Gran Canaria"
              },
              _days: [
                "IC",
                "regions",
                "GC"
              ]
            },
            LG: {
              names: {
                es: "La Gomera"
              },
              _days: [
                "IC",
                "regions",
                "LG"
              ]
            },
            LP: {
              names: {
                es: "La Palma"
              },
              _days: [
                "IC",
                "regions",
                "LP"
              ]
            },
            LA: {
              names: {
                es: "Lanzarote"
              },
              _days: [
                "IC",
                "regions",
                "LA"
              ]
            },
            TE: {
              names: {
                es: "Tenerife"
              },
              _days: [
                "IC",
                "regions",
                "TE"
              ]
            }
          }
        },
        CT: {
          names: {
            ca: "Catalunya",
            es: "Cataluña",
            en: "Catalonia"
          },
          days: {
            "09-11": {
              name: {
                ca: "Diada de Catalunya",
                es: "Dia de Cataluña"
              }
            },
            "06-24": {
              name: {
                ca: "Sant Joan",
                es: "San Juan"
              }
            },
            "easter -3": {
              _name: "easter -3",
              type: "observance"
            },
            "easter 1": {
              _name: "easter 1"
            },
            "easter 50": {
              _name: "easter 50"
            },
            "substitutes 05-01 if Saturday, Sunday then next Monday": {
              substitute: !0,
              _name: "05-01"
            },
            "09-24 if sunday then next monday": {
              name: {
                es: "Mare de Déu de la Mercè"
              }
            },
            "12-26": {
              name: {
                ca: "Sant Esteve",
                es: "San Esteban"
              },
              type: "observance"
            }
          }
        },
        EX: {
          name: "Extremadura",
          days: {
            "substitutes 05-01 if Sunday then next Monday": {
              substitute: !0,
              _name: "05-01"
            },
            "09-08": {
              name: "Día de Extremadura"
            },
            "substitutes 09-08 if Sunday then next Monday": {
              substitute: !0,
              name: "Día de Extremadura"
            }
          }
        },
        GA: {
          name: "Galicia",
          days: {
            "05-17": {
              name: "Día de las Letras Gallegas"
            },
            "substitutes 05-17 if Sunday then next Monday": {
              substitute: !0,
              name: "Día de las Letras Gallegas"
            },
            "07-25": {
              name: "Día Nacional de Galicia"
            },
            "substitutes 07-25 if Sunday then next Monday": {
              substitute: !0,
              name: "Día Nacional de Galicia"
            }
          }
        },
        IB: {
          names: {
            es: "Illes Balears",
            en: "Balearic Islands"
          },
          days: {
            "03-01": {
              name: {
                es: "Día de les Illes Balears"
              }
            },
            "substitutes 03-01 if Sunday then next Monday": {
              substitute: !0,
              name: {
                es: "Día de les Illes Balears"
              }
            },
            "easter 1": {
              _name: "easter 1"
            },
            "12-26": {
              name: {
                es: "Sant Esteve"
              },
              type: "observance"
            }
          }
        },
        MC: {
          name: "Murcia Region",
          days: {
            "substitutes 05-01 if Sunday then next Monday": {
              substitute: !0,
              _name: "05-01"
            }
          }
        },
        MD: {
          name: "Comunidad de Madrid",
          days: {
            "05-02 if Sunday then next Monday": {
              name: {
                es: "Día de la Comunidad de Madrid"
              }
            },
            "substitutes 05-02 if Sunday then next Monday": {
              substitute: !0,
              name: {
                es: "Día de la Comunidad de Madrid"
              }
            },
            "05-16": {
              name: {
                es: "San Isidro Labrador"
              },
              type: "observance"
            },
            "07-25": {
              name: "Santiago Apóstol"
            },
            "substitutes 07-25 if Sunday then next Monday": {
              substitute: !0,
              name: "Santiago Apóstol"
            },
            "11-09 if sunday then next monday": {
              name: {
                es: "Nuestra Señora de la Almudena"
              },
              type: "observance"
            }
          }
        },
        ML: {
          name: "Ciudad de Melilla",
          days: {
            "1 Shawwal": {
              _name: "1 Shawwal"
            },
            "10 Dhu al-Hijjah": {
              _name: "10 Dhu al-Hijjah"
            }
          }
        },
        NC: {
          names: {
            es: "Comunidad Foral de Navarra",
            en: "Navarra Chartered Community"
          },
          days: {
            "easter 1": {
              _name: "easter 1"
            },
            "07-25": {
              name: "Santiago Apóstol"
            },
            "substitutes 07-25 if Sunday then next Monday": {
              substitute: !0,
              name: "Santiago Apóstol"
            }
          }
        },
        PV: {
          names: {
            es: "País Vasco",
            en: "Basque Country"
          },
          days: {
            "easter 1": {
              _name: "easter 1"
            },
            "07-25": {
              name: "Santiago Apóstol"
            },
            "substitutes 07-25 if Sunday then next Monday": {
              substitute: !0,
              name: "Santiago Apóstol"
            },
            "2022-09-06": {
              name: "V Centenario Vuelta al Mundo"
            }
          }
        },
        RI: {
          name: "La Rioja",
          days: {
            "easter 1": {
              _name: "easter 1"
            }
          }
        },
        VC: {
          names: {
            es: "Comunitat Valenciana",
            en: "Valencian Community"
          },
          days: {
            "03-19": {
              _name: "03-19"
            },
            "easter 1": {
              _name: "easter 1"
            }
          }
        }
      }
    },
    ET: {
      names: {
        am: "ኢትዮጵያ",
        en: "Ethiopia"
      },
      dayoff: "sunday",
      langs: [
        "am",
        "en"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      days: {
        "01-06 in non-leap years": {
          _name: "12-25"
        },
        "01-07 in leap years": {
          _name: "12-25"
        },
        "01-19": {
          _name: "01-06"
        },
        "03-02": {
          name: {
            am: "የዓድዋ ድል በዓል",
            en: "Victory at Adwa Day"
          }
        },
        "03-28": {
          name: {
            am: "የቀይ ሽብር መታሰቢያ ቀን",
            en: "Day of Lament"
          }
        },
        "orthodox -2": {
          _name: "easter -2"
        },
        orthodox: {
          _name: "easter"
        },
        "05-28": {
          name: {
            am: "ደርግ የወደቀበት ቀን",
            en: "Derg Downfall Day"
          }
        },
        "09-11 in non-leap years": {
          _name: "01-01"
        },
        "09-12 in leap years": {
          _name: "01-01"
        },
        "09-27 in non-leap years": {
          name: {
            am: "ብርሐነ-መስቀል",
            en: "Finding of the True Cross"
          }
        },
        "09-28 in leap years": {
          name: {
            am: "ብርሐነ-መስቀል",
            en: "Finding of the True Cross"
          }
        },
        "1 Ramadan": {
          _name: "1 Ramadan"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    FI: {
      names: {
        fi: "Suomi",
        en: "Finland"
      },
      dayoff: "sunday",
      langs: [
        "fi"
      ],
      zones: [
        "Europe/Helsinki"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "friday after 06-19": {
          name: {
            fi: "Juhannusaatto",
            en: "Midsummer Eve",
            sv: "Midsommarafton"
          },
          type: "bank"
        },
        "saturday after 06-20": {
          name: {
            fi: "Juhannuspäivä",
            en: "Midsummer Day",
            sv: "Midsommardagen"
          }
        },
        "saturday after 10-31": {
          _name: "11-01"
        },
        "2nd sunday in November": {
          _name: "Fathers Day",
          type: "observance"
        },
        "12-06": {
          _name: "Independence Day"
        },
        "12-24": {
          _name: "12-24",
          type: "bank"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31": {
          _name: "12-31",
          type: "bank"
        }
      }
    },
    FJ: {
      names: {
        fj: "Matanitu Tugalala o Viti",
        en: "Fiji"
      },
      langs: [
        "fj",
        "en"
      ],
      zones: [
        "Pacific/Fiji"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "09-07": {
          _name: "Constitution Day"
        },
        "10-10 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Fiji Day"
          }
        },
        "12-25 if Sunday then next Monday": {
          _name: "12-25"
        },
        "12-26 if Sunday then next Monday if Monday then next Tuesday": {
          _name: "12-26"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "2014-10-22": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2015-11-10": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2016-10-29": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2017-10-19": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2018-11-07": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2019-10-27": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2019-10-28": {
          substitute: !0,
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2020-11-14": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2020-11-16": {
          substitute: !0,
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2021-11-04": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2022-10-24": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2023-11-12": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2023-11-13": {
          substitute: !0,
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2024-11-01": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        },
        "2025-10-21": {
          _name: "Deepavali",
          name: {
            en: "Diwali"
          }
        }
      }
    },
    FO: {
      names: {
        fo: "Føroyar",
        da: "Færøerne",
        en: "Faroe Islands"
      },
      langs: [
        "fo",
        "da"
      ],
      zones: [
        "Atlantic/Faroe"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-24": {
          name: {
            fo: "Flaggdagur",
            da: "Flagdag",
            en: "Flag Day"
          }
        },
        "easter 26": {
          name: {
            fo: "Dýri biðidagur",
            en: "Great Prayer Day"
          }
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "06-05 12:00 if sunday then 00:00": {
          _name: "Constitution Day"
        },
        "07-28 12:00 if sunday then 00:00": {
          name: {
            da: "Sankt Olavsaften",
            en: "St.Olav's Eve"
          },
          note: "half-day holiday for some workers' unions",
          type: "observance"
        },
        "07-29": {
          name: {
            fo: "Ólavsøka",
            da: "Sankt Olavs Dag",
            en: "St.Olav's Day"
          },
          note: "full holiday for most workers' unions",
          type: "observance"
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31 12:00 if sunday then 00:00": {
          _name: "12-31"
        }
      }
    },
    FR: {
      names: {
        fr: "France",
        en: "France"
      },
      dayoff: "sunday",
      zones: [
        "Europe/Paris"
      ],
      langs: [
        "fr"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-08": {
          name: {
            fr: "Fête de la Victoire 1945",
            en: "Victory Day"
          }
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "sunday before 06-01": {
          _name: "Mothers Day",
          type: "observance"
        },
        "07-14": {
          name: {
            fr: "Fête Nationale de la France",
            en: "Bastille Day"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "11-11": {
          name: {
            fr: "Armistice 1918",
            en: "Armistice Day"
          }
        },
        "12-25": {
          _name: "12-25"
        }
      },
      states: {
        57: {
          name: "Département Moselle",
          days: {
            "easter -2": {
              _name: "easter -2"
            },
            "12-26": {
              _name: "12-26"
            }
          }
        },
        67: {
          name: "Département Bas-Rhin",
          days: {
            "easter -2": {
              _name: "easter -2"
            },
            "12-26": {
              _name: "12-26"
            }
          }
        },
        68: {
          name: "Département Haut-Rhin",
          days: {
            "easter -2": {
              _name: "easter -2"
            },
            "12-26": {
              _name: "12-26"
            }
          }
        },
        YT: {
          name: "Département et région d'outre-mer Mayotte",
          zones: [
            "Africa/Nairobi"
          ],
          _days: "YT"
        },
        MQ: {
          name: "Département et région d'outre-mer Martinique",
          zones: [
            "America/Martinique"
          ],
          _days: "MQ"
        },
        GP: {
          name: "Département et région d'outre-mer Guadeloupe",
          zones: [
            "America/Port_of_Spain"
          ],
          _days: "GP"
        },
        GF: {
          name: "Département et région d'outre-mer Guyane",
          zones: [
            "America/Cayenne"
          ],
          _days: "GF"
        },
        RE: {
          name: "Département et région d'outre-mer La Réunion",
          zones: [
            "Indian/Reunion"
          ],
          _days: "RE"
        },
        MF: {
          name: "Département et région d'outre-mer Saint Martin",
          zones: [
            "America/Marigot"
          ],
          _days: "MF"
        },
        BL: {
          name: "Département et région d'outre-mer Saint Barthélemy",
          zones: [
            "America/St_Barthelemy"
          ],
          _days: "BL"
        }
      }
    },
    GA: {
      names: {
        fr: "Gabon",
        en: "Gabon"
      },
      dayoff: "sunday",
      langs: [
        "fr"
      ],
      zones: [
        "Africa/Lagos"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-17": {
          name: {
            fr: "Journée des droits de la femme",
            en: "Women's Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "08-15": {
          _name: "08-15"
        },
        "08-16 P2D": {
          _name: "Independence Day"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    GB: {
      names: {
        en: "United Kingdom"
      },
      dayoff: "sunday",
      zones: [
        "Europe/London"
      ],
      langs: [
        "en"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "substitutes 01-01 if saturday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "easter -21": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "1st monday in May": {
          name: {
            en: "Early May bank holiday"
          },
          disable: [
            "2020-05-04"
          ]
        },
        "1st monday before 06-01": {
          name: {
            en: "Spring bank holiday"
          },
          disable: [
            "2022-05-30"
          ],
          enable: [
            "2022-06-02"
          ]
        },
        "12-25": {
          _name: "12-25"
        },
        "substitutes 12-25 if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "substitutes 12-26 if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "12-26"
        },
        "2012-06-05": {
          name: {
            en: "Queen’s Diamond Jubilee"
          }
        },
        "2020-05-08": {
          name: {
            en: "Early May bank holiday (VE day)"
          }
        },
        "2022-06-03": {
          name: {
            en: "Queen’s Platinum Jubilee"
          }
        },
        "2022-09-19": {
          name: {
            en: "Queen Elizabeth's Funeral Day"
          }
        },
        "2023-05-08": {
          name: {
            en: "King Charles III's Coronation"
          }
        },
        "3rd sunday in June": {
          _name: "Fathers Day",
          type: "observance"
        }
      },
      states: {
        ALD: {
          name: "Alderney",
          zones: [
            "Europe/Guernsey"
          ],
          days: {
            "12-15": {
              name: {
                en: "Homecoming Day"
              }
            }
          }
        },
        ENG: {
          name: "England",
          days: {
            "1st monday before 09-01": {
              name: {
                en: "Summer bank holiday"
              }
            }
          }
        },
        NIR: {
          name: "Northern Ireland",
          zones: [
            "Europe/Belfast"
          ],
          days: {
            "03-17": {
              name: {
                en: "St Patrick's Day"
              }
            },
            "substitutes 03-17 if saturday then next monday": {
              substitute: !0,
              name: {
                en: "St Patrick's Day"
              }
            },
            "substitutes 03-17 if sunday then next monday": {
              substitute: !0,
              name: {
                en: "St Patrick's Day"
              }
            },
            "07-12": {
              name: {
                en: "Battle of the Boyne, Orangemen’s Day"
              }
            },
            "substitutes 07-12 if saturday then next monday": {
              substitute: !0,
              name: {
                en: "Battle of the Boyne"
              }
            },
            "substitutes 07-12 if sunday then next monday": {
              substitute: !0,
              name: {
                en: "Battle of the Boyne"
              }
            },
            "1st monday before 09-01": {
              name: {
                en: "Summer bank holiday"
              }
            }
          }
        },
        SCT: {
          name: "Scotland",
          days: {
            "substitutes 01-01 if sunday then next monday": !1,
            "substitutes 01-01 if saturday then next monday": !1,
            "substitutes 01-01 if saturday then next tuesday": {
              substitute: !0,
              _name: "01-01"
            },
            "substitutes 01-01 if sunday then next tuesday": {
              substitute: !0,
              _name: "01-01"
            },
            "01-02": {
              name: {
                en: "January 2nd"
              }
            },
            "substitutes 01-02 if saturday then next monday": {
              substitute: !0,
              name: {
                en: "January 2nd"
              }
            },
            "substitutes 01-02 if sunday then next monday": {
              substitute: !0,
              name: {
                en: "January 2nd"
              }
            },
            "easter 1": {
              _name: "easter 1"
            },
            "1st monday in August": {
              name: {
                en: "Summer bank holiday"
              }
            },
            "11-30": {
              name: {
                en: "St Andrew’s Day"
              }
            }
          }
        },
        WLS: {
          name: "Wales",
          days: {
            "1st monday before 09-01": {
              name: {
                en: "Summer bank holiday"
              }
            }
          },
          regions: {}
        }
      }
    },
    GD: {
      names: {
        en: "Grenada"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-07": {
          _name: "Independence Day"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-24 P3D": {
          name: {
            en: "Carriacou Maroon and String Band Music Festival"
          },
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "1st monday in August": {
          name: {
            en: "Emancipation Day"
          }
        },
        "2nd monday in August": {
          name: {
            en: "Carnival Monday"
          }
        },
        "tuesday after 2nd monday in August": {
          name: {
            en: "Carnival Tuesday"
          }
        },
        "09-01": {
          name: {
            en: "Kirani Day"
          },
          type: "observance"
        },
        "10-15 P5D": {
          name: {
            en: "Aunty Tek Spice Word Festival"
          },
          type: "observance"
        },
        "10-25": {
          name: {
            en: "Thanksgiving Day"
          }
        },
        "12-04 P3D": {
          name: {
            en: "Camerhogne Folk Festival"
          },
          type: "observance"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    GE: {
      names: {
        ge: "საქართველო",
        en: "Georgia"
      },
      langs: [
        "ge"
      ],
      zones: [
        "Asia/Tbilisi"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-02": {
          name: {
            ge: "ბედობა",
            en: "Bedoba"
          }
        },
        "01-07": {
          name: {
            ge: "შობა",
            en: "Orthodox Christmas"
          }
        },
        "01-19": {
          name: {
            ge: "ნათლისღება",
            en: "Orthodox Epiphany"
          }
        },
        "03-03": {
          name: {
            ge: "დედის დღე",
            en: "Mother's Day"
          }
        },
        "03-08": {
          _name: "03-08"
        },
        "04-09": {
          name: {
            ge: "ეროვნული ერთიანობის დღე",
            en: "National Unity Day"
          }
        },
        "orthodox -2": {
          _name: "easter -2"
        },
        "orthodox -1": {
          _name: "easter -1"
        },
        orthodox: {
          _name: "easter"
        },
        "orthodox 1": {
          _name: "easter 1"
        },
        "05-09": {
          name: {
            ge: "ფაშიზმზე გამარჯვების დღე",
            en: "Victory Day"
          }
        },
        "05-12": {
          name: {
            ge: "წმინდა ანდრია პირველწოდებულის ხსენების დღე",
            en: "Saint Andrew the First-Called Day"
          }
        },
        "05-26": {
          name: {
            ge: "დამოუკიდებლობის დღე",
            en: "Independence Day"
          }
        },
        "08-28": {
          name: {
            ge: "მარიამობა",
            en: "Saint Mary's Day"
          }
        },
        "10-14": {
          name: {
            ge: "სვეტიცხოვლობა",
            en: "Svetitskhovloba"
          }
        },
        "11-23": {
          name: {
            ge: "გიორგობა",
            en: "Saint George's Day"
          }
        }
      }
    },
    GF: {
      names: {
        fr: "Guyane",
        en: "French Guiana"
      },
      langs: [
        "fr"
      ],
      zones: [
        "America/Cayenne"
      ],
      dayoff: "sunday",
      _days: "FR",
      days: {
        "06-10": {
          _name: "Abolition of Slavery"
        }
      }
    },
    GG: {
      names: {
        en: "Guernsey"
      },
      dayoff: "sunday",
      zones: [
        "Europe/Guernsey"
      ],
      langs: [
        "en"
      ],
      _days: [
        "GB"
      ],
      days: {
        "05-09": {
          name: {
            en: "Liberation Day"
          }
        }
      }
    },
    GH: {
      names: {
        en: "Ghana"
      },
      langs: [
        "en"
      ],
      zones: [
        "Africa/Accra"
      ],
      dayoff: "",
      days: {
        "01-01 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-07 since 2019": {
          _name: "Constitution Day"
        },
        "03-06 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "05-01"
        },
        "08-04 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Founders Day"
          }
        },
        "09-21 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Kwame Nkrumah Memorial Day"
          }
        },
        "1st Friday in December since 1988": {
          name: {
            en: "Farmers Day"
          }
        },
        "12-25 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-26"
        },
        "1 Shawwal and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    GI: {
      names: {
        en: "Gibraltar"
      },
      langs: [
        "en"
      ],
      zones: [
        "Europe/Gibraltar"
      ],
      dayoff: "sunday",
      _days: "GB",
      days: {
        "2nd monday in March": {
          name: {
            en: "Commonwealth Day"
          }
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "04-28": {
          name: {
            en: "Workers Memorial Day"
          },
          disable: [
            "2015-04-28"
          ],
          enable: [
            "2015-04-27"
          ]
        },
        "05-01 if sunday, saturday then next monday": {
          substitute: !0,
          name: {
            en: "May Day"
          }
        },
        "1st monday in May": !1,
        "2020-05-08": {
          name: {
            en: "Victory in Europe Day (VE Day)"
          }
        },
        "monday before 06-20": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "monday before September": {
          name: {
            en: "Late Summer Bank Holiday"
          }
        },
        "09-10": {
          name: {
            en: "Gibraltar National Day"
          },
          active: [
            {
              to: 2015
            }
          ]
        },
        "09-10 and if sunday, saturday then previous monday": {
          substitute: !0,
          name: {
            en: "Gibraltar National Day"
          },
          active: [
            {
              from: 2015
            }
          ]
        }
      }
    },
    GL: {
      names: {
        kl: "Kalaallit Nunaat",
        da: "Grønland",
        en: "Greenland"
      },
      langs: [
        "kl",
        "da"
      ],
      zones: [
        "America/Godthab",
        "America/Danmarkshavn",
        "America/Scoresbysund",
        "America/Thule"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 26": {
          name: {
            kl: "tussiarfissuaq",
            da: "Store Bededag",
            en: "Prayer Day"
          }
        },
        "easter 39": {
          _name: "easter 39"
        },
        "06-21": {
          name: {
            kl: "ullortuneq",
            da: "Nationaldag",
            en: "National Day"
          }
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    GM: {
      names: {
        en: "The Gambia"
      },
      langs: [
        "en"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-18": {
          _name: "Independence Day"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-25": {
          name: {
            en: "Africa Day"
          }
        },
        "07-22": {
          name: {
            en: "Revolution Day"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "12-25": {
          _name: "12-25"
        },
        "10 Muharram": {
          _name: "10 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "23 Ramadan": {
          _name: "23 Ramadan"
        },
        "1 Shawwal": {
          _name: "1 Shawwal",
          name: {
            en: "Korité"
          }
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          name: {
            en: "Tabaski"
          }
        }
      }
    },
    GN: {
      names: {
        fr: "Guinée",
        en: "Guinea"
      },
      langs: [
        "fr"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-03": {
          name: {
            fr: "Fête Nationale de la deuxième République",
            en: "National Holiday"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "05-25": {
          name: {
            fr: "Anniversaire de l'Organisation de l'unité africaine (OUA)",
            en: "Africa Day"
          }
        },
        "27 Ramadan": {
          _name: "27 Ramadan"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "08-15": {
          _name: "08-15"
        },
        "10-02": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        }
      }
    },
    GP: {
      names: {
        fr: "Guadeloupe",
        en: "Guadeloupe"
      },
      langs: [
        "fr"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      dayoff: "sunday",
      _days: "FR",
      days: {
        "easter 49": !1,
        "easter -2": {
          _name: "easter -2"
        },
        "05-27": {
          _name: "Abolition of Slavery"
        },
        "07-21": {
          name: {
            fr: "Jour de Victor Shoelcher",
            en: "Victor Shoelcher Day"
          }
        }
      }
    },
    GQ: {
      names: {
        es: "República de Guinea Ecuatorial",
        fr: "République de Guinée équatoriale",
        pt: "República da Guiné Equatorial",
        en: "Republic of Equatorial Guinea"
      },
      dayoff: "sunday",
      weekend: [
        "saturday",
        "sunday"
      ],
      langs: [
        "es",
        "fr",
        "pt"
      ],
      zones: [
        "Africa/Lagos"
      ],
      days: {
        "01-01 and if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "05-01 and if sunday then next monday": {
          substitute: !0,
          _name: "05-01"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "06-05 and if sunday then next monday": {
          substitute: !0,
          name: {
            es: "Natalicio de Teodoro Obiang",
            en: "President's Day"
          }
        },
        "08-03 and if sunday then next monday": {
          substitute: !0,
          name: {
            es: "Día del Golpe de Libertad",
            en: "Armed Forces Day"
          }
        },
        "08-15 and if sunday then next monday": {
          substitute: !0,
          _name: "Constitution Day"
        },
        "10-12 and if sunday then next monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "12-08 and if sunday then next monday": {
          substitute: !0,
          _name: "12-08"
        },
        "12-25 and if sunday then next monday": {
          substitute: !0,
          _name: "12-25"
        }
      }
    },
    GR: {
      names: {
        el: "Ελλάδα",
        en: "Greece"
      },
      dayoff: "sunday",
      zones: [
        "Europe/Athens"
      ],
      langs: [
        "el"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        "orthodox -48": {
          name: {
            el: "Καθαρά Δευτέρα",
            en: "Ash Sunday"
          }
        },
        "03-25": {
          name: {
            el: "Ευαγγελισμός, Εθνική Εορτή",
            en: "Annunciation, Anniversary of 1821 Revolution"
          }
        },
        "orthodox -2": {
          _name: "easter -2"
        },
        orthodox: {
          _name: "easter"
        },
        "orthodox 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "orthodox 49": {
          _name: "easter 49"
        },
        "orthodox 50": {
          _name: "easter 50"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "08-15": {
          _name: "08-15"
        },
        "10-28": {
          _name: "National Holiday",
          name: {
            el: "Επέτειος του Όχι"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    GT: {
      names: {
        es: "Guatemala",
        en: "Guatemala"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Guatemala"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "06-30 if tuesday then previous monday if wednesday,thursday then next friday": {
          name: {
            es: "Día de las Fuerzas Armadas",
            en: "Army Day"
          }
        },
        "09-15": {
          _name: "Independence Day"
        },
        "10-20": {
          _name: "Revolution Day"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-24 12:00": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-31 12:00": {
          _name: "12-31"
        }
      }
    },
    GU: {
      names: {
        en: "Guam"
      },
      dayoff: "sunday",
      langs: [
        "en-us",
        "en"
      ],
      zones: [
        "Pacific/Guam"
      ],
      _days: [
        "US"
      ],
      days: {
        "3rd monday in February": !1,
        "03-17": !1,
        "1st monday in March": {
          name: {
            en: "Guam History and Chamorro Heritage Day"
          }
        },
        "easter -2": {
          _name: "easter -2",
          type: "observance"
        },
        "07-21 if sunday then next monday": {
          name: {
            en: "Liberation Day"
          }
        },
        "11-02": {
          _name: "11-02"
        },
        "12-08 if sunday then next monday": {
          name: {
            en: "Our Lady of Camarin Day"
          }
        }
      }
    },
    GW: {
      names: {
        pt: "Guiné-Bissau",
        en: "Guinea-Bissau"
      },
      langs: [
        "pt"
      ],
      zones: [
        "Africa/Bissau"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-20": {
          name: {
            pt: "Dia dos heróis",
            en: "Heroes Day"
          }
        },
        "03-08": {
          _name: "03-08"
        },
        "05-01": {
          _name: "05-01"
        },
        "08-03": {
          name: {
            pt: "Pidjiguiti Day"
          }
        },
        "09-24": {
          _name: "Independence Day"
        },
        "11-14": {
          name: {
            pt: "Dia do Movimento de Reajustamento",
            en: "Readjustment Movement Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    GY: {
      names: {
        en: "Guyana"
      },
      coord: {
        lat: 6.8045,
        lng: -58.1553
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "America/Guyana"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-23": {
          name: {
            en: "Republic Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-05": {
          name: {
            en: "Arrival Day"
          }
        },
        "05-26": {
          _name: "Independence Day"
        },
        "monday after 07-01": {
          name: {
            en: "CARICOM Day"
          }
        },
        "08-01": {
          name: {
            en: "Emancipation Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal",
          name: {
            en: "Youman Nabi"
          },
          note: "tentative",
          disable: [
            "2016-12-11",
            "2015-12-23",
            "2013-01-24"
          ],
          enable: [
            "2016-12-12",
            "2015-12-24",
            "2013-01-23"
          ]
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          name: {
            en: "Eid Ul Adha"
          },
          note: "tentative",
          disable: [
            "2015-09-23"
          ],
          enable: [
            "2015-09-24"
          ]
        },
        "2015-03-05": {
          name: {
            en: "Phagwah"
          }
        },
        "2016-03-23": {
          name: {
            en: "Phagwah"
          }
        },
        "2017-03-12": {
          name: {
            en: "Phagwah"
          }
        },
        "2017-03-13": {
          substitute: !0,
          name: {
            en: "Phagwah"
          }
        },
        "2018-03-02": {
          name: {
            en: "Phagwah"
          }
        },
        "2019-03-21": {
          name: {
            en: "Phagwah"
          }
        },
        "2020-03-10": {
          name: {
            en: "Phagwah"
          }
        },
        "2021-03-29": {
          name: {
            en: "Phagwah"
          }
        },
        "2022-03-18": {
          name: {
            en: "Phagwah"
          }
        },
        "2023-03-07": {
          name: {
            en: "Phagwah"
          }
        },
        "2024-03-25": {
          name: {
            en: "Phagwah"
          }
        },
        "2015-11-11": {
          name: {
            en: "Deepavali"
          }
        },
        "2017-10-18": {
          name: {
            en: "Deepavali"
          }
        },
        "2018-11-07": {
          name: {
            en: "Deepavali"
          }
        },
        "2019-10-27": {
          name: {
            en: "Deepavali"
          }
        },
        "2019-10-28": {
          substitute: !0,
          name: {
            en: "Deepavali"
          }
        },
        "2020-11-14": {
          name: {
            en: "Deepavali"
          }
        },
        "2021-11-04": {
          name: {
            en: "Deepavali"
          }
        },
        "2022-10-24": {
          name: {
            en: "Deepavali"
          }
        },
        "2023-11-12": {
          name: {
            en: "Deepavali"
          }
        },
        "2023-11-13": {
          substitute: !0,
          name: {
            en: "Deepavali"
          }
        },
        "2024-10-31": {
          name: {
            en: "Deepavali"
          }
        }
      }
    },
    HK: {
      names: {
        zh: "香港",
        en: "Hong Kong"
      },
      langs: [
        "zh",
        "en"
      ],
      zones: [
        "Asia/Hong_Kong"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Sunday then next Monday": {
          substitute: !0,
          _name: "01-01",
          name: {
            zh: "一月一日"
          }
        },
        "chinese 01-0-01 and if Saturday then next Tuesday": {
          name: {
            en: "Lunar New Year",
            zh: "農曆年初一"
          }
        },
        "chinese 01-0-02 and if Saturday then next Monday": {
          name: {
            en: "The second day of the Lunar New Year",
            zh: "農曆年初二"
          }
        },
        "chinese 01-0-03 and if Saturday then next Monday": {
          name: {
            en: "The third day of the Lunar New Year",
            zh: "農曆年初三"
          }
        },
        "chinese 5-01 solarterm and if Sunday then next Monday": {
          name: {
            en: "Qingming Festival",
            zh: "清明節"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1",
          disable: [
            "2021-04-05"
          ],
          enable: [
            "2021-04-06"
          ]
        },
        "05-01 and if Sunday then next Monday": {
          substitute: !0,
          _name: "05-01"
        },
        "chinese 04-0-08 and if Sunday then next Monday": {
          name: {
            en: "Birthday of the Buddha",
            zh: "佛誕"
          }
        },
        "chinese 05-0-05": {
          name: {
            en: "Dragon Boat Festival",
            zh: "端午节"
          }
        },
        "07-01 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Hong Kong Special Administrative Region Establishment Day",
            zh: "香港特別行政區成立紀念日"
          }
        },
        "chinese 08-0-16 and if Sunday then next Monday if is public holiday then next day omit Saturday, Sunday": {
          substitute: !0,
          name: {
            en: "The day following the Chinese Mid-Autumn Festival",
            zh: "中秋節翌日"
          }
        },
        "10-01 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "National Day",
            zh: "國慶日"
          }
        },
        "chinese 09-0-09 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Chung Yeung Festival",
            zh: "重阳节"
          }
        },
        "12-25 and if Sunday then next Monday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if Sunday then next Monday if Monday then next Tuesday": {
          substitute: !0,
          name: {
            en: "The first weekday after Christmas Day",
            zh: "圣诞节后的第一个工作日"
          }
        }
      }
    },
    HN: {
      names: {
        es: "Honduras",
        en: "Honduras"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Tegucigalpa"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-19": {
          _name: "Fathers Day",
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "04-14": {
          name: {
            es: "Día de las Américas"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "2nd monday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "06-11": {
          name: {
            en: "Pupil's Day",
            es: "Día del Estudiante"
          },
          type: "observance"
        },
        "09-10": {
          name: {
            en: "Children's Day",
            es: "Día del Niño"
          },
          type: "observance"
        },
        "09-15": {
          _name: "Independence Day"
        },
        "09-17": {
          name: {
            en: "Teacher's Day",
            es: "Día del Maestro"
          },
          type: "observance"
        },
        "10-03": {
          name: {
            en: "Soldier's Day",
            es: "Día del Soldado"
          }
        },
        "10-12": {
          name: {
            es: "Día de la Raza",
            en: "Columbus Day"
          }
        },
        "10-21": {
          name: {
            es: "Día de las Fuerzas Armadas",
            en: "Armed forces Day"
          }
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    HR: {
      names: {
        hr: "Hrvatska",
        en: "Croatia"
      },
      langs: [
        "hr"
      ],
      zones: [
        "Europe/Belgrade"
      ],
      days: {
        "01-01": {
          _name: "01-01",
          type: "public"
        },
        "01-06": {
          _name: "01-06",
          type: "public"
        },
        "easter -47": {
          _name: "easter -47",
          type: "observance"
        },
        easter: {
          _name: "easter",
          type: "public"
        },
        "easter 1": {
          _name: "easter 1",
          type: "public"
        },
        "easter 60": {
          _name: "easter 60",
          type: "public"
        },
        "03-08": {
          _name: "03-08",
          type: "observance"
        },
        "05-01": {
          _name: "05-01",
          type: "public"
        },
        "05-30": {
          name: {
            hr: "Dan državnosti",
            en: "National Day"
          },
          type: "public",
          active: [
            {
              from: "2020-01-01"
            }
          ]
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "06-22": {
          name: {
            hr: "Dan antifašističke borbe",
            en: "Anti-Fascist Struggle Day"
          },
          type: "public"
        },
        "06-25 #1": {
          name: {
            hr: "Dan državnosti",
            en: "Statehood Day"
          },
          type: "public",
          active: [
            {
              to: "2020-01-01"
            }
          ]
        },
        "06-25": {
          name: {
            hr: "Dan neovisnosti",
            en: "Independence Day"
          },
          type: "observance",
          active: [
            {
              from: "2020-01-01"
            }
          ]
        },
        "08-05": {
          name: {
            hr: "Dan pobjede i domovinske zahvalnosti i Dan hrvatskih branitelja",
            en: "Victory and Homeland Thanksgiving Day and the Day of Croatian defenders"
          },
          type: "public"
        },
        "08-15": {
          _name: "08-15",
          type: "public"
        },
        "10-08 #1": {
          name: {
            hr: "Dan neovisnosti",
            en: "Independence Day"
          },
          type: "public",
          active: [
            {
              to: "2020-01-01"
            }
          ]
        },
        "10-08": {
          name: {
            hr: "Dan Hrvatskoga sabora",
            en: "Day of the Croatian Parliament"
          },
          type: "observence",
          active: [
            {
              from: "2020-01-01"
            }
          ]
        },
        "11-01": {
          _name: "11-01",
          type: "public"
        },
        "11-18 #1": {
          name: {
            hr: "Dan sjećanja na žrtvu Vukovara i Škabrnje",
            en: "Remembrance Day"
          },
          type: "observance",
          active: [
            {
              to: "2020-01-01"
            }
          ]
        },
        "11-18": {
          name: {
            hr: "Dan sjećanja na žrtve Domovinskog rata i Dan sjećanja na žrtvu Vukovara i Škabrnje",
            en: "Remembrance Day"
          },
          type: "public",
          active: [
            {
              from: "2020-01-01"
            }
          ]
        },
        "12-25": {
          _name: "12-25",
          type: "public"
        },
        "12-26": {
          _name: "12-26",
          type: "public"
        },
        orthodox: {
          _name: "orthodox",
          type: "optional",
          note: "Orthodox believers (legally defined as Christians who follow the Julian Calender)"
        },
        "orthodox 1": {
          _name: "orthodox 1",
          type: "optional",
          note: "Orthodox believers (legally defined as Christians who follow the Julian Calender)"
        },
        "julian 12-25": {
          _name: "julian 12-25",
          type: "optional",
          note: "Orthodox believers (legally defined as Christians who follow the Julian Calender)"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          type: "optional",
          note: "Muslim believers"
        },
        "1 Shawwal": {
          _name: "1 Shawwal",
          type: "optional",
          note: "Muslim believers"
        },
        "1 Tishrei": {
          _name: "10 Tishrei",
          type: "optional",
          note: "Jewish believers"
        },
        "10 Tishrei": {
          _name: "10 Tishrei",
          type: "optional",
          note: "Jewish believers"
        }
      },
      regions: {
        17: {
          name: "Split-Dalmatia",
          days: {
            "05-07": {
              name: {
                hr: "Sveti Duje",
                en: "Saint Domnius"
              },
              type: "optional"
            }
          }
        },
        19: {
          name: "Dubrovnik-Neretva",
          days: {
            "02-03": {
              name: {
                hr: "Sveti Vlaho",
                en: "Saint Blaise"
              },
              type: "optional"
            }
          }
        }
      }
    },
    HT: {
      names: {
        fr: "Haïti",
        en: "Haiti"
      },
      dayoff: "sunday",
      langs: [
        "fr"
      ],
      zones: [
        "America/Port-au-Prince"
      ],
      days: {
        "01-01": {
          _name: "Independence Day"
        },
        "01-02": {
          name: {
            fr: "Jour des Aieux",
            en: "Ancestry Day"
          }
        },
        "01-06": {
          _name: "01-06",
          name: {
            fr: "Le Jour des Rois"
          },
          type: "observance"
        },
        "easter -48 14:00": {
          name: {
            fr: "Lundi Gras",
            en: "Lundi Gras"
          }
        },
        "easter -47": {
          name: {
            fr: "Mardi Gras",
            en: "Mardi Gras"
          }
        },
        "easter -46": {
          _name: "easter -46",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-18": {
          name: {
            fr: "Jour du Drapeau et de l'Université",
            en: "Flag and Universities' Day"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "10-17": {
          name: {
            fr: "Anniversaire de la mort de Dessalines",
            en: "Anniversary of the death of Dessalines"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "11-02": {
          _name: "11-02"
        },
        "11-18": {
          name: {
            fr: "Vertières",
            en: "Battle of Vertières Day"
          }
        },
        "12-05": {
          name: {
            fr: "Découverte d'Haïti",
            en: "Discovery Day"
          },
          type: "observance"
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    HU: {
      names: {
        hu: "Magyarország",
        en: "Hungary"
      },
      dayoff: "sunday",
      langs: [
        "hu"
      ],
      zones: [
        "Europe/Budapest"
      ],
      days: {
        "01-01": {
          _name: "01-01",
          type: "public"
        },
        "02-01": {
          name: {
            hu: "A köztársaság emléknapja",
            en: "Memorial Day of the Republic"
          },
          type: "observance"
        },
        "02-25": {
          name: {
            hu: "A kommunista diktatúrák áldozatainak emléknapja",
            en: "Memorial Day for the Victims of the Communist Dictatorships"
          },
          type: "observance"
        },
        "03-08": {
          _name: "03-08",
          type: "observance"
        },
        "03-15": {
          name: {
            hu: "1848-as forradalom",
            en: "National Day"
          },
          type: "public"
        },
        "04-16": {
          name: {
            en: "Memorial Day for the Victims of the Holocaust",
            hu: "A holokauszt áldozatainak emléknapja"
          },
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2",
          type: "public",
          active: [
            {
              from: "2017-01-01"
            }
          ]
        },
        easter: {
          _name: "easter",
          type: "public"
        },
        "easter 1": {
          _name: "easter 1",
          type: "public"
        },
        "05-01": {
          _name: "05-01",
          type: "public"
        },
        "1st sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "05-21": {
          name: {
            en: "National Defense Day",
            hu: "Honvédelmi nap"
          },
          type: "observance"
        },
        "easter 49": {
          _name: "easter 49",
          type: "public"
        },
        "easter 50": {
          _name: "easter 50",
          type: "public"
        },
        "06-04": {
          name: {
            en: "Day of National Unity",
            hu: "A nemzeti összetartozás napja"
          },
          type: "observance"
        },
        "06-19": {
          name: {
            en: "Day of the Independent Hungary",
            hu: "A független Magyarország napja"
          },
          type: "observance"
        },
        "08-20": {
          name: {
            hu: "Szent István ünnepe",
            en: "Saint Stephen's Day"
          },
          type: "public"
        },
        "10-06": {
          name: {
            en: "Memorial Day for the Martyrs of Arad",
            hu: "Az aradi vértanúk emléknapja"
          },
          type: "observance"
        },
        "10-23": {
          name: {
            hu: "1956-os forradalom",
            en: "National Day"
          },
          type: "public"
        },
        "11-01": {
          _name: "11-01",
          type: "public"
        },
        "12-06": {
          _name: "12-06",
          type: "observance"
        },
        "12-24": {
          _name: "12-24",
          type: "optional"
        },
        "12-25": {
          _name: "12-25",
          type: "public"
        },
        "12-26": {
          _name: "12-26",
          type: "public"
        },
        "12-31": {
          _name: "12-31",
          type: "observance"
        },
        "2023-10-30": {
          name: {
            hu: "Őszi szünet",
            en: "Autumn school holiday"
          },
          type: "school"
        },
        "2023-10-31": {
          name: {
            hu: "Őszi szünet",
            en: "Autumn school holiday"
          },
          type: "school"
        },
        "2023-11-02": {
          name: {
            hu: "Őszi szünet",
            en: "Autumn school holiday"
          },
          type: "school"
        },
        "2023-11-03": {
          name: {
            hu: "Őszi szünet",
            en: "Autumn school holiday"
          },
          type: "school"
        },
        "2023-12-22": {
          name: {
            hu: "Téli szünet",
            en: "Winter school holiday"
          },
          type: "school"
        },
        "2023-12-27": {
          name: {
            hu: "Téli szünet",
            en: "Winter school holiday"
          },
          type: "school"
        },
        "2024-01-02": {
          name: {
            hu: "Téli szünet",
            en: "Winter school holiday"
          },
          type: "school"
        },
        "2024-01-03": {
          name: {
            hu: "Téli szünet",
            en: "Winter school holiday"
          },
          type: "school"
        },
        "2024-01-04": {
          name: {
            hu: "Téli szünet",
            en: "Winter school holiday"
          },
          type: "school"
        },
        "2024-01-05": {
          name: {
            hu: "Téli szünet",
            en: "Winter school holiday"
          },
          type: "school"
        }
      }
    },
    IC: {
      names: {
        es: "Islas Canarias",
        en: "Canary Islands"
      },
      langs: [
        "es"
      ],
      zones: [
        "Atlantic/Canary"
      ],
      dayoff: "sunday",
      _days: "ES",
      days: {
        "05-30": {
          name: {
            es: "Día de Canarias",
            en: "Canary Islands Day"
          }
        },
        "substitutes 05-30 if Sunday then next Monday": {
          substitute: !0,
          name: {
            es: "Día de Canarias",
            en: "Canary Islands Day"
          }
        },
        "substitutes 08-15 if Sunday then next Monday": {
          substitute: !0,
          _name: "08-15"
        }
      },
      regions: {
        EH: {
          names: {
            es: "El Hierro"
          },
          days: {
            "09-24": {
              name: {
                es: "Nuestra Señora de los Reyes"
              }
            }
          }
        },
        FU: {
          names: {
            es: "Fuerteventura"
          },
          days: {
            "09-18": {
              name: {
                es: "Nuestra Señora de la Peña"
              }
            }
          }
        },
        GC: {
          names: {
            es: "Gran Canaria"
          },
          days: {
            "09-08": {
              name: {
                es: "Nuestra Señora del Pino"
              }
            }
          }
        },
        LG: {
          names: {
            es: "La Gomera"
          },
          days: {
            "10-05": {
              name: {
                es: "Nuestra Señora de Guadalupe"
              }
            }
          }
        },
        LP: {
          names: {
            es: "La Palma"
          },
          days: {
            "08-05": {
              name: {
                es: "Nuestra Señora de las Nieves"
              }
            }
          }
        },
        LA: {
          names: {
            es: "Lanzarote"
          },
          days: {
            "09-15": {
              name: {
                es: "Nuestra Señora de los Dolores"
              }
            }
          }
        },
        TE: {
          names: {
            es: "Tenerife"
          },
          days: {
            "09-07": {
              name: {
                es: "La Bajada de la Virgen del Socorro"
              }
            }
          }
        }
      }
    },
    ID: {
      names: {
        en: "Indonesia",
        id: "Indonesia"
      },
      langs: [
        "id"
      ],
      zones: [
        "Asia/Jakarta",
        "Asia/Pontianak",
        "Asia/Makassar",
        "Asia/Jayapura"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "chinese 01-0-01": {
          name: {
            en: "Chinese New Year",
            id: "Tahun Baru Imlek"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "06-01": {
          name: {
            en: "Pancasila Day",
            id: "Hari Lahir Pancasila"
          }
        },
        "08-17": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "27 Rajab": {
          _name: "27 Rajab"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "2 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "2009-03-26": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2010-03-16": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2011-03-05": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2012-03-23": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2013-03-12": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2014-03-31": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2015-03-21": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2016-03-09": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2017-03-28": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2018-03-17": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2019-03-07": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2020-03-25": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2021-03-14": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2022-03-03": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2023-03-22": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2024-03-11": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2025-03-29": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2026-03-19": {
          name: {
            en: "Nyepi",
            id: "Hari Raya Nyepi"
          }
        },
        "2001-05-07": {
          _name: "Vesak"
        },
        "2002-05-26": {
          _name: "Vesak"
        },
        "2003-05-16": {
          _name: "Vesak"
        },
        "2004-06-03": {
          _name: "Vesak"
        },
        "2005-05-24": {
          _name: "Vesak"
        },
        "2006-05-13": {
          _name: "Vesak"
        },
        "2007-06-01": {
          _name: "Vesak"
        },
        "2008-05-20": {
          _name: "Vesak"
        },
        "2009-05-09": {
          _name: "Vesak"
        },
        "2010-05-28": {
          _name: "Vesak"
        },
        "2011-05-17": {
          _name: "Vesak"
        },
        "2012-05-06": {
          _name: "Vesak"
        },
        "2013-05-25": {
          _name: "Vesak"
        },
        "2014-05-15": {
          _name: "Vesak"
        },
        "2015-06-02": {
          _name: "Vesak"
        },
        "2016-05-22": {
          _name: "Vesak"
        },
        "2017-05-11": {
          _name: "Vesak"
        },
        "2018-05-29": {
          _name: "Vesak"
        },
        "2019-05-19": {
          _name: "Vesak"
        },
        "2020-05-07": {
          _name: "Vesak"
        },
        "2021-05-26": {
          _name: "Vesak"
        },
        "2022-05-16": {
          _name: "Vesak"
        },
        "2023-05-06": {
          _name: "Vesak"
        },
        "2024-05-23": {
          _name: "Vesak"
        }
      }
    },
    IE: {
      names: {
        en: "Ireland"
      },
      dayoff: "sunday",
      zones: [
        "Europe/Dublin"
      ],
      langs: [
        "en"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "1st monday in January": {
          name: {
            en: "Bank Holiday"
          },
          type: "bank"
        },
        "02-01 if Tuesday,Wednesday,Thursday,Saturday,Sunday then next Monday since 2023": {
          name: {
            en: "St. Brigid’s Day"
          }
        },
        "03-17": {
          name: {
            en: "St. Patrick’s Day"
          }
        },
        "03-17 and if saturday then next monday if sunday then next monday": {
          name: {
            en: "St. Patrick’s Day"
          },
          substitute: !0,
          type: "bank"
        },
        "easter -21": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2",
          type: "bank"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "1st monday in May": {
          name: {
            en: "May Day"
          }
        },
        "1st monday in June": {
          name: {
            en: "First Monday in June"
          }
        },
        "1st monday in August": {
          name: {
            en: "First Monday in August"
          }
        },
        "1st Monday before 11-01": {
          name: {
            en: "October Bank Holiday",
            type: "bank"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26",
          name: {
            en: "St. Stephen's Day"
          }
        },
        "12-26 and if saturday then next monday if sunday then next monday": {
          _name: "12-26",
          name: {
            en: "St. Stephen's Day"
          },
          substitute: !0,
          type: "bank"
        },
        "12-27 and if saturday then next monday if sunday then next tuesday": {
          name: {
            en: "Christmas Bank Holiday"
          },
          type: "bank"
        },
        "3rd sunday in June": {
          _name: "Fathers Day",
          type: "observance"
        }
      }
    },
    IL: {
      names: {
        he: "מְדִינַת יִשְׂרָאֵל",
        en: "Israel"
      },
      langs: [
        "he"
      ],
      zones: [
        "Asia/Jerusalem"
      ],
      dayoff: "Saturday",
      days: {
        "1 Tishrei": {
          name: {
            he: "ראש השנה",
            en: "Rosh Hashanah (Yom Teruah)"
          }
        },
        "2 Tishrei": {
          name: {
            he: "ראש השנה יום 2",
            en: "Rosh Hashanah (Day 2)"
          }
        },
        "3 Tishrei if Saturday then next Sunday": {
          name: {
            he: "צום גדליה",
            en: "Fast of Gedaliah (Tzom Gedalya)"
          },
          type: "observance"
        },
        "10 Tishrei": {
          name: {
            he: "יום כיפור",
            en: "Day of Atonement (Yom Kippur)"
          }
        },
        "15 Tishrei": {
          name: {
            he: "סוכות",
            en: "Feast of Tabernacles (Sukkot)"
          }
        },
        "16 Tishrei P6D": {
          name: {
            he: "חול המועד סוכות",
            en: "The week of Sukkot"
          },
          type: "school",
          note: "Collective paid leave in many businesses and government offices"
        },
        "22 Tishrei": {
          name: {
            he: "שמחת תורה/שמיני עצרת",
            en: "Simchat Torah/ Shmini Atzeret"
          }
        },
        "12 Cheshvan if Friday,Saturday then previous Thursday since 1997": {
          name: {
            he: "יום רבין",
            en: "Rabin Day"
          },
          type: "observance",
          note: "National remembrance day, business as usual"
        },
        "29 Cheshvan": {
          name: {
            he: "סיגד",
            en: "Sigd"
          },
          type: "observance",
          note: "Festival of the Ethiopian Jews, optional paid leave, business as usual"
        },
        "6 Kislev if Saturday then next Sunday": {
          name: {
            en: "Ben-Gurion Day",
            he: "יום בן-גוריון"
          },
          type: "observance",
          note: "Day marked by the Knesset"
        },
        "25 Kislev P8D": {
          name: {
            en: "Hanukkah",
            he: "חנוכה"
          },
          type: "school"
        },
        "10 Tevet": {
          name: {
            en: "Tenth of Tevet",
            he: "צום עשרה בטבת"
          },
          type: "observance"
        },
        "15 Shvat": {
          name: {
            en: "Tu Bishvat (Arbor Day)",
            he: 'ט"ו בשבט'
          },
          type: "observance"
        },
        "13 AdarII if Saturday then previous Thursday": {
          name: {
            en: "Fast of Esther",
            he: "תענית אסתר"
          },
          type: "school"
        },
        "14 AdarII P2D": {
          name: {
            en: "Purim",
            he: "פורים"
          },
          type: "school",
          note: "optional paid leave"
        },
        "10 Nisan": {
          name: {
            en: "Aliyah Day",
            he: "יום העלייה"
          },
          type: "observance",
          note: "Official holiday, business as usual"
        },
        "15 Nisan": {
          name: {
            en: "Passover (Pesach)",
            he: "פסח"
          }
        },
        "16 Nisan P5D": {
          name: {
            en: "Passover (intermediate days)",
            he: "חול המועד פסח"
          },
          type: "school",
          note: "School holiday, collective paid leave in many businesses and government offices"
        },
        "21 Nisan": {
          name: {
            en: "Mimouna, Seventh day of Passover",
            he: "מימונה, שביעי של פסח"
          }
        },
        "27 Nisan if Friday then previous Thursday if Sunday then next Monday": {
          name: {
            en: "Holocaust Remembrance Day (Yom HaShoah)",
            he: "יום הזיכרון לשואה ולגבורה"
          },
          type: "observance",
          note: "National remembrance day, business as usual except places of public entertainment"
        },
        "05-09": {
          name: {
            en: "Victory in Europe Day",
            he: "יום הניצחון על גרמניה הנאצית"
          },
          type: "observance"
        },
        "4 Iyyar if Thursday,Friday then previous Wednesday if Sunday then next Monday": {
          name: {
            en: "Fallen Soldiers and Victims of Terrorism Remembrance Day (Yom HaZikaron)",
            he: "יום הזיכרון לחללי מערכות ישראל ונפגעי פעולות האיבה"
          },
          type: "observance",
          note: "National remembrance day, business as usual except places of public entertainment"
        },
        "5 Iyyar if Friday,Saturday then previous Thursday if Monday then next Tuesday": {
          name: {
            en: "Independence Day (Yom HaAtzmaut)",
            he: "יום העצמאות"
          }
        },
        "10 Iyyar if Saturday then next Sunday since 2004": {
          name: {
            en: "Herzl Day",
            he: "יום הרצל"
          },
          type: "observance",
          note: "Day marked by the Knesset"
        },
        "18 Iyyar": {
          name: {
            en: "Lag BaOmer",
            he: 'ל"ג בעומר'
          },
          type: "school"
        },
        "28 Iyyar": {
          name: {
            en: "Jerusalem Day (Yom Yerushalayim)",
            he: "יום ירושלים"
          },
          type: "observance",
          note: "Optional paid leave"
        },
        "6 Sivan": {
          name: {
            en: "Shavuot (Feast of Weeks)",
            he: "שבועות"
          }
        },
        "17 Tamuz if Saturday then next Sunday": {
          name: {
            en: "Seventeenth of Tamuz, fast",
            he: "שבעה עשר בתמוז"
          },
          type: "observance"
        },
        "29 Tamuz if Saturday then next Sunday": {
          name: {
            en: "Jabotinsky Day",
            he: "יום ז'בוטינסקי"
          },
          type: "observance",
          note: "Day marked by the Knesset"
        },
        "9 Av if Saturday then next Sunday": {
          name: {
            en: "Tisha B'Av, fast",
            he: "תשעה באב"
          },
          type: "observance",
          note: "Optional paid leave, business as usual except places of public entertainment"
        },
        "15 Av": {
          name: {
            en: "Tu B'Av (Fifteenth of Av)",
            he: 'ט"ו באב'
          },
          type: "observance"
        },
        "2015-03-17": {
          name: {
            en: "Election Day",
            he: "יום הבחירות"
          }
        },
        "2019-04-09": {
          name: {
            en: "Election Day",
            he: "יום הבחירות"
          }
        },
        "2019-09-17": {
          name: {
            en: "Election Day",
            he: "יום הבחירות"
          }
        },
        "2020-03-02": {
          name: {
            en: "Election Day",
            he: "יום הבחירות"
          }
        },
        "2021-03-23": {
          name: {
            en: "Election Day",
            he: "יום הבחירות"
          }
        }
      }
    },
    IM: {
      names: {
        en: "Isle of Man"
      },
      zones: [
        "Europe/Isle_of_Man"
      ],
      langs: [
        "en"
      ],
      _days: [
        "GB"
      ],
      days: {
        "2nd friday in June": {
          name: {
            en: "Tourist Trophy, Senior Race Day"
          }
        },
        "07-05": {
          name: {
            en: "Tynwald Day"
          }
        }
      }
    },
    IR: {
      names: {
        fa: "جمهوری اسلامی ایران",
        en: "Iran"
      },
      langs: [
        "fa",
        "en"
      ],
      zones: [
        "Asia/Tehran"
      ],
      dayoff: "Friday",
      days: {
        "1 Farvardin": {
          name: {
            fa: "نوروز",
            en: "Nowruz"
          }
        },
        "2 Farvardin": {
          name: {
            fa: "نوروز",
            en: "Nowruz"
          }
        },
        "3 Farvardin": {
          name: {
            fa: "نوروز",
            en: "Nowruz"
          }
        },
        "4 Farvardin": {
          name: {
            fa: "نوروز",
            en: "Nowruz"
          }
        },
        "12 Farvardin": {
          name: {
            fa: "روز جمهوری اسلامی",
            en: "Islamic Republic Day"
          }
        },
        "13 Farvardin": {
          name: {
            fa: "سیزده بدر",
            en: "Sizdah Bedar"
          }
        },
        "14 Khordad": {
          name: {
            fa: "رﺣﻠﺖ اﻣﺎم ﺧﻤﯿﻨﯽ",
            en: "Imam Khomeini's Demise"
          }
        },
        "15 Khordad": {
          name: {
            fa: "قیام ۱۵ خرداد",
            en: "Revolt of Khordad 15"
          }
        },
        "22 Bahman": {
          name: {
            fa: "انقلاب اسلامی پنجاه و هفت",
            en: "Anniversary of Islamic Revolution"
          }
        },
        "29 Esfand": {
          name: {
            fa: "ملی شدن صنعت نفت",
            en: "Nationalization of the Iranian oil industry"
          }
        },
        "9 Muharram": {
          name: {
            fa: "ﺗﺎﺳﻮﻋﺎی ﺣﺴﯿﻨﯽ",
            en: "Tasoua"
          }
        },
        "10 Muharram": {
          name: {
            fa: "ﻋﺎﺷﻮرای ﺣﺴﯿﻨﯽ",
            en: "Ashoura"
          }
        },
        "20 Safar": {
          name: {
            fa: "اربعین حسینی",
            en: "Arbaeen-e Hosseini"
          }
        },
        "28 Safar": {
          name: {
            fa: "رﺣﻠﺖ ﺣﻀﺮت رﺳﻮل اﮐﺮم صلّی الله علیه وآله و سلّم",
            en: "Demise of Prophet Muhammad and Imam Hassan (Mujtaba)"
          }
        },
        "30 Safar": {
          name: {
            fa: "ﺷﻬﺎدت ﺣﻀﺮت اﻣﺎم رﺿﺎ ﻋﻠﯿﻪاﻟﺴﻼم",
            en: "Martyrdom of Imam Reza"
          }
        },
        "8 Rabi al-awwal": {
          name: {
            fa: "شهادت امام حسن عسكری علیه‌السلام",
            en: "Martyrdom of Imam Hassan"
          }
        },
        "17 Rabi al-awwal": {
          name: {
            fa: "ولادت حضرت رسول اکرم صلّی الله علیه وآله و سلّم",
            en: "Birthday of Muhammad Prophet"
          }
        },
        "3 Jumada al-thani": {
          name: {
            fa: "ﺷﻬﺎدت ﺣﻀﺮت ﻓﺎﻃﻤﻪ زﻫﺮا ﺳﻼم اﷲ ﻋﻠﯿﻬﺎ",
            en: "Martyrdom of Fatima-Zahara"
          }
        },
        "13 Rajab": {
          name: {
            fa: "وﻻدت ﺣﻀﺮت اﻣﺎم ﻋﻠﯽ ﻋﻠﯿﻪ اﻟﺴﻼم",
            en: "Birthday of Imam Ali"
          }
        },
        "27 Rajab": {
          name: {
            fa: "ﻣﺒﻌﺚ ﺣﻀﺮت رﺳﻮل اﮐﺮم ﺻﻠﯽ اﷲ ﻋﻠﯿﻪ و آﻟﻪ",
            en: "Mabaas of Muhammad"
          }
        },
        "15 Shaban": {
          name: {
            fa: "وﻻدت ﺣﻀﺮت ﻗﺎﺋﻢ ﻋﺠﻞاﷲ ﺗﻌﺎﻟﯽ ﻓﺮﺟﻪ شریف",
            en: "Birthday of Imam Mahdi"
          }
        },
        "21 Ramadan": {
          name: {
            fa: "ﺷﻬﺎدت ﺣﻀﺮت ﻋﻠﯽ ﻋﻠﯿﻪاﻟﺴﻼم",
            en: "Martyrdom of Imam Ali"
          }
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "2 Shawwal": {
          name: {
            fa: "ﺑﻪ ﻣﻨﺎﺳﺒﺖ ﻋﯿﺪ ﺳﻌﯿﺪ ﻓﻄﺮ",
            en: "Holyday for Fetr Eeid"
          }
        },
        "25 Shawwal": {
          name: {
            fa: "ﺷﻬﺎدت ﺣﻀﺮت اﻣﺎم ﺟﻌﻔﺮ ﺻﺎدق ﻋﻠﯿﻪاﻟﺴﻼم",
            en: "Martyrdom of Imam Jafar"
          }
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "18 Dhu al-Hijjah": {
          name: {
            fa: "ﻋﯿﺪ ﺳﻌﯿﺪ ﻏﺪﯾﺮ ﺧﻢ",
            en: "Eid al-Ghadeer"
          }
        }
      }
    },
    IS: {
      names: {
        is: "Ísland",
        en: "Iceland"
      },
      dayoff: "sunday",
      zones: [
        "Atlantic/Reykjavik"
      ],
      langs: [
        "is"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06",
          type: "observance"
        },
        "friday after 01-18": {
          name: {
            is: "Bóndadagur"
          },
          type: "observance"
        },
        "02-18": {
          name: {
            is: "Konudagur",
            en: "Woman's Day"
          },
          type: "observance"
        },
        "easter -48": {
          name: {
            is: "Bolludagur"
          },
          type: "observance"
        },
        "easter -47": {
          name: {
            is: "Sprengidagur"
          },
          type: "observance"
        },
        "easter -46": {
          _name: "easter -46",
          type: "observance"
        },
        "easter -7": {
          _name: "easter -7",
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "thursday after 04-18": {
          name: {
            is: "Sumardagurinn fyrsti",
            en: "First Day of Summer"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "1st sunday in June": {
          name: {
            is: "Sjómannadagurinn",
            en: "The Seamen's Day"
          },
          type: "observance"
        },
        "06-17": {
          name: {
            is: "Íslenski þjóðhátíðardagurinn",
            en: "Icelandic National Day"
          }
        },
        "1st monday in August": {
          name: {
            is: "Frídagur verslunarmanna",
            en: "Commerce Day"
          }
        },
        "saturday after 10-21": {
          name: {
            is: "Fyrsti vetrardagur",
            en: "First Day of Winter"
          },
          type: "observance"
        },
        "11-16": {
          name: {
            is: "Dagur íslenskrar tungu",
            en: "Icelandic Language Day"
          },
          type: "observance"
        },
        "12-23": {
          name: {
            is: "Þorláksmessa",
            en: "St Þorlákur's Day"
          },
          type: "observance"
        },
        "12-24 13:00 if sunday then 00:00": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31 13:00 if sunday then 00:00": {
          _name: "12-31"
        }
      }
    },
    IT: {
      names: {
        it: "Italia",
        en: "Italia"
      },
      dayoff: "sunday",
      zones: [
        "Europe/Rome"
      ],
      langs: [
        "it"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-25": {
          name: {
            it: "Anniversario della Liberazione",
            en: "Liberation Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "06-02": {
          name: {
            it: "Festa della Repubblica",
            en: "Republic Day"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-08": {
          _name: "12-08"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "2011-03-17": {
          name: {
            it: "Festa Nazionale 2011",
            en: "National Day 2011"
          }
        }
      },
      states: {
        25: {
          name: "Lombardy",
          regions: {
            MI: {
              name: "Milan",
              days: {
                "12-07": {
                  name: {
                    it: "Sant'Ambrogio",
                    en: "Saint Ambrose"
                  }
                }
              }
            }
          }
        },
        32: {
          name: "Südtirol, Alto Adige",
          days: {
            "easter 50": {
              _name: "easter 50"
            }
          }
        }
      }
    },
    JE: {
      names: {
        en: "Jersey"
      },
      zones: [
        "Europe/Jersey"
      ],
      langs: [
        "en"
      ],
      _days: [
        "GB"
      ],
      days: {
        "05-09": {
          name: {
            en: "Liberation Day"
          }
        }
      }
    },
    JM: {
      names: {
        en: "Jamaica"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "America/Jamaica"
      ],
      days: {
        "01-01 and if sunday then next monday": {
          _name: "01-01",
          substitute: !0
        },
        "easter -46": {
          _name: "easter -46"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-23 if saturday,sunday then next monday": {
          _name: "05-01"
        },
        "08-01 if sunday then next monday": {
          name: {
            en: "Emancipation Day"
          }
        },
        "08-06 and if sunday then next monday": {
          _name: "Independence Day",
          substitute: !0
        },
        "3rd monday in October": {
          name: {
            en: "National Heroes Day"
          }
        },
        "12-25 and if sunday then next tuesday": {
          _name: "12-25",
          substitute: !0
        },
        "12-26 and if sunday then next monday": {
          _name: "12-26",
          substitute: !0
        }
      }
    },
    JP: {
      names: {
        jp: "日本",
        en: "Japan"
      },
      dayoff: "sunday",
      langs: [
        "jp"
      ],
      zones: [
        "Asia/Tokyo"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if sunday then next monday": {
          substitute: !0,
          _name: "01-01",
          active: [
            {
              from: "1973-04-12T00:00:00.000Z"
            }
          ]
        },
        "01-02": {
          name: {
            en: "January 2nd",
            jp: "銀行休業日"
          },
          type: "bank"
        },
        "01-03": {
          name: {
            en: "January 3rd",
            jp: "銀行休業日"
          },
          type: "bank"
        },
        "01-15": {
          name: {
            en: "Coming of Age Day",
            jp: "成人の日"
          },
          active: [
            {
              from: "1948-07-20T00:00:00.000Z",
              to: "1999-12-31T00:00:00.000Z"
            }
          ]
        },
        "substitutes 01-15 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Coming of Age Day",
            jp: "成人の日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z",
              to: "1999-12-31T00:00:00.000Z"
            }
          ]
        },
        "2nd monday in January": {
          name: {
            en: "Coming of Age Day",
            jp: "成人の日"
          },
          active: [
            {
              from: "2000-01-01T00:00:00.000Z"
            }
          ]
        },
        "02-11": {
          name: {
            en: "Foundation Day",
            jp: "建国記念の日"
          },
          active: [
            {
              from: "1967-01-01T00:00:00.000Z"
            }
          ]
        },
        "substitutes 02-11 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Foundation Day",
            jp: "建国記念の日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z"
            }
          ]
        },
        "02-23 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Emperor's Birthday",
            jp: "天皇誕生日"
          },
          active: [
            {
              from: "2020-01-01T00:00:00.000Z"
            }
          ]
        },
        "1989-02-24": {
          name: {
            en: "State Funeral of Emperor Showa",
            jp: "大喪の礼"
          }
        },
        "march equinox in +09:00": {
          name: {
            en: "Spring Equinox Day",
            jp: "春分の日"
          },
          active: [
            {
              from: "1948-07-20T00:00:00.000Z"
            }
          ]
        },
        "substitutes march equinox in +09:00 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Spring Equinox Day",
            jp: "春分の日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z"
            }
          ]
        },
        "1959-04-10": {
          name: {
            en: "Marriage of Crown Prince Akihito",
            jp: "結婚の儀"
          }
        },
        "04-29": {
          name: {
            en: "Emperor's Birthday",
            jp: "天皇誕生日"
          },
          active: [
            {
              from: "1948-07-20T00:00:00.000Z",
              to: "1988-12-31T00:00:00.000Z"
            }
          ]
        },
        "substitutes 04-29 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Emperor's Birthday",
            jp: "天皇誕生日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z",
              to: "1988-12-31T00:00:00.000Z"
            }
          ]
        },
        "04-29 and if sunday then next monday #1": {
          substitute: !0,
          name: {
            en: "Greenery Day",
            jp: "みどりの日"
          },
          active: [
            {
              from: "1989-01-01T00:00:00.000Z",
              to: "2006-12-31T00:00:00.000Z"
            }
          ]
        },
        "04-29 and if sunday then next monday #2": {
          substitute: !0,
          name: {
            en: "Showa Day",
            jp: "昭和の日"
          },
          active: [
            {
              from: "2007-01-01T00:00:00.000Z"
            }
          ]
        },
        "2019-04-30": {
          name: {
            en: "Citizens' Holiday",
            jp: "国民の休日"
          }
        },
        "2019-05-01": {
          name: {
            en: "Coronation Day",
            jp: "即位の日"
          }
        },
        "2019-05-02": {
          name: {
            en: "Citizens' Holiday",
            jp: "国民の休日"
          }
        },
        "05-03": {
          _name: "Constitution Day"
        },
        "substitutes 05-03 if sunday then next monday": {
          substitute: !0,
          _name: "Constitution Day",
          active: [
            {
              from: "1973-04-12T00:00:00.000Z",
              to: "2006-12-31T00:00:00.000Z"
            }
          ]
        },
        "substitutes 05-03 if sunday then next wednesday": {
          substitute: !0,
          _name: "Constitution Day",
          active: [
            {
              from: "2007-01-01T00:00:00.000Z"
            }
          ]
        },
        "05-04 not on sunday, monday": {
          name: {
            en: "Citizens' Holiday",
            jp: "国民の休日"
          },
          active: [
            {
              from: "1986-01-01T00:00:00.000Z",
              to: "2006-12-31T00:00:00.000Z"
            }
          ]
        },
        "05-04 and if sunday then next tuesday": {
          substitute: !0,
          name: {
            en: "Greenery Day",
            jp: "みどりの日"
          },
          active: [
            {
              from: "2007-01-01T00:00:00.000Z"
            }
          ]
        },
        "05-05": {
          name: {
            en: "Children's Day",
            jp: "こどもの日"
          }
        },
        "substitutes 05-05 if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Children's Day",
            jp: "こどもの日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z"
            }
          ]
        },
        "1993-06-09": {
          name: {
            en: "Marriage of Crown Prince Naruhito",
            jp: "結婚の儀"
          }
        },
        "07-20": {
          name: {
            en: "Marine Day",
            jp: "海の日"
          },
          active: [
            {
              from: "1996-01-01T00:00:00.000Z",
              to: "2002-12-31T00:00:00.000Z"
            }
          ]
        },
        "substitutes 07-20 if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Marine Day",
            jp: "海の日"
          },
          active: [
            {
              from: "1996-01-01T00:00:00.000Z",
              to: "2002-12-31T00:00:00.000Z"
            }
          ]
        },
        "3rd monday in July": {
          name: {
            en: "Marine Day",
            jp: "海の日"
          },
          disable: [
            "2020-07-20",
            "2021-07-19"
          ],
          enable: [
            "2020-07-23",
            "2021-07-22"
          ],
          active: [
            {
              from: "2003-01-01T00:00:00.000Z"
            }
          ]
        },
        "substitutes 2021-08-08 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Mountain Day",
            jp: "山の日"
          }
        },
        "substitutes 08-11 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Mountain Day",
            jp: "山の日"
          },
          disable: [
            "2020-08-11",
            "2021-08-11"
          ],
          enable: [
            "2020-08-10"
          ],
          active: [
            {
              from: "2016-01-01T00:00:00.000Z"
            }
          ]
        },
        "09-15": {
          name: {
            en: "Respect-for-the-Aged Day",
            jp: "敬老の日"
          },
          active: [
            {
              from: "1966-01-01T00:00:00.000Z",
              to: "2002-12-31T00:00:00.000Z"
            }
          ]
        },
        "substitutes 09-15 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Respect-for-the-Aged Day",
            jp: "敬老の日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z",
              to: "2002-12-31T00:00:00.000Z"
            }
          ]
        },
        "3rd monday in September": {
          name: {
            en: "Respect-for-the-Aged Day",
            jp: "敬老の日"
          },
          active: [
            {
              from: "2003-01-01T00:00:00.000Z"
            }
          ]
        },
        "09-22 if 09-21 and 09-23 is public holiday": {
          name: {
            en: "Citizens' Holiday",
            jp: "国民の休日"
          }
        },
        "september equinox in +09:00": {
          name: {
            en: "Autumnal Equinox Day",
            jp: "秋分の日"
          },
          active: [
            {
              from: "1948-07-20T00:00:00.000Z"
            }
          ]
        },
        "substitutes september equinox in +09:00 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Autumnal Equinox Day",
            jp: "秋分の日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z"
            }
          ]
        },
        "10-10": {
          name: {
            en: "Sports Day",
            jp: "体育の日"
          },
          active: [
            {
              from: "1966-01-01T00:00:00.000Z",
              to: "1999-12-31T00:00:00.000Z"
            }
          ]
        },
        "substitutes 10-10 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Sports Day",
            jp: "体育の日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z",
              to: "1999-12-31T00:00:00.000Z"
            }
          ]
        },
        "2nd monday in October #1": {
          name: {
            en: "Sports Day",
            jp: "体育の日"
          },
          active: [
            {
              from: "2000-01-01T00:00:00.000Z",
              to: "2019-12-31T00:00:00.000Z"
            }
          ]
        },
        "2nd monday in October #2": {
          name: {
            en: "Sports Day",
            jp: "スポーツの日"
          },
          disable: [
            "2020-10-12",
            "2021-10-11"
          ],
          enable: [
            "2020-07-24",
            "2021-07-23"
          ],
          active: [
            {
              from: "2020-01-01T00:00:00.000Z"
            }
          ]
        },
        "2019-10-22": {
          name: {
            en: "Enthronement Ceremony Day",
            jp: "即位礼正殿の儀"
          }
        },
        "11-03": {
          substitute: !0,
          name: {
            en: "Culture Day",
            jp: "文化の日"
          },
          active: [
            {
              from: "1948-07-20T00:00:00.000Z"
            }
          ]
        },
        "substitutes 11-03 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Culture Day",
            jp: "文化の日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z"
            }
          ]
        },
        "1990-11-12": {
          name: {
            en: "Official Enthronement Ceremony of Emperor Heisei (Akihito)",
            jp: "即位礼正殿の儀"
          }
        },
        "11-15": {
          name: {
            en: "Seven-Five-Three Festival",
            jp: "七五三"
          },
          type: "observance"
        },
        "11-23": {
          name: {
            en: "Labor Thanksgiving Day",
            jp: "勤労感謝の日"
          },
          active: [
            {
              from: "1948-07-20T00:00:00.000Z"
            }
          ]
        },
        "substitutes 11-23 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Labor Thanksgiving Day",
            jp: "勤労感謝の日"
          },
          active: [
            {
              from: "1973-04-12T00:00:00.000Z"
            }
          ]
        },
        "12-23 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Emperor's Birthday",
            jp: "天皇誕生日"
          },
          active: [
            {
              from: "1989-01-01T00:00:00.000Z",
              to: "2018-12-31T00:00:00.000Z"
            }
          ]
        },
        "12-25": {
          _name: "12-25",
          type: "observance"
        },
        "12-31": {
          _name: "12-31",
          type: "bank"
        }
      }
    },
    KE: {
      names: {
        en: "Kenya"
      },
      dayoff: "sunday",
      langs: [
        "sw",
        "en"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      days: {
        "01-01 and if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01 and if sunday then next monday": {
          substitute: !0,
          _name: "05-01"
        },
        "06-01 and if sunday then next monday": {
          substitute: !0,
          name: {
            sw: "Siku ya Madaraka",
            en: "Madaraka Day"
          }
        },
        "10-10 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Moi Day"
          }
        },
        "10-20 and if sunday then next monday": {
          substitute: !0,
          name: {
            sw: "Siku ya Mashujaa",
            en: "Mashujaa Day"
          }
        },
        "12-12 and if sunday then next monday": {
          substitute: !0,
          name: {
            sw: "Siku ya Jamhuri",
            en: "Jamhuri Day"
          }
        },
        "12-25 and if sunday then next tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if sunday then next monday": {
          substitute: !0,
          _name: "12-26"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          note: "For all persons belonging to the Islamic faith."
        }
      }
    },
    KM: {
      names: {
        fr: "Union des Comores",
        en: "Comoros"
      },
      langs: [
        "fr",
        "ar",
        "swb",
        "wlc",
        "wni",
        "zdj"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-18": {
          name: {
            fr: "Journée de Cheikh Al Maarouf",
            en: "Cheikh Al Maarouf Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "07-06": {
          _name: "Independence Day"
        },
        "11-12": {
          name: {
            fr: "Journée Maoré",
            en: "Maore Day"
          }
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal P3DT0H0M": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah P2DT0H0M": {
          _name: "10 Dhu al-Hijjah"
        },
        "27 Rajab": {
          _name: "27 Rajab"
        }
      }
    },
    KN: {
      names: {
        en: "St. Kitts & Nevis"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Saturday then next Monday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-02": {
          name: {
            en: "Carnival Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "1st Monday in May": {
          _name: "05-01"
        },
        "1st Monday in August": {
          name: {
            en: "Emancipation Day"
          }
        },
        "1st Tuesday in August": {
          name: {
            en: "Culturama Day"
          }
        },
        "09-16 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "National Heroes' Day"
          }
        },
        "09-19 if Sunday then next Monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    KR: {
      names: {
        ko: "대한민국",
        en: "South Korea"
      },
      dayoff: "sunday",
      langs: [
        "ko"
      ],
      zones: [
        "Asia/Seoul"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "korean 01-0-01 P3D": {
          name: {
            en: "Korean New Year",
            ko: "설날"
          }
        },
        "03-01": {
          name: {
            en: "Independence Movement Day",
            ko: "3·1절"
          }
        },
        "05-05": {
          name: {
            en: "Children's Day",
            ko: "어린이날"
          }
        },
        "korean 4-0-8": {
          name: {
            en: "Buddha's Birthday",
            ko: "석가탄신일"
          }
        },
        "06-06": {
          name: {
            en: "Memorial Day",
            ko: "현충일"
          }
        },
        "07-17": {
          _name: "Constitution Day",
          type: "observance"
        },
        "08-15": {
          name: {
            en: "Liberation Day",
            ko: "광복절"
          }
        },
        "korean 8-0-15 P3D": {
          name: {
            en: "Korean Thanksgiving",
            ko: "추석"
          }
        },
        "10-03": {
          name: {
            en: "National Foundation Day",
            ko: "개천절"
          }
        },
        "10-09": {
          name: {
            en: "Hangul Day",
            ko: "한글날"
          }
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    KY: {
      names: {
        en: "Cayman Islands"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Panama"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "01-01"
        },
        "4th Monday in January": {
          name: {
            en: "National Heroes Day"
          }
        },
        "easter -46": {
          _name: "easter -46"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "3rd Monday in May": {
          name: {
            en: "Discovery Day"
          }
        },
        "07-02": {
          name: {
            en: "Constitution Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "2017-05-24": {
          name: "General Election Day"
        },
        "2021-04-14": {
          name: "General Election Day"
        },
        "2016-06-13": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2017-06-19": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2018-06-11": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2019-06-10": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2020-06-15": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2021-06-14": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2022-06-20": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2023-06-19": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2024-06-17": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2025-06-16": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "2026-06-15": {
          name: {
            en: "Queen's Birthday"
          }
        }
      }
    },
    LC: {
      names: {
        en: "St. Lucia"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-02": {
          name: {
            en: "Second New Year's Day"
          }
        },
        "02-22": {
          _name: "Independence Day"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "1st Friday after 07-10 P4D": {
          name: {
            en: "Carnival"
          }
        },
        "08-01": {
          name: {
            en: "Emancipation Day"
          }
        },
        "1st Monday in October": {
          name: {
            en: "Thanksgiving"
          }
        },
        "12-13": {
          name: {
            en: "National Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    LI: {
      names: {
        de: "Lichtenstein",
        en: "Lichtenstein"
      },
      dayoff: "sunday",
      langs: [
        "de"
      ],
      zones: [
        "Europe/Zurich"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-02": {
          name: {
            de: "Berchtoldstag",
            en: "Berchtold Day"
          },
          type: "bank"
        },
        "01-06": {
          _name: "01-06"
        },
        "02-02": {
          _name: "02-02",
          type: "observance"
        },
        "03-19": {
          _name: "03-19",
          type: "observance"
        },
        "easter -47": {
          _name: "easter -47",
          type: "bank"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 39": {
          _name: "easter 39",
          name: {
            de: "Auffahrt"
          }
        },
        "easter 40": {
          name: {
            de: "Feiertagsbrücke"
          }
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "easter 61": {
          name: {
            de: "Feiertagsbrücke"
          }
        },
        "08-15": {
          name: {
            de: "Staatsfeiertag"
          },
          type: "observance"
        },
        "09-08": {
          name: {
            de: "Mariä Geburt"
          }
        },
        "11-01": {
          _name: "11-01",
          type: "observance"
        },
        "12-08": {
          _name: "12-08"
        },
        "12-24": {
          _name: "12-24",
          type: "bank"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26",
          name: {
            de: "Stephanstag"
          }
        },
        "12-31": {
          _name: "12-31",
          type: "bank"
        }
      }
    },
    LR: {
      names: {
        en: "Liberia"
      },
      langs: [
        "en"
      ],
      zones: [
        "Africa/Monrovia"
      ],
      dayoff: "Sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-11": {
          name: {
            en: "Armed Forces Day"
          }
        },
        "2nd Wednesday in March": {
          name: {
            en: "Decoration Day"
          }
        },
        "03-15": {
          name: {
            en: "J. J. Robert's Day"
          }
        },
        "2nd Friday in April": {
          name: {
            en: "Fast and Prayer Day"
          }
        },
        "05-14": {
          name: {
            en: "National Unification Day"
          }
        },
        "07-26": {
          _name: "Independence Day"
        },
        "08-24": {
          name: {
            en: "Flag Day"
          }
        },
        "1st Thursday in November": {
          name: {
            en: "Thanksgiving"
          }
        },
        "11-29": {
          name: {
            en: "William Tubman's Birthday"
          }
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    LS: {
      names: {
        st: "\\'Muso oa Lesotho",
        en: "Lesotho"
      },
      langs: [
        "st",
        "en"
      ],
      zones: [
        "Africa/Johannesburg"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-11": {
          name: {
            en: "Moshoeshoe Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01",
          name: {
            en: "Workers' Day"
          }
        },
        "easter 39": {
          _name: "easter 39"
        },
        "05-25": {
          name: {
            en: "Africa Day/ Heroes' Day"
          }
        },
        "07-17": {
          name: {
            en: "King Letsie III's Birthday"
          }
        },
        "10-04": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    LT: {
      names: {
        lt: "Lietuva",
        en: "Lithuania"
      },
      dayoff: "sunday",
      langs: [
        "lt"
      ],
      zones: [
        "Europe/Vilnius"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-16": {
          name: {
            en: "Day of Restoration of the State of Lithuania",
            lt: "Lietuvos valstybės atkūrimo diena"
          }
        },
        "03-11": {
          name: {
            en: "Day of Restoration of Independence of Lithuania",
            lt: "Lietuvos nepriklausomybės atkūrimo diena"
          }
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "1st sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "1st sunday in June": {
          _name: "Fathers Day",
          type: "observance"
        },
        "06-24": {
          name: {
            en: "St. John's Day",
            lt: "Joninės, Rasos"
          }
        },
        "07-06": {
          name: {
            en: "Statehood Day",
            lt: "Valstybės diena"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "11-02": {
          _name: "11-02",
          active: [
            {
              from: 2020
            }
          ]
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    LU: {
      names: {
        fr: "Luxembourg",
        en: "Luxembourg",
        de: "Luxemburg",
        lb: "Lëtzebuerg",
        pt: "Luxemburgo"
      },
      langs: [
        "fr",
        "de",
        "lb"
      ],
      zones: [
        "Europe/Luxembourg"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-23": {
          _name: "National Holiday",
          active: [
            {
              from: "1947-08-08",
              to: "1961-12-23"
            }
          ]
        },
        "easter -2": {
          _name: "easter -2",
          type: "observance"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1",
          active: [
            {
              from: "1892-02-16"
            }
          ]
        },
        "05-01": {
          _name: "05-01",
          name: {
            fr: "1er mai"
          },
          active: [
            {
              from: "1946-04-23"
            }
          ]
        },
        "05-09": {
          _name: "05-09",
          active: [
            {
              from: "2019-01-01"
            }
          ]
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 50": {
          _name: "easter 50",
          active: [
            {
              from: "1892-02-16"
            }
          ]
        },
        "06-23": {
          _name: "National Holiday",
          active: [
            {
              from: "1961-12-23"
            }
          ]
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26",
          active: [
            {
              from: "1892-02-16"
            }
          ]
        }
      }
    },
    LV: {
      names: {
        lv: "Latvija",
        en: "Latvia"
      },
      dayoff: "sunday",
      langs: [
        "lv"
      ],
      zones: [
        "Europe/Riga"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-04 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            en: "Restoration of Independence day",
            lv: "Latvijas Republikas Neatkarības atjaunošanas diena"
          }
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "06-23": {
          name: {
            en: "Midsummer Eve",
            lv: "Līgo Diena"
          }
        },
        "06-24": {
          name: {
            en: "Midsummer",
            lv: "Jāņi"
          }
        },
        "11-18 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            en: "Republic Day",
            lv: "Latvijas Republikas proklamēšanas diena"
          }
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31": {
          _name: "12-31"
        },
        "2023-05-29": {
          name: {
            en: "Bronze medal of the Latvian hockey team at the 2023 World Hockey Championship",
            lv: "Latvijas hokeja komandas 2023. gada Pasaules hokeja čempionātā bronzas medaļa"
          }
        }
      }
    },
    LY: {
      names: {
        ar: "دولة ليبيا",
        en: "Libya"
      },
      langs: [
        "ar"
      ],
      zones: [
        "Africa/Tripoli"
      ],
      dayoff: "",
      days: {
        "02-17": {
          _name: "Revolution Day"
        },
        "05-01": {
          _name: "05-01"
        },
        "09-16": {
          name: {
            ar: "يوم الشهداء",
            en: "Martyrs' Day"
          }
        },
        "10-23": {
          _name: "Liberation Day"
        },
        "12-24": {
          _name: "Independence Day"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal P3D": {
          _name: "1 Shawwal"
        },
        "9 Dhu al-Hijjah": {
          _name: "9 Dhu al-Hijjah"
        },
        "10 Dhu al-Hijjah P3D": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    MA: {
      names: {
        ar: "المملكة المغربية",
        fr: "Royaume du Maroc",
        en: "Kingdom of Morocco"
      },
      langs: [
        "ar",
        "ber",
        "fr"
      ],
      zones: [
        "Africa/Casablanca"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-11": {
          name: {
            fr: "Manifeste de l'indépendance",
            ar: "ذكرى تقديم وثيقة الاستقلال",
            en: "Anniversary of the Independence Manifesto"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "07-30": {
          name: {
            fr: "Fête du trône",
            ar: "عيد العرش",
            en: "Feast of the Throne"
          }
        },
        "08-14": {
          name: {
            fr: "Journée de Oued Ed-Dahab",
            ar: "يوم وادي الذهب",
            en: "Anniversary of the Recovery Oued Ed-Dahab"
          }
        },
        "08-20": {
          name: {
            fr: "Fête de la révolution du roi et du peuple",
            ar: "ثورة الملك والشعب",
            en: "Anniversary of the Revolution of the King and the People"
          }
        },
        "08-21": {
          name: {
            fr: "Journée de la jeunesse",
            ar: "عيد الشباب",
            en: "Youth Day"
          }
        },
        "11-06": {
          name: {
            fr: "La Marche verte",
            ar: "المسيرة الخضراء",
            en: "Anniversary of the Green March"
          }
        },
        "11-18": {
          _name: "Independence Day",
          name: {
            fr: "Fête de l'indépendance"
          }
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    MC: {
      names: {
        fr: "Monaco",
        en: "Monaco"
      },
      dayoff: "sunday",
      langs: [
        "fr"
      ],
      zones: [
        "Europe/Monaco"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-27 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Saint Devota's Day",
            fr: "Sainte Dévote"
          }
        },
        "easter -2": {
          _name: "easter -2",
          type: "observance"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01 and if sunday then next monday": {
          substitute: !0,
          _name: "05-01",
          name: {
            fr: "1er mai"
          }
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "11-19 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "H.S.H. the Sovereign Prince's Day",
            fr: "La Fête du Prince"
          }
        },
        "12-08": {
          _name: "12-08"
        },
        "12-25 and if sunday then next monday": {
          substitute: !0,
          _name: "12-25"
        }
      }
    },
    MD: {
      names: {
        ro: "Republica Moldova",
        en: "Moldova"
      },
      langs: [
        "ro"
      ],
      zones: [
        "Europe/Chisinau"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "julian 12-25 P2D": {
          _name: "julian 12-25",
          name: {
            ro: "Craciun pe Rit Vechi"
          }
        },
        "03-08": {
          _name: "03-08"
        },
        orthodox: {
          _name: "easter"
        },
        "orthodox 1": {
          _name: "easter 1"
        },
        "orthodox 8": {
          name: {
            ro: "Paştele Blăjinilor",
            en: "Memorial Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "05-09": {
          name: {
            ro: "Ziua Victoriei",
            en: "Victory Day"
          }
        },
        "08-27": {
          _name: "Independence Day"
        },
        "08-31": {
          name: {
            ro: "Limba noastră",
            en: "National Language Day"
          }
        },
        "1st saturday in October P2D": {
          name: {
            ro: "Ziua vinului",
            en: "Wine Day"
          },
          type: "observance",
          active: [
            {
              from: 2013
            }
          ]
        },
        "12-25": {
          _name: "12-25",
          name: {
            ro: "Craciun pe stil Nou"
          }
        }
      },
      states: {
        CA: {
          name: "Cahul",
          days: {
            "11-21": {
              name: {
                ro: "Ziua Cahul",
                en: "Cahul Day"
              }
            }
          }
        },
        CU: {
          name: "Chișinău",
          days: {
            "10-14": {
              name: {
                ro: "Ziua capitalului",
                en: "Capital's Day"
              }
            }
          }
        }
      }
    },
    ME: {
      names: {
        hr: "Crna Gora",
        sr: "Црна Гора",
        bs: "Crna Gora",
        sq: "Mali i Zi",
        en: "Montenegro"
      },
      dayoff: "sunday",
      langs: [
        "hr",
        "sr",
        "bs",
        "sq"
      ],
      zones: [
        "Europe/Belgrade"
      ],
      days: {
        "05-21 and if sunday then next tuesday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "05-22 and if sunday then next monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "07-13 and if sunday then next tuesday": {
          substitute: !0,
          name: {
            hr: "Dan državnosti",
            sr: "Дан државности",
            en: "Statehood Day"
          }
        },
        "07-14 and if sunday then next monday": {
          substitute: !0,
          name: {
            hr: "Dan državnosti",
            sr: "Дан државности",
            en: "Statehood Day"
          }
        },
        "01-01 and if sunday then next tuesday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-02 and if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "05-01 and if sunday then next tuesday": {
          substitute: !0,
          _name: "05-01"
        },
        "05-02 and if sunday then next monday": {
          substitute: !0,
          _name: "05-01"
        },
        "julian 12-24": {
          _name: "12-24"
        },
        "julian 12-25": {
          _name: "12-25"
        },
        "julian 12-26": {
          _name: "12-26"
        },
        "julian 01-01": {
          _name: "julian 01-01",
          type: "observance"
        },
        "orthodox -2": {
          _name: "easter -2"
        },
        orthodox: {
          _name: "easter"
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-25"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter"
        },
        "08-15": {
          _name: "08-15",
          type: "observance"
        },
        "11-01": {
          _name: "11-01"
        },
        "1 Shawwal P3D": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah P3D": {
          _name: "10 Dhu al-Hijjah"
        },
        "1 Muharram": {
          _name: "1 Muharram",
          type: "observance"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal",
          type: "observance"
        },
        "27 Rajab": {
          _name: "27 Rajab",
          type: "observance"
        },
        "15 Shaban": {
          _name: "15 Shaban",
          type: "observance"
        },
        "1 Ramadan": {
          _name: "1 Ramadan",
          type: "observance"
        },
        "27 Ramadan": {
          _name: "27 Ramadan",
          type: "observance"
        },
        "15 Nisan P2D": {
          _name: "15 Nisan"
        },
        "1 Tishrei": {
          _name: "1 Tishrei",
          type: "observance"
        },
        "10 Tishrei P2D": {
          _name: "10 Tishrei"
        }
      }
    },
    MF: {
      names: {
        en: "St. Martin",
        fr: "Saint Martin"
      },
      langs: [
        "fr"
      ],
      zones: [
        "America/Marigot"
      ],
      dayoff: "sunday",
      _days: "FR",
      days: {
        "05-27": {
          name: {
            fr: "Abolition de l'esclavage",
            en: "abolition of slavery"
          }
        }
      }
    },
    MG: {
      names: {
        mg: "Repoblikan'i Madagasikara",
        fr: "République de Madagascar",
        en: "Madagascar"
      },
      dayoff: "sunday",
      langs: [
        "mg",
        "fr",
        "en"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-08": {
          name: {
            mg: "Andro iraisam-pirenena ho an'ny vehivavy",
            fr: "Journée internationale de la femme",
            en: "International Women's Day"
          },
          note: "only for women"
        },
        "03-29": {
          name: {
            mg: "Martioran'ny tolona tamin'ny 1947",
            fr: "Commémoration des martyrs de l'insurrection de 1947.",
            en: "Martyrs' Day"
          }
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-25": {
          name: {
            mg: "Andron'i Afrika",
            fr: "Jour de l'Afrique",
            en: "Africa Day"
          }
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "06-26": {
          _name: "Independence Day",
          name: {
            mg: "Fetim-pirenena",
            fr: "Fête Nationale"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal",
          note: "For Muslim"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          note: "For Muslim"
        }
      }
    },
    MK: {
      names: {
        mk: "Република Македонија",
        en: "Macedonia"
      },
      langs: [
        "mk"
      ],
      zones: [
        "Europe/Belgrade"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "julian 12-25 and if sunday then next monday": {
          substitute: !0,
          _name: "julian 12-25"
        },
        orthodox: {
          _name: "orthodox"
        },
        "orthodox 1": {
          _name: "orthodox 1"
        },
        "05-01 and if sunday then next monday": {
          substitute: !0,
          _name: "05-01"
        },
        "05-24 and if sunday then next monday": {
          substitute: !0,
          name: {
            mk: "Св. Кирил и Методиј",
            en: "Saints Cyril and Methodius Day"
          }
        },
        "08-02 and if sunday then next monday": {
          substitute: !0,
          name: {
            mk: "Ден на Републиката",
            en: "Day of the Republic"
          }
        },
        "09-08 and if sunday then next monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "10-11 and if sunday then next monday": {
          substitute: !0,
          name: {
            mk: "Ден на востанието",
            en: "Revolution Day"
          }
        },
        "10-23 and if sunday then next monday": {
          substitute: !0,
          name: {
            mk: "Ден на македонската револуционерна борба",
            en: "Day of the Macedonian Revolutionary Struggle"
          }
        },
        "12-08 and if sunday then next monday": {
          substitute: !0,
          name: {
            mk: "Св. Климент Охридски",
            en: "Saint Clement of Ohrid Day"
          }
        },
        "1 Shawwal and if sunday then next monday": {
          substitute: !0,
          _name: "1 Shawwal"
        },
        "julian 12-24": {
          _name: "julian 12-24",
          type: "optional",
          note: "Orthodox believers"
        },
        "julian 01-06": {
          _name: "01-06",
          type: "optional",
          note: "Orthodox believers"
        },
        "orthodox -2": {
          _name: "orthodox -2",
          type: "optional",
          note: "Orthodox believers"
        },
        "orthodox 47": {
          name: {
            mk: "петок пред Духовден",
            en: "Friday before Pentecost"
          },
          type: "optional",
          note: "Orthodox believers"
        },
        "orthodox 49": {
          _name: "easter 49",
          type: "optional",
          note: "Orthodox believers"
        },
        "julian 08-15": {
          _name: "08-15",
          type: "optional",
          note: "Orthodox believers"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          type: "optional",
          note: "Muslim believers"
        },
        "10 Tishrei": {
          _name: "10 Tishrei",
          type: "optional",
          note: "Jewish believers"
        },
        "easter 1": {
          _name: "easter 1",
          type: "optional",
          note: "Catholic believers"
        },
        "11-01": {
          _name: "11-01",
          type: "optional",
          note: "Catholic believers"
        },
        "12-25": {
          _name: "12-25",
          type: "optional",
          note: "Catholic believers"
        },
        "11-22": {
          name: {
            mk: "Ден на Албанската азбука",
            en: "Day of the Albanian Alphabet"
          },
          type: "optional",
          note: "For members of the Albanian community"
        },
        "12-21": {
          name: {
            mk: "Ден на настава на турски јазик",
            en: "Turkish Language Day"
          },
          type: "optional",
          note: "For members of the the Turkish community"
        },
        "01-27": {
          name: {
            mk: "Свети Сава",
            en: "St. Sava"
          },
          type: "optional",
          note: "For members of the Serbian community"
        },
        "04-08": {
          name: {
            mk: "Меѓународен ден на Ромите",
            en: "International Roma Day"
          },
          type: "optional",
          note: "For members of the the Roma community"
        },
        "05-23": {
          name: {
            mk: "Национален ден на Властите",
            en: "National Day of Authorities"
          },
          type: "optional",
          note: "For members of the Vlach community"
        },
        "09-28": {
          name: {
            mk: "Меѓународен ден на Бошњаците",
            en: "International Day of Bosniaks"
          },
          type: "optional",
          note: "For Members of the Bosniak community."
        }
      }
    },
    ML: {
      names: {
        fr: "République du Mali",
        en: "Republic of Mali"
      },
      langs: [
        "fr",
        "en"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-20": {
          name: {
            fr: "Fête de l'armée",
            en: "Army Day"
          }
        },
        "03-26": {
          name: {
            fr: "Journée des Martyrs",
            en: "Martyrs' Day"
          }
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "05-25": {
          name: "Jour de l'Afrique"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "09-22": {
          _name: "Independence Day",
          name: {
            fr: "Fête nationale de l'indépendance"
          }
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        }
      }
    },
    MQ: {
      names: {
        fr: "Martinique",
        en: "Martinique"
      },
      langs: [
        "fr"
      ],
      zones: [
        "America/Martinique"
      ],
      dayoff: "sunday",
      _days: "FR",
      days: {
        "easter -2": {
          _name: "easter -2"
        },
        "05-22": {
          _name: "Abolition of Slavery"
        },
        "07-21": {
          name: {
            fr: "Jour de Victor Schoelcher",
            en: "Victor Shoelcher Day"
          }
        }
      }
    },
    MR: {
      names: {
        ar: "الجمهورية الإسلامية الموريتانية",
        en: "Mauritania"
      },
      langs: [
        "ar",
        "fr"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-25": {
          name: {
            ar: "يوم افريقيا",
            en: "Africa Day"
          }
        },
        "11-28": {
          _name: "Independence Day"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah P3D": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    MS: {
      names: {
        en: "Montserrat"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "01-01"
        },
        "03-17 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Saint Patrick's Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "1st Monday in May": {
          _name: "05-01"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "2nd Monday after 06-02": {
          name: {
            en: "Queen's Birthday Celebration"
          }
        },
        "08-01 if Saturday, Sunday then next Monday": {
          name: {
            en: "Emancipation Day"
          }
        },
        "12-25 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-26"
        },
        "12-31 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-31",
          name: {
            en: "Festival Day"
          }
        }
      }
    },
    MT: {
      names: {
        mt: "Malta",
        en: "Malta"
      },
      dayoff: "sunday",
      langs: [
        "mt"
      ],
      zones: [
        "Europe/Malta"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-10": {
          name: {
            en: "Feast of Saint Paul's Shipwreck in Malta",
            mt: "Nawfraġju ta' San Pawl"
          }
        },
        "03-19": {
          _name: "03-19"
        },
        "03-31": {
          name: {
            en: "Freedom Day",
            mt: "Jum il-Ħelsien"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "05-01": {
          _name: "05-01"
        },
        "06-07": {
          name: {
            mt: "Sette Giugno",
            en: "June 7th"
          }
        },
        "06-29": {
          _name: "06-29"
        },
        "08-15": {
          _name: "08-15"
        },
        "09-08": {
          name: {
            en: "Victory Day",
            mt: "Jum il-Vitorja"
          }
        },
        "09-21": {
          _name: "Independence Day"
        },
        "12-08": {
          _name: "12-08"
        },
        "12-13": {
          name: {
            en: "Republic Day",
            mt: "Jum ir-Repubblika"
          }
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    MW: {
      names: {
        en: "Malawi"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "Africa/Maputo"
      ],
      days: {
        "01-01 and if saturday,sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-15 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            en: "John Chilembwe Day"
          }
        },
        "03-03 and if saturday,sunday then next monday": {
          name: {
            en: "Martyrs' Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01 and if saturday,sunday then next monday": {
          _name: "05-01"
        },
        "05-14 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            en: "Kamuzu Day"
          }
        },
        "07-06 and if saturday,sunday then next monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "10-15 and if saturday,sunday then next monday": {
          substitute: !0,
          _name: "Mothers Day"
        },
        "12-25 and if saturday,sunday then next monday": {
          substitute: !0,
          _name: "12-25"
        },
        "1 Shawwal and if saturday,sunday then next monday": {
          substitute: !0,
          _name: "1 Shawwal",
          name: {
            en: "Eid al Fitri"
          }
        }
      }
    },
    MX: {
      names: {
        es: "México",
        en: "Mexico"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Mexico_City",
        "America/Cancun",
        "America/Merida",
        "America/Monterrey",
        "America/Matamoros",
        "America/Mazatlan",
        "America/Chihuahua",
        "America/Ojinaga",
        "America/Hermosillo",
        "America/Tijuana",
        "America/Santa_Isabel",
        "America/Bahia_Banderas"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-05": {
          _name: "Constitution Day"
        },
        "1st monday in February": {
          name: {
            en: "Constitution Day (day off)",
            es: "Día de la Constitución (día libre)"
          }
        },
        "03-21": {
          name: {
            en: "Benito Juárez's birthday",
            es: "Natalicio de Benito Juárez"
          }
        },
        "3rd monday in March": {
          name: {
            en: "Benito Juárez's birthday (day off)",
            es: "Natalicio de Benito Juárez (día libre)"
          }
        },
        "easter -3": {
          _name: "easter -3",
          type: "bank"
        },
        "easter -2": {
          _name: "easter -2",
          type: "bank"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-10": {
          _name: "Mothers Day",
          type: "observance"
        },
        "09-16": {
          _name: "Independence Day"
        },
        "11-02": {
          _name: "11-02",
          type: "bank"
        },
        "11-20": {
          _name: "Revolution Day"
        },
        "3rd monday in November": {
          name: {
            en: "Revolution Day (day off)",
            es: "Día de la Revolución (día libre)"
          }
        },
        "12-01 every 6 years since 1934": {
          name: {
            en: "Change of Federal Government",
            es: "Transmisión del Poder Ejecutivo Federal"
          }
        },
        "12-12": {
          name: {
            en: "Day of the Virgin of Guadalupe",
            es: "Día de la Virgen de Guadalupe"
          },
          type: "bank"
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    MY: {
      names: {
        en: "Malaysia"
      },
      langs: [
        "ms"
      ],
      zones: [
        "Asia/Kuala_Lumpur",
        "Asia/Kuching"
      ],
      dayoff: "Saturday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if Sunday then next Monday": {
          substitute: !0,
          _name: "01-01"
        },
        "chinese 01-0-01": {
          name: {
            en: "Chinese New Year",
            ms: "Tahun Baru Cina"
          }
        },
        "chinese 01-0-02": {
          name: {
            en: "Chinese New Year",
            ms: "Tahun Baru Cina"
          }
        },
        "substitutes chinese 01-0-01 if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Chinese New Year",
            ms: "Tahun Baru Cina"
          }
        },
        "substitutes chinese 01-0-02 if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Chinese New Year",
            ms: "Tahun Baru Cina"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "substitutes 05-01 if Sunday then next Monday": {
          substitute: !0,
          _name: "05-01"
        },
        "1st Monday in June": {
          name: {
            en: "Yang di-Pertuan Agong's Birthday",
            ms: "Hari Keputeraan Yang di-Pertuan Agong"
          }
        },
        "08-31": {
          _name: "Independence Day"
        },
        "substitutes 08-31 if Sunday then next Monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "09-16": {
          name: {
            en: "Malaysia Day",
            ms: "Hari Malaysia"
          }
        },
        "substitutes 09-16 if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Malaysia Day",
            ms: "Hari Malaysia"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "substitutes 12-25 if Sunday then next Monday": {
          substitute: !0,
          _name: "12-25"
        },
        "17 Ramadan": {
          _name: "17 Ramadan",
          disable: [
            "2022-04-18"
          ],
          enable: [
            "2022-04-19"
          ]
        },
        "1 Shawwal": {
          _name: "1 Shawwal",
          disable: [
            "2022-05-02"
          ],
          enable: [
            "2022-05-03"
          ]
        },
        "2 Shawwal": {
          _name: "1 Shawwal",
          disable: [
            "2022-05-03"
          ],
          enable: [
            "2022-05-04"
          ]
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          disable: [
            "2022-07-09"
          ],
          enable: [
            "2022-07-10"
          ]
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal",
          disable: [
            "2022-10-08"
          ],
          enable: [
            "2022-10-09"
          ]
        },
        "2010-05-28": {
          _name: "Vesak"
        },
        "2011-05-17": {
          _name: "Vesak"
        },
        "2012-05-06": {
          _name: "Vesak"
        },
        "2013-05-25": {
          _name: "Vesak"
        },
        "2014-05-15": {
          _name: "Vesak"
        },
        "2015-06-02": {
          _name: "Vesak"
        },
        "2016-05-22": {
          _name: "Vesak"
        },
        "2017-05-10": {
          _name: "Vesak"
        },
        "2018-05-29": {
          _name: "Vesak"
        },
        "2019-05-19": {
          _name: "Vesak"
        },
        "2020-05-07": {
          _name: "Vesak"
        },
        "2021-05-26": {
          _name: "Vesak"
        },
        "2022-05-15": {
          _name: "Vesak"
        },
        "2022-05-16": {
          substitute: !0,
          _name: "Vesak"
        },
        "2023-05-04": {
          _name: "Vesak"
        },
        "2024-05-22": {
          _name: "Vesak"
        },
        "2025-05-12": {
          _name: "Vesak"
        },
        "2026-05-31": {
          _name: "Vesak"
        },
        "2016-10-29": {
          _name: "Deepavali"
        },
        "2017-10-18": {
          _name: "Deepavali"
        },
        "2018-11-06": {
          _name: "Deepavali"
        },
        "2019-10-27": {
          _name: "Deepavali"
        },
        "2019-10-28": {
          substitute: !0,
          _name: "Deepavali"
        },
        "2020-11-14": {
          _name: "Deepavali"
        },
        "2021-11-04": {
          _name: "Deepavali"
        },
        "2022-10-24": {
          _name: "Deepavali"
        },
        "2023-11-12": {
          _name: "Deepavali"
        },
        "2023-11-13": {
          substitute: !0,
          _name: "Deepavali"
        },
        "2024-10-31": {
          _name: "Deepavali"
        },
        "2025-10-20": {
          _name: "Deepavali"
        },
        "2026-11-09": {
          _name: "Deepavali"
        },
        "2027-10-28": {
          _name: "Deepavali"
        },
        "2028-11-15": {
          _name: "Deepavali"
        },
        "2029-11-05": {
          _name: "Deepavali"
        },
        "2030-10-25": {
          _name: "Deepavali"
        }
      },
      states: {
        10: {
          name: "Selangor",
          days: {
            "12-11": {
              name: {
                en: "Sultan of Selangor's Birthday",
                id: "Hari Keputeraan Sultan Selangor"
              }
            },
            "2016-01-24": {
              _name: "Thaipusam"
            },
            "2017-02-10": {
              _name: "Thaipusam"
            },
            "2018-01-31": {
              _name: "Thaipusam"
            },
            "2019-01-21": {
              _name: "Thaipusam"
            },
            "2020-02-08": {
              _name: "Thaipusam"
            },
            "2021-01-28": {
              _name: "Thaipusam"
            },
            "2022-01-18": {
              _name: "Thaipusam"
            },
            "2023-02-05": {
              _name: "Thaipusam"
            },
            "2024-01-25": {
              _name: "Thaipusam"
            },
            "2025-02-11": {
              _name: "Thaipusam"
            },
            "2026-02-01": {
              _name: "Thaipusam"
            }
          }
        },
        11: {
          name: "Terengganu",
          days: {
            "01-01": !1,
            "03-04": {
              name: {
                en: "Anniversary of Installation of the Sultan of Terengganu",
                ms: "Hari Ulang Tahun Pertabalan Sultan Terengganu"
              }
            },
            "04-26": {
              name: {
                en: "Sultan of Terengganu's Birthday",
                ms: "Hari Keputeraan Sultan Terengganu"
              }
            },
            "27 Rajab": {
              _name: "27 Rajab"
            },
            "9 Dhu al-Hijjah": {
              _name: "9 Dhu al-Hijjah"
            },
            "11 Dhu al-Hijjah": {
              _name: "10 Dhu al-Hijjah"
            }
          }
        },
        12: {
          name: "Sabah",
          days: {
            "easter -2": {
              _name: "easter -2"
            },
            "05-30": {
              name: {
                en: "Tadau Kaamatan",
                ms: "Pesta Kaamatan"
              }
            },
            "05-31": {
              name: {
                en: "Tadau Kaamatan",
                ms: "Pesta Kaamatan"
              }
            },
            "1st Saturday in October": {
              name: {
                en: "Sabah State Governor's Birthday",
                ms: "Hari Jadi Yang di-Pertua Negeri Sabah"
              }
            },
            "12-24": {
              _name: "12-24"
            },
            "17 Ramadan": !1
          }
        },
        13: {
          name: "Sarawak",
          days: {
            "2016-10-29": !1,
            "2017-10-18": !1,
            "2018-11-06": !1,
            "2019-10-27": !1,
            "2020-11-14": !1,
            "2021-11-04": !1,
            "2022-10-24": !1,
            "2023-11-13": !1,
            "2024-10-31": !1,
            "2025-10-20": !1,
            "2026-11-09": !1,
            "2027-10-28": !1,
            "2028-11-15": !1,
            "2029-11-05": !1,
            "2030-10-25": !1,
            "easter -2": {
              _name: "easter -2"
            },
            "06-01": {
              name: {
                en: "Gawai Dayak",
                ms: "Perayaan Hari Gawai Dayak"
              }
            },
            "06-02": {
              name: {
                en: "Gawai Dayak",
                ms: "Perayaan Hari Gawai Dayak"
              }
            },
            "07-22": {
              name: {
                en: "Sarawak Independence Day",
                ms: "Hari Kemerdekaan Sarawak"
              }
            },
            "2nd Saturday in October": {
              name: {
                en: "Sarawak State Governor's Birthday",
                ms: "Hari Jadi Yang di-Pertua Negeri Sarawak"
              }
            },
            "17 Ramadan": !1
          }
        },
        14: {
          name: "Kuala Lumpur",
          days: {
            "02-01": {
              name: {
                en: "Federal Territory Day",
                ms: "Hari Wilayah Persekutuan"
              }
            },
            "2016-01-24": {
              _name: "Thaipusam"
            },
            "2017-02-10": {
              _name: "Thaipusam"
            },
            "2018-01-31": {
              _name: "Thaipusam"
            },
            "2019-01-21": {
              _name: "Thaipusam"
            },
            "2020-02-08": {
              _name: "Thaipusam"
            },
            "2021-01-28": {
              _name: "Thaipusam"
            },
            "2022-01-18": {
              _name: "Thaipusam"
            },
            "2023-02-05": {
              _name: "Thaipusam"
            },
            "2024-01-25": {
              _name: "Thaipusam"
            },
            "2025-02-11": {
              _name: "Thaipusam"
            },
            "2026-02-01": {
              _name: "Thaipusam"
            }
          }
        },
        15: {
          name: "Labuan",
          days: {
            "02-01": {
              name: {
                en: "Federal Territory Day",
                ms: "Hari Wilayah Persekutuan"
              }
            },
            "05-30": {
              name: {
                en: "Tadau Kaamatan",
                ms: "Pesta Kaamatan"
              }
            },
            "05-31": {
              name: {
                en: "Tadau Kaamatan",
                ms: "Pesta Kaamatan"
              }
            }
          }
        },
        16: {
          name: "Putrajaya",
          days: {
            "02-01": {
              name: {
                en: "Federal Territory Day",
                ms: "Hari Wilayah Persekutuan"
              }
            },
            "2016-01-24": {
              _name: "Thaipusam"
            },
            "2017-02-10": {
              _name: "Thaipusam"
            },
            "2018-01-31": {
              _name: "Thaipusam"
            },
            "2019-01-21": {
              _name: "Thaipusam"
            },
            "2020-02-08": {
              _name: "Thaipusam"
            },
            "2021-01-28": {
              _name: "Thaipusam"
            },
            "2022-01-18": {
              _name: "Thaipusam"
            },
            "2023-02-05": {
              _name: "Thaipusam"
            },
            "2024-01-25": {
              _name: "Thaipusam"
            },
            "2025-02-11": {
              _name: "Thaipusam"
            },
            "2026-02-01": {
              _name: "Thaipusam"
            }
          }
        },
        "01": {
          name: "Johor",
          days: {
            "01-01": !1,
            "03-23": {
              name: {
                en: "Sultan of Johor's Birthday",
                ms: "Hari Keputeraan Sultan Johor"
              }
            },
            "1 Ramadan": {
              _name: "1 Ramadan"
            },
            "17 Ramadan": !1,
            "6 Safar": {
              name: {
                en: "Hari Hol of Sultan Iskandar of Johor",
                ms: "Hari Hol Almarhum Sultan Iskandar"
              }
            },
            "2016-01-24": {
              _name: "Thaipusam"
            },
            "2017-02-10": {
              _name: "Thaipusam"
            },
            "2018-01-31": {
              _name: "Thaipusam"
            },
            "2019-01-21": {
              _name: "Thaipusam"
            },
            "2020-02-08": {
              _name: "Thaipusam"
            },
            "2021-01-28": {
              _name: "Thaipusam"
            },
            "2022-01-18": {
              _name: "Thaipusam"
            },
            "2023-02-05": {
              _name: "Thaipusam"
            },
            "2024-01-25": {
              _name: "Thaipusam"
            },
            "2025-02-11": {
              _name: "Thaipusam"
            },
            "2026-02-01": {
              _name: "Thaipusam"
            }
          }
        },
        "02": {
          name: "Kedah",
          days: {
            "01-01": !1,
            "3rd Sunday in June": {
              name: {
                en: "Sultan of Kedah's Birthday",
                ms: "Hari Keputeraan Sultan Kedah"
              }
            },
            "27 Rajab": {
              _name: "27 Rajab"
            },
            "1 Ramadan": {
              _name: "1 Ramadan"
            },
            "17 Ramadan": !1,
            "11 Dhu al-Hijjah": {
              _name: "10 Dhu al-Hijjah"
            },
            "2016-01-24": {
              _name: "Thaipusam"
            },
            "2017-02-10": {
              _name: "Thaipusam"
            },
            "2018-01-31": {
              _name: "Thaipusam"
            },
            "2019-01-21": {
              _name: "Thaipusam"
            },
            "2020-02-08": {
              _name: "Thaipusam"
            },
            "2021-01-28": {
              _name: "Thaipusam"
            },
            "2022-01-18": {
              _name: "Thaipusam"
            },
            "2023-02-05": {
              _name: "Thaipusam"
            },
            "2024-01-25": {
              _name: "Thaipusam"
            },
            "2025-02-11": {
              _name: "Thaipusam"
            },
            "2026-02-01": {
              _name: "Thaipusam"
            }
          }
        },
        "03": {
          name: "Kelantan",
          days: {
            "01-01": !1,
            "11 Dhu al-Hijjah": {
              _name: "10 Dhu al-Hijjah"
            },
            "11-11": {
              name: {
                en: "Sultan of Kelantan's Birthday",
                ms: "Hari Keputeraan Sultan Kelantan"
              }
            },
            "11-12": {
              name: {
                en: "Sultan of Kelantan's Birthday",
                ms: "Hari Keputeraan Sultan Kelantan"
              }
            }
          }
        },
        "04": {
          name: "Malacca",
          days: {
            "04-15": {
              name: {
                en: "Declaration of Malacca City as Historical City",
                ms: "Hari Perisytiharan Bandar Melaka sebagai Bandaraya Bersejarah"
              }
            },
            "08-24": {
              name: {
                en: "Melaka State Governor's Birthday",
                ms: "Hari Jadi Yang di-Pertua Negeri Melaka"
              }
            },
            "1 Ramadan": {
              _name: "1 Ramadan"
            },
            "17 Ramadan": !1
          }
        },
        "05": {
          name: "Negeri Sembilan",
          days: {
            "01-14": {
              name: {
                en: "Yang di-Pertuan Besar of Negeri Sembilan's Birthday",
                ms: "Hari Keputeraan Yang di-Pertuan Besar Negeri Sembilan"
              }
            },
            "27 Rajab": {
              _name: "27 Rajab"
            },
            "17 Ramadan": !1,
            "2016-01-24": {
              _name: "Thaipusam"
            },
            "2017-02-10": {
              _name: "Thaipusam"
            },
            "2018-01-31": {
              _name: "Thaipusam"
            },
            "2019-01-21": {
              _name: "Thaipusam"
            },
            "2020-02-08": {
              _name: "Thaipusam"
            },
            "2021-01-28": {
              _name: "Thaipusam"
            },
            "2022-01-18": {
              _name: "Thaipusam"
            },
            "2023-02-05": {
              _name: "Thaipusam"
            },
            "2024-01-25": {
              _name: "Thaipusam"
            },
            "2025-02-11": {
              _name: "Thaipusam"
            },
            "2026-02-01": {
              _name: "Thaipusam"
            }
          }
        },
        "06": {
          name: "Pahang",
          days: {
            "05-22": {
              name: {
                en: "Hari Hol of Pahang",
                ms: "Hari Hol Pahang"
              }
            },
            "07-30": {
              name: {
                en: "Sultan of Pahang's Birthday",
                ms: "Hari Keputeraan Sultan Pahang"
              }
            }
          }
        },
        "07": {
          name: "Penang",
          days: {
            "07-07": {
              name: {
                en: "Declaration of George Town as World Heritage Site",
                id: "Hari Ulang Tahun Perisytiharan Tapak Warisan Dunia"
              }
            },
            "2nd Saturday in July": {
              name: {
                en: "Penang State Governor's Birthday",
                ms: "Hari Jadi Yang di-Pertua Negeri Pulau Pinang"
              }
            },
            "2016-01-24": {
              _name: "Thaipusam"
            },
            "2017-02-10": {
              _name: "Thaipusam"
            },
            "2018-01-31": {
              _name: "Thaipusam"
            },
            "2019-01-21": {
              _name: "Thaipusam"
            },
            "2020-02-08": {
              _name: "Thaipusam"
            },
            "2021-01-28": {
              _name: "Thaipusam"
            },
            "2022-01-18": {
              _name: "Thaipusam"
            },
            "2023-02-05": {
              _name: "Thaipusam"
            },
            "2024-01-25": {
              _name: "Thaipusam"
            },
            "2025-02-11": {
              _name: "Thaipusam"
            },
            "2026-02-01": {
              _name: "Thaipusam"
            }
          }
        },
        "08": {
          name: "Perak",
          days: {
            "1st Friday in November": {
              name: {
                en: "Sultan of Perak's Birthday",
                ms: "Hari Keputeraan Sultan Perak"
              }
            },
            "2016-01-24": {
              _name: "Thaipusam"
            },
            "2017-02-10": {
              _name: "Thaipusam"
            },
            "2018-01-31": {
              _name: "Thaipusam"
            },
            "2019-01-21": {
              _name: "Thaipusam"
            },
            "2020-02-08": {
              _name: "Thaipusam"
            },
            "2021-01-28": {
              _name: "Thaipusam"
            },
            "2022-01-18": {
              _name: "Thaipusam"
            },
            "2023-02-05": {
              _name: "Thaipusam"
            },
            "2024-01-25": {
              _name: "Thaipusam"
            },
            "2025-02-11": {
              _name: "Thaipusam"
            },
            "2026-02-01": {
              _name: "Thaipusam"
            }
          }
        },
        "09": {
          name: "Perlis",
          days: {
            "01-01": !1,
            "07-17": {
              name: {
                en: "Raja of Perlis's Birthday",
                id: "Hari Keputeraan Raja Perlis"
              }
            },
            "27 Rajab": {
              _name: "27 Rajab"
            },
            "11 Dhu al-Hijjah": {
              _name: "10 Dhu al-Hijjah"
            }
          }
        }
      }
    },
    MZ: {
      names: {
        pt: "Moçambique",
        en: "Mozambique"
      },
      dayoff: "sunday",
      langs: [
        "pt"
      ],
      zones: [
        "Africa/Maputo"
      ],
      days: {
        "01-01": {
          _name: "01-01",
          name: {
            pt: "Dia da Fraternidade universal"
          }
        },
        "substitutes 01-01 if sunday then next monday": {
          _name: "Public Holiday"
        },
        "02-03": {
          name: {
            pt: "Dia dos heróis moçambicanos",
            en: "Heroes’ Day"
          }
        },
        "substitutes 02-03 if sunday then next monday": {
          _name: "Public Holiday"
        },
        "04-07": {
          name: {
            pt: "Dia da Mulher Moçambicana",
            en: "Women’s Day"
          }
        },
        "substitutes 04-07 if sunday then next monday": {
          _name: "Public Holiday"
        },
        "05-01": {
          _name: "05-01",
          name: {
            pt: "Dia Internacional dos Trabalhadores",
            en: "Workers' Day"
          }
        },
        "substitutes 05-01 if sunday then next monday": {
          _name: "Public Holiday"
        },
        "1st sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "06-25": {
          _name: "Independence Day",
          name: {
            pt: "Dia da Independência Nacional"
          }
        },
        "substitutes 06-25 if sunday then next monday": {
          _name: "Public Holiday"
        },
        "09-07": {
          name: {
            pt: "Dia da Vitória",
            en: "Lusaka Peace Agreement"
          }
        },
        "substitutes 09-07 if sunday then next monday": {
          _name: "Public Holiday"
        },
        "09-25": {
          name: {
            pt: "Dia das Forças Armadas de Libertação Nacional",
            en: "Defense Force’s Day"
          }
        },
        "substitutes 09-25 if sunday then next monday": {
          _name: "Public Holiday"
        },
        "10-04": {
          name: {
            pt: "Dia da Paz e Reconciliação",
            en: "Peace and Reconciliation Day"
          }
        },
        "substitutes 10-04 if sunday then next monday": {
          _name: "Public Holiday"
        },
        "12-25": {
          _name: "12-25",
          name: {
            pt: "Dia da Família",
            en: "Family Day"
          }
        },
        "substitutes 12-25 if sunday then next monday": {
          _name: "Public Holiday"
        }
      }
    },
    NA: {
      names: {
        en: "Namibia"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "Africa/Windhoek"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if sunday then next monday": {
          name: "Public Holiday"
        },
        "03-21": {
          _name: "Independence Day"
        },
        "substitutes 03-21 if sunday then next monday": {
          name: "Public Holiday"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01",
          name: {
            en: "Workers Day"
          }
        },
        "substitutes 05-01 if sunday then next monday": {
          name: "Public Holiday"
        },
        "05-04": {
          name: {
            en: "Cassinga Day"
          }
        },
        "substitutes 05-04 if sunday then next monday": {
          name: "Public Holiday"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "05-25": {
          name: {
            en: "Africa Day"
          }
        },
        "substitutes 05-25 if sunday then next monday": {
          name: "Public Holiday"
        },
        "08-26": {
          name: {
            en: "Heroes' Day"
          }
        },
        "substitutes 08-26 if sunday then next monday": {
          name: "Public Holiday"
        },
        "12-10": {
          name: {
            en: "Human Rights Day"
          }
        },
        "substitutes 12-10 if sunday then next monday": {
          name: "Public Holiday"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26",
          name: {
            en: "Day of Goodwill"
          }
        },
        "substitutes 12-26 if sunday then next monday": {
          name: "Public Holiday"
        }
      }
    },
    NC: {
      names: {
        fr: "Nouvelle-Calédonie",
        en: "New Caledonia"
      },
      dayoff: "sunday",
      zones: [
        "Pacific/Noumea"
      ],
      langs: [
        "fr"
      ],
      _days: "FR",
      days: {
        "01-01": {
          name: {
            fr: "Jour de l'an"
          }
        },
        "09-24": {
          name: {
            fr: "Fête de la Citonneyeté",
            en: "New Caledonia Day"
          }
        }
      }
    },
    NE: {
      names: {
        fr: "République du Niger",
        en: "Republic of the Niger"
      },
      langs: [
        "fr"
      ],
      zones: [
        "Africa/Lagos"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "04-24": {
          name: {
            fr: "Journée Nationale de la Concorde",
            en: "Concord Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "08-03": {
          _name: "Independence Day",
          name: {
            fr: "Proclamation de l'indépendance"
          }
        },
        "12-18": {
          name: {
            fr: "Proclamation de la République",
            en: "Republic Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "27 Ramadan": {
          _name: "27 Ramadan"
        }
      }
    },
    NG: {
      names: {
        en: "Nigeria"
      },
      langs: [
        "en"
      ],
      zones: [
        "Africa/Lagos"
      ],
      dayoff: "Saturday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "05-01 and if Saturday then next Monday": {
          substitute: !0,
          _name: "05-01",
          name: {
            en: "Worker's Day"
          }
        },
        "05-27": {
          name: {
            en: "Children's Day",
            type: "school"
          }
        },
        "05-29 prior to 2018": {
          name: {
            en: "Democracy Day"
          }
        },
        "06-12 prior to 2018": {
          name: {
            en: "M.K.O Abiola Day"
          }
        },
        "06-12 and if Saturday then next Monday since 2018": {
          substitute: !0,
          name: {
            en: "Democracy Day"
          }
        },
        "10-01": {
          _name: "Independence Day"
        },
        "11-01 since 2020": {
          name: {
            en: "National Youth Day"
          }
        },
        "12-31": {
          _name: "12-31",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal P2D": {
          _name: "1 Shawwal",
          name: {
            en: "Id el Fitr"
          }
        },
        "10 Dhu al-Hijjah P2D": {
          _name: "10 Dhu al-Hijjah",
          name: {
            en: "Id el Kabir"
          }
        }
      }
    },
    NI: {
      names: {
        es: "Nicaragua",
        en: "Nicaragua"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Managua"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-18": {
          name: {
            en: "Birthday of Rubén Darío",
            es: "Natalicio de Rubén Darío"
          },
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-30": {
          _name: "Mothers Day",
          name: {
            es: "Día de la madre nicaragüense"
          },
          type: "observance"
        },
        "06-01": {
          name: {
            en: "Children's Day",
            es: "Día del niño"
          }
        },
        "06-23": {
          _name: "Fathers Day",
          name: {
            es: "Día del padre nicaragüense"
          },
          type: "observance"
        },
        "07-19": {
          name: {
            en: "Revolution Day",
            es: "Triunfo de la Revolución Popular"
          }
        },
        "09-14": {
          name: {
            en: "Battle of San Jacinto",
            es: "Batalla de San Jacinto"
          }
        },
        "09-15": {
          _name: "Independence Day"
        },
        "10-12": {
          name: {
            en: "Indigenous Resistance Day",
            es: "Día de la resistencia indígena"
          }
        },
        "12-08": {
          _name: "12-08"
        },
        "12-24": {
          _name: "12-24",
          type: "observance"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-31": {
          _name: "12-31",
          type: "observance"
        }
      }
    },
    NL: {
      names: {
        nl: "Nederland",
        en: "Netherlands",
        de: "Niederlande"
      },
      dayoff: "sunday",
      langs: [
        "nl"
      ],
      zones: [
        "Europe/Amsterdam"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2",
          type: "school"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-27 if sunday then previous saturday since 2014": {
          name: {
            nl: "Koningsdag",
            en: "King's Day",
            de: "Königstag"
          }
        },
        "04-30 if sunday then next monday since 1949 and prior to 1980": {
          name: {
            nl: "Koninginnedag",
            en: "Queen's Day",
            de: "Königinnentag"
          }
        },
        "04-30 if sunday then previous saturday since 1980 and prior to 2014": {
          name: {
            nl: "Koninginnedag",
            en: "Queen's Day",
            de: "Königinnentag"
          }
        },
        "05-04": {
          name: {
            nl: "Nationale Dodenherdenking",
            en: "Remembrance of the Dead",
            de: "Nationaler Totengedenktag"
          },
          type: "observance"
        },
        "05-05": {
          name: {
            nl: "Bevrijdingsdag",
            en: "Liberation Day",
            de: "Befreiungstag"
          },
          type: "school"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 39": {
          _name: "easter 39",
          name: {
            nl: "Hemelvaartsdag",
            en: "Ascension Day",
            de: "Christi Himmelfahrt"
          }
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "3rd sunday in June": {
          _name: "Fathers Day",
          type: "observance"
        },
        "08-31 since 1885 and prior to 1891": {
          name: {
            nl: "Princessedag",
            en: "Princess Day",
            de: "Prinzessinnentag"
          }
        },
        "08-31 since 1891 and prior to 1949": {
          name: {
            nl: "Koninginnedag",
            en: "Queen's Day",
            de: "Königinnentag"
          }
        },
        "3rd tuesday in September": {
          name: {
            nl: "Prinsjesdag",
            en: "Prince's Day",
            de: "Prinzentag"
          },
          note: "Scholen in Den Haag geven meestal 1 dag vrij",
          type: "observance"
        },
        "11-11": {
          _name: "11-11",
          type: "observance"
        },
        "12-05": {
          name: {
            nl: "Sinterklaasavond",
            en: "St Nicholas' Eve",
            de: "Nikolausabend"
          },
          type: "observance"
        },
        "12-15": {
          name: {
            nl: "Koninkrijksdag",
            en: "Kingdom Day",
            de: "Königreichstag"
          },
          type: "observance"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31": {
          _name: "12-31",
          type: "bank"
        }
      }
    },
    NO: {
      names: {
        no: "Norge",
        en: "Norway"
      },
      dayoff: "sunday",
      langs: [
        "no"
      ],
      zones: [
        "Europe/Oslo"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-21": {
          name: {
            no: "H.K.H. prinsesse Ingrid Alexandra",
            en: "Birthday of Princess Ingrid Alexandra"
          },
          type: "observance"
        },
        "02-06": {
          name: {
            no: "Samefolkets dag",
            en: "Day of the Sami people"
          },
          type: "observance"
        },
        "2nd sunday in February": {
          _name: "Mothers Day",
          type: "observance"
        },
        "02-14": {
          _name: "02-14",
          type: "observance"
        },
        "02-21": {
          name: {
            no: "H.M. kong Harald V",
            en: "Birthday of King Harald V"
          },
          type: "observance"
        },
        "easter -49": {
          name: {
            no: "Fastelavn",
            en: "Carnival"
          },
          type: "observance"
        },
        "easter -46": {
          _name: "easter -46",
          type: "observance"
        },
        "03-08": {
          _name: "03-08",
          type: "observance"
        },
        "easter -7": {
          _name: "easter -7",
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-01": {
          _name: "04-01",
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-08": {
          _name: "Liberation Day",
          type: "observance"
        },
        "05-17": {
          _name: "Constitution Day"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "06-07": {
          name: {
            no: "Unionsoppløsningen",
            en: "Union Dissolution Day"
          },
          type: "observance"
        },
        "06-23": {
          name: {
            no: "Sankthansaften",
            en: "Midsummar Eve"
          },
          type: "observance"
        },
        "07-04": {
          name: {
            no: "H.M. dronning Sonja",
            en: "Birthday of Queen Sonja"
          },
          type: "observance"
        },
        "07-20": {
          name: {
            no: "H.K.H. kronprins Haakon Magnus",
            en: "Birthday of Crown Prince Haakon Magnus"
          },
          type: "observance"
        },
        "07-29": {
          name: {
            no: "Olsok",
            en: "Olsok"
          },
          type: "optional"
        },
        "08-19": {
          name: {
            no: "H.K.H. kronprinsesse Mette-Marit",
            en: "Birthday of Crown Princess Mette-Marit"
          },
          type: "observance"
        },
        "1st sunday in November": {
          name: {
            no: "Allehelgensaften",
            en: "All Saints' Day"
          },
          type: "observance"
        },
        "2nd sunday in November": {
          _name: "Fathers Day",
          type: "observance"
        },
        "4th sunday before 12-25": {
          name: {
            no: "Første søndag i advent",
            en: "First Sunday of Advent"
          },
          type: "observance"
        },
        "3rd sunday before 12-25": {
          name: {
            no: "Andre søndag i advent",
            en: "Second Sunday of Advent"
          },
          type: "observance"
        },
        "2nd sunday before 12-25": {
          name: {
            no: "Tredje søndag i advent",
            en: "Third Sunday of Advent"
          },
          type: "observance"
        },
        "1st sunday before 12-25": {
          name: {
            no: "Fjerde søndag i advent",
            en: "Fourth Sunday of Advent"
          },
          type: "observance"
        },
        "12-24": {
          _name: "12-24",
          type: "bank"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31 14:00 if sunday then 00:00": {
          _name: "12-31",
          type: "bank"
        }
      }
    },
    NZ: {
      names: {
        en: "New Zealand",
        mi: "Aotearoa"
      },
      dayoff: "sunday",
      langs: [
        "en",
        "mi"
      ],
      zones: [
        "Pacific/Auckland",
        "Pacific/Chatham"
      ],
      days: {
        "01-01 and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-02 and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          name: {
            en: "Day after New Year's Day"
          }
        },
        "02-06 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            en: "Waitangi Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-25 and if saturday,sunday then next monday": {
          substitute: !0,
          name: {
            en: "ANZAC Day"
          }
        },
        "1st monday in June prior to 2023": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "1st monday in June since 2023": {
          name: {
            en: "King's Birthday"
          }
        },
        "4th monday in October": {
          _name: "05-01"
        },
        "12-25 and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if saturday then next monday if sunday then next tuesday": {
          substitute: !0,
          _name: "12-26"
        },
        "2022-06-24": {
          name: {
            en: "Matariki"
          }
        },
        "2023-07-14": {
          name: {
            en: "Matariki"
          }
        },
        "2024-06-28": {
          name: {
            en: "Matariki"
          }
        },
        "2025-06-20": {
          name: {
            en: "Matariki"
          }
        },
        "2026-07-10": {
          name: {
            en: "Matariki"
          }
        },
        "2027-06-25": {
          name: {
            en: "Matariki"
          }
        },
        "2028-07-14": {
          name: {
            en: "Matariki"
          }
        },
        "2029-07-06": {
          name: {
            en: "Matariki"
          }
        },
        "2030-06-21": {
          name: {
            en: "Matariki"
          }
        },
        "2031-07-11": {
          name: {
            en: "Matariki"
          }
        },
        "2032-07-02": {
          name: {
            en: "Matariki"
          }
        },
        "2033-06-24": {
          name: {
            en: "Matariki"
          }
        },
        "2034-07-07": {
          name: {
            en: "Matariki"
          }
        },
        "2035-06-29": {
          name: {
            en: "Matariki"
          }
        },
        "2036-07-18": {
          name: {
            en: "Matariki"
          }
        },
        "2037-07-10": {
          name: {
            en: "Matariki"
          }
        },
        "2038-06-25": {
          name: {
            en: "Matariki"
          }
        },
        "2039-07-15": {
          name: {
            en: "Matariki"
          }
        },
        "2040-07-06": {
          name: {
            en: "Matariki"
          }
        },
        "2041-07-19": {
          name: {
            en: "Matariki"
          }
        },
        "2042-07-11": {
          name: {
            en: "Matariki"
          }
        },
        "2043-07-03": {
          name: {
            en: "Matariki"
          }
        },
        "2044-06-24": {
          name: {
            en: "Matariki"
          }
        },
        "2045-07-07": {
          name: {
            en: "Matariki"
          }
        },
        "2046-06-29": {
          name: {
            en: "Matariki"
          }
        },
        "2047-07-19": {
          name: {
            en: "Matariki"
          }
        },
        "2048-07-03": {
          name: {
            en: "Matariki"
          }
        },
        "2049-06-25": {
          name: {
            en: "Matariki"
          }
        },
        "2050-07-15": {
          name: {
            en: "Matariki"
          }
        },
        "2051-06-30": {
          name: {
            en: "Matariki"
          }
        },
        "2052-06-21": {
          name: {
            en: "Matariki"
          }
        },
        "2022-09-26": {
          name: {
            en: "National Day of Mourning for Queen Elizabeth II"
          }
        }
      },
      states: {
        AUK: {
          names: {
            en: "Auckland Province",
            mi: "Tāmaki-makau-rau"
          },
          days: {
            "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        BOP: {
          names: {
            en: "Bay of Plenty",
            mi: "Te Moana-a-Toi"
          },
          days: {
            "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        CAN: {
          names: {
            en: "Canterbury",
            mi: "Waitaha"
          },
          days: {
            "friday after 2nd tuesday in November": {
              name: {
                en: "Christchurch Show Day"
              },
              note: "May differ in parts of North Canterbury"
            }
          },
          regions: {
            Timaru: {
              name: "Timaru District",
              days: {
                "friday after 2nd tuesday in November": !1,
                "4th monday in September": {
                  name: {
                    en: "Dominion Day"
                  }
                }
              }
            }
          }
        },
        CIT: {
          names: {
            en: "Chatham Islands",
            mi: "Wharekauri"
          },
          days: {
            "11-30 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        GIS: {
          names: {
            en: "Gisborne",
            mi: "Te Tai Rāwhiti"
          },
          days: {
            "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        HKB: {
          names: {
            en: "Hawke's Bay",
            mi: "Te Matau-a-Māui"
          },
          days: {
            "friday before 4th monday in October": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        MBH: {
          names: {
            en: "Marlborough",
            mi: "Te Tauihu-o-te-waka"
          },
          days: {
            "5th monday in October": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        MWT: {
          name: "Manawatu-Wanganui",
          days: {
            "01-22 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        NSN: {
          names: {
            en: "Nelson",
            mi: "Whakatū"
          },
          days: {
            "02-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        NTL: {
          names: {
            en: "Northland",
            mi: "Te Tai Tokerau"
          },
          days: {
            "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        OTA: {
          names: {
            en: "Otago Province",
            mi: "Ōtākou"
          },
          days: {
            "03-23 if Tuesday,Wednesday,Thursday then previous Monday if Friday,Saturday,Sunday then next Monday if is public holiday then next Monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        STL: {
          names: {
            en: "Southland",
            mi: "Murihiku"
          },
          days: {
            "easter 2": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        TAS: {
          names: {
            en: "Tasman",
            mi: "Te Tai-o-Aorere"
          },
          days: {
            "02-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        TKI: {
          name: "Taranaki",
          days: {
            "2nd monday in March": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        WKO: {
          name: "Waikato",
          days: {
            "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        WGN: {
          names: {
            en: "Wellington Province",
            mi: "Te Whanga-nui-a-Tara"
          },
          days: {
            "01-22 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          }
        },
        WTC: {
          names: {
            en: "Westland",
            mi: "Te Tai Poutini"
          },
          days: {
            "12-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
              name: {
                en: "Provincial anniversary day"
              }
            }
          },
          regions: {
            Buller: {
              name: "Buller district",
              days: {
                "12-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": !1,
                "02-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                  name: {
                    en: "Provincial anniversary day"
                  }
                }
              }
            }
          }
        }
      }
    },
    PA: {
      names: {
        es: "Panamá",
        en: "Panama"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Panama"
      ],
      days: {
        "01-01 and if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "01-09 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Martyrs' Day",
            es: "Día de los Mártires Caídos en la Gesta Patriótica"
          }
        },
        "easter -48": {
          _name: "easter -48",
          type: "observance"
        },
        "easter -47": {
          _name: "easter -47"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "05-01 and if sunday then next monday": {
          substitute: !0,
          _name: "05-01"
        },
        "07-01 every 5 years since 2014": {
          name: {
            en: "Presidential Inauguration"
          }
        },
        "11-03 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Separation Day (from Columbia)",
            es: "Día de la Separación (de Colombia)"
          }
        },
        "11-10 and if sunday then next monday": {
          substitute: !0,
          name: {
            es: "Primer Grito de Independencia"
          }
        },
        "11-28 and if sunday then next monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "12-08 and if sunday then next monday": {
          substitute: !0,
          _name: "Mothers Day"
        },
        "12-25 and if sunday then next monday": {
          substitute: !0,
          _name: "12-25"
        }
      }
    },
    PE: {
      names: {
        es: "Perú",
        en: "Peru"
      },
      dayoff: "sunday",
      langs: [
        "es",
        "qu"
      ],
      zones: [
        "America/Lima"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "05-01": {
          _name: "05-01"
        },
        "06-29": {
          _name: "06-29"
        },
        "07-28": {
          _name: "Independence Day"
        },
        "07-29": {
          _name: "Independence Day"
        },
        "08-30": {
          name: {
            en: "Santa Rosa de Lima",
            es: "Día de Santa Rosa de Lima"
          }
        },
        "10-08": {
          name: {
            en: "Battle of Angamos",
            es: "Combate de Angamos"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "12-08": {
          _name: "12-08"
        },
        "12-25": {
          _name: "12-25"
        }
      },
      regions: {
        CUS: {
          name: "Cuzco",
          days: {
            "06-24": {
              name: {
                en: "Festival of the Sun",
                es: "Fiesta Inca del Sol",
                qu: "Inti Raymi"
              },
              type: "observance"
            }
          }
        }
      }
    },
    PH: {
      names: {
        en: "Philippines"
      },
      langs: [
        "en",
        "fil"
      ],
      zones: [
        "Asia/Manila"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-23": {
          type: "observance",
          name: {
            en: "First Philippine Republic Day",
            fil: "Araw ng Unang Republika ng Pilipinas"
          }
        },
        "chinese 01-0-01": {
          type: "optional",
          name: {
            en: "Chinese New Year",
            fil: "Bagong Taon ng mga Tsino"
          }
        },
        "02-02": {
          type: "observance",
          _name: "Constitution Day"
        },
        "chinese 01-0-15": {
          type: "observance",
          name: {
            en: "Lantern Festival",
            fil: "Piyesta ng mga Parol Tsino"
          }
        },
        "02-25": {
          name: {
            en: "EDSA Revolution Anniversary",
            fil: "Anibersaryo ng Rebolusyon sa EDSA"
          },
          type: "optional",
          note: "Non-working Day"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1",
          type: "optional",
          note: "Non-working Day"
        },
        easter: {
          _name: "easter"
        },
        "04-09": {
          name: {
            en: "Day of Valor",
            fil: "Araw ng Kagitingan"
          }
        },
        "04-27": {
          type: "observance",
          name: {
            en: "Lapu-Lapu Day",
            fil: "Araw ni Lapu-Lapu"
          }
        },
        "05-01": {
          _name: "05-01",
          name: {
            en: "Labour Day",
            fil: "Araw ng mga Manggagawa"
          }
        },
        "06-12": {
          _name: "Independence Day"
        },
        "06-19": {
          type: "observance",
          name: {
            en: "José Rizal's birthday",
            fil: "Araw ng Kapanganakan ni José Rizal"
          },
          active: [
            {
              from: "1961-01-01T00:00:00.000Z"
            }
          ],
          disable: [
            "2011-06-19"
          ]
        },
        "2011-06-19": {
          name: {
            en: "José Rizal's birthday",
            fil: "Araw ng Kapanganakan ni José Rizal"
          }
        },
        "07-27": {
          type: "observance",
          name: {
            en: "Iglesia ni Cristo Day",
            fil: "Araw ng Iglesia ni Cristo"
          }
        },
        "08-21": {
          name: {
            en: "Ninoy Aquino Day",
            fil: "Araw ng Kabayanihan ni Ninoy Aquino"
          },
          type: "optional",
          note: "Non-working Day"
        },
        "1st monday before September": {
          name: {
            en: "National Heroes' Day",
            fil: "Araw ng mga Bayani"
          }
        },
        "chinese 08-0-15": {
          type: "observance",
          name: {
            en: "Mid-Autumn Festival",
            fil: "Piyestang Zhōngqiū Jié"
          }
        },
        "11-01": {
          _name: "11-01",
          type: "optional",
          note: "Non-working Day"
        },
        "11-02": {
          _name: "11-02",
          type: "optional",
          note: "Non-working Day"
        },
        "11-30": {
          name: {
            en: "Bonifacio Day",
            fil: "Araw ng Kapanganakan ni Bonifacio"
          }
        },
        "12-08": {
          _name: "12-08",
          name: {
            en: "Feast of the Immaculate Conception of the Blessed Virgin Mary",
            fil: "Pagdiriwang ng Kalinis-linisang Paglilihi sa Mahal na Birheng Maria"
          },
          type: "optional",
          note: "Non-working Day"
        },
        "12-24": {
          _name: "12-24",
          type: "optional",
          note: "Non-working Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-30": {
          name: {
            en: "Rizal Day",
            fil: "Paggunita sa Kamatayan ni Dr. Jose Rizal"
          }
        },
        "12-31": {
          _name: "12-31",
          type: "optional",
          note: "Non-working Day"
        },
        "1 Muharram": {
          type: "observance",
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          type: "observance",
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    PL: {
      names: {
        pl: "Polska",
        en: "Poland"
      },
      dayoff: "sunday",
      langs: [
        "pl"
      ],
      zones: [
        "Europe/Warsaw"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01",
          name: {
            pl: "Święto Państwowe; Święto Pracy"
          }
        },
        "05-03": {
          name: {
            pl: "Święto Narodowe Trzeciego Maja",
            en: "Constitution Day"
          }
        },
        "05-26": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "11-11": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    PM: {
      names: {
        en: "St. Pierre & Miquelon"
      },
      langs: [
        "fr"
      ],
      zones: [
        "America/Miquelon"
      ],
      dayoff: "sunday",
      days: {},
      _days: "FR"
    },
    PR: {
      names: {
        en: "Puerto Rico"
      },
      langs: [
        "es",
        "en"
      ],
      zones: [
        "America/Puerto_Rico"
      ],
      dayoff: "sunday",
      _days: "US",
      days: {
        "01-06": {
          _name: "01-06"
        },
        "2nd Monday in January": {
          name: {
            es: "Natalicio de Eugenio María de Hostos",
            en: "Birthday of Eugenio María de Hostos"
          }
        },
        "02-18": {
          name: {
            es: "Natalicio de Luis Muñoz Marín",
            en: "Birthday of Luis Muñoz Marín"
          }
        },
        "03-02 since 2017": {
          name: {
            es: "Día de la Ciudadanía Americana",
            en: "American Citizenship Day"
          }
        },
        "03-17": !1,
        "03-22": {
          name: {
            es: "Día de la Abolición de Esclavitud",
            en: "Emancipation Day"
          }
        },
        "04-16": {
          name: {
            es: "Natalicio de José de Diego",
            en: "Birthday of José de Diego"
          }
        },
        "3rd Monday in July": {
          name: {
            es: "Natalicio de Don Luis Muñoz Rivera",
            en: "Birthday of Don Luis Muñoz Rivera"
          }
        },
        "07-25": {
          name: {
            es: "Constitución de Puerto Rico",
            en: "Puerto Rico Constitution Day"
          }
        },
        "07-27": {
          name: {
            es: "Natalicio de Dr. José Celso Barbosa",
            en: "Birthday of Dr. José Celso Barbosa"
          }
        },
        "11-19": {
          name: {
            es: "Día del Descubrimiento de Puerto Rico",
            en: "Discovery of Puerto Rico"
          }
        }
      }
    },
    PT: {
      names: {
        pt: "Portugal",
        en: "Portugal"
      },
      dayoff: "sunday",
      langs: [
        "pt"
      ],
      zones: [
        "Europe/Lisbon",
        "Atlantic/Madeira",
        "Atlantic/Azores"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -47": {
          _name: "easter -47",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "04-25": {
          name: {
            pt: "Dia da Liberdade",
            en: "Liberty Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "1st sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "06-10": {
          name: {
            pt: "Dia de Portugal",
            en: "Portugal Day"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "10-05": {
          name: {
            pt: "Implantação da República"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "12-01": {
          name: {
            pt: "Restauração da Independência"
          }
        },
        "12-08": {
          _name: "12-08"
        },
        "12-24": {
          _name: "12-24",
          type: "observance"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-31": {
          _name: "12-31",
          type: "observance"
        }
      }
    },
    PY: {
      names: {
        es: "Paraguay",
        en: "Paraguay"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Asuncion"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "03-01": {
          disable: [
            "2017-03-01"
          ],
          enable: [
            "2017-02-27"
          ],
          name: {
            en: "Heroes' Day",
            es: "Dia de los héroes"
          }
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "04-30": {
          name: {
            en: "Teacher's Day",
            es: "Día del Maestro"
          },
          type: "optional",
          note: "Affects educational institutions"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-14": {
          _name: "Independence Day"
        },
        "05-15": {
          _name: "Independence Day"
        },
        "06-12": {
          name: {
            en: "Chaco Armistice",
            es: "Día de la Paz del Chaco"
          },
          disable: [
            "2020-06-12"
          ],
          enable: [
            "2020-06-15"
          ]
        },
        "08-15": {
          _name: "08-15",
          disable: [
            "2017-08-15"
          ],
          enable: [
            "2017-08-14"
          ]
        },
        "09-29": {
          disable: [
            "2017-09-29"
          ],
          enable: [
            "2017-10-02"
          ],
          name: {
            en: "Boqueron Battle Victory Day",
            es: "Victoria de Boquerón"
          }
        },
        "12-08": {
          _name: "12-08",
          name: {
            en: "Virgin of Caacupe",
            es: "Virgen de Caacupé"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-31": {
          _name: "12-31",
          type: "bank"
        }
      }
    },
    RE: {
      names: {
        fr: "Réunion",
        en: "Réunion"
      },
      langs: [
        "fr"
      ],
      zones: [
        "Indian/Reunion"
      ],
      dayoff: "",
      _days: "FR",
      days: {
        "12-20": {
          _name: "Abolition of Slavery"
        }
      }
    },
    RO: {
      names: {
        ro: "Romania",
        en: "Romania"
      },
      dayoff: "sunday",
      langs: [
        "ro"
      ],
      zones: [
        "Europe/Bucharest"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-24": {
          name: {
            ro: "Ziua Unirii",
            en: "Unification Day"
          }
        },
        "03-08": {
          name: {
            ro: "Ziua Mamei"
          },
          type: "observance"
        },
        "orthodox -2": {
          _name: "easter -2"
        },
        orthodox: {
          _name: "easter"
        },
        "orthodox 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "orthodox 39": {
          _name: "easter 39",
          type: "observance"
        },
        "orthodox 49": {
          _name: "easter 49"
        },
        "orthodox 50": {
          _name: "easter 50"
        },
        "1st sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "06-01": {
          name: {
            ro: "Ziua Copilului",
            en: "Children's Day"
          }
        },
        "06-26": {
          name: {
            ro: "Ziua drapelului national",
            en: "Flag Day"
          },
          type: "observance"
        },
        "07-29": {
          name: {
            ro: "Ziua Imnului național",
            en: "National Anthem Day"
          },
          type: "observance"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-30": {
          name: {
            ro: "Sfântul Andrei",
            en: "St Andrew's Day"
          }
        },
        "12-01": {
          name: {
            ro: "Ziua națională, Ziua Marii Uniri",
            en: "National holiday"
          }
        },
        "12-08": {
          _name: "Constitution Day",
          type: "observance"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    RS: {
      names: {
        sr: "Република Србија",
        en: "Serbia"
      },
      langs: [
        "sr"
      ],
      zones: [
        "Europe/Belgrade"
      ],
      dayoff: "sunday",
      days: {
        "01-01 if sunday then next tuesday": {
          _name: "01-01"
        },
        "01-02 if sunday then next monday": {
          _name: "01-01"
        },
        "julian 12-25": {
          _name: "julian 12-25"
        },
        "02-15 if sunday then next tuesday": {
          name: {
            sr: "Дан државности Србије",
            en: "Statehood Day"
          }
        },
        "02-16 if sunday then next monday": {
          name: {
            sr: "Дан државности Србије",
            en: "Statehood Day"
          }
        },
        "orthodox -2": {
          _name: "orthodox -2"
        },
        orthodox: {
          _name: "orthodox"
        },
        "orthodox 1": {
          _name: "orthodox 1"
        },
        "05-01 if sunday then next tuesday": {
          _name: "05-01"
        },
        "05-02 if sunday then next monday": {
          _name: "05-01"
        },
        "11-11 if sunday then next monday": {
          name: {
            sr: "Дан примирја",
            en: "Armistice Day"
          }
        },
        "easter -2": {
          _name: "easter -2",
          type: "optional",
          note: "Catholic believers"
        },
        easter: {
          _name: "easter",
          type: "optional",
          note: "Catholic believers"
        },
        "easter 1": {
          _name: "easter 1",
          type: "optional",
          note: "Catholic believers"
        },
        "12-25": {
          _name: "12-25",
          type: "optional",
          note: "Catholic believers"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          type: "optional",
          note: "Muslim believers"
        },
        "1 Shawwal": {
          _name: "1 Shawwal",
          type: "optional",
          note: "Muslim believers"
        },
        "10 Tishrei": {
          _name: "10 Tishrei",
          type: "optional",
          note: "Jewish believers"
        },
        "julian 01-14": {
          name: {
            sr: "Свети Сава",
            en: "Saint Sava Day"
          },
          type: "observance"
        },
        "04-22": {
          name: {
            sr: "Дан сећања на жртве холокауста",
            en: "Holocaust Remembrance Day"
          },
          type: "observance"
        },
        "05-09": {
          name: {
            sr: "Дан победе",
            en: "Victory Day"
          },
          type: "observance"
        },
        "julian 06-15": {
          name: {
            sr: "Видовдан",
            en: "Saint Vitus Day"
          },
          type: "observance"
        },
        "10-21": {
          name: {
            sr: "Дан сећања на српске жртве у Другом светском рату",
            en: "World War II Serbian Victims Remembrance Day"
          },
          type: "observance"
        }
      }
    },
    RU: {
      names: {
        ru: "Россия",
        en: "Russia"
      },
      dayoff: "sunday",
      langs: [
        "ru"
      ],
      zones: [
        "Europe/Moscow",
        "Europe/Kaliningrad",
        "Europe/Simferopol",
        "Europe/Volgograd",
        "Europe/Samara",
        "Asia/Yekaterinburg",
        "Asia/Omsk",
        "Asia/Novosibirsk",
        "Asia/Novokuznetsk",
        "Asia/Krasnoyarsk",
        "Asia/Irkutsk",
        "Asia/Chita",
        "Asia/Yakutsk",
        "Asia/Khandyga",
        "Asia/Vladivostok",
        "Asia/Sakhalin",
        "Asia/Ust-Nera",
        "Asia/Magadan",
        "Asia/Srednekolymsk",
        "Asia/Kamchatka",
        "Asia/Anadyr"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-02 P5D": {
          name: {
            ru: "Новогодние каникулы",
            en: "New Year Holiday"
          }
        },
        "julian 12-25": {
          _name: "12-25"
        },
        "01-08": {
          name: {
            ru: "Новогодние каникулы",
            en: "New Year Holiday"
          }
        },
        "02-23": {
          name: {
            ru: "День защитника Отечества",
            en: "Defender of the Fatherland Day"
          }
        },
        "03-08": {
          _name: "03-08"
        },
        "05-01": {
          name: {
            ru: "День весны и труда",
            en: "Spring and Labour Day"
          }
        },
        "05-09": {
          name: {
            ru: "День Победы",
            en: "Victory Day"
          }
        },
        "06-12": {
          name: {
            ru: "День России",
            en: "Russia Day"
          }
        },
        "11-04": {
          name: {
            ru: "День народного единства",
            en: "Unity Day"
          }
        }
      }
    },
    RW: {
      names: {
        en: "Rwanda",
        fr: "République du Rwanda",
        rw: "Repubulika y'u Rwanda"
      },
      dayoff: "sunday",
      langs: [
        "en",
        "fr",
        "rw"
      ],
      zones: [
        "Africa/Maputo"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-02": {
          _name: "Public Holiday"
        },
        "02-01": {
          name: {
            en: "Heroes Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "04-07": {
          name: {
            fr: "Jour de Mémorial du Génocide",
            en: "Genocide Memorial Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "07-01": {
          _name: "Independence Day"
        },
        "07-04": {
          name: {
            fr: "Jour de la Libération",
            en: "Liberation Day"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "1st friday in August": {
          name: {
            rw: "Umuganura",
            fr: "Journée nationale de récolte",
            en: "National Harvest Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    SC: {
      names: {
        en: "Seychelles",
        fr: "République des Seychelles",
        crs: "Repiblik Sesel"
      },
      langs: [
        "en",
        "fr",
        "crs"
      ],
      zones: [
        "Indian/Mahe"
      ],
      dayoff: "sunday",
      days: {
        "01-01 P2D": {
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "05-01": {
          _name: "05-01"
        },
        "06-18": {
          _name: "National Holiday"
        },
        "06-29": {
          _name: "Independence Day"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-08": {
          _name: "12-08"
        },
        "12-25": {
          _name: "12-25"
        }
      }
    },
    SD: {
      names: {
        ar: "جمهورية السودان",
        en: "Sudan"
      },
      langs: [],
      zones: [
        "Africa/Khartoum"
      ],
      dayoff: "",
      days: {
        "01-01": {
          _name: "Independence Day"
        },
        "12-19": {
          _name: "Revolution Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal P4D": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah P3D": {
          _name: "10 Dhu al-Hijjah"
        },
        "julian 12-25": {
          _name: "julian 12-25",
          name: {
            en: "Coptic Christmas"
          }
        },
        orthodox: {
          _name: "orthodox",
          name: {
            en: "Coptic Easter"
          }
        }
      }
    },
    SE: {
      names: {
        sv: "Sverige",
        en: "Sweden"
      },
      dayoff: "sunday",
      langs: [
        "sv"
      ],
      zones: [
        "Europe/Stockholm"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-05 12:00": {
          name: {
            sv: "Trettondagsafton",
            en: "Twelfth Night"
          },
          type: "optional"
        },
        "01-06": {
          _name: "01-06"
        },
        "01-13": {
          name: {
            sv: "Tjugondag Knut",
            en: "Saint Knut's Day"
          },
          type: "observance"
        },
        "1st sunday in March": {
          name: {
            sv: "Vasaloppet"
          },
          type: "observance"
        },
        "03-25": {
          name: {
            sv: "Marie Bebådelsedag",
            en: "Annunciation Day",
            lat: "Annuntiatio Mariæ"
          },
          type: "observance"
        },
        "04-30 12:00": {
          name: {
            sv: "Valborgsmässoafton",
            en: "Walpurgis Night"
          },
          type: "optional"
        },
        "easter -3": {
          _name: "easter -3",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter -1": {
          _name: "easter -1",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 48": {
          name: {
            sv: "Pingstafton",
            en: "Whitsun Eve"
          },
          type: "observance"
        },
        "easter 49": {
          _name: "easter 49",
          type: "public"
        },
        "easter 50": {
          _name: "easter 50",
          type: "observance"
        },
        "sunday before 06-01": {
          _name: "Mothers Day",
          type: "observance"
        },
        "06-06": {
          name: {
            sv: "Sveriges nationaldag",
            en: "National Day"
          }
        },
        "friday after 06-19": {
          name: {
            sv: "Midsommarafton",
            en: "Midsummer Eve",
            fi: "Juhannusaatto"
          },
          type: "bank"
        },
        "saturday after 06-20": {
          name: {
            sv: "Midsommardagen",
            en: "Midsummer Day",
            fi: "Juhannuspäivä"
          }
        },
        "friday after 10-30 12:00": {
          name: {
            sv: "Allhelgonaafton",
            en: "Halloween"
          },
          type: "optional"
        },
        "saturday after 10-31": {
          _name: "11-01"
        },
        "11-06": {
          name: {
            sv: "Gustav-Adolf-dagen",
            en: "Gustavus Adolphus Day"
          },
          type: "observance"
        },
        "11-11": {
          name: {
            sv: "Mårtensgås",
            en: "Saint Martin's Day"
          },
          type: "observance"
        },
        "12-10": {
          name: {
            sv: "Nobeldagen",
            en: "Nobel Day"
          },
          type: "observance"
        },
        "12-13": {
          name: {
            sv: "Luciadagen",
            en: "Saint Lucy's Day"
          },
          type: "observance"
        },
        "12-24": {
          _name: "12-24",
          type: "bank"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31": {
          _name: "12-31",
          type: "bank"
        }
      }
    },
    SG: {
      names: {
        en: "Singapore"
      },
      langs: [
        "en"
      ],
      zones: [
        "Asia/Singapore"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "chinese 01-0-01": {
          name: {
            en: "Chinese New Year"
          }
        },
        "chinese 01-0-02": {
          name: {
            en: "Chinese New Year"
          }
        },
        "substitutes chinese 01-0-01 if sunday then next tuesday": {
          substitute: !0,
          name: {
            en: "Chinese New Year"
          }
        },
        "substitutes chinese 01-0-02 if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Chinese New Year"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "05-01": {
          _name: "05-01"
        },
        "substitutes 05-01 if sunday then next monday": {
          substitute: !0,
          _name: "05-01"
        },
        "08-09": {
          name: {
            en: "National Day"
          }
        },
        "substitutes 08-09 if sunday then next monday": {
          substitute: !0,
          name: {
            en: "National Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "substitutes 12-25 if sunday then next monday": {
          substitute: !0,
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal",
          name: {
            en: "Hari Raya Puasa"
          },
          disable: [
            "2022-05-02",
            "2023-04-21",
            "2024-04-09"
          ],
          enable: [
            "2022-05-03",
            "2023-04-22",
            "2024-04-10"
          ]
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah",
          name: {
            en: "Hari Raya Haji"
          },
          disable: [
            "2022-07-09",
            "2023-06-28",
            "2024-06-29"
          ],
          enable: [
            "2022-07-10",
            "2023-06-29",
            "2024-06-17"
          ]
        },
        "2001-05-07": {
          _name: "Vesak"
        },
        "2002-05-27": {
          _name: "Vesak"
        },
        "2003-05-15": {
          _name: "Vesak"
        },
        "2004-06-02": {
          _name: "Vesak"
        },
        "2005-05-23": {
          _name: "Vesak"
        },
        "2006-05-12": {
          _name: "Vesak"
        },
        "2007-05-31": {
          _name: "Vesak"
        },
        "2008-05-19": {
          _name: "Vesak"
        },
        "2009-05-09": {
          _name: "Vesak"
        },
        "2010-05-28": {
          _name: "Vesak"
        },
        "2011-05-17": {
          _name: "Vesak"
        },
        "2012-05-05": {
          _name: "Vesak"
        },
        "2013-05-24": {
          _name: "Vesak"
        },
        "2014-05-13": {
          _name: "Vesak"
        },
        "2015-06-01": {
          _name: "Vesak"
        },
        "2016-05-21": {
          _name: "Vesak"
        },
        "2017-05-10": {
          _name: "Vesak"
        },
        "2018-05-29": {
          _name: "Vesak"
        },
        "2019-05-19": {
          _name: "Vesak"
        },
        "2019-05-20": {
          substitute: !0,
          _name: "Vesak"
        },
        "2020-05-07": {
          _name: "Vesak"
        },
        "2021-05-26": {
          _name: "Vesak"
        },
        "2022-05-15": {
          _name: "Vesak"
        },
        "2022-05-16": {
          substitute: !0,
          _name: "Vesak"
        },
        "2023-06-02": {
          _name: "Vesak"
        },
        "2024-05-22": {
          _name: "Vesak"
        },
        "2000-10-26": {
          _name: "Deepavali"
        },
        "2001-11-14": {
          _name: "Deepavali"
        },
        "2002-11-03": {
          _name: "Deepavali"
        },
        "2002-11-04": {
          substitute: !0,
          _name: "Deepavali"
        },
        "2003-10-23": {
          _name: "Deepavali"
        },
        "2004-11-11": {
          _name: "Deepavali"
        },
        "2005-11-01": {
          _name: "Deepavali"
        },
        "2006-10-21": {
          _name: "Deepavali"
        },
        "2007-11-08": {
          _name: "Deepavali"
        },
        "2008-10-27": {
          _name: "Deepavali"
        },
        "2009-10-17": {
          _name: "Deepavali"
        },
        "2010-11-05": {
          _name: "Deepavali"
        },
        "2011-10-26": {
          _name: "Deepavali"
        },
        "2012-11-13": {
          _name: "Deepavali"
        },
        "2013-11-03": {
          _name: "Deepavali"
        },
        "2013-11-04": {
          substitute: !0,
          _name: "Deepavali"
        },
        "2014-10-22": {
          _name: "Deepavali"
        },
        "2015-11-10": {
          _name: "Deepavali"
        },
        "2016-10-29": {
          _name: "Deepavali"
        },
        "2017-10-18": {
          _name: "Deepavali"
        },
        "2018-11-06": {
          _name: "Deepavali"
        },
        "2019-10-27": {
          _name: "Deepavali"
        },
        "2019-10-28": {
          substitute: !0,
          _name: "Deepavali"
        },
        "2020-11-14": {
          _name: "Deepavali"
        },
        "2021-11-04": {
          _name: "Deepavali"
        },
        "2022-10-24": {
          _name: "Deepavali"
        },
        "2023-11-13": {
          _name: "Deepavali"
        },
        "2024-10-31": {
          _name: "Deepavali"
        },
        "2025-10-20": {
          _name: "Deepavali"
        },
        "2026-11-09": {
          _name: "Deepavali"
        },
        "2027-10-28": {
          _name: "Deepavali"
        },
        "2028-11-15": {
          _name: "Deepavali"
        },
        "2029-11-05": {
          _name: "Deepavali"
        },
        "2030-10-25": {
          _name: "Deepavali"
        },
        "2023-09-1": {
          name: {
            en: "Presidential Election Day"
          },
          type: "public"
        }
      }
    },
    SH: {
      names: {
        en: "St. Helena"
      },
      langs: [
        "en"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "substitutes 01-01 if saturday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "3rd monday in April": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "05-21": {
          name: {
            en: "Saint Helena Day"
          }
        },
        "easter 50": {
          _name: "easter 50"
        },
        "monday before 09-01": {
          name: {
            en: "August Bank Holiday"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "substitutes 12-25 if saturday then next tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "substitutes 12-25 if sunday then next tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "substitutes 12-26 if saturday then next monday": {
          substitute: !0,
          _name: "12-26"
        },
        "substitutes 12-26 if sunday then next monday": {
          substitute: !0,
          _name: "12-26"
        }
      },
      states: {
        AC: {
          name: "Ascension Island",
          days: {
            "easter 39": {
              _name: "easter 39"
            }
          }
        },
        HL: {
          name: "Saint Helena",
          days: {}
        },
        TA: {
          name: "Tristan da Cunha",
          days: {
            "easter 39": {
              _name: "easter 39"
            },
            "2012-04-23": {
              name: {
                en: "Ratting Day"
              }
            },
            "2013-05-03": {
              name: {
                en: "Ratting Day"
              }
            },
            "2014-05-02": {
              name: {
                en: "Ratting Day"
              }
            },
            "2015-05-16": {
              name: {
                en: "Ratting Day"
              }
            },
            "2016-04-30": {
              name: {
                en: "Ratting Day"
              }
            },
            "2017-05-26": {
              name: {
                en: "Ratting Day"
              }
            },
            "2018-06-02": {
              name: {
                en: "Ratting Day"
              }
            },
            "08-14": {
              name: {
                en: "Anniversary Day"
              }
            },
            "monday before 09-01": !1
          }
        }
      }
    },
    SI: {
      names: {
        sl: "Republika Slovenija",
        en: "Slovenia"
      },
      langs: [
        "sl"
      ],
      zones: [
        "Europe/Belgrade"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-02": {
          _name: "01-01",
          active: [
            {
              to: 1955
            },
            {
              from: 2017
            }
          ]
        },
        "02-08": {
          name: {
            en: "Prešeren Day, the Slovenian Cultural Holiday",
            sl: "Prešernov dan, slovenski kulturni praznik"
          },
          active: [
            {
              from: 1991
            }
          ]
        },
        "03-08": {
          _name: "03-08",
          type: "observance"
        },
        "04-23": {
          name: {
            sl: "Jurjevanje",
            en: "St. George's Day"
          },
          type: "observance"
        },
        "easter -49": {
          name: {
            sl: "Pust",
            en: "Carnival"
          },
          type: "observance"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-27": {
          name: {
            sl: "Dan upora proti okupatorju",
            en: "Day of Uprising Against Occupation"
          }
        },
        "05-01": {
          _name: "05-01",
          name: {
            en: "Labour Day"
          },
          active: [
            {
              from: 1949
            }
          ]
        },
        "05-02": {
          _name: "05-01",
          name: {
            en: "Labour Day"
          },
          active: [
            {
              from: 1949
            }
          ]
        },
        "easter 49": {
          _name: "easter 49"
        },
        "06-08": {
          name: {
            sl: "Dan Primoža Trubarja",
            en: "Primož Trubar Day"
          },
          type: "observance",
          active: [
            {
              from: 2010
            }
          ]
        },
        "06-25": {
          name: {
            sl: "Dan državnosti",
            en: "Statehood Day"
          },
          active: [
            {
              from: 1991
            }
          ]
        },
        "08-15": {
          _name: "08-15",
          active: [
            {
              from: 1992
            }
          ]
        },
        "08-17": {
          name: {
            sl: "Združitev prekmurskih Slovencev z matičnim narodom",
            en: "Unification of Prekmurje Slovenes with the Mother Nation"
          },
          type: "observance",
          active: [
            {
              from: 2006
            }
          ]
        },
        "09-15": {
          name: {
            sl: "Vrnitev Primorske k matični domovini",
            en: "Return of Primorska to the Motherland"
          },
          type: "observance",
          active: [
            {
              from: 2005
            }
          ]
        },
        "09-23": {
          name: {
            sl: "Dan slovenskega športa",
            en: "Slovenian Sports Day"
          },
          type: "observance",
          active: [
            {
              from: 2020
            }
          ]
        },
        "10-25": {
          name: {
            sl: "Dan suverenosti",
            en: "Sovereignty Day"
          },
          type: "observance",
          active: [
            {
              from: 2015
            }
          ]
        },
        "10-31": {
          name: {
            sl: "Dan reformacije",
            en: "Reformation Day"
          }
        },
        "11-01": {
          name: {
            sl: "Dan spomina na mrtve",
            en: "Day of Remembrance for the Dead"
          }
        },
        "11-11": {
          name: {
            sl: "Martinovanje",
            en: "St. Martin's Day"
          },
          type: "observance"
        },
        "11-23": {
          name: {
            sl: "Dan Rudolfa Maistra",
            en: "Rudolf Maister Day"
          },
          type: "observance",
          active: [
            {
              from: 2015
            }
          ]
        },
        "12-06": {
          name: {
            sl: "Miklavž",
            en: "Saint Nicholas Day"
          },
          type: "observance"
        },
        "12-25": {
          _name: "12-25",
          active: [
            {
              to: 1953
            },
            {
              from: 1991
            }
          ]
        },
        "12-26": {
          name: {
            sl: "Dan samostojnosti in enotnosti",
            en: "Independence and Unity Day"
          }
        }
      }
    },
    SJ: {
      names: {
        en: "Svalbard & Jan Mayen"
      },
      langs: [
        "no"
      ],
      zones: [
        "Europe/Oslo"
      ],
      dayoff: "sunday",
      _days: "NO"
    },
    SK: {
      names: {
        sk: "Slovenská republika",
        en: "Slovakia"
      },
      langs: [
        "sk"
      ],
      zones: [
        "Europe/Prague"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01",
          name: {
            sk: "Deň vzniku Slovenskej republiky"
          }
        },
        "01-06": {
          _name: "01-06"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-08": {
          name: {
            sk: "Deň víťazstva nad fašizmom",
            en: "Day of victory over fascism"
          }
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "07-05": {
          name: {
            sk: "Sviatok svätého Cyrila a Metoda",
            en: "Saints Cyril and Methodius Day"
          }
        },
        "08-29": {
          name: {
            sk: "Výročie Slovenského národného povstania",
            en: "Slovak National Uprising anniversary"
          }
        },
        "09-01": {
          _name: "Constitution Day"
        },
        "09-15": {
          name: {
            sk: "Sviatok Panny Márie Sedembolestnej",
            en: "Day of Our Lady of the Seven Sorrows"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "11-17": {
          name: {
            sk: "Deň boja za slobodu a demokraciu",
            en: "Struggle for Freedom and Democracy Day"
          }
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    SL: {
      names: {
        en: "Sierra Leone"
      },
      langs: [
        "en"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Sunday then next Monday": {
          substitute: !0,
          _name: "01-01"
        },
        "02-18 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Armed Forces Day"
          }
        },
        "03-08 and if Sunday then next Monday": {
          substitute: !0,
          _name: "03-08"
        },
        "04-27 and if Sunday then next Monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "1 Shawwal and if Sunday then next Monday": {
          substitute: !0,
          _name: "1 Shawwal",
          name: {
            en: "Korité"
          }
        },
        "10 Dhu al-Hijjah and if Sunday then next Monday": {
          substitute: !0,
          _name: "10 Dhu al-Hijjah",
          name: {
            en: "Tabaski"
          }
        },
        "12 Rabi al-awwal and if Sunday then next Monday": {
          substitute: !0,
          _name: "12 Rabi al-awwal",
          name: {
            en: "Mawlid"
          }
        },
        "12-25 and if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if Sunday then next Monday": {
          substitute: !0,
          _name: "12-26"
        }
      }
    },
    SM: {
      names: {
        it: "San Marino",
        en: "San Marino"
      },
      langs: [
        "it"
      ],
      zones: [
        "Europe/Rome"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06",
          name: {
            it: "Epifania"
          }
        },
        "02-05": {
          name: {
            it: "Festa di Sant’Agata",
            en: "Feast of Saint Agatha"
          }
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "03-25": {
          name: {
            it: "Anniversario dell'Arengo",
            en: "Anniversary of the Arengo"
          }
        },
        "04-01": {
          name: {
            it: "Cerimonia di investitura dei Capitani Reggenti",
            en: "Inauguration Ceremony"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "easter 60": {
          _name: "easter 60"
        },
        "07-28": {
          name: {
            it: "Anniversario della caduta del Fascismo e Festa della Libertà",
            en: "Liberation from Fascism"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "09-03": {
          name: {
            it: "Festa di San Marino e di Fondazione della Repubblica",
            en: "The Feast of San Marino and the Republic"
          }
        },
        "10-01": {
          name: {
            it: "Cerimonia di investitura dei Capitani Reggenti"
          }
        },
        "11-01": {
          _name: "11-01",
          name: {
            it: "Tutti i Santi"
          }
        },
        "11-02": {
          name: {
            it: "Commemorazione dei defunti",
            en: "Commemoration of the deceased"
          }
        },
        "12-08": {
          _name: "12-08"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "12-31": {
          _name: "12-31",
          type: "optional"
        }
      }
    },
    SN: {
      names: {
        fr: "République du Sénégal",
        wo: "Réewum Senegaal",
        en: "Senegal"
      },
      langs: [
        "fr",
        "wo"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "04-04": {
          _name: "National Holiday"
        },
        "05-01": {
          _name: "05-01"
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-25": {
          _name: "12-25"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal and if sunday then next monday": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah and if sunday then next monday": {
          _name: "10 Dhu al-Hijjah"
        },
        "10 Muharram": {
          _name: "10 Muharram"
        },
        "18 Safar": {
          name: "Magal de Touba"
        }
      }
    },
    SO: {
      names: {
        so: "Jamhuuriyadda Federaalka Soomaaliya",
        ar: "جمهورية الصومال الفدرالية",
        en: "Somalia"
      },
      dayoff: "?",
      langs: [
        "so",
        "ar",
        "en"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "05-01": {
          _name: "05-01"
        },
        "06-26": {
          name: {
            ar: "استقلال الصومال البريطاني",
            en: "Independence of British Somaliland"
          }
        },
        "07-01": {
          _name: "Independence Day"
        },
        "10 Muharram": {
          _name: "10 Muharram"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      },
      states: {
        AW: {
          name: "Awdal",
          days: {
            "01-01": !1,
            "05-18 P2D": {
              name: {
                en: "Restoration of Somaliland Sovereignty"
              }
            },
            "07-01": !1,
            "1 Muharram": {
              _name: "1 Muharram"
            },
            "10 Muharram": !1,
            "27 Rajab": {
              _name: "27 Rajab"
            }
          }
        },
        SA: {
          name: "Sanaag",
          _days: [
            "SO",
            "states",
            "AW"
          ]
        },
        SO: {
          name: "Sool",
          _days: [
            "SO",
            "states",
            "AW"
          ]
        },
        TO: {
          name: "Togdheer",
          _days: [
            "SO",
            "states",
            "AW"
          ]
        },
        WO: {
          name: "Woqooyi Galbeed",
          _days: [
            "SO",
            "states",
            "AW"
          ]
        }
      }
    },
    SR: {
      names: {
        en: "Suriname"
      },
      langs: [
        "nl",
        "srn"
      ],
      zones: [
        "America/Paramaribo"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "chinese 01-0-01": {
          name: {
            nl: "Chinees Nieuwjaar",
            en: "Chinese New Year"
          }
        },
        "02-25": {
          name: {
            nl: "Dag van Bevrijding en Vernieuwing",
            en: "Day of Liberation and Innovation"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "07-01": {
          name: {
            nl: "Dag der Vrijheden (Keti koti)",
            srn: "Keti koti",
            en: "Emancipation Day"
          }
        },
        "08-09": {
          name: {
            nl: "Dag der Inheemsen",
            en: "Indigenous People's Day"
          }
        },
        "10-10": {
          name: {
            nl: "Dag van de Marrons",
            en: "Day of the Maroons"
          }
        },
        "11-25": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "2015-03-06": {
          _name: "Holi"
        },
        "2016-03-23": {
          _name: "Holi"
        },
        "2017-03-12": {
          _name: "Holi"
        },
        "2018-03-02": {
          _name: "Holi"
        },
        "2019-03-21": {
          _name: "Holi"
        },
        "2020-03-09": {
          _name: "Holi"
        },
        "2021-03-28": {
          _name: "Holi"
        },
        "2022-03-18": {
          _name: "Holi"
        },
        "2023-03-07": {
          _name: "Holi"
        },
        "2024-03-25": {
          _name: "Holi"
        },
        "2025-03-14": {
          _name: "Holi"
        },
        "2026-03-03": {
          _name: "Holi"
        },
        "2027-03-22": {
          _name: "Holi"
        },
        "2028-03-11": {
          _name: "Holi"
        },
        "2029-03-28": {
          _name: "Holi"
        },
        "2030-03-19": {
          _name: "Holi"
        },
        "2014-10-23": {
          _name: "Deepavali"
        },
        "2015-11-11": {
          _name: "Deepavali"
        },
        "2016-10-30": {
          _name: "Deepavali"
        },
        "2017-10-19": {
          _name: "Deepavali"
        },
        "2018-11-07": {
          _name: "Deepavali"
        },
        "2019-10-27": {
          _name: "Deepavali"
        },
        "2020-11-14": {
          _name: "Deepavali"
        },
        "2021-11-04": {
          _name: "Deepavali"
        },
        "2022-10-24": {
          _name: "Deepavali"
        },
        "2023-11-12": {
          _name: "Deepavali"
        },
        "2024-10-31": {
          _name: "Deepavali"
        },
        "2025-10-20": {
          _name: "Deepavali"
        },
        "2026-11-08": {
          _name: "Deepavali"
        },
        "2027-10-28": {
          _name: "Deepavali"
        },
        "2028-10-17": {
          _name: "Deepavali"
        },
        "2029-11-05": {
          _name: "Deepavali"
        },
        "2030-10-25": {
          _name: "Deepavali"
        }
      }
    },
    SS: {
      names: {
        en: "South Sudan"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "Africa/Maputo"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-09": {
          name: {
            en: "Peace Agreement Day"
          }
        },
        "03-08": {
          _name: "03-08"
        },
        "05-16": {
          name: {
            en: "SPLA Day"
          }
        },
        "1st monday in July": {
          _name: "Mothers Day",
          type: "observance"
        },
        "07-09": {
          _name: "Independence Day"
        },
        "07-30": {
          name: {
            en: "Martyrs Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-28": {
          name: {
            en: "Republic Day"
          }
        },
        "12-31": {
          _name: "12-31"
        },
        "2 Shawwal": {
          _name: "1 Shawwal"
        },
        "12 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    ST: {
      names: {
        pt: "São Tomé & Príncipe",
        en: "São Tomé & Príncipe"
      },
      langs: [
        "pt",
        "en"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          _name: "01-01"
        },
        "02-03 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Martyrs' Day",
            pt: "Dia dos Mártires"
          }
        },
        "05-01 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          _name: "05-01"
        },
        "07-12 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "09-06 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Armed Forces Day",
            pt: "Dia das Forças Armadas"
          }
        },
        "09-30 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Agricultural Reform Day",
            pt: "Dia da Reforma Agrária"
          }
        },
        "12-21 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "São Tomé Day",
            pt: "Dia de São Tomé"
          }
        },
        "12-25 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          _name: "12-25"
        }
      }
    },
    SV: {
      names: {
        es: "El Salvador",
        en: "El Salvador"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/El_Salvador"
      ],
      days: {
        "01-01": {
          _name: "01-01",
          type: "observance"
        },
        "01-16": {
          name: {
            es: "Firma de los Acuerdos de Paz"
          },
          type: "observance"
        },
        "03-08": {
          name: {
            es: "Día de la Mujer"
          },
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter -1": {
          _name: "easter -1"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-07": {
          name: {
            en: "Soldier's Day",
            es: "Día del Soldado"
          },
          type: "observance"
        },
        "05-10": {
          _name: "Mothers Day",
          type: "optional",
          note: "Public Offices only"
        },
        "06-17": {
          _name: "Fathers Day",
          type: "observance"
        },
        "06-22": {
          name: {
            es: "Día del Maestro"
          },
          type: "optional",
          note: "Dayoff for teachers only"
        },
        "08-06": {
          name: {
            es: "Celebración del Divino Salvador del Mundo"
          }
        },
        "09-15": {
          _name: "Independence Day"
        },
        "11-02": {
          _name: "11-02"
        },
        "12-25": {
          _name: "12-25"
        }
      },
      regions: {
        SS: {
          name: "San Salvador",
          days: {
            "08-03": {
              name: {
                es: "Fiestas Agostinas"
              }
            },
            "08-05": {
              name: {
                es: "Fiestas Agostinas"
              }
            }
          }
        }
      }
    },
    SX: {
      names: {
        en: "Sint Maarten"
      },
      langs: [
        "nl"
      ],
      zones: [
        "America/Curacao"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-27": {
          name: {
            nl: "Koningsdag",
            en: "King's Day"
          }
        },
        "04-30 if Sunday then next Tuesday prior to 2017": {
          name: {
            nl: "Carnaval",
            en: "Carnival"
          }
        },
        "04-30 if Saturday then previous Friday if Sunday then next Tuesday since 2017": {
          name: {
            nl: "Carnaval",
            en: "Carnival"
          }
        },
        "05-01 if Sunday then next Monday": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 49": {
          _name: "easter 49"
        },
        "07-01": {
          name: {
            nl: "Emancipatiedag",
            en: "Emancipation Day"
          }
        },
        "10-09": {
          _name: "Constitution Day"
        },
        "11-11": {
          name: {
            en: "Sint Maarten Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    SZ: {
      names: {
        ss: "Eswatini",
        en: "Swaziland"
      },
      langs: [
        "ss",
        "en"
      ],
      zones: [
        "Africa/Johannesburg"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-19 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Birthday of King Mswati III"
          }
        },
        "04-25 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "National Flag Day"
          }
        },
        "05-01 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "07-22 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Birthday of the late King Sobhuza"
          }
        },
        "1st Monday in September": {
          name: {
            ss: "Umhlanga Reed Dance",
            en: "Umhlanga Reed Dance"
          }
        },
        "09-06 and if Saturday, Sunday then next Monday": {
          substitute: !0,
          _name: "Independence Day",
          name: {
            ss: "Somhlolo Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26 and if Sunday then next Monday": {
          _name: "12-26"
        },
        "12-28 P6D": {
          name: {
            ss: "Incwala",
            en: "Incwala Festival"
          }
        }
      }
    },
    TC: {
      names: {
        en: "Turks & Caicos Islands"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Grand_Turk"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Saturday, Sunday then next Monday": {
          _name: "01-01"
        },
        "2nd Monday in March": {
          name: {
            en: "Commonwealth Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "1st Monday before 06-01": {
          name: {
            en: "National Heroes' Day"
          }
        },
        "2nd Monday after 06-02": {
          name: {
            en: "Queen's Birthday"
          }
        },
        "1st Monday in August": {
          name: {
            en: "Emancipation Day"
          }
        },
        "1st Friday before 10-01": {
          name: {
            en: "National Youth Day"
          }
        },
        "2nd Monday in October": {
          name: {
            en: "National Heritage Day"
          }
        },
        "4th Friday in November": {
          name: {
            en: "National Day of Thanksgiving"
          }
        },
        "12-25 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-26"
        }
      }
    },
    TD: {
      names: {
        ar: "جمهورية تشاد",
        fr: "République du Tchad",
        en: "Chad"
      },
      langs: [
        "ar",
        "fr"
      ],
      zones: [
        "Africa/Ndjamena"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if sunday then next monday": {
          _name: "01-01"
        },
        "05-01 and if sunday then next monday": {
          _name: "05-01"
        },
        "08-11 and if sunday then next monday": {
          name: {
            fr: "Fête Nationale (Indépendance)",
            en: "Independence Day"
          }
        },
        "12-01 and if sunday then next monday": {
          name: {
            fr: "Journée de la libération et de la démocratie",
            en: "Freedom and Democracy Day"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "11-28": {
          name: {
            fr: "Anniversaire de la Proclamation de la République",
            en: "Proclamation of the Republic"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    TG: {
      names: {
        fr: "République togolaise",
        en: "Togolese Republic"
      },
      dayoff: "sunday",
      langs: [
        "fr"
      ],
      zones: [
        "Africa/Abidjan"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-13": {
          name: {
            fr: "Jour de la libération",
            en: "Liberation Day"
          }
        },
        "04-27": {
          _name: "Independence Day"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "06-21": {
          name: {
            fr: "Journée des Martyrs",
            en: "Day of the Martyrs"
          }
        },
        "08-15": {
          _name: "08-15"
        },
        "11-01": {
          _name: "11-01"
        },
        "12-25": {
          _name: "12-25"
        },
        "13 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "2 Shawwal": {
          _name: "1 Shawwal"
        },
        "11 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    TH: {
      names: {
        en: "Thailand"
      },
      langs: [
        "en",
        "th"
      ],
      zones: [
        "Asia/Bangkok"
      ],
      dayoff: "Saturday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "04-06": {
          name: {
            en: "Chakri Memorial Day",
            th: "วันจักรี"
          }
        },
        "04-13": {
          name: {
            en: "Songkran Festival",
            th: "วันสงกรานต์"
          }
        },
        "04-14": {
          name: {
            en: "Songkran Festival",
            th: "วันสงกรานต์"
          }
        },
        "04-15": {
          name: {
            en: "Songkran Festival",
            th: "วันสงกรานต์"
          }
        },
        "05-04": {
          name: {
            en: "Coronation Day",
            th: "วันฉัตรมงคล"
          }
        },
        "06-03": {
          name: {
            en: "Queen Suthida's Birthday",
            th: "วันเฉลิมพระชนมพรรษาสมเด็จพระนางเจ้าสุทิดา พัชรสุธาพิมลลักษณ พระบรมราชินี"
          }
        },
        "07-28": {
          name: {
            en: "King's Birthday",
            th: "วันเฉลิมพระชนมพรรษาพระบาทสมเด็จพระวชิรเกล้าเจ้าอยู่หัว"
          }
        },
        "08-12": {
          name: {
            en: "The Queen Mother's Birthday",
            th: "วันเฉลิมพระชนมพรรษาสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ พระบรมราชชนนีพันปีหลวง"
          }
        },
        "10-13": {
          name: {
            en: "King Bhumibol Adulyadej Memorial Day",
            th: "วันคล้ายวันสวรรคตพระบาทสมเด็จพระบรมชนกาธิเบศร มหาภูมิพลอดุลยเดชมหาราช บรมนาถบพิตร"
          }
        },
        "10-23": {
          name: {
            en: "King Chulalongkorn Day",
            th: "วันปิยมหาราช"
          }
        },
        "12-05": {
          name: {
            en: "King Bhumibol Adulyadej's Birthday",
            th: "วันคล้ายวันพระบรมราชสมภพ พระบาทสมเด็จพระบรมชนกาธิเบศร มหาภูมิพลอดุลยเดชมหาราช บรมนาถบพิตร"
          }
        },
        "12-10": {
          name: {
            en: "Constitution Day",
            th: "วันรัฐธรรมนูญ"
          }
        },
        "12-31": {
          _name: "12-31"
        },
        "2010-03-01": {
          _name: "Makha Bucha"
        },
        "2011-02-18": {
          _name: "Makha Bucha"
        },
        "2012-03-07": {
          _name: "Makha Bucha"
        },
        "2013-02-25": {
          _name: "Makha Bucha"
        },
        "2014-02-14": {
          _name: "Makha Bucha"
        },
        "2015-03-04": {
          _name: "Makha Bucha"
        },
        "2016-02-22": {
          _name: "Makha Bucha"
        },
        "2017-02-11": {
          _name: "Makha Bucha"
        },
        "2018-03-01": {
          _name: "Makha Bucha"
        },
        "2019-02-19": {
          _name: "Makha Bucha"
        },
        "2020-02-08": {
          _name: "Makha Bucha"
        },
        "2021-02-26": {
          _name: "Makha Bucha"
        },
        "2022-02-16": {
          _name: "Makha Bucha"
        },
        "2023-03-06": {
          _name: "Makha Bucha"
        },
        "2024-02-24": {
          _name: "Makha Bucha"
        },
        "2025-02-13": {
          _name: "Makha Bucha"
        },
        "2026-03-03": {
          _name: "Makha Bucha"
        },
        "2010-05-28": {
          _name: "Vesak"
        },
        "2011-05-17": {
          _name: "Vesak"
        },
        "2012-05-06": {
          _name: "Vesak"
        },
        "2013-05-25": {
          _name: "Vesak"
        },
        "2014-05-15": {
          _name: "Vesak"
        },
        "2015-06-02": {
          _name: "Vesak"
        },
        "2016-05-22": {
          _name: "Vesak"
        },
        "2017-05-10": {
          _name: "Vesak"
        },
        "2018-05-29": {
          _name: "Vesak"
        },
        "2019-05-19": {
          _name: "Vesak"
        },
        "2020-05-07": {
          _name: "Vesak"
        },
        "2021-05-26": {
          _name: "Vesak"
        },
        "2022-05-15": {
          _name: "Vesak"
        },
        "2022-05-16": {
          substitute: !0,
          _name: "Vesak"
        },
        "2023-05-04": {
          _name: "Vesak"
        },
        "2024-05-22": {
          _name: "Vesak"
        },
        "2025-05-12": {
          _name: "Vesak"
        },
        "2026-05-31": {
          _name: "Vesak"
        },
        "2010-07-25": {
          _name: "Asalha Puja"
        },
        "2011-07-15": {
          _name: "Asalha Puja"
        },
        "2012-08-02": {
          _name: "Asalha Puja"
        },
        "2013-07-22": {
          _name: "Asalha Puja"
        },
        "2014-07-11": {
          _name: "Asalha Puja"
        },
        "2015-07-30": {
          _name: "Asalha Puja"
        },
        "2016-07-19": {
          _name: "Asalha Puja"
        },
        "2017-07-08": {
          _name: "Asalha Puja"
        },
        "2018-07-27": {
          _name: "Asalha Puja"
        },
        "2019-07-16": {
          _name: "Asalha Puja"
        },
        "2020-07-04": {
          _name: "Asalha Puja"
        },
        "2021-07-24": {
          _name: "Asalha Puja"
        },
        "2022-07-13": {
          _name: "Asalha Puja"
        },
        "2023-07-31": {
          _name: "Asalha Puja"
        },
        "2024-07-19": {
          _name: "Asalha Puja"
        },
        "2025-07-10": {
          _name: "Asalha Puja"
        },
        "2026-07-29": {
          _name: "Asalha Puja"
        },
        "2010-07-26": {
          _name: "Buddhist Lent"
        },
        "2011-07-16": {
          _name: "Buddhist Lent"
        },
        "2012-08-03": {
          _name: "Buddhist Lent"
        },
        "2013-07-23": {
          _name: "Buddhist Lent"
        },
        "2014-07-12": {
          _name: "Buddhist Lent"
        },
        "2015-07-31": {
          _name: "Buddhist Lent"
        },
        "2016-07-20": {
          _name: "Buddhist Lent"
        },
        "2017-07-09": {
          _name: "Buddhist Lent"
        },
        "2018-07-28": {
          _name: "Buddhist Lent"
        },
        "2019-07-17": {
          _name: "Buddhist Lent"
        },
        "2020-07-05": {
          _name: "Buddhist Lent"
        },
        "2021-07-25": {
          _name: "Buddhist Lent"
        },
        "2022-07-14": {
          _name: "Buddhist Lent"
        },
        "2023-08-01": {
          _name: "Buddhist Lent"
        },
        "2024-07-20": {
          _name: "Buddhist Lent"
        },
        "2025-07-11": {
          _name: "Buddhist Lent"
        },
        "2026-07-30": {
          _name: "Buddhist Lent"
        }
      }
    },
    TN: {
      names: {
        ar: "الجمهورية التونسية",
        fr: "République tunisienne",
        en: "Tunisia"
      },
      langs: [
        "ar",
        "fr"
      ],
      zones: [
        "Africa/Tunis"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-14": {
          name: {
            fr: "Fête de la Révolution et de la Jeunesse",
            ar: "عيد الثورة و الشباب"
          }
        },
        "03-20": {
          name: {
            fr: "Fête de l'indépendance",
            ar: "عيد الإستقلال"
          }
        },
        "04-09": {
          name: {
            fr: "Journée des Martyrs",
            ar: "عيد الشهداء"
          }
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal"
        },
        "1 Muharram": {
          _name: "1 Muharram"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "05-01": {
          _name: "05-01"
        },
        "07-25": {
          name: {
            fr: "Fête de la République",
            ar: "عيد الجمهورية"
          }
        },
        "08-13": {
          name: {
            fr: "Fête de la Femme et de la Famille",
            ar: "عيد المرأة"
          }
        },
        "10-15": {
          name: {
            fr: "Fête de l'Évacuation",
            ar: "عيد الجلاء"
          }
        }
      }
    },
    TO: {
      names: {
        to: "Puleʻanga Fakatuʻi ʻo Tonga",
        en: "Tonga"
      },
      langs: [
        "to",
        "en"
      ],
      zones: [
        "Pacific/Tongatapu"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-25": {
          name: {
            en: "ANZAC Day"
          }
        },
        "06-04 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday": {
          name: {
            en: "Emancipation Day"
          }
        },
        "07-04": {
          name: {
            en: "Official Birthday of His Majesty King Tupou VI"
          }
        },
        "09-17 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday": {
          name: {
            en: "Birthday of His Royal Highness The Crown Prince Tupotoʻa-ʻUlukalala"
          }
        },
        "11-04 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday": {
          _name: "Constitution Day",
          name: {
            en: "Constitutional Day"
          }
        },
        "12-04 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday": {
          name: {
            en: "Tupou I Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    },
    TR: {
      names: {
        tr: "Türkiye",
        en: "Turkey"
      },
      dayoff: "saturday",
      langs: [
        "tr"
      ],
      zones: [
        "Europe/Istanbul"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "04-23": {
          name: {
            en: "National Sovereignty and Children's Day",
            tr: "Ulusal Egemenlik ve Çocuk Bayramı"
          }
        },
        "05-01": {
          _name: "05-01",
          name: {
            en: "Labour and Solidarity Day",
            tr: "Emek ve Dayanışma Günü"
          }
        },
        "05-19": {
          name: {
            en: "Commemoration of Atatürk, Youth and Sports Day",
            tr: "Atatürk'ü Anma Gençlik ve Spor Bayramı"
          }
        },
        "07-15": {
          name: {
            en: "Democracy and National Unity Day",
            tr: "Demokrasi ve Millî Birlik Günü"
          }
        },
        "08-30": {
          name: {
            en: "Victory Day",
            tr: "Zafer Bayramı"
          }
        },
        "10-29": {
          name: {
            en: "Republic Day",
            tr: "Cumhuriyet Bayramı"
          }
        },
        "1 Shawwal PT90H": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah PT114H": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    TT: {
      names: {
        en: "Trinidad & Tobago"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Sunday then next Monday": {
          substitute: !0,
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1",
          type: "observance"
        },
        "03-30 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Spiritual Baptist Liberation Day"
          }
        },
        "easter 60": {
          _name: "easter 60"
        },
        "05-30 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Indian Arrival Day"
          }
        },
        "06-19 and if Sunday then next Monday": {
          substitute: !0,
          _name: "05-01"
        },
        "08-01 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Emancipation Day"
          }
        },
        "08-31 and if Sunday then next Monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "09-24 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Republic Day"
          }
        },
        "12-25 and if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if Sunday then next Monday": {
          substitute: !0,
          _name: "12-26"
        },
        "1 Shawwal and if Sunday then next Monday": {
          substitute: !0,
          _name: "1 Shawwal"
        },
        "2012-11-13": {
          _name: "Deepavali"
        },
        "2013-11-03": {
          _name: "Deepavali"
        },
        "2013-11-04": {
          substitute: !0,
          _name: "Deepavali"
        },
        "2014-10-23": {
          _name: "Deepavali"
        },
        "2015-11-11": {
          _name: "Deepavali"
        },
        "2016-10-29": {
          _name: "Deepavali"
        },
        "2017-10-19": {
          _name: "Deepavali"
        },
        "2018-11-07": {
          _name: "Deepavali"
        },
        "2019-10-27": {
          _name: "Deepavali"
        },
        "2019-10-28": {
          substitute: !0,
          _name: "Deepavali"
        },
        "2020-11-14": {
          _name: "Deepavali"
        },
        "2021-11-04": {
          _name: "Deepavali"
        },
        "2022-10-24": {
          _name: "Deepavali"
        },
        "2023-11-12": {
          _name: "Deepavali"
        },
        "2023-11-13": {
          substitute: !0,
          _name: "Deepavali"
        },
        "2024-10-31": {
          _name: "Deepavali"
        },
        "2025-10-20": {
          _name: "Deepavali"
        },
        "2026-11-08": {
          _name: "Deepavali"
        },
        "2026-11-09": {
          substitute: !0,
          _name: "Deepavali"
        },
        "2027-10-28": {
          _name: "Deepavali"
        },
        "2028-10-17": {
          _name: "Deepavali"
        },
        "2029-11-05": {
          _name: "Deepavali"
        },
        "2030-10-25": {
          _name: "Deepavali"
        }
      }
    },
    TW: {
      names: {
        zh: "中華民國",
        en: "Taiwan"
      },
      langs: [
        "zh"
      ],
      zones: [
        "Asia/Taipei"
      ],
      dayoff: "",
      days: {
        "01-01 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          _name: "01-01",
          name: {
            zh: "中華民國開國紀念日 / 元旦",
            en: "Founding of the Republic of China"
          }
        },
        "chinese 01-0-00": {
          name: {
            en: "Chinese New Year's Eve",
            zh: "農曆除夕"
          }
        },
        "chinese 01-0-01": {
          name: {
            en: "Chinese New Year",
            zh: "農曆年初一"
          }
        },
        "chinese 01-0-01 if Monday then next Friday if Tuesday then next Saturdayif Wednesday then next Sunday if Thursday then next Monday if Friday then next Tuesday if Saturday then next Wednesday if Sunday then next Thursday": {
          name: {
            en: "Chinese New Year Holiday",
            zh: "农历新年假期"
          }
        },
        "chinese 01-0-02": {
          name: {
            en: "The second day of the Chinese New Year",
            zh: "農曆年初二"
          }
        },
        "chinese 01-0-03": {
          name: {
            en: "The third day of the Chinese New Year",
            zh: "農曆年初三"
          }
        },
        "chinese 01-0-04": {
          name: {
            en: "The forth day of the Chinese New Year",
            zh: "農曆年初四"
          }
        },
        "02-28 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Peace Memorial Day",
            zh: "228和平紀念日"
          }
        },
        "04-04 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Children's Day",
            zh: "兒童節"
          }
        },
        "chinese 5-01 solarterm and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Tomb Sweeping Day",
            zh: "淸明節"
          }
        },
        "chinese 05-0-05 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Dragon Boat Festival",
            zh: "端午節"
          }
        },
        "chinese 08-0-15 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Mid-Autumn Festival",
            zh: "中秋節"
          }
        },
        "10-10 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "National Day / Double Tenth Day",
            zh: "國慶日 / 雙十節"
          }
        },
        "02-04": {
          name: {
            en: "Farmer's Day",
            zh: "農民節"
          },
          type: "observance"
        },
        "03-08": {
          _name: "03-08",
          type: "observance"
        },
        "03-12": {
          name: {
            en: "Arbor Day",
            zh: "國父逝世紀念日"
          },
          type: "observance"
        },
        "03-29": {
          name: {
            en: "Youth Day",
            zh: "靑年節"
          },
          type: "observance"
        },
        "05-01 and if Saturday then previous Friday if Sunday then next Monday": {
          substitute: !0,
          _name: "05-01",
          name: {
            zh: "勞動節"
          },
          type: "observance",
          note: "private sector"
        },
        "05-04": {
          name: {
            en: "Literary Day",
            zh: "文藝節"
          },
          type: "observance"
        },
        "2nd Sunday in May": {
          _name: "Mothers Day",
          name: {
            zh: "母親節"
          },
          type: "observance"
        },
        "06-03": {
          name: {
            en: "Opium Suppression Movement Day",
            zh: "禁菸節"
          },
          type: "observance"
        },
        "08-08": {
          _name: "Fathers Day",
          name: {
            zh: "父親節"
          },
          type: "observance"
        },
        "09-01": {
          name: {
            en: "Journalist' Day",
            zh: "記者節"
          },
          type: "observance"
        },
        "09-03": {
          name: {
            en: "Armed Forces Day",
            zh: "軍人節"
          },
          type: "observance"
        },
        "09-28": {
          name: {
            en: "Teachers' Day",
            zh: "孔子誕辰紀念日"
          },
          type: "observance"
        },
        "10-21": {
          name: {
            en: "Overseas Chinese Day",
            zh: "華僑節"
          },
          type: "observance"
        },
        "10-25": {
          name: {
            en: "Taiwan Retrocession Day",
            zh: "臺灣光復節"
          },
          type: "observance"
        },
        "11-12": {
          name: {
            en: "Sun Yat-sen's Birthday",
            zh: "國父誕辰紀念日"
          },
          note: "Also Doctors' Day and Cultural Renaissance Day",
          type: "observance"
        },
        "december solstice": {
          name: {
            en: "Dongzhi Festival",
            zh: "冬至"
          },
          type: "observance"
        },
        "12-25": {
          name: {
            en: "Constitution Day",
            zh: "行憲紀念日"
          },
          type: "observance"
        },
        "chinese 01-0-15": {
          name: {
            en: "Lantern Festival",
            zh: "元宵節"
          },
          type: "observance"
        },
        "chinese 01-0-15 #1": {
          name: {
            en: "Tourism Day",
            zh: "觀光節"
          },
          type: "observance"
        },
        "chinese 02-0-02": {
          name: {
            en: "Earth God's Birthday",
            zh: "土地公誕辰"
          },
          type: "observance"
        },
        "chinese 02-0-19": {
          name: {
            en: "Kuan Yin's Birthday",
            zh: "觀音誕辰"
          },
          type: "observance"
        },
        "chinese 03-0-15": {
          name: {
            en: "God of Medicine's Birthday",
            zh: "保生大帝誕辰"
          },
          type: "observance"
        },
        "chinese 03-0-23": {
          name: {
            en: "Matsu's Birthday",
            zh: "媽祖誕辰"
          },
          type: "observance"
        },
        "chinese 04-0-08": {
          name: {
            en: "Buddha's Birthday",
            zh: "佛誕日"
          },
          type: "observance"
        },
        "chinese 05-0-13": {
          name: {
            en: "Kuan Kung's Birthday",
            zh: "關公誕辰"
          },
          type: "observance"
        },
        "chinese 05-0-13 #1": {
          name: {
            en: "Cheng Huang's Birthday",
            zh: "城隍爺誕辰"
          },
          type: "observance"
        },
        "chinese 07-0-07": {
          name: {
            en: "Qixi Festival",
            zh: "七夕"
          },
          type: "observance"
        },
        "chinese 07-0-15": {
          name: {
            en: "Ghost Festival",
            zh: "中元節"
          },
          type: "observance"
        },
        "chinese 09-0-09": {
          name: {
            en: "Double Ninth Festival",
            zh: "重陽節"
          },
          type: "observance"
        },
        "chinese 10-0-15": {
          name: {
            en: "Saisiat Festival",
            zh: "賽夏節"
          },
          type: "observance"
        }
      }
    },
    TZ: {
      names: {
        en: "Tanzania"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-02": {
          name: {
            en: "Zanzibar Revolution Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-07": {
          name: {
            en: "Karume Day"
          }
        },
        "04-26": {
          name: {
            en: "Union Day"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "07-07": {
          name: {
            en: "Saba Saba Day"
          }
        },
        "08-08": {
          name: {
            en: "Nane Nane Day"
          }
        },
        "10-14": {
          name: {
            en: "Nyerere Day"
          }
        },
        "12-09": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-25"
        },
        "1 Shawwal P2D": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        },
        "12 Rabi al-awwal": {
          _name: "12 Rabi al-awwal",
          name: {
            en: "Maulid Day"
          }
        }
      }
    },
    UA: {
      names: {
        uk: "Україна",
        en: "Ukraine"
      },
      langs: [
        "uk"
      ],
      zones: [
        "Europe/Kiev",
        "Europe/Uzhgorod",
        "Europe/Zaporozhye"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if saturday, sunday then next tuesday": {
          _name: "01-01",
          name: {
            en: "New Year"
          },
          substitute: !0
        },
        "01-02 and if saturday, sunday then next monday": {
          _name: "01-01",
          name: {
            en: "New Year"
          },
          substitute: !0
        },
        "julian 12-25 and if saturday, sunday then next monday prior to 2023": {
          _name: "julian 12-25",
          substitute: !0
        },
        "03-08 and if saturday, sunday then next monday": {
          _name: "03-08"
        },
        "orthodox and if sunday then next monday": {
          _name: "orthodox"
        },
        "orthodox 49 and if sunday then next monday": {
          _name: "easter 49"
        },
        "05-01 and if saturday, sunday then next tuesday": {
          _name: "05-01",
          substitute: !0
        },
        "05-02 and if saturday, sunday then next monday prior to 2018": {
          _name: "05-01",
          substitute: !0
        },
        "05-09 and if saturday, sunday then next monday": {
          name: {
            uk: "День перемоги над нацизмом у Другій світовій війні",
            en: "Victory Day"
          },
          substitute: !0
        },
        "06-28 and if saturday, sunday then next monday": {
          _name: "Constitution Day",
          substitute: !0
        },
        "07-15 and if saturday, sunday then next monday since 2023": {
          name: {
            en: "Statehood Day",
            uk: "День Української Державності"
          }
        },
        "07-28 and if saturday, sunday then next monday prior to 2023": {
          name: {
            en: "Statehood Day",
            uk: "День Української Державності"
          }
        },
        "08-24 and if saturday, sunday then next monday": {
          _name: "Independence Day",
          substitute: !0
        },
        "10-14 and if saturday, sunday then next monday since 2015 and prior to 2023": {
          name: {
            uk: "День захисника України",
            en: "Defenders of Ukraine Day"
          },
          substitute: !0
        },
        "10-01 and if saturday, sunday then next monday since 2023": {
          name: {
            uk: "День захисників і захисниць України",
            en: "Defenders of Ukraine Day"
          },
          substitute: !0
        },
        "12-25 and if saturday, sunday then next monday since 2017": {
          _name: "12-25"
        }
      }
    },
    UG: {
      names: {
        en: "Uganda"
      },
      dayoff: "sundays",
      langs: [
        "en",
        "sw"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-26": {
          name: {
            en: "Liberation Day"
          }
        },
        "02-16": {
          name: {
            en: "Archbishop Janan Luwum Day"
          }
        },
        "03-08": {
          _name: "03-08"
        },
        "easter -46": {
          _name: "easter -46",
          type: "observance"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "06-03": {
          name: {
            en: "Martyr's Day"
          }
        },
        "06-09": {
          name: {
            en: "National Heroes Day"
          }
        },
        "10-09": {
          _name: "Independence Day"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    US: {
      names: {
        en: "United States of America"
      },
      dayoff: "sunday",
      zones: [
        "America/New_York",
        "America/Detroit",
        "America/Kentucky/Louisville",
        "America/Kentucky/Monticello",
        "America/Indiana/Indianapolis",
        "America/Indiana/Vincennes",
        "America/Indiana/Winamac",
        "America/Indiana/Marengo",
        "America/Indiana/Petersburg",
        "America/Indiana/Vevay",
        "America/Chicago",
        "America/Indiana/Tell_City",
        "America/Indiana/Knox",
        "America/Menominee",
        "America/North_Dakota/Center",
        "America/North_Dakota/New_Salem",
        "America/North_Dakota/Beulah",
        "America/Denver",
        "America/Boise",
        "America/Phoenix",
        "America/Los_Angeles",
        "America/Metlakatla",
        "America/Anchorage",
        "America/Juneau",
        "America/Sitka",
        "America/Yakutat",
        "America/Nome",
        "America/Adak",
        "Pacific/Honolulu"
      ],
      langs: [
        "en-us",
        "en"
      ],
      days: {
        "01-01 and if sunday then next monday if saturday then previous friday": {
          substitute: !0,
          _name: "01-01"
        },
        "3rd monday in January": {
          name: {
            en: "Martin Luther King Jr. Day",
            es: "Natalicio de Martin Luther King, Jr."
          }
        },
        "3rd monday in February": {
          name: {
            en: "Washington's Birthday",
            es: "Día de los Presidentes"
          }
        },
        "02-14": {
          _name: "02-14",
          type: "observance"
        },
        "03-17": {
          name: {
            en: "St. Patrick's Day"
          },
          type: "observance"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "04-15 if friday then next monday if saturday,sunday then next tuesday": {
          name: {
            en: "Tax Day"
          },
          type: "observance"
        },
        "wednesday before 04-28": {
          name: {
            en: "Administrative Professionals Day"
          },
          type: "observance"
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "monday before 06-01": {
          name: {
            en: "Memorial Day",
            es: "Recordación de los Muertos de la Guerra"
          }
        },
        "06-19 and if sunday then next monday if saturday then previous friday since 2021": {
          substitute: !0,
          name: {
            en: "Juneteenth"
          }
        },
        "3rd sunday in June": {
          _name: "Fathers Day",
          type: "observance"
        },
        "07-04 and if sunday then next monday if saturday then previous friday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "1st monday in September": {
          _name: "05-01"
        },
        "2nd monday in October": {
          name: {
            en: "Columbus Day",
            es: "Descubrimiento de América"
          }
        },
        "10-31 18:00": {
          name: {
            en: "Halloween"
          },
          type: "observance"
        },
        "11-11": {
          name: {
            en: "Veterans Day",
            es: "Día del Veterano"
          }
        },
        "substitutes 11-11 if sunday then next monday if saturday then previous friday": {
          substitute: !0,
          name: {
            en: "Veterans Day",
            es: "Día del Veterano"
          },
          type: "bank",
          note: "Federal Government offices are closed"
        },
        "tuesday after 1st monday in November every 4 years since 1848": {
          name: {
            en: "Election Day"
          },
          type: "observance"
        },
        "4th thursday in November": {
          name: {
            en: "Thanksgiving Day",
            es: "Acción de Gracias"
          }
        },
        "friday after 4th thursday in November": {
          name: {
            en: "Day after Thanksgiving Day",
            es: "Dia despues Acción de Gracias"
          },
          type: "observance"
        },
        "12-24": {
          _name: "12-24",
          type: "optional"
        },
        "12-25 and if sunday then next monday if saturday then previous friday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-31": {
          _name: "12-31",
          type: "observance"
        }
      },
      states: {
        AL: {
          name: "Alabama",
          zones: [
            "America/Chicago"
          ],
          days: {
            "3rd monday in January": {
              name: {
                en: "Robert E. Lee/Martin Luther King Birthday"
              }
            },
            "3rd monday in February": {
              name: {
                en: "George Washington/Thomas Jefferson Birthday"
              }
            },
            "4th monday in April": {
              name: {
                en: "Confederate Memorial Day"
              }
            },
            "1st monday in June": {
              name: {
                en: "Jefferson Davis' birthday"
              }
            }
          }
        },
        AK: {
          name: "Alaska",
          zones: [
            "America/Anchorage",
            "America/Metlakatla",
            "America/Juneau",
            "America/Sitka",
            "America/Yakutat",
            "America/Nome"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "President's Day"
              }
            },
            "monday before April": {
              name: {
                en: "Seward's Day"
              }
            },
            "2nd monday in October": {
              name: {
                en: "Columbus Day"
              },
              active: [
                {
                  to: "2017-01-01"
                }
              ]
            },
            "2nd monday in October #1": {
              name: {
                en: "Indigenous Peoples' Day"
              },
              active: [
                {
                  from: "2017-01-01"
                }
              ]
            },
            "10-18": {
              name: {
                en: "Alaska Day"
              }
            }
          }
        },
        AZ: {
          name: "Arizona",
          zones: [
            "America/Phoenix",
            "America/Denver"
          ],
          days: {
            "3rd monday in January": {
              name: {
                en: "Dr. Martin Luther King Jr./ Civil Rights Day"
              }
            },
            "3rd monday in February": {
              name: {
                en: "Lincoln/Washington Presidents' Day"
              }
            }
          }
        },
        AR: {
          name: "Arkansas",
          zones: [
            "America/Chicago"
          ],
          days: {
            "3rd monday in January": {
              name: {
                en: "Dr. Martin Luther King Jr./Robert E. Lee's Birthdays"
              }
            },
            "3rd monday in February": {
              name: {
                en: "George Washington's Birthday/Daisy Gatson Bates Day"
              }
            },
            "12-24": {
              _name: "12-24"
            }
          }
        },
        CA: {
          name: "California",
          zones: [
            "America/Los_Angeles"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            },
            "2nd monday in October": !1,
            "02-15": {
              type: "observance",
              name: {
                en: "Susan B. Anthony Day"
              }
            },
            "03-31 and if sunday then next monday": {
              substitute: !0,
              name: {
                en: "César Chávez Day"
              }
            },
            "05-19": {
              type: "observance",
              name: {
                en: "Malcolm X Day"
              }
            },
            "05-23": {
              type: "observance",
              name: {
                en: "Harvey Milk Day"
              }
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Day after Thanksgiving Day"
              },
              type: "public"
            }
          },
          regions: {
            LA: {
              name: "Los Angeles",
              days: {
                "08-24": {
                  name: {
                    en: "Kobe Bryant Day"
                  },
                  type: "observance",
                  active: [
                    {
                      from: 2016
                    }
                  ]
                }
              }
            }
          }
        },
        CO: {
          name: "Colorado",
          zones: [
            "America/Denver"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Washington-Lincoln Day"
              }
            },
            "2nd monday in October": {
              type: "observance"
            }
          }
        },
        CT: {
          name: "Connecticut",
          zones: [
            "America/New_York"
          ],
          days: {
            "02-12": {
              name: {
                en: "Lincoln's Birthday"
              }
            },
            "easter -2": {
              _name: "easter -2"
            }
          }
        },
        DE: {
          name: "Delaware",
          days: {
            "2nd monday in October": !1,
            "3rd monday in February": !1,
            "easter -2": {
              _name: "easter -2"
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Day After Thanksgiving"
              }
            },
            "tuesday after 1st monday in November in even years": {
              name: {
                en: "Election Day"
              }
            }
          }
        },
        DC: {
          name: "District of Columbia",
          days: {
            "04-16": {
              name: {
                en: "Emancipation Day"
              }
            },
            "2nd monday in October": {
              name: {
                en: "Columbus Day"
              },
              active: [
                {
                  to: "2019-10-08"
                }
              ]
            },
            "2nd monday in October #1": {
              name: {
                en: "Indigenous Peoples' Day"
              },
              active: [
                {
                  from: "2019-10-09"
                }
              ]
            }
          }
        },
        FL: {
          name: "Florida",
          days: {
            "2nd monday in October": !1,
            "3rd monday in February": !1,
            "02-15": {
              name: {
                en: "Susan B. Anthony Day"
              }
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Day After Thanksgiving"
              }
            }
          }
        },
        GA: {
          name: "Georgia",
          days: {
            "3rd monday in February": !1,
            "monday before 05-01 #1": {
              name: {
                en: "Confederate Memorial Day"
              },
              active: [
                {
                  to: "2016-01-01"
                }
              ]
            },
            "monday before 05-01 #2": {
              name: {
                en: "State Holiday"
              },
              note: "Known as Confederate Memorial Day prior to 2016",
              active: [
                {
                  from: "2016-01-01"
                }
              ]
            },
            "friday after 4th thursday in November #1": {
              name: {
                en: "Robert E. Lee's Birthday"
              },
              note: "General Lee was born on 1807-01-19 but this holiday was traditionally observed the day after Thanksgiving.",
              active: [
                {
                  to: "2016-01-01"
                }
              ]
            },
            "friday after 4th thursday in November #2": {
              name: {
                en: "State Holiday"
              },
              note: "Known as Robert E. Lee's Birtday prior to 2016",
              active: [
                {
                  from: "2016-01-01"
                }
              ]
            },
            "12-24": {
              name: {
                en: "Washington's Birthday"
              }
            },
            "substitutes 12-24 if wednesday then next friday": {
              substitute: !0,
              name: {
                en: "Washington's Birthday"
              }
            }
          }
        },
        HI: {
          name: "Hawaii",
          zones: [
            "Pacific/Honolulu"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            },
            "03-26 and if saturday then previous friday if sunday then next monday": {
              substitute: !0,
              name: {
                en: "Prince Jonah Kuhio Kalanianaole Day"
              }
            },
            "easter -2": {
              _name: "easter -2"
            },
            "06-11 and if saturday then previous friday if sunday then next monday": {
              substitute: !0,
              name: {
                en: "Kamehameha Day"
              }
            },
            "3rd friday in August": {
              name: {
                en: "Statehood Day"
              }
            },
            "2nd monday in October": !1,
            "tuesday after 1st monday in November in even years": {
              name: {
                en: "General Election Day"
              }
            }
          }
        },
        ID: {
          name: "Idaho",
          zones: [
            "America/Boise",
            "America/Los_Angeles"
          ],
          days: {
            "3rd monday in January": {
              name: {
                en: "Martin Luther King, Jr./ Idaho Human Rights Day"
              }
            },
            "3rd monday in February": {
              name: {
                en: "President's Day"
              }
            }
          }
        },
        IL: {
          name: "Illinois",
          zones: [
            "America/Chicago"
          ],
          days: {
            "02-12": {
              name: {
                en: "Lincoln's Birthday"
              }
            },
            "1st monday in March": {
              name: {
                en: "Casimir Pulaski Day"
              }
            },
            "05-19": {
              name: {
                en: "Malcolm X Day"
              }
            },
            "tuesday after 1st monday in November in even years": {
              name: {
                en: "Election Day"
              }
            }
          }
        },
        IN: {
          name: "Indiana",
          zones: [
            "America/Indiana/Indianapolis",
            "America/Indiana/Vincennes",
            "America/Indiana/Winamac",
            "America/Indiana/Marengo",
            "America/Indiana/Petersburg",
            "America/Indiana/Vevay",
            "America/Indiana/Tell_City",
            "America/Indiana/Knox"
          ],
          days: {
            "easter -2": {
              _name: "easter -2"
            },
            "tuesday after 1st monday in May": {
              name: {
                en: "Primary Election Day"
              }
            },
            "tuesday after 1st monday in November": {
              name: {
                en: "Election Day"
              }
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Lincoln's Birthday"
              }
            }
          }
        },
        IA: {
          name: "Iowa",
          zones: [
            "America/Chicago"
          ],
          days: {
            "02-12": {
              name: {
                en: "Lincoln's Birthday"
              }
            },
            "2nd monday in October": {
              name: {
                en: "Columbus Day"
              },
              active: [
                {
                  to: "2018-10-07"
                }
              ]
            },
            "2nd monday in October #1": {
              name: {
                en: "Indigenous Peoples' Day"
              },
              active: [
                {
                  from: "2018-10-08"
                }
              ]
            }
          }
        },
        KS: {
          name: "Kansas",
          zones: [
            "America/Chicago",
            "America/Denver"
          ],
          days: {
            "3rd monday in February": !1
          }
        },
        KY: {
          name: "Kentucky",
          zones: [
            "America/Kentucky/Louisville",
            "America/Kentucky/Monticello"
          ],
          days: {
            "3rd monday in February": !1,
            "easter -2 14:00": {
              _name: "easter -2"
            },
            "12-24": {
              _name: "12-24"
            },
            "12-31": {
              _name: "12-31"
            }
          }
        },
        LA: {
          name: "Louisiana",
          zones: [
            "America/Chicago"
          ],
          days: {
            "easter -2": {
              _name: "easter -2"
            },
            "tuesday after 1st monday in November in even years": {
              name: {
                en: "Election Day"
              }
            }
          },
          regions: {
            NO: {
              name: "New Orleans",
              days: {
                "easter -47": {
                  _name: "easter -47",
                  name: {
                    en: "Mardi Gras"
                  }
                }
              }
            }
          }
        },
        ME: {
          name: "Maine",
          zones: [
            "America/New_York"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Washington's Birthday/President's Day"
              }
            },
            "3rd monday in April": {
              name: {
                en: "Patriots' Day"
              }
            },
            "2nd monday in October #1": {
              name: {
                en: "Indigenous Peoples' Day"
              },
              active: [
                {
                  from: "2019-04-26"
                }
              ]
            }
          }
        },
        MD: {
          name: "Maryland",
          zones: [
            "America/New_York"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "President's Day"
              }
            },
            "friday before 1st monday before 06-01 since 2009 and prior to 2016": {
              name: {
                en: "Service Reduction Day"
              }
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Native American Heritage Day"
              }
            }
          }
        },
        MA: {
          name: "Massachusetts",
          zones: [
            "America/New_York"
          ],
          days: {
            "03-17": {
              name: {
                en: "Evacuation Day"
              }
            },
            "3rd monday in April": {
              name: {
                en: "Patriots' Day"
              }
            },
            "06-17": {
              name: {
                en: "Bunker Hill Day"
              }
            }
          }
        },
        MI: {
          name: "Michigan",
          zones: [
            "America/Detroit",
            "America/Menominee"
          ],
          days: {
            "12-24": {
              _name: "12-24"
            },
            "12-31": {
              _name: "12-31"
            }
          }
        },
        MN: {
          name: "Minnesota",
          zones: [
            "America/Chicago"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Washington's and Lincoln's Birthday"
              }
            },
            "2nd monday in October": {
              name: {
                en: "Columbus Day"
              },
              active: [
                {
                  to: "2017-01-01"
                }
              ]
            },
            "2nd monday in October #1": {
              name: {
                en: "Indigenous Peoples' Day"
              },
              active: [
                {
                  from: "2017-01-01"
                }
              ]
            }
          }
        },
        MS: {
          name: "Mississippi",
          zones: [
            "America/Chicago"
          ],
          days: {
            "3rd monday in January": {
              name: {
                en: "Martin Luther King's and Robert E. Lee's Birthdays"
              }
            },
            "monday before 05-01": {
              name: {
                en: "Confederate Memorial Day"
              }
            }
          }
        },
        MO: {
          name: "Missouri",
          zones: [
            "America/Chicago"
          ],
          days: {
            "02-12": {
              name: {
                en: "Lincoln's Birthday"
              }
            },
            "05-08": {
              name: {
                en: "Truman Day"
              }
            }
          }
        },
        MT: {
          name: "Montana",
          zones: [
            "America/Denver"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Lincoln's and Washington's Birthday"
              }
            },
            "tuesday after 1st monday in November": {
              name: {
                en: "Election Day"
              }
            },
            "12-24": {
              _name: "12-24"
            },
            "12-31": {
              _name: "12-31"
            }
          }
        },
        NE: {
          name: "Nebraska",
          zones: [
            "America/Chicago",
            "America/Denver"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "President's Day"
              }
            },
            "friday before 05-01": {
              name: {
                en: "Arbor Day"
              }
            }
          }
        },
        NV: {
          name: "Nevada",
          zones: [
            "America/Los_Angeles"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents Day"
              }
            },
            "2nd monday in October": !1,
            "08-09": {
              name: {
                en: "Indigenous Peoples' Day"
              },
              active: [
                {
                  from: "2017-01-01"
                }
              ],
              type: "observance"
            },
            "friday before 11-01": {
              name: {
                en: "Nevada Day"
              }
            },
            "4th friday in November": {
              name: {
                en: "Family Day"
              }
            }
          }
        },
        NH: {
          name: "New Hampshire",
          zones: [
            "America/New_York"
          ],
          days: {
            "3rd monday in January": {
              name: {
                en: "Martin Luther King, Jr./ Civil Rights Day"
              }
            },
            "3rd monday in February": {
              name: {
                en: "President's Day"
              }
            },
            "2nd monday in October": {
              type: "observance"
            },
            "tuesday after 1st monday in November in even years": {
              name: {
                en: "Election Day"
              }
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Day after Thanksgiving"
              }
            }
          }
        },
        NJ: {
          name: "New Jersey",
          zones: [
            "America/New_York"
          ],
          days: {
            "02-12": {
              name: {
                en: "Lincoln's Birthday"
              }
            },
            "3rd monday in February": {
              name: {
                en: "Presidents Day"
              }
            },
            "easter -2": {
              _name: "easter -2"
            },
            "tuesday after 1st monday in November": {
              name: {
                en: "Election Day"
              }
            }
          }
        },
        NM: {
          name: "New Mexico",
          zones: [
            "America/Denver"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            },
            "2nd monday in October #1": {
              name: {
                en: "Indigenous Peoples' Day"
              },
              active: [
                {
                  from: "2019-04-01"
                }
              ]
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Day after Thanksgiving"
              }
            }
          }
        },
        NY: {
          name: "New York",
          zones: [
            "America/New_York"
          ],
          days: {
            "02-12": {
              name: {
                en: "Lincoln's Birthday"
              }
            },
            "02-15": {
              name: {
                en: "Susan B. Anthony Day"
              }
            },
            "tuesday after 1st monday in November": {
              name: {
                en: "Election Day"
              }
            }
          }
        },
        NC: {
          name: "North Carolina",
          zones: [
            "America/New_York"
          ],
          days: {
            "3rd monday in February": !1,
            "2nd monday in October": !1,
            "easter -2": {
              _name: "easter -2"
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Day after Thanksgiving"
              }
            },
            "12-24 and if friday then previous thursday if saturday,sunday then previous friday": {
              substitute: !0,
              _name: "12-24"
            }
          }
        },
        ND: {
          name: "North Dakota",
          zones: [
            "America/North_Dakota/Center",
            "America/North_Dakota/New_Salem",
            "America/North_Dakota/Beulah"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            }
          }
        },
        OH: {
          name: "Ohio",
          zones: [
            "America/New_York"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Washington-Lincoln Day"
              }
            }
          }
        },
        OK: {
          name: "Oklahoma",
          zones: [
            "America/Chicago"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Day after Thanksgiving"
              }
            }
          }
        },
        OR: {
          name: "Oregon",
          zones: [
            "America/Los_Angeles"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents Day"
              }
            }
          }
        },
        PA: {
          name: "Pennsylvania",
          zones: [
            "America/New_York"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            },
            "06-14": {
              name: {
                en: "Flag Day"
              }
            }
          }
        },
        RI: {
          name: "Rhode Island",
          zones: [
            "America/New_York"
          ],
          days: {
            "2nd monday in August": {
              name: {
                en: "Victory Day"
              }
            }
          }
        },
        SC: {
          name: "South Carolina",
          zones: [
            "America/New_York"
          ],
          days: {
            "05-10": {
              name: {
                en: "Confederate Memorial Day"
              }
            },
            "12-26": {
              _name: "12-26"
            }
          }
        },
        SD: {
          name: "South Dakota",
          zones: [
            "America/Chicago",
            "America/Denver"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            },
            "2nd monday in October": {
              name: {
                en: "Columbus Day"
              },
              active: [
                {
                  to: "2015-01-01"
                }
              ]
            },
            "2nd monday in October #1": {
              name: {
                en: "Native American Day"
              },
              active: [
                {
                  from: "2015-01-01"
                }
              ]
            }
          }
        },
        TN: {
          name: "Tennessee",
          zones: [
            "America/Chicago",
            "America/New_York"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "President's Day"
              }
            },
            "easter -2": {
              _name: "easter -2"
            },
            "12-24": {
              _name: "12-24"
            }
          }
        },
        TX: {
          name: "Texas",
          zones: [
            "America/Chicago",
            "America/Denver"
          ],
          days: {
            "01-19": {
              name: {
                en: "Confederate Heroes Day"
              },
              type: "observance",
              note: "state agencies are partially staffed"
            },
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            },
            "03-02": {
              name: {
                en: "Texas Independence Day"
              },
              type: "observance",
              note: "state agencies are partially staffed"
            },
            "03-31": {
              name: {
                en: "Cesar Chavez Day"
              },
              type: "observance"
            },
            "easter -2": {
              _name: "easter -2",
              type: "observance"
            },
            "04-21": {
              name: {
                en: "San Jacinto Day"
              },
              type: "observance",
              note: "state agencies are partially staffed"
            },
            "06-19": {
              name: {
                en: "Emancipation Day In Texas"
              },
              type: "observance",
              note: "state agencies are partially staffed"
            },
            "08-27": {
              name: {
                en: "Lyndon Baines Johnson Day"
              },
              type: "observance",
              note: "state agencies are partially staffed"
            },
            "friday after 4th thursday in November": {
              name: {
                en: "Day after Thanksgiving"
              }
            },
            "12-24": {
              _name: "12-24"
            },
            "12-26": {
              _name: "12-26",
              name: {
                en: "Day after Christmas"
              }
            }
          }
        },
        UT: {
          name: "Utah",
          zones: [
            "America/Denver"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Washington and Lincoln Day"
              }
            },
            "07-24": {
              name: {
                en: "Pioneer Day"
              }
            }
          }
        },
        VT: {
          name: "Vermont",
          zones: [
            "America/New_York"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            },
            "1st tuesday in March": {
              name: {
                en: "Town Meeting Day"
              }
            },
            "3rd monday in August": {
              name: {
                en: "Bennington Battle Day"
              }
            },
            "2nd monday in October": {
              name: {
                en: "Columbus Day"
              },
              active: [
                {
                  to: "2017-09-01"
                }
              ]
            },
            "2nd monday in October #1": {
              name: {
                en: "Indigenous Peoples' Day"
              },
              active: [
                {
                  from: "2017-09-01"
                }
              ]
            }
          }
        },
        VA: {
          name: "Virginia",
          zones: [
            "America/New_York"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "George Washington Day"
              }
            },
            "friday before 3rd monday in January prior to 2021": {
              name: {
                en: "Lee–Jackson Day"
              }
            },
            "tuesday after 1st monday in November in even years since 2020": {
              name: "Election Day"
            }
          }
        },
        WA: {
          name: "Washington",
          zones: [
            "America/Los_Angeles"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "Presidents' Day"
              }
            }
          }
        },
        WV: {
          name: "West Virginia",
          zones: [
            "America/New_York"
          ],
          days: {
            "02-15": {
              name: {
                en: "Susan B. Anthony Day"
              }
            },
            "3rd monday in February": {
              name: {
                en: "President's Day"
              }
            },
            "06-20": {
              name: {
                en: "West Virginia Day"
              }
            },
            "4th friday in November": {
              name: {
                en: "Lincoln's Day"
              }
            }
          }
        },
        WI: {
          name: "Wisconsin",
          zones: [
            "America/Chicago"
          ],
          days: {
            "02-15": {
              name: {
                en: "Susan B. Anthony Day"
              }
            },
            "2nd tuesday in September": {
              name: {
                en: "Primary Election Day"
              }
            },
            "tuesday after 1st monday in November": {
              name: {
                en: "Election Day"
              }
            }
          }
        },
        WY: {
          name: "Wyoming",
          zones: [
            "America/Denver"
          ],
          days: {
            "3rd monday in February": {
              name: {
                en: "President's Day"
              }
            }
          }
        }
      }
    },
    UY: {
      names: {
        es: "Uruguay",
        en: "Uruguay"
      },
      dayoff: "sunday",
      langs: [
        "es"
      ],
      zones: [
        "America/Montevideo"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06",
          type: "observance"
        },
        "easter -48": {
          name: {
            en: "Carnival",
            es: "Carnaval"
          },
          type: "observance"
        },
        "easter -47": {
          _name: "easter -47",
          type: "observance"
        },
        "easter -6 P5D": {
          name: {
            en: "Tourism Week",
            es: "Semana de Turismo"
          },
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "04-19 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
          name: {
            en: "Landing of the 33 Orientals",
            es: "Desembarco de los 33 Orientales"
          },
          type: "observance"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-18 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
          name: {
            en: "Battle of Las Piedras",
            es: "Batalla de las Piedras"
          },
          type: "observance"
        },
        "06-19": {
          name: {
            en: "Birthday of José Gervasio Artigas and Never Again Day",
            es: "Natalicio de Artigas y Día del Nunca Más"
          },
          type: "observance"
        },
        "07-18": {
          _name: "Constitution Day"
        },
        "08-25": {
          _name: "Independence Day"
        },
        "10-12 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
          name: {
            en: "Columbus Day",
            es: "Día de la Raza"
          },
          type: "observance"
        },
        "11-02": {
          _name: "11-02",
          type: "observance"
        },
        "12-24": {
          _name: "12-24",
          type: "observance"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-31": {
          _name: "12-31",
          type: "observance"
        }
      }
    },
    VA: {
      names: {
        it: "Stato della Città del Vaticano",
        la: "Status Civitatis Vaticanae",
        en: "Vatican City"
      },
      langs: [
        "it"
      ],
      zones: [
        "Europe/Rome"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          name: {
            en: "Solemnity of Mary, Mother of God",
            it: "Maria Santissima Madre di Dio"
          }
        },
        "01-06": {
          name: {
            en: "Epiphany",
            it: "Epifania del Signore"
          }
        },
        "02-11": {
          name: {
            en: "Anniversary of the foundation of Vatican City",
            it: "Anniversario della istituzione dello Stato della Città del Vaticano"
          }
        },
        "03-19": {
          _name: "03-19"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 39": {
          _name: "easter 39",
          active: [
            {
              to: 2009
            }
          ]
        },
        "easter 60": {
          _name: "easter 60",
          active: [
            {
              to: 2009
            }
          ]
        },
        "05-01": {
          _name: "05-01",
          name: {
            en: "Saint Joseph the Worker",
            it: "San Giuseppe lavoratore"
          }
        },
        "06-29": {
          _name: "06-29"
        },
        "08-15": {
          _name: "08-15",
          name: {
            it: "Assunzione di Maria in Cielo"
          }
        },
        "09-08": {
          name: {
            en: "Nativity of Mary",
            it: "Festa della natività della madonna"
          }
        },
        "11-01": {
          _name: "11-01"
        },
        "12-08": {
          _name: "12-08"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        },
        "10-16": {
          name: {
            en: "Anniversary of the election of Pope John Paul II",
            it: "Anniversario dell'Elezione del Santo Padre"
          },
          active: [
            {
              from: 1978,
              to: 2005
            }
          ]
        },
        "11-04": {
          name: {
            en: "Saint Charles Borromeo - Name day of the Holy Father",
            it: "San Carlo Borromeo - Onomastico del Santo Padre"
          },
          note: "Name day of Pope John Paul II (Karol Józef Wojtyła)",
          active: [
            {
              from: 1978,
              to: 2005
            }
          ]
        },
        "04-19": {
          name: {
            en: "Anniversary of the election of Pope Benedict XVI",
            it: "Anniversario dell'Elezione del Santo Padre"
          },
          active: [
            {
              from: 2005,
              to: 2013
            }
          ]
        },
        "03-19#1": {
          name: {
            en: "Saint Joseph - Name day of the Holy Father",
            it: "San Giuseppe - Onomastico del Santo Padre"
          },
          note: "Name day of Pope Benedict XVI (Josef Ratzinger)",
          active: [
            {
              from: 2005,
              to: 2013
            }
          ]
        },
        "03-13": {
          name: {
            en: "Anniversary of the election of Pope Francis",
            it: "Anniversario dell'Elezione del Santo Padre"
          },
          active: [
            {
              from: 2013
            }
          ]
        },
        "04-23": {
          name: {
            en: "Saint George - Name day of the Holy Father",
            it: "San Giorgio - Onomastico del Santo Padre"
          },
          note: "Name day of Pope Francis (Jorge Mario Bergoglio)",
          active: [
            {
              from: 2013
            }
          ]
        }
      }
    },
    VC: {
      names: {
        en: "St. Vincent & Grenadines"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      dayoff: "sunday",
      days: {
        "01-01 and if Sunday then next Monday": {
          substitute: !0,
          _name: "01-01"
        },
        "03-14 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "National Hero′s Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01 and if Sunday then next Monday": {
          substitute: !0,
          _name: "05-01"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "1st Monday in July": {
          name: {
            en: "Carnival Monday"
          },
          disable: [
            "2021-06-05"
          ],
          enable: [
            "2021-09-06"
          ]
        },
        "Tuesday after 1st Monday in July": {
          name: {
            en: "Carnival Tuesday"
          },
          disable: [
            "2021-06-06"
          ],
          enable: [
            "2021-09-07"
          ]
        },
        "08-01 and if Sunday then next Monday": {
          substitute: !0,
          name: {
            en: "Emancipation Day"
          }
        },
        "10-27 and if Sunday then next Monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "12-25 and if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if Sunday then next Monday": {
          substitute: !0,
          _name: "12-26"
        }
      }
    },
    VE: {
      names: {
        es: "Venezuela",
        en: "Venezuela"
      },
      dayoff: "sundays",
      langs: [
        "es"
      ],
      zones: [
        "America/Caracas"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "01-06": {
          _name: "01-06",
          type: "observance"
        },
        "01-15": {
          name: {
            es: "Día del Maestro",
            en: "Teacher's Day"
          },
          type: "optional",
          note: "teachers only"
        },
        "03-19": {
          _name: "03-19",
          type: "observance"
        },
        "easter -48": {
          name: {
            en: "Carnival",
            es: "Carnaval"
          }
        },
        "easter -47": {
          _name: "easter -47"
        },
        "easter -6 P7D": {
          name: {
            en: "Holy Week",
            es: "Semana Santa"
          },
          type: "observance"
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter"
        },
        "04-19": {
          name: {
            en: "Declaration of Independence",
            es: "Declaración de la Independencia"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "06-24": {
          name: {
            en: "Battle of Carabobo",
            es: "Aniversario de la Batalla de Carabobo"
          }
        },
        "07-05": {
          _name: "Independence Day"
        },
        "07-24": {
          name: {
            en: "Birthday of Simón Bolívar",
            es: "Natalicio de Simón Bolívar"
          }
        },
        "08-03": {
          name: {
            en: "Flag Day",
            es: "Día de la Bandera"
          },
          type: "observance"
        },
        "09-11": {
          name: {
            en: "Our Lady of Coromoto",
            es: "Día de Nuestra Señora de Coromoto"
          },
          type: "observance"
        },
        "10-12": {
          name: {
            en: "Day of Indigenous Resistance",
            es: "Día de la resistencia indígena"
          }
        },
        "11-01": {
          _name: "11-01",
          type: "observance"
        },
        "11-02": {
          _name: "11-02",
          type: "observance"
        },
        "12-08": {
          _name: "12-08",
          type: "observance"
        },
        "12-10": {
          name: {
            en: "Venezuelan Air Force Day",
            es: "Día de la Aviación Nacional"
          },
          type: "observance"
        },
        "12-24": {
          _name: "12-24"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-31": {
          _name: "12-31"
        }
      },
      states: {
        B: {
          name: "Anzoátegui",
          days: {
            "11-14": {
              name: {
                es: "Natalicio de José Antonio Anzoátegui"
              }
            }
          }
        },
        G: {
          name: "Carabobo",
          days: {
            "11-13": {
              name: {
                es: "Día de la Virgen del Socorro"
              }
            }
          }
        },
        K: {
          name: "Lara",
          days: {
            "01-14": {
              name: {
                es: "Día de La Divina Pastora"
              }
            },
            "05-28": {
              name: {
                es: "Natalicio de Jacinto Lara"
              }
            }
          },
          regions: {
            BA: {
              name: "Barquisimeto",
              days: {
                "09-14": {
                  name: {
                    es: "Día de Barquisimeto"
                  }
                }
              }
            }
          }
        },
        M: {
          name: "Miranda",
          days: {
            "03-19": {
              _name: "03-19"
            }
          }
        },
        N: {
          name: "Monagas",
          days: {
            "12-07": {
              name: {
                es: "Día de Maturin"
              }
            }
          }
        },
        S: {
          name: "Táchira",
          days: {
            "08-15": {
              _name: "08-15",
              name: {
                es: "Día de la Virgen de Consolación"
              }
            }
          }
        },
        V: {
          name: "Zulia",
          days: {
            "10-24": {
              name: {
                es: "Natalicio de Rafael Urdaneta"
              }
            },
            "11-18": {
              name: {
                es: "Día de la Virgen de la Chinita"
              }
            }
          }
        }
      }
    },
    VG: {
      names: {
        en: "British Virgin Islands"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "Monday before 03-08": {
          name: {
            en: "The Anniversary of the Birth of Hamilton Lavity Stoutt"
          }
        },
        "2nd Monday in March": {
          name: {
            en: "Commonwealth Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "easter 49": {
          _name: "easter 49",
          type: "observance"
        },
        "easter 50": {
          _name: "easter 50"
        },
        "2nd Saturday after 06-02 prior to 2020": {
          name: {
            en: "Sovereign’s Birthday"
          },
          disable: [
            "2017-06-10",
            "2019-06-15"
          ],
          enable: [
            "2017-06-17",
            "2019-06-07"
          ]
        },
        "2nd Friday after 06-02 since 2020": {
          name: {
            en: "Sovereign’s Birthday"
          }
        },
        "07-01 if Sunday,Thursday then next Monday if Saturday then previous Friday if Tuesday,Wednesday then previous Monday": {
          name: {
            en: "Virgin Islands Day"
          }
        },
        "10-21 if Sunday then next Monday if Saturday then previous Friday if Tuesday,Wednesday then previous Monday if Thursday then next Friday": {
          name: {
            en: "St. Ursula’s Day"
          },
          disable: [
            "2016-10-23",
            "2020-10-19",
            "2021-10-22"
          ],
          enable: [
            "2016-10-19",
            "2020-10-23"
          ]
        },
        "1st Monday in August": {
          name: {
            en: "Emancipation Monday"
          }
        },
        "Tuesday after 1st Monday in August": {
          name: {
            en: "Emancipation Tuesday"
          }
        },
        "Wednesday after 1st Monday in August": {
          name: {
            en: "Emancipation Wednesday"
          }
        },
        "2021-10-18": {
          name: {
            en: "Heroes’ and Forefathers Day"
          }
        },
        "2021-11-08": {
          name: {
            en: "Commemoration of the Great March of 1949"
          }
        },
        "12-25 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-25"
        },
        "12-26 and if Saturday then next Monday if Sunday then next Tuesday": {
          substitute: !0,
          _name: "12-26"
        }
      }
    },
    VI: {
      names: {
        en: "U.S. Virgin Islands"
      },
      langs: [
        "en"
      ],
      zones: [
        "America/Port_of_Spain"
      ],
      dayoff: "sunday",
      _days: "US",
      days: {
        "01-06": {
          _name: "01-06",
          name: {
            en: "Three Kings Day"
          }
        },
        "3rd monday in February": {
          name: {
            en: "President's Day"
          }
        },
        "03-17": !1,
        "03-31": {
          name: {
            en: "Transfer Day"
          }
        },
        "easter -3": {
          _name: "easter -3"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "07-03": {
          name: {
            en: "Emancipation Day"
          }
        },
        "4th Monday in July": {
          name: {
            en: "Hurricane Supplication Day"
          }
        },
        "2nd monday in October": {
          name: {
            en: "Virgin Islands–Puerto Rico Friendship Day"
          }
        },
        "10-25": {
          name: {
            en: "Hurricane Thanksgiving"
          },
          type: "observance"
        },
        "friday after 4th thursday in November": {
          name: {
            en: "Day after Thanksgiving Day"
          },
          type: "school"
        }
      }
    },
    VN: {
      names: {
        vi: "Cộng hòa Xã hội chủ nghĩa Việt Nam",
        en: "Vietnam"
      },
      dayoff: "",
      langs: [
        "vi"
      ],
      zones: [
        "Asia/Ho_Chi_Minh",
        "Asia/Bangkok"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "vietnamese 1-0-1": {
          name: {
            en: "Vietnamese New Year",
            vi: "Tết Nguyên Đán"
          }
        },
        "1 day before vietnamese 1-0-1 P5D": {
          name: {
            en: "Vietnamese New Year Holidays",
            vi: "Giao thừa Tết Nguyên Đán"
          }
        },
        "vietnamese 3-0-10": {
          name: {
            en: "Hung Kings Commemorations",
            vi: "Giỗ tổ Hùng Vương"
          }
        },
        "04-30": {
          name: {
            en: "Day of liberating the South for national reunification",
            vi: "Ngày Giải phóng miền Nam"
          }
        },
        "05-01": {
          _name: "05-01"
        },
        "09-02": {
          name: {
            en: "National Day",
            vi: "Quốc khánh"
          }
        },
        "02-03": {
          name: {
            en: "Communist Party of Viet Nam Foundation Anniversary",
            vi: "Ngày thành lập Đảng"
          },
          type: "observance"
        },
        "03-08": {
          _name: "03-08",
          type: "observance"
        },
        "04-21": {
          name: {
            en: "Vietnam Book Day",
            vi: "Ngày Sách Việt Nam"
          },
          type: "observance"
        },
        "05-07": {
          name: {
            en: "Dien Bien Phu Victory Day",
            vi: "Ngày Chiến thắng Điện Biện Phủ"
          },
          type: "observance"
        },
        "05-19": {
          name: {
            en: "President Ho Chi Minh's Birthday",
            vi: "Ngày sinh Chủ tịch Hồ Chí Minh"
          },
          type: "observance"
        },
        "06-01": {
          name: {
            en: "International Children's Day",
            vi: "Ngày quốc tế Thiếu nhi"
          },
          type: "observance"
        },
        "06-28": {
          name: {
            en: "Vietnamese Family Day",
            vi: "Ngày Gia đình Việt Nam"
          },
          type: "observance"
        },
        "07-27": {
          name: {
            en: "Remembrance Day",
            vi: "Ngày Thương Binh Liệt Sĩ"
          },
          type: "observance"
        },
        "08-19": {
          name: {
            en: "August Revolution Commemoration Day",
            vi: "Ngày cách mạng Tháng Tám"
          },
          type: "observance"
        },
        "10-10": {
          name: {
            en: "Capital Liberation Day",
            vi: "Ngày giải phóng Thủ Đô"
          },
          type: "observance"
        },
        "10-20": {
          name: {
            en: "Vietnamese Women's Day",
            vi: "Ngày Phụ nữ Việt Nam"
          },
          type: "observance"
        },
        "11-20": {
          name: {
            en: "Vietnamese Teacher's Day",
            vi: "Ngày Nhà giáo Việt Nam"
          },
          type: "observance"
        },
        "12-22": {
          name: {
            en: "National Defence Day",
            vi: "Ngày hội Quốc phòng Toàn dân"
          },
          type: "observance"
        },
        "vietnamese 1-0-5": {
          name: {
            en: "Victory of Ngọc Hồi-Đống Đa",
            vi: "Chiến thắng Ngọc Hồi - Đống Đa"
          },
          type: "observance"
        },
        "vietnamese 1-0-15": {
          name: {
            en: "Lantern Festival",
            vi: "Tết Nguyên Tiêu"
          },
          type: "observance"
        },
        "vietnamese 4-0-15": {
          name: {
            en: "Buddha's Birthday",
            vi: "Lễ Phật đản"
          },
          type: "observance"
        },
        "vietnamese 5-0-5": {
          name: {
            en: "Mid-year Festival",
            vi: "Tết Đoan ngọ"
          },
          type: "observance"
        },
        "vietnamese 7-0-15": {
          name: {
            en: "Ghost Festival",
            vi: "Rằm Tháng Bảy, Vu Lan"
          },
          type: "observance"
        },
        "vietnamese 8-0-15": {
          name: {
            en: "Mid-Autumn Festival",
            vi: "Tết Trung thu"
          },
          type: "observance"
        },
        "vietnamese 12-0-23": {
          name: {
            en: "Kitchen guardians",
            vi: "Ông Táo chầu trời"
          },
          type: "observance"
        }
      }
    },
    VU: {
      names: {
        en: "Vanuatu",
        fr: "République de Vanuatu"
      },
      langs: [
        "fr",
        "en",
        "bi"
      ],
      zones: [
        "Pacific/Efate"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "02-21": {
          name: "Mémoire du père de l'indépendance Rév. Dr. W.H. Lini"
        },
        "02-22": {
          _name: "Public Holiday"
        },
        "03-05": {
          name: "Fête des chefs coutumiers"
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01": {
          _name: "05-01"
        },
        "easter 39": {
          _name: "easter 39"
        },
        "07-24": {
          name: "Journée Mondiale des Enfants"
        },
        "07-30": {
          _name: "Independence Day"
        },
        "08-15": {
          _name: "08-15"
        },
        "08-16": {
          _name: "Public Holiday"
        },
        "10-05": {
          _name: "Constitution Day"
        },
        "10-29": {
          name: "Jour de l'Unité"
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          name: "Fête de Famille"
        },
        "12-27": {
          _name: "Public Holiday"
        }
      }
    },
    XK: {
      names: {
        sq: "Republika e Kosovës",
        sr: "Република Косово",
        en: "Kosovo"
      },
      langs: [
        "sq",
        "sr"
      ],
      zones: [
        "Europe/Belgrade"
      ],
      dayoff: "sunday",
      days: {
        "01-01": {
          _name: "01-01"
        },
        "julian 12-25": {
          _name: "julian 12-25"
        },
        "02-17": {
          _name: "Independence Day"
        },
        "04-09": {
          _name: "Constitution Day"
        },
        easter: {
          _name: "easter"
        },
        orthodox: {
          _name: "orthodox"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-09": {
          _name: "05-09"
        },
        "12-25": {
          _name: "12-25"
        },
        "1 Shawwal": {
          _name: "1 Shawwal"
        },
        "10 Dhu al-Hijjah": {
          _name: "10 Dhu al-Hijjah"
        }
      }
    },
    YT: {
      names: {
        fr: "Mayotte",
        en: "Mayotte"
      },
      langs: [
        "fr"
      ],
      zones: [
        "Africa/Nairobi"
      ],
      dayoff: "sunday",
      _days: "FR",
      days: {
        "04-27": {
          _name: "Abolition of Slavery"
        }
      }
    },
    ZA: {
      names: {
        en: "South Africa"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "Africa/Johannesburg"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "substitutes 01-01 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "03-21": {
          name: {
            en: "Human Rights Day"
          }
        },
        "substitutes 03-21 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1",
          name: {
            en: "Family Day"
          }
        },
        "04-27": {
          name: {
            en: "Freedom Day"
          }
        },
        "substitutes 04-27 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "05-01": {
          _name: "05-01",
          name: {
            en: "Workers' Day"
          }
        },
        "substitutes 05-01 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "06-16": {
          name: {
            en: "Youth Day"
          }
        },
        "substitutes 06-16 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "3rd sunday in June": {
          _name: "Fathers Day",
          type: "observance"
        },
        "08-09": {
          name: {
            en: "National Women's Day"
          }
        },
        "substitutes 08-09 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "07-18": {
          name: {
            en: "Nelson Mandela Day"
          },
          type: "observance"
        },
        "09-24": {
          name: {
            en: "Heritage Day"
          }
        },
        "substitutes 09-24 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "12-16": {
          name: {
            en: "Day of Reconciliation"
          }
        },
        "substitutes 12-16 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26",
          name: {
            en: "Day of Goodwill"
          }
        },
        "substitutes 12-26 if sunday then next monday": {
          name: {
            en: "Public Holiday"
          }
        },
        "2023-12-15": {
          name: {
            en: "Rugby World Cup Win Public Holiday"
          }
        },
        "2024-05-29": {
          name: {
            en: "Voting Day"
          }
        }
      }
    },
    ZM: {
      names: {
        en: "Zambia"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "Africa/Maputo"
      ],
      days: {
        "01-01 and if sunday then next monday": {
          substitute: !0,
          _name: "01-01"
        },
        "03-09": {
          name: {
            en: "Women’s Day"
          }
        },
        "03-12 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "Youth Day"
          }
        },
        "easter -2": {
          _name: "easter -2"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "05-01 and if sunday then next monday": {
          substitute: !0,
          _name: "05-01"
        },
        "05-25 and if sunday then next monday": {
          substitute: !0,
          name: {
            en: "African Freedom Day"
          }
        },
        "1st monday in July": {
          name: {
            en: "Heroes' Day"
          }
        },
        "tuesday after 1st monday in July": {
          name: {
            en: "Unity Day"
          }
        },
        "1st monday in August": {
          name: {
            en: "Farmers' Day"
          }
        },
        "2015-10-18": {
          name: {
            en: "National day of Prayers"
          }
        },
        "10-24 and if sunday then next monday": {
          substitute: !0,
          _name: "Independence Day"
        },
        "12-25 and if sunday then next monday": {
          substitute: !0,
          _name: "12-25"
        }
      }
    },
    ZW: {
      names: {
        sn: "Nyika yeZimbabwe",
        nd: "iRiphabhuliki yeZimbabwe",
        xh: "iRiphubliki eyeZimbabwe",
        kck: "Nyika yeZimbabwe",
        en: "Zimbabwe"
      },
      dayoff: "sunday",
      langs: [
        "en"
      ],
      zones: [
        "Africa/Maputo"
      ],
      days: {
        "01-01": {
          _name: "01-01"
        },
        "easter -2": {
          _name: "easter -2"
        },
        easter: {
          _name: "easter",
          type: "observance"
        },
        "easter 1": {
          _name: "easter 1"
        },
        "04-18": {
          _name: "Independence Day"
        },
        "05-01": {
          _name: "05-01"
        },
        "05-25": {
          name: {
            en: "Africa Day"
          }
        },
        "2nd sunday in May": {
          _name: "Mothers Day",
          type: "observance"
        },
        "3rd sunday in June": {
          _name: "Fathers Day",
          type: "observance"
        },
        "2nd monday in August": {
          name: {
            en: "Heroes' Day"
          }
        },
        "2nd tuesday in August": {
          name: {
            en: "Defence Forces Day"
          }
        },
        "12-22": {
          name: {
            en: "Unity Day"
          }
        },
        "12-25": {
          _name: "12-25"
        },
        "12-26": {
          _name: "12-26"
        }
      }
    }
  },
  names: {
    "01-01": {
      name: {
        en: "New Year's Day",
        am: "እንቁጣጣሽ",
        ar: "عيد رأس السنة",
        az: "Yeni il",
        be: "Новы год",
        bg: "Нова Година",
        bs: "Novogodisnji dan",
        ca: "Any nou",
        cz: "Nový rok",
        da: "Nytår",
        de: "Neujahr",
        el: "Πρωτοχρονιά",
        es: "Año Nuevo",
        et: "uusaasta",
        fi: "Uudenvuodenpäivä",
        fil: "Araw ng Bagong Taon",
        fo: "Nýggjársdagur",
        fr: "Nouvel An",
        ge: "ახალი წელი",
        hr: "Nova godina",
        hu: "Újév",
        hy: "Ամանոր",
        id: "Hari tahun baru",
        it: "Capodanno",
        is: "Nýársdagur",
        jp: "元日",
        kl: "ukiortaaq",
        ko: "신정",
        lb: "Neijoerschdag",
        lt: "Naujieji metai",
        lv: "Jaunais Gads",
        mg: "Taom-baovao",
        mk: "Нова Година",
        ms: "Hari Tahun Baru",
        mt: "L-Ewwel tas-Sena",
        nl: "Nieuwjaar",
        no: "Første nyttårsdag",
        pap: "Aña Nobo",
        pl: "Nowy Rok",
        pt: "Ano Novo",
        ro: "Anul nou",
        ru: "Новый год",
        sl: "Novo leto",
        sq: "Viti i Ri",
        sr: "Нова година",
        sv: "Nyårsdagen",
        sw: "Mwaka mpya",
        th: "วันขึ้นปีใหม่",
        ti: "ሓዲሽ ዓመት",
        tr: "Yılbaşı",
        uk: "Новий Рік",
        vi: "Tết Dương lịch",
        zh: "元旦"
      }
    },
    "01-06": {
      name: {
        en: "Epiphany",
        am: "ብርሐነ ጥምቀት",
        da: "Åbenbaring",
        de: "Heilige Drei Könige",
        "de-ch": "Dreikönigstag",
        es: "Día de los Reyes Magos",
        et: "kolmekuningapäev",
        fi: "Loppiainen",
        fr: "l'Épiphanie",
        el: "Θεοφάνεια",
        hr: "Bogojavljenje, Sveta tri kralja",
        hu: "Vízkereszt",
        it: "Befana",
        is: "Þrettándinn",
        lb: "Dräikinneksdag",
        nl: "Driekoningen",
        mk: "Богојавление",
        pl: "Święto Trzech Króli",
        sk: "Zjavenie Pána",
        sv: "Trettondedag jul",
        ti: "ጥምቀት",
        vi: "Lễ Hiển Linh"
      }
    },
    "02-02": {
      name: {
        en: "Candlemas",
        de: "Lichtmess",
        hu: "Gyertyaszentelő Boldogasszony",
        lb: "Liichtmëssdag",
        nl: "Lichtmis",
        vi: "Lễ Đức Mẹ dâng Chúa Giêsu trong đền thánh"
      }
    },
    "02-14": {
      name: {
        en: "Valentine's Day",
        de: "Valentinstag",
        fr: "Saint-Valentin",
        hu: "Valentin nap",
        lb: "Vältesdag",
        nl: "Valentijnsdag",
        no: "Valentinsdag",
        vi: "Lễ tình nhân"
      }
    },
    "03-08": {
      name: {
        en: "International Women's Day",
        az: "Qadınlar günü",
        be: "Мiжнародны жаночы дзень",
        bg: "Ден на жената",
        de: "Internationaler Frauentag",
        fr: "Journée internationale des femmes",
        ge: "ქალთა საერთაშორისო დღე",
        hu: "Nemzetközi nőnap",
        hy: "Կանանց տոն",
        lb: "Internationale Fraendag",
        nl: "Internationale Vrouwendag",
        no: "Kvinnedagen",
        pt: "Dia Internacional da Mulher",
        ro: "Ziua Internationala a Femeii",
        ru: "Международный женский день",
        sl: "Mednarodni dan žena",
        uk: "Міжнародний жіночий день",
        vi: "Quốc tế Phụ nữ",
        zh: "国际妇女节",
        ti: "መዓልቲ ኣነስቲ"
      }
    },
    "03-19": {
      name: {
        en: "Saint Joseph",
        "de-at": "Josefitag",
        de: "Josefstag",
        es: "San José",
        it: "San Giuseppe",
        mt: "San Ġużepp",
        nl: "Hoogfeest van de Heilige Jozef",
        vi: "Kính Thánh Giuse"
      }
    },
    "04-01": {
      name: {
        en: "April Fools' Day",
        de: "1. April",
        hu: "Bolondok napja",
        nl: "1 April",
        no: "Aprilsnarr",
        sq: "Dita e Gënjeshtrave",
        vi: "Cá tháng tư"
      }
    },
    "05-01": {
      name: {
        en: "Labour Day",
        "en-us": "Labor Day",
        ar: "يوم العمال",
        be: "Дзень працы",
        bg: "Ден на труда",
        bs: "Radni dan",
        cz: "Svátek práce",
        da: "1. maj",
        de: "Tag der Arbeit",
        el: "Εργατική Πρωτομαγιά",
        es: "Día del trabajador",
        et: "kevadpüha",
        fi: "Vappu",
        fil: "Araw ng mga Manggagawa",
        fr: "Fête du travail",
        hr: "Praznik rada",
        hu: "A munka ünnepe",
        hy: "Աշխատանքի օր",
        id: "Hari Buruh Internasional",
        it: "Festa del Lavoro",
        is: "Hátíðisdagur Verkamanna",
        lb: "Éischte Mee",
        lt: "Tarptautinė darbo diena",
        lv: "Darba svētki",
        nl: "Dag van de Arbeid",
        no: "Arbeidernes dag",
        mg: "Fetin'ny asa",
        mk: "Ден на трудот",
        ms: "Hari Pekerja",
        mt: "Jum il-Ħaddiem",
        pap: "Dia di Obrero",
        pl: "Święto Pracy",
        pt: "Dia do trabalhador",
        ro: "Ziua muncii",
        sk: "Sviatok práce",
        sl: "Praznik dela",
        sq: "Dita Ndërkombëtare e Punonjësve",
        sr: "Празник рада",
        sv: "Första Maj",
        ti: "የላብ አደሮች ቀን",
        uk: "День міжнародної солідарності трудящих",
        vi: "Quốc tế Lao động",
        zh: "劳动节"
      }
    },
    "05-09": {
      name: {
        en: "Europe Day",
        bg: "Денят на Европа",
        cs: "Den Evropy",
        da: "Europadagen",
        de: "Europatag",
        el: "Ημέρα της Ευρώπης",
        es: "Día de Europa",
        et: "Euroopa päev",
        fi: "Eurooppa-päivä",
        fr: "Journée de l'Europe",
        ga: "Lá na hEorpa",
        hr: "Dan Europe",
        hu: "Európa-nap",
        it: "Festa dell'Europa",
        lb: "Europadag",
        ls: "Dan Evrope",
        lt: "Europos diena",
        lv: "Eiropas diena",
        mt: "Jum l-Ewropa",
        nl: "Europadag",
        pl: "Dzień Europy",
        pt: "Dia da Europa",
        ro: "Ziua Europei",
        sk: "Deň Európy",
        sq: "Dita e Evropës",
        sv: "Europadagen"
      }
    },
    "06-29": {
      name: {
        en: "Saints Peter and Paul",
        de: "Peter und Paul",
        es: "San Pedro y San Pablo",
        fr: "Saint Pierre et Paul",
        it: "Santi Pietro e Paolo",
        mt: "L-Imnarja",
        nl: "Hoogfeest van Petrus en Paulus",
        vi: "Lễ kính Thánh Phêrô"
      }
    },
    "08-15": {
      name: {
        en: "Assumption",
        de: "Mariä Himmelfahrt",
        es: "Asunción",
        fr: "Assomption",
        el: "Κοίμηση της Θεοτόκου",
        hr: "Velika Gospa",
        it: "Ferragosto",
        lb: "Léiffrawëschdag",
        lt: "Žolinė",
        mg: "Asompsiona",
        mk: "Успение на Пресвета Богородица",
        mt: "Santa Marija",
        nl: "O.L.V. Hemelvaart",
        pl: "Wniebowzięcie Najświętszej Maryi Panny",
        pt: "Assunção de Maria",
        ro: "Adormirea Maicii Domnului",
        sl: "Marijino vnebovzetje",
        sq: "Shën Mëria e Gushtit",
        vi: "Đức Mẹ Lên Trời"
      }
    },
    "11-01": {
      name: {
        en: "All Saints' Day",
        bs: "Dita e të gjithë Shenjtorëve",
        de: "Allerheiligen",
        es: "Todos los Santos",
        fi: "Pyhäinpäivä",
        fil: "Undás; Todos los Santos; Araw ng mga Santo",
        fr: "Toussaint",
        hr: "Svi sveti",
        hu: "Mindenszentek",
        it: "Ognissanti",
        lb: "Allerhellegen",
        lt: "Visų šventųjų diena",
        mg: "Fetin'ny olo-masina",
        mk: "Празникот на сите светци",
        nl: "Allerheiligen",
        pl: "Wszystkich Świętych",
        pt: "Todos os santos",
        sk: "Sviatok všetkých svätých",
        sq: "Të gjitha Saints",
        sr: "Сви Свети",
        sv: "Alla Helgons dag",
        vi: "Lễ Các Thánh"
      }
    },
    "11-02": {
      name: {
        en: "All Souls' Day",
        de: "Allerseelen",
        es: "Día de los Difuntos",
        et: "hingedepäev",
        fil: "Araw ng mga Kaluluwa",
        fr: "Fête des morts",
        hr: "Dušni dan",
        hu: "Halottak napja",
        lb: "Allerséilen",
        nl: "Allerzielen",
        pt: "Dia de Finados",
        vi: "Lễ Các Đẳng",
        lt: "Vėlinės"
      }
    },
    "10-04": {
      name: {
        en: "World Animal Day",
        de: "Welttierschutztag",
        es: "Día de los Animales",
        fr: "Journée mondiale des Animaux",
        nl: "Dierendag"
      }
    },
    "11-11": {
      name: {
        en: "Saint Martin",
        de: "Sankt Martin (Faschingsbeginn)",
        hu: "Márton nap",
        nl: "Sint-Maarten",
        vi: "Lễ thánh Martin"
      }
    },
    "12-06": {
      name: {
        en: "Saint Nicholas",
        de: "Sankt Nikolaus",
        fr: "Saint-Nicolas",
        hu: "Mikulás",
        lb: "Niklosdag",
        nl: "Sinterklaas",
        vi: "Thánh Saint Nicholas"
      }
    },
    "12-07": {
      name: {
        it: "Sant'Ambrogio",
        en: "Saint Ambrose",
        de: "Ambrosius von Mailand",
        nl: "Ambrosius van Milaan"
      }
    },
    "12-08": {
      name: {
        en: "Immaculate Conception",
        de: "Mariä Empfängnis",
        es: "La inmaculada concepción",
        fr: "Immaculée Conception",
        it: "Immacolata Concezione",
        mt: "Il-Kunċizzjoni",
        nl: "Onbevlekte Ontvangenis van Maria",
        pt: "Imaculada Conceição"
      }
    },
    "12-24": {
      name: {
        en: "Christmas Eve",
        bg: "Бъдни вечер",
        bs: "Badnji dan",
        cz: "Štědrý den",
        da: "Juleaften",
        de: "Heiliger Abend",
        es: "Nochebuena",
        et: "jõululaupäev",
        fo: "Jólaaftan",
        fi: "Jouluaatto",
        fil: "Bisperas ng Pasko",
        fr: "Veille de Noël",
        hr: "Badnji dan",
        hu: "Szenteste",
        is: "Aðfangadagur",
        kl: "juulliaraq",
        lb: "Hellegowend",
        lt: "Šv. Kūčios",
        lv: "Ziemassvētku vakars",
        ms: "Hari Sebelum Krismas",
        nl: "Kerstavond",
        no: "Julaften",
        pt: "Noite de Natal",
        sk: "Štedrý deň",
        sq: "Nata e Krishtlindjes",
        sr: "Бадњи дан",
        sv: "Julafton",
        vi: "Đêm Giáng Sinh"
      }
    },
    "12-25": {
      name: {
        en: "Christmas Day",
        am: "ልደተ-ለእግዚእነ/ ገና",
        ar: "عيد الميلاد المجيد",
        bg: "Коледа",
        bn: "বড়দিন",
        bs: "Božić",
        "de-at": "Christtag",
        ca: "Nadal",
        cz: "1. svátek vánoční",
        da: "Juledag",
        de: "Weihnachten",
        "de-ch": "Weihnachtstag",
        el: "Χριστούγεννα",
        es: "Navidad",
        et: "esimene jõulupüha",
        fi: "Joulupäivä",
        fil: "Araw ng Pasko",
        fo: "Fyrsti jóladagur",
        fr: "Noël",
        hr: "Božić",
        hu: "Karácsony",
        hy: "Սուրբ Ծնունդ",
        id: "Hari Raya Natal",
        it: "Natale",
        is: "Jóladagur",
        jp: "ノエル",
        kl: "juullerujussuaq",
        ko: "기독탄신일",
        lb: "Chrëschtdag",
        lt: "Šv. Kalėdos",
        lv: "Ziemassvētki",
        mg: "Krismasy",
        mk: "Католички Божиќ",
        ms: "Hari Krismas",
        mt: "Il-Milied",
        nl: "Kerstmis",
        no: "Første Juledag",
        pap: "Dia Pasco di Nascimento",
        pl: "Pierwszy dzień Bożego Narodzenia",
        pt: "Natal",
        ro: "Crăciunul",
        ru: "Рождество Христово",
        sk: "Prvý sviatok vianočný",
        sl: "Božič",
        sq: "Krishtlindja",
        sr: "Католички Божић",
        sv: "Juldagen",
        sw: "Krismasi",
        ti: "ልደት",
        uk: "Різдво Христове",
        vi: "Lễ Giáng Sinh",
        zh: "聖誕節"
      }
    },
    "12-26": {
      name: {
        en: "Boxing Day",
        bg: "2-ри ден на Коледа",
        cz: "2. svátek vánoční",
        da: "Anden Juledag",
        de: "2. Weihnachtstag",
        "de-at": "Stefanitag",
        "de-ch": "Stephanstag",
        el: "Δεύτερη μέρα των Χριστουγέννων",
        es: "San Esteban",
        et: "teine jõulupüha",
        fi: "2. joulupäivä",
        fo: "Fyrsti gerandisdagur eftir jóladag",
        fr: "Lendemain de Noël",
        hr: "Svetog Stjepana",
        hu: "Karácsony másnapja",
        it: "Santo Stefano",
        is: "Annar í jólum",
        kl: "juullip aappaa",
        lb: "Stiefesdag",
        lt: "2. Kalėdų diena",
        lv: "Otrie Ziemassvētki",
        nl: "Tweede kerstdag",
        no: "Andre juledag",
        pap: "Di dos Dia Pasco di Nascimento",
        pl: "Drugi dzień Bożego Narodzenia",
        ro: "A doua zi de Crăciun",
        sk: "Druhý sviatok vianočný",
        sv: "Annandag jul",
        vi: "Ngày tặng quà"
      }
    },
    "12-31": {
      name: {
        en: "New Year's Eve",
        da: "Nytårsaften",
        de: "Silvester",
        es: "Fin del Año",
        fi: "Uudenvuodenaatto",
        fil: "Bisperas ng Bagong Taon",
        fo: "Nýggjársaftan",
        fr: "Saint-Sylvestre",
        hu: "Szilveszter",
        hy: "Նոր տարվա գիշեր",
        is: "Gamlársdagur",
        it: "Ultimo dell’anno",
        jp: "大晦日",
        lb: "Silvester",
        lv: "Vecgada vakars",
        nl: "Oudejaarsavond",
        no: "Nyttårsaften",
        pt: "Véspera de Ano Novo",
        sv: "Nyårsafton",
        th: "วันสิ้นปี",
        vi: "Đêm giao thừa"
      }
    },
    "easter -48": {
      name: {
        en: "Shrove Monday",
        de: "Rosenmontag",
        es: "Carnaval",
        fr: "Lundi de Carnaval",
        lb: "Fuesméindeg",
        nl: "Carnavalsmaandag",
        pap: "Dialuna di Carnaval",
        vi: "Ngày thứ hai hoa hồng"
      }
    },
    "easter -47": {
      name: {
        en: "Shrove Tuesday",
        es: "Carnaval",
        de: "Faschingsdienstag",
        hr: "Pokladni utorak",
        hu: "Húshagyó kedd",
        nl: "Vastenavond",
        pt: "Carnaval",
        vi: "Thứ ba mập béo"
      }
    },
    "easter -46": {
      name: {
        en: "Ash Wednesday",
        de: "Aschermittwoch",
        es: "Miercoles de Ceniza",
        fr: "Mercredi des Cendres",
        hu: "Hamvazószerda",
        it: "Ceneri",
        is: "Öskudagur",
        lb: "Äschermëttwoch",
        nl: "Aswoensdag",
        no: "Askeonsdag",
        pt: "Quarta-feira de Cinzas",
        sw: "Jumatano ya Majivu",
        vi: "Thứ tư Lễ Tro"
      }
    },
    "easter -7": {
      name: {
        en: "Palm Sunday",
        de: "Palmsonntag",
        es: "Domingo de Ramos",
        hu: "Virágvasárnap",
        it: "Domenica delle Palme",
        is: "Pálmasunnudagur",
        lb: "Pällemsonndeg",
        nl: "Palmzondag",
        no: "Palmesøndag",
        vi: "Chúa nhật Lễ Lá"
      }
    },
    "easter -3": {
      name: {
        en: "Maundy Thursday",
        cz: "Zelený čtvrtek",
        da: "Skærtorsdag",
        de: "Gründonnerstag",
        es: "Jueves Santo",
        fil: "Huwebes Santo",
        fo: "Skírhósdagur",
        fr: "Jeudi saint",
        is: "Skírdagur",
        it: "Giovedì santo",
        kl: "sisamanngortoq illernartoq",
        lb: "Gréngen Donneschdeg",
        nl: "Witte Donderdag",
        no: "Skjærtorsdag",
        sv: "Skärtorsdagen",
        vi: "Thứ năm Tuần Thánh"
      }
    },
    "easter -2": {
      name: {
        en: "Good Friday",
        am: "ስቅለት",
        bg: "Разпети петък",
        bs: "Dobar petak",
        cz: "Velký pátek",
        da: "Langfredag",
        de: "Karfreitag",
        es: "Viernes Santo",
        fi: "Pitkäperjantai",
        fil: "Biyernes Santo",
        fo: "Langafríggjadagur",
        fr: "Vendredi saint",
        el: "Μεγάλη Παρασκευή",
        et: "suur reede",
        ge: "წითელი პარასკევი",
        hr: "Veliki petak",
        hu: "Nagypéntek",
        id: "Wafat Yesus Kristus",
        it: "Venerdì santo",
        is: "Föstudagurinn langi",
        kl: "tallimanngornersuaq",
        lb: "Karfreideg",
        lv: "Lielā Piektdiena",
        ms: "Jumat Agung",
        mt: "Il-Ġimgħa l-Kbira",
        nl: "Goede Vrijdag",
        no: "Langfredag",
        pap: "Diabierna Santo",
        pt: "Sexta-Feira Santa",
        ro: "Vinerea Mare",
        sk: "Veľkonočný piatok",
        sq: "E Premtja e Madhe",
        sr: "Католички Велики петак",
        sv: "Långfredagen",
        sw: "Ijumaa Kuu",
        vi: "Thứ sáu Tuần Thánh",
        zh: "耶穌受難節"
      }
    },
    "easter -1": {
      name: {
        en: "Easter Saturday",
        cz: "Bílá sobota",
        de: "Karsamstag",
        es: "Sabado Santo",
        fil: "Sabado de Gloria",
        fr: "Samedi saint",
        ge: "დიდი შაბათი",
        hu: "Nagyszombat",
        it: "Sabado santo",
        lb: "Karsamschdeg",
        nl: "Dag voor Pasen",
        no: "Påskeaften",
        sv: "Påskafton",
        vi: "Thứ bảy Tuần Thánh",
        zh: "耶穌受難節翌日"
      }
    },
    easter: {
      name: {
        en: "Easter Sunday",
        am: "ፋሲካ",
        bg: "Великден",
        bs: "Vaskrs",
        cz: "Velikonoční neděle",
        da: "Påskesøndag",
        de: "Ostersonntag",
        el: "Πάσχα",
        es: "Pascua",
        et: "lihavõtted",
        fi: "Pääsiäispäivä",
        fil: "Pasko ng Pagkabuhay",
        fo: "Páskadagur",
        fr: "Pâques",
        ge: "აღდგომა",
        hr: "Uskrs",
        hu: "Húsvétvasárnap",
        it: "Domenica di Pasqua",
        is: "Páskadagur",
        kl: "poorskip-ullua",
        lb: "Ouschtersonndeg",
        lt: "Velykos",
        lv: "Lieldienas",
        nl: "Pasen",
        no: "Første påskedag",
        pap: "Dia Pasco di Resureccion",
        pl: "Niedziela Wielkanocna",
        pt: "Páscoa",
        ro: "Paștele",
        sk: "Veľká noc",
        sl: "Velika noč",
        sq: "Pashkët Katolike",
        sr: "Католички Васкрс",
        sv: "Påskdagen",
        sw: "Pasaka",
        vi: "Lễ Phục Sinh",
        zh: "复活节"
      }
    },
    "easter 1": {
      name: {
        en: "Easter Monday",
        bg: "Велики понеделник",
        bs: "Uskrsni ponedjeljak",
        cz: "Velikonoční pondělí",
        da: "Anden påskedag",
        de: "Ostermontag",
        el: "Δευτέρα του Πάσχα",
        es: "Lunes de Pascua",
        fi: "2. pääsiäispäivä",
        fo: "Annar páskadagur",
        fr: "Lundi de Pâques",
        ge: "აღდგომის ორშაბათი",
        hr: "Uskršnji ponedjeljak",
        hu: "Húsvéthétfő",
        it: "Lunedì dell’Angelo",
        is: "Annar í páskum",
        kl: "poorskip-aappaa",
        lb: "Ouschterméindeg",
        lt: "Velykų pirmadienis",
        lv: "Otrās Lieldienas",
        mg: "Alatsinain'ny Paska",
        mk: "вториот ден на Велигден",
        nl: "Tweede paasdag",
        no: "Andre påskedag",
        pap: "Di dos Dia Pasco di Resureccion",
        pl: "Drugi dzień Wielkanocy",
        ro: "A doua zi de Pasti",
        sk: "Veľkonočný pondelok",
        sl: "Velikonočni ponedeljek",
        sr: "Католички Васкрсни понедељак",
        sv: "Annandag påsk",
        sw: "Jumatatu ya Pasaka",
        vi: "Thứ hai phục sinh",
        zh: "復活節星期一"
      }
    },
    "easter 39": {
      name: {
        en: "Ascension Day",
        da: "Kristi Himmelfartsdag",
        de: "Christi Himmelfahrt",
        es: "La Asunción",
        fi: "Helatorstai",
        fo: "Kristi Himmalsferðardagur",
        fr: "Ascension",
        id: "Kenaikan Yesus Kristus",
        it: "Ascensione",
        is: "Uppstigningardagur",
        kl: "qilaliarfik",
        mg: "Andro niakarana",
        lb: "Christi Himmelfaart",
        nl: "O.L.H. Hemelvaart",
        no: "Kristi himmelfartsdag",
        pap: "Dia di Asuncion",
        ro: "Ziua Eroilor",
        sv: "Kristi himmelfärds dag",
        vi: "Lễ Thăng Thiên"
      }
    },
    "easter 49": {
      name: {
        en: "Pentecost",
        da: "Pinsedag",
        de: "Pfingstsonntag",
        el: "Πεντηκοστή",
        es: "Pentecostés",
        et: "nelipühade 1. püha",
        fi: "Helluntaipäivä",
        fo: "Hvítusunnudagur",
        fr: "Pentecôte",
        hu: "Pünkösdvasárnap",
        it: "Pentecoste",
        is: "Hvítasunnudagur",
        kl: "piinsip ullua",
        lb: "Päischtsonndeg",
        nl: "Pinksteren",
        no: "Første pinsedag",
        mk: "Духовден",
        pl: "Zielone Świątki",
        ro: "Rusaliile",
        sl: "Binkošti",
        sv: "Pingstdagen",
        uk: "Трійця",
        vi: "Lễ Chúa Thánh Thần Hiện Xuống"
      }
    },
    "easter 50": {
      name: {
        en: "Whit Monday",
        da: "Anden Pinsedag",
        de: "Pfingstmontag",
        el: "Αγίου Πνεύματος",
        es: "Lunes de Pentecostés",
        fo: "Annar hvítusunnudagur",
        fr: "Lundi de Pentecôte",
        hu: "Pünkösdhétfő",
        is: "Annar í hvítasunnu",
        it: "Lunedì di Pentecoste",
        kl: "piinsip aappaa",
        mg: "Alatsinain'ny Pentekosta",
        lb: "Péngschtméindeg",
        nl: "Tweede pinksterdag",
        no: "Andre pinsedag",
        ro: "A doua zi de Rusalii",
        sv: "Annandag pingst"
      }
    },
    "easter 60": {
      name: {
        en: "Corpus Christi",
        de: "Fronleichnam",
        es: "Corpus Christi",
        fr: "la Fête-Dieu",
        it: "Corpus Domini",
        hr: "Tijelovo",
        nl: "Sacramentsdag",
        pl: "Dzień Bożego Ciała",
        pt: "Corpo de Deus",
        vi: "Lễ Mình và Máu Thánh Chúa Kitô"
      }
    },
    "julian 01-01": {
      name: {
        en: "Orthodox New Year",
        bs: "Pravoslavni novogodišnji dan",
        hr: "Pravoslavna Nova Godina",
        nl: "Orthodox Nieuwjaar",
        sq: "Viti i Ri Ortodoks",
        sr: "Православна Нова година"
      }
    },
    "julian 12-24": {
      name: {
        en: "Orthodox Christmas Eve",
        nl: "Orthodoxe Kerstavond",
        mk: "Бадник",
        ti: "ልደት"
      }
    },
    "julian 12-25": {
      name: {
        en: "Orthodox Christmas",
        bs: "Pravoslavni Božić",
        hr: "Pravoslavni Božić",
        mk: "Прв ден Божик",
        nl: "Orthodoxe Kerstmis",
        ro: "Craciun pe Rit Vechi",
        sq: "Krishtlindjet Ortodokse",
        sr: "Божић",
        uk: "Різдво"
      }
    },
    "orthodox -2": {
      name: {
        en: "Orthodox Good Friday",
        mk: "Велики Петок",
        nl: "Orthodoxe Goede Vrijdag",
        sr: "Велики петак",
        ti: "ዓርቢ ስቅለት"
      }
    },
    orthodox: {
      name: {
        en: "Orthodox Easter",
        bs: "Pravoslavni Vaskrs",
        hr: "Pravoslavni Uskrs",
        mk: "Прв ден Велигден",
        nl: "Orthodox Pasen",
        sq: "Pashkët Ortodokse",
        sr: "Васкрс",
        ti: "ፋሲካ",
        uk: "Великдень"
      }
    },
    "orthodox 1": {
      name: {
        en: "Orthodox Easter Monday",
        mk: "Втор ден Велигден",
        nl: "Orthodoxe Tweede Paasdag",
        sr: "Васкрсни понедељак"
      }
    },
    "1 Muharram": {
      name: {
        en: "Islamic New Year",
        ar: "رأس السنة الهجرية",
        bs: "Nova hidžretska godina",
        fil: "Unang Araw ng Muharram",
        fr: "Nouvel an islamique",
        hr: "Nova hidžretska godina",
        id: "Tahun Baru Islam",
        ms: "Awal Muharram",
        nl: "Islamitisch Nieuwjaar",
        sq: "Viti i Ri hixhri"
      }
    },
    "10 Muharram": {
      name: {
        en: "Day of Ashura",
        ar: "عاشوراء",
        bn: "আশুরা",
        nl: "De tiende dag (Asjoera)"
      }
    },
    "12 Rabi al-awwal": {
      name: {
        en: "Birthday of Muhammad (Mawlid)",
        am: "መውሊድ",
        ar: "المولد النبويّ",
        bn: "ঈদে মিলাদুন্নবী",
        bs: "Mevlud",
        fr: "Mawlid",
        id: "Maulid Nabi Muhammad",
        ms: "Hari Keputeraan Nabi Muhammad S.A.W.",
        nl: "Geboortedag Mohammed (Mawlid an-Nabi)",
        sq: "Mevludi"
      }
    },
    "27 Rajab": {
      name: {
        en: "Laylat al-Mi'raj",
        ar: "الإسراء والمعراج",
        bs: "Lejletul Mi'radž",
        id: "Maulid Nabi Muhammad",
        ms: "Israk dan Mikraj",
        nl: "Hemelvaart Mohammed (Lailat-ul-Meraj)",
        sq: "Nata e Miraxhit",
        tr: "Miraç Gecesi"
      }
    },
    "15 Shaban": {
      name: {
        en: "Laylat al-Bara'at",
        ar: "ليلة البراءة",
        bs: "Lejletul berat",
        nl: "Nacht van de Lotsbezegeling (Lailat-ul-Baraat)",
        sq: "Nata e Beratit"
      }
    },
    "1 Ramadan": {
      name: {
        en: "First day of Ramadan",
        am: "ረመዳን",
        ar: "اليوم الأول من رمضان",
        bs: "Prvi dan posta",
        ms: "Awal Ramadan",
        nl: "Eerste dag van Ramadan",
        sq: "Dita e parë e agjërimit"
      }
    },
    "17 Ramadan": {
      name: {
        en: "Day of Nuzul Al-Quran",
        ms: "Hari Nuzul Al-Quran"
      }
    },
    "23 Ramadan": {
      name: {
        en: "Lailat al-Qadr"
      }
    },
    "27 Ramadan": {
      name: {
        en: "Laylat al-Qadr",
        ar: "لیلة القدر",
        bs: "Lejletul kadr",
        nl: "Waardevolle Nacht (Laylat al-Qadr)",
        sq: "Nata e Kadrit"
      }
    },
    "1 Shawwal": {
      name: {
        en: "End of Ramadan (Eid al-Fitr)",
        am: "ዒድ አል ፈጥር",
        ar: "عيد الفطر",
        az: "Ramazan Bayramı",
        bn: "ঈদুল ফিতর",
        bs: "Ramazanski bajram",
        de: "Zuckerfest",
        es: "Fiesta del Eid Fitr",
        fa: "ﻋﯿﺪ ﺳﻌﯿﺪ ﻓﻄﺮ",
        fil: "Pagwawakas ng Ramadan",
        fr: "Fête de fin du Ramadan",
        hr: "Ramazanski bajram",
        id: "Hari Raya Idul Fitri",
        nl: "Suikerfeest (Eid al-Fitr)",
        mk: "Рамазан Бајрам",
        ms: "Hari Raya Aidil Fitri",
        sq: "Fitër Bajrami",
        tr: "Ramazan Bayramı",
        sr: "Рамазански Бајрам",
        sw: "Idd-ul-Fitr"
      }
    },
    "9 Dhu al-Hijjah": {
      name: {
        en: "Arafat Day",
        ar: "يوم عرفة",
        es: "Fiesta del Sacrificio-Eidul Adha",
        ms: "Hari Arafah"
      }
    },
    "10 Dhu al-Hijjah": {
      name: {
        en: "Feast of the Sacrifice (Eid al-Adha)",
        am: "ዒድ አል አድሐ",
        ar: "عيد الأضحى",
        az: "Qurban Bayramı",
        bn: "ঈদুল আযহা",
        bs: "Kurbanski bajram",
        de: "Opferfest",
        es: "Fiesta del Sacrificio-Aid Al Adha",
        fa: "ﻋﯿﺪ ﺳﻌﯿﺪ ﻗﺮﺑﺎن",
        fil: "Eidul Adha",
        fr: "Fête du mouton",
        hr: "Kurban-bajram",
        id: "Hari Raya Idul Adha",
        nl: "Offerfeest (Eid Al-Adha)",
        mk: "Курбан Бајрам",
        ms: "Hari Raya Haji",
        sq: "Kurban Bajrami",
        tr: "Kurban Bayramı",
        sr: "Курбански Бајрам",
        sw: "Idd-ul-Azha"
      }
    },
    "15 Nisan": {
      name: {
        en: "Pesach",
        bs: "Pesah",
        de: "Pessach",
        hr: "Pesač",
        nl: "Pesach",
        sq: "Pesach",
        sr: "Песах"
      }
    },
    "1 Tishrei": {
      name: {
        en: "Rosh Hashanah",
        bs: "Roš Hašana",
        de: "Rosch Haschana",
        hr: "Roš Hašane",
        nl: "Rosj Hasjana",
        sq: "Rosh Hashanah",
        sr: "Рош Хашана"
      }
    },
    "10 Tishrei": {
      name: {
        en: "Yom Kippur",
        bs: "Jom Kipur",
        de: "Jom Kippur",
        hr: "Jom Kipur",
        mk: "Јом Кипур",
        nl: "Jom Kipoer",
        sq: "Yom Kippur",
        sr: "Јом Кипур"
      }
    },
    Deepavali: {
      name: {
        en: "Deepavali",
        nl: "Divali"
      }
    },
    Vesak: {
      name: {
        en: "Vesak Day",
        id: "Hari Raya Waisak",
        nl: "Vesakha Puja",
        th: "วันวิสาขบูชา"
      }
    },
    Holi: {
      name: {
        en: "Holi Phagwa",
        nl: "Holifeest"
      }
    },
    Thaipusam: {
      name: {
        en: "Thaipusam",
        ms: "Hari Thaipusam"
      }
    },
    "Makha Bucha": {
      name: {
        en: "Makha Bucha",
        nl: "Magha Puja",
        th: "วันมาฆบูชา"
      }
    },
    "Asalha Puja": {
      name: {
        en: "Asalha Puja",
        nl: "Asalha Puja",
        th: "วันอาสาฬหบูชา"
      }
    },
    "Buddhist Lent": {
      name: {
        en: "Buddhist Lent",
        nl: "Vassa",
        th: "วันเข้าพรรษา"
      }
    },
    "Abolition of Slavery": {
      name: {
        en: "Abolition of Slavery",
        fr: "Abolition de l’esclavage",
        nl: "Afschaffing van de slavernij",
        vi: "Bãi bỏ chế độ Nô lệ"
      }
    },
    "Buß- und Bettag": {
      name: {
        de: "Buß- und Bettag",
        en: "Day of Prayer and Repentance"
      }
    },
    "Constitution Day": {
      name: {
        en: "Constitution Day",
        da: "Grundlovsdag",
        de: "Tag der Verfassung",
        ca: "Dia de la Constitució",
        es: "Día de la Constitución",
        fil: "Araw ng Saligang Batas",
        fo: "Grundlógardagur",
        hy: "Սահմանադրության օր",
        jp: "憲法記念日",
        ko: "제헌절",
        nl: "Dag van de Grondwet",
        no: "Grunnlovsdagen",
        pt: "Dia da Constituição",
        ro: "Ziua Constituției",
        sk: "Deň Ústavy",
        sq: "Dita e Kushtetutës",
        uk: "День Конституції",
        vi: "Ngày pháp luật"
      }
    },
    "Fathers Day": {
      name: {
        en: "Father's Day",
        et: "isadepäev",
        fi: "Isänpäivä",
        fr: "Fête des Pères",
        lt: "Tėvo diena",
        nl: "Vaderdag",
        pt: "Dia dos Pais",
        no: "Farsdag",
        sv: "Fars dag",
        vi: "Ngày của cha"
      }
    },
    "Independence Day": {
      name: {
        en: "Independence Day",
        ar: "عيد الاستقلال",
        be: "Дзень Незалежнасцi",
        bg: "Ден на независимостта",
        bs: "Dan nezavisnosti",
        de: "Unabhängigkeitstag",
        es: "Día de la Independencia",
        et: "iseseisvuspäev",
        fi: "Itsenäisyyspäivä",
        fil: "Araw ng Kalayaan",
        fr: "Jour de l'Indépendance",
        hr: "Dan neovisnosti",
        hy: "Անկախության օր",
        id: "Hari Ulang Tahun Kemerdekaan Republik Indonesia",
        mk: "Ден на независноста",
        ms: "Hari Kebangsaan",
        mt: "Jum l-Indipendenza",
        nl: "Onafhankelijkheidsdag",
        pl: "Narodowe Święto Niepodległości",
        pt: "Dia da Independência",
        ro: "Ziua Independentei",
        sq: "Dita e Pavarësisë",
        sr: "Дан независности",
        sv: "Självständighetsdagen",
        sw: "Siku ya uhuru",
        ti: "መዓልቲ ናጽነት",
        uk: "День Незалежності",
        vi: "Ngày Độc lập"
      }
    },
    "Liberation Day": {
      name: {
        en: "Liberation Day",
        ar: "يوم التحرير",
        nl: "Bevrijdingsdag",
        no: "Frigjøringsdagen",
        sq: "Dita e Çlirimit",
        vi: "Ngày Thống nhất"
      }
    },
    "Mothers Day": {
      name: {
        en: "Mother's Day",
        cz: "Den matek",
        da: "Mors Dag",
        de: "Muttertag",
        el: "Γιορτή της μητέρας",
        es: "Día de la Madre",
        et: "emadepäev",
        fi: "Äitienpäivä",
        fr: "Fête des Mères",
        hr: "Majčin dan",
        hu: "Anyák napja",
        hy: "Ցեղասպանության զոհերի հիշատակի օր",
        is: "Mæðradagurinn",
        it: "Festa della mamma",
        lt: "Motinos diena",
        lv: "Mātes diena",
        nl: "Moederdag",
        no: "Morsdag",
        pt: "Dia das Mães",
        pl: "Dzień Matki",
        ro: "Ziua Mamei",
        sq: "Dita e Nënës",
        sv: "Mors dag",
        vi: "Ngày của mẹ"
      }
    },
    "National Holiday": {
      name: {
        en: "National Holiday",
        de: "Nationalfeiertag",
        es: "Fiesta Nacional",
        fr: "Fête nationale",
        hu: "Nemzeti ünnep",
        el: "εθνική επέτειος",
        lb: "Nationalfeierdag",
        nl: "Nationale feestdag",
        vi: "Quốc Lễ"
      }
    },
    "Public Holiday": {
      name: {
        en: "Public Holiday",
        fr: "Jour férié légaux",
        nl: "Wettelijke feestdag",
        pt: "Feriado Obrigatório",
        vi: "Nghỉ lễ Toàn Quốc"
      }
    },
    "Reformation Day": {
      name: {
        en: "Reformation Day",
        de: "Reformationstag",
        es: "Día Nacional de las Iglesias Evangélicas y Protestantes",
        nl: "Hervormingsdag",
        vi: "Kháng Cách"
      }
    },
    "Revolution Day": {
      name: {
        en: "Revolution Day",
        ar: "يوم الثورة",
        es: "Día de la Revolución",
        nl: "Dag van de Revolutie",
        ti: "ባሕቲ መስከረም",
        vi: "Tổng khởi nghĩa"
      }
    },
    "Bridge Day": {
      name: {
        en: "Bridge Day",
        es: "Feriado Puente Turístico"
      }
    },
    substitutes: {
      name: {
        en: "substitute day",
        az: "əvəz gün",
        bs: "zamjena dan",
        de: "Ersatztag",
        es: "día sustituto",
        fr: "jour substitut",
        hr: "zamjena dan",
        jp: "振替休日",
        lv: "aizstājējs diena",
        mk: "заменет ден",
        nl: "substituut",
        sq: "ditë zëvendësuese",
        sr: "замена дан",
        uk: "замінити день",
        vi: "ngày thay thế",
        zh: "更换日"
      }
    }
  }
};
/**
 * @copyright 2015-present (c) commenthol
 * @license ISC
 */
class sP extends iP {
  constructor(n, a, t, r) {
    super(bP, n, a, t, r);
  }
}
function yU(e, n, a = "en") {
  var M;
  if (n || (n = (/* @__PURE__ */ new Date()).getFullYear()), (e == null ? void 0 : e.length) === 3 && (e = (M = j0[e.toUpperCase()]) == null ? void 0 : M.iso2), !e || !R1(e) || e.length > 3 || e.length < 2)
    throw new Error("Invalid country");
  return new sP(e.toLowerCase()).getHolidays(n, a).map((b) => ({
    date: b.date.substring(0, 10),
    name: b.name
  }));
}
function dP(e) {
  const n = e.lastIndexOf(".");
  if (n === -1)
    return [e, null];
  const a = e.slice(0, n), t = e.slice(n + 1);
  return [a, t];
}
function WU(e) {
  const n = [];
  if (!e || typeof e != "string")
    return [];
  let a = !0;
  for (; a; ) {
    let t;
    n.push(e), [e, t] = dP(e), t || (a = !1);
  }
  return n.reverse();
}
const pP = "mr.preview@example.com", cP = "__preview";
function gU(e) {
  var n;
  return e ? !!(e.email === pP || (n = e.tags) != null && n.includes(cP)) : !1;
}
const RU = [
  {
    id: "932cbe67-7af1-4f1c-9d38-81bd16f23e02",
    createDateTime: "2023-04-21T04:10:40.955Z",
    createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
    lastChangedDateTime: "2023-04-21T04:10:51.009Z",
    lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
    isActive: !0,
    tags: null,
    schedule: {
      friday: [{ end: "17:00", start: "8:00" }],
      monday: [{ end: "17:00", start: "8:00" }],
      tuesday: [{ end: "17:00", start: "8:00" }],
      version: 1,
      thursday: [{ end: "17:00", start: "8:00" }],
      wednesday: [{ end: "17:00", start: "8:00" }]
    },
    name: "New York",
    facilityNumber: "110",
    street: "459 Broadway",
    city: "New York",
    state: "NY",
    zip: "10013",
    country: "USA",
    timezone: "America/New_York",
    orgId: "fc8a34b6-06f4-406c-853a-942dd8425a31",
    contactName: null,
    phone: null,
    email: null,
    notes: null,
    instructions: null,
    customApptFieldsTemplate: null,
    refNumberValidationVersion: "V2",
    refNumberValidationUrl: null,
    refNumberValidationPasscode: null,
    settings: {
      appointmentStartTimeMinutes: 30,
      customAppointmentStartTimes: [],
      isLoadTypeDurationCarrierViewHidden: !1
    },
    allowCarrierScheduling: !0,
    geolocation: null,
    ccEmails: [],
    amenities: [],
    ppeRequirements: [],
    docks: [
      {
        id: "c7522cbd-f4f3-443c-b02b-f794b7e7bdd9",
        createDateTime: "2023-04-21T14:43:37.538Z",
        createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        lastChangedDateTime: "2023-04-21T21:45:02.494Z",
        lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        isActive: !0,
        tags: null,
        schedule: {
          friday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          monday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          sunday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          tuesday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          version: 1,
          saturday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          thursday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          wednesday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          closedIntervals: [
            { end: "2023-04-26T23:59:59-04:00", start: "2023-04-26T00:00:00-04:00" },
            { end: "2023-06-19T23:59:59-04:00", start: "2023-06-19T00:00:00-04:00" }
          ]
        },
        name: "test",
        warehouseId: "932cbe67-7af1-4f1c-9d38-81bd16f23e02",
        orgId: "fc8a34b6-06f4-406c-853a-942dd8425a31",
        loadTypeIds: ["9ff991a6-769b-4bcc-a873-978523339152"],
        doorNumber: null,
        instructions: null,
        minCarrierLeadTime_hr: null,
        minCarrierLeadTimeForUpdates_hr: null,
        maxCarrierLeadTime_hr: null,
        ccEmails: null,
        allowCarrierScheduling: !0,
        allowOverBooking: !1,
        capacityParentId: null,
        sortOrder: 2,
        settings: null,
        capacityChildren: []
      },
      {
        id: "51bad233-48d5-4a42-a26e-dd3994bca619",
        createDateTime: "2023-04-21T04:11:40.742Z",
        createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        lastChangedDateTime: "2023-04-21T21:43:38.861Z",
        lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        isActive: !0,
        tags: null,
        schedule: {
          friday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          monday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          sunday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          tuesday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          version: 1,
          saturday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          thursday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          wednesday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          closedIntervals: [
            { end: "2023-05-14T23:59:59-04:00", start: "2023-05-14T00:00:00-04:00" }
          ]
        },
        name: "Reefer",
        warehouseId: "932cbe67-7af1-4f1c-9d38-81bd16f23e02",
        orgId: "fc8a34b6-06f4-406c-853a-942dd8425a31",
        loadTypeIds: ["9ff991a6-769b-4bcc-a873-978523339152"],
        doorNumber: "5",
        instructions: null,
        minCarrierLeadTime_hr: null,
        minCarrierLeadTimeForUpdates_hr: null,
        maxCarrierLeadTime_hr: null,
        ccEmails: null,
        allowCarrierScheduling: !0,
        allowOverBooking: !1,
        capacityParentId: "51bad233-48d5-4a42-a26e-dd3994bca619",
        sortOrder: 0,
        settings: null,
        capacityChildren: [
          {
            id: "83e4e525-bd67-42f4-9d89-777b7a3d15ae",
            createDateTime: "2023-04-21T14:42:52.459Z",
            createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
            lastChangedDateTime: "2023-04-21T21:43:38.879Z",
            lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
            isActive: !0,
            tags: null,
            schedule: {
              friday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              monday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              sunday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              tuesday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              version: 1,
              saturday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              thursday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              wednesday: [{ end: "23:59", start: "0:00" }]
            },
            name: `Reefer${Jo}1682088172450`,
            warehouseId: "932cbe67-7af1-4f1c-9d38-81bd16f23e02",
            orgId: "fc8a34b6-06f4-406c-853a-942dd8425a31",
            loadTypeIds: ["9ff991a6-769b-4bcc-a873-978523339152"],
            doorNumber: "5",
            instructions: null,
            minCarrierLeadTime_hr: null,
            minCarrierLeadTimeForUpdates_hr: null,
            maxCarrierLeadTime_hr: null,
            ccEmails: null,
            allowCarrierScheduling: !0,
            allowOverBooking: !1,
            capacityParentId: "51bad233-48d5-4a42-a26e-dd3994bca619",
            sortOrder: 1,
            settings: null
          },
          {
            id: "51bad233-48d5-4a42-a26e-dd3994bca619",
            createDateTime: "2023-04-21T04:11:40.742Z",
            createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
            lastChangedDateTime: "2023-04-21T21:43:38.861Z",
            lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
            isActive: !0,
            tags: null,
            schedule: {
              friday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              monday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              sunday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              tuesday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              version: 1,
              saturday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              thursday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              wednesday: [
                { end: "11:30", start: "0:00" },
                { end: "13:30", start: "12:00" },
                { end: "15:30", start: "14:00" },
                { end: "23:59", start: "16:00" }
              ],
              closedIntervals: [
                { end: "2023-05-14T23:59:59-04:00", start: "2023-05-14T00:00:00-04:00" }
              ]
            },
            name: "Reefer",
            warehouseId: "932cbe67-7af1-4f1c-9d38-81bd16f23e02",
            orgId: "fc8a34b6-06f4-406c-853a-942dd8425a31",
            loadTypeIds: ["9ff991a6-769b-4bcc-a873-978523339152"],
            doorNumber: "5",
            instructions: null,
            minCarrierLeadTime_hr: null,
            minCarrierLeadTimeForUpdates_hr: null,
            maxCarrierLeadTime_hr: null,
            ccEmails: null,
            allowCarrierScheduling: !0,
            allowOverBooking: !1,
            capacityParentId: "51bad233-48d5-4a42-a26e-dd3994bca619",
            sortOrder: 0,
            settings: null
          }
        ]
      },
      {
        id: "83e4e525-bd67-42f4-9d89-777b7a3d15ae",
        createDateTime: "2023-04-21T14:42:52.459Z",
        createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        lastChangedDateTime: "2023-04-21T21:43:38.879Z",
        lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        isActive: !0,
        tags: null,
        schedule: {
          friday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          monday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          sunday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          tuesday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          version: 1,
          saturday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          thursday: [
            { end: "11:30", start: "0:00" },
            { end: "13:30", start: "12:00" },
            { end: "15:30", start: "14:00" },
            { end: "23:59", start: "16:00" }
          ],
          wednesday: [{ end: "23:59", start: "0:00" }]
        },
        name: `Reefer${Jo}1682088172450`,
        warehouseId: "932cbe67-7af1-4f1c-9d38-81bd16f23e02",
        orgId: "fc8a34b6-06f4-406c-853a-942dd8425a31",
        loadTypeIds: ["9ff991a6-769b-4bcc-a873-978523339152"],
        doorNumber: "5",
        instructions: null,
        minCarrierLeadTime_hr: null,
        minCarrierLeadTimeForUpdates_hr: null,
        maxCarrierLeadTime_hr: null,
        ccEmails: null,
        allowCarrierScheduling: !0,
        allowOverBooking: !1,
        capacityParentId: "51bad233-48d5-4a42-a26e-dd3994bca619",
        sortOrder: 1,
        settings: null,
        capacityChildren: []
      }
    ],
    org: {
      id: "fc8a34b6-06f4-406c-853a-942dd8425a31",
      createDateTime: "2023-04-21T04:09:57.641Z",
      createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
      lastChangedDateTime: "2023-04-26T15:37:17.044Z",
      lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
      isActive: !0,
      tags: null,
      name: "Sam's Club",
      isDataWallEnabled: !1,
      settings: {
        referenceNumberIsUnique: !1,
        statusSucceedingArrived: "InProgress",
        referenceNumberIsVisible: !0,
        appointmentCreationStatus: "Requested",
        referenceNumberIsRequired: !1,
        appointmentStartTimeMinutes: 30,
        appointmentStartTimeInterval: "30",
        muteAppointmentNotifications: !1,
        mutedAppointmentNotifications: []
      },
      favoriteCarrierIds: null,
      customTags: null,
      expiresAt: "2023-05-21T05:13:00.371Z"
    }
  },
  {
    id: "80d28081-e8d7-4691-8eb4-db5d7baa4d37",
    createDateTime: "2023-04-26T15:16:57.689Z",
    createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
    lastChangedDateTime: "2023-04-26T15:18:54.752Z",
    lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
    isActive: !0,
    tags: null,
    schedule: {
      friday: [],
      monday: [{ end: "13:00", start: "4:00" }],
      sunday: [{ end: "14:00", start: "3:00" }],
      tuesday: [{ end: "12:00", start: "4:00" }],
      version: 1,
      thursday: [{ end: "10:00", start: "4:00" }],
      wednesday: [{ end: "11:00", start: "3:00" }]
    },
    name: "Schedule Test",
    facilityNumber: null,
    street: "459 Broadway",
    city: "New York",
    state: "NY",
    zip: "10013",
    country: "USA",
    timezone: "America/New_York",
    orgId: "fc8a34b6-06f4-406c-853a-942dd8425a31",
    contactName: null,
    phone: null,
    email: null,
    notes: null,
    instructions: "",
    customApptFieldsTemplate: null,
    refNumberValidationVersion: "V2",
    refNumberValidationUrl: null,
    refNumberValidationPasscode: null,
    settings: {
      appointmentStartTimeMinutes: 30,
      customAppointmentStartTimes: [],
      isLoadTypeDurationCarrierViewHidden: !1
    },
    allowCarrierScheduling: !0,
    geolocation: null,
    ccEmails: ["phaseflipaudio@gmail.com"],
    amenities: ["Lumper services", "Drivers restroom", "Overnight parking", "Free Wi-Fi"],
    ppeRequirements: [
      "Face Mask",
      "Safety Glasses",
      "Hard Hat",
      "Safety Boots",
      "Gloves",
      "High Visibility Vest",
      "Long Pants",
      "Long Sleeves",
      "No Smoking"
    ],
    docks: [
      {
        id: "d47bbcfa-fed7-4068-a814-4fead4cd6227",
        createDateTime: "2023-04-26T15:21:21.407Z",
        createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        lastChangedDateTime: "2023-04-26T15:24:01.263Z",
        lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        isActive: !0,
        tags: null,
        schedule: {
          friday: [{ end: "23:59", start: "0:00" }],
          monday: [{ end: "23:59", start: "0:00" }],
          sunday: [{ end: "23:59", start: "0:00" }],
          tuesday: [{ end: "23:59", start: "0:00" }],
          version: 1,
          saturday: [{ end: "23:59", start: "0:00" }],
          thursday: [{ end: "23:59", start: "0:00" }],
          wednesday: [
            { end: "3:00", start: "0:00" },
            { end: "23:59", start: "4:00" }
          ],
          closedIntervals: []
        },
        name: "Inbound",
        warehouseId: "80d28081-e8d7-4691-8eb4-db5d7baa4d37",
        orgId: "fc8a34b6-06f4-406c-853a-942dd8425a31",
        loadTypeIds: ["b4e12083-45b1-4a1b-9dd4-5fe91a49ba34"],
        doorNumber: null,
        instructions: null,
        minCarrierLeadTime_hr: null,
        minCarrierLeadTimeForUpdates_hr: null,
        maxCarrierLeadTime_hr: 8760,
        ccEmails: null,
        allowCarrierScheduling: !0,
        allowOverBooking: !1,
        capacityParentId: null,
        sortOrder: 0,
        settings: null,
        capacityChildren: []
      },
      {
        id: "6571f58a-1985-4c29-8e3b-276647652322",
        createDateTime: "2023-04-26T15:22:15.752Z",
        createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        lastChangedDateTime: "2023-04-26T15:24:06.122Z",
        lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
        isActive: !0,
        tags: null,
        schedule: {
          friday: [{ end: "23:59", start: "0:00" }],
          monday: [{ end: "23:59", start: "0:00" }],
          sunday: [{ end: "23:59", start: "0:00" }],
          tuesday: [{ end: "23:59", start: "0:00" }],
          version: 1,
          saturday: [{ end: "23:59", start: "0:00" }],
          thursday: [
            { end: "4:00", start: "0:00" },
            { end: "23:59", start: "8:30" }
          ],
          wednesday: [
            { end: "3:00", start: "0:00" },
            { end: "23:59", start: "4:00" }
          ],
          closedIntervals: []
        },
        name: "Outbound",
        warehouseId: "80d28081-e8d7-4691-8eb4-db5d7baa4d37",
        orgId: "fc8a34b6-06f4-406c-853a-942dd8425a31",
        loadTypeIds: ["b4e12083-45b1-4a1b-9dd4-5fe91a49ba34"],
        doorNumber: null,
        instructions: null,
        minCarrierLeadTime_hr: null,
        minCarrierLeadTimeForUpdates_hr: null,
        maxCarrierLeadTime_hr: null,
        ccEmails: null,
        allowCarrierScheduling: !0,
        allowOverBooking: !1,
        capacityParentId: null,
        sortOrder: 1,
        settings: null,
        capacityChildren: []
      }
    ],
    org: {
      id: "fc8a34b6-06f4-406c-853a-942dd8425a31",
      createDateTime: "2023-04-21T04:09:57.641Z",
      createdBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
      lastChangedDateTime: "2023-04-26T15:37:17.044Z",
      lastChangedBy: "504037bf-26b1-4f61-9907-bc2a6cc16ba2",
      isActive: !0,
      tags: null,
      name: "Sam's Club",
      isDataWallEnabled: !1,
      settings: {
        referenceNumberIsUnique: !1,
        statusSucceedingArrived: "InProgress",
        referenceNumberIsVisible: !0,
        appointmentCreationStatus: "Requested",
        referenceNumberIsRequired: !1,
        appointmentStartTimeMinutes: 30,
        appointmentStartTimeInterval: "30",
        muteAppointmentNotifications: !1,
        mutedAppointmentNotifications: []
      },
      favoriteCarrierIds: null,
      customTags: null,
      expiresAt: "2023-05-21T05:13:00.371Z"
    }
  }
], $U = [
  {
    name: "strText R",
    type: "str",
    label: "Text R",
    value: "Mon Text",
    dropDownValues: []
  },
  {
    name: "strText",
    type: "str",
    label: "Text",
    value: "",
    dropDownValues: []
  },
  {
    name: "dateDate R",
    type: "date",
    label: "Date R",
    value: "2022-08-11",
    dropDownValues: []
  },
  {
    name: "dateDate",
    type: "date",
    label: "Date",
    value: "2022-08-25",
    dropDownValues: []
  }
];
var zP = /* @__PURE__ */ ((e) => (e.Live = "Live", e.Drop = "Drop", e.PickUp = "PickUp", e.DropHook = "DropHook", e.Unknown = "Unknown", e))(zP || {}), Ra = /* @__PURE__ */ ((e) => (e.Arrived = "Arrived", e.Docked = "Docked", e.Parked = "Parked", e.Unassigned = "Unassigned", e.Dropped = "Dropped", e.Hooked = "Hooked", e.AppointmentLinked = "Appointment Linked", e.AppointmentUnlinked = "Appointment Unlinked", e.StatusUpdated = "Status Updated", e))(Ra || {});
function LU(e) {
  return [
    "Drop",
    "Live",
    "DropHook"
    /* DropHook */
  ].includes(e);
}
function OP(e) {
  return (e.isPlanned && !v9(e)) ?? !1;
}
function uP(e) {
  return !e.isPlanned && !e.appointmentId && !D9(e);
}
function AP(e) {
  var n;
  return !!(!e.isPlanned && (e.appointmentId || (n = e.assetVisitEvents) != null && n.some(
    (a) => a.eventType === a3.Canceled
  )));
}
function v9(e) {
  var n;
  return !![
    i0.InProgress,
    i0.Completed,
    i0.Cancelled,
    i0.NoShow
  ].includes((n = e.appointment) == null ? void 0 : n.status);
}
function lP(e) {
  var n;
  return (n = e.assetVisitEvents) == null ? void 0 : n.map((a) => a.eventType).includes(a3.Departed);
}
function _U(e) {
  var n;
  return (n = e.assetVisitEvents) == null ? void 0 : n.map((a) => a.eventType).includes(a3.Docked);
}
function D9(e) {
  var n;
  return (n = e.assetVisitEvents) == null ? void 0 : n.map((a) => a.eventType).includes(a3.Canceled);
}
function fP(e) {
  var n;
  return ((n = e.spotAssignments) == null ? void 0 : n.length) > 0;
}
function NU(e) {
  return e.filter(OP);
}
function vU(e) {
  return e.filter(uP);
}
function DU(e) {
  return e.filter(
    (n) => AP(n) || v9(n)
  );
}
function TU(e) {
  return (e == null ? void 0 : e.filter(
    (n) => !D9(n) && !lP(n) && !fP(n)
  )) || [];
}
var a3 = /* @__PURE__ */ ((e) => (e.NotArrived = "NotArrived", e.Arrived = "Arrived", e.Docked = "Docked", e.Departed = "Departed", e.Canceled = "Canceled", e.Attached = "Attached", e.Detached = "Detached", e.AppointmentLinked = "Appointment Linked", e.AppointmentUnlinked = "Appointment Unlinked", e))(a3 || {});
const SU = [
  "NotArrived",
  "Arrived",
  "Docked",
  "Departed",
  "Canceled"
  /* Canceled */
];
function BU(e) {
  if (e === "Attached")
    return Ra.Hooked;
  if (e === "Detached")
    return Ra.Dropped;
}
var mP = /* @__PURE__ */ ((e) => (e.BACKSPACE = "Backspace", e.TAB = "Tab", e.ENTER = "Enter", e.SHIFT = "Shift", e.CTRL = "Control", e.ALT = "Alt", e.PAUSE_BREAK = "Pause", e.CAPS_LOCK = "CapsLock", e.ESCAPE = "Escape", e.SPACE = " ", e.PAGE_UP = "PageUp", e.PAGE_DOWN = "PageDown", e.END = "End", e.HOME = "Home", e.LEFT_ARROW = "ArrowLeft", e.UP_ARROW = "ArrowUp", e.RIGHT_ARROW = "ArrowRight", e.DOWN_ARROW = "ArrowDown", e.INSERT = "Insert", e.DELETE = "Delete", e.KEY_0 = "0", e.KEY_1 = "1", e.KEY_2 = "2", e.KEY_3 = "3", e.KEY_4 = "4", e.KEY_5 = "5", e.KEY_6 = "6", e.KEY_7 = "7", e.KEY_8 = "8", e.KEY_9 = "9", e.KEY_A = "a", e.KEY_B = "b", e.KEY_C = "c", e.KEY_D = "d", e.KEY_E = "e", e.KEY_F = "f", e.KEY_G = "g", e.KEY_H = "h", e.KEY_I = "i", e.KEY_J = "j", e.KEY_K = "k", e.KEY_L = "l", e.KEY_M = "m", e.KEY_N = "n", e.KEY_O = "o", e.KEY_P = "p", e.KEY_Q = "q", e.KEY_R = "r", e.KEY_S = "s", e.KEY_T = "t", e.KEY_U = "u", e.KEY_V = "v", e.KEY_W = "w", e.KEY_X = "x", e.KEY_Y = "y", e.KEY_Z = "z", e.LEFT_META = "Meta", e.RIGHT_META = "Meta", e.SELECT = "Select", e.NUMPAD_0 = "0", e.NUMPAD_1 = "1", e.NUMPAD_2 = "2", e.NUMPAD_3 = "3", e.NUMPAD_4 = "4", e.NUMPAD_5 = "5", e.NUMPAD_6 = "6", e.NUMPAD_7 = "7", e.NUMPAD_8 = "8", e.NUMPAD_9 = "9", e.MULTIPLY = "*", e.ADD = "+", e.SUBTRACT = "-", e.DECIMAL_POINT = ".", e.DIVIDE = "/", e.F1 = "F1", e.F2 = "F2", e.F3 = "F3", e.F4 = "F4", e.F5 = "F5", e.F6 = "F6", e.F7 = "F7", e.F8 = "F8", e.F9 = "F9", e.F10 = "F10", e.F11 = "F11", e.F12 = "F12", e.NUM_LOCK = "NumLock", e.SCROLL_LOCK = "ScrollLock", e.COLON = ":", e.SEMI_COLON = ";", e.EQUAL_SIGN = "=", e.COMMA = ",", e.DASH = "-", e.PERIOD = ".", e.FORWARD_SLASH = "/", e.GRAVE_ACCENT = "`", e.OPEN_BRACKET = "[", e.BACK_SLASH = "\\", e.CLOSE_BRACKET = "]", e.SINGLE_QUOTE = "'", e))(mP || {}), T9 = { exports: {} };
(function(e) {
  (function(n) {
    if (typeof a != "function") {
      var a = function($) {
        return $;
      };
      a.nonNative = !0;
    }
    const t = a("plaintext"), r = a("html"), M = a("comment"), b = /<(\w*)>/g, d = /<\/?([^\s\/>]+)/;
    function c($, v, E) {
      $ = $ || "", v = v || [], E = E || "";
      let t0 = A(v, E);
      return m($, t0);
    }
    function O($, v) {
      $ = $ || [], v = v || "";
      let E = A($, v);
      return function(K) {
        return m(K || "", E);
      };
    }
    c.init_streaming_mode = O;
    function A($, v) {
      return $ = q($), {
        allowable_tags: $,
        tag_replacement: v,
        state: t,
        tag_buffer: "",
        depth: 0,
        in_quote_char: ""
      };
    }
    function m($, v) {
      if (typeof $ != "string")
        throw new TypeError("'html' parameter must be a string");
      let E = v.allowable_tags, t0 = v.tag_replacement, K = v.state, C = v.tag_buffer, s0 = v.depth, J = v.in_quote_char, I0 = "";
      for (let g0 = 0, S0 = $.length; g0 < S0; g0++) {
        let u0 = $[g0];
        if (K === t)
          switch (u0) {
            case "<":
              K = r, C += u0;
              break;
            default:
              I0 += u0;
              break;
          }
        else if (K === r)
          switch (u0) {
            case "<":
              if (J)
                break;
              s0++;
              break;
            case ">":
              if (J)
                break;
              if (s0) {
                s0--;
                break;
              }
              J = "", K = t, C += ">", E.has(y(C)) ? I0 += C : I0 += t0, C = "";
              break;
            case '"':
            case "'":
              u0 === J ? J = "" : J = J || u0, C += u0;
              break;
            case "-":
              C === "<!-" && (K = M), C += u0;
              break;
            case " ":
            case `
`:
              if (C === "<") {
                K = t, I0 += "< ", C = "";
                break;
              }
              C += u0;
              break;
            default:
              C += u0;
              break;
          }
        else if (K === M)
          switch (u0) {
            case ">":
              C.slice(-2) == "--" && (K = t), C = "";
              break;
            default:
              C += u0;
              break;
          }
      }
      return v.state = K, v.tag_buffer = C, v.depth = s0, v.in_quote_char = J, I0;
    }
    function q($) {
      let v = /* @__PURE__ */ new Set();
      if (typeof $ == "string") {
        let E;
        for (; E = b.exec($); )
          v.add(E[1]);
      } else !a.nonNative && typeof $[a.iterator] == "function" ? v = new Set($) : typeof $.forEach == "function" && $.forEach(v.add, v);
      return v;
    }
    function y($) {
      let v = d.exec($);
      return v ? v[1].toLowerCase() : null;
    }
    e.exports ? e.exports = c : n.striptags = c;
  })(Ln);
})(T9);
var qP = T9.exports;
const hP = /* @__PURE__ */ I2(qP);
var k, j4, S9, B9, w9, C9, E9, X9, P9, k9, I9, x9, f0, F9, Ae, qt, H9, U9;
class wU {
  constructor(n, a = {}, t) {
    Hp(this, k);
    this.appointments = n, this.settings = a, this.exportableFields = t, eb(a) || (this.settings = {});
  }
  stripNotesField(n) {
    return !n || !R1(n) ? "" : (n = n.replace(/<br\s*\/?>/giu, `
`), n = n.replace(/&nbsp;/gu, " "), n = n.replace(/<\/p>/giu, `
`), hP(n.trim()));
  }
  convertAppointmentsToExcelData() {
    const n = String(
      this.settings.referenceNumberDisplayName ?? ye.Org.referenceNumberDisplayName.defaultValue
    ), a = String(this.settings.handlingUnitsLabel ?? "Handling Units");
    return Tb(this.appointments || [], "start").map((t) => {
      const r = cw(z1.Warehouse, {
        ...t.dock.warehouse,
        org: { settings: this.settings }
      });
      return G(this, k, S9).call(this, t, n, a, r);
    });
  }
}
k = new WeakSet(), j4 = function(n, a, t) {
  let r, M, b;
  const d = !!(typeof a.enableMilitaryTime == "boolean" ? a.enableMilitaryTime : ye.Org.enableMilitaryTime.defaultValue), c = n.statusTimeline[i0.Arrived] ? G(this, k, Ae).call(this, n.statusTimeline[i0.Arrived], {
    zone: t
  }).startOf("minute") : null;
  return c && n.statusTimeline[i0.Completed] && (r = G(this, k, Ae).call(this, n.statusTimeline[i0.Completed], {
    zone: t
  }).startOf("minute"), M = r.diff(c, "minutes").as("minutes")), c && (b = G(this, k, qt).call(this, n.start, c.toISO(), t, "minutes")), { completedT: r, arrivedT: c, onTimeMinutes: b, actualDuration: M, militaryTimeEnabled: d };
}, S9 = function(n, a, t, r) {
  var c, O, A;
  const M = {}, b = ((O = (c = n.dock) == null ? void 0 : c.warehouse) == null ? void 0 : O.timezone) || "UTC", { militaryTimeEnabled: d } = G(this, k, j4).call(this, n, r, b);
  return G(this, k, P9).call(this, n, d, b, M), G(this, k, I9).call(this, n, r, b, M), G(this, k, B9).call(this, n, M), this.exportableFields.includes("REFERENCE_NUMBER") && (M[a] = n.refNumber), this.exportableFields.includes("HANDLING_UNITS") && (M[t] = n.units), G(this, k, k9).call(this, n, b, d, M), G(this, k, X9).call(this, n, M), G(this, k, E9).call(this, n, M), G(this, k, w9).call(this, n, M, r), this.exportableFields.includes("CUSTOM_FIELDS") && G(this, k, U9).call(this, n, M), (A = n.customFormData) != null && A.length && G(this, k, H9).call(this, n, M), M;
}, B9 = function(n, a) {
  var t, r, M, b, d;
  G(this, k, f0).call(this, "WAREHOUSE", (r = (t = n.dock) == null ? void 0 : t.warehouse) == null ? void 0 : r.name, a), G(this, k, f0).call(this, "DOCK", (M = n.dock) == null ? void 0 : M.name, a), G(this, k, f0).call(this, "LOAD_TYPE", (b = n.loadType) == null ? void 0 : b.name, a), G(this, k, f0).call(this, "LOAD_TYPE_DIRECTION", (d = n.loadType) == null ? void 0 : d.direction, a);
}, w9 = function(n, a, t) {
  t.overrideExternalAppointmentValidation && G(this, k, C9).call(this, n, a);
}, C9 = function(n, a) {
  var M, b;
  let t = "N/A", r = "N/A";
  typeof ((M = n.metadata) == null ? void 0 : M[mt.externalValidationFailed]) < "u" && (t = n.metadata[mt.externalValidationFailed] === !0 ? "Failed" : "Passed"), (b = n.metadata) != null && b[mt.externalValidationErrorMessage] && (r = n.metadata[mt.externalValidationErrorMessage]), G(this, k, f0).call(this, "EXTERNAL_VALIDATION_STATUS", t, a), G(this, k, f0).call(this, "EXTERNAL_VALIDATION_ERROR_MESSAGE", r, a);
}, E9 = function(n, a) {
  G(this, k, f0).call(this, "NOTES", this.stripNotesField(n.notes), a), G(this, k, f0).call(this, "TAGS", n.tags ? n.tags.map((t) => `#${t}`).join(", ") : null, a);
}, X9 = function(n, a) {
  var t, r, M, b;
  G(this, k, f0).call(this, "CARRIER_COMPANY", (r = (t = n.user) == null ? void 0 : t.company) == null ? void 0 : r.name, a), G(this, k, f0).call(this, "CONTACT_NAME", n.user ? `${n.user.firstName} ${n.user.lastName}` : null, a), G(this, k, f0).call(this, "CONTACT_EMAIL", (M = n.user) == null ? void 0 : M.email, a), G(this, k, f0).call(this, "CONTACT_PHONE", (b = n.user) == null ? void 0 : b.phone, a);
}, P9 = function(n, a, t, r) {
  G(this, k, f0).call(this, "CONFIRMATION_NUMBER", n.confirmationNumber, r), G(this, k, f0).call(this, "APPOINTMENT_ID", n.id, r), G(this, k, f0).call(this, "APPOINTMENT_DATE", G(this, k, Ae).call(this, n.start, { zone: t }).toFormat(
    G0.MonthDayYearSlashed
  ), r), G(this, k, f0).call(this, "APPOINTMENT_TIME", Ve(
    n.start,
    t,
    G0.Extended12HrTimeAMPM,
    a,
    G0.Extended24HrTime
  ), r), G(this, k, f0).call(this, "APPOINTMENT_TIMEZONE", Ve(
    n.start,
    t,
    G0.AbbreviatedNamedOffset,
    a,
    G0.AbbreviatedNamedOffset
  ), r), G(this, k, f0).call(this, "APPOINTMENT_TYPE", n.type, r);
}, k9 = function(n, a, t, r) {
  var M, b;
  G(this, k, f0).call(this, "RESCHEDULE_COUNT", yB(n).toFixed(0), r), (M = n.createdByUser) != null && M.id && (G(this, k, f0).call(this, "CREATED_BY", `${n.createdByUser.firstName} ${n.createdByUser.lastName}`, r), G(this, k, f0).call(this, "CREATOR_TYPE", G(this, k, F9).call(this, n.createdByUser), r)), G(this, k, f0).call(this, "CREATION_DATE", G(this, k, Ae).call(this, n.createDateTime, { zone: a }).toFormat(
    G0.MonthDayYearSlashed
  ), r), (b = n.lastChangedByUser) != null && b.id && G(this, k, f0).call(this, "LAST_UPDATED_BY", `${n.lastChangedByUser.firstName} ${n.lastChangedByUser.lastName}`, r), G(this, k, f0).call(this, "LAST_UPDATE_DATE", G(this, k, Ae).call(this, n.lastChangedDateTime, { zone: a }).toFormat(
    G0.MonthDayYearSlashed
  ), r), G(this, k, f0).call(this, "LAST_UPDATE_TIME", Ve(
    n.lastChangedDateTime,
    a,
    G0.Extended12HrTimeAMPM,
    t,
    G0.Extended24HrTime
  ), r);
}, I9 = function(n, a, t, r) {
  const { militaryTimeEnabled: M, onTimeMinutes: b, actualDuration: d, completedT: c, arrivedT: O } = G(this, k, j4).call(this, n, a, t);
  G(this, k, f0).call(this, "SCHEDULED_DURATION", G(this, k, qt).call(this, n.start, n.end, t, "minutes").toFixed(0), r), G(this, k, f0).call(this, "STATUS", n.status, r), G(this, k, f0).call(this, "ARRIVAL_DATE", O ? O.toFormat(G0.MonthDayYearSlashed) : "", r), G(this, k, f0).call(this, "ARRIVAL_TIME", O ? Ve(
    O.toISO(),
    t,
    G0.Extended12HrTimeAMPM,
    M,
    G0.Extended24HrTime
  ) : "", r), G(this, k, f0).call(this, "DEPARTURE_DATE", c ? c.toFormat(G0.MonthDayYearSlashed) : "", r), G(this, k, f0).call(this, "DEPARTURE_TIME", c ? Ve(
    c.toISO(),
    t,
    G0.Extended12HrTimeAMPM,
    M,
    G0.Extended24HrTime
  ) : "", r), G(this, k, f0).call(this, "DWELL_TIME", (d == null ? void 0 : d.toFixed(0)) || "", r), G(this, k, f0).call(this, "ON_TIME", (b == null ? void 0 : b.toFixed(0)) || "", r), G(this, k, x9).call(this, n, a, t, M, r);
}, x9 = function(n, a, t, r, M) {
  let b, d, c;
  a.statusSucceedingArrived === i0.InProgress && (b = n.statusTimeline[i0.Arrived], d = n.statusTimeline[i0.InProgress], c = n.statusTimeline[i0.Completed]), G(this, k, f0).call(this, "IN_PROGRESS_DATE", d ? G(this, k, Ae).call(this, d).toFormat(
    G0.MonthDayYearSlashed
  ) : "", M), G(this, k, f0).call(this, "IN_PROGRESS_TIME", d ? Ve(
    d,
    t,
    G0.Extended12HrTimeAMPM,
    r,
    G0.Extended24HrTime
  ) : "", M);
  let O = "";
  b && d && (O = G(this, k, qt).call(this, b, d, t, "minutes").toFixed()), G(this, k, f0).call(this, "WAIT_TIME", O, M);
  let A = "";
  c && d && (A = G(this, k, qt).call(this, d, c, t, "minutes").toFixed()), G(this, k, f0).call(this, "PROCESSING_TIME", A, M);
}, f0 = function(n, a, t) {
  this.exportableFields.includes(n) && (t[Bw[n]] = a);
}, F9 = function(n) {
  return n ? te(n) ? "Carrier" : "Warehouse" : "Unknown user";
}, Ae = function(n, a) {
  return Pn(n) && (n = n.toISOString()), P.fromISO(n, a);
}, qt = function(n, a, t, r = "milliseconds") {
  const M = G(this, k, Ae).call(this, n, { zone: t }).startOf("minute"), d = G(this, k, Ae).call(this, a, { zone: t }).startOf("minute").diff(M, r).toObject();
  return d && d[r] ? d[r] : 0;
}, H9 = function(n, a) {
  const t = this.exportableFields.filter((r) => Object.keys(x4).includes(r)).map((r) => x4[r]);
  t.length && n.customFormData.filter((r) => t.includes(r.feature)).forEach((r) => {
    if (r.type === "multidoc")
      return;
    let M = r.value;
    r.type === "doc" && r.value && (M = {
      t: "s",
      v: Zo(r.value),
      l: {
        Target: r.value,
        Tooltip: "Download File"
      }
      // Target is the URL, optionally specify Tooltip
    }), r.type === "bool" && (M = r.value === "true" ? "Yes" : "No"), a[r.label] = M;
  });
}, U9 = function(n, a) {
  if (Array.isArray(n.customFields)) {
    const t = {};
    n.customFields.forEach((r) => {
      let M = r.value;
      wn(r.value) && (M = r.value.join(", ")), r.type === "int" && r.value && (M = parseInt(r.value, 10)), r.type === "doc" && r.value && (M = {
        t: "s",
        v: Zo(r.value),
        l: {
          Target: r.value,
          Tooltip: "Download File"
        }
        // Target is the URL, optionally specify Tooltip
      }), a[r.label] ? (t[r.label] = (t[r.label] || 1) + 1, a[`${r.label} (${t[r.label]})`] = M) : (t[r.label] = 1, a[r.label] = M);
    });
  }
};
var yP = /* @__PURE__ */ ((e) => (e.DELIVERED = "delivered", e.FAILED = "failed", e.SENT = "sent", e.RECEIVED = "received", e))(yP || {}), WP = /* @__PURE__ */ ((e) => (e.JPG = "image/jpeg", e.PNG = "image/png", e.GIF = "image/gif", e.HEIC = "image/heic", e.PDF = "application/pdf", e.DOC = "application/msword", e.DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document", e.CSV = "text/csv", e.TSV = "text/tab-separated-values", e))(WP || {}), gP = /* @__PURE__ */ ((e) => (e.DRIVER = "driver", e.WAREHOUSE = "warehouse", e.SYSTEM = "system", e))(gP || {});
function CU(e) {
  const n = new Date(e.expiresAt).getTime();
  return (/* @__PURE__ */ new Date()).getTime() > n;
}
var j9 = /* @__PURE__ */ ((e) => (e.START = "start", e.RECIBIR = "recibir", e.RECEBER = "receber", e))(j9 || {}), G9 = /* @__PURE__ */ ((e) => (e.STOP = "stop", e.ALTO = "alto", e.PARAR = "parar", e))(G9 || {});
function EU(e) {
  return Object.values(j9).includes(e == null ? void 0 : e.toLowerCase());
}
function XU(e) {
  return Object.values(G9).includes(
    e == null ? void 0 : e.toLowerCase()
  );
}
const PU = 14, kU = {
  ERROR: {
    DEFAULT: () => "Automated Response: An error occurred while processing your message. Please try again later.",
    INVALID_FILE_TYPE: (e) => `Automated Response: Sorry, your message was not delivered. ${e ? `The file type ${e} is not supported.` : "This file type is not supported."}`,
    THREAD_NOT_FOUND: (e) => `Automated Response: Sorry, your message was not delivered. There are no active conversations with ${e}.`,
    THREAD_CLOSED: (e) => `Automated Response: Sorry, your message was not delivered. Conversation with ${e} has been closed.`,
    THREAD_EXPIRED: (e) => `Automated Response: Sorry, your message was not delivered. Conversation with ${e} has expired.`
  },
  EVENT: {
    DRIVER_SUBSCRIBED: () => "The driver has opted to start receiving messages",
    DRIVER_UNSUBSCRIBED: () => "The driver has opted to stop receiving messages",
    PHONE_CHANGED: (e) => `Driver's phone changed to ${UO(e)}`,
    THREAD_OPEN: () => "Chat resumed by the warehouse",
    THREAD_CLOSED: () => "Chat ended by the warehouse",
    THREAD_CLOSED_BY_ANOTHER_CHECKIN: (e) => `Chat at ${e} ended due to another check-in`
  },
  INFO: {
    DRIVER_GREETING: (e, n) => {
      switch (n) {
        case "BRA":
          return `Obrigado por seu check-in em ${e}. Instruções serão enviadas para este número. Responda PARAR caso não queira receber mais mensagens.`;
        case "MEX":
          return `Gracias por registrarte en ${e}. Las instrucciones serán enviadas a este número. Responde ALTO si no deseas recibir más mensajes.`;
        default:
          return `Thanks for checking in at ${e}. Instructions will follow to this phone number. Reply STOP to unsubscribe.`;
      }
    }
  }
};
var RP = /* @__PURE__ */ ((e) => (e.ELASTIC_SEARCH_COMMIT_DATASTORE = "elasticsearch-commit-datastore", e))(RP || {}), $P = /* @__PURE__ */ ((e) => (e.CREATED = "created", e.STARTED = "started", e.COMPLETED = "completed", e.CANCELLED = "cancelled", e.FAILED = "failed", e))($P || {}), LP = /* @__PURE__ */ ((e) => (e.CRON = "cron", e.TIMEOUT = "timeout", e.INTERVAL = "interval", e))(LP || {});
const IU = Object.freeze([
  "created"
  /* CREATED */
]);
function xU(e) {
  return e !== null;
}
function FU(e) {
  return e;
}
function HU(e = !0) {
  const n = m2.weekdays("short");
  return (e ? [n[n.length - 1], ...n.slice(0, -1)] : n).map((t) => t);
}
function UU(e = !0) {
  const n = m2.weekdays();
  return (e ? [n[n.length - 1], ...n.slice(0, -1)] : n).map((t) => t);
}
function jU(e) {
  const n = m2.weekdays("short"), a = m2.weekdays("long"), t = n.reduce((r, M, b) => (r[M] = a[b], r), {});
  if (!t[e])
    throw new Error("Invalid weekday");
  return t[e];
}
function GU(e) {
  const n = m2.weekdays("long"), a = m2.weekdays("long", { locale: "en" }), t = n.reduce((r, M, b) => (r[M] = a[b], r), {});
  return e.map((r) => t[r] || r);
}
function VU(e) {
  return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][e];
}
var _P = /* @__PURE__ */ ((e) => (e.GRID = "grid", e.LIST = "list", e.TV = "tv", e))(_P || {}), NP = /* @__PURE__ */ ((e) => (e.BOARD = "board", e.LIST = "list", e))(NP || {}), vP = /* @__PURE__ */ ((e) => (e.PARKING = "parking", e.DOCKING = "docking", e))(vP || {}), DP = /* @__PURE__ */ ((e) => (e.OPEN = "open", e.CLOSED = "closed", e.ASSIGNED = "assigned", e.RESERVED = "reserved", e.UNKNOWN = "unknown", e))(DP || {}), TP = /* @__PURE__ */ ((e) => (e.ASSIGNMENT = "assignment", e.RELEASE = "release", e.RESERVE = "reserve", e.RELEASE_RESERVE = "release_reserve", e.CLOSE = "close", e.OPEN = "open", e.OTHER = "other", e))(TP || {}), SP = ((e) => (e[e.YardTask = z1.YardTask] = "YardTask", e))(SP || {}), BP = ((e) => (e.All = "All", e[e.AssetVisit = z1.AssetVisit] = "AssetVisit", e[e.AssetContainer = z1.AssetContainer] = "AssetContainer", e))(BP || {});
function YU(e) {
  const n = (e == null ? void 0 : e.spotReserves) || [], a = (e == null ? void 0 : e.spotAssignments) || [], t = n.some((r) => r.isActive);
  return e.isActive === !1 && t ? "reserved" : e.isActive === !1 ? "closed" : e.isActive === !0 && !a.length ? "open" : e.isActive === !0 && a.length ? "assigned" : "unknown";
}
function JU(e) {
  var n;
  return ((n = e.spotAssignments) == null ? void 0 : n.some((a) => !!a.assetVisitId)) ?? !1;
}
function KU(e) {
  var n;
  return ((n = e.spotAssignments) == null ? void 0 : n.every((a) => !!a.assetVisitId)) ?? !1;
}
function ZU(e) {
  var n;
  return ((n = e.spotAssignments) == null ? void 0 : n.some((a) => !!a.assetContainerId)) ?? !1;
}
function QU(e) {
  var n;
  return ((n = e.spotAssignments) == null ? void 0 : n.every((a) => !!a.assetContainerId)) ?? !1;
}
function ej(e) {
  const n = (t) => {
    const r = t.match(/\d+/u);
    return r ? parseInt(r[0], 10) : 1 / 0;
  }, a = (t) => {
    const r = t.match(/[a-zA-Z]+/u);
    return r ? r[0] : "";
  };
  Array.isArray(e) && e.every((t) => typeof t == "object" && t !== null && "code" in t) && e.sort((t, r) => {
    const M = a(t.code), b = a(r.code);
    return M === b ? n(t.code) - n(r.code) : M.localeCompare(b);
  });
}
const nj = 5;
function aj(e, n) {
  if (e === "assignment")
    return n === "docking" ? Ra.Docked : Ra.Parked;
  if (e === "release")
    return Ra.Unassigned;
}
var wP = /* @__PURE__ */ ((e) => (e.INDEX = "index", e.UPDATE = "update", e.DELETE = "delete", e))(wP || {}), CP = /* @__PURE__ */ ((e) => (e.Inbound = "Inbound", e.Outbound = "Outbound", e))(CP || {}), EP = /* @__PURE__ */ ((e) => (e.Diesel = "Diesel", e.Electric = "Electric", e.FuelCell = "FuelCell", e.Gasoline = "Gasoline", e.NaturalGas = "NaturalGas", e.Propane = "Propane", e.Unavailable = "Unavailable", e))(EP || {}), XP = /* @__PURE__ */ ((e) => (e.Three = "<2b", e.Seven = "2b-7", e.Eight = "8", e))(XP || {}), Do = /* @__PURE__ */ ((e) => (e.Container = "Container", e.ContainerReefer = "ContainerReefer", e.DryVan = "DryVan", e.DryVanReefer = "DryVanReefer", e.Flatbed = "Flatbed", e.Chassis = "Chassis", e))(Do || {}), PP = /* @__PURE__ */ ((e) => (e.Trailer = "Trailer", e.Container = "Container", e.Oversized = "Oversized", e.Chassis = "Chassis", e.Reefer = "Reefer", e.Other = "Other", e))(PP || {}), kP = /* @__PURE__ */ ((e) => (e.Full = "Full", e.Empty = "Empty", e.PartiallyLoaded = "Partially Loaded", e))(kP || {}), IP = /* @__PURE__ */ ((e) => (e.Arrived = "Arrived", e.Docked = "Docked", e.Parked = "Parked", e.Unassigned = "Unassigned", e.Dropped = "Dropped", e.Hooked = "Hooked", e.DropAppointmentLinked = "Drop Appointment Linked", e.DropAppointmentUnlinked = "Drop Appointment Unlinked", e.PickupAppointmentUnlinked = "Pickup Appointment Unlinked", e.PickupAppointmentLinked = "Pickup Appointment Linked", e.StatusUpdated = "Status Updated", e))(IP || {});
function tj(e) {
  if (Array.isArray(e) && e.length > 0) {
    const n = e == null ? void 0 : e.reduce((a, t) => a.createDateTime > t.createDateTime ? a : t);
    return (n == null ? void 0 : n.eventType) || null;
  }
  return null;
}
function oj(e) {
  switch (e) {
    case Do.Container:
      return "Container";
    case Do.ContainerReefer:
      return "Container";
    case Do.Chassis:
      return "Chassis";
    default:
      return "Trailer";
  }
}
var xP = /* @__PURE__ */ ((e) => (e.Arrived = "Arrived", e.Loading = "Loading", e.LoadingComplete = "Loading Complete", e.Unloading = "Unloading", e.UnloadingComplete = "Unloading Complete", e.ReadyForPickup = "Ready for Pickup", e.Departed = "Departed", e.Inoperable = "Inoperable", e))(xP || {}), FP = /* @__PURE__ */ ((e) => (e.Appointment = "Appointment", e.Units = "Units", e))(FP || {}), HP = ((e) => (e[e.LoadType = z1.LoadType] = "LoadType", e[e.Dock = z1.Dock] = "Dock", e[e.Warehouse = z1.Warehouse] = "Warehouse", e[e.LoadTypeGroup = z1.LoadTypeGroup] = "LoadTypeGroup", e))(HP || {});
const UP = 7, jP = 0;
function rj(e) {
  return e === UP ? jP : e;
}
const uo = /* @__PURE__ */ new Map();
async function ij(e, n) {
  if (typeof e != "string" || e.trim() === "")
    throw new Error("Key must be a non-empty string");
  if (typeof n != "function")
    throw new Error("requestFn must be a function");
  if (uo.has(e))
    return uo.get(e);
  const a = n().finally(() => {
    uo.delete(e);
  });
  return uo.set(e, a), a;
}
var GP = /* @__PURE__ */ ((e) => (e.MOVE = "move", e.CHECK = "check", e))(GP || {}), VP = /* @__PURE__ */ ((e) => (e.CREATED = "created", e.IN_PROGRESS = "in-progress", e.COMPLETED = "completed", e.CANCELLED = "cancelled", e))(VP || {}), YP = /* @__PURE__ */ ((e) => (e.CREATED = "created", e.ASSIGNED = "assigned", e.UNASSIGNED = "unassigned", e.IN_PROGRESS = "in-progress", e.COMPLETED = "completed", e.CANCELLED = "cancelled", e.FLAGGED = "flagged", e.ISSUE = "issue", e))(YP || {});
const Mj = Object.freeze([
  z1.AssetContainer,
  z1.Spot,
  z1.SpotArea
]);
var Bn = ((e) => (e[e.AssetContainer = z1.AssetContainer] = "AssetContainer", e[e.Spot = z1.Spot] = "Spot", e[e.SpotArea = z1.SpotArea] = "SpotArea", e))(Bn || {}), JP = /* @__PURE__ */ ((e) => (e.IDENTIFICATION_CHECK = "identification-check", e.INSPECTION = "inspection", e.LOCATION_CHECK = "location-check", e.STATUS_CHECK = "status-check", e.CONDITION_ASSESSMENT = "condition-assessment", e.INVENTORY_CHECK = "inventory-check", e.MOVEMENT_CHECK = "movement-check", e))(JP || {});
const V9 = [
  "identification-check",
  "inspection",
  "location-check"
  /* LOCATION_CHECK */
], Y9 = [
  "inspection",
  "status-check"
  /* STATUS_CHECK */
], J9 = [
  "condition-assessment",
  "inventory-check",
  "movement-check"
  /* MOVEMENT_CHECK */
];
function KP(e) {
  return V9.includes(e);
}
function ZP(e) {
  return Y9.includes(e);
}
function QP(e) {
  return J9.includes(e);
}
function bj(e) {
  switch (e) {
    case Bn.AssetContainer:
      return [...V9];
    case Bn.Spot:
      return [...Y9];
    case Bn.SpotArea:
      return [...J9];
    default:
      return [];
  }
}
function sj(e, n) {
  switch (n) {
    case Bn.AssetContainer:
      return KP(e);
    case Bn.Spot:
      return ZP(e);
    case Bn.SpotArea:
      return QP(e);
    default:
      return !1;
  }
}
function dj(e) {
  switch (e) {
    case "identification-check":
      return "yard.drawers.createTaskDrawer.labels.identificationCheck";
    case "inspection":
      return "yard.drawers.createTaskDrawer.labels.inspection";
    case "location-check":
      return "yard.drawers.createTaskDrawer.labels.locationCheck";
    case "status-check":
      return "yard.drawers.createTaskDrawer.labels.statusCheck";
    case "condition-assessment":
      return "yard.drawers.createTaskDrawer.labels.conditionAssessment";
    case "inventory-check":
      return "yard.drawers.createTaskDrawer.labels.inventoryCheck";
    case "movement-check":
      return "yard.drawers.createTaskDrawer.labels.movementCheck";
    default:
      return null;
  }
}
var ek = /* @__PURE__ */ ((e) => (e.FLAGGED = "flagged", e.URGENT = "urgent", e.ISSUE = "issue", e))(ek || {}), nk = /* @__PURE__ */ ((e) => (e.REQUEST = "REQUEST", e.PUBLISH = "PUBLISH", e))(nk || {});
function pj(e) {
  const {
    title: n,
    description: a,
    location: t,
    start: r,
    end: M,
    uid: b,
    company: d,
    product: c,
    organizer: O,
    attendees: A = [],
    method: m = "REQUEST",
    language: q = "EN",
    version: y = "2.0",
    transparent: $ = !1
  } = e, v = `-//${d}//${c}//${q}`, E = (C) => new D2(C).toDateTime().toUTC().toFormat("yyyyMMdd'T'HHmmss'Z'"), t0 = (C) => {
    var s0, J;
    return `"${C.name || "Unknown"}";RSVP=${((J = (s0 = C.rsvp) == null ? void 0 : s0.toString()) == null ? void 0 : J.toUpperCase()) ?? "FALSE"}:mailto:${C.email}`;
  };
  return `${[
    "BEGIN:VCALENDAR",
    `VERSION:${y}`,
    `PRODID:${v}`,
    `METHOD:${m}`,
    "BEGIN:VEVENT",
    `UID:${b}`,
    `DTSTAMP:${E(D2.tzNow())}`,
    `DTSTART:${E(r)}`,
    `DTEND:${E(M)}`,
    `SUMMARY:${n}`,
    `LOCATION:${t}`,
    `DESCRIPTION:${a}`,
    O ? `ORGANIZER;CN="${O.name}";SENT-BY="mailto:noreply@nova-mg.opendock.com":mailto:${O.email}` : null,
    ...A.map((C) => `ATTENDEE;CN=${t0(C)}`),
    $ ? "TRANSP:TRANSPARENT" : "TRANSP:OPAQUE",
    "END:VEVENT",
    "END:VCALENDAR"
  ].filter((C) => !!C).join(`\r
`)}\r
`;
}
export {
  nH as ALLOWABLE_CHILD_DOCK_FIELDS,
  jP as ARRAY_INDEX_SUNDAY,
  WP as AllowedMessageThreadMediaMimeTypes,
  GB as AmenitiesEnum,
  Cw as AppointmentCreatorTypeReportOptions,
  kw as AppointmentIdType,
  mt as AppointmentMetadataEnum,
  xw as AppointmentNotificationField,
  iw as AppointmentStartTimeMinutes,
  i0 as AppointmentStatus,
  pB as AppointmentType,
  Nw as AppsEnum,
  xP as AssetContainerEventType,
  kP as AssetContainerState,
  PP as AssetContainerType,
  IP as AssetContainerYardEventType,
  Do as AssetTypeEnum,
  SU as AssetVisitEventOrder,
  a3 as AssetVisitEventType,
  zP as AssetVisitType,
  Ra as AssetVisitYardEventType,
  PU as BrazilianPhoneNumberLength,
  Jo as CAPACITY_CHILD_SLUG,
  JI as CARRIER_ROLES,
  xH as CUSTOM_FIELD_DROP_DOWN_OPTIONS_LIMIT,
  mP as CharacterKeys,
  sw as CheckoutIdentifierAttribute,
  Vo as ClockSpanFormat,
  gB as ClockSpanMultiFormats,
  tw as CompanyType,
  Iw as ContentBlockStyleType,
  LP as CronjobScheduleType,
  IU as CronjobsPendingStatuses,
  $P as CronjobsStatus,
  RP as CronjobsTask,
  qu as CustomFieldType,
  vw as CustomFormDataEntitiesEnum,
  Tw as CustomFormFlowCategoryEnum,
  Dw as CustomFormFlowEntitiesEnum,
  Rw as CustomFormsClaimFeatures,
  x4 as CustomFormsFeatures,
  Lw as CustomFormsFeaturesData,
  nU as CustomFormsFeaturesInstalledByDefault,
  $w as CustomFormsGateManagementFeatures,
  rw as DEFAULT_APPOINTMENT_START_TIME_INTERVAL,
  ow as DEFAULT_EXTERNAL_VALIDATION_SERVER_ERROR_NOTIFY_THROTTLE_MINUTES,
  IO as DEFAULT_PHONE_COUNTRY,
  cF as DEFAULT_RESERVE_DURATION_MIN,
  XF as DEFAULT_SCHEDULE,
  z1 as DatabaseEntities,
  nw as DatabaseEventType,
  ew as DatabaseOperations,
  yO as DateTimeFormats,
  XH as DefaultExpirationDaysForTrialAccounts,
  BP as DepartTypeEnum,
  uF as ETACarrierValidations,
  uB as ETA_PREFIX_STRING,
  dB as ETA_SET_ALLOWED_STATUSES,
  sB as ETA_WINDOW_HOURS,
  wP as ElasticsearchOperation,
  ye as EntitySettings,
  zB as EtaCondition,
  wU as ExportAppointment,
  hu as ExportableCustomFormsFeatures,
  Bw as ExportableFields,
  Xw as ExportableYardFields,
  IH as FIELDS_WITHOUT_PLACEHOLDER,
  oU as FieldExtraFields,
  Ko as FileUnits,
  EP as FuelTypeEnum,
  UI as GATE_MANAGEMENT_SALES_URL,
  on as GlobalLimits,
  yP as IMessageStatus,
  j0 as ISO3166Countries,
  wT as ISO3166FilteredCountries,
  nk as IcsMethod,
  UP as LUXON_WEEKDAY_SUNDAY,
  YB as LoadTypeDirection,
  KB as LoadTypeEquipmentType,
  JB as LoadTypeOperation,
  ZB as LoadTypeTransportationMode,
  G0 as LuxonDateTimeFormats,
  CD as LuxonLocales,
  eH as MAX_CAPACITY_DOCKS,
  QF as MAX_CARRIER_LEADTIME_LIMIT_HRS,
  bU as MAX_CUSTOM_TAGS_PER_ORG,
  dH as MAX_LOAD_TYPES_PER_WAREHOUSE,
  pF as MAX_RECURRING_APPOINTMENT_WEEKS,
  VI as MAX_WAREHOUSE_PER_USER,
  ZF as MIN_CARRIER_LEADTIME_LIMIT_HRS,
  pP as MR_PREVIEW_EMAIL,
  mw as MULTI_DOC_MAX_FILES_PER_APPOINTMENT,
  FU as MakePartial,
  gP as MessageSourceType,
  Fw as NotificationContentBlockKey,
  dU as NotificationContentBlocks,
  Pw as NotificationType,
  Hw as Notifications,
  D2 as NovaDate,
  so as NovaDateInvalidValueError,
  gw as NovaErrorCode,
  CP as ObservationDirectionEnum,
  bw as ObservationMatchAttribute,
  Aw as OrgType,
  E5 as PASSWORD_RESET_EMAIL_THROTTLE_IN_MINUTES,
  YI as PASSWORD_SALT_LENGTH,
  VB as PPERequirementsEnum,
  cP as PREVIEW_TAG,
  cB as RecurringExtraFieldsToCopyEnum,
  jB as RefNumberValidationVersion,
  Mw as ReferenceNumberInputModes,
  ww as ReportDateFields,
  Sw as ReportSearchDefinedRanges,
  IS as SELF_CHECKIN_EMAIL,
  C5 as SELF_CHECKIN_LEAD_TIME_MINUTES,
  kS as SELF_CHECKIN_RADIUS_LIMIT_MILES,
  HS as SMARTGATE_USER_FIRST_NAME,
  fu as SettingGroups,
  zw as SettingInputType,
  V as Settings,
  TP as SpotEventTypeEnum,
  SP as SpotReserveEntityEnum,
  DP as SpotStatus,
  vP as SpotType,
  kU as SystemMessages,
  _w as TriggerOperatorsEnum,
  vF as TwentyFourHourClockSpan,
  HP as UnitGrouper,
  FP as UnitType,
  Pb as UserRole,
  US as UserType,
  XP as VehicleClassEnum,
  vo as WarehouseFeatureEnum,
  Ew as WarehouseMetricGroupOptions,
  uw as WarnOrgExpirationDays,
  WO as Weekday,
  OH as XNovaEntity,
  nj as YARD_SPOT_CODE_MAX_LENGTH,
  V9 as YARD_TASK_ASSET_CONTAINER_CATEGORIES,
  J9 as YARD_TASK_SPOT_AREA_CATEGORIES,
  Y9 as YARD_TASK_SPOT_CATEGORIES,
  JP as YardTaskCheckCategory,
  Mj as YardTaskCheckEntities,
  Bn as YardTaskCheckEntity,
  YP as YardTaskEvent,
  ek as YardTaskFlags,
  VP as YardTaskStatus,
  GP as YardTaskType,
  NP as YardTasksViewModeEnum,
  _P as YardViewModeEnum,
  KO as _unionLists,
  ID as absDiffDatesInMillis,
  ok as addDays,
  pS as addOffset_day,
  dS as addOffset_hr,
  wb as addOffset_min,
  GO as addOffset_ms,
  VO as addOffset_s,
  cS as addOffset_week,
  rk as addWeeks,
  Au as adjustTzOffsetIfNegative,
  uU as aggregateAvailability,
  fH as allowedMimeTypes,
  lI as anyOverlaps,
  tU as applyFieldOperation,
  TH as applyOverrides,
  DH as areRequiredFieldsSet,
  SH as areSettingRequirementsMet,
  uk as arr,
  T4 as breakWordsAtCaps,
  ij as cachedInflightRequest,
  wk as camelCaseToHumanReadable,
  Kx as canRole1UpdateUser2ToRole3,
  QI as canUserAccessWarehouse,
  lx as canUserBookInThePast,
  nB as canUserCancelAppointment,
  Bx as canUserChangeChatOpenStatus,
  wx as canUserChangeDriverPhone,
  Zx as canUserChangeOrgCarrierSettings,
  eF as canUserConfigureSaml,
  ru as canUserCreateAppointment,
  Gx as canUserCreateCarrier,
  ou as canUserCreateDocks,
  KS as canUserCreateLoadTypes,
  hx as canUserCreateNotificationConfig,
  Ix as canUserCreateOrg,
  Vx as canUserCreateReportSearch,
  Tx as canUserCreateReserve,
  su as canUserCreateSpot,
  du as canUserCreateSpotArea,
  pu as canUserCreateSpotAssignment,
  Fx as canUserCreateUser,
  gx as canUserCreateWarehouse,
  $x as canUserCreateWarehouseGroup,
  vx as canUserDeleteAppointment,
  zx as canUserDeleteDocks,
  ZS as canUserDeleteLoadTypes,
  kx as canUserDeleteOrg,
  Yx as canUserDeleteReportSearch,
  iF as canUserDeleteSpot,
  bF as canUserDeleteSpotArea,
  dF as canUserDeleteSpotAssignment,
  Sx as canUserDeleteUser,
  iB as canUserDeleteUserById,
  Rx as canUserDeleteWarehouse,
  _x as canUserDeleteWarehouseGroup,
  ux as canUserInviteUsers,
  QS as canUserModifyApmtStatus,
  Nx as canUserModifyAppointment,
  Dx as canUserModifyCustomFormData,
  eB as canUserModifyStatusTimeline,
  qx as canUserReadNotificationConfig,
  Qx as canUserReadOrgCarrierSettings,
  Px as canUserReadOrgData,
  nF as canUserReadSelfSamlConfig,
  cx as canUserReadSubscriptions,
  GS as canUserRoleHaveWarehouseAccessList,
  iu as canUserSendChatMessage,
  tB as canUserUpdateAppointment,
  oB as canUserUpdateAppointmentEmailCCs,
  rB as canUserUpdateAppointmentTags,
  Jx as canUserUpdateCarrier,
  mx as canUserUpdateCustomTags,
  Ox as canUserUpdateDocks,
  fx as canUserUpdateFavoriteCarriers,
  Ax as canUserUpdateLoadTypes,
  yx as canUserUpdateNotificationConfig,
  xx as canUserUpdateOrg,
  rF as canUserUpdateSpot,
  MF as canUserUpdateSpotArea,
  sF as canUserUpdateSpotAssignment,
  aB as canUserUpdateStatus,
  Hx as canUserUpdateUser,
  Nr as canUserUpdateWarehouse,
  Lx as canUserUpdateWarehouseGroup,
  Ik as capitalize,
  ZH as castField,
  GT as chunk,
  BF as clockAsInt,
  $B as clockIsValid,
  NB as clockSpanListToIntervalList,
  Tt as clockSpanToInterval,
  Yo as clockTo2001Format,
  _a as clockToMoment,
  DF as clocksDontOverlap,
  TF as clocksOverlap,
  _o as clone,
  mk as closestValueInList,
  _k as compareDateStrings,
  bu as compareUserRoles,
  wI as computeUndoStatus,
  WH as convertBytes,
  qk as countBy,
  qU as createSlotsFromAvailabilityResponse,
  fw as customFieldDescriptions,
  UH as customFieldIcons,
  lw as customFieldLabels,
  iU as customFormsSwaggerTags,
  LH as customSettingInputTypes,
  AH as databaseActions,
  Lk as deepClone,
  tS as deepEqual,
  UM as defaultPagination,
  zH as defaultQueryLimit,
  cH as defaultUUID,
  MU as definedRangeMetadata,
  FO as deleteFields,
  $k as deleteSensitiveFields,
  mH as deniedExtensions,
  vS as diffBetweenDates,
  xb as doesUserHaveOrgRole,
  Ux as doesWarehouseAccessAllowUpdate,
  Yt as doesntOverlap,
  uS as duration_day,
  YO as duration_hr,
  OS as duration_min,
  an as duration_ms,
  zS as duration_s,
  AS as duration_week,
  cU as emailNotificationPayloadMock,
  uI as endsAfter,
  Cb as endsBefore,
  B4 as endsBeforeStartOf,
  Uk as ensureDateTypes,
  GF as ensureIntervalListDatesAreDateObjects,
  pw as entitySettingsHierarchy,
  WU as exhaustJoin,
  mu as expiresAtDayDiff,
  AU as extractOpenDatesFromAvailability,
  hH as fileKeyToDownloadUrl,
  _F as findAppointmentWithNearestDate,
  uH as findOneOptionsHaveOnlyId,
  No as firstWeekOf2001,
  P5 as fixDSTOffsetInUTCDate,
  mU as floorOfInterval,
  EF as formatClockTime,
  Gk as formatCurrency,
  Ve as formatDateTimeWithMilitarySupport,
  sk as formatDuration,
  wH as formatExpiresAt,
  bH as formatFullAddress,
  Sk as formatMinutesToHuman,
  UO as formatPhoneNumber,
  Fk as formatPhoneNumberAsE164,
  YF as formatScheduleClock,
  MS as fromDateArray,
  W2 as fromDates,
  mS as gaps,
  $U as genericCustomFieldsMock,
  E4 as getAllStatuses,
  jM as getAppointmentDetailHtmlBlock,
  LF as getAppointmentStartStatus,
  tj as getAssetContainerStatus,
  oj as getAssetObservationType,
  px as getAuthenticatedUserId,
  bj as getAvailableCategoriesForEntity,
  k5 as getCapacityNumber,
  tH as getCapacityParentNameFromCapacityChildName,
  dj as getCategoryLabelTranslationKey,
  IF as getClosedScheduleTemplate,
  rI as getCountryCallingCodes,
  _I as getCreationStatusFromSettings,
  GH as getCustomFieldFormattedValue,
  lU as getCustomStartTimes,
  IB as getDSTOffsetMs,
  VU as getDayName,
  cI as getDeepProperty,
  yw as getDefaultCustomFieldName,
  PH as getDefaultOrgSettings,
  kF as getDefaultSchedule,
  oF as getDiffBetweenPasswordResetEmailAndNow,
  MH as getDockNameWithActiveStatus,
  Zo as getDocumentNameFromUrl,
  lk as getEnvVar,
  zF as getEtaCondition,
  $F as getEtaTagString,
  OB as getEtaVerb,
  EH as getExpirationWarningText,
  vk as getFormattedTime,
  SF as getFullDayClockOptionsGroupedByHour,
  II as getFullDayIntervalFromDateInTimezone,
  kI as getFullDayIntervalFromDateInUtc,
  PF as getFullyOpenSchedule,
  nx as getJwtExpirationTimeByRole,
  rU as getLoadTypesNames,
  QB as getLoadtypeShortDirection,
  jU as getLongWeekdayByShortName,
  TI as getMostRecentStatusChange,
  SI as getMostRecentStatusChangeByHappyPath,
  sI as getNestedPropertyByDotNotation,
  B5 as getNonOptionalStatuses,
  HI as getNowInTimezone,
  Qk as getObjectsKeyedById,
  yS as getOptionalStatuses,
  tF as getPasswordResetRequiredErrorMessage,
  bB as getPasswordValidationErrors,
  NU as getPlannedAssetVisits,
  OF as getReadableEtaStatus,
  RF as getReadableRecurringPatternParts,
  Ww as getRequiredValue,
  NI as getReschedulableStatuses,
  yB as getReschedulesCount,
  gF as getReschedulesString,
  DU as getResolvedAssetVisits,
  ZI as getRoleActionError,
  eI as getSetDiff,
  JF as getShortDayName,
  HU as getShortWeekdays,
  aj as getSpotEventType,
  YU as getSpotStatus,
  Uw as getStartOfIntervalRounded,
  jo as getStartStatuses,
  fU as getStartTimes,
  k2 as getStatusChangeRules,
  LS as getStatusesInHappyPathOrder,
  Mk as getSupportedTimezones,
  HH as getTranslatedCustomFieldDescriptions,
  FH as getTranslatedCustomFieldLabels,
  aU as getTranslatedCustomFormsFeaturesData,
  pU as getTranslatedNotifications,
  aF as getTranslatedPasswordErrors,
  BH as getTranslatedRefNumberDisplayName,
  RH as getTranslatedSettingGroupMetadata,
  gH as getTranslatedSettingGroups,
  Ow as getTranslatedSettings,
  tx as getTranslatedUserRoleDescription,
  yn as getTwentyFourHourClockSpan,
  vU as getUnplannedAndUnresolvedAssetVisits,
  KI as getUserFullName,
  Mu as getUserRoleValues,
  Cx as getUserRoles,
  jS as getUserType,
  ax as getValidInviteeRoles,
  TU as getWaitingAssetVisits,
  UU as getWeekdays,
  BU as getYardEventType,
  yU as getYearHolidaysForCountry,
  tu as hasEmptyOrgId,
  YT as hasNestedField,
  WB as hasOnlyCCEmails,
  aw as hasOnlyTags,
  KH as hasRequiredCustomFieldsForUserType,
  Rk as hasSameKeys,
  xF as hasSchedule,
  pj as icsCreate,
  oS as insertStringIntoString,
  wF as intToClock,
  xB as intersectIntervals,
  C4 as intersectLists,
  ZO as intersectPair,
  KF as intersectSchedules,
  WI as intersectedGaps,
  vB as intervalListToClockSpanList,
  _B as intervalToClockSpan,
  lu as isAnyIntervalDateInDST,
  AI as isAnySubInterval,
  fB as isAppointmentCancellation,
  v9 as isAssetVisitAppointmentFinished,
  fP as isAssetVisitAssigned,
  D9 as isAssetVisitCancelled,
  lP as isAssetVisitDeparted,
  _U as isAssetVisitDocked,
  OP as isAssetVisitPlanned,
  AP as isAssetVisitUnplannedAndResolved,
  uP as isAssetVisitUnplannedAndUnresolved,
  YS as isBaseUser,
  LI as isCancelAllowed,
  aH as isCapacityChild,
  UB as isCapacityChildByName,
  Ub as isCapacityParent,
  Hb as isCapacityParticipant,
  te as isCarrierUser,
  $S as isChronologyEnforced,
  PB as isDSTChangeBetweenIntervalList,
  kB as isDSTChangeStarting,
  I4 as isDateInDST,
  lF as isDockChanging,
  EU as isDriverSubscribing,
  XU as isDriverUnsubscribing,
  JT as isEmptyObject,
  sS as isEqual,
  CH as isExpiresAtWarningVisible,
  sH as isFeatureEnabledForWarehouse,
  NS as isFutureDate,
  ix as isIdenticalUser,
  Zk as isImageUrl,
  WF as isInProgress,
  kb as isInternalRole,
  ae as isInternalUser,
  JS as isLoggedInAsAnotherUser,
  CU as isMessageThreadExpired,
  gU as isMrPreview,
  HB as isNormalDock,
  bx as isNormalUser,
  xU as isNotNull,
  rx as isOmnipotentUser,
  gS as isOptionalStatus,
  dx as isOwner,
  Xx as isPasswordResetRequired,
  fF as isPastAppointment,
  FI as isPastDate,
  KT as isPhoneValid,
  zu as isRecurringAppointment,
  mF as isRecurringAppointmentChild,
  hB as isRecurringAppointmentParent,
  hF as isRequested,
  RS as isRescheduleAllowed,
  qF as isReserve,
  jx as isRestrictedUserAttemptingToUnRestrictUser,
  oH as isRootDock,
  OU as isSAMLWhitelistedURL,
  yF as isScheduled,
  sx as isSelfCheckInUser,
  NH as isSettingHidden,
  sU as isSlowSearch,
  Mx as isSmartgateUser,
  QU as isSpotAssignedOnlyToAssetContainer,
  KU as isSpotAssignedOnlyToAssetVisit,
  ZU as isSpotAssignedToAssetContainer,
  JU as isSpotAssignedToAssetVisit,
  ft as isStartStatus,
  cu as isStatusChange,
  qB as isStatusOnlyChange,
  BI as isStatusSetInStatusTimeline,
  mB as isStatusTimelineChange,
  vI as isStatusTransitionAllowed,
  X5 as isStrictInternalRole,
  Eb as isSubInterval,
  WS as isTimelineStatusChangeDateInvalid,
  Bb as isTrulyEmpty,
  $I as isUndoAllowed,
  Wx as isUserInSameOrg,
  oe as isUserRoleGreater,
  P0 as isUserRoleGreaterOrEqual,
  Ex as isUserRoleLess,
  Fb as isUserRoleLessOrEqual,
  rn as isUserRoleValid,
  MB as isUserValid,
  Ne as isUserWarehouseRestricted,
  KP as isValidAssetContainerCategory,
  sj as isValidCategoryForEntity,
  jH as isValidCustomField,
  S4 as isValidDate,
  Nk as isValidInputUrl,
  jO as isValidInternalEmail,
  ex as isValidInternalLoginAttempt,
  QP as isValidSpotAreaCategory,
  ZP as isValidSpotCategory,
  pH as isWarehouseLoadType,
  Ib as isWarehouseUser,
  AF as isWithin24HoursWindow,
  SB as isZMM,
  dk as json,
  S5 as leftPadString,
  rj as luxonWeekdayToArrayIndex,
  cw as makeEntitySettings,
  DB as makeFullDayClockOptions,
  _H as makeGroupedSettings,
  zU as makeInjectedNotificationSubject,
  kk as makeUnuseablePassword,
  GU as mapLongWeekdaysToEnLocale,
  zk as math,
  kD as maxDate,
  LB as mergeAdjacentSpans,
  Hk as mergeArrays,
  JH as mergeCustomFieldsWithUserRestrictions,
  FB as mergeIntervals,
  _r as mergeSmallGaps,
  jI as milesToMeters,
  Cn as millisecondsIn,
  PD as minDate,
  CF as minutesSinceMidnightToClock,
  Ak as misc,
  RU as mockWarehouses,
  VF as mutation_mergeDailyGaps,
  iS as namesToFullName,
  Ck as naturalSort,
  L5 as nextTimezoneWeekday,
  ik as nextTimezoneWeekdayInterval,
  BB as nextZMM,
  fS as noneOverlap,
  hw as numberCustomFieldRangeIsOk,
  Ok as obj,
  nI as objExistsInArr,
  Vt as objPropExists,
  Kk as objectContainsKeyFromArr,
  Sb as objectFilter,
  RI as occursWithin,
  fI as overlapCount,
  $r as overlaps,
  bI as paginateArray,
  gk as pluck,
  MI as pluralize,
  wB as prevZMM,
  pk as promise,
  Pk as randomPassword,
  yk as randomPick,
  Xk as randomString,
  HO as randomStringWithDigitsAndSymbols,
  iH as rearrangeDocksSortOrder,
  rS as recursivelyRemoveKeys,
  T5 as recursivelySanitizeValues,
  XB as reifyToZMMInterval,
  jF as reifyToZMMIntervalWithDSTOffset,
  nS as removeArrayDateDuplicates,
  Vk as removeArrayDuplicates,
  Dk as removeArrayItem,
  Yk as removeArrayObjDuplicates,
  Jk as removeArrayValsFromAnother,
  YH as removeHiddenFromCarrierFields,
  iI as removeNonAlphaNumericChars,
  VT as removeNullFieldsRecursive,
  Ek as removeNulls,
  PI as renderTimezoneInUtc,
  CI as renderUtcInTimezone,
  EI as renderUtcInTimezoneMoment,
  qS as repeat,
  hS as repeatWeekly,
  eU as resolveCustomFieldType,
  bk as roundDownToNearestMinute,
  aI as roundToNearestNumber,
  ZT as sanitizeInput,
  dI as searchStringToQuery,
  v2 as secondsIn,
  xk as setNullsToEmptyString,
  GI as setTranslator,
  dw as settingGroupDescriptions,
  LU as shouldCreateAssetContainerFromAssetVisit,
  vH as shouldDisplayError,
  QH as shouldEnableCustomFields,
  eS as shouldTruncateString,
  oI as snakeToTitleCase,
  qI as someOverlap,
  Tb as sortBy,
  pI as sortByArray,
  fk as sortByCaseInsensitive,
  yI as sortByDuration,
  QO as sortByEdge,
  hI as sortByEnd,
  Lr as sortByStart,
  rH as sortCapacityChildren,
  QT as sortObjectByKeys,
  ej as sortSpots,
  RB as splitClockIntoUnitsOfTime,
  OI as startsAfter,
  lS as startsAfterEndOf,
  JO as startsBefore,
  qH as storageFolder,
  ck as str,
  Tk as sumArray,
  zI as sumDurations_ms,
  h0 as t,
  $H as test,
  qw as textCustomFieldLenghtIsOk,
  CB as to2001,
  UF as to2001ZMM,
  EB as to2001Zulu,
  bS as toArray,
  Wk as toCamelCase,
  tI as toKebabCase,
  XI as transformForUserFriendlyTimezone,
  gI as trimFront,
  jk as truncateString,
  aS as tryParseJson,
  Bk as ucWords,
  mI as unionLists,
  w4 as unionPair,
  hk as uniqBy,
  VH as updateCustomFieldsFromWarehouse,
  xO as upperFirst,
  yH as urlToFileKey,
  VS as userRoleDescription,
  ox as userRoleToText,
  xI as utcNow,
  _S as utcNowAsDate,
  X4 as validateAppointmentStatus,
  NF as validateCarrierLeadTimeRules,
  k4 as validateClockSpan,
  Xb as validateInterval,
  Go as validateRole,
  HF as validateSchedule,
  DI as validateStatusTimeline,
  c0 as validateUser,
  kH as versionToString,
  FF as widenToZMM,
  lH as zipMimeTypes
};
